
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea675"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea675"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});

parcelRegister("jVuP9", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRegister("dws6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $950d101d2b26469b$export$2e2bcd8739ae039);
/*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $950d101d2b26469b$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $950d101d2b26469b$var$mathceil = Math.ceil, $950d101d2b26469b$var$mathfloor = Math.floor, $950d101d2b26469b$var$bignumberError = '[BigNumber Error] ', $950d101d2b26469b$var$tooManyDigits = $950d101d2b26469b$var$bignumberError + 'Number primitive has more than 15 significant digits: ', $950d101d2b26469b$var$BASE = 1e14, $950d101d2b26469b$var$LOG_BASE = 14, $950d101d2b26469b$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$950d101d2b26469b$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $950d101d2b26469b$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$950d101d2b26469b$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $950d101d2b26469b$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: '',
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ',',
        decimalSeparator: '.',
        fractionGroupSize: 0,
        fractionGroupSeparator: '\xA0',
        suffix: ''
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == 'number') && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$950d101d2b26469b$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $950d101d2b26469b$var$intCheck(b, 2, ALPHABET.length, 'Base');
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == 'number') {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error($950d101d2b26469b$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == '.') // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $950d101d2b26469b$var$MAX_SAFE_INTEGER || v !== $950d101d2b26469b$var$mathfloor(v))) throw Error($950d101d2b26469b$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $950d101d2b26469b$var$LOG_BASE;
                if (e < 0) i += $950d101d2b26469b$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $950d101d2b26469b$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $950d101d2b26469b$var$LOG_BASE));
                    i = $950d101d2b26469b$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += '0');
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $950d101d2b26469b$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == 'object') {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                    v = obj[p];
                    $950d101d2b26469b$var$intCheck(v, 0, $950d101d2b26469b$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                    v = obj[p];
                    $950d101d2b26469b$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                    v = obj[p];
                    if (v && v.pop) {
                        $950d101d2b26469b$var$intCheck(v[0], -$950d101d2b26469b$var$MAX, 0, p);
                        $950d101d2b26469b$var$intCheck(v[1], 0, $950d101d2b26469b$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $950d101d2b26469b$var$intCheck(v, -$950d101d2b26469b$var$MAX, $950d101d2b26469b$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = 'RANGE')) {
                    v = obj[p];
                    if (v && v.pop) {
                        $950d101d2b26469b$var$intCheck(v[0], -$950d101d2b26469b$var$MAX, -1, p);
                        $950d101d2b26469b$var$intCheck(v[1], 1, $950d101d2b26469b$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $950d101d2b26469b$var$intCheck(v, -$950d101d2b26469b$var$MAX, $950d101d2b26469b$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($950d101d2b26469b$var$bignumberError + p + ' cannot be zero: ' + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = 'CRYPTO')) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($950d101d2b26469b$var$bignumberError + 'crypto unavailable');
                            }
                        } else CRYPTO = v;
                    } else throw Error($950d101d2b26469b$var$bignumberError + p + ' not true or false: ' + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                    v = obj[p];
                    $950d101d2b26469b$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                    v = obj[p];
                    $950d101d2b26469b$var$intCheck(v, 0, $950d101d2b26469b$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = 'FORMAT')) {
                    v = obj[p];
                    if (typeof v == 'object') FORMAT = v;
                    else throw Error($950d101d2b26469b$var$bignumberError + p + ' not an object: ' + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = 'ALPHABET')) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                        ALPHABET = v;
                    } else throw Error($950d101d2b26469b$var$bignumberError + p + ' invalid: ' + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($950d101d2b26469b$var$bignumberError + 'Object expected: ' + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == '[object Array]') {
            if ((s === 1 || s === -1) && e >= -$950d101d2b26469b$var$MAX && e <= $950d101d2b26469b$var$MAX && e === $950d101d2b26469b$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $950d101d2b26469b$var$LOG_BASE;
                if (i < 1) i += $950d101d2b26469b$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $950d101d2b26469b$var$BASE || n !== $950d101d2b26469b$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($950d101d2b26469b$var$bignumberError + 'Invalid BigNumber: ' + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $950d101d2b26469b$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $950d101d2b26469b$var$intCheck(dp, 0, $950d101d2b26469b$var$MAX);
            k = $950d101d2b26469b$var$mathceil(dp / $950d101d2b26469b$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($950d101d2b26469b$var$bignumberError + 'crypto unavailable');
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $950d101d2b26469b$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $950d101d2b26469b$var$POWS_TEN[$950d101d2b26469b$var$LOG_BASE - dp];
                c[i] = $950d101d2b26469b$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $950d101d2b26469b$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $950d101d2b26469b$var$LOG_BASE) e -= $950d101d2b26469b$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = '0123456789';
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace('.', '');
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($950d101d2b26469b$var$toFixedPoint($950d101d2b26469b$var$coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // The index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $950d101d2b26469b$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $950d101d2b26469b$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $950d101d2b26469b$var$SQRT_BASE, khi = k / $950d101d2b26469b$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $950d101d2b26469b$var$SQRT_BASE;
                xhi = x[i] / $950d101d2b26469b$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $950d101d2b26469b$var$SQRT_BASE * $950d101d2b26469b$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $950d101d2b26469b$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $950d101d2b26469b$var$BASE;
                e = $950d101d2b26469b$var$bitFloor(x.e / $950d101d2b26469b$var$LOG_BASE) - $950d101d2b26469b$var$bitFloor(y.e / $950d101d2b26469b$var$LOG_BASE);
                s = s / $950d101d2b26469b$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $950d101d2b26469b$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $950d101d2b26469b$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $950d101d2b26469b$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $950d101d2b26469b$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $950d101d2b26469b$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $950d101d2b26469b$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $950d101d2b26469b$var$toExponential(str, ne) : $950d101d2b26469b$var$toFixedPoint(str, ne, '0');
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $950d101d2b26469b$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += '0', len++);
                str = $950d101d2b26469b$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne + (id === 2 && e > ne);
                str = $950d101d2b26469b$var$toFixedPoint(str, e, '0');
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += '.'; i--; str += '0');
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += '.';
                        for(; i--; str += '0');
                    }
                }
            }
        }
        return n.s < 0 && c0 ? '-' + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $950d101d2b26469b$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $950d101d2b26469b$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($950d101d2b26469b$var$bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $950d101d2b26469b$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $950d101d2b26469b$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $950d101d2b26469b$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $950d101d2b26469b$var$mathceil((i + 1) / $950d101d2b26469b$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $950d101d2b26469b$var$LOG_BASE;
                            j = i - $950d101d2b26469b$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $950d101d2b26469b$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $950d101d2b26469b$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $950d101d2b26469b$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($950d101d2b26469b$var$LOG_BASE - sd % $950d101d2b26469b$var$LOG_BASE) % $950d101d2b26469b$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$950d101d2b26469b$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $950d101d2b26469b$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $950d101d2b26469b$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $950d101d2b26469b$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $950d101d2b26469b$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $950d101d2b26469b$var$toExponential(str, e) : $950d101d2b26469b$var$toFixedPoint(str, e, '0');
        return n.s < 0 ? '-' + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $950d101d2b26469b$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $950d101d2b26469b$var$intCheck(dp, 0, $950d101d2b26469b$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $950d101d2b26469b$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $950d101d2b26469b$var$bitFloor(this.e / $950d101d2b26469b$var$LOG_BASE)) * $950d101d2b26469b$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($950d101d2b26469b$var$bignumberError + 'Exponent not an integer: ' + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $950d101d2b26469b$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $950d101d2b26469b$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $950d101d2b26469b$var$mathceil(POW_PRECISION / $950d101d2b26469b$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $950d101d2b26469b$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $950d101d2b26469b$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $950d101d2b26469b$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $950d101d2b26469b$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $950d101d2b26469b$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $950d101d2b26469b$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $950d101d2b26469b$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $950d101d2b26469b$var$bitFloor(this.e / $950d101d2b26469b$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $950d101d2b26469b$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $950d101d2b26469b$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $950d101d2b26469b$var$LOG_BASE, ye = y.e / $950d101d2b26469b$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $950d101d2b26469b$var$bitFloor(xe);
        ye = $950d101d2b26469b$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $950d101d2b26469b$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $950d101d2b26469b$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $950d101d2b26469b$var$bitFloor(x.e / $950d101d2b26469b$var$LOG_BASE) + $950d101d2b26469b$var$bitFloor(y.e / $950d101d2b26469b$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $950d101d2b26469b$var$BASE;
        sqrtBase = $950d101d2b26469b$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $950d101d2b26469b$var$LOG_BASE, ye = y.e / $950d101d2b26469b$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $950d101d2b26469b$var$bitFloor(xe);
        ye = $950d101d2b26469b$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $950d101d2b26469b$var$BASE | 0;
            xc[b] = $950d101d2b26469b$var$BASE === xc[b] ? 0 : xc[b] % $950d101d2b26469b$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $950d101d2b26469b$var$intCheck(sd, 1, $950d101d2b26469b$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $950d101d2b26469b$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $950d101d2b26469b$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $950d101d2b26469b$var$intCheck(k, -$950d101d2b26469b$var$MAX_SAFE_INTEGER, $950d101d2b26469b$var$MAX_SAFE_INTEGER);
        return this.times('1e' + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $950d101d2b26469b$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(+n);
            e = $950d101d2b26469b$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + '');
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($950d101d2b26469b$var$coeffToString(t.c).slice(0, s) === (n = $950d101d2b26469b$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == '9999' || !rep && n == '4999') {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $950d101d2b26469b$var$intCheck(dp, 0, $950d101d2b26469b$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $950d101d2b26469b$var$intCheck(dp, 0, $950d101d2b26469b$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == 'object') {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == 'object') {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != 'object') throw Error($950d101d2b26469b$var$bignumberError + 'Argument not an object: ' + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = '-' + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
        }
        return (format.prefix || '') + str + (format.suffix || '');
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($950d101d2b26469b$var$bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $950d101d2b26469b$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $950d101d2b26469b$var$POWS_TEN[(exp = e % $950d101d2b26469b$var$LOG_BASE) < 0 ? $950d101d2b26469b$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $950d101d2b26469b$var$intCheck(sd, 1, $950d101d2b26469b$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = 'Infinity';
                if (s < 0) str = '-' + str;
            } else str = 'NaN';
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $950d101d2b26469b$var$toExponential($950d101d2b26469b$var$coeffToString(n.c), e) : $950d101d2b26469b$var$toFixedPoint($950d101d2b26469b$var$coeffToString(n.c), e, '0');
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $950d101d2b26469b$var$toFixedPoint($950d101d2b26469b$var$coeffToString(n.c), n.e, '0');
            } else {
                $950d101d2b26469b$var$intCheck(b, 2, ALPHABET.length, 'Base');
                str = convertBase($950d101d2b26469b$var$toFixedPoint($950d101d2b26469b$var$coeffToString(n.c), e, '0'), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = '-' + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = 'BigNumber';
    // Node.js v10.12.0+
    P[Symbol.for('nodejs.util.inspect.custom')] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $950d101d2b26469b$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $950d101d2b26469b$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + '';
    for(; i < j;){
        s = a[i++] + '';
        z = $950d101d2b26469b$var$LOG_BASE - s.length;
        for(; z--; s = '0' + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $950d101d2b26469b$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $950d101d2b26469b$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $950d101d2b26469b$var$mathfloor(n)) throw Error($950d101d2b26469b$var$bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
}
// Assumes finite n.
function $950d101d2b26469b$var$isOdd(n) {
    var k = n.c.length - 1;
    return $950d101d2b26469b$var$bitFloor(n.e / $950d101d2b26469b$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $950d101d2b26469b$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
}
function $950d101d2b26469b$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + '.'; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
    }
    return str;
}
var $950d101d2b26469b$export$d97aa349ed20696 = $950d101d2b26469b$var$clone();
var $950d101d2b26469b$export$2e2bcd8739ae039 = $950d101d2b26469b$export$d97aa349ed20696;

});

parcelRegister("gNDby", function(module, exports) {

$parcel$export(module.exports, "PublicKey", () => $c3af9e523501759a$export$ca8b6604d6ce14de);
$parcel$export(module.exports, "VersionedMessage", () => $c3af9e523501759a$export$b0a61927d00ede7f);
$parcel$export(module.exports, "TransactionInstruction", () => $c3af9e523501759a$export$a7a3aa8360ac9f59);
$parcel$export(module.exports, "Transaction", () => $c3af9e523501759a$export$febc5573c75cefb0);
$parcel$export(module.exports, "VersionedTransaction", () => $c3af9e523501759a$export$232cc3f078dcc284);
$parcel$export(module.exports, "SYSVAR_RENT_PUBKEY", () => $c3af9e523501759a$export$970d0190cdb3a8e9);
$parcel$export(module.exports, "sendAndConfirmTransaction", () => $c3af9e523501759a$export$4ad6fe6dae0b6bc3);
$parcel$export(module.exports, "SystemInstruction", () => $c3af9e523501759a$export$f009802131fa3d06);
$parcel$export(module.exports, "SystemProgram", () => $c3af9e523501759a$export$d8c4e17726848113);
$parcel$export(module.exports, "Connection", () => $c3af9e523501759a$export$98b66c25bb38499d);
$parcel$export(module.exports, "Keypair", () => $c3af9e523501759a$export$c53bca448cf33676);
$parcel$export(module.exports, "clusterApiUrl", () => $c3af9e523501759a$export$11656287b4eb76ff);
$parcel$export(module.exports, "LAMPORTS_PER_SOL", () => $c3af9e523501759a$export$5f6a2f2669741bbe);

var $6ZWSX = parcelRequire("6ZWSX");

var $97ic6 = parcelRequire("97ic6");

var $3Di93 = parcelRequire("3Di93");

var $bYkMz = parcelRequire("bYkMz");

var $43uCS = parcelRequire("43uCS");

var $75BJw = parcelRequire("75BJw");

var $Q02IV = parcelRequire("Q02IV");

var $cWwdi = parcelRequire("cWwdi");

var $5DqgT = parcelRequire("5DqgT");

var $7pfXJ = parcelRequire("7pfXJ");

var $ga6mf = parcelRequire("ga6mf");

var $lk8ID = parcelRequire("lk8ID");

var $4hazQ = parcelRequire("4hazQ");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $c3af9e523501759a$var$generatePrivateKey = (0, $97ic6.ed25519).utils.randomPrivateKey;
const $c3af9e523501759a$var$generateKeypair = ()=>{
    const privateScalar = (0, $97ic6.ed25519).utils.randomPrivateKey();
    const publicKey = $c3af9e523501759a$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $c3af9e523501759a$var$getPublicKey = (0, $97ic6.ed25519).getPublicKey;
function $c3af9e523501759a$var$isOnCurve(publicKey) {
    try {
        (0, $97ic6.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $c3af9e523501759a$var$sign = (message, secretKey)=>(0, $97ic6.ed25519).sign(message, secretKey.slice(0, 32));
const $c3af9e523501759a$var$verify = (0, $97ic6.ed25519).verify;
const $c3af9e523501759a$var$toBuffer = (arr)=>{
    if ((0, $6ZWSX.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $6ZWSX.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $6ZWSX.Buffer).from(arr);
};
// Class wrapping a plain object
class $c3af9e523501759a$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $6ZWSX.Buffer).from((0, $75BJw.serialize)($c3af9e523501759a$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $75BJw.deserialize)($c3af9e523501759a$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $75BJw.deserializeUnchecked)($c3af9e523501759a$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $c3af9e523501759a$export$deb82508dd66d288 extends $c3af9e523501759a$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = '';
        if (Object.keys(properties).length !== 1) throw new Error('Enum can only take single value');
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $c3af9e523501759a$export$68d13ce9b4cc48f3 = new Map();
var $c3af9e523501759a$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ const $c3af9e523501759a$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $c3af9e523501759a$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $c3af9e523501759a$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $c3af9e523501759a$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ class $c3af9e523501759a$export$ca8b6604d6ce14de extends $c3af9e523501759a$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($c3af9e523501759a$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === 'string') {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(value);
                if (decoded.length != $c3af9e523501759a$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($3Di93)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($3Di93)))(value);
            if (this._bn.byteLength() > $c3af9e523501759a$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$uniquePublicKeyCounter);
        $c3af9e523501759a$var$uniquePublicKeyCounter += 1;
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $6ZWSX.Buffer));
        if (b.length === $c3af9e523501759a$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $6ZWSX.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [Symbol.toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $6ZWSX.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $6ZWSX.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $43uCS.sha256)(buffer);
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $6ZWSX.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $c3af9e523501759a$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $6ZWSX.Buffer).concat([
                buffer,
                $c3af9e523501759a$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $6ZWSX.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $6ZWSX.Buffer).from('ProgramDerivedAddress')
        ]);
        const publicKeyBytes = (0, $43uCS.sha256)(buffer);
        if ($c3af9e523501759a$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $6ZWSX.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $c3af9e523501759a$export$ca8b6604d6ce14de(pubkeyData);
        return $c3af9e523501759a$var$isOnCurve(pubkey.toBytes());
    }
}
$c3af9e523501759a$var$_PublicKey = $c3af9e523501759a$export$ca8b6604d6ce14de;
$c3af9e523501759a$export$ca8b6604d6ce14de.default = new $c3af9e523501759a$var$_PublicKey('11111111111111111111111111111111');
$c3af9e523501759a$export$68d13ce9b4cc48f3.set($c3af9e523501759a$export$ca8b6604d6ce14de, {
    kind: 'struct',
    fields: [
        [
            '_bn',
            'u256'
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $c3af9e523501759a$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $c3af9e523501759a$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error('bad secret key size');
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $c3af9e523501759a$var$toBuffer($c3af9e523501759a$var$generatePrivateKey());
            this._publicKey = $c3af9e523501759a$var$toBuffer($c3af9e523501759a$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $6ZWSX.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $c3af9e523501759a$export$42bd37c1c64962b6 = new $c3af9e523501759a$export$ca8b6604d6ce14de('BPFLoader1111111111111111111111111111111111');
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $c3af9e523501759a$export$4c6d5b89e1596f26 = 1232;
const $c3af9e523501759a$export$3c3793d809f8b858 = 0x7f;
const $c3af9e523501759a$export$14aee086fde78fa6 = 64;
const $c3af9e523501759a$export$5dbcf462800ade42 = 0x81;
/**
 * The maximum size of a version 1 transaction in bytes.
 */ const $c3af9e523501759a$export$3d14a9df30042586 = 4096;
class $c3af9e523501759a$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$718fcd78527f88ed.prototype, 'name', {
    value: 'TransactionExpiredBlockheightExceededError'
});
class $c3af9e523501759a$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + 'unknown if it succeeded or failed. Check signature ' + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$b822204c22e46bdf.prototype, 'name', {
    value: 'TransactionExpiredTimeoutError'
});
class $c3af9e523501759a$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($c3af9e523501759a$export$a3e7565a95f5a1e5.prototype, 'name', {
    value: 'TransactionExpiredNonceInvalidError'
});
class $c3af9e523501759a$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error('Account index overflow encountered during compilation');
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error('Encountered an unknown instruction account key during compilation');
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $c3af9e523501759a$var$publicKey = (property = 'publicKey')=>{
    return $Q02IV.blob(32, property);
};
/**
 * Layout for a signature
 */ const $c3af9e523501759a$var$signature = (property = 'signature')=>{
    return $Q02IV.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $c3af9e523501759a$var$rustString = (property = 'string')=>{
    const rsl = $Q02IV.struct([
        $Q02IV.u32('length'),
        $Q02IV.u32('lengthPadding'),
        $Q02IV.blob($Q02IV.offset($Q02IV.u32(), -8), 'chars')
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data['chars'].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $6ZWSX.Buffer).from(str, 'utf8')
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $Q02IV.u32().span + $Q02IV.u32().span + (0, $6ZWSX.Buffer).from(str, 'utf8').length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $c3af9e523501759a$var$authorized = (property = 'authorized')=>{
    return $Q02IV.struct([
        $c3af9e523501759a$var$publicKey('staker'),
        $c3af9e523501759a$var$publicKey('withdrawer')
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $c3af9e523501759a$var$lockup = (property = 'lockup')=>{
    return $Q02IV.struct([
        $Q02IV.ns64('unixTimestamp'),
        $Q02IV.ns64('epoch'),
        $c3af9e523501759a$var$publicKey('custodian')
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $c3af9e523501759a$var$voteInit = (property = 'voteInit')=>{
    return $Q02IV.struct([
        $c3af9e523501759a$var$publicKey('nodePubkey'),
        $c3af9e523501759a$var$publicKey('authorizedVoter'),
        $c3af9e523501759a$var$publicKey('authorizedWithdrawer'),
        $Q02IV.u8('commission')
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $c3af9e523501759a$var$voteAuthorizeWithSeedArgs = (property = 'voteAuthorizeWithSeedArgs')=>{
    return $Q02IV.struct([
        $Q02IV.u32('voteAuthorizationType'),
        $c3af9e523501759a$var$publicKey('currentAuthorityDerivedKeyOwnerPubkey'),
        $c3af9e523501759a$var$rustString('currentAuthorityDerivedKeySeed'),
        $c3af9e523501759a$var$publicKey('newAuthorized')
    ], property);
};
function $c3af9e523501759a$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === 'function') return item.alloc(fields[item.property]);
        else if ('count' in item && 'elementLayout' in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ('fields' in item) // This is a `Structure` whose size needs to be recursively measured.
        return $c3af9e523501759a$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $c3af9e523501759a$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $c3af9e523501759a$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $c3af9e523501759a$var$assert(condition, message) {
    if (!condition) throw new Error(message || 'Assertion failed');
}
class $c3af9e523501759a$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $c3af9e523501759a$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $c3af9e523501759a$var$assert(mapEntries.length <= 256, 'Max static account keys length exceeded');
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $c3af9e523501759a$var$assert(writableSigners.length > 0, 'Expected at least one writable signer key');
            const [payerAddress] = writableSigners[0];
            $c3af9e523501759a$var$assert(payerAddress === this.payer.toBase58(), 'Expected first writable signer key to be the fee payer');
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $c3af9e523501759a$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $c3af9e523501759a$var$assert(lookupTableIndex < 256, 'Max lookup table index exceeded');
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $c3af9e523501759a$var$END_OF_BUFFER_ERROR_MESSAGE = 'Reached end of buffer unexpectedly';
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $c3af9e523501759a$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($c3af9e523501759a$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $c3af9e523501759a$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($c3af9e523501759a$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $c3af9e523501759a$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return 'legacy';
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $c3af9e523501759a$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $c3af9e523501759a$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $c3af9e523501759a$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode(ix.data)
            }));
        return new $c3af9e523501759a$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $c3af9e523501759a$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(instruction.data));
            let keyIndicesCount = [];
            $c3af9e523501759a$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $c3af9e523501759a$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $6ZWSX.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $6ZWSX.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $c3af9e523501759a$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$export$4c6d5b89e1596f26);
        (0, $6ZWSX.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $Q02IV.struct([
                $Q02IV.u8('programIdIndex'),
                $Q02IV.blob(instruction.keyIndicesCount.length, 'keyIndicesCount'),
                $Q02IV.seq($Q02IV.u8('keyIndex'), instruction.keyIndices.length, 'keyIndices'),
                $Q02IV.blob(instruction.dataLength.length, 'dataLength'),
                $Q02IV.seq($Q02IV.u8('userdatum'), instruction.data.length, 'data')
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $Q02IV.struct([
            $Q02IV.blob(1, 'numRequiredSignatures'),
            $Q02IV.blob(1, 'numReadonlySignedAccounts'),
            $Q02IV.blob(1, 'numReadonlyUnsignedAccounts'),
            $Q02IV.blob(keyCount.length, 'keyCount'),
            $Q02IV.seq($c3af9e523501759a$var$publicKey('key'), numKeys, 'keys'),
            $c3af9e523501759a$var$publicKey('recentBlockhash')
        ]);
        const transaction = {
            numRequiredSignatures: (0, $6ZWSX.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $6ZWSX.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $6ZWSX.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $6ZWSX.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$c3af9e523501759a$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(this.recentBlockhash)
        };
        let signData = (0, $6ZWSX.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $c3af9e523501759a$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $c3af9e523501759a$export$3c3793d809f8b858)) throw new Error('Versioned messages must be deserialized with VersionedMessage.deserialize()');
        const numReadonlySignedAccounts = $c3af9e523501759a$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $c3af9e523501759a$var$guardedShift(byteArray);
        const accountCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343);
            accountKeys.push(new $c3af9e523501759a$export$ca8b6604d6ce14de((0, $6ZWSX.Buffer).from(account)));
        }
        const recentBlockhash = $c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343);
        const instructionCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $c3af9e523501759a$var$guardedShift(byteArray);
            const accountCount = $c3af9e523501759a$var$decodeLength(byteArray);
            const accounts = $c3af9e523501759a$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const dataSlice = $c3af9e523501759a$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode((0, $6ZWSX.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode((0, $6ZWSX.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $c3af9e523501759a$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $c3af9e523501759a$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && 'accountKeysFromLookups' in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error('Failed to get account keys because of a mismatch in the number of account keys from lookups');
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && 'addressLookupTableAccounts' in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error('Failed to get account keys because address table lookups were not resolved');
        return new $c3af9e523501759a$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $c3af9e523501759a$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $c3af9e523501759a$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $c3af9e523501759a$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $Q02IV.struct([
            $Q02IV.u8('prefix'),
            $Q02IV.struct([
                $Q02IV.u8('numRequiredSignatures'),
                $Q02IV.u8('numReadonlySignedAccounts'),
                $Q02IV.u8('numReadonlyUnsignedAccounts')
            ], 'header'),
            $Q02IV.blob(encodedStaticAccountKeysLength.length, 'staticAccountKeysLength'),
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), this.staticAccountKeys.length, 'staticAccountKeys'),
            $c3af9e523501759a$var$publicKey('recentBlockhash'),
            $Q02IV.blob(encodedInstructionsLength.length, 'instructionsLength'),
            $Q02IV.blob(serializedInstructions.length, 'serializedInstructions'),
            $Q02IV.blob(encodedAddressTableLookupsLength.length, 'addressTableLookupsLength'),
            $Q02IV.blob(serializedAddressTableLookups.length, 'serializedAddressTableLookups')
        ]);
        const serializedMessage = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $Q02IV.struct([
                $Q02IV.u8('programIdIndex'),
                $Q02IV.blob(encodedAccountKeyIndexesLength.length, 'encodedAccountKeyIndexesLength'),
                $Q02IV.seq($Q02IV.u8(), instruction.accountKeyIndexes.length, 'accountKeyIndexes'),
                $Q02IV.blob(encodedDataLength.length, 'encodedDataLength'),
                $Q02IV.blob(instruction.data.length, 'data')
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($c3af9e523501759a$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $c3af9e523501759a$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $Q02IV.struct([
                $c3af9e523501759a$var$publicKey('accountKey'),
                $Q02IV.blob(encodedWritableIndexesLength.length, 'encodedWritableIndexesLength'),
                $Q02IV.seq($Q02IV.u8(), lookup.writableIndexes.length, 'writableIndexes'),
                $Q02IV.blob(encodedReadonlyIndexesLength.length, 'encodedReadonlyIndexesLength'),
                $Q02IV.seq($Q02IV.u8(), lookup.readonlyIndexes.length, 'readonlyIndexes')
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $c3af9e523501759a$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $c3af9e523501759a$export$3c3793d809f8b858;
        $c3af9e523501759a$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $c3af9e523501759a$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $c3af9e523501759a$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $c3af9e523501759a$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $c3af9e523501759a$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $c3af9e523501759a$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343));
        const instructionCount = $c3af9e523501759a$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $c3af9e523501759a$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const accountKeyIndexes = $c3af9e523501759a$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const data = new Uint8Array($c3af9e523501759a$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $c3af9e523501759a$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343));
            const writableIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const writableIndexes = $c3af9e523501759a$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $c3af9e523501759a$var$decodeLength(byteArray);
            const readonlyIndexes = $c3af9e523501759a$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $c3af9e523501759a$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
const $c3af9e523501759a$var$CONFIG_MASK_PRIORITY_FEE_BITS = 3;
const $c3af9e523501759a$var$CONFIG_MASK_COMPUTE_UNIT_LIMIT_BIT = 4;
const $c3af9e523501759a$var$CONFIG_MASK_LOADED_ACCOUNTS_DATA_SIZE_LIMIT_BIT = 8;
const $c3af9e523501759a$var$CONFIG_MASK_HEAP_SIZE_BIT = 16;
function $c3af9e523501759a$var$decodeU32(byteArray) {
    const bytes = $c3af9e523501759a$var$guardedSplice(byteArray, 0, 4);
    return bytes[0] + bytes[1] * 256 + bytes[2] * 2 ** 16 + bytes[3] * 2 ** 24;
}
function $c3af9e523501759a$var$decodeU64(byteArray) {
    const bytes = $c3af9e523501759a$var$guardedSplice(byteArray, 0, 8);
    let value = BigInt(0);
    for(let i = bytes.length - 1; i >= 0; i--)value = value << BigInt(8) | BigInt(bytes[i]);
    $c3af9e523501759a$var$assert(value <= BigInt(Number.MAX_SAFE_INTEGER), 'Expected u64 value to be within the safe integer range');
    return Number(value);
}
/**
 * The transaction config of a v1 transaction message, which expresses the
 * compute budget directly in the message instead of through ComputeBudget
 * program instructions. Fields the transaction did not set are `null`.
 */ /**
 * Message constructor arguments
 */ class $c3af9e523501759a$export$3f19d3fe02a59272 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.transactionConfig = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.transactionConfig = args.transactionConfig ?? {
            computeUnitLimit: null,
            heapSize: null,
            loadedAccountsDataSizeLimit: null,
            priorityFee: null
        };
    }
    get version() {
        return 1;
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $c3af9e523501759a$export$109914c107623102(this.staticAccountKeys);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) return false;
        else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    serialize() {
        throw new Error('Serialization of version 1 transaction messages is not supported');
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $c3af9e523501759a$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $c3af9e523501759a$export$3c3793d809f8b858;
        $c3af9e523501759a$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $c3af9e523501759a$var$assert(version === 1, `Expected versioned message with version 1 but found version ${version}`);
        const header = {
            numRequiredSignatures: $c3af9e523501759a$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $c3af9e523501759a$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $c3af9e523501759a$var$guardedShift(byteArray)
        };
        const configMask = $c3af9e523501759a$var$decodeU32(byteArray);
        $c3af9e523501759a$var$assert((configMask & -32) === 0, 'Unexpected bits set in the transaction config mask');
        const priorityFeeBits = configMask & $c3af9e523501759a$var$CONFIG_MASK_PRIORITY_FEE_BITS;
        $c3af9e523501759a$var$assert(priorityFeeBits === 0 || priorityFeeBits === $c3af9e523501759a$var$CONFIG_MASK_PRIORITY_FEE_BITS, 'Expected both or neither of the priority fee bits to be set in the transaction config mask');
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343));
        const instructionCount = $c3af9e523501759a$var$guardedShift(byteArray);
        const staticAccountKeysLength = $c3af9e523501759a$var$guardedShift(byteArray);
        const staticAccountKeys = [];
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343)));
        const transactionConfig = {
            computeUnitLimit: null,
            heapSize: null,
            loadedAccountsDataSizeLimit: null,
            priorityFee: null
        };
        if (priorityFeeBits !== 0) transactionConfig.priorityFee = $c3af9e523501759a$var$decodeU64(byteArray);
        if (configMask & $c3af9e523501759a$var$CONFIG_MASK_COMPUTE_UNIT_LIMIT_BIT) transactionConfig.computeUnitLimit = $c3af9e523501759a$var$decodeU32(byteArray);
        if (configMask & $c3af9e523501759a$var$CONFIG_MASK_LOADED_ACCOUNTS_DATA_SIZE_LIMIT_BIT) transactionConfig.loadedAccountsDataSizeLimit = $c3af9e523501759a$var$decodeU32(byteArray);
        if (configMask & $c3af9e523501759a$var$CONFIG_MASK_HEAP_SIZE_BIT) transactionConfig.heapSize = $c3af9e523501759a$var$decodeU32(byteArray);
        const instructionHeaders = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $c3af9e523501759a$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $c3af9e523501759a$var$guardedShift(byteArray);
            const dataLength = $c3af9e523501759a$var$guardedShift(byteArray) + $c3af9e523501759a$var$guardedShift(byteArray) * 256;
            instructionHeaders.push({
                accountKeyIndexesLength: accountKeyIndexesLength,
                dataLength: dataLength,
                programIdIndex: programIdIndex
            });
        }
        const compiledInstructions = [];
        for (const instructionHeader of instructionHeaders)compiledInstructions.push({
            programIdIndex: instructionHeader.programIdIndex,
            accountKeyIndexes: $c3af9e523501759a$var$guardedSplice(byteArray, 0, instructionHeader.accountKeyIndexesLength),
            data: new Uint8Array($c3af9e523501759a$var$guardedSplice(byteArray, 0, instructionHeader.dataLength))
        });
        $c3af9e523501759a$var$assert(byteArray.length === 0, 'Expected no bytes to remain after deserializing a version 1 message');
        return new $c3af9e523501759a$export$3f19d3fe02a59272({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            transactionConfig: transactionConfig
        });
    }
}
// eslint-disable-next-line no-redeclare
const $c3af9e523501759a$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $c3af9e523501759a$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return 'legacy';
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $c3af9e523501759a$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === 'legacy') return $c3af9e523501759a$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $c3af9e523501759a$export$ee274c70e0fae590.deserialize(serializedMessage);
        else if (version === 1) return $c3af9e523501759a$export$3f19d3fe02a59272.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $c3af9e523501759a$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $c3af9e523501759a$var$DEFAULT_SIGNATURE = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $c3af9e523501759a$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $6ZWSX.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $c3af9e523501759a$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, 'nonceInfo')) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, 'lastValidBlockHeight')) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error('No instructions');
        items.forEach((item)=>{
            if ('instructions' in item) this.instructions = this.instructions.concat(item.instructions);
            else if ('data' in item && 'programId' in item && 'keys' in item) this.instructions.push(item);
            else this.instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error('Transaction recentBlockhash required');
        if (instructions.length < 1) console.warn('No instructions provided');
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error('Transaction fee payer required');
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: 'best fit',
                usage: 'sort',
                sensitivity: 'variant',
                ignorePunctuation: false,
                numeric: false,
                caseFirst: 'lower'
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), 'en', options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $c3af9e523501759a$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$c3af9e523501759a$var$assert(keyIndex >= 0));
        });
        return new $c3af9e523501759a$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error('No signers');
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $c3af9e523501759a$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $c3af9e523501759a$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $c3af9e523501759a$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $6ZWSX.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$c3af9e523501759a$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = 'Signature verification failed.';
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? '' : '(s)'} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join('`, `')}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? '' : '(s)'} [\`${sigErrors.missing.map((p)=>p.toBase58()).join('`, `')}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $c3af9e523501759a$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $6ZWSX.Buffer).alloc(transactionLength);
        $c3af9e523501759a$var$assert(signatures.length < 256);
        (0, $6ZWSX.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $c3af9e523501759a$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $6ZWSX.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $c3af9e523501759a$var$assert(wireTransaction.length <= $c3af9e523501759a$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$c3af9e523501759a$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $c3af9e523501759a$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $c3af9e523501759a$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode((0, $6ZWSX.Buffer).from(signature)));
        }
        return $c3af9e523501759a$export$febc5573c75cefb0.populate($c3af9e523501759a$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode($c3af9e523501759a$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $c3af9e523501759a$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $c3af9e523501759a$var$assert(numWritableSignedAccounts > 0, 'Message header is invalid');
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $c3af9e523501759a$var$assert(numWritableUnsignedAccounts >= 0, 'Message header is invalid');
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error('Failed to decompile message because no account keys were found');
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $c3af9e523501759a$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $c3af9e523501759a$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $c3af9e523501759a$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $c3af9e523501759a$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $c3af9e523501759a$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $c3af9e523501759a$var$assert(signatures.length === message.header.numRequiredSignatures, 'Expected signatures length to be equal to the number of required signatures');
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($c3af9e523501759a$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $c3af9e523501759a$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $Q02IV.struct([
            $Q02IV.blob(encodedSignaturesLength.length, 'encodedSignaturesLength'),
            $Q02IV.seq($c3af9e523501759a$var$signature(), this.signatures.length, 'signatures'),
            $Q02IV.blob(serializedMessage.length, 'serializedMessage')
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        if (serializedTransaction[0] === $c3af9e523501759a$export$5dbcf462800ade42) return this.deserializeV1(serializedTransaction);
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $c3af9e523501759a$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$14aee086fde78fa6)));
        const message = $c3af9e523501759a$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $c3af9e523501759a$export$232cc3f078dcc284(message, signatures);
    }
    static deserializeV1(serializedTransaction) {
        const numRequiredSignatures = serializedTransaction[1];
        const signaturesLength = numRequiredSignatures * $c3af9e523501759a$export$14aee086fde78fa6;
        const messageLength = serializedTransaction.length - signaturesLength;
        $c3af9e523501759a$var$assert(messageLength > 0, 'Expected transaction to have enough bytes for its signatures');
        const message = $c3af9e523501759a$export$b0a61927d00ede7f.deserialize(serializedTransaction.slice(0, messageLength));
        const signatures = [];
        for(let i = 0; i < numRequiredSignatures; i++){
            const offset = messageLength + i * $c3af9e523501759a$export$14aee086fde78fa6;
            signatures.push(serializedTransaction.slice(offset, offset + $c3af9e523501759a$export$14aee086fde78fa6));
        }
        return new $c3af9e523501759a$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $c3af9e523501759a$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $c3af9e523501759a$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $c3af9e523501759a$var$assert(signature.byteLength === 64, 'Signature must be 64 bytes long');
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $c3af9e523501759a$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $c3af9e523501759a$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $c3af9e523501759a$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $c3af9e523501759a$var$NUM_SLOTS_PER_SECOND = $c3af9e523501759a$var$NUM_TICKS_PER_SECOND / $c3af9e523501759a$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $c3af9e523501759a$var$MS_PER_SLOT = 1000 / $c3af9e523501759a$var$NUM_SLOTS_PER_SECOND;
const $c3af9e523501759a$export$393aa1412d47050e = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarC1ock11111111111111111111111111111111');
const $c3af9e523501759a$export$2b71d479444d2f4 = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarEpochSchedu1e111111111111111111111111');
const $c3af9e523501759a$export$54419cc1a3ece8d6 = new $c3af9e523501759a$export$ca8b6604d6ce14de('Sysvar1nstructions1111111111111111111111111');
const $c3af9e523501759a$export$e74201139e9833db = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarRecentB1ockHashes11111111111111111111');
const $c3af9e523501759a$export$970d0190cdb3a8e9 = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarRent111111111111111111111111111111111');
const $c3af9e523501759a$export$da3b38d796bc1af1 = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarRewards111111111111111111111111111111');
const $c3af9e523501759a$export$7b3a057916a4a7ae = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarS1otHashes111111111111111111111111111');
const $c3af9e523501759a$export$3272815bf0633907 = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarS1otHistory11111111111111111111111111');
const $c3af9e523501759a$export$ca994171317280ea = new $c3af9e523501759a$export$ca8b6604d6ce14de('SysvarStakeHistory1111111111111111111111111');
class $c3af9e523501759a$export$121e803f723b3045 extends Error {
    constructor({ action: action, signature: signature, transactionMessage: transactionMessage, logs: logs }){
        const maybeLogsOutput = logs ? `Logs: \n${JSON.stringify(logs.slice(-10), null, 2)}. ` : '';
        const guideText = '\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.';
        let message;
        switch(action){
            case 'send':
                message = `Transaction ${signature} resulted in an error. \n` + `${transactionMessage}. ` + maybeLogsOutput + guideText;
                break;
            case 'simulate':
                message = `Simulation failed. \nMessage: ${transactionMessage}. \n` + maybeLogsOutput + guideText;
                break;
            default:
                message = `Unknown action '${((a)=>a)(action)}'`;
        }
        super(message);
        this.signature = void 0;
        this.transactionMessage = void 0;
        this.transactionLogs = void 0;
        this.signature = signature;
        this.transactionMessage = transactionMessage;
        this.transactionLogs = logs ? logs : undefined;
    }
    get transactionError() {
        return {
            message: this.transactionMessage,
            logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
        };
    }
    /* @deprecated Use `await getLogs()` instead */ get logs() {
        const cachedLogs = this.transactionLogs;
        if (cachedLogs != null && typeof cachedLogs === 'object' && 'then' in cachedLogs) return undefined;
        return cachedLogs;
    }
    async getLogs(connection) {
        if (!Array.isArray(this.transactionLogs)) this.transactionLogs = new Promise((resolve, reject)=>{
            connection.getTransaction(this.signature).then((tx)=>{
                if (tx && tx.meta && tx.meta.logMessages) {
                    const logs = tx.meta.logMessages;
                    this.transactionLogs = logs;
                    resolve(logs);
                } else reject(new Error('Log messages not found'));
            }).catch(reject);
        });
        return await this.transactionLogs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $c3af9e523501759a$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $c3af9e523501759a$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = 'SolanaJSONRPCError';
    }
}
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) {
        if (signature != null) throw new $c3af9e523501759a$export$121e803f723b3045({
            action: 'send',
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
// zzz
function $c3af9e523501759a$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $c3af9e523501759a$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $c3af9e523501759a$var$getAlloc(type, fields);
    const data = (0, $6ZWSX.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $c3af9e523501759a$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $c3af9e523501759a$export$d1cc579b1c48f515 = $Q02IV.nu64('lamportsPerSignature');
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $c3af9e523501759a$var$NonceAccountLayout = $Q02IV.struct([
    $Q02IV.u32('version'),
    $Q02IV.u32('state'),
    $c3af9e523501759a$var$publicKey('authorizedPubkey'),
    $c3af9e523501759a$var$publicKey('nonce'),
    $Q02IV.struct([
        $c3af9e523501759a$export$d1cc579b1c48f515
    ], 'feeCalculator')
]);
const $c3af9e523501759a$export$7126250b6d8bd94a = $c3af9e523501759a$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $c3af9e523501759a$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $c3af9e523501759a$var$NonceAccountLayout.decode($c3af9e523501759a$var$toBuffer(buffer), 0);
        return new $c3af9e523501759a$export$ed1c2356ce604759({
            authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $c3af9e523501759a$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
function $c3af9e523501759a$var$u64(property) {
    const layout = (0, $Q02IV.blob)(8 /* bytes */ , property);
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    const bigIntLayout = layout;
    const codec = (0, $cWwdi.getU64Codec)();
    bigIntLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return codec.decode(src);
    };
    bigIntLayout.encode = (bigInt, buffer, offset)=>{
        const src = codec.encode(bigInt);
        return encode(src, buffer, offset);
    };
    return bigIntLayout;
}
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $c3af9e523501759a$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a SystemInstruction');
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $c3af9e523501759a$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$d8c4e17726848113.programId)) throw new Error('invalid instruction; programId is not SystemProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('lamports'),
            $Q02IV.ns64('space'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    Assign: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    Transfer: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$u64('lamports')
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('base'),
            $c3af9e523501759a$var$rustString('seed'),
            $Q02IV.ns64('lamports'),
            $Q02IV.ns64('space'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('lamports')
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('authorized')
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('authorized')
        ])
    },
    Allocate: {
        index: 8,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('space')
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('base'),
            $c3af9e523501759a$var$rustString('seed'),
            $Q02IV.ns64('space'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('base'),
            $c3af9e523501759a$var$rustString('seed'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$u64('lamports'),
            $c3af9e523501759a$var$rustString('seed'),
            $c3af9e523501759a$var$publicKey('programId')
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $c3af9e523501759a$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Create;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Transfer;
            data = $c3af9e523501759a$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Assign;
            data = $c3af9e523501759a$var$encodeData(type, {
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        if ('basePubkey' in params && 'seed' in params) transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $c3af9e523501759a$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $c3af9e523501759a$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: $c3af9e523501759a$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: $c3af9e523501759a$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ('basePubkey' in params) {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $c3af9e523501759a$var$encodeData(type, {
                base: $c3af9e523501759a$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $c3af9e523501759a$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $c3af9e523501759a$export$74bdf41d8d1e7108.Allocate;
            data = $c3af9e523501759a$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$d8c4e17726848113.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('11111111111111111111111111111111');
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $c3af9e523501759a$var$CHUNK_SIZE = $c3af9e523501759a$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $c3af9e523501759a$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $c3af9e523501759a$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, 'confirmed');
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error('Program load failed, account is already executable');
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $c3af9e523501759a$export$febc5573c75cefb0();
                    transaction.add($c3af9e523501759a$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            });
        }
        const dataLayout = $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.u32('offset'),
            $Q02IV.u32('bytesLength'),
            $Q02IV.u32('bytesLengthPadding'),
            $Q02IV.seq($Q02IV.u8('byte'), $Q02IV.offset($Q02IV.u32(), -8), 'bytes')
        ]);
        const chunkSize = $c3af9e523501759a$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $6ZWSX.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($c3af9e523501759a$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: 'confirmed'
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes('solana.com')) {
                const REQUESTS_PER_SECOND = 4;
                await $c3af9e523501759a$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $Q02IV.struct([
                $Q02IV.u32('instruction')
            ]);
            const data = (0, $6ZWSX.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $c3af9e523501759a$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = 'processed';
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($c3af9e523501759a$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$c3af9e523501759a$export$3b0d6d7590275603.chunkSize = $c3af9e523501759a$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $c3af9e523501759a$export$59833422f998b937 = new $c3af9e523501759a$export$ca8b6604d6ce14de('BPFLoader2111111111111111111111111111111111');
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $c3af9e523501759a$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $c3af9e523501759a$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $c3af9e523501759a$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $c3af9e523501759a$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $c3af9e523501759a$var$fastStableStringify$1;
var $c3af9e523501759a$var$hasRequiredFastStableStringify;
function $c3af9e523501759a$var$requireFastStableStringify() {
    if ($c3af9e523501759a$var$hasRequiredFastStableStringify) return $c3af9e523501759a$var$fastStableStringify$1;
    $c3af9e523501759a$var$hasRequiredFastStableStringify = 1;
    var objToString = Object.prototype.toString;
    var objKeys = Object.keys || function(obj) {
        var keys = [];
        for(var name in obj)keys.push(name);
        return keys;
    };
    function stringify(val, isArrayProp) {
        var i, max, str, keys, key, propVal, toStr;
        if (val === true) return "true";
        if (val === false) return "false";
        switch(typeof val){
            case "object":
                if (val === null) return null;
                else if (val.toJSON && typeof val.toJSON === "function") return stringify(val.toJSON(), isArrayProp);
                else {
                    toStr = objToString.call(val);
                    if (toStr === "[object Array]") {
                        str = '[';
                        max = val.length - 1;
                        for(i = 0; i < max; i++)str += stringify(val[i], true) + ',';
                        if (max > -1) str += stringify(val[i], true);
                        return str + ']';
                    } else if (toStr === "[object Object]") {
                        // only object is left
                        keys = objKeys(val).sort();
                        max = keys.length;
                        str = "";
                        i = 0;
                        while(i < max){
                            key = keys[i];
                            propVal = stringify(val[key], false);
                            if (propVal !== undefined) {
                                if (str) str += ',';
                                str += JSON.stringify(key) + ':' + propVal;
                            }
                            i++;
                        }
                        return '{' + str + '}';
                    } else return JSON.stringify(val);
                }
            case "function":
            case "undefined":
                return isArrayProp ? null : undefined;
            case "string":
                return JSON.stringify(val);
            default:
                return isFinite(val) ? val : null;
        }
    }
    $c3af9e523501759a$var$fastStableStringify$1 = function(val) {
        var returnVal = stringify(val, false);
        if (returnVal !== undefined) return '' + returnVal;
    };
    return $c3af9e523501759a$var$fastStableStringify$1;
}
var $c3af9e523501759a$var$fastStableStringifyExports = /*@__PURE__*/ $c3af9e523501759a$var$requireFastStableStringify();
var $c3af9e523501759a$var$fastStableStringify = /*@__PURE__*/ $c3af9e523501759a$var$getDefaultExportFromCjs($c3af9e523501759a$var$fastStableStringifyExports);
const $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $c3af9e523501759a$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $c3af9e523501759a$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $c3af9e523501759a$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$nextPowerOfTwo(slot + $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $c3af9e523501759a$var$trailingZeros($c3af9e523501759a$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
var $c3af9e523501759a$var$fetchImpl = globalThis.fetch;
class $c3af9e523501759a$var$RpcWebSocketClient extends (0, $ga6mf.CommonClient) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, $ga6mf.WebSocket)(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ('socket' in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error('Tried to call a JSON-RPC method `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error('Tried to send a JSON-RPC notification `' + args[0] + '` but the socket was not `CONNECTING` or `OPEN` (`readyState` was ' + readyState + ')'));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $c3af9e523501759a$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error('invalid instruction; ' + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE = 56;
class $c3af9e523501759a$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt('0xffffffffffffffff');
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $c3af9e523501759a$var$decodeData($c3af9e523501759a$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE;
        $c3af9e523501759a$var$assert(serializedAddressesLen >= 0, 'lookup table is invalid');
        $c3af9e523501759a$var$assert(serializedAddressesLen % 32 === 0, 'lookup table is invalid');
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $Q02IV.struct([
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), numSerializedAddresses, 'addresses')
        ]).decode(accountData.slice($c3af9e523501759a$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $c3af9e523501759a$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(address))
        };
    }
}
const $c3af9e523501759a$var$LookupTableMetaLayout = {
    index: 1,
    layout: $Q02IV.struct([
        $Q02IV.u32('typeIndex'),
        $c3af9e523501759a$var$u64('deactivationSlot'),
        $Q02IV.nu64('lastExtendedSlot'),
        $Q02IV.u8('lastExtendedStartIndex'),
        $Q02IV.u8(),
        // option
        $Q02IV.seq($c3af9e523501759a$var$publicKey(), $Q02IV.offset($Q02IV.u8(), -1), 'authority')
    ])
};
const $c3af9e523501759a$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $c3af9e523501759a$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($c3af9e523501759a$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith('https:') ? 'wss:' : 'ws:';
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? '' : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $c3af9e523501759a$var$PublicKeyFromString = (0, $5DqgT.coerce)((0, $5DqgT.instance)($c3af9e523501759a$export$ca8b6604d6ce14de), (0, $5DqgT.string)(), (value)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(value));
const $c3af9e523501759a$var$RawAccountDataResult = (0, $5DqgT.tuple)([
    (0, $5DqgT.string)(),
    (0, $5DqgT.literal)('base64')
]);
const $c3af9e523501759a$var$BufferFromRawAccountData = (0, $5DqgT.coerce)((0, $5DqgT.instance)((0, $6ZWSX.Buffer)), $c3af9e523501759a$var$RawAccountDataResult, (value)=>(0, $6ZWSX.Buffer).from(value[0], 'base64'));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $c3af9e523501759a$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $c3af9e523501759a$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError('Endpoint URL must start with `http:` or `https:`.');
    return putativeUrl;
}
/** @internal */ function $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === 'string') commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $c3af9e523501759a$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map((filter)=>'memcmp' in filter ? {
            ...filter,
            memcmp: {
                ...filter.memcmp,
                encoding: filter.memcmp.encoding ?? 'base58'
            }
        } : filter);
}
/**
 * @internal
 */ function $c3af9e523501759a$var$createRpcResult(result) {
    return (0, $5DqgT.union)([
        (0, $5DqgT.type)({
            jsonrpc: (0, $5DqgT.literal)('2.0'),
            id: (0, $5DqgT.string)(),
            result: result
        }),
        (0, $5DqgT.type)({
            jsonrpc: (0, $5DqgT.literal)('2.0'),
            id: (0, $5DqgT.string)(),
            error: (0, $5DqgT.type)({
                code: (0, $5DqgT.unknown)(),
                message: (0, $5DqgT.string)(),
                data: (0, $5DqgT.optional)((0, $5DqgT.any)())
            })
        })
    ]);
}
const $c3af9e523501759a$var$UnknownRpcResult = $c3af9e523501759a$var$createRpcResult((0, $5DqgT.unknown)());
/**
 * @internal
 */ function $c3af9e523501759a$var$jsonRpcResult(schema) {
    return (0, $5DqgT.coerce)($c3af9e523501759a$var$createRpcResult(schema), $c3af9e523501759a$var$UnknownRpcResult, (value)=>{
        if ('error' in value) return value;
        else return {
            ...value,
            result: (0, $5DqgT.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $c3af9e523501759a$var$jsonRpcResultAndContext(value) {
    return $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.type)({
        context: (0, $5DqgT.type)({
            slot: (0, $5DqgT.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $c3af9e523501759a$var$notificationResultAndContext(value) {
    return (0, $5DqgT.type)({
        context: (0, $5DqgT.type)({
            slot: (0, $5DqgT.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $c3af9e523501759a$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $c3af9e523501759a$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else if (version === 1) {
        const transactionConfig = response.transactionConfig;
        if (transactionConfig == null) throw new Error('Expected a version 1 transaction message response to have a `transactionConfig`');
        return new $c3af9e523501759a$export$3f19d3fe02a59272({
            header: response.header,
            staticAccountKeys: response.accountKeys.map((accountKey)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(accountKey)),
            recentBlockhash: response.recentBlockhash,
            compiledInstructions: response.instructions.map((ix)=>({
                    programIdIndex: ix.programIdIndex,
                    accountKeyIndexes: ix.accounts,
                    data: (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(ix.data)
                })),
            transactionConfig: transactionConfig
        });
    } else return new $c3af9e523501759a$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $c3af9e523501759a$var$GetInflationGovernorResult = (0, $5DqgT.type)({
    foundation: (0, $5DqgT.number)(),
    foundationTerm: (0, $5DqgT.number)(),
    initial: (0, $5DqgT.number)(),
    taper: (0, $5DqgT.number)(),
    terminal: (0, $5DqgT.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $c3af9e523501759a$var$GetInflationRewardResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)((0, $5DqgT.nullable)((0, $5DqgT.type)({
    epoch: (0, $5DqgT.number)(),
    effectiveSlot: (0, $5DqgT.number)(),
    amount: (0, $5DqgT.number)(),
    postBalance: (0, $5DqgT.number)(),
    commission: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $c3af9e523501759a$var$GetRecentPrioritizationFeesResult = (0, $5DqgT.array)((0, $5DqgT.type)({
    slot: (0, $5DqgT.number)(),
    prioritizationFee: (0, $5DqgT.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $c3af9e523501759a$var$GetInflationRateResult = (0, $5DqgT.type)({
    total: (0, $5DqgT.number)(),
    validator: (0, $5DqgT.number)(),
    foundation: (0, $5DqgT.number)(),
    epoch: (0, $5DqgT.number)()
});
/**
 * Information about the current epoch
 */ const $c3af9e523501759a$var$GetEpochInfoResult = (0, $5DqgT.type)({
    epoch: (0, $5DqgT.number)(),
    slotIndex: (0, $5DqgT.number)(),
    slotsInEpoch: (0, $5DqgT.number)(),
    absoluteSlot: (0, $5DqgT.number)(),
    blockHeight: (0, $5DqgT.optional)((0, $5DqgT.number)()),
    transactionCount: (0, $5DqgT.optional)((0, $5DqgT.number)())
});
const $c3af9e523501759a$var$GetEpochScheduleResult = (0, $5DqgT.type)({
    slotsPerEpoch: (0, $5DqgT.number)(),
    leaderScheduleSlotOffset: (0, $5DqgT.number)(),
    warmup: (0, $5DqgT.boolean)(),
    firstNormalEpoch: (0, $5DqgT.number)(),
    firstNormalSlot: (0, $5DqgT.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $c3af9e523501759a$var$GetLeaderScheduleResult = (0, $5DqgT.record)((0, $5DqgT.string)(), (0, $5DqgT.array)((0, $5DqgT.number)()));
/**
 * Transaction error or null
 */ const $c3af9e523501759a$var$TransactionErrorResult = (0, $5DqgT.nullable)((0, $5DqgT.union)([
    (0, $5DqgT.type)({}),
    (0, $5DqgT.string)()
]));
/**
 * Signature status for a transaction
 */ const $c3af9e523501759a$var$SignatureStatusResult = (0, $5DqgT.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $c3af9e523501759a$var$SignatureReceivedResult = (0, $5DqgT.literal)('receivedSignature');
/**
 * Version info for a node
 */ const $c3af9e523501759a$var$VersionResult = (0, $5DqgT.type)({
    'solana-core': (0, $5DqgT.string)(),
    'feature-set': (0, $5DqgT.optional)((0, $5DqgT.number)())
});
const $c3af9e523501759a$var$ParsedInstructionStruct = (0, $5DqgT.type)({
    program: (0, $5DqgT.string)(),
    programId: $c3af9e523501759a$var$PublicKeyFromString,
    parsed: (0, $5DqgT.unknown)()
});
const $c3af9e523501759a$var$PartiallyDecodedInstructionStruct = (0, $5DqgT.type)({
    programId: $c3af9e523501759a$var$PublicKeyFromString,
    accounts: (0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString),
    data: (0, $5DqgT.string)()
});
const $c3af9e523501759a$var$SimulatedTransactionResponseStruct = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.type)({
    err: (0, $5DqgT.nullable)((0, $5DqgT.union)([
        (0, $5DqgT.type)({}),
        (0, $5DqgT.string)()
    ])),
    logs: (0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.string)())),
    accounts: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.nullable)((0, $5DqgT.type)({
        executable: (0, $5DqgT.boolean)(),
        owner: (0, $5DqgT.string)(),
        lamports: (0, $5DqgT.number)(),
        data: (0, $5DqgT.array)((0, $5DqgT.string)()),
        rentEpoch: (0, $5DqgT.optional)((0, $5DqgT.number)())
    }))))),
    unitsConsumed: (0, $5DqgT.optional)((0, $5DqgT.number)()),
    returnData: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.type)({
        programId: (0, $5DqgT.string)(),
        data: (0, $5DqgT.tuple)([
            (0, $5DqgT.string)(),
            (0, $5DqgT.literal)('base64')
        ])
    }))),
    innerInstructions: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.type)({
        index: (0, $5DqgT.number)(),
        instructions: (0, $5DqgT.array)((0, $5DqgT.union)([
            $c3af9e523501759a$var$ParsedInstructionStruct,
            $c3af9e523501759a$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $c3af9e523501759a$var$BlockProductionResponseStruct = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.type)({
    byIdentity: (0, $5DqgT.record)((0, $5DqgT.string)(), (0, $5DqgT.array)((0, $5DqgT.number)())),
    range: (0, $5DqgT.type)({
        firstSlot: (0, $5DqgT.number)(),
        lastSlot: (0, $5DqgT.number)()
    })
}));
/**
 * A performance sample
 */ function $c3af9e523501759a$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $c3af9e523501759a$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($7pfXJ)))(async (request, callback)=>{
        const options = {
            method: 'POST',
            body: request,
            agent: agent,
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, httpHeaders || {}, $c3af9e523501759a$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $c3af9e523501759a$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $c3af9e523501759a$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $c3af9e523501759a$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $c3af9e523501759a$var$GetInflationGovernorRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $c3af9e523501759a$var$GetInflationRateRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $c3af9e523501759a$var$GetRecentPrioritizationFeesRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $c3af9e523501759a$var$GetEpochInfoRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $c3af9e523501759a$var$GetEpochScheduleRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $c3af9e523501759a$var$GetLeaderScheduleRpcResult = $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $c3af9e523501759a$var$SlotRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $c3af9e523501759a$var$GetSupplyRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.type)({
    total: (0, $5DqgT.number)(),
    circulating: (0, $5DqgT.number)(),
    nonCirculating: (0, $5DqgT.number)(),
    nonCirculatingAccounts: (0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $c3af9e523501759a$var$TokenAmountResult = (0, $5DqgT.type)({
    amount: (0, $5DqgT.string)(),
    uiAmount: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    decimals: (0, $5DqgT.number)(),
    uiAmountString: (0, $5DqgT.optional)((0, $5DqgT.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $c3af9e523501759a$var$GetTokenLargestAccountsResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.type)({
    address: $c3af9e523501759a$var$PublicKeyFromString,
    amount: (0, $5DqgT.string)(),
    uiAmount: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    decimals: (0, $5DqgT.number)(),
    uiAmountString: (0, $5DqgT.optional)((0, $5DqgT.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $c3af9e523501759a$var$GetTokenAccountsByOwner = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: (0, $5DqgT.type)({
        executable: (0, $5DqgT.boolean)(),
        owner: $c3af9e523501759a$var$PublicKeyFromString,
        lamports: (0, $5DqgT.number)(),
        data: $c3af9e523501759a$var$BufferFromRawAccountData,
        rentEpoch: (0, $5DqgT.number)()
    })
})));
const $c3af9e523501759a$var$ParsedAccountDataResult = (0, $5DqgT.type)({
    program: (0, $5DqgT.string)(),
    parsed: (0, $5DqgT.unknown)(),
    space: (0, $5DqgT.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $c3af9e523501759a$var$GetParsedTokenAccountsByOwner = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: (0, $5DqgT.type)({
        executable: (0, $5DqgT.boolean)(),
        owner: $c3af9e523501759a$var$PublicKeyFromString,
        lamports: (0, $5DqgT.number)(),
        data: $c3af9e523501759a$var$ParsedAccountDataResult,
        rentEpoch: (0, $5DqgT.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $c3af9e523501759a$var$GetLargestAccountsRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.type)({
    lamports: (0, $5DqgT.number)(),
    address: $c3af9e523501759a$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $c3af9e523501759a$var$AccountInfoResult = (0, $5DqgT.type)({
    executable: (0, $5DqgT.boolean)(),
    owner: $c3af9e523501759a$var$PublicKeyFromString,
    lamports: (0, $5DqgT.number)(),
    data: $c3af9e523501759a$var$BufferFromRawAccountData,
    rentEpoch: (0, $5DqgT.number)()
});
/**
 * @internal
 */ const $c3af9e523501759a$var$KeyedAccountInfoResult = (0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$AccountInfoResult
});
const $c3af9e523501759a$var$ParsedOrRawAccountData = (0, $5DqgT.coerce)((0, $5DqgT.union)([
    (0, $5DqgT.instance)((0, $6ZWSX.Buffer)),
    $c3af9e523501759a$var$ParsedAccountDataResult
]), (0, $5DqgT.union)([
    $c3af9e523501759a$var$RawAccountDataResult,
    $c3af9e523501759a$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $5DqgT.create)(value, $c3af9e523501759a$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedAccountInfoResult = (0, $5DqgT.type)({
    executable: (0, $5DqgT.boolean)(),
    owner: $c3af9e523501759a$var$PublicKeyFromString,
    lamports: (0, $5DqgT.number)(),
    data: $c3af9e523501759a$var$ParsedOrRawAccountData,
    rentEpoch: (0, $5DqgT.number)()
});
const $c3af9e523501759a$var$KeyedParsedAccountInfoResult = (0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $c3af9e523501759a$var$StakeActivationResult = (0, $5DqgT.type)({
    state: (0, $5DqgT.union)([
        (0, $5DqgT.literal)('active'),
        (0, $5DqgT.literal)('inactive'),
        (0, $5DqgT.literal)('activating'),
        (0, $5DqgT.literal)('deactivating')
    ]),
    active: (0, $5DqgT.number)(),
    inactive: (0, $5DqgT.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $c3af9e523501759a$var$GetConfirmedSignaturesForAddress2RpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)((0, $5DqgT.type)({
    signature: (0, $5DqgT.string)(),
    slot: (0, $5DqgT.number)(),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    memo: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    blockTime: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $c3af9e523501759a$var$GetSignaturesForAddressRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)((0, $5DqgT.type)({
    signature: (0, $5DqgT.string)(),
    slot: (0, $5DqgT.number)(),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    memo: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    blockTime: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $c3af9e523501759a$var$AccountNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$AccountInfoResult)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ProgramAccountInfoResult = (0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    account: $c3af9e523501759a$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $c3af9e523501759a$var$ProgramAccountNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$SlotInfoResult = (0, $5DqgT.type)({
    parent: (0, $5DqgT.number)(),
    slot: (0, $5DqgT.number)(),
    root: (0, $5DqgT.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $c3af9e523501759a$var$SlotNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: $c3af9e523501759a$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $c3af9e523501759a$var$SlotUpdateResult = (0, $5DqgT.union)([
    (0, $5DqgT.type)({
        type: (0, $5DqgT.union)([
            (0, $5DqgT.literal)('firstShredReceived'),
            (0, $5DqgT.literal)('completed'),
            (0, $5DqgT.literal)('optimisticConfirmation'),
            (0, $5DqgT.literal)('root')
        ]),
        slot: (0, $5DqgT.number)(),
        timestamp: (0, $5DqgT.number)()
    }),
    (0, $5DqgT.type)({
        type: (0, $5DqgT.literal)('createdBank'),
        parent: (0, $5DqgT.number)(),
        slot: (0, $5DqgT.number)(),
        timestamp: (0, $5DqgT.number)()
    }),
    (0, $5DqgT.type)({
        type: (0, $5DqgT.literal)('frozen'),
        slot: (0, $5DqgT.number)(),
        timestamp: (0, $5DqgT.number)(),
        stats: (0, $5DqgT.type)({
            numTransactionEntries: (0, $5DqgT.number)(),
            numSuccessfulTransactions: (0, $5DqgT.number)(),
            numFailedTransactions: (0, $5DqgT.number)(),
            maxTransactionsPerEntry: (0, $5DqgT.number)()
        })
    }),
    (0, $5DqgT.type)({
        type: (0, $5DqgT.literal)('dead'),
        slot: (0, $5DqgT.number)(),
        timestamp: (0, $5DqgT.number)(),
        err: (0, $5DqgT.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $c3af9e523501759a$var$SlotUpdateNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: $c3af9e523501759a$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $c3af9e523501759a$var$SignatureNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: $c3af9e523501759a$var$notificationResultAndContext((0, $5DqgT.union)([
        $c3af9e523501759a$var$SignatureStatusResult,
        $c3af9e523501759a$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $c3af9e523501759a$var$RootNotificationResult = (0, $5DqgT.type)({
    subscription: (0, $5DqgT.number)(),
    result: (0, $5DqgT.number)()
});
const $c3af9e523501759a$var$ContactInfoResult = (0, $5DqgT.type)({
    pubkey: (0, $5DqgT.string)(),
    gossip: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    tpu: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    rpc: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    version: (0, $5DqgT.nullable)((0, $5DqgT.string)())
});
const $c3af9e523501759a$var$VoteAccountInfoResult = (0, $5DqgT.type)({
    votePubkey: (0, $5DqgT.string)(),
    nodePubkey: (0, $5DqgT.string)(),
    activatedStake: (0, $5DqgT.number)(),
    epochVoteAccount: (0, $5DqgT.boolean)(),
    epochCredits: (0, $5DqgT.array)((0, $5DqgT.tuple)([
        (0, $5DqgT.number)(),
        (0, $5DqgT.number)(),
        (0, $5DqgT.number)()
    ])),
    commission: (0, $5DqgT.number)(),
    lastVote: (0, $5DqgT.number)(),
    rootSlot: (0, $5DqgT.nullable)((0, $5DqgT.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $c3af9e523501759a$var$GetVoteAccounts = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.type)({
    current: (0, $5DqgT.array)($c3af9e523501759a$var$VoteAccountInfoResult),
    delinquent: (0, $5DqgT.array)($c3af9e523501759a$var$VoteAccountInfoResult)
}));
const $c3af9e523501759a$var$ConfirmationStatus = (0, $5DqgT.union)([
    (0, $5DqgT.literal)('processed'),
    (0, $5DqgT.literal)('confirmed'),
    (0, $5DqgT.literal)('finalized')
]);
const $c3af9e523501759a$var$SignatureStatusResponse = (0, $5DqgT.type)({
    slot: (0, $5DqgT.number)(),
    confirmations: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    err: $c3af9e523501759a$var$TransactionErrorResult,
    confirmationStatus: (0, $5DqgT.optional)($c3af9e523501759a$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $c3af9e523501759a$var$GetSignatureStatusesRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.nullable)($c3af9e523501759a$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $c3af9e523501759a$var$GetMinimumBalanceForRentExemptionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)());
const $c3af9e523501759a$var$AddressTableLookupStruct = (0, $5DqgT.type)({
    accountKey: $c3af9e523501759a$var$PublicKeyFromString,
    writableIndexes: (0, $5DqgT.array)((0, $5DqgT.number)()),
    readonlyIndexes: (0, $5DqgT.array)((0, $5DqgT.number)())
});
const $c3af9e523501759a$var$TransactionConfigResult = (0, $5DqgT.type)({
    computeUnitLimit: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    heapSize: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    loadedAccountsDataSizeLimit: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    priorityFee: (0, $5DqgT.nullable)((0, $5DqgT.number)())
});
const $c3af9e523501759a$var$ConfirmedTransactionResult = (0, $5DqgT.type)({
    signatures: (0, $5DqgT.array)((0, $5DqgT.string)()),
    message: (0, $5DqgT.type)({
        accountKeys: (0, $5DqgT.array)((0, $5DqgT.string)()),
        header: (0, $5DqgT.type)({
            numRequiredSignatures: (0, $5DqgT.number)(),
            numReadonlySignedAccounts: (0, $5DqgT.number)(),
            numReadonlyUnsignedAccounts: (0, $5DqgT.number)()
        }),
        instructions: (0, $5DqgT.array)((0, $5DqgT.type)({
            accounts: (0, $5DqgT.array)((0, $5DqgT.number)()),
            data: (0, $5DqgT.string)(),
            programIdIndex: (0, $5DqgT.number)()
        })),
        recentBlockhash: (0, $5DqgT.string)(),
        addressTableLookups: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$AddressTableLookupStruct)),
        transactionConfig: (0, $5DqgT.optional)((0, $5DqgT.nullable)($c3af9e523501759a$var$TransactionConfigResult))
    })
});
const $c3af9e523501759a$var$AnnotatedAccountKey = (0, $5DqgT.type)({
    pubkey: $c3af9e523501759a$var$PublicKeyFromString,
    signer: (0, $5DqgT.boolean)(),
    writable: (0, $5DqgT.boolean)(),
    source: (0, $5DqgT.optional)((0, $5DqgT.union)([
        (0, $5DqgT.literal)('transaction'),
        (0, $5DqgT.literal)('lookupTable')
    ]))
});
const $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult = (0, $5DqgT.type)({
    accountKeys: (0, $5DqgT.array)($c3af9e523501759a$var$AnnotatedAccountKey),
    signatures: (0, $5DqgT.array)((0, $5DqgT.string)())
});
const $c3af9e523501759a$var$ParsedInstructionResult = (0, $5DqgT.type)({
    parsed: (0, $5DqgT.unknown)(),
    program: (0, $5DqgT.string)(),
    programId: $c3af9e523501759a$var$PublicKeyFromString
});
const $c3af9e523501759a$var$RawInstructionResult = (0, $5DqgT.type)({
    accounts: (0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString),
    data: (0, $5DqgT.string)(),
    programId: $c3af9e523501759a$var$PublicKeyFromString
});
const $c3af9e523501759a$var$InstructionResult = (0, $5DqgT.union)([
    $c3af9e523501759a$var$RawInstructionResult,
    $c3af9e523501759a$var$ParsedInstructionResult
]);
const $c3af9e523501759a$var$UnknownInstructionResult = (0, $5DqgT.union)([
    (0, $5DqgT.type)({
        parsed: (0, $5DqgT.unknown)(),
        program: (0, $5DqgT.string)(),
        programId: (0, $5DqgT.string)()
    }),
    (0, $5DqgT.type)({
        accounts: (0, $5DqgT.array)((0, $5DqgT.string)()),
        data: (0, $5DqgT.string)(),
        programId: (0, $5DqgT.string)()
    })
]);
const $c3af9e523501759a$var$ParsedOrRawInstruction = (0, $5DqgT.coerce)($c3af9e523501759a$var$InstructionResult, $c3af9e523501759a$var$UnknownInstructionResult, (value)=>{
    if ('accounts' in value) return (0, $5DqgT.create)(value, $c3af9e523501759a$var$RawInstructionResult);
    else return (0, $5DqgT.create)(value, $c3af9e523501759a$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedConfirmedTransactionResult = (0, $5DqgT.type)({
    signatures: (0, $5DqgT.array)((0, $5DqgT.string)()),
    message: (0, $5DqgT.type)({
        accountKeys: (0, $5DqgT.array)($c3af9e523501759a$var$AnnotatedAccountKey),
        instructions: (0, $5DqgT.array)($c3af9e523501759a$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $5DqgT.string)(),
        addressTableLookups: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)($c3af9e523501759a$var$AddressTableLookupStruct))),
        transactionConfig: (0, $5DqgT.optional)((0, $5DqgT.nullable)($c3af9e523501759a$var$TransactionConfigResult))
    })
});
const $c3af9e523501759a$var$TokenBalanceResult = (0, $5DqgT.type)({
    accountIndex: (0, $5DqgT.number)(),
    mint: (0, $5DqgT.string)(),
    owner: (0, $5DqgT.optional)((0, $5DqgT.string)()),
    programId: (0, $5DqgT.optional)((0, $5DqgT.string)()),
    uiTokenAmount: $c3af9e523501759a$var$TokenAmountResult
});
const $c3af9e523501759a$var$LoadedAddressesResult = (0, $5DqgT.type)({
    writable: (0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString),
    readonly: (0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ConfirmedTransactionMetaResult = (0, $5DqgT.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    fee: (0, $5DqgT.number)(),
    innerInstructions: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.type)({
        index: (0, $5DqgT.number)(),
        instructions: (0, $5DqgT.array)((0, $5DqgT.type)({
            accounts: (0, $5DqgT.array)((0, $5DqgT.number)()),
            data: (0, $5DqgT.string)(),
            programIdIndex: (0, $5DqgT.number)()
        }))
    })))),
    preBalances: (0, $5DqgT.array)((0, $5DqgT.number)()),
    postBalances: (0, $5DqgT.array)((0, $5DqgT.number)()),
    logMessages: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.string)()))),
    preTokenBalances: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)($c3af9e523501759a$var$TokenBalanceResult))),
    postTokenBalances: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)($c3af9e523501759a$var$TokenBalanceResult))),
    loadedAddresses: (0, $5DqgT.optional)($c3af9e523501759a$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $5DqgT.optional)((0, $5DqgT.number)()),
    costUnits: (0, $5DqgT.optional)((0, $5DqgT.number)())
});
/**
 * @internal
 */ const $c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult = (0, $5DqgT.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    fee: (0, $5DqgT.number)(),
    innerInstructions: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.type)({
        index: (0, $5DqgT.number)(),
        instructions: (0, $5DqgT.array)($c3af9e523501759a$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $5DqgT.array)((0, $5DqgT.number)()),
    postBalances: (0, $5DqgT.array)((0, $5DqgT.number)()),
    logMessages: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)((0, $5DqgT.string)()))),
    preTokenBalances: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)($c3af9e523501759a$var$TokenBalanceResult))),
    postTokenBalances: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.array)($c3af9e523501759a$var$TokenBalanceResult))),
    loadedAddresses: (0, $5DqgT.optional)($c3af9e523501759a$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $5DqgT.optional)((0, $5DqgT.number)()),
    costUnits: (0, $5DqgT.optional)((0, $5DqgT.number)())
});
const $c3af9e523501759a$var$TransactionVersionStruct = (0, $5DqgT.union)([
    (0, $5DqgT.literal)(0),
    (0, $5DqgT.literal)(1),
    (0, $5DqgT.literal)('legacy')
]);
/** @internal */ const $c3af9e523501759a$var$RewardsResult = (0, $5DqgT.type)({
    pubkey: (0, $5DqgT.string)(),
    lamports: (0, $5DqgT.number)(),
    postBalance: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    rewardType: (0, $5DqgT.nullable)((0, $5DqgT.string)()),
    commission: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    transactions: (0, $5DqgT.array)((0, $5DqgT.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
        meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
        version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $c3af9e523501759a$var$GetNoneModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $c3af9e523501759a$var$GetAccountsModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    transactions: (0, $5DqgT.array)((0, $5DqgT.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
        version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetParsedBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    transactions: (0, $5DqgT.array)((0, $5DqgT.type)({
        transaction: $c3af9e523501759a$var$ParsedConfirmedTransactionResult,
        meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $c3af9e523501759a$var$GetParsedAccountsModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    transactions: (0, $5DqgT.array)((0, $5DqgT.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
    })),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $c3af9e523501759a$var$GetParsedNoneModeBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)()),
    blockHeight: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $c3af9e523501759a$var$GetConfirmedBlockRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    transactions: (0, $5DqgT.array)((0, $5DqgT.type)({
        transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
        meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $5DqgT.optional)((0, $5DqgT.array)($c3af9e523501759a$var$RewardsResult)),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $c3af9e523501759a$var$GetBlockSignaturesRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    previousBlockhash: (0, $5DqgT.string)(),
    parentSlot: (0, $5DqgT.number)(),
    signatures: (0, $5DqgT.array)((0, $5DqgT.string)()),
    blockTime: (0, $5DqgT.nullable)((0, $5DqgT.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $c3af9e523501759a$var$GetTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    slot: (0, $5DqgT.number)(),
    meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)())),
    transaction: $c3af9e523501759a$var$ConfirmedTransactionResult,
    version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $c3af9e523501759a$var$GetParsedTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.type)({
    slot: (0, $5DqgT.number)(),
    transaction: $c3af9e523501759a$var$ParsedConfirmedTransactionResult,
    meta: (0, $5DqgT.nullable)($c3af9e523501759a$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $5DqgT.optional)((0, $5DqgT.nullable)((0, $5DqgT.number)())),
    version: (0, $5DqgT.optional)($c3af9e523501759a$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $c3af9e523501759a$var$GetLatestBlockhashRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.type)({
    blockhash: (0, $5DqgT.string)(),
    lastValidBlockHeight: (0, $5DqgT.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $c3af9e523501759a$var$IsBlockhashValidRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.boolean)());
const $c3af9e523501759a$var$PerfSampleResult = (0, $5DqgT.type)({
    slot: (0, $5DqgT.number)(),
    numTransactions: (0, $5DqgT.number)(),
    numSlots: (0, $5DqgT.number)(),
    samplePeriodSecs: (0, $5DqgT.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $c3af9e523501759a$var$GetRecentPerformanceSamplesRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)($c3af9e523501759a$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $c3af9e523501759a$var$GetFeeCalculatorRpcResult = $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.nullable)((0, $5DqgT.type)({
    feeCalculator: (0, $5DqgT.type)({
        lamportsPerSignature: (0, $5DqgT.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $c3af9e523501759a$var$RequestAirdropRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $c3af9e523501759a$var$SendTransactionRpcResult = $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $c3af9e523501759a$var$LogsResult = (0, $5DqgT.type)({
    err: $c3af9e523501759a$var$TransactionErrorResult,
    logs: (0, $5DqgT.array)((0, $5DqgT.string)()),
    signature: (0, $5DqgT.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $c3af9e523501759a$var$LogsNotificationResult = (0, $5DqgT.type)({
    result: $c3af9e523501759a$var$notificationResultAndContext($c3af9e523501759a$var$LogsResult),
    subscription: (0, $5DqgT.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $c3af9e523501759a$var$COMMON_HTTP_HEADERS = {
    'solana-client': `js/${"1.99.0"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $c3af9e523501759a$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $c3af9e523501759a$var$fastStableStringify(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest('getBlockHeight', args);
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)()));
                        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get block height information');
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === 'string') this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $c3af9e523501759a$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $c3af9e523501759a$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $c3af9e523501759a$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $c3af9e523501759a$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $c3af9e523501759a$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $c3af9e523501759a$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on('open', this._wsOnOpen.bind(this));
        this._rpcWebSocket.on('error', this._wsOnError.bind(this));
        this._rpcWebSocket.on('close', this._wsOnClose.bind(this));
        this._rpcWebSocket.on('accountNotification', this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on('programNotification', this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on('slotNotification', this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on('slotsUpdatesNotification', this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on('signatureNotification', this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on('rootNotification', this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on('logsNotification', this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBalance', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.number)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get balance of account ' + publicKey.toBase58() + ': ' + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest('getBlockTime', [
            slot
        ]);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.nullable)((0, $5DqgT.number)())));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest('minimumLedgerSlot', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get minimum ledger slot');
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest('getFirstAvailableBlock', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$SlotRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get first available block');
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === 'string') configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest('getSupply', [
            configArg
        ]);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetSupplyRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get supply');
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenSupply', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext($c3af9e523501759a$var$TokenAmountResult));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get token supply');
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenAccountBalance', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext($c3af9e523501759a$var$TokenAmountResult));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get token account balance');
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetTokenAccountsByOwner);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ('mint' in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getTokenAccountsByOwner', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTokenAccountsByOwner);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest('getLargestAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetLargestAccountsRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get largest accounts');
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTokenLargestAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetTokenLargestAccountsResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get token largest accounts');
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.nullable)($c3af9e523501759a$var$AccountInfoResult)));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getAccountInfo', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.nullable)($c3af9e523501759a$var$ParsedAccountInfoResult)));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get info about account ' + publicKey.toBase58() + ': ' + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.nullable)($c3af9e523501759a$var$ParsedAccountInfoResult))));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, 'base64', config);
        const unsafeRes = await this._rpcRequest('getMultipleAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.array)((0, $5DqgT.nullable)($c3af9e523501759a$var$AccountInfoResult))));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getStakeActivation', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$StakeActivationResult));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || 'base64', {
            ...configWithoutEncoding,
            ...configWithoutEncoding.filters ? {
                filters: $c3af9e523501759a$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
            } : null
        });
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const baseSchema = (0, $5DqgT.array)($c3af9e523501759a$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext(baseSchema)) : (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult(baseSchema));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getProgramAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)($c3af9e523501759a$var$KeyedParsedAccountInfoResult)));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == 'string') rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).decode(rawSignature);
        } catch (err) {
            throw new Error('signature must be base58 encoded: ' + rawSignature);
        }
        $c3af9e523501759a$var$assert(decodedSignature.length === 64, 'signature has invalid length');
        if (typeof strategy === 'string') return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ('lastValidBlockHeight' in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener('abort', ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === 'subscribed') resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case 'confirmed':
                            case 'single':
                            case 'singleGossip':
                                if (value.confirmationStatus === 'processed') return;
                                break;
                            case 'finalized':
                            case 'max':
                            case 'root':
                                if (value.confirmationStatus === 'processed' || value.confirmationStatus === 'confirmed') return;
                                break;
                            // exhaust enums to ensure full coverage
                            case 'processed':
                            case 'recent':
                        }
                        done = true;
                        resolve({
                            __type: $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $c3af9e523501759a$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $c3af9e523501759a$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $c3af9e523501759a$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $c3af9e523501759a$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $c3af9e523501759a$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $c3af9e523501759a$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || 'finalized';
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case 'processed':
                        case 'recent':
                            if (confirmationStatus !== 'processed' && confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'confirmed':
                        case 'single':
                        case 'singleGossip':
                            if (confirmationStatus !== 'confirmed' && confirmationStatus !== 'finalized') throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        case 'finalized':
                        case 'max':
                        case 'root':
                            if (confirmationStatus !== 'finalized') throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $c3af9e523501759a$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case 'processed':
                case 'recent':
                case 'single':
                case 'confirmed':
                case 'singleGossip':
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $c3af9e523501759a$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $c3af9e523501759a$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $c3af9e523501759a$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest('getClusterNodes', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)($c3af9e523501759a$var$ContactInfoResult)));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get cluster nodes');
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getVoteAccounts', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetVoteAccounts);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get vote accounts');
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlot', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot');
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getSlotLeader', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.string)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leader');
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest('getSlotLeaders', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)($c3af9e523501759a$var$PublicKeyFromString)));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get slot leaders');
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $c3af9e523501759a$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest('getSignatureStatuses', params);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetSignatureStatusesRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get signature status');
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransactionCount', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.number)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction count');
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest('getInflationGovernor', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetInflationGovernorRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation');
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest('getInflationReward', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetInflationRewardResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation reward');
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest('getInflationRate', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetInflationRateRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get inflation rate');
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getEpochInfo', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetEpochInfoRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch info');
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest('getEpochSchedule', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetEpochScheduleRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get epoch schedule');
        const epochSchedule = res.result;
        return new $c3af9e523501759a$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest('getLeaderSchedule', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetLeaderScheduleRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get leader schedule');
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest('getMinimumBalanceForRentExemption', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ('error' in res) {
            console.warn('Unable to fetch minimum balance for rent exemption');
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const { context: context, value: { blockhash: blockhash } } = await this.getLatestBlockhashAndContext(commitment);
        const feeCalculator = {
            get lamportsPerSignature () {
                throw new Error("The capability to fetch `lamportsPerSignature` using the `getRecentBlockhash` API is no longer offered by the network. Use the `getFeeForMessage` API to obtain the fee for a given message.");
            },
            toJSON () {
                return {};
            }
        };
        return {
            context: context,
            value: {
                blockhash: blockhash,
                feeCalculator: feeCalculator
            }
        };
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest('getRecentPerformanceSamples', limit ? [
            limit
        ] : []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetRecentPerformanceSamplesRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent performance samples');
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeCalculatorForBlockhash', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetFeeCalculatorRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee calculator');
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $c3af9e523501759a$var$toBuffer(message.serialize()).toString('base64');
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest('getFeeForMessage', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.nullable)((0, $5DqgT.number)())));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get fee for message');
        if (res.result === null) throw new Error('invalid blockhash');
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest('getRecentPrioritizationFees', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetRecentPrioritizationFeesRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get recent prioritization fees');
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error('failed to get recent blockhash: ' + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getLatestBlockhash', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetLatestBlockhashRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get latest blockhash');
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('isBlockhashValid', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$IsBlockhashValidRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to determine if the blockhash `' + blockhash + '`is valid');
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest('getVersion', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult($c3af9e523501759a$var$VersionResult));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get version');
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest('getGenesisHash', []);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.string)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get genesis hash');
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetBlockRpcResult);
                        if ('error' in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $c3af9e523501759a$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(e, 'failed to get confirmed block');
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        try {
            switch(config?.transactionDetails){
                case 'accounts':
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedAccountsModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                case 'none':
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedNoneModeBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedBlockRpcResult);
                        if ('error' in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(e, 'failed to get block');
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === 'string') commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, 'base64', extra);
        const unsafeRes = await this._rpcRequest('getBlockProduction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$BlockProductionResponseStruct);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get block production information');
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $c3af9e523501759a$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed', config);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed', config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
            if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transactions');
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $c3af9e523501759a$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetConfirmedBlockRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $c3af9e523501759a$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $c3af9e523501759a$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest('getBlocks', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResult((0, $5DqgT.array)((0, $5DqgT.number)())));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get blocks');
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get block');
        const result = res.result;
        if (!result) throw new Error('Block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: 'signatures',
            rewards: false
        });
        const unsafeRes = await this._rpcRequest('getBlock', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetBlockSignaturesRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed block');
        const result = res.result;
        if (!result) throw new Error('Confirmed block ' + slot + ' not found');
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetTransactionRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get transaction');
        const result = res.result;
        if (!result) return result;
        const message = new $c3af9e523501759a$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $c3af9e523501759a$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, 'jsonParsed');
        const unsafeRes = await this._rpcRequest('getTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transaction');
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, 'jsonParsed');
            return {
                methodName: 'getTransaction',
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetParsedTransactionRpcResult);
            if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed transactions');
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!('until' in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, 'finalized');
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot('finalized');
        while(!('before' in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes('skipped')) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getConfirmedSignaturesForAddress2', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get confirmed signatures for address');
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest('getSignaturesForAddress', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$GetSignaturesForAddressRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, 'failed to get signatures for address');
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $c3af9e523501759a$export$5b2310da10e607da({
            key: accountKey,
            state: $c3af9e523501759a$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $c3af9e523501759a$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error('failed to get nonce for account ' + nonceAccount.toBase58() + ': ' + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest('requestAirdrop', [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$RequestAirdropRpcResult);
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $c3af9e523501759a$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $c3af9e523501759a$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash('finalized');
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $c3af9e523501759a$var$sleep($c3af9e523501759a$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $c3af9e523501759a$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, 'base64', configArg);
        const unsafeRes = await this._rpcRequest('getStakeMinimumDelegation', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$jsonRpcResultAndContext((0, $5DqgT.number)()));
        if ('error' in res) throw new $c3af9e523501759a$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ('message' in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $6ZWSX.Buffer).from(wireTransaction).toString('base64');
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error('Invalid arguments');
            const config = configOrSigners || {};
            config.encoding = 'base64';
            if (!('commitment' in config)) config.commitment = this.commitment;
            if (configOrSigners && typeof configOrSigners === 'object' && 'innerInstructions' in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest('simulateTransaction', args);
            const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$SimulatedTransactionResponseStruct);
            if ('error' in res) throw new Error('failed to simulate transaction: ' + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $c3af9e523501759a$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $c3af9e523501759a$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error('Invalid arguments');
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString('base64');
        const config = {
            encoding: 'base64',
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config['accounts'] = {
                encoding: 'base64',
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        if (configOrSigners && typeof configOrSigners === 'object' && 'innerInstructions' in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('simulateTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$SimulatedTransactionResponseStruct);
        if ('error' in res) {
            let logs;
            if ('data' in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = '\n    ';
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $c3af9e523501759a$export$121e803f723b3045({
                action: 'simulate',
                signature: '',
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ('version' in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error('Invalid arguments');
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error('!signature'); // should never happen
                const signature = transaction.signature.toString('base64');
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $c3af9e523501759a$var$toBuffer(rawTransaction).toString('base64');
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: 'base64'
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? 'processed' // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest('sendTransaction', args);
        const res = (0, $5DqgT.create)(unsafeRes, $c3af9e523501759a$var$SendTransactionRpcResult);
        if ('error' in res) {
            let logs = undefined;
            if ('data' in res.error) logs = res.error.data.logs;
            throw new $c3af9e523501759a$export$121e803f723b3045({
                action: skipPreflight ? 'send' : 'simulate',
                signature: '',
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify('ping');
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error('ws error:', err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: 'pending'
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case 'pending':
                case 'unsubscribed':
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === 'unsubscribed') delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'subscribing'
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: 'subscribed'
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            console.error(`Received ${e instanceof Error ? '' : 'JSON-RPC '}error calling \`${method}\``, {
                                args: args,
                                error: e
                            });
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'pending'
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case 'subscribed':
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: 'unsubscribing'
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: 'subscribed'
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: 'unsubscribed'
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $c3af9e523501759a$var$fastStableStringify([
            subscriptionConfig.method,
            args
        ]);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: 'pending'
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $c3af9e523501759a$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onAccountChange(publicKey, callback, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64', config);
        return this._makeSubscription({
            callback: callback,
            method: 'accountSubscribe',
            unsubscribeMethod: 'accountUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'account change');
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
        const { commitment: commitment, config: config } = $c3af9e523501759a$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || 'finalized', // Apply connection/server default.
        'base64' /* encoding */ , config ? config : maybeFilters ? {
            filters: $c3af9e523501759a$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: 'programSubscribe',
            unsubscribeMethod: 'programUnsubscribe'
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'program account change');
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === 'object' ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: 'logsSubscribe',
            unsubscribeMethod: 'logsUnsubscribe'
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'logs');
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotSubscribe',
            unsubscribeMethod: 'slotUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot change');
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'slotsUpdatesSubscribe',
            unsubscribeMethod: 'slotsUpdatesUnsubscribe'
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'slot update');
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn('Ignored unsubscribe request because an active subscription with id ' + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + 'could not be found.');
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            'confirmed',
            'finalized'
        ].includes(commitment)) throw new Error('Using Connection with default commitment: `' + this._commitment + '`, but method requires at least `confirmed`');
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$SignatureNotificationResult);
        if (result.value !== 'receivedSignature') /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === 'receivedSignature' ? [
            {
                type: 'received'
            },
            result.context
        ] : [
            {
                type: 'status',
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || 'finalized' // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === 'status') {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || 'finalized' // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: 'signatureSubscribe',
            unsubscribeMethod: 'signatureUnsubscribe'
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'signature result');
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $5DqgT.create)(notification, $c3af9e523501759a$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: 'rootSubscribe',
            unsubscribeMethod: 'rootUnsubscribe'
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, 'root change');
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $c3af9e523501759a$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $c3af9e523501759a$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $c3af9e523501759a$export$c53bca448cf33676($c3af9e523501759a$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error('bad secret key size');
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $c3af9e523501759a$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error('provided secretKey is invalid');
            }
        }
        return new $c3af9e523501759a$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $c3af9e523501759a$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $c3af9e523501759a$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $c3af9e523501759a$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$u64('recentSlot'),
            $Q02IV.u8('bumpSeed')
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$u64(),
            $Q02IV.seq($c3af9e523501759a$var$publicKey(), $Q02IV.offset($Q02IV.u32(), -8), 'addresses')
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    }
});
class $c3af9e523501759a$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32('instruction');
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($c3af9e523501759a$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error('Invalid Instruction. Should be a LookupTable Instruction');
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $c3af9e523501759a$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$5147a345798de168.programId)) throw new Error('invalid instruction; programId is not AddressLookupTable Program');
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $c3af9e523501759a$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $c3af9e523501759a$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $cWwdi.getU64Encoder)().encode(params.recentSlot)
        ], this.programId);
        const type = $c3af9e523501759a$export$7d102200c3a357d6.CreateLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $c3af9e523501759a$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $c3af9e523501759a$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $c3af9e523501759a$export$7d102200c3a357d6.CloseLookupTable;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$c3af9e523501759a$export$5147a345798de168.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('AddressLookupTab1e1111111111111111111111111');
/**
 * Compute Budget Instruction class
 */ class $c3af9e523501759a$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u8('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a ComputeBudgetInstruction');
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$11585db5942bcdb7.programId)) throw new Error('invalid instruction; programId is not ComputeBudgetProgram');
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u8('instruction'),
            $Q02IV.u32('units'),
            $Q02IV.u32('additionalFee')
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u8('instruction'),
            $Q02IV.u32('bytes')
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u8('instruction'),
            $Q02IV.u32('units')
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u8('instruction'),
            $c3af9e523501759a$var$u64('microLamports')
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $c3af9e523501759a$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.RequestUnits;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $c3af9e523501759a$var$encodeData(type, params);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $c3af9e523501759a$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $c3af9e523501759a$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$11585db5942bcdb7.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('ComputeBudget111111111111111111111111111111');
const $c3af9e523501759a$var$PRIVATE_KEY_BYTES$1 = 64;
const $c3af9e523501759a$var$PUBLIC_KEY_BYTES$1 = 32;
const $c3af9e523501759a$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT = $Q02IV.struct([
    $Q02IV.u8('numSignatures'),
    $Q02IV.u8('padding'),
    $Q02IV.u16('signatureOffset'),
    $Q02IV.u16('signatureInstructionIndex'),
    $Q02IV.u16('publicKeyOffset'),
    $Q02IV.u16('publicKeyInstructionIndex'),
    $Q02IV.u16('messageDataOffset'),
    $Q02IV.u16('messageDataSize'),
    $Q02IV.u16('messageInstructionIndex')
]);
class $c3af9e523501759a$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(publicKey.length === $c3af9e523501759a$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$c3af9e523501759a$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $c3af9e523501759a$var$assert(signature.length === $c3af9e523501759a$var$SIGNATURE_BYTES, `Signature must be ${$c3af9e523501759a$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $6ZWSX.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $c3af9e523501759a$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $c3af9e523501759a$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(privateKey.length === $c3af9e523501759a$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$c3af9e523501759a$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $c3af9e523501759a$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $c3af9e523501759a$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$c3af9e523501759a$export$e5087aea02631e.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('Ed25519SigVerify111111111111111111111111111');
const $c3af9e523501759a$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $4hazQ.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $4hazQ.secp256k1).utils.isValidPrivateKey;
const $c3af9e523501759a$var$publicKeyCreate = (0, $4hazQ.secp256k1).getPublicKey;
const $c3af9e523501759a$var$PRIVATE_KEY_BYTES = 32;
const $c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES = 20;
const $c3af9e523501759a$var$PUBLIC_KEY_BYTES = 64;
const $c3af9e523501759a$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT = $Q02IV.struct([
    $Q02IV.u8('numSignatures'),
    $Q02IV.u16('signatureOffset'),
    $Q02IV.u8('signatureInstructionIndex'),
    $Q02IV.u16('ethAddressOffset'),
    $Q02IV.u8('ethAddressInstructionIndex'),
    $Q02IV.u16('messageDataOffset'),
    $Q02IV.u16('messageDataSize'),
    $Q02IV.u8('messageInstructionIndex'),
    $Q02IV.blob(20, 'ethAddress'),
    $Q02IV.blob(64, 'signature'),
    $Q02IV.u8('recoveryId')
]);
class $c3af9e523501759a$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $c3af9e523501759a$var$assert(publicKey.length === $c3af9e523501759a$var$PUBLIC_KEY_BYTES, `Public key must be ${$c3af9e523501759a$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $6ZWSX.Buffer).from((0, $lk8ID.keccak_256)($c3af9e523501759a$var$toBuffer(publicKey))).slice(-$c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $c3af9e523501759a$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $c3af9e523501759a$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === 'string') {
            if (rawAddress.startsWith('0x')) ethAddress = (0, $6ZWSX.Buffer).from(rawAddress.substr(2), 'hex');
            else ethAddress = (0, $6ZWSX.Buffer).from(rawAddress, 'hex');
        } else ethAddress = rawAddress;
        $c3af9e523501759a$var$assert(ethAddress.length === $c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$c3af9e523501759a$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $c3af9e523501759a$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $6ZWSX.Buffer).alloc($c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $c3af9e523501759a$var$toBuffer(signature),
            ethAddress: $c3af9e523501759a$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($c3af9e523501759a$var$toBuffer(message), $c3af9e523501759a$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $c3af9e523501759a$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $c3af9e523501759a$var$assert(pkey.length === $c3af9e523501759a$var$PRIVATE_KEY_BYTES, `Private key must be ${$c3af9e523501759a$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $c3af9e523501759a$var$toBuffer(pkey);
            const publicKey = $c3af9e523501759a$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $6ZWSX.Buffer).from((0, $lk8ID.keccak_256)($c3af9e523501759a$var$toBuffer(message)));
            const [signature, recoveryId] = $c3af9e523501759a$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$c3af9e523501759a$export$d85dd4c1161d13c9.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('KeccakSecp256k11111111111111111111111111111');
var $c3af9e523501759a$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $c3af9e523501759a$export$18aac71979bdd08f = new $c3af9e523501759a$export$ca8b6604d6ce14de('StakeConfig11111111111111111111111111111111');
/**
 * Stake account authority info
 */ class $c3af9e523501759a$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $c3af9e523501759a$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$c3af9e523501759a$var$_Lockup = $c3af9e523501759a$export$e7f3941ade35598c;
$c3af9e523501759a$export$e7f3941ade35598c.default = new $c3af9e523501759a$var$_Lockup(0, 0, $c3af9e523501759a$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $c3af9e523501759a$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a StakeInstruction');
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $c3af9e523501759a$export$9ac74ae66932a145(new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized.staker), new $c3af9e523501759a$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $c3af9e523501759a$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $c3af9e523501759a$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$df86f933e9f8fb15.programId)) throw new Error('invalid instruction; programId is not StakeProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $c3af9e523501759a$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$authorized(),
            $c3af9e523501759a$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('newAuthorized'),
            $Q02IV.u32('stakeAuthorizationType')
        ])
    },
    Delegate: {
        index: 2,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    Split: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('lamports')
        ])
    },
    Withdraw: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('lamports')
        ])
    },
    Deactivate: {
        index: 5,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    Merge: {
        index: 7,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('newAuthorized'),
            $Q02IV.u32('stakeAuthorizationType'),
            $c3af9e523501759a$var$rustString('authoritySeed'),
            $c3af9e523501759a$var$publicKey('authorityOwner')
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $c3af9e523501759a$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $c3af9e523501759a$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $c3af9e523501759a$export$e7f3941ade35598c.default;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Initialize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            authorized: {
                staker: $c3af9e523501759a$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $c3af9e523501759a$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $c3af9e523501759a$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Delegate;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Authorize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $c3af9e523501759a$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Split;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($c3af9e523501759a$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Merge;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Withdraw;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $c3af9e523501759a$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $c3af9e523501759a$export$c89793bd2bba8b2e.Deactivate;
        const data = $c3af9e523501759a$var$encodeData(type);
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$df86f933e9f8fb15.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('Stake11111111111111111111111111111111111111');
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $c3af9e523501759a$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $c3af9e523501759a$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $c3af9e523501759a$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Q02IV.u32('instruction');
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error('Instruction type incorrect; not a VoteInstruction');
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $c3af9e523501759a$export$3f9d1b16ff840d7(new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $c3af9e523501759a$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $c3af9e523501759a$var$decodeData$1($c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($c3af9e523501759a$export$83db2bc702bee1eb.programId)) throw new Error('invalid instruction; programId is not VoteProgram');
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$publicKey('newAuthorized'),
            $Q02IV.u32('voteAuthorizationType')
        ])
    },
    Withdraw: {
        index: 3,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $Q02IV.ns64('lamports')
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction')
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $Q02IV.struct([
            $Q02IV.u32('instruction'),
            $c3af9e523501759a$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $c3af9e523501759a$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $c3af9e523501759a$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $c3af9e523501759a$var$encodeData(type, {
            voteInit: {
                nodePubkey: $c3af9e523501759a$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $c3af9e523501759a$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $c3af9e523501759a$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $c3af9e523501759a$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $c3af9e523501759a$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $c3af9e523501759a$export$febc5573c75cefb0();
        transaction.add($c3af9e523501759a$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $c3af9e523501759a$var$encodeData(type, {
            newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $c3af9e523501759a$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $c3af9e523501759a$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $c3af9e523501759a$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $c3af9e523501759a$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $c3af9e523501759a$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error('Withdraw will leave vote account with insufficient funds.');
        return $c3af9e523501759a$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $c3af9e523501759a$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $c3af9e523501759a$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $c3af9e523501759a$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$c3af9e523501759a$export$83db2bc702bee1eb.programId = new $c3af9e523501759a$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $c3af9e523501759a$export$83db2bc702bee1eb.space = 3762;
const $c3af9e523501759a$export$afdb09d3afdde87c = new $c3af9e523501759a$export$ca8b6604d6ce14de('Va1idator1nfo111111111111111111111111111111');
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $c3af9e523501759a$var$InfoString = (0, $5DqgT.type)({
    name: (0, $5DqgT.string)(),
    website: (0, $5DqgT.optional)((0, $5DqgT.string)()),
    details: (0, $5DqgT.optional)((0, $5DqgT.string)()),
    iconUrl: (0, $5DqgT.optional)((0, $5DqgT.string)()),
    keybaseUsername: (0, $5DqgT.optional)((0, $5DqgT.string)())
});
/**
 * ValidatorInfo class
 */ class $c3af9e523501759a$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $c3af9e523501759a$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $c3af9e523501759a$export$ca8b6604d6ce14de($c3af9e523501759a$var$guardedSplice(byteArray, 0, $c3af9e523501759a$export$84fc0a248cc54343));
            const isSigner = $c3af9e523501759a$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($c3af9e523501759a$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $c3af9e523501759a$var$rustString().decode((0, $6ZWSX.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $5DqgT.assert)(info, $c3af9e523501759a$var$InfoString);
                return new $c3af9e523501759a$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $c3af9e523501759a$export$90bca02a3aea0768 = new $c3af9e523501759a$export$ca8b6604d6ce14de('Vote111111111111111111111111111111111111111');
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $c3af9e523501759a$var$VoteAccountLayout = $Q02IV.struct([
    $c3af9e523501759a$var$publicKey('nodePubkey'),
    $c3af9e523501759a$var$publicKey('authorizedWithdrawer'),
    $Q02IV.u8('commission'),
    $Q02IV.nu64(),
    // votes.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64('slot'),
        $Q02IV.u32('confirmationCount')
    ]), $Q02IV.offset($Q02IV.u32(), -8), 'votes'),
    $Q02IV.u8('rootSlotValid'),
    $Q02IV.nu64('rootSlot'),
    $Q02IV.nu64(),
    // authorizedVoters.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64('epoch'),
        $c3af9e523501759a$var$publicKey('authorizedVoter')
    ]), $Q02IV.offset($Q02IV.u32(), -8), 'authorizedVoters'),
    $Q02IV.struct([
        $Q02IV.seq($Q02IV.struct([
            $c3af9e523501759a$var$publicKey('authorizedPubkey'),
            $Q02IV.nu64('epochOfLastAuthorizedSwitch'),
            $Q02IV.nu64('targetEpoch')
        ]), 32, 'buf'),
        $Q02IV.nu64('idx'),
        $Q02IV.u8('isEmpty')
    ], 'priorVoters'),
    $Q02IV.nu64(),
    // epochCredits.length
    $Q02IV.seq($Q02IV.struct([
        $Q02IV.nu64('epoch'),
        $Q02IV.nu64('credits'),
        $Q02IV.nu64('prevCredits')
    ]), $Q02IV.offset($Q02IV.u32(), -8), 'epochCredits'),
    $Q02IV.struct([
        $Q02IV.nu64('slot'),
        $Q02IV.nu64('timestamp')
    ], 'lastTimestamp')
]);
/**
 * VoteAccount class
 */ class $c3af9e523501759a$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $c3af9e523501759a$var$VoteAccountLayout.decode($c3af9e523501759a$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $c3af9e523501759a$export$89ef186f708d638b({
            nodePubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $c3af9e523501759a$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($c3af9e523501759a$var$parseAuthorizedVoter),
            priorVoters: $c3af9e523501759a$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $c3af9e523501759a$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $c3af9e523501759a$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $c3af9e523501759a$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $c3af9e523501759a$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($c3af9e523501759a$var$parsePriorVoters),
        ...buf.slice(0, idx).map($c3af9e523501759a$var$parsePriorVoters)
    ];
}
const $c3af9e523501759a$var$endpoint = {
    http: {
        devnet: 'http://api.devnet.solana.com',
        testnet: 'http://api.testnet.solana.com',
        'mainnet-beta': 'http://api.mainnet-beta.solana.com/'
    },
    https: {
        devnet: 'https://api.devnet.solana.com',
        testnet: 'https://api.testnet.solana.com',
        'mainnet-beta': 'https://api.mainnet-beta.solana.com/'
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $c3af9e523501759a$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? 'http' : 'https';
    if (!cluster) return $c3af9e523501759a$var$endpoint[key]['devnet'];
    const url = $c3af9e523501759a$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $c3af9e523501759a$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'lastValidBlockHeight')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, 'nonceValue')) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) {
        if (signature != null) throw new $c3af9e523501759a$export$121e803f723b3045({
            action: sendOptions?.skipPreflight ? 'send' : 'simulate',
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $c3af9e523501759a$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("97ic6", function(module, exports) {

$parcel$export(module.exports, "ed25519", () => $6a32e17df003bb31$export$f63794f4a09a19c1);
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $93IJ3 = parcelRequire("93IJ3");

var $aX27w = parcelRequire("aX27w");

var $gaxAZ = parcelRequire("gaxAZ");

var $IRQiB = parcelRequire("IRQiB");

var $jRTZM = parcelRequire("jRTZM");

var $f8jNy = parcelRequire("f8jNy");

var $igELH = parcelRequire("igELH");

var $3TGEu = parcelRequire("3TGEu");
// prettier-ignore
const $6a32e17df003bb31$var$_0n = /* @__PURE__ */ BigInt(0), $6a32e17df003bb31$var$_1n = BigInt(1), $6a32e17df003bb31$var$_2n = BigInt(2), $6a32e17df003bb31$var$_3n = BigInt(3);
// prettier-ignore
const $6a32e17df003bb31$var$_5n = BigInt(5), $6a32e17df003bb31$var$_8n = BigInt(8);
// P = 2n**255n-19n
const $6a32e17df003bb31$var$ed25519_CURVE_p = BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed');
// N = 2n**252n + 27742317777372353535851937790883648493n
// a = Fp.create(BigInt(-1))
// d = -121665/121666 a.k.a. Fp.neg(121665 * Fp.inv(121666))
const $6a32e17df003bb31$var$ed25519_CURVE = /* @__PURE__ */ (()=>({
        p: $6a32e17df003bb31$var$ed25519_CURVE_p,
        n: BigInt('0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed'),
        h: $6a32e17df003bb31$var$_8n,
        a: BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec'),
        d: BigInt('0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3'),
        Gx: BigInt('0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a'),
        Gy: BigInt('0x6666666666666666666666666666666666666666666666666666666666666658')
    }))();
function $6a32e17df003bb31$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $6a32e17df003bb31$var$ed25519_CURVE_p;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $f8jNy.pow2)(b2, $6a32e17df003bb31$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $f8jNy.pow2)(b4, $6a32e17df003bb31$var$_1n, P) * x % P; // x^31
    const b10 = (0, $f8jNy.pow2)(b5, $6a32e17df003bb31$var$_5n, P) * b5 % P;
    const b20 = (0, $f8jNy.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $f8jNy.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $f8jNy.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $f8jNy.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $f8jNy.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $f8jNy.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $f8jNy.pow2)(b250, $6a32e17df003bb31$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $6a32e17df003bb31$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// √(-1) aka √(a) aka 2^((p-1)/4)
// Fp.sqrt(Fp.neg(1))
const $6a32e17df003bb31$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt('19681161376707505956807079304988542015446066515923890162744021073123829784752');
// sqrt(u/v)
function $6a32e17df003bb31$var$uvRatio(u, v) {
    const P = $6a32e17df003bb31$var$ed25519_CURVE_p;
    const v3 = (0, $f8jNy.mod)(v * v * v, P); // v³
    const v7 = (0, $f8jNy.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $6a32e17df003bb31$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $f8jNy.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $f8jNy.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $f8jNy.mod)(x * $6a32e17df003bb31$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $f8jNy.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $f8jNy.mod)(-u * $6a32e17df003bb31$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $f8jNy.isNegativeLE)(x, P)) x = (0, $f8jNy.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $6a32e17df003bb31$var$Fp = /* @__PURE__ */ (()=>(0, $f8jNy.Field)($6a32e17df003bb31$var$ed25519_CURVE.p, {
        isLE: true
    }))();
const $6a32e17df003bb31$var$Fn = /* @__PURE__ */ (()=>(0, $f8jNy.Field)($6a32e17df003bb31$var$ed25519_CURVE.n, {
        isLE: true
    }))();
const $6a32e17df003bb31$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        ...$6a32e17df003bb31$var$ed25519_CURVE,
        Fp: $6a32e17df003bb31$var$Fp,
        hash: (0, $93IJ3.sha512),
        adjustScalarBytes: $6a32e17df003bb31$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $6a32e17df003bb31$var$uvRatio
    }))();
const $6a32e17df003bb31$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $IRQiB.twistedEdwards)($6a32e17df003bb31$var$ed25519Defaults))();
function $6a32e17df003bb31$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error('Context is too big');
    return (0, $aX27w.concatBytes)((0, $aX27w.utf8ToBytes)('SigEd25519 no Ed25519 collisions'), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $6a32e17df003bb31$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $IRQiB.twistedEdwards)({
        ...$6a32e17df003bb31$var$ed25519Defaults,
        domain: $6a32e17df003bb31$var$ed25519_domain
    }))();
const $6a32e17df003bb31$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $IRQiB.twistedEdwards)(Object.assign({}, $6a32e17df003bb31$var$ed25519Defaults, {
        domain: $6a32e17df003bb31$var$ed25519_domain,
        prehash: (0, $93IJ3.sha512)
    })))();
const $6a32e17df003bb31$export$dab9625394da700 = /* @__PURE__ */ (()=>{
    const P = $6a32e17df003bb31$var$Fp.ORDER;
    return (0, $igELH.montgomery)({
        P: P,
        type: 'x25519',
        powPminus2: (x)=>{
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $6a32e17df003bb31$var$ed25519_pow_2_252_3(x);
            return (0, $f8jNy.mod)((0, $f8jNy.pow2)(pow_p_5_8, $6a32e17df003bb31$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $6a32e17df003bb31$var$adjustScalarBytes
    });
})();
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $6a32e17df003bb31$var$ELL2_C1 = /* @__PURE__ */ (()=>($6a32e17df003bb31$var$ed25519_CURVE_p + $6a32e17df003bb31$var$_3n) / $6a32e17df003bb31$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $6a32e17df003bb31$var$ELL2_C2 = /* @__PURE__ */ (()=>$6a32e17df003bb31$var$Fp.pow($6a32e17df003bb31$var$_2n, $6a32e17df003bb31$var$ELL2_C1))(); // 2. c2 = 2^c1
const $6a32e17df003bb31$var$ELL2_C3 = /* @__PURE__ */ (()=>$6a32e17df003bb31$var$Fp.sqrt($6a32e17df003bb31$var$Fp.neg($6a32e17df003bb31$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $6a32e17df003bb31$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($6a32e17df003bb31$var$ed25519_CURVE_p - $6a32e17df003bb31$var$_5n) / $6a32e17df003bb31$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $6a32e17df003bb31$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $6a32e17df003bb31$var$Fp.mul(tv1, $6a32e17df003bb31$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $6a32e17df003bb31$var$Fp.add(tv1, $6a32e17df003bb31$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $6a32e17df003bb31$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $6a32e17df003bb31$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $6a32e17df003bb31$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $6a32e17df003bb31$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $6a32e17df003bb31$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $6a32e17df003bb31$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $6a32e17df003bb31$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $6a32e17df003bb31$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $6a32e17df003bb31$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $6a32e17df003bb31$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $6a32e17df003bb31$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $6a32e17df003bb31$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $6a32e17df003bb31$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $6a32e17df003bb31$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $6a32e17df003bb31$var$Fp.mul(y11, $6a32e17df003bb31$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $6a32e17df003bb31$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $6a32e17df003bb31$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $6a32e17df003bb31$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $6a32e17df003bb31$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $6a32e17df003bb31$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $6a32e17df003bb31$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $6a32e17df003bb31$var$Fp.mul(y21, $6a32e17df003bb31$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $6a32e17df003bb31$var$Fp.mul(y21, $6a32e17df003bb31$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $6a32e17df003bb31$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $6a32e17df003bb31$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $6a32e17df003bb31$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $6a32e17df003bb31$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $6a32e17df003bb31$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $6a32e17df003bb31$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $6a32e17df003bb31$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $6a32e17df003bb31$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $6a32e17df003bb31$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $6a32e17df003bb31$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $6a32e17df003bb31$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $6a32e17df003bb31$var$Fp.cmov(y, $6a32e17df003bb31$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $6a32e17df003bb31$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $6a32e17df003bb31$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $f8jNy.FpSqrtEven)($6a32e17df003bb31$var$Fp, $6a32e17df003bb31$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $6a32e17df003bb31$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $6a32e17df003bb31$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $6a32e17df003bb31$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $6a32e17df003bb31$var$Fp.mul(xn, $6a32e17df003bb31$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $6a32e17df003bb31$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $6a32e17df003bb31$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $6a32e17df003bb31$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $6a32e17df003bb31$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $6a32e17df003bb31$var$Fp.eql(tv1, $6a32e17df003bb31$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $6a32e17df003bb31$var$Fp.cmov(xn, $6a32e17df003bb31$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $6a32e17df003bb31$var$Fp.cmov(xd, $6a32e17df003bb31$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $6a32e17df003bb31$var$Fp.cmov(yn, $6a32e17df003bb31$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $6a32e17df003bb31$var$Fp.cmov(yd, $6a32e17df003bb31$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const [xd_inv, yd_inv] = (0, $f8jNy.FpInvertBatch)($6a32e17df003bb31$var$Fp, [
        xd,
        yd
    ], true); // batch division
    return {
        x: $6a32e17df003bb31$var$Fp.mul(xn, xd_inv),
        y: $6a32e17df003bb31$var$Fp.mul(yn, yd_inv)
    }; //  13. return (xn, xd, yn, yd)
}
const $6a32e17df003bb31$export$bd158472185fbd42 = /* @__PURE__ */ (()=>(0, $jRTZM.createHasher)($6a32e17df003bb31$export$f63794f4a09a19c1.Point, (scalars)=>$6a32e17df003bb31$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: 'edwards25519_XMD:SHA-512_ELL2_RO_',
        encodeDST: 'edwards25519_XMD:SHA-512_ELL2_NU_',
        p: $6a32e17df003bb31$var$ed25519_CURVE_p,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $93IJ3.sha512)
    }))();
// √(-1) aka √(a) aka 2^((p-1)/4)
const $6a32e17df003bb31$var$SQRT_M1 = $6a32e17df003bb31$var$ED25519_SQRT_M1;
// √(ad - 1)
const $6a32e17df003bb31$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt('25063068953384623474111414158702152701244531502492656460079210482610430750235');
// 1 / √(a-d)
const $6a32e17df003bb31$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt('54469307008909316920995813868745141605393597292927456921205312896311721017578');
// 1-d²
const $6a32e17df003bb31$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt('1159843021668779879193775521855586647937357759715417654439879720876111806838');
// (d-1)²
const $6a32e17df003bb31$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt('40440834346308536858101042469323190826248399146238708352240133220865137265952');
// Calculates 1/√(number)
const $6a32e17df003bb31$var$invertSqrt = (number)=>$6a32e17df003bb31$var$uvRatio($6a32e17df003bb31$var$_1n, number);
const $6a32e17df003bb31$var$MAX_255B = /* @__PURE__ */ BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
const $6a32e17df003bb31$var$bytes255ToNumberLE = (bytes)=>$6a32e17df003bb31$export$f63794f4a09a19c1.Point.Fp.create((0, $3TGEu.bytesToNumberLE)(bytes) & $6a32e17df003bb31$var$MAX_255B);
/**
 * Computes Elligator map for Ristretto255.
 * Described in [RFC9380](https://www.rfc-editor.org/rfc/rfc9380#appendix-B) and on
 * the [website](https://ristretto.group/formulas/elligator.html).
 */ function $6a32e17df003bb31$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $6a32e17df003bb31$var$ed25519_CURVE;
    const P = $6a32e17df003bb31$var$ed25519_CURVE_p;
    const mod = (n)=>$6a32e17df003bb31$var$Fp.create(n);
    const r = mod($6a32e17df003bb31$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $6a32e17df003bb31$var$_1n) * $6a32e17df003bb31$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $6a32e17df003bb31$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $f8jNy.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $6a32e17df003bb31$var$_1n) * $6a32e17df003bb31$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $6a32e17df003bb31$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($6a32e17df003bb31$var$_1n - s2); // 12
    const W3 = mod($6a32e17df003bb31$var$_1n + s2); // 13
    return new $6a32e17df003bb31$export$f63794f4a09a19c1.Point(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
function $6a32e17df003bb31$var$ristretto255_map(bytes) {
    (0, $aX27w.abytes)(bytes, 64);
    const r1 = $6a32e17df003bb31$var$bytes255ToNumberLE(bytes.subarray(0, 32));
    const R1 = $6a32e17df003bb31$var$calcElligatorRistrettoMap(r1);
    const r2 = $6a32e17df003bb31$var$bytes255ToNumberLE(bytes.subarray(32, 64));
    const R2 = $6a32e17df003bb31$var$calcElligatorRistrettoMap(r2);
    return new $6a32e17df003bb31$var$_RistrettoPoint(R1.add(R2));
}
/**
 * Wrapper over Edwards Point for ristretto255.
 *
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * See [RFC9496](https://www.rfc-editor.org/rfc/rfc9496).
 */ class $6a32e17df003bb31$var$_RistrettoPoint extends (0, $IRQiB.PrimeEdwardsPoint) {
    constructor(ep){
        super(ep);
    }
    static fromAffine(ap) {
        return new $6a32e17df003bb31$var$_RistrettoPoint($6a32e17df003bb31$export$f63794f4a09a19c1.Point.fromAffine(ap));
    }
    assertSame(other) {
        if (!(other instanceof $6a32e17df003bb31$var$_RistrettoPoint)) throw new Error('RistrettoPoint expected');
    }
    init(ep) {
        return new $6a32e17df003bb31$var$_RistrettoPoint(ep);
    }
    /** @deprecated use `import { ristretto255_hasher } from '@noble/curves/ed25519.js';` */ static hashToCurve(hex) {
        return $6a32e17df003bb31$var$ristretto255_map((0, $3TGEu.ensureBytes)('ristrettoHash', hex, 64));
    }
    static fromBytes(bytes) {
        (0, $aX27w.abytes)(bytes, 32);
        const { a: a, d: d } = $6a32e17df003bb31$var$ed25519_CURVE;
        const P = $6a32e17df003bb31$var$ed25519_CURVE_p;
        const mod = (n)=>$6a32e17df003bb31$var$Fp.create(n);
        const s = $6a32e17df003bb31$var$bytes255ToNumberLE(bytes);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $3TGEu.equalBytes)($6a32e17df003bb31$var$Fp.toBytes(s), bytes) || (0, $f8jNy.isNegativeLE)(s, P)) throw new Error('invalid ristretto255 encoding 1');
        const s2 = mod(s * s);
        const u1 = mod($6a32e17df003bb31$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($6a32e17df003bb31$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $6a32e17df003bb31$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $f8jNy.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $f8jNy.isNegativeLE)(t, P) || y === $6a32e17df003bb31$var$_0n) throw new Error('invalid ristretto255 encoding 2');
        return new $6a32e17df003bb31$var$_RistrettoPoint(new $6a32e17df003bb31$export$f63794f4a09a19c1.Point(x, y, $6a32e17df003bb31$var$_1n, t));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-decode).
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        return $6a32e17df003bb31$var$_RistrettoPoint.fromBytes((0, $3TGEu.ensureBytes)('ristrettoHex', hex, 32));
    }
    static msm(points, scalars) {
        return (0, $gaxAZ.pippenger)($6a32e17df003bb31$var$_RistrettoPoint, $6a32e17df003bb31$export$f63794f4a09a19c1.Point.Fn, points, scalars);
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-encode).
     */ toBytes() {
        let { X: X, Y: Y, Z: Z, T: T } = this.ep;
        const P = $6a32e17df003bb31$var$ed25519_CURVE_p;
        const mod = (n)=>$6a32e17df003bb31$var$Fp.create(n);
        const u1 = mod(mod(Z + Y) * mod(Z - Y)); // 1
        const u2 = mod(X * Y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $6a32e17df003bb31$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * T); // 6
        let D; // 7
        if ((0, $f8jNy.isNegativeLE)(T * zInv, P)) {
            let _x = mod(Y * $6a32e17df003bb31$var$SQRT_M1);
            let _y = mod(X * $6a32e17df003bb31$var$SQRT_M1);
            X = _x;
            Y = _y;
            D = mod(D1 * $6a32e17df003bb31$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $f8jNy.isNegativeLE)(X * zInv, P)) Y = mod(-Y); // 9
        let s = mod((Z - Y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $f8jNy.isNegativeLE)(s, P)) s = mod(-s);
        return $6a32e17df003bb31$var$Fp.toBytes(s); // 11
    }
    /**
     * Compares two Ristretto points.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-equals).
     */ equals(other) {
        this.assertSame(other);
        const { X: X1, Y: Y1 } = this.ep;
        const { X: X2, Y: Y2 } = other.ep;
        const mod = (n)=>$6a32e17df003bb31$var$Fp.create(n);
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    is0() {
        return this.equals($6a32e17df003bb31$var$_RistrettoPoint.ZERO);
    }
}
// Do NOT change syntax: the following gymnastics is done,
// because typescript strips comments, which makes bundlers disable tree-shaking.
// prettier-ignore
$6a32e17df003bb31$var$_RistrettoPoint.BASE = /* @__PURE__ */ (()=>new $6a32e17df003bb31$var$_RistrettoPoint($6a32e17df003bb31$export$f63794f4a09a19c1.Point.BASE))();
// prettier-ignore
$6a32e17df003bb31$var$_RistrettoPoint.ZERO = /* @__PURE__ */ (()=>new $6a32e17df003bb31$var$_RistrettoPoint($6a32e17df003bb31$export$f63794f4a09a19c1.Point.ZERO))();
// prettier-ignore
$6a32e17df003bb31$var$_RistrettoPoint.Fp = /* @__PURE__ */ (()=>$6a32e17df003bb31$var$Fp)();
// prettier-ignore
$6a32e17df003bb31$var$_RistrettoPoint.Fn = /* @__PURE__ */ (()=>$6a32e17df003bb31$var$Fn)();
const $6a32e17df003bb31$export$f57beb4c2054cdc7 = {
    Point: $6a32e17df003bb31$var$_RistrettoPoint
};
const $6a32e17df003bb31$export$e58e8945170587ea = {
    hashToCurve (msg, options) {
        const DST = options?.DST || 'ristretto255_XMD:SHA-512_R255MAP_RO_';
        const xmd = (0, $jRTZM.expand_message_xmd)(msg, DST, 64, (0, $93IJ3.sha512));
        return $6a32e17df003bb31$var$ristretto255_map(xmd);
    },
    hashToScalar (msg, options = {
        DST: (0, $jRTZM._DST_scalar)
    }) {
        const xmd = (0, $jRTZM.expand_message_xmd)(msg, options.DST, 64, (0, $93IJ3.sha512));
        return $6a32e17df003bb31$var$Fn.create((0, $3TGEu.bytesToNumberLE)(xmd));
    }
};
const $6a32e17df003bb31$export$5ce3305f0d0b8e6f = [
    '0100000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a',
    '0000000000000000000000000000000000000000000000000000000000000080',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05',
    'ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85',
    '0000000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa'
];
function $6a32e17df003bb31$export$78609ae56f1edf04(edwardsPub) {
    return $6a32e17df003bb31$export$f63794f4a09a19c1.utils.toMontgomery((0, $3TGEu.ensureBytes)('pub', edwardsPub));
}
const $6a32e17df003bb31$export$84bc39a6e4664b07 = $6a32e17df003bb31$export$78609ae56f1edf04;
function $6a32e17df003bb31$export$c32b0f86cebbdf19(edwardsPriv) {
    return $6a32e17df003bb31$export$f63794f4a09a19c1.utils.toMontgomerySecret((0, $3TGEu.ensureBytes)('pub', edwardsPriv));
}
const $6a32e17df003bb31$export$5e87c4f36f27816d = $6a32e17df003bb31$var$_RistrettoPoint;
const $6a32e17df003bb31$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$6a32e17df003bb31$export$bd158472185fbd42.hashToCurve)();
const $6a32e17df003bb31$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$6a32e17df003bb31$export$bd158472185fbd42.encodeToCurve)();
const $6a32e17df003bb31$export$c9ad4c0d917ad3 = /* @__PURE__ */ (()=>$6a32e17df003bb31$export$e58e8945170587ea.hashToCurve)();
const $6a32e17df003bb31$export$667ef88de7a83a7f = /* @__PURE__ */ (()=>$6a32e17df003bb31$export$e58e8945170587ea.hashToCurve)();

});
parcelRegister("93IJ3", function(module, exports) {

$parcel$export(module.exports, "SHA256", () => $6987167581226d5e$export$397b834fceb5b168);
$parcel$export(module.exports, "SHA224", () => $6987167581226d5e$export$d90fcf4a65424421);
$parcel$export(module.exports, "sha256", () => $6987167581226d5e$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha224", () => $6987167581226d5e$export$97b70509d4e397ea);
$parcel$export(module.exports, "sha512", () => $6987167581226d5e$export$a888d2532e6dc7bb);
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 
var $cUTBr = parcelRequire("cUTBr");

var $eH71W = parcelRequire("eH71W");

var $aX27w = parcelRequire("aX27w");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $6987167581226d5e$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $6987167581226d5e$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $6987167581226d5e$export$397b834fceb5b168 extends (0, $cUTBr.HashMD) {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = (0, $cUTBr.SHA256_IV)[0] | 0;
        this.B = (0, $cUTBr.SHA256_IV)[1] | 0;
        this.C = (0, $cUTBr.SHA256_IV)[2] | 0;
        this.D = (0, $cUTBr.SHA256_IV)[3] | 0;
        this.E = (0, $cUTBr.SHA256_IV)[4] | 0;
        this.F = (0, $cUTBr.SHA256_IV)[5] | 0;
        this.G = (0, $cUTBr.SHA256_IV)[6] | 0;
        this.H = (0, $cUTBr.SHA256_IV)[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$6987167581226d5e$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $6987167581226d5e$var$SHA256_W[i - 15];
            const W2 = $6987167581226d5e$var$SHA256_W[i - 2];
            const s0 = (0, $aX27w.rotr)(W15, 7) ^ (0, $aX27w.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $aX27w.rotr)(W2, 17) ^ (0, $aX27w.rotr)(W2, 19) ^ W2 >>> 10;
            $6987167581226d5e$var$SHA256_W[i] = s1 + $6987167581226d5e$var$SHA256_W[i - 7] + s0 + $6987167581226d5e$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $aX27w.rotr)(E, 6) ^ (0, $aX27w.rotr)(E, 11) ^ (0, $aX27w.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $cUTBr.Chi)(E, F, G) + $6987167581226d5e$var$SHA256_K[i] + $6987167581226d5e$var$SHA256_W[i] | 0;
            const sigma0 = (0, $aX27w.rotr)(A, 2) ^ (0, $aX27w.rotr)(A, 13) ^ (0, $aX27w.rotr)(A, 22);
            const T2 = sigma0 + (0, $cUTBr.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $aX27w.clean)($6987167581226d5e$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $aX27w.clean)(this.buffer);
    }
}
class $6987167581226d5e$export$d90fcf4a65424421 extends $6987167581226d5e$export$397b834fceb5b168 {
    constructor(){
        super(28);
        this.A = (0, $cUTBr.SHA224_IV)[0] | 0;
        this.B = (0, $cUTBr.SHA224_IV)[1] | 0;
        this.C = (0, $cUTBr.SHA224_IV)[2] | 0;
        this.D = (0, $cUTBr.SHA224_IV)[3] | 0;
        this.E = (0, $cUTBr.SHA224_IV)[4] | 0;
        this.F = (0, $cUTBr.SHA224_IV)[5] | 0;
        this.G = (0, $cUTBr.SHA224_IV)[6] | 0;
        this.H = (0, $cUTBr.SHA224_IV)[7] | 0;
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $6987167581226d5e$var$K512 = /* @__PURE__ */ (()=>$eH71W.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $6987167581226d5e$var$SHA512_Kh = /* @__PURE__ */ (()=>$6987167581226d5e$var$K512[0])();
const $6987167581226d5e$var$SHA512_Kl = /* @__PURE__ */ (()=>$6987167581226d5e$var$K512[1])();
// Reusable temporary buffers
const $6987167581226d5e$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $6987167581226d5e$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $6987167581226d5e$export$d655fdb8a1cad5df extends (0, $cUTBr.HashMD) {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = (0, $cUTBr.SHA512_IV)[0] | 0;
        this.Al = (0, $cUTBr.SHA512_IV)[1] | 0;
        this.Bh = (0, $cUTBr.SHA512_IV)[2] | 0;
        this.Bl = (0, $cUTBr.SHA512_IV)[3] | 0;
        this.Ch = (0, $cUTBr.SHA512_IV)[4] | 0;
        this.Cl = (0, $cUTBr.SHA512_IV)[5] | 0;
        this.Dh = (0, $cUTBr.SHA512_IV)[6] | 0;
        this.Dl = (0, $cUTBr.SHA512_IV)[7] | 0;
        this.Eh = (0, $cUTBr.SHA512_IV)[8] | 0;
        this.El = (0, $cUTBr.SHA512_IV)[9] | 0;
        this.Fh = (0, $cUTBr.SHA512_IV)[10] | 0;
        this.Fl = (0, $cUTBr.SHA512_IV)[11] | 0;
        this.Gh = (0, $cUTBr.SHA512_IV)[12] | 0;
        this.Gl = (0, $cUTBr.SHA512_IV)[13] | 0;
        this.Hh = (0, $cUTBr.SHA512_IV)[14] | 0;
        this.Hl = (0, $cUTBr.SHA512_IV)[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $6987167581226d5e$var$SHA512_W_H[i] = view.getUint32(offset);
            $6987167581226d5e$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $6987167581226d5e$var$SHA512_W_H[i - 15] | 0;
            const W15l = $6987167581226d5e$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eH71W.rotrSH(W15h, W15l, 1) ^ $eH71W.rotrSH(W15h, W15l, 8) ^ $eH71W.shrSH(W15h, W15l, 7);
            const s0l = $eH71W.rotrSL(W15h, W15l, 1) ^ $eH71W.rotrSL(W15h, W15l, 8) ^ $eH71W.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $6987167581226d5e$var$SHA512_W_H[i - 2] | 0;
            const W2l = $6987167581226d5e$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eH71W.rotrSH(W2h, W2l, 19) ^ $eH71W.rotrBH(W2h, W2l, 61) ^ $eH71W.shrSH(W2h, W2l, 6);
            const s1l = $eH71W.rotrSL(W2h, W2l, 19) ^ $eH71W.rotrBL(W2h, W2l, 61) ^ $eH71W.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eH71W.add4L(s0l, s1l, $6987167581226d5e$var$SHA512_W_L[i - 7], $6987167581226d5e$var$SHA512_W_L[i - 16]);
            const SUMh = $eH71W.add4H(SUMl, s0h, s1h, $6987167581226d5e$var$SHA512_W_H[i - 7], $6987167581226d5e$var$SHA512_W_H[i - 16]);
            $6987167581226d5e$var$SHA512_W_H[i] = SUMh | 0;
            $6987167581226d5e$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eH71W.rotrSH(Eh, El, 14) ^ $eH71W.rotrSH(Eh, El, 18) ^ $eH71W.rotrBH(Eh, El, 41);
            const sigma1l = $eH71W.rotrSL(Eh, El, 14) ^ $eH71W.rotrSL(Eh, El, 18) ^ $eH71W.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eH71W.add5L(Hl, sigma1l, CHIl, $6987167581226d5e$var$SHA512_Kl[i], $6987167581226d5e$var$SHA512_W_L[i]);
            const T1h = $eH71W.add5H(T1ll, Hh, sigma1h, CHIh, $6987167581226d5e$var$SHA512_Kh[i], $6987167581226d5e$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eH71W.rotrSH(Ah, Al, 28) ^ $eH71W.rotrBH(Ah, Al, 34) ^ $eH71W.rotrBH(Ah, Al, 39);
            const sigma0l = $eH71W.rotrSL(Ah, Al, 28) ^ $eH71W.rotrBL(Ah, Al, 34) ^ $eH71W.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eH71W.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eH71W.add3L(T1l, sigma0l, MAJl);
            Ah = $eH71W.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eH71W.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eH71W.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eH71W.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eH71W.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eH71W.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eH71W.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eH71W.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eH71W.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $aX27w.clean)($6987167581226d5e$var$SHA512_W_H, $6987167581226d5e$var$SHA512_W_L);
    }
    destroy() {
        (0, $aX27w.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $6987167581226d5e$export$b4bd5cd48f62bcf0 extends $6987167581226d5e$export$d655fdb8a1cad5df {
    constructor(){
        super(48);
        this.Ah = (0, $cUTBr.SHA384_IV)[0] | 0;
        this.Al = (0, $cUTBr.SHA384_IV)[1] | 0;
        this.Bh = (0, $cUTBr.SHA384_IV)[2] | 0;
        this.Bl = (0, $cUTBr.SHA384_IV)[3] | 0;
        this.Ch = (0, $cUTBr.SHA384_IV)[4] | 0;
        this.Cl = (0, $cUTBr.SHA384_IV)[5] | 0;
        this.Dh = (0, $cUTBr.SHA384_IV)[6] | 0;
        this.Dl = (0, $cUTBr.SHA384_IV)[7] | 0;
        this.Eh = (0, $cUTBr.SHA384_IV)[8] | 0;
        this.El = (0, $cUTBr.SHA384_IV)[9] | 0;
        this.Fh = (0, $cUTBr.SHA384_IV)[10] | 0;
        this.Fl = (0, $cUTBr.SHA384_IV)[11] | 0;
        this.Gh = (0, $cUTBr.SHA384_IV)[12] | 0;
        this.Gl = (0, $cUTBr.SHA384_IV)[13] | 0;
        this.Hh = (0, $cUTBr.SHA384_IV)[14] | 0;
        this.Hl = (0, $cUTBr.SHA384_IV)[15] | 0;
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $6987167581226d5e$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $6987167581226d5e$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $6987167581226d5e$export$9269e18873efb8a1 extends $6987167581226d5e$export$d655fdb8a1cad5df {
    constructor(){
        super(28);
        this.Ah = $6987167581226d5e$var$T224_IV[0] | 0;
        this.Al = $6987167581226d5e$var$T224_IV[1] | 0;
        this.Bh = $6987167581226d5e$var$T224_IV[2] | 0;
        this.Bl = $6987167581226d5e$var$T224_IV[3] | 0;
        this.Ch = $6987167581226d5e$var$T224_IV[4] | 0;
        this.Cl = $6987167581226d5e$var$T224_IV[5] | 0;
        this.Dh = $6987167581226d5e$var$T224_IV[6] | 0;
        this.Dl = $6987167581226d5e$var$T224_IV[7] | 0;
        this.Eh = $6987167581226d5e$var$T224_IV[8] | 0;
        this.El = $6987167581226d5e$var$T224_IV[9] | 0;
        this.Fh = $6987167581226d5e$var$T224_IV[10] | 0;
        this.Fl = $6987167581226d5e$var$T224_IV[11] | 0;
        this.Gh = $6987167581226d5e$var$T224_IV[12] | 0;
        this.Gl = $6987167581226d5e$var$T224_IV[13] | 0;
        this.Hh = $6987167581226d5e$var$T224_IV[14] | 0;
        this.Hl = $6987167581226d5e$var$T224_IV[15] | 0;
    }
}
class $6987167581226d5e$export$70b84015054354f1 extends $6987167581226d5e$export$d655fdb8a1cad5df {
    constructor(){
        super(32);
        this.Ah = $6987167581226d5e$var$T256_IV[0] | 0;
        this.Al = $6987167581226d5e$var$T256_IV[1] | 0;
        this.Bh = $6987167581226d5e$var$T256_IV[2] | 0;
        this.Bl = $6987167581226d5e$var$T256_IV[3] | 0;
        this.Ch = $6987167581226d5e$var$T256_IV[4] | 0;
        this.Cl = $6987167581226d5e$var$T256_IV[5] | 0;
        this.Dh = $6987167581226d5e$var$T256_IV[6] | 0;
        this.Dl = $6987167581226d5e$var$T256_IV[7] | 0;
        this.Eh = $6987167581226d5e$var$T256_IV[8] | 0;
        this.El = $6987167581226d5e$var$T256_IV[9] | 0;
        this.Fh = $6987167581226d5e$var$T256_IV[10] | 0;
        this.Fl = $6987167581226d5e$var$T256_IV[11] | 0;
        this.Gh = $6987167581226d5e$var$T256_IV[12] | 0;
        this.Gl = $6987167581226d5e$var$T256_IV[13] | 0;
        this.Hh = $6987167581226d5e$var$T256_IV[14] | 0;
        this.Hl = $6987167581226d5e$var$T256_IV[15] | 0;
    }
}
const $6987167581226d5e$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$397b834fceb5b168());
const $6987167581226d5e$export$97b70509d4e397ea = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$d90fcf4a65424421());
const $6987167581226d5e$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$d655fdb8a1cad5df());
const $6987167581226d5e$export$612d47d55dedde45 = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$b4bd5cd48f62bcf0());
const $6987167581226d5e$export$c78786b6da86db2a = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$70b84015054354f1());
const $6987167581226d5e$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $aX27w.createHasher)(()=>new $6987167581226d5e$export$9269e18873efb8a1());

});
parcelRegister("cUTBr", function(module, exports) {

$parcel$export(module.exports, "Chi", () => $9675d8967fc4e416$export$d0d97f016526eaf0);
$parcel$export(module.exports, "Maj", () => $9675d8967fc4e416$export$8b1d810b1bd30adf);
$parcel$export(module.exports, "HashMD", () => $9675d8967fc4e416$export$f9f830659f932cb2);
$parcel$export(module.exports, "SHA256_IV", () => $9675d8967fc4e416$export$a986fdf7a5bdfdf8);
$parcel$export(module.exports, "SHA224_IV", () => $9675d8967fc4e416$export$104dc246f4c65f21);
$parcel$export(module.exports, "SHA384_IV", () => $9675d8967fc4e416$export$b5217b4b948279ee);
$parcel$export(module.exports, "SHA512_IV", () => $9675d8967fc4e416$export$f2cbb88a1784d2d1);
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ 
var $aX27w = parcelRequire("aX27w");
function $9675d8967fc4e416$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $9675d8967fc4e416$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $9675d8967fc4e416$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $9675d8967fc4e416$export$f9f830659f932cb2 extends (0, $aX27w.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $aX27w.createView)(this.buffer);
    }
    update(data) {
        (0, $aX27w.aexists)(this);
        data = (0, $aX27w.toBytes)(data);
        (0, $aX27w.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $aX27w.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $aX27w.aexists)(this);
        (0, $aX27w.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $aX27w.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $9675d8967fc4e416$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $aX27w.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $9675d8967fc4e416$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $9675d8967fc4e416$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $9675d8967fc4e416$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $9675d8967fc4e416$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});
parcelRegister("aX27w", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $7f910f1ea7070e43$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "anumber", () => $7f910f1ea7070e43$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $7f910f1ea7070e43$export$e8a750b9efad93f5);
$parcel$export(module.exports, "ahash", () => $7f910f1ea7070e43$export$3ff5a4f04de7e52e);
$parcel$export(module.exports, "aexists", () => $7f910f1ea7070e43$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $7f910f1ea7070e43$export$e8e53abee12b995e);
$parcel$export(module.exports, "u32", () => $7f910f1ea7070e43$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "clean", () => $7f910f1ea7070e43$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "createView", () => $7f910f1ea7070e43$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $7f910f1ea7070e43$export$466993d7d0d272aa);
$parcel$export(module.exports, "swap32IfBE", () => $7f910f1ea7070e43$export$f3e5ccb1e5f96d20);
$parcel$export(module.exports, "bytesToHex", () => $7f910f1ea7070e43$export$58b867e287a802c8);
$parcel$export(module.exports, "hexToBytes", () => $7f910f1ea7070e43$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "utf8ToBytes", () => $7f910f1ea7070e43$export$3df70a15530b5e81);
$parcel$export(module.exports, "toBytes", () => $7f910f1ea7070e43$export$30a71edf0753ed6b);
$parcel$export(module.exports, "concatBytes", () => $7f910f1ea7070e43$export$287dd7971339c972);
$parcel$export(module.exports, "Hash", () => $7f910f1ea7070e43$export$ab85ecd77ce6a5cd);
$parcel$export(module.exports, "createHasher", () => $7f910f1ea7070e43$export$14b114effbc08b6b);
$parcel$export(module.exports, "createXOFer", () => $7f910f1ea7070e43$export$741ac6dc04ed5295);
$parcel$export(module.exports, "randomBytes", () => $7f910f1ea7070e43$export$5f828d93ff035aa8);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $4aUcu = parcelRequire("4aUcu");
function $7f910f1ea7070e43$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $7f910f1ea7070e43$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $7f910f1ea7070e43$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$7f910f1ea7070e43$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $7f910f1ea7070e43$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $7f910f1ea7070e43$export$75364c6cb16d43b6(h.outputLen);
    $7f910f1ea7070e43$export$75364c6cb16d43b6(h.blockLen);
}
function $7f910f1ea7070e43$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $7f910f1ea7070e43$export$e8e53abee12b995e(out, instance) {
    $7f910f1ea7070e43$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $7f910f1ea7070e43$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $7f910f1ea7070e43$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $7f910f1ea7070e43$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $7f910f1ea7070e43$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $7f910f1ea7070e43$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $7f910f1ea7070e43$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $7f910f1ea7070e43$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $7f910f1ea7070e43$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $7f910f1ea7070e43$export$e108944b32ae0e38 = $7f910f1ea7070e43$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$7f910f1ea7070e43$export$a4170f7f8be47425(n);
const $7f910f1ea7070e43$export$4a0a88cc2d284e7f = $7f910f1ea7070e43$export$e108944b32ae0e38;
function $7f910f1ea7070e43$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $7f910f1ea7070e43$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $7f910f1ea7070e43$export$f3e5ccb1e5f96d20 = $7f910f1ea7070e43$export$a0f88e38d4cf9577 ? (u)=>u : $7f910f1ea7070e43$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $7f910f1ea7070e43$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $7f910f1ea7070e43$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $7f910f1ea7070e43$export$58b867e287a802c8(bytes) {
    $7f910f1ea7070e43$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($7f910f1ea7070e43$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $7f910f1ea7070e43$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $7f910f1ea7070e43$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $7f910f1ea7070e43$var$asciiToBase16(ch) {
    if (ch >= $7f910f1ea7070e43$var$asciis._0 && ch <= $7f910f1ea7070e43$var$asciis._9) return ch - $7f910f1ea7070e43$var$asciis._0; // '2' => 50-48
    if (ch >= $7f910f1ea7070e43$var$asciis.A && ch <= $7f910f1ea7070e43$var$asciis.F) return ch - ($7f910f1ea7070e43$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $7f910f1ea7070e43$var$asciis.a && ch <= $7f910f1ea7070e43$var$asciis.f) return ch - ($7f910f1ea7070e43$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $7f910f1ea7070e43$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($7f910f1ea7070e43$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $7f910f1ea7070e43$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $7f910f1ea7070e43$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $7f910f1ea7070e43$export$bdd553fddd433dcb = async ()=>{};
async function $7f910f1ea7070e43$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $7f910f1ea7070e43$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $7f910f1ea7070e43$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $7f910f1ea7070e43$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $7f910f1ea7070e43$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $7f910f1ea7070e43$export$3df70a15530b5e81(data);
    $7f910f1ea7070e43$export$e8a750b9efad93f5(data);
    return data;
}
function $7f910f1ea7070e43$export$e01ba4a527b8942d(data) {
    if (typeof data === 'string') data = $7f910f1ea7070e43$export$3df70a15530b5e81(data);
    $7f910f1ea7070e43$export$e8a750b9efad93f5(data);
    return data;
}
function $7f910f1ea7070e43$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $7f910f1ea7070e43$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $7f910f1ea7070e43$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
class $7f910f1ea7070e43$export$ab85ecd77ce6a5cd {
}
function $7f910f1ea7070e43$export$14b114effbc08b6b(hashCons) {
    const hashC = (msg)=>hashCons().update($7f910f1ea7070e43$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $7f910f1ea7070e43$export$aaa6b3684f701ca2(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($7f910f1ea7070e43$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $7f910f1ea7070e43$export$741ac6dc04ed5295(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($7f910f1ea7070e43$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
const $7f910f1ea7070e43$export$f081816339df1972 = $7f910f1ea7070e43$export$14b114effbc08b6b;
const $7f910f1ea7070e43$export$b465638d1569a3ae = $7f910f1ea7070e43$export$aaa6b3684f701ca2;
const $7f910f1ea7070e43$export$e18964dbd6e083c1 = $7f910f1ea7070e43$export$741ac6dc04ed5295;
function $7f910f1ea7070e43$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $4aUcu.crypto) && typeof (0, $4aUcu.crypto).getRandomValues === 'function') return (0, $4aUcu.crypto).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $4aUcu.crypto) && typeof (0, $4aUcu.crypto).randomBytes === 'function') return Uint8Array.from((0, $4aUcu.crypto).randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

});
parcelRegister("4aUcu", function(module, exports) {

$parcel$export(module.exports, "crypto", () => $30a3b0dac6c36090$export$7effb53edfc7fa2d);
const $30a3b0dac6c36090$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("eH71W", function(module, exports) {

$parcel$export(module.exports, "split", () => $ab2a88e931a1466b$export$65980d18b75784e2);
$parcel$export(module.exports, "shrSH", () => $ab2a88e931a1466b$export$75aa78dc5bd52853);
$parcel$export(module.exports, "shrSL", () => $ab2a88e931a1466b$export$a0225ff0aee14e25);
$parcel$export(module.exports, "rotrSH", () => $ab2a88e931a1466b$export$97f812dfd830ca87);
$parcel$export(module.exports, "rotrSL", () => $ab2a88e931a1466b$export$60987e30e2c9d9d);
$parcel$export(module.exports, "rotrBH", () => $ab2a88e931a1466b$export$af9c7fbac44dcb76);
$parcel$export(module.exports, "rotrBL", () => $ab2a88e931a1466b$export$f619171d6d5ac414);
$parcel$export(module.exports, "rotlSH", () => $ab2a88e931a1466b$export$4b80a2917447870e);
$parcel$export(module.exports, "rotlSL", () => $ab2a88e931a1466b$export$20652918a7b63b3);
$parcel$export(module.exports, "rotlBH", () => $ab2a88e931a1466b$export$a52f14bf902f9977);
$parcel$export(module.exports, "rotlBL", () => $ab2a88e931a1466b$export$5d12cc1da441323f);
$parcel$export(module.exports, "add", () => $ab2a88e931a1466b$export$e16d8520af44a096);
$parcel$export(module.exports, "add3L", () => $ab2a88e931a1466b$export$c0c22b91f08911f);
$parcel$export(module.exports, "add3H", () => $ab2a88e931a1466b$export$ef7b26044977a8ec);
$parcel$export(module.exports, "add4L", () => $ab2a88e931a1466b$export$2f4e199c560f545d);
$parcel$export(module.exports, "add4H", () => $ab2a88e931a1466b$export$e909220d675a7741);
$parcel$export(module.exports, "add5L", () => $ab2a88e931a1466b$export$d732b061fe9c9ae4);
$parcel$export(module.exports, "add5H", () => $ab2a88e931a1466b$export$b45ee8d78c965098);
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $ab2a88e931a1466b$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $ab2a88e931a1466b$var$_32n = /* @__PURE__ */ BigInt(32);
function $ab2a88e931a1466b$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $ab2a88e931a1466b$var$U32_MASK64),
        l: Number(n >> $ab2a88e931a1466b$var$_32n & $ab2a88e931a1466b$var$U32_MASK64)
    };
    return {
        h: Number(n >> $ab2a88e931a1466b$var$_32n & $ab2a88e931a1466b$var$U32_MASK64) | 0,
        l: Number(n & $ab2a88e931a1466b$var$U32_MASK64) | 0
    };
}
function $ab2a88e931a1466b$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $ab2a88e931a1466b$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $ab2a88e931a1466b$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $ab2a88e931a1466b$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $ab2a88e931a1466b$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $ab2a88e931a1466b$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $ab2a88e931a1466b$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $ab2a88e931a1466b$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ab2a88e931a1466b$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $ab2a88e931a1466b$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $ab2a88e931a1466b$export$a088d44bd387d2a3 = (_h, l)=>l;
const $ab2a88e931a1466b$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $ab2a88e931a1466b$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $ab2a88e931a1466b$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ab2a88e931a1466b$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $ab2a88e931a1466b$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $ab2a88e931a1466b$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $ab2a88e931a1466b$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $ab2a88e931a1466b$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $ab2a88e931a1466b$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $ab2a88e931a1466b$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $ab2a88e931a1466b$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $ab2a88e931a1466b$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $ab2a88e931a1466b$var$u64 = {
    fromBig: $ab2a88e931a1466b$export$9625d4333cb56c3f,
    split: $ab2a88e931a1466b$export$65980d18b75784e2,
    toBig: $ab2a88e931a1466b$export$30f78adcaaa2eb7,
    shrSH: $ab2a88e931a1466b$export$75aa78dc5bd52853,
    shrSL: $ab2a88e931a1466b$export$a0225ff0aee14e25,
    rotrSH: $ab2a88e931a1466b$export$97f812dfd830ca87,
    rotrSL: $ab2a88e931a1466b$export$60987e30e2c9d9d,
    rotrBH: $ab2a88e931a1466b$export$af9c7fbac44dcb76,
    rotrBL: $ab2a88e931a1466b$export$f619171d6d5ac414,
    rotr32H: $ab2a88e931a1466b$export$a088d44bd387d2a3,
    rotr32L: $ab2a88e931a1466b$export$8415aae4d1f69577,
    rotlSH: $ab2a88e931a1466b$export$4b80a2917447870e,
    rotlSL: $ab2a88e931a1466b$export$20652918a7b63b3,
    rotlBH: $ab2a88e931a1466b$export$a52f14bf902f9977,
    rotlBL: $ab2a88e931a1466b$export$5d12cc1da441323f,
    add: $ab2a88e931a1466b$export$e16d8520af44a096,
    add3L: $ab2a88e931a1466b$export$c0c22b91f08911f,
    add3H: $ab2a88e931a1466b$export$ef7b26044977a8ec,
    add4L: $ab2a88e931a1466b$export$2f4e199c560f545d,
    add4H: $ab2a88e931a1466b$export$e909220d675a7741,
    add5H: $ab2a88e931a1466b$export$b45ee8d78c965098,
    add5L: $ab2a88e931a1466b$export$d732b061fe9c9ae4
};
var $ab2a88e931a1466b$export$2e2bcd8739ae039 = $ab2a88e931a1466b$var$u64;

});


parcelRegister("gaxAZ", function(module, exports) {

$parcel$export(module.exports, "negateCt", () => $bc57a3e355a13f4b$export$c6bd445aafe431ea);
$parcel$export(module.exports, "normalizeZ", () => $bc57a3e355a13f4b$export$bc27bc65d7bff1c7);
$parcel$export(module.exports, "wNAF", () => $bc57a3e355a13f4b$export$1c8afd86ce547420);
$parcel$export(module.exports, "mulEndoUnsafe", () => $bc57a3e355a13f4b$export$4e37e5581461a31);
$parcel$export(module.exports, "pippenger", () => $bc57a3e355a13f4b$export$8e2f6717424463a3);
$parcel$export(module.exports, "_createCurveFields", () => $bc57a3e355a13f4b$export$a26f87e9b807e0c6);
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $3TGEu = parcelRequire("3TGEu");

var $f8jNy = parcelRequire("f8jNy");
const $bc57a3e355a13f4b$var$_0n = BigInt(0);
const $bc57a3e355a13f4b$var$_1n = BigInt(1);
function $bc57a3e355a13f4b$export$c6bd445aafe431ea(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function $bc57a3e355a13f4b$export$bc27bc65d7bff1c7(c, points) {
    const invertedZs = (0, $f8jNy.FpInvertBatch)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $bc57a3e355a13f4b$var$validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function $bc57a3e355a13f4b$var$calcWOpts(W, scalarBits) {
    $bc57a3e355a13f4b$var$validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $3TGEu.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function $bc57a3e355a13f4b$var$calcOffsets(n, window, wOpts) {
    const { windowSize: windowSize, mask: mask, maxNumber: maxNumber, shiftBy: shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += $bc57a3e355a13f4b$var$_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function $bc57a3e355a13f4b$var$validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function $bc57a3e355a13f4b$var$validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const $bc57a3e355a13f4b$var$pointPrecomputes = new WeakMap();
const $bc57a3e355a13f4b$var$pointWindowSizes = new WeakMap();
function $bc57a3e355a13f4b$var$getW(P) {
    // To disable precomputes:
    // return 1;
    return $bc57a3e355a13f4b$var$pointWindowSizes.get(P) || 1;
}
function $bc57a3e355a13f4b$var$assert0(n) {
    if (n !== $bc57a3e355a13f4b$var$_0n) throw new Error('invalid wNAF');
}
class $bc57a3e355a13f4b$export$1c8afd86ce547420 {
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits){
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while(n > $bc57a3e355a13f4b$var$_0n){
            if (n & $bc57a3e355a13f4b$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $bc57a3e355a13f4b$var$_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow(point, W) {
        const { windows: windows, windowSize: windowSize } = $bc57a3e355a13f4b$var$calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for(let i = 1; i < windowSize; i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */ wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n)) throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = $bc57a3e355a13f4b$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg, isNegF: isNegF, offsetF: offsetF } = $bc57a3e355a13f4b$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) // bits are 0: add garbage to fake point
            // Important part for const-time getPublicKey: add random "noise" point to f.
            f = f.add($bc57a3e355a13f4b$export$c6bd445aafe431ea(isNegF, precomputes[offsetF]));
            else // bits are 1: add to result point
            p = p.add($bc57a3e355a13f4b$export$c6bd445aafe431ea(isNeg, precomputes[offset]));
        }
        $bc57a3e355a13f4b$var$assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return {
            p: p,
            f: f
        };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */ wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = $bc57a3e355a13f4b$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            if (n === $bc57a3e355a13f4b$var$_0n) break; // Early-exit, skip 0 value
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg } = $bc57a3e355a13f4b$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) continue;
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        $bc57a3e355a13f4b$var$assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = $bc57a3e355a13f4b$var$pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function') comp = transform(comp);
                $bc57a3e355a13f4b$var$pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = $bc57a3e355a13f4b$var$getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = $bc57a3e355a13f4b$var$getW(point);
        if (W === 1) return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        $bc57a3e355a13f4b$var$validateW(W, this.bits);
        $bc57a3e355a13f4b$var$pointWindowSizes.set(P, W);
        $bc57a3e355a13f4b$var$pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return $bc57a3e355a13f4b$var$getW(elm) !== 1;
    }
}
function $bc57a3e355a13f4b$export$4e37e5581461a31(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while(k1 > $bc57a3e355a13f4b$var$_0n || k2 > $bc57a3e355a13f4b$var$_0n){
        if (k1 & $bc57a3e355a13f4b$var$_1n) p1 = p1.add(acc);
        if (k2 & $bc57a3e355a13f4b$var$_1n) p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= $bc57a3e355a13f4b$var$_1n;
        k2 >>= $bc57a3e355a13f4b$var$_1n;
    }
    return {
        p1: p1,
        p2: p2
    };
}
function $bc57a3e355a13f4b$export$8e2f6717424463a3(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    $bc57a3e355a13f4b$var$validateMSMPoints(points, c);
    $bc57a3e355a13f4b$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $3TGEu.bitLen)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $3TGEu.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function $bc57a3e355a13f4b$export$c33f75a98e3bde1d(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ $bc57a3e355a13f4b$var$validateW(windowSize, fieldN.BITS);
    $bc57a3e355a13f4b$var$validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $3TGEu.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        $bc57a3e355a13f4b$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function $bc57a3e355a13f4b$export$8ffa17c2a9bceb5e(curve) {
    (0, $f8jNy.validateField)(curve.Fp);
    (0, $3TGEu.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $f8jNy.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
function $bc57a3e355a13f4b$var$createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $f8jNy.validateField)(field);
        return field;
    } else return (0, $f8jNy.Field)(order, {
        isLE: isLE
    });
}
function $bc57a3e355a13f4b$export$a26f87e9b807e0c6(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > $bc57a3e355a13f4b$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $bc57a3e355a13f4b$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $bc57a3e355a13f4b$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}

});
parcelRegister("3TGEu", function(module, exports) {

$parcel$export(module.exports, "_abool2", () => $2d6797fcf1c5a5cb$export$dcc04a11b0f94c2a);
$parcel$export(module.exports, "_abytes2", () => $2d6797fcf1c5a5cb$export$8b73a320627a4b4b);
$parcel$export(module.exports, "numberToHexUnpadded", () => $2d6797fcf1c5a5cb$export$4ed2545b622827c1);
$parcel$export(module.exports, "bytesToNumberBE", () => $2d6797fcf1c5a5cb$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $2d6797fcf1c5a5cb$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $2d6797fcf1c5a5cb$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $2d6797fcf1c5a5cb$export$ba2172e58d139f6d);
$parcel$export(module.exports, "ensureBytes", () => $2d6797fcf1c5a5cb$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "equalBytes", () => $2d6797fcf1c5a5cb$export$2aa59cef064b0333);
$parcel$export(module.exports, "copyBytes", () => $2d6797fcf1c5a5cb$export$56728fb2d7dba34e);
$parcel$export(module.exports, "inRange", () => $2d6797fcf1c5a5cb$export$ddf89a9c5af38f94);
$parcel$export(module.exports, "aInRange", () => $2d6797fcf1c5a5cb$export$86cc12b5dde3c1e4);
$parcel$export(module.exports, "bitLen", () => $2d6797fcf1c5a5cb$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitMask", () => $2d6797fcf1c5a5cb$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $2d6797fcf1c5a5cb$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $2d6797fcf1c5a5cb$export$381bae2d0f08004f);
$parcel$export(module.exports, "isHash", () => $2d6797fcf1c5a5cb$export$e8eff8fe65a171f3);
$parcel$export(module.exports, "_validateObject", () => $2d6797fcf1c5a5cb$export$1b8d274177e893f0);
$parcel$export(module.exports, "notImplemented", () => $2d6797fcf1c5a5cb$export$94a5f06e658f87e2);
$parcel$export(module.exports, "memoized", () => $2d6797fcf1c5a5cb$export$9756366f7cb6f62b);
$parcel$export(module.exports, "abytes", () => (parcelRequire("aX27w")).abytes);
$parcel$export(module.exports, "bytesToHex", () => (parcelRequire("aX27w")).bytesToHex);
$parcel$export(module.exports, "concatBytes", () => (parcelRequire("aX27w")).concatBytes);
$parcel$export(module.exports, "hexToBytes", () => (parcelRequire("aX27w")).hexToBytes);
$parcel$export(module.exports, "isBytes", () => (parcelRequire("aX27w")).isBytes);
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $aX27w = parcelRequire("aX27w");
const $2d6797fcf1c5a5cb$var$_0n = /* @__PURE__ */ BigInt(0);
const $2d6797fcf1c5a5cb$var$_1n = /* @__PURE__ */ BigInt(1);
function $2d6797fcf1c5a5cb$export$809304d28d77d92d(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
function $2d6797fcf1c5a5cb$export$dcc04a11b0f94c2a(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}"`;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
function $2d6797fcf1c5a5cb$export$8b73a320627a4b4b(value, length, title = '') {
    const bytes = (0, $aX27w.isBytes)(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
function $2d6797fcf1c5a5cb$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $2d6797fcf1c5a5cb$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $2d6797fcf1c5a5cb$var$_0n : BigInt('0x' + hex); // Big Endian
}
function $2d6797fcf1c5a5cb$export$d609354794974f8(bytes) {
    return $2d6797fcf1c5a5cb$export$d57f2bacc26b4249((0, $aX27w.bytesToHex)(bytes));
}
function $2d6797fcf1c5a5cb$export$d67b1d03392107e7(bytes) {
    (0, $aX27w.abytes)(bytes);
    return $2d6797fcf1c5a5cb$export$d57f2bacc26b4249((0, $aX27w.bytesToHex)(Uint8Array.from(bytes).reverse()));
}
function $2d6797fcf1c5a5cb$export$1459dafd057611cb(n, len) {
    return (0, $aX27w.hexToBytes)(n.toString(16).padStart(len * 2, '0'));
}
function $2d6797fcf1c5a5cb$export$ba2172e58d139f6d(n, len) {
    return $2d6797fcf1c5a5cb$export$1459dafd057611cb(n, len).reverse();
}
function $2d6797fcf1c5a5cb$export$80ee8c1914de6dde(n) {
    return (0, $aX27w.hexToBytes)($2d6797fcf1c5a5cb$export$4ed2545b622827c1(n));
}
function $2d6797fcf1c5a5cb$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = (0, $aX27w.hexToBytes)(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ((0, $aX27w.isBytes)(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
function $2d6797fcf1c5a5cb$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $2d6797fcf1c5a5cb$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}
function $2d6797fcf1c5a5cb$export$e151636497a65339(ascii) {
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ // export const utf8ToBytes: typeof utf8ToBytes_ = utf8ToBytes_;
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ // export const bytesToUtf8: typeof bytesToUtf8_ = bytesToUtf8_;
// Is positive bigint
const $2d6797fcf1c5a5cb$var$isPosBig = (n)=>typeof n === 'bigint' && $2d6797fcf1c5a5cb$var$_0n <= n;
function $2d6797fcf1c5a5cb$export$ddf89a9c5af38f94(n, min, max) {
    return $2d6797fcf1c5a5cb$var$isPosBig(n) && $2d6797fcf1c5a5cb$var$isPosBig(min) && $2d6797fcf1c5a5cb$var$isPosBig(max) && min <= n && n < max;
}
function $2d6797fcf1c5a5cb$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$2d6797fcf1c5a5cb$export$ddf89a9c5af38f94(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
function $2d6797fcf1c5a5cb$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $2d6797fcf1c5a5cb$var$_0n; n >>= $2d6797fcf1c5a5cb$var$_1n, len += 1);
    return len;
}
function $2d6797fcf1c5a5cb$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $2d6797fcf1c5a5cb$var$_1n;
}
function $2d6797fcf1c5a5cb$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $2d6797fcf1c5a5cb$var$_1n : $2d6797fcf1c5a5cb$var$_0n) << BigInt(pos);
}
const $2d6797fcf1c5a5cb$export$803efa2fa1c7279 = (n)=>($2d6797fcf1c5a5cb$var$_1n << BigInt(n)) - $2d6797fcf1c5a5cb$var$_1n;
function $2d6797fcf1c5a5cb$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
    const u8of = (byte)=>Uint8Array.of(byte); // another shortcut
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8of(0x00), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8of(0x01), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return (0, $aX27w.concatBytes)(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $2d6797fcf1c5a5cb$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || (0, $aX27w.isBytes)(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
function $2d6797fcf1c5a5cb$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $2d6797fcf1c5a5cb$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
function $2d6797fcf1c5a5cb$export$e8eff8fe65a171f3(val) {
    return typeof val === 'function' && Number.isSafeInteger(val.outputLen);
}
function $2d6797fcf1c5a5cb$export$1b8d274177e893f0(object, fields, optFields = {}) {
    if (!object || typeof object !== 'object') throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    Object.entries(fields).forEach(([k, v])=>checkField(k, v, false));
    Object.entries(optFields).forEach(([k, v])=>checkField(k, v, true));
}
const $2d6797fcf1c5a5cb$export$94a5f06e658f87e2 = ()=>{
    throw new Error('not implemented');
};
function $2d6797fcf1c5a5cb$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});

parcelRegister("f8jNy", function(module, exports) {

$parcel$export(module.exports, "mod", () => $b046f5de9391306a$export$842a2cf37af977e1);
$parcel$export(module.exports, "Field", () => $b046f5de9391306a$export$a455218a85c89869);
$parcel$export(module.exports, "pow2", () => $b046f5de9391306a$export$fa569bd808b67eef);
$parcel$export(module.exports, "isNegativeLE", () => $b046f5de9391306a$export$7806f13ad5078b2f);
$parcel$export(module.exports, "validateField", () => $b046f5de9391306a$export$bd454f0cef11418d);
$parcel$export(module.exports, "FpInvertBatch", () => $b046f5de9391306a$export$a492e3387142c0e9);
$parcel$export(module.exports, "nLength", () => $b046f5de9391306a$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "FpSqrtEven", () => $b046f5de9391306a$export$1d7b691df0888e02);
$parcel$export(module.exports, "getMinHashLength", () => $b046f5de9391306a$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $b046f5de9391306a$export$20cb21dbfa61dac3);
/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
// prettier-ignore
const $b046f5de9391306a$var$_0n = BigInt(0), $b046f5de9391306a$var$_1n = BigInt(1), $b046f5de9391306a$var$_2n = /* @__PURE__ */ BigInt(2), $b046f5de9391306a$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $b046f5de9391306a$var$_4n = /* @__PURE__ */ BigInt(4), $b046f5de9391306a$var$_5n = /* @__PURE__ */ BigInt(5), $b046f5de9391306a$var$_7n = /* @__PURE__ */ BigInt(7);
// prettier-ignore
const $b046f5de9391306a$var$_8n = /* @__PURE__ */ BigInt(8), $b046f5de9391306a$var$_9n = /* @__PURE__ */ BigInt(9), $b046f5de9391306a$var$_16n = /* @__PURE__ */ BigInt(16);
function $b046f5de9391306a$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $b046f5de9391306a$var$_0n ? result : b + result;
}
function $b046f5de9391306a$export$9c297f60e22e3389(num, power, modulo) {
    return $b046f5de9391306a$export$5d8ce3717733a987($b046f5de9391306a$export$a455218a85c89869(modulo), num, power);
}
function $b046f5de9391306a$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $b046f5de9391306a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $b046f5de9391306a$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $b046f5de9391306a$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $b046f5de9391306a$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $b046f5de9391306a$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $b046f5de9391306a$var$_0n, y = $b046f5de9391306a$var$_1n, u = $b046f5de9391306a$var$_1n, v = $b046f5de9391306a$var$_0n;
    while(a !== $b046f5de9391306a$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $b046f5de9391306a$var$_1n) throw new Error('invert: does not exist');
    return $b046f5de9391306a$export$842a2cf37af977e1(x, modulo);
}
function $b046f5de9391306a$var$assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $b046f5de9391306a$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $b046f5de9391306a$var$_1n) / $b046f5de9391306a$var$_4n;
    const root = Fp.pow(n, p1div4);
    $b046f5de9391306a$var$assertIsSquare(Fp, root, n);
    return root;
}
function $b046f5de9391306a$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $b046f5de9391306a$var$_5n) / $b046f5de9391306a$var$_8n;
    const n2 = Fp.mul(n, $b046f5de9391306a$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $b046f5de9391306a$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    $b046f5de9391306a$var$assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $b046f5de9391306a$var$sqrt9mod16(P) {
    const Fp_ = $b046f5de9391306a$export$a455218a85c89869(P);
    const tn = $b046f5de9391306a$export$69f29ab1f3e9a234(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $b046f5de9391306a$var$_7n) / $b046f5de9391306a$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $b046f5de9391306a$var$assertIsSquare(Fp, root, n);
        return root;
    };
}
function $b046f5de9391306a$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $b046f5de9391306a$var$_3n) throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $b046f5de9391306a$var$_1n;
    let S = 0;
    while(Q % $b046f5de9391306a$var$_2n === $b046f5de9391306a$var$_0n){
        Q /= $b046f5de9391306a$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $b046f5de9391306a$var$_2n;
    const _Fp = $b046f5de9391306a$export$a455218a85c89869(P);
    while($b046f5de9391306a$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $b046f5de9391306a$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $b046f5de9391306a$var$_1n) / $b046f5de9391306a$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($b046f5de9391306a$export$77ed22730026dd0d(Fp, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $b046f5de9391306a$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $b046f5de9391306a$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $b046f5de9391306a$var$_4n === $b046f5de9391306a$var$_3n) return $b046f5de9391306a$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $b046f5de9391306a$var$_8n === $b046f5de9391306a$var$_5n) return $b046f5de9391306a$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $b046f5de9391306a$var$_16n === $b046f5de9391306a$var$_9n) return $b046f5de9391306a$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $b046f5de9391306a$export$69f29ab1f3e9a234(P);
}
const $b046f5de9391306a$export$7806f13ad5078b2f = (num, modulo)=>($b046f5de9391306a$export$842a2cf37af977e1(num, modulo) & $b046f5de9391306a$var$_1n) === $b046f5de9391306a$var$_1n;
// prettier-ignore
const $b046f5de9391306a$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $b046f5de9391306a$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'number',
        BITS: 'number'
    };
    const opts = $b046f5de9391306a$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    (0, $3TGEu._validateObject)(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
function $b046f5de9391306a$export$5d8ce3717733a987(Fp, num, power) {
    if (power < $b046f5de9391306a$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $b046f5de9391306a$var$_0n) return Fp.ONE;
    if (power === $b046f5de9391306a$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $b046f5de9391306a$var$_0n){
        if (power & $b046f5de9391306a$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $b046f5de9391306a$var$_1n;
    }
    return p;
}
function $b046f5de9391306a$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $b046f5de9391306a$export$e74c665040343df6(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? $b046f5de9391306a$export$6897c284b6f9f4dc(rhs, Fp.ORDER) : Fp.inv(rhs));
}
function $b046f5de9391306a$export$77ed22730026dd0d(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $b046f5de9391306a$var$_1n) / $b046f5de9391306a$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
function $b046f5de9391306a$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $b046f5de9391306a$export$77ed22730026dd0d(Fp, n);
    return l === 1;
}
function $b046f5de9391306a$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $aX27w.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $b046f5de9391306a$export$a455218a85c89869(ORDER, bitLenOrOpts, isLE = false, opts = {}) {
    if (ORDER <= $b046f5de9391306a$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    let _nbitLength = undefined;
    let _sqrt = undefined;
    let modFromBytes = false;
    let allowedLengths = undefined;
    if (typeof bitLenOrOpts === 'object' && bitLenOrOpts != null) {
        if (opts.sqrt || isLE) throw new Error('cannot specify opts in two arguments');
        const _opts = bitLenOrOpts;
        if (_opts.BITS) _nbitLength = _opts.BITS;
        if (_opts.sqrt) _sqrt = _opts.sqrt;
        if (typeof _opts.isLE === 'boolean') isLE = _opts.isLE;
        if (typeof _opts.modFromBytes === 'boolean') modFromBytes = _opts.modFromBytes;
        allowedLengths = _opts.allowedLengths;
    } else {
        if (typeof bitLenOrOpts === 'number') _nbitLength = bitLenOrOpts;
        if (opts.sqrt) _sqrt = opts.sqrt;
    }
    const { nBitLength: BITS, nByteLength: BYTES } = $b046f5de9391306a$export$c79df43ecd7e66c2(ORDER, _nbitLength);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $3TGEu.bitMask)(BITS),
        ZERO: $b046f5de9391306a$var$_0n,
        ONE: $b046f5de9391306a$var$_1n,
        allowedLengths: allowedLengths,
        create: (num)=>$b046f5de9391306a$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $b046f5de9391306a$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $b046f5de9391306a$var$_0n,
        // is valid and invertible
        isValidNot0: (num)=>!f.is0(num) && f.isValid(num),
        isOdd: (num)=>(num & $b046f5de9391306a$var$_1n) === $b046f5de9391306a$var$_1n,
        neg: (num)=>$b046f5de9391306a$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$b046f5de9391306a$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$b046f5de9391306a$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$b046f5de9391306a$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$b046f5de9391306a$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$b046f5de9391306a$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$b046f5de9391306a$export$842a2cf37af977e1(lhs * $b046f5de9391306a$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$b046f5de9391306a$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: _sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $b046f5de9391306a$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, $3TGEu.numberToBytesLE)(num, BYTES) : (0, $3TGEu.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes, skipValidation = true)=>{
            if (allowedLengths) {
                if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
                const padded = new Uint8Array(BYTES);
                // isLE add 0 to right, !isLE to the left.
                padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
                bytes = padded;
            }
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            let scalar = isLE ? (0, $3TGEu.bytesToNumberLE)(bytes) : (0, $3TGEu.bytesToNumberBE)(bytes);
            if (modFromBytes) scalar = $b046f5de9391306a$export$842a2cf37af977e1(scalar, ORDER);
            if (!skipValidation) {
                if (!f.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
            }
            // NOTE: we don't validate scalar here, please use isValid. This done such way because some
            // protocol may allow non-reduced scalar that reduced later or changed some other way.
            return scalar;
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>$b046f5de9391306a$export$a492e3387142c0e9(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
function $b046f5de9391306a$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $b046f5de9391306a$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $b046f5de9391306a$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $3TGEu.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $b046f5de9391306a$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $3TGEu.bytesToNumberLE)(hash) : (0, $3TGEu.bytesToNumberBE)(hash);
    return $b046f5de9391306a$export$842a2cf37af977e1(num, groupOrder - $b046f5de9391306a$var$_1n) + $b046f5de9391306a$var$_1n;
}
function $b046f5de9391306a$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $b046f5de9391306a$export$d058763b563056af(fieldOrder) {
    const length = $b046f5de9391306a$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $b046f5de9391306a$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $b046f5de9391306a$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $b046f5de9391306a$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $3TGEu.bytesToNumberLE)(key) : (0, $3TGEu.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $b046f5de9391306a$export$842a2cf37af977e1(num, fieldOrder - $b046f5de9391306a$var$_1n) + $b046f5de9391306a$var$_1n;
    return isLE ? (0, $3TGEu.numberToBytesLE)(reduced, fieldLen) : (0, $3TGEu.numberToBytesBE)(reduced, fieldLen);
}

});


parcelRegister("IRQiB", function(module, exports) {

$parcel$export(module.exports, "PrimeEdwardsPoint", () => $086de02e4ec94e35$export$de66e17e5739587e);
$parcel$export(module.exports, "twistedEdwards", () => $086de02e4ec94e35$export$f0c1eee63ea541eb);
/**
 * Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y².
 * For design rationale of types / exports, see weierstrass module documentation.
 * Untwisted Edwards curves exist, but they aren't used in real-world protocols.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
var $aX27w = parcelRequire("aX27w");

var $gaxAZ = parcelRequire("gaxAZ");

var $f8jNy = parcelRequire("f8jNy");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $086de02e4ec94e35$var$_0n = BigInt(0), $086de02e4ec94e35$var$_1n = BigInt(1), $086de02e4ec94e35$var$_2n = BigInt(2), $086de02e4ec94e35$var$_8n = BigInt(8);
function $086de02e4ec94e35$var$isEdValidXY(Fp, CURVE, x, y) {
    const x2 = Fp.sqr(x);
    const y2 = Fp.sqr(y);
    const left = Fp.add(Fp.mul(CURVE.a, x2), y2);
    const right = Fp.add(Fp.ONE, Fp.mul(CURVE.d, Fp.mul(x2, y2)));
    return Fp.eql(left, right);
}
function $086de02e4ec94e35$export$2a322ec7af93e9e7(params, extraOpts = {}) {
    const validated = (0, $gaxAZ._createCurveFields)('edwards', params, extraOpts, extraOpts.FpFnLE);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor } = CURVE;
    (0, $3TGEu._validateObject)(extraOpts, {}, {
        uvRatio: 'function'
    });
    // Important:
    // There are some places where Fp.BYTES is used instead of nByteLength.
    // So far, everything has been tested with curves of Fp.BYTES == nByteLength.
    // TODO: test and find curves which behave otherwise.
    const MASK = $086de02e4ec94e35$var$_2n << BigInt(Fn.BYTES * 8) - $086de02e4ec94e35$var$_1n;
    const modP = (n)=>Fp.create(n); // Function overrides
    // sqrt(u/v)
    const uvRatio = extraOpts.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(Fp.div(u, v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $086de02e4ec94e35$var$_0n
            };
        }
    });
    // Validate whether the passed curve params are valid.
    // equation ax² + y² = 1 + dx²y² should work for generator point.
    if (!$086de02e4ec94e35$var$isEdValidXY(Fp, CURVE, CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    /**
     * Asserts coordinate is valid: 0 <= n < MASK.
     * Coordinates >= Fp.ORDER are allowed for zip215.
     */ function acoord(title, n, banZero = false) {
        const min = banZero ? $086de02e4ec94e35$var$_1n : $086de02e4ec94e35$var$_0n;
        (0, $3TGEu.aInRange)('coordinate ' + title, n, min, MASK);
        return n;
    }
    function aextpoint(other) {
        if (!(other instanceof Point)) throw new Error('ExtendedPoint expected');
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $3TGEu.memoized)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $086de02e4ec94e35$var$_8n : Fp.inv(Z); // 8 was chosen arbitrarily
        const x = modP(X * iz);
        const y = modP(Y * iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: $086de02e4ec94e35$var$_0n,
            y: $086de02e4ec94e35$var$_1n
        };
        if (zz !== $086de02e4ec94e35$var$_1n) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    const assertValidMemo = (0, $3TGEu.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error('bad point: ZERO'); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { X: X, Y: Y, Z: Z, T: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error('bad point: equation left != right (1)');
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error('bad point: equation left != right (2)');
        return true;
    });
    // Extended Point works in extended coordinates: (X, Y, Z, T) ∋ (x=X/Z, y=Y/Z, T=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(X, Y, Z, T){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y);
            this.Z = acoord('z', Z, true);
            this.T = acoord('t', T);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error('extended point not allowed');
            const { x: x, y: y } = p || {};
            acoord('x', x);
            acoord('y', y);
            return new Point(x, y, $086de02e4ec94e35$var$_1n, modP(x * y));
        }
        // Uses algo from RFC8032 5.1.3.
        static fromBytes(bytes, zip215 = false) {
            const len = Fp.BYTES;
            const { a: a, d: d } = CURVE;
            bytes = (0, $3TGEu.copyBytes)((0, $3TGEu._abytes2)(bytes, len, 'point'));
            (0, $3TGEu._abool2)(zip215, 'zip215');
            const normed = (0, $3TGEu.copyBytes)(bytes); // copy again, we'll manipulate it
            const lastByte = bytes[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = (0, $3TGEu.bytesToNumberLE)(normed);
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            (0, $3TGEu.aInRange)('point.y', y, $086de02e4ec94e35$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $086de02e4ec94e35$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error('bad point: invalid y coordinate');
            const isXOdd = (x & $086de02e4ec94e35$var$_1n) === $086de02e4ec94e35$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $086de02e4ec94e35$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error('bad point: x=0 and x_0=1');
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromHex(bytes, zip215 = false) {
            return Point.fromBytes((0, $3TGEu.ensureBytes)('point', bytes), zip215);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($086de02e4ec94e35$var$_2n); // random number
            return this;
        }
        // Useful in fromAffine() - not for fromBytes(), which always created valid points.
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            aextpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.X), this.Y, this.Z, modP(-this.T));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($086de02e4ec94e35$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            aextpoint(other);
            const { a: a, d: d } = CURVE;
            const { X: X1, Y: Y1, Z: Z1, T: T1 } = this;
            const { X: X2, Y: Y2, Z: Z2, T: T2 } = other;
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        // Constant-time multiplication.
        multiply(scalar) {
            // 1 <= scalar < L
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: expected 1 <= sc < curve.n');
            const { p: p, f: f } = wnaf.cached(this, scalar, (p)=>(0, $gaxAZ.normalizeZ)(Point, p));
            return (0, $gaxAZ.normalizeZ)(Point, [
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        // Accepts optional accumulator to merge with multiply (important for sparse scalars)
        multiplyUnsafe(scalar, acc = Point.ZERO) {
            // 0 <= scalar < L
            if (!Fn.isValid(scalar)) throw new Error('invalid scalar: expected 0 <= sc < curve.n');
            if (scalar === $086de02e4ec94e35$var$_0n) return Point.ZERO;
            if (this.is0() || scalar === $086de02e4ec94e35$var$_1n) return this;
            return wnaf.unsafe(this, scalar, (p)=>(0, $gaxAZ.normalizeZ)(Point, p), acc);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafe(this, CURVE.n).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        clearCofactor() {
            if (cofactor === $086de02e4ec94e35$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        toBytes() {
            const { x: x, y: y } = this.toAffine();
            // Fp.toBytes() allows non-canonical encoding of y (>= p).
            const bytes = Fp.toBytes(y);
            // Each y has 2 valid points: (x, y), (x,-y).
            // When compressing, it's enough to store y and use the last byte to encode sign of x
            bytes[bytes.length - 1] |= x & $086de02e4ec94e35$var$_1n ? 0x80 : 0;
            return bytes;
        }
        toHex() {
            return (0, $aX27w.bytesToHex)(this.toBytes());
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get ex() {
            return this.X;
        }
        get ey() {
            return this.Y;
        }
        get ez() {
            return this.Z;
        }
        get et() {
            return this.T;
        }
        static normalizeZ(points) {
            return (0, $gaxAZ.normalizeZ)(Point, points);
        }
        static msm(points, scalars) {
            return (0, $gaxAZ.pippenger)(Point, Fn, points, scalars);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        toRawBytes() {
            return this.toBytes();
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $086de02e4ec94e35$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    // zero / infinity / identity point
    Point.ZERO = new Point($086de02e4ec94e35$var$_0n, $086de02e4ec94e35$var$_1n, $086de02e4ec94e35$var$_1n, $086de02e4ec94e35$var$_0n); // 0, 1, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const wnaf = new (0, $gaxAZ.wNAF)(Point, Fn.BITS);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
class $086de02e4ec94e35$export$de66e17e5739587e {
    constructor(ep){
        this.ep = ep;
    }
    // Static methods that must be implemented by subclasses
    static fromBytes(_bytes) {
        (0, $3TGEu.notImplemented)();
    }
    static fromHex(_hex) {
        (0, $3TGEu.notImplemented)();
    }
    get x() {
        return this.toAffine().x;
    }
    get y() {
        return this.toAffine().y;
    }
    // Common implementations
    clearCofactor() {
        // no-op for prime-order groups
        return this;
    }
    assertValidity() {
        this.ep.assertValidity();
    }
    toAffine(invertedZ) {
        return this.ep.toAffine(invertedZ);
    }
    toHex() {
        return (0, $aX27w.bytesToHex)(this.toBytes());
    }
    toString() {
        return this.toHex();
    }
    isTorsionFree() {
        return true;
    }
    isSmallOrder() {
        return false;
    }
    add(other) {
        this.assertSame(other);
        return this.init(this.ep.add(other.ep));
    }
    subtract(other) {
        this.assertSame(other);
        return this.init(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return this.init(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return this.init(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return this.init(this.ep.double());
    }
    negate() {
        return this.init(this.ep.negate());
    }
    precompute(windowSize, isLazy) {
        return this.init(this.ep.precompute(windowSize, isLazy));
    }
    /** @deprecated use `toBytes` */ toRawBytes() {
        return this.toBytes();
    }
}
function $086de02e4ec94e35$export$446a9d260f465faa(Point, cHash, eddsaOpts = {}) {
    if (typeof cHash !== 'function') throw new Error('"hash" function param is required');
    (0, $3TGEu._validateObject)(eddsaOpts, {}, {
        adjustScalarBytes: 'function',
        randomBytes: 'function',
        domain: 'function',
        prehash: 'function',
        mapToCurve: 'function'
    });
    const { prehash: prehash } = eddsaOpts;
    const { BASE: BASE, Fp: Fp, Fn: Fn } = Point;
    const randomBytes = eddsaOpts.randomBytes || (0, $aX27w.randomBytes);
    const adjustScalarBytes = eddsaOpts.adjustScalarBytes || ((bytes)=>bytes);
    const domain = eddsaOpts.domain || ((data, ctx, phflag)=>{
        (0, $3TGEu._abool2)(phflag, 'phflag');
        if (ctx.length || phflag) throw new Error('Contexts/pre-hash are not supported');
        return data;
    }); // NOOP
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return Fn.create((0, $3TGEu.bytesToNumberLE)(hash)); // Not Fn.fromBytes: it has length limit
    }
    // Get the hashed private scalar per RFC8032 5.1.5
    function getPrivateScalar(key) {
        const len = lengths.secretKey;
        key = (0, $3TGEu.ensureBytes)('private key', key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $3TGEu.ensureBytes)('hashed private key', cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        return {
            head: head,
            prefix: prefix,
            scalar: scalar
        };
    }
    /** Convenience method that creates public key from scalar. RFC8032 5.1.5 */ function getExtendedPublicKey(secretKey) {
        const { head: head, prefix: prefix, scalar: scalar } = getPrivateScalar(secretKey);
        const point = BASE.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toBytes();
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    /** Calculates EdDSA pub key. RFC8032 5.1.5. */ function getPublicKey(secretKey) {
        return getExtendedPublicKey(secretKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = Uint8Array.of(), ...msgs) {
        const msg = (0, $aX27w.concatBytes)(...msgs);
        return modN_LE(cHash(domain(msg, (0, $3TGEu.ensureBytes)('context', context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, secretKey, options = {}) {
        msg = (0, $3TGEu.ensureBytes)('message', msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(secretKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = BASE.multiply(r).toBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = Fn.create(r + k * scalar); // S = (r + k * s) mod L
        if (!Fn.isValid(s)) throw new Error('sign failed: invalid s'); // 0 <= s < L
        const rs = (0, $aX27w.concatBytes)(R, Fn.toBytes(s));
        return (0, $3TGEu._abytes2)(rs, lengths.signature, 'result');
    }
    // verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
    const verifyOpts = {
        zip215: true
    };
    /**
     * Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
     * An extended group equation is checked.
     */ function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = lengths.signature;
        sig = (0, $3TGEu.ensureBytes)('signature', sig, len);
        msg = (0, $3TGEu.ensureBytes)('message', msg);
        publicKey = (0, $3TGEu.ensureBytes)('publicKey', publicKey, lengths.publicKey);
        if (zip215 !== undefined) (0, $3TGEu._abool2)(zip215, 'zip215');
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const mid = len / 2;
        const r = sig.subarray(0, mid);
        const s = (0, $3TGEu.bytesToNumberLE)(sig.subarray(mid, len));
        let A, R, SB;
        try {
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            A = Point.fromBytes(publicKey, zip215);
            R = Point.fromBytes(r, zip215);
            SB = BASE.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false; // zip215 allows public keys of small order
        const k = hashDomainToScalar(context, R.toBytes(), A.toBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // Extended group equation
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().is0();
    }
    const _size = Fp.BYTES; // 32 for ed25519, 57 for ed448
    const lengths = {
        secretKey: _size,
        publicKey: _size,
        signature: 2 * _size,
        seed: _size
    };
    function randomSecretKey(seed = randomBytes(lengths.seed)) {
        return (0, $3TGEu._abytes2)(seed, lengths.seed, 'seed');
    }
    function keygen(seed) {
        const secretKey = utils.randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    }
    function isValidSecretKey(key) {
        return (0, $aX27w.isBytes)(key) && key.length === Fn.BYTES;
    }
    function isValidPublicKey(key, zip215) {
        try {
            return !!Point.fromBytes(key, zip215);
        } catch (error) {
            return false;
        }
    }
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        randomSecretKey: randomSecretKey,
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        /**
         * Converts ed public key to x public key. Uses formula:
         * - ed25519:
         *   - `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
         *   - `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
         * - ed448:
         *   - `(u, v) = ((y-1)/(y+1), sqrt(156324)*u/x)`
         *   - `(x, y) = (sqrt(156324)*u/v, (1+u)/(1-u))`
         */ toMontgomery (publicKey) {
            const { y: y } = Point.fromBytes(publicKey);
            const size = lengths.publicKey;
            const is25519 = size === 32;
            if (!is25519 && size !== 57) throw new Error('only defined for 25519 and 448');
            const u = is25519 ? Fp.div($086de02e4ec94e35$var$_1n + y, $086de02e4ec94e35$var$_1n - y) : Fp.div(y - $086de02e4ec94e35$var$_1n, y + $086de02e4ec94e35$var$_1n);
            return Fp.toBytes(u);
        },
        toMontgomerySecret (secretKey) {
            const size = lengths.secretKey;
            (0, $3TGEu._abytes2)(secretKey, size);
            const hashed = cHash(secretKey.subarray(0, size));
            return adjustScalarBytes(hashed).subarray(0, size);
        },
        /** @deprecated */ randomPrivateKey: randomSecretKey,
        /** @deprecated */ precompute (windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        }
    };
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        utils: utils,
        Point: Point,
        lengths: lengths
    });
}
function $086de02e4ec94e35$var$_eddsa_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        d: c.d,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy
    };
    const Fp = c.Fp;
    const Fn = (0, $f8jNy.Field)(CURVE.n, c.nBitLength, true);
    const curveOpts = {
        Fp: Fp,
        Fn: Fn,
        uvRatio: c.uvRatio
    };
    const eddsaOpts = {
        randomBytes: c.randomBytes,
        adjustScalarBytes: c.adjustScalarBytes,
        domain: c.domain,
        prehash: c.prehash,
        mapToCurve: c.mapToCurve
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts,
        hash: c.hash,
        eddsaOpts: eddsaOpts
    };
}
function $086de02e4ec94e35$var$_eddsa_new_output_to_legacy(c, eddsa) {
    const Point = eddsa.Point;
    const legacy = Object.assign({}, eddsa, {
        ExtendedPoint: Point,
        CURVE: c,
        nBitLength: Point.Fn.BITS,
        nByteLength: Point.Fn.BYTES
    });
    return legacy;
}
function $086de02e4ec94e35$export$f0c1eee63ea541eb(c) {
    const { CURVE: CURVE, curveOpts: curveOpts, hash: hash, eddsaOpts: eddsaOpts } = $086de02e4ec94e35$var$_eddsa_legacy_opts_to_new(c);
    const Point = $086de02e4ec94e35$export$2a322ec7af93e9e7(CURVE, curveOpts);
    const EDDSA = $086de02e4ec94e35$export$446a9d260f465faa(Point, hash, eddsaOpts);
    return $086de02e4ec94e35$var$_eddsa_new_output_to_legacy(c, EDDSA);
}

});

parcelRegister("jRTZM", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", () => $e76e671a8305cba2$export$3df78c69af9fc85d);
$parcel$export(module.exports, "isogenyMap", () => $e76e671a8305cba2$export$9393380cf1075f28);
$parcel$export(module.exports, "_DST_scalar", () => $e76e671a8305cba2$export$eaf8c8caa9e37fdf);
$parcel$export(module.exports, "createHasher", () => $e76e671a8305cba2$export$14b114effbc08b6b);

var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
var $aX27w = parcelRequire("aX27w");

var $f8jNy = parcelRequire("f8jNy");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $e76e671a8305cba2$var$os2ip = (0, $3TGEu.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $e76e671a8305cba2$var$i2osp(value, length) {
    $e76e671a8305cba2$var$anum(value);
    $e76e671a8305cba2$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $e76e671a8305cba2$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $e76e671a8305cba2$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
function $e76e671a8305cba2$var$normDST(DST) {
    if (!(0, $aX27w.isBytes)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or string');
    return typeof DST === 'string' ? (0, $aX27w.utf8ToBytes)(DST) : DST;
}
function $e76e671a8305cba2$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $aX27w.abytes)(msg);
    $e76e671a8305cba2$var$anum(lenInBytes);
    DST = $e76e671a8305cba2$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $aX27w.concatBytes)((0, $aX27w.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $aX27w.concatBytes)(DST, $e76e671a8305cba2$var$i2osp(DST.length, 1));
    const Z_pad = $e76e671a8305cba2$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $e76e671a8305cba2$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $aX27w.concatBytes)(Z_pad, msg, l_i_b_str, $e76e671a8305cba2$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $aX27w.concatBytes)(b_0, $e76e671a8305cba2$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $e76e671a8305cba2$var$strxor(b_0, b[i - 1]),
            $e76e671a8305cba2$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $aX27w.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $aX27w.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $e76e671a8305cba2$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $aX27w.abytes)(msg);
    $e76e671a8305cba2$var$anum(lenInBytes);
    DST = $e76e671a8305cba2$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $aX27w.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($e76e671a8305cba2$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($e76e671a8305cba2$var$i2osp(DST.length, 1)).digest();
}
function $e76e671a8305cba2$export$97cdd5ee18de8172(msg, count, options) {
    (0, $3TGEu._validateObject)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    if (!(0, $3TGEu.isHash)(options.hash)) throw new Error('expected valid hash');
    (0, $aX27w.abytes)(msg);
    $e76e671a8305cba2$var$anum(count);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $e76e671a8305cba2$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $e76e671a8305cba2$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $f8jNy.mod)($e76e671a8305cba2$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $e76e671a8305cba2$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $f8jNy.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
const $e76e671a8305cba2$export$eaf8c8caa9e37fdf = (0, $aX27w.utf8ToBytes)('HashToScalar-');
function $e76e671a8305cba2$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: defaults,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, defaults, options);
            const u = $e76e671a8305cba2$export$97cdd5ee18de8172(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = defaults.encodeDST ? {
                DST: defaults.encodeDST
            } : {};
            const opts = Object.assign({}, defaults, optsDst, options);
            const u = $e76e671a8305cba2$export$97cdd5ee18de8172(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, defaults, {
                p: N,
                m: 1,
                DST: $e76e671a8305cba2$export$eaf8c8caa9e37fdf
            }, options);
            return $e76e671a8305cba2$export$97cdd5ee18de8172(msg, 1, opts)[0][0];
        }
    };
}

});

parcelRegister("igELH", function(module, exports) {

$parcel$export(module.exports, "montgomery", () => $d4c95860ef717658$export$bdbee0d01bf914a7);
/**
 * Montgomery curve methods. It's not really whole montgomery curve,
 * just bunch of very specific methods for X25519 / X448 from
 * [RFC 7748](https://www.rfc-editor.org/rfc/rfc7748)
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
var $aX27w = parcelRequire("aX27w");

var $f8jNy = parcelRequire("f8jNy");
const $d4c95860ef717658$var$_0n = BigInt(0);
const $d4c95860ef717658$var$_1n = BigInt(1);
const $d4c95860ef717658$var$_2n = BigInt(2);
function $d4c95860ef717658$var$validateOpts(curve) {
    (0, $3TGEu._validateObject)(curve, {
        adjustScalarBytes: 'function',
        powPminus2: 'function'
    });
    return Object.freeze({
        ...curve
    });
}
function $d4c95860ef717658$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $d4c95860ef717658$var$validateOpts(curveDef);
    const { P: P, type: type, adjustScalarBytes: adjustScalarBytes, powPminus2: powPminus2, randomBytes: rand } = CURVE;
    const is25519 = type === 'x25519';
    if (!is25519 && type !== 'x448') throw new Error('invalid type');
    const randomBytes_ = rand || (0, $aX27w.randomBytes);
    const montgomeryBits = is25519 ? 255 : 448;
    const fieldLen = is25519 ? 32 : 56;
    const Gu = is25519 ? BigInt(9) : BigInt(5);
    // RFC 7748 #5:
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519 and
    // (156326 - 2) / 4 = 39081 for curve448/X448
    // const a = is25519 ? 156326n : 486662n;
    const a24 = is25519 ? BigInt(121665) : BigInt(39081);
    // RFC: x25519 "the resulting integer is of the form 2^254 plus
    // eight times a value between 0 and 2^251 - 1 (inclusive)"
    // x448: "2^447 plus four times a value between 0 and 2^445 - 1 (inclusive)"
    const minScalar = is25519 ? $d4c95860ef717658$var$_2n ** BigInt(254) : $d4c95860ef717658$var$_2n ** BigInt(447);
    const maxAdded = is25519 ? BigInt(8) * $d4c95860ef717658$var$_2n ** BigInt(251) - $d4c95860ef717658$var$_1n : BigInt(4) * $d4c95860ef717658$var$_2n ** BigInt(445) - $d4c95860ef717658$var$_1n;
    const maxScalar = minScalar + maxAdded + $d4c95860ef717658$var$_1n; // (inclusive)
    const modP = (n)=>(0, $f8jNy.mod)(n, P);
    const GuBytes = encodeU(Gu);
    function encodeU(u) {
        return (0, $3TGEu.numberToBytesLE)(modP(u), fieldLen);
    }
    function decodeU(u) {
        const _u = (0, $3TGEu.ensureBytes)('u coordinate', u, fieldLen);
        // RFC: When receiving such an array, implementations of X25519
        // (but not X448) MUST mask the most significant bit in the final byte.
        if (is25519) _u[31] &= 127; // 0b0111_1111
        // RFC: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.  The non-canonical
        // values are 2^255 - 19 through 2^255 - 1 for X25519 and 2^448 - 2^224
        // - 1 through 2^448 - 1 for X448.
        return modP((0, $3TGEu.bytesToNumberLE)(_u));
    }
    function decodeScalar(scalar) {
        return (0, $3TGEu.bytesToNumberLE)(adjustScalarBytes((0, $3TGEu.ensureBytes)('scalar', scalar, fieldLen)));
    }
    function scalarMult(scalar, u) {
        const pu = montgomeryLadder(decodeU(u), decodeScalar(scalar));
        // Some public keys are useless, of low-order. Curve author doesn't think
        // it needs to be validated, but we do it nonetheless.
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $d4c95860ef717658$var$_0n) throw new Error('invalid private or public key received');
        return encodeU(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    // cswap from RFC7748 "example code"
    function cswap(swap, x_2, x_3) {
        // dummy = mask(swap) AND (x_2 XOR x_3)
        // Where mask(swap) is the all-1 or all-0 word of the same length as x_2
        // and x_3, computed, e.g., as mask(swap) = 0 - swap.
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy); // x_2 = x_2 XOR dummy
        x_3 = modP(x_3 + dummy); // x_3 = x_3 XOR dummy
        return {
            x_2: x_2,
            x_3: x_3
        };
    }
    /**
     * Montgomery x-only multiplication ladder.
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $3TGEu.aInRange)('u', u, $d4c95860ef717658$var$_0n, P);
        (0, $3TGEu.aInRange)('scalar', scalar, minScalar, maxScalar);
        const k = scalar;
        const x_1 = u;
        let x_2 = $d4c95860ef717658$var$_1n;
        let z_2 = $d4c95860ef717658$var$_0n;
        let x_3 = u;
        let z_3 = $d4c95860ef717658$var$_1n;
        let swap = $d4c95860ef717658$var$_0n;
        for(let t = BigInt(montgomeryBits - 1); t >= $d4c95860ef717658$var$_0n; t--){
            const k_t = k >> t & $d4c95860ef717658$var$_1n;
            swap ^= k_t;
            ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
            ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
        ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
        const z2 = powPminus2(z_2); // `Fp.pow(x, P - _2n)` is much slower equivalent
        return modP(x_2 * z2); // Return x_2 * (z_2^(p - 2))
    }
    const lengths = {
        secretKey: fieldLen,
        publicKey: fieldLen,
        seed: fieldLen
    };
    const randomSecretKey = (seed = randomBytes_(fieldLen))=>{
        (0, $aX27w.abytes)(seed, lengths.seed);
        return seed;
    };
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: scalarMultBase(secretKey)
        };
    }
    const utils = {
        randomSecretKey: randomSecretKey,
        randomPrivateKey: randomSecretKey
    };
    return {
        keygen: keygen,
        getSharedSecret: (secretKey, publicKey)=>scalarMult(secretKey, publicKey),
        getPublicKey: (secretKey)=>scalarMultBase(secretKey),
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        utils: utils,
        GuBytes: GuBytes.slice(),
        lengths: lengths
    };
}

});


parcelRegister("3Di93", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("bYkMz", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $8b756b3b8ee97947$var$ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
module.exports = $0DhcF($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError('Expected Buffer');
        if (source.length === 0) return '';
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            var charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            var carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error('Non-base' + BASE + ' character');
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("43uCS", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $2f3f32ea0e529d41$export$bced8d2aada2d1c9);
/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 * @deprecated
 */ 
var $93IJ3 = parcelRequire("93IJ3");
const $2f3f32ea0e529d41$export$397b834fceb5b168 = (0, $93IJ3.SHA256);
const $2f3f32ea0e529d41$export$bced8d2aada2d1c9 = (0, $93IJ3.sha256);
const $2f3f32ea0e529d41$export$d90fcf4a65424421 = (0, $93IJ3.SHA224);
const $2f3f32ea0e529d41$export$97b70509d4e397ea = (0, $93IJ3.sha224);

});

parcelRegister("75BJw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5296450c35a171ab$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $5296450c35a171ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5296450c35a171ab$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5296450c35a171ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5296450c35a171ab$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $5296450c35a171ab$var$__createBinding(result, mod, k);
    }
    $5296450c35a171ab$var$__setModuleDefault(result, mod);
    return result;
};
var $5296450c35a171ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $5296450c35a171ab$var$bn_js_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("1j0q7")));

const $5296450c35a171ab$var$bs58_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("bYkMz")));

// TODO: Make sure this polyfill not included when not required
const $5296450c35a171ab$var$encoding = $5296450c35a171ab$var$__importStar((parcelRequire("kOaA4")));
const $5296450c35a171ab$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $5296450c35a171ab$var$encoding.TextDecoder : TextDecoder;
const $5296450c35a171ab$var$textDecoder = new $5296450c35a171ab$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $5296450c35a171ab$var$baseEncode(value) {
    if (typeof value === "string") value = $5296450c35a171ab$require$Buffer.from(value, "utf8");
    return $5296450c35a171ab$var$bs58_1.default.encode($5296450c35a171ab$require$Buffer.from(value));
}
module.exports.baseEncode = $5296450c35a171ab$var$baseEncode;
function $5296450c35a171ab$var$baseDecode(value) {
    return $5296450c35a171ab$require$Buffer.from($5296450c35a171ab$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $5296450c35a171ab$var$baseDecode;
const $5296450c35a171ab$var$INITIAL_LENGTH = 1024;
class $5296450c35a171ab$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $5296450c35a171ab$var$BorshError;
/// Binary encoder.
class $5296450c35a171ab$var$BinaryWriter {
    constructor(){
        this.buf = $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $5296450c35a171ab$require$Buffer.concat([
            this.buf,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $5296450c35a171ab$require$Buffer.concat([
            $5296450c35a171ab$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $5296450c35a171ab$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $5296450c35a171ab$var$BinaryWriter;
function $5296450c35a171ab$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $5296450c35a171ab$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $5296450c35a171ab$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $5296450c35a171ab$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $5296450c35a171ab$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $5296450c35a171ab$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU8", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU16", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU32", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU64", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU128", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU256", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU512", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readString", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readFixedArray", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $5296450c35a171ab$var$BinaryReader;
function $5296450c35a171ab$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$5296450c35a171ab$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $5296450c35a171ab$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $5296450c35a171ab$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $5296450c35a171ab$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $5296450c35a171ab$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $5296450c35a171ab$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $5296450c35a171ab$var$serialize(schema, obj, Writer = $5296450c35a171ab$var$BinaryWriter) {
    const writer = new Writer();
    $5296450c35a171ab$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $5296450c35a171ab$var$serialize;
function $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($5296450c35a171ab$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $5296450c35a171ab$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $5296450c35a171ab$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $5296450c35a171ab$var$deserialize(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $5296450c35a171ab$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $5296450c35a171ab$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $5296450c35a171ab$var$deserializeUnchecked(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $5296450c35a171ab$var$deserializeUnchecked;

});
parcelRegister("1j0q7", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("kOaA4", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $f260af419b27244f$export$88fb0cfd153261a7, (v) => $f260af419b27244f$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $f260af419b27244f$export$9c6b53e35bc51b5c, (v) => $f260af419b27244f$export$9c6b53e35bc51b5c = v);
var $f260af419b27244f$export$88fb0cfd153261a7;
var $f260af419b27244f$export$9c6b53e35bc51b5c;
'use strict';
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $f260af419b27244f$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $f260af419b27244f$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError('Could not convert argument to dictionary');
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $f260af419b27244f$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $f260af419b27244f$var$codePointsToString(code_points) {
    var s = '';
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $f260af419b27244f$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $f260af419b27244f$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$f260af419b27244f$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $f260af419b27244f$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $f260af419b27244f$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $f260af419b27244f$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError('Decoder error');
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $f260af419b27244f$var$DEFAULT_ENCODING = 'utf-8';
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextDecoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextDecoder)) return new $f260af419b27244f$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options['fatal']);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options['ignoreBOM']);
    Object.defineProperty(this, 'encoding', {
        value: 'utf-8'
    });
    Object.defineProperty(this, 'fatal', {
        value: this._fatal
    });
    Object.defineProperty(this, 'ignoreBOM', {
        value: this._ignoreBOM
    });
}
$f260af419b27244f$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === 'object' && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === 'object' && 'buffer' in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $f260af419b27244f$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $f260af419b27244f$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options['stream']);
        var input_stream = new $f260af419b27244f$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                'utf-8'
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $f260af419b27244f$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextEncoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextEncoder)) return new $f260af419b27244f$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error('Encoding not supported. Only utf-8 is supported');
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options['fatal'])
    };
    Object.defineProperty(this, 'encoding', {
        value: 'utf-8'
    });
}
$f260af419b27244f$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : '';
        options = $f260af419b27244f$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $f260af419b27244f$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options['stream']);
        var bytes = [];
        var input_stream = new $f260af419b27244f$var$Stream($f260af419b27244f$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $f260af419b27244f$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($f260af419b27244f$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($f260af419b27244f$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $f260af419b27244f$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$f260af419b27244f$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($f260af419b27244f$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($f260af419b27244f$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$f260af419b27244f$export$88fb0cfd153261a7 = $f260af419b27244f$var$TextEncoder;
$f260af419b27244f$export$9c6b53e35bc51b5c = $f260af419b27244f$var$TextDecoder;

});


parcelRegister("Q02IV", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $6ZWSX = parcelRequire("6ZWSX");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $09c4e3f7de797447$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError('b must be a Uint8Array');
}
module.exports.checkUint8Array = $09c4e3f7de797447$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $09c4e3f7de797447$var$uint8ArrayToBuffer(b) {
    $09c4e3f7de797447$var$checkUint8Array(b);
    return $6ZWSX.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $09c4e3f7de797447$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError('span must be an integer');
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError('indeterminate span');
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $09c4e3f7de797447$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $09c4e3f7de797447$var$nameWithProperty(name, lo) {
    if (lo.property) return name + '[' + lo.property + ']';
    return name;
}
module.exports.nameWithProperty = $09c4e3f7de797447$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $09c4e3f7de797447$var$bindConstructorLayout(Class, layout) {
    if ('function' !== typeof Class) throw new TypeError('Class must be constructor');
    if (Object.prototype.hasOwnProperty.call(Class, 'layout_')) throw new Error('Class is already bound to a layout');
    if (!(layout && layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError('layout must be a Layout');
    if (Object.prototype.hasOwnProperty.call(layout, 'boundConstructor_')) throw new Error('layout is already bound to a constructor');
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, 'encode', {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, 'decode', {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $09c4e3f7de797447$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$ExternalLayout extends $09c4e3f7de797447$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error('ExternalLayout is abstract');
    }
}
module.exports.ExternalLayout = $09c4e3f7de797447$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $09c4e3f7de797447$var$GreedyCount extends $09c4e3f7de797447$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError('elementSpan must be a (positive) integer');
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $09c4e3f7de797447$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$OffsetLayout extends $09c4e3f7de797447$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError('layout must be a Layout');
        if (!Number.isInteger(offset)) throw new TypeError('offset must be integer or undefined');
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $09c4e3f7de797447$var$UInt || this.layout instanceof $09c4e3f7de797447$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $09c4e3f7de797447$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UInt extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $09c4e3f7de797447$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UIntBE extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $09c4e3f7de797447$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Int extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $09c4e3f7de797447$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$IntBE extends $09c4e3f7de797447$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError('span must not exceed 6 bytes');
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $09c4e3f7de797447$var$IntBE;
const $09c4e3f7de797447$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $09c4e3f7de797447$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $09c4e3f7de797447$var$V2E32);
    const lo32 = src - hi32 * $09c4e3f7de797447$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $09c4e3f7de797447$var$roundedInt64(hi32, lo32) {
    return hi32 * $09c4e3f7de797447$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearUInt64 extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $09c4e3f7de797447$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearUInt64BE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $09c4e3f7de797447$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearInt64 extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $09c4e3f7de797447$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$NearInt64BE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $09c4e3f7de797447$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $09c4e3f7de797447$var$divmodInt64(src);
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $09c4e3f7de797447$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Float extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $09c4e3f7de797447$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$FloatBE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $09c4e3f7de797447$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Double extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $09c4e3f7de797447$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$DoubleBE extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $09c4e3f7de797447$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Sequence extends $09c4e3f7de797447$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError('elementLayout must be a Layout');
        if (!(count instanceof $09c4e3f7de797447$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $09c4e3f7de797447$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $09c4e3f7de797447$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $09c4e3f7de797447$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $09c4e3f7de797447$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $09c4e3f7de797447$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Structure extends $09c4e3f7de797447$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $09c4e3f7de797447$var$Layout, true))) throw new TypeError('fields must be array of Layout instances');
        if ('boolean' === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error('fields cannot contain unnamed variable-length layout');
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError('indeterminate span');
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $09c4e3f7de797447$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $09c4e3f7de797447$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error('UnionDiscriminator is abstract');
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error('UnionDiscriminator is abstract');
    }
}
module.exports.UnionDiscriminator = $09c4e3f7de797447$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $09c4e3f7de797447$var$UnionLayoutDiscriminator extends $09c4e3f7de797447$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $09c4e3f7de797447$var$ExternalLayout && layout.isCount())) throw new TypeError('layout must be an unsigned integer ExternalLayout');
        super(property || layout.property || 'variant');
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $09c4e3f7de797447$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Union extends $09c4e3f7de797447$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE) discriminator = new $09c4e3f7de797447$var$UnionLayoutDiscriminator(new $09c4e3f7de797447$var$OffsetLayout(discr));
        else if (discr instanceof $09c4e3f7de797447$var$ExternalLayout && discr.isCount()) discriminator = new $09c4e3f7de797447$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $09c4e3f7de797447$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError('defaultLayout must be null or a Layout');
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error('defaultLayout must have constant span');
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate('content');
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $09c4e3f7de797447$var$UInt || discr instanceof $09c4e3f7de797447$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error('unable to determine span for unrecognized variant');
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error('unable to infer src variant');
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $09c4e3f7de797447$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $09c4e3f7de797447$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$VariantLayout extends $09c4e3f7de797447$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $09c4e3f7de797447$var$Union)) throw new TypeError('union must be a Union');
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError('variant must be a (non-negative) integer');
        if ('string' === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $09c4e3f7de797447$var$Layout)) throw new TypeError('layout must be a Layout');
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error('variant span exceeds span of containing union');
            if ('string' !== typeof property) throw new TypeError('variant must have a String property');
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error('variant mismatch');
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError('variant lacks property ' + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error('encoded variant overruns containing union');
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $09c4e3f7de797447$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $09c4e3f7de797447$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$BitStructure extends $09c4e3f7de797447$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $09c4e3f7de797447$var$UInt || word instanceof $09c4e3f7de797447$var$UIntBE)) throw new TypeError('word must be a UInt or UIntBE layout');
        if ('string' === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError('word cannot exceed 32 bits');
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $09c4e3f7de797447$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $09c4e3f7de797447$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $09c4e3f7de797447$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ('string' !== typeof property) throw new TypeError('property must be string');
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $09c4e3f7de797447$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $09c4e3f7de797447$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $09c4e3f7de797447$var$BitStructure)) throw new TypeError('container must be a BitStructure');
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError('bits must be positive integer');
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error('bits too long for span remainder (' + (totalBits - usedBits) + ' of ' + totalBits + ' remain)');
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $09c4e3f7de797447$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $09c4e3f7de797447$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ('number' !== typeof value || !Number.isInteger(value) || value !== $09c4e3f7de797447$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($09c4e3f7de797447$var$nameWithProperty('BitField.encode', this) + ' value must be integer not exceeding ' + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $09c4e3f7de797447$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($09c4e3f7de797447$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $09c4e3f7de797447$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $09c4e3f7de797447$var$Boolean extends $09c4e3f7de797447$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ('boolean' === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $09c4e3f7de797447$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Blob extends $09c4e3f7de797447$var$Layout {
    constructor(length, property){
        if (!(length instanceof $09c4e3f7de797447$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $09c4e3f7de797447$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $09c4e3f7de797447$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($09c4e3f7de797447$var$nameWithProperty('Blob.encode', this) + ' requires (length ' + span + ') Uint8Array as src');
        if (offset + span > b.length) throw new RangeError('encoding overruns Uint8Array');
        const srcBuffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(src);
        $09c4e3f7de797447$var$uint8ArrayToBuffer(b).write(srcBuffer.toString('hex'), offset, span, 'hex');
        if (this.length instanceof $09c4e3f7de797447$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $09c4e3f7de797447$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$CString extends $09c4e3f7de797447$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString('utf-8');
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ('string' !== typeof src) src = String(src);
        const srcb = $6ZWSX.Buffer.from(src, 'utf8');
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError('encoding overruns Buffer');
        const buffer = $09c4e3f7de797447$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $09c4e3f7de797447$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$UTF8 extends $09c4e3f7de797447$var$Layout {
    constructor(maxSpan, property){
        if ('string' === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError('maxSpan must be an integer');
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $09c4e3f7de797447$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError('text length exceeds maxSpan');
        return $09c4e3f7de797447$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString('utf-8');
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ('string' !== typeof src) src = String(src);
        const srcb = $6ZWSX.Buffer.from(src, 'utf8');
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError('text length exceeds maxSpan');
        if (offset + span > b.length) throw new RangeError('encoding overruns Buffer');
        srcb.copy($09c4e3f7de797447$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $09c4e3f7de797447$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $09c4e3f7de797447$var$Constant extends $09c4e3f7de797447$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $09c4e3f7de797447$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $09c4e3f7de797447$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $09c4e3f7de797447$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $09c4e3f7de797447$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $09c4e3f7de797447$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $09c4e3f7de797447$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $09c4e3f7de797447$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $09c4e3f7de797447$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $09c4e3f7de797447$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $09c4e3f7de797447$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $09c4e3f7de797447$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $09c4e3f7de797447$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $09c4e3f7de797447$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $09c4e3f7de797447$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $09c4e3f7de797447$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $09c4e3f7de797447$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $09c4e3f7de797447$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $09c4e3f7de797447$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $09c4e3f7de797447$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $09c4e3f7de797447$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $09c4e3f7de797447$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $09c4e3f7de797447$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $09c4e3f7de797447$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $09c4e3f7de797447$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $09c4e3f7de797447$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $09c4e3f7de797447$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $09c4e3f7de797447$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $09c4e3f7de797447$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $09c4e3f7de797447$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $09c4e3f7de797447$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $09c4e3f7de797447$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $09c4e3f7de797447$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $09c4e3f7de797447$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $09c4e3f7de797447$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $09c4e3f7de797447$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $09c4e3f7de797447$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $09c4e3f7de797447$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $09c4e3f7de797447$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $09c4e3f7de797447$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $09c4e3f7de797447$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $09c4e3f7de797447$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $09c4e3f7de797447$var$Constant(value, property);

});

parcelRegister("cWwdi", function(module, exports) {

$parcel$export(module.exports, "getU64Encoder", () => $2ff00f90dade824a$export$59d3bc8d559487ec);
$parcel$export(module.exports, "getU64Codec", () => $2ff00f90dade824a$export$7e56ec13f6029ccc);

var $jzZdh = parcelRequire("jzZdh");

var $amDIA = parcelRequire("amDIA");
// src/assertions.ts
function $2ff00f90dade824a$export$50ab5941a148d055(codecDescription, min, max, value) {
    if (value < min || value > max) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__NUMBER_OUT_OF_RANGE), {
        codecDescription: codecDescription,
        max: max,
        min: min,
        value: value
    });
}
// src/common.ts
var $2ff00f90dade824a$export$54493dce0da47833 = /* @__PURE__ */ ((Endian2)=>{
    Endian2[Endian2["Little"] = 0] = "Little";
    Endian2[Endian2["Big"] = 1] = "Big";
    return Endian2;
})($2ff00f90dade824a$export$54493dce0da47833 || {});
function $2ff00f90dade824a$var$isLittleEndian(config) {
    return config?.endian === 1 /* Big */  ? false : true;
}
function $2ff00f90dade824a$var$numberEncoderFactory(input) {
    return (0, $amDIA.createEncoder)({
        fixedSize: input.size,
        write (value, bytes, offset) {
            if (input.range) $2ff00f90dade824a$export$50ab5941a148d055(input.name, input.range[0], input.range[1], value);
            const arrayBuffer = new ArrayBuffer(input.size);
            input.set(new DataView(arrayBuffer), value, $2ff00f90dade824a$var$isLittleEndian(input.config));
            bytes.set(new Uint8Array(arrayBuffer), offset);
            return offset + input.size;
        }
    });
}
function $2ff00f90dade824a$var$numberDecoderFactory(input) {
    return (0, $amDIA.createDecoder)({
        fixedSize: input.size,
        read (bytes, offset = 0) {
            (0, $amDIA.assertByteArrayIsNotEmptyForCodec)(input.name, bytes, offset);
            (0, $amDIA.assertByteArrayHasEnoughBytesForCodec)(input.name, input.size, bytes, offset);
            const view = new DataView((0, $amDIA.toArrayBuffer)(bytes, offset, input.size));
            return [
                input.get(view, $2ff00f90dade824a$var$isLittleEndian(input.config)),
                offset + input.size
            ];
        }
    });
}
// src/f32.ts
var $2ff00f90dade824a$export$d76ef1cfec201bc9 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "f32",
        set: (view, value, le)=>view.setFloat32(0, Number(value), le),
        size: 4
    });
var $2ff00f90dade824a$export$314df11445cfa5d0 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat32(0, le),
        name: "f32",
        size: 4
    });
var $2ff00f90dade824a$export$97a035f0564c51de = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$d76ef1cfec201bc9(config), $2ff00f90dade824a$export$314df11445cfa5d0(config));
var $2ff00f90dade824a$export$551368d522177b99 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "f64",
        set: (view, value, le)=>view.setFloat64(0, Number(value), le),
        size: 8
    });
var $2ff00f90dade824a$export$9475ae45ddf86dec = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat64(0, le),
        name: "f64",
        size: 8
    });
var $2ff00f90dade824a$export$9db82e6fbf3ec8ac = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$551368d522177b99(config), $2ff00f90dade824a$export$9475ae45ddf86dec(config));
var $2ff00f90dade824a$export$cf7587f741407205 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "i128",
        range: [
            -BigInt("0x7fffffffffffffffffffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigInt64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $2ff00f90dade824a$export$aacd18c97984700c = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigInt64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "i128",
        size: 16
    });
var $2ff00f90dade824a$export$b2a180b15845f643 = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$cf7587f741407205(config), $2ff00f90dade824a$export$aacd18c97984700c(config));
var $2ff00f90dade824a$export$45d575c12b2bb6a5 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "i16",
        range: [
            -Number("0x7fff") - 1,
            Number("0x7fff")
        ],
        set: (view, value, le)=>view.setInt16(0, Number(value), le),
        size: 2
    });
var $2ff00f90dade824a$export$4617ff1e22909f4 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt16(0, le),
        name: "i16",
        size: 2
    });
var $2ff00f90dade824a$export$c82cd783a714bca2 = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$45d575c12b2bb6a5(config), $2ff00f90dade824a$export$4617ff1e22909f4(config));
var $2ff00f90dade824a$export$73a58a16e77bb58b = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "i32",
        range: [
            -Number("0x7fffffff") - 1,
            Number("0x7fffffff")
        ],
        set: (view, value, le)=>view.setInt32(0, Number(value), le),
        size: 4
    });
var $2ff00f90dade824a$export$a7167d44cb5c65b9 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt32(0, le),
        name: "i32",
        size: 4
    });
var $2ff00f90dade824a$export$c31d2e083195a86f = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$73a58a16e77bb58b(config), $2ff00f90dade824a$export$a7167d44cb5c65b9(config));
var $2ff00f90dade824a$export$42b58a304e7edd67 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "i64",
        range: [
            -BigInt("0x7fffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigInt64(0, BigInt(value), le),
        size: 8
    });
var $2ff00f90dade824a$export$6f14c9b3a349f404 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigInt64(0, le),
        name: "i64",
        size: 8
    });
var $2ff00f90dade824a$export$ebdc4dbdba726e6a = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$42b58a304e7edd67(config), $2ff00f90dade824a$export$6f14c9b3a349f404(config));
var $2ff00f90dade824a$export$44792a8c35b3c0ce = ()=>$2ff00f90dade824a$var$numberEncoderFactory({
        name: "i8",
        range: [
            -Number("0x7f") - 1,
            Number("0x7f")
        ],
        set: (view, value)=>view.setInt8(0, Number(value)),
        size: 1
    });
var $2ff00f90dade824a$export$fdc22c4a59dfe6be = ()=>$2ff00f90dade824a$var$numberDecoderFactory({
        get: (view)=>view.getInt8(0),
        name: "i8",
        size: 1
    });
var $2ff00f90dade824a$export$f930a8952cfab173 = ()=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$44792a8c35b3c0ce(), $2ff00f90dade824a$export$fdc22c4a59dfe6be());
var $2ff00f90dade824a$export$6f025a6ce2a023fc = ()=>(0, $amDIA.createEncoder)({
        getSizeFromValue: (value)=>{
            if (value <= 127) return 1;
            if (value <= 16383) return 2;
            return 3;
        },
        maxSize: 3,
        write: (value, bytes, offset)=>{
            $2ff00f90dade824a$export$50ab5941a148d055("shortU16", 0, 65535, value);
            const shortU16Bytes = [
                0
            ];
            for(let ii = 0;; ii += 1){
                const alignedValue = Number(value) >> ii * 7;
                if (alignedValue === 0) break;
                const nextSevenBits = 127 & alignedValue;
                shortU16Bytes[ii] = nextSevenBits;
                if (ii > 0) shortU16Bytes[ii - 1] |= 128;
            }
            bytes.set(shortU16Bytes, offset);
            return offset + shortU16Bytes.length;
        }
    });
var $2ff00f90dade824a$export$fa35aa457fb08b4a = ()=>(0, $amDIA.createDecoder)({
        maxSize: 3,
        read: (bytes, offset)=>{
            let value = 0;
            let byteCount = 0;
            while(++byteCount){
                const byteIndex = byteCount - 1;
                const currentByte = bytes[offset + byteIndex];
                const nextSevenBits = 127 & currentByte;
                value |= nextSevenBits << byteIndex * 7;
                if ((currentByte & 128) === 0) break;
            }
            return [
                value,
                offset + byteCount
            ];
        }
    });
var $2ff00f90dade824a$export$9f6b1d6c8cda8e31 = ()=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$6f025a6ce2a023fc(), $2ff00f90dade824a$export$fa35aa457fb08b4a());
var $2ff00f90dade824a$export$3333225663a8d6bb = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "u128",
        range: [
            0n,
            BigInt("0xffffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigUint64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $2ff00f90dade824a$export$523e33537e060693 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigUint64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "u128",
        size: 16
    });
var $2ff00f90dade824a$export$e775878beaafab29 = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$3333225663a8d6bb(config), $2ff00f90dade824a$export$523e33537e060693(config));
var $2ff00f90dade824a$export$e156211d06496a2f = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "u16",
        range: [
            0,
            Number("0xffff")
        ],
        set: (view, value, le)=>view.setUint16(0, Number(value), le),
        size: 2
    });
var $2ff00f90dade824a$export$1a649eb0055ac058 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint16(0, le),
        name: "u16",
        size: 2
    });
var $2ff00f90dade824a$export$dda1212c8afd5e5c = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$e156211d06496a2f(config), $2ff00f90dade824a$export$1a649eb0055ac058(config));
var $2ff00f90dade824a$export$3e3136013a349951 = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "u32",
        range: [
            0,
            Number("0xffffffff")
        ],
        set: (view, value, le)=>view.setUint32(0, Number(value), le),
        size: 4
    });
var $2ff00f90dade824a$export$ddc26825031b1ac9 = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint32(0, le),
        name: "u32",
        size: 4
    });
var $2ff00f90dade824a$export$172bf721fe9bbfd1 = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$3e3136013a349951(config), $2ff00f90dade824a$export$ddc26825031b1ac9(config));
var $2ff00f90dade824a$export$59d3bc8d559487ec = (config = {})=>$2ff00f90dade824a$var$numberEncoderFactory({
        config: config,
        name: "u64",
        range: [
            0n,
            BigInt("0xffffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigUint64(0, BigInt(value), le),
        size: 8
    });
var $2ff00f90dade824a$export$faa05ffebebd465d = (config = {})=>$2ff00f90dade824a$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigUint64(0, le),
        name: "u64",
        size: 8
    });
var $2ff00f90dade824a$export$7e56ec13f6029ccc = (config = {})=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$59d3bc8d559487ec(config), $2ff00f90dade824a$export$faa05ffebebd465d(config));
var $2ff00f90dade824a$export$dc9732115561fb4b = ()=>$2ff00f90dade824a$var$numberEncoderFactory({
        name: "u8",
        range: [
            0,
            Number("0xff")
        ],
        set: (view, value)=>view.setUint8(0, Number(value)),
        size: 1
    });
var $2ff00f90dade824a$export$edadf68f5f1a8bc6 = ()=>$2ff00f90dade824a$var$numberDecoderFactory({
        get: (view)=>view.getUint8(0),
        name: "u8",
        size: 1
    });
var $2ff00f90dade824a$export$5ae2d5c46a10d97 = ()=>(0, $amDIA.combineCodec)($2ff00f90dade824a$export$dc9732115561fb4b(), $2ff00f90dade824a$export$edadf68f5f1a8bc6());
 //# sourceMappingURL=index.browser.mjs.map

});
parcelRegister("jzZdh", function(module, exports) {

$parcel$export(module.exports, "SOLANA_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY", () => $6317368273b77e46$export$9c9326ce1e3df40c);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__INVALID_BYTE_LENGTH", () => $6317368273b77e46$export$18fbf24f19efc69b);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__EXPECTED_FIXED_LENGTH", () => $6317368273b77e46$export$93561b31b951410d);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH", () => $6317368273b77e46$export$3417da5bc6bcb45);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH", () => $6317368273b77e46$export$c4c73ab3c0833591);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH", () => $6317368273b77e46$export$824d79ab1779d517);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH", () => $6317368273b77e46$export$c464f3b291f1f3d0);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__NUMBER_OUT_OF_RANGE", () => $6317368273b77e46$export$8653c145864f47f4);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH", () => $6317368273b77e46$export$4c1fcb4bd20b2951);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__OFFSET_OUT_OF_RANGE", () => $6317368273b77e46$export$a617dff403944ec6);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__ENCODED_BYTES_MUST_NOT_INCLUDE_SENTINEL", () => $6317368273b77e46$export$a9282ed13660c9f6);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__SENTINEL_MISSING_IN_DECODED_BYTES", () => $6317368273b77e46$export$5bdfee6423bc35ce);
$parcel$export(module.exports, "SOLANA_ERROR__CODECS__EXPECTED_DECODER_TO_CONSUME_ENTIRE_BYTE_ARRAY", () => $6317368273b77e46$export$11a7243580452ad8);
$parcel$export(module.exports, "SolanaError", () => $6317368273b77e46$export$8349fd9adaaed269);
// src/codes.ts
var $6317368273b77e46$export$637a712014b81b9c = 1;
var $6317368273b77e46$export$2b45309b0547a9c4 = 2;
var $6317368273b77e46$export$7cf14cde1226b7cb = 3;
var $6317368273b77e46$export$6ad19ea5e363a944 = 4;
var $6317368273b77e46$export$c37fe345cc9b38e7 = 5;
var $6317368273b77e46$export$cf7b28c4ea07497b = 6;
var $6317368273b77e46$export$e8ff0c73a3d6800d = 7;
var $6317368273b77e46$export$7dd7d17f1f93a166 = 8;
var $6317368273b77e46$export$8b23617676679e2d = 9;
var $6317368273b77e46$export$1cf7bba40d7d2361 = 10;
var $6317368273b77e46$export$e09e3905081e44fe = -32700;
var $6317368273b77e46$export$afa40fd3fc01204 = -32603;
var $6317368273b77e46$export$2981978a530b1a7c = -32602;
var $6317368273b77e46$export$5ec955cc8b7e8cf9 = -32601;
var $6317368273b77e46$export$23cb4efd59427895 = -32600;
var $6317368273b77e46$export$35d837f314929752 = -32019;
var $6317368273b77e46$export$86fc15c41ff3dc9c = -32018;
var $6317368273b77e46$export$1e95c50f9776ce34 = -32017;
var $6317368273b77e46$export$4f93db3d1b48599e = -32016;
var $6317368273b77e46$export$f7685139153f9191 = -32015;
var $6317368273b77e46$export$65235469ebe9845e = -32014;
var $6317368273b77e46$export$bdeebdca616ef1f3 = -32013;
var $6317368273b77e46$export$1b90c411626421b1 = -32012;
var $6317368273b77e46$export$8e678bf9b4e5cb64 = -32011;
var $6317368273b77e46$export$54dea2286c43ec1e = -32010;
var $6317368273b77e46$export$e71fbee92648fc61 = -32009;
var $6317368273b77e46$export$eb4f7515ff6aa19d = -32008;
var $6317368273b77e46$export$d21075fd06730e = -32007;
var $6317368273b77e46$export$d964b43bb02eacdf = -32006;
var $6317368273b77e46$export$6bad0f4fb625ae6e = -32005;
var $6317368273b77e46$export$bfbf8b75e865efa0 = -32004;
var $6317368273b77e46$export$83dce8c0aef70463 = -32003;
var $6317368273b77e46$export$426cc73f5ad00f38 = -32002;
var $6317368273b77e46$export$6ae475e85fe02aad = -32001;
var $6317368273b77e46$export$fe284a92110eab86 = 28e5;
var $6317368273b77e46$export$8aae3518bf4ea38c = 2800001;
var $6317368273b77e46$export$e31a90a3bf6aebaa = 2800002;
var $6317368273b77e46$export$adaec66b544981e7 = 2800003;
var $6317368273b77e46$export$523a769cce7318bf = 2800004;
var $6317368273b77e46$export$68473acf744cabf5 = 2800005;
var $6317368273b77e46$export$940d17d3b63dba7c = 2800006;
var $6317368273b77e46$export$a1cf857da540ee2e = 2800007;
var $6317368273b77e46$export$30501b98da9564bb = 2800008;
var $6317368273b77e46$export$123d01dd469dc2ef = 2800009;
var $6317368273b77e46$export$2a7684440f52314e = 2800010;
var $6317368273b77e46$export$7ada2ae349acb674 = 2800011;
var $6317368273b77e46$export$8f39956700e64760 = 323e4;
var $6317368273b77e46$export$1239089c4564c858 = 32300001;
var $6317368273b77e46$export$afc08ee11abbc257 = 3230002;
var $6317368273b77e46$export$57836d13a84f54b0 = 3230003;
var $6317368273b77e46$export$f080cd056a56cd54 = 3230004;
var $6317368273b77e46$export$f2bbb3c14e29977e = 361e4;
var $6317368273b77e46$export$f18173f573d8bb21 = 3610001;
var $6317368273b77e46$export$7ad09900bd645a86 = 3610002;
var $6317368273b77e46$export$69c08c51e1841f29 = 3610003;
var $6317368273b77e46$export$325dad4e0a6bd514 = 3610004;
var $6317368273b77e46$export$242c341c7c464bee = 3610005;
var $6317368273b77e46$export$a73c064bb32a7c36 = 3610006;
var $6317368273b77e46$export$b6497aaa1c3cb4a7 = 3610007;
var $6317368273b77e46$export$bc2b26beee0f9a0b = 3611e3;
var $6317368273b77e46$export$bc1242deaa4d848d = 3704e3;
var $6317368273b77e46$export$44352af09ecae39f = 3704001;
var $6317368273b77e46$export$d2a0e93e506be463 = 3704002;
var $6317368273b77e46$export$bbe4ed5687bc7f55 = 3704003;
var $6317368273b77e46$export$436df06ce5af77b3 = 3704004;
var $6317368273b77e46$export$552eeff1216c4a1e = 4128e3;
var $6317368273b77e46$export$b260fc8c8d3cde52 = 4128001;
var $6317368273b77e46$export$b81e507604713b9b = 4128002;
var $6317368273b77e46$export$d308cb6df5c28ff6 = 4615e3;
var $6317368273b77e46$export$ab2273c84ffc5d61 = 4615001;
var $6317368273b77e46$export$23cc359156888c7f = 4615002;
var $6317368273b77e46$export$a4193356408e9ff0 = 4615003;
var $6317368273b77e46$export$f9ae264f831e3bcf = 4615004;
var $6317368273b77e46$export$e170b44d99a3d17c = 4615005;
var $6317368273b77e46$export$84ec8e94b54ae7d2 = 4615006;
var $6317368273b77e46$export$4063fe8d5aed84a5 = 4615007;
var $6317368273b77e46$export$ecdd3388f6a493b1 = 4615008;
var $6317368273b77e46$export$df0a6d6cbb0d96a1 = 4615009;
var $6317368273b77e46$export$e45bdcd5a97f01d1 = 4615010;
var $6317368273b77e46$export$c2bfe7e903a0febb = 4615011;
var $6317368273b77e46$export$fa2d8ac69bd6117e = 4615012;
var $6317368273b77e46$export$2b7e7e6bd3d5b8c4 = 4615013;
var $6317368273b77e46$export$72e64aed285de589 = 4615014;
var $6317368273b77e46$export$95d7c72146ee65c6 = 4615015;
var $6317368273b77e46$export$aa03f185732dc00b = 4615016;
var $6317368273b77e46$export$c390f45549d7336b = 4615017;
var $6317368273b77e46$export$2ea2f2f9a9e26449 = 4615018;
var $6317368273b77e46$export$c9ece88629d0d2d8 = 4615019;
var $6317368273b77e46$export$2f331454431511bf = 4615020;
var $6317368273b77e46$export$3c4b9377ed4116a0 = 4615021;
var $6317368273b77e46$export$211b990ef3bd19ce = 4615022;
var $6317368273b77e46$export$ef486e0fcc8262b = 4615023;
var $6317368273b77e46$export$afcb9eeb4bf056b5 = 4615024;
var $6317368273b77e46$export$4db39a3a67e51db2 = 4615025;
var $6317368273b77e46$export$5abe2d1d040bf6cf = 4615026;
var $6317368273b77e46$export$35a7a209cf9aaee8 = 4615027;
var $6317368273b77e46$export$203fce7ce63eb278 = 4615028;
var $6317368273b77e46$export$c65d87b69a4b86e5 = 4615029;
var $6317368273b77e46$export$d13686e596713674 = 4615030;
var $6317368273b77e46$export$a070310f29fe959b = 4615031;
var $6317368273b77e46$export$8eb8ce58a8afa4d8 = 4615032;
var $6317368273b77e46$export$1224afa7bd705d3d = 4615033;
var $6317368273b77e46$export$547fdb4fff65c547 = 4615034;
var $6317368273b77e46$export$cbeea52e947eb081 = 4615035;
var $6317368273b77e46$export$fd7a98f0746b6c8a = 4615036;
var $6317368273b77e46$export$8e6d399c8fb88eaa = 4615037;
var $6317368273b77e46$export$2c001ce75e66180d = 4615038;
var $6317368273b77e46$export$ec7d592dad68aa12 = 4615039;
var $6317368273b77e46$export$8815da3ec592d05a = 4615040;
var $6317368273b77e46$export$b1b9bf899899a525 = 4615041;
var $6317368273b77e46$export$67715a67add5645f = 4615042;
var $6317368273b77e46$export$e343a153899b82e9 = 4615043;
var $6317368273b77e46$export$2199fb95c7d85b85 = 4615044;
var $6317368273b77e46$export$57c1675a0c20931f = 4615045;
var $6317368273b77e46$export$9e62f446da191370 = 4615046;
var $6317368273b77e46$export$b5ccaf975fe486a0 = 4615047;
var $6317368273b77e46$export$4d39d4c2f04b41a8 = 4615048;
var $6317368273b77e46$export$1997554dc67e9c4e = 4615049;
var $6317368273b77e46$export$8a65209e9cece2cd = 4615050;
var $6317368273b77e46$export$6b675123aa59300c = 4615051;
var $6317368273b77e46$export$70b4e2dd1496c5a3 = 4615052;
var $6317368273b77e46$export$43d5111034db211a = 4615053;
var $6317368273b77e46$export$8aebe3e76f515046 = 4615054;
var $6317368273b77e46$export$ee84b29a9985e516 = 5508e3;
var $6317368273b77e46$export$9998b265c986beaa = 5508001;
var $6317368273b77e46$export$dd792e9d67cd031b = 5508002;
var $6317368273b77e46$export$14d32fbdad2233cd = 5508003;
var $6317368273b77e46$export$8c6fc1cfcec8440c = 5508004;
var $6317368273b77e46$export$dcec7171cff295d1 = 5508005;
var $6317368273b77e46$export$200acbfc722e322b = 5508006;
var $6317368273b77e46$export$4c96d9a95880ae4b = 5508007;
var $6317368273b77e46$export$bba76b21ada319a5 = 5508008;
var $6317368273b77e46$export$3cb3b480d2bfdacc = 5508009;
var $6317368273b77e46$export$1f5fbaa83776feec = 5508010;
var $6317368273b77e46$export$1d51c4c8b2c49e09 = 5508011;
var $6317368273b77e46$export$e095feafa627ab93 = 5607e3;
var $6317368273b77e46$export$1bd1351c3c04dffb = 5607001;
var $6317368273b77e46$export$c2666c33001f9716 = 5607002;
var $6317368273b77e46$export$13efb168b2f8723b = 5607003;
var $6317368273b77e46$export$cdd46422e6064873 = 5607004;
var $6317368273b77e46$export$ca446d431d3e0795 = 5607005;
var $6317368273b77e46$export$7b86ea017e7c65a8 = 5607006;
var $6317368273b77e46$export$47bddc6d96d8aafe = 5607007;
var $6317368273b77e46$export$16aa99698ba98923 = 5607008;
var $6317368273b77e46$export$24dfb058e3a278af = 5607009;
var $6317368273b77e46$export$5de6608bb79088df = 5607010;
var $6317368273b77e46$export$5b7facf9eb8f4fc1 = 5607011;
var $6317368273b77e46$export$ac41328a8c021f1d = 5607012;
var $6317368273b77e46$export$a722215db3dceeea = 5607013;
var $6317368273b77e46$export$c0e832e2b8c6c75c = 5607014;
var $6317368273b77e46$export$7be41df2aa4d6598 = 5607015;
var $6317368273b77e46$export$f4c0dc856ca8d3c6 = 5607016;
var $6317368273b77e46$export$3abfcff57e9c6b21 = 5607017;
var $6317368273b77e46$export$694fd435994bcca = 5663e3;
var $6317368273b77e46$export$707576ec00ca24d6 = 5663001;
var $6317368273b77e46$export$e33d07a7526bded0 = 5663002;
var $6317368273b77e46$export$a20747f749dd4515 = 5663003;
var $6317368273b77e46$export$3963d9bca4091810 = 5663004;
var $6317368273b77e46$export$b34a16b8adbffdc1 = 5663005;
var $6317368273b77e46$export$3764bbcfb0679211 = 5663006;
var $6317368273b77e46$export$ed2bdee7953e467f = 5663007;
var $6317368273b77e46$export$11bea4440904349c = 5663008;
var $6317368273b77e46$export$6d61b980429516bd = 5663009;
var $6317368273b77e46$export$819b1b0603d2a966 = 5663010;
var $6317368273b77e46$export$592862d1b11e32ac = 5663011;
var $6317368273b77e46$export$242af5597d94abaf = 5663012;
var $6317368273b77e46$export$802b3ebe5297e360 = 5663013;
var $6317368273b77e46$export$bed6f92dafea0623 = 5663014;
var $6317368273b77e46$export$36c2547c3c4d823f = 5663015;
var $6317368273b77e46$export$de92784c954d1b84 = 5663016;
var $6317368273b77e46$export$b55a3eb3d894ad9f = 5663017;
var $6317368273b77e46$export$4e4582c633fc423e = 5663018;
var $6317368273b77e46$export$923893d5c076a47c = 5663019;
var $6317368273b77e46$export$980469bdb5d5bd4f = 5663020;
var $6317368273b77e46$export$8ff97fea1326b6e7 = 5663021;
var $6317368273b77e46$export$204c62c0e8d2efcc = 5663022;
var $6317368273b77e46$export$8c82dde5b12c9789 = 705e4;
var $6317368273b77e46$export$a746609ecc2f6acf = 7050001;
var $6317368273b77e46$export$c4d8217d3eb3eaf8 = 7050002;
var $6317368273b77e46$export$5d0f06cd8bc8e3af = 7050003;
var $6317368273b77e46$export$83c8fe2717d1b271 = 7050004;
var $6317368273b77e46$export$39ead28cf48a604c = 7050005;
var $6317368273b77e46$export$624f65633216eb57 = 7050006;
var $6317368273b77e46$export$2bbd9403cb117ea7 = 7050007;
var $6317368273b77e46$export$e108dd5343c4c11 = 7050008;
var $6317368273b77e46$export$a504ed6cab09ce4a = 7050009;
var $6317368273b77e46$export$8c1ae05eccc11ef9 = 7050010;
var $6317368273b77e46$export$47df44101c6f04b0 = 7050011;
var $6317368273b77e46$export$89ae0c424691fbcb = 7050012;
var $6317368273b77e46$export$bea5f92951bc42e7 = 7050013;
var $6317368273b77e46$export$91a668e132084ecf = 7050014;
var $6317368273b77e46$export$211b9b84186690f0 = 7050015;
var $6317368273b77e46$export$291ea8d5a7496fde = 7050016;
var $6317368273b77e46$export$5f027a86397cba92 = 7050017;
var $6317368273b77e46$export$58bf90c73afbc02e = 7050018;
var $6317368273b77e46$export$b8b2610c9a910763 = 7050019;
var $6317368273b77e46$export$fb693aebffa32676 = 7050020;
var $6317368273b77e46$export$572954173bc64b66 = 7050021;
var $6317368273b77e46$export$fa9a13f1b40ee2fb = 7050022;
var $6317368273b77e46$export$95c94f6ea500f1ab = 7050023;
var $6317368273b77e46$export$11d69fb6993b2cf5 = 7050024;
var $6317368273b77e46$export$bd54a9a85614b3a7 = 7050025;
var $6317368273b77e46$export$df4ef1824fd194a3 = 7050026;
var $6317368273b77e46$export$2725d50dd432fb3a = 7050027;
var $6317368273b77e46$export$41f13726b04d8d05 = 7050028;
var $6317368273b77e46$export$7b4a7eebff68ca7b = 7050029;
var $6317368273b77e46$export$e3a4007020a2e8f5 = 7050030;
var $6317368273b77e46$export$2ecc275dffbc087c = 7050031;
var $6317368273b77e46$export$e3289c5954208202 = 7050032;
var $6317368273b77e46$export$3569c6c71e349538 = 7050033;
var $6317368273b77e46$export$4f413e02d5e82221 = 7050034;
var $6317368273b77e46$export$1cd0de5dfcdeb99d = 7050035;
var $6317368273b77e46$export$87e01307d368f511 = 7050036;
var $6317368273b77e46$export$4758b9d97c7acd49 = 7618e3;
var $6317368273b77e46$export$2e5fda8b40bc9396 = 7618001;
var $6317368273b77e46$export$b22811c3929e985a = 7618002;
var $6317368273b77e46$export$12d6d18d48ba64e9 = 7618003;
var $6317368273b77e46$export$e4bc7cf62067d898 = 7618004;
var $6317368273b77e46$export$f988935bbec3c348 = 7618005;
var $6317368273b77e46$export$a55985b9459d2f3b = 7618006;
var $6317368273b77e46$export$dba3fa3abd2194c6 = 7618007;
var $6317368273b77e46$export$a751080bf117630f = 7618008;
var $6317368273b77e46$export$9318fa904fe94ef2 = 7618009;
var $6317368273b77e46$export$9c9326ce1e3df40c = 8078e3;
var $6317368273b77e46$export$18fbf24f19efc69b = 8078001;
var $6317368273b77e46$export$93561b31b951410d = 8078002;
var $6317368273b77e46$export$3417da5bc6bcb45 = 8078003;
var $6317368273b77e46$export$c4c73ab3c0833591 = 8078004;
var $6317368273b77e46$export$824d79ab1779d517 = 8078005;
var $6317368273b77e46$export$c464f3b291f1f3d0 = 8078006;
var $6317368273b77e46$export$c04710d31ef4d278 = 8078007;
var $6317368273b77e46$export$1fa107ead8489cf2 = 8078008;
var $6317368273b77e46$export$2bb0703affb8fe68 = 8078009;
var $6317368273b77e46$export$f6bf8a7c1f3defe4 = 8078010;
var $6317368273b77e46$export$8653c145864f47f4 = 8078011;
var $6317368273b77e46$export$89b582b06852d433 = 8078012;
var $6317368273b77e46$export$4c1fcb4bd20b2951 = 8078013;
var $6317368273b77e46$export$a617dff403944ec6 = 8078014;
var $6317368273b77e46$export$c89f43f0d783cd50 = 8078015;
var $6317368273b77e46$export$f73fb8ecbd4b2395 = 8078016;
var $6317368273b77e46$export$efbd199de191d2aa = 8078017;
var $6317368273b77e46$export$cb77f5a0f0fa7f18 = 8078018;
var $6317368273b77e46$export$47278510a511031b = 8078019;
var $6317368273b77e46$export$a9282ed13660c9f6 = 8078020;
var $6317368273b77e46$export$5bdfee6423bc35ce = 8078021;
var $6317368273b77e46$export$a2e9526594022372 = 8078022;
var $6317368273b77e46$export$11a7243580452ad8 = 8078023;
var $6317368273b77e46$export$ef742b7036fb9005 = 81e5;
var $6317368273b77e46$export$2a2f0f75708d1697 = 8100001;
var $6317368273b77e46$export$7f6822f75edb8f41 = 8100002;
var $6317368273b77e46$export$119023a74b281384 = 8100003;
var $6317368273b77e46$export$c32108b180210fc5 = 819e4;
var $6317368273b77e46$export$e1a3658b043aad8e = 8190001;
var $6317368273b77e46$export$ae8da83a78732501 = 8190002;
var $6317368273b77e46$export$73f01f46f9a97cf0 = 8190003;
var $6317368273b77e46$export$5293460f390d6127 = 8190004;
var $6317368273b77e46$export$a12ca71185bd51db = 99e5;
var $6317368273b77e46$export$d5b3c70e0e0f470a = 9900001;
var $6317368273b77e46$export$b57ffff6ec11f63 = 9900002;
var $6317368273b77e46$export$6fe73388375373f = 9900003;
var $6317368273b77e46$export$8b0d360227f3435e = 9900004;
var $6317368273b77e46$export$bcbc513a8682960f = 9900005;
var $6317368273b77e46$export$8f646bf76fb27ec0 = 9900006;
// src/context.ts
function $6317368273b77e46$var$encodeValue(value) {
    if (Array.isArray(value)) {
        const commaSeparatedValues = value.map($6317368273b77e46$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $6317368273b77e46$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$6317368273b77e46$var$encodeValue(value)}`;
}
function $6317368273b77e46$var$encodeContextObject(context) {
    const searchParamsString = Object.entries(context).map($6317368273b77e46$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
// src/messages.ts
var $6317368273b77e46$var$SolanaErrorMessages = {
    [$6317368273b77e46$export$8f39956700e64760]: "Account not found at address: $address",
    [$6317368273b77e46$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$6317368273b77e46$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$6317368273b77e46$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$6317368273b77e46$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$6317368273b77e46$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$6317368273b77e46$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$6317368273b77e46$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$6317368273b77e46$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$6317368273b77e46$export$7ada2ae349acb674]: "$putativeOffCurveAddress is not a base58-encoded off-curve address.",
    [$6317368273b77e46$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$6317368273b77e46$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$6317368273b77e46$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$6317368273b77e46$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$6317368273b77e46$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$6317368273b77e46$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$6317368273b77e46$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$6317368273b77e46$export$6ad19ea5e363a944]: "Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$6317368273b77e46$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$6317368273b77e46$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$6317368273b77e46$export$a2e9526594022372]: "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.",
    [$6317368273b77e46$export$a9282ed13660c9f6]: "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].",
    [$6317368273b77e46$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$6317368273b77e46$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$6317368273b77e46$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$6317368273b77e46$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.",
    [$6317368273b77e46$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$6317368273b77e46$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$6317368273b77e46$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$6317368273b77e46$export$47278510a511031b]: "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].",
    [$6317368273b77e46$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$6317368273b77e46$export$cb77f5a0f0fa7f18]: "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].",
    [$6317368273b77e46$export$2bb0703affb8fe68]: "Invalid discriminated union variant. Expected one of [$variants], got $value.",
    [$6317368273b77e46$export$f6bf8a7c1f3defe4]: "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.",
    [$6317368273b77e46$export$c89f43f0d783cd50]: "Invalid literal union variant. Expected one of [$variants], got $value.",
    [$6317368273b77e46$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$6317368273b77e46$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$6317368273b77e46$export$f73fb8ecbd4b2395]: "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$6317368273b77e46$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$6317368273b77e46$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$6317368273b77e46$export$5bdfee6423bc35ce]: "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].",
    [$6317368273b77e46$export$efbd199de191d2aa]: "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.",
    [$6317368273b77e46$export$11a7243580452ad8]: "This decoder expected a byte array of exactly $expectedLength bytes, but $numExcessBytes unexpected excess bytes remained after decoding. Are you sure that you have chosen the correct decoder for this data?",
    [$6317368273b77e46$export$bc2b26beee0f9a0b]: "No random values implementation could be found.",
    [$6317368273b77e46$export$df0a6d6cbb0d96a1]: "instruction requires an uninitialized account",
    [$6317368273b77e46$export$ef486e0fcc8262b]: "instruction tries to borrow reference for an account which is already borrowed",
    [$6317368273b77e46$export$afcb9eeb4bf056b5]: "instruction left account with an outstanding borrowed reference",
    [$6317368273b77e46$export$3c4b9377ed4116a0]: "program other than the account's owner changed the size of the account data",
    [$6317368273b77e46$export$e170b44d99a3d17c]: "account data too small for instruction",
    [$6317368273b77e46$export$211b990ef3bd19ce]: "instruction expected an executable account",
    [$6317368273b77e46$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$6317368273b77e46$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$6317368273b77e46$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data: $encodedData",
    [$6317368273b77e46$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$6317368273b77e46$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$6317368273b77e46$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$6317368273b77e46$export$5abe2d1d040bf6cf]: "custom program error: #$code",
    [$6317368273b77e46$export$c390f45549d7336b]: "instruction contains duplicate accounts",
    [$6317368273b77e46$export$4db39a3a67e51db2]: "instruction modifications of multiply-passed account differ",
    [$6317368273b77e46$export$d13686e596713674]: "executable accounts must be rent exempt",
    [$6317368273b77e46$export$203fce7ce63eb278]: "instruction changed executable accounts data",
    [$6317368273b77e46$export$c65d87b69a4b86e5]: "instruction changed the balance of an executable account",
    [$6317368273b77e46$export$2ea2f2f9a9e26449]: "instruction changed executable bit of an account",
    [$6317368273b77e46$export$72e64aed285de589]: "instruction modified data of an account it does not own",
    [$6317368273b77e46$export$2b7e7e6bd3d5b8c4]: "instruction spent from the balance of an account it does not own",
    [$6317368273b77e46$export$ab2273c84ffc5d61]: "generic instruction error",
    [$6317368273b77e46$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$6317368273b77e46$export$e343a153899b82e9]: "Account is immutable",
    [$6317368273b77e46$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$6317368273b77e46$export$4063fe8d5aed84a5]: "incorrect program id for instruction",
    [$6317368273b77e46$export$84ec8e94b54ae7d2]: "insufficient funds for instruction",
    [$6317368273b77e46$export$f9ae264f831e3bcf]: "invalid account data for instruction",
    [$6317368273b77e46$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$6317368273b77e46$export$23cc359156888c7f]: "invalid program argument",
    [$6317368273b77e46$export$35a7a209cf9aaee8]: "program returned invalid error code",
    [$6317368273b77e46$export$a4193356408e9ff0]: "invalid instruction data",
    [$6317368273b77e46$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$6317368273b77e46$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$6317368273b77e46$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$6317368273b77e46$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$6317368273b77e46$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$6317368273b77e46$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$6317368273b77e46$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$6317368273b77e46$export$ecdd3388f6a493b1]: "missing required signature for instruction",
    [$6317368273b77e46$export$fa2d8ac69bd6117e]: "instruction illegally modified the program id of an account",
    [$6317368273b77e46$export$2f331454431511bf]: "insufficient account keys for instruction",
    [$6317368273b77e46$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$6317368273b77e46$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$6317368273b77e46$export$67715a67add5645f]: "Program failed to compile",
    [$6317368273b77e46$export$b1b9bf899899a525]: "Program failed to complete",
    [$6317368273b77e46$export$aa03f185732dc00b]: "instruction modified data of a read-only account",
    [$6317368273b77e46$export$95d7c72146ee65c6]: "instruction changed the balance of a read-only account",
    [$6317368273b77e46$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$6317368273b77e46$export$c9ece88629d0d2d8]: "instruction modified rent epoch of an account",
    [$6317368273b77e46$export$c2bfe7e903a0febb]: "sum of account balances before and after instruction do not match",
    [$6317368273b77e46$export$e45bdcd5a97f01d1]: "instruction requires an initialized account",
    [$6317368273b77e46$export$d308cb6df5c28ff6]: "",
    [$6317368273b77e46$export$a070310f29fe959b]: "Unsupported program id",
    [$6317368273b77e46$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$6317368273b77e46$export$bcbc513a8682960f]: "Invalid instruction plan kind: $kind.",
    [$6317368273b77e46$export$b22811c3929e985a]: "The provided instruction plan is empty.",
    [$6317368273b77e46$export$f988935bbec3c348]: "No failed transaction plan result was found in the provided transaction plan result.",
    [$6317368273b77e46$export$e4bc7cf62067d898]: "This transaction plan executor does not support non-divisible sequential plans. To support them, you may create your own executor such that multi-transaction atomicity is preserved \u2014 e.g. by targetting RPCs that support transaction bundles.",
    [$6317368273b77e46$export$12d6d18d48ba64e9]: "The provided transaction plan failed to execute. See the `transactionPlanResult` attribute for more details. Note that the `cause` property is deprecated, and a future version will not set it.",
    [$6317368273b77e46$export$4758b9d97c7acd49]: "The provided message has insufficient capacity to accommodate the next instruction(s) in this plan. Expected at least $numBytesRequired free byte(s), got $numFreeBytes byte(s).",
    [$6317368273b77e46$export$8f646bf76fb27ec0]: "Invalid transaction plan kind: $kind.",
    [$6317368273b77e46$export$2e5fda8b40bc9396]: "No more instructions to pack; the message packer has completed the instruction plan.",
    [$6317368273b77e46$export$a55985b9459d2f3b]: "Unexpected instruction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$6317368273b77e46$export$dba3fa3abd2194c6]: "Unexpected transaction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$6317368273b77e46$export$a751080bf117630f]: "Unexpected transaction plan result. Expected $expectedKind plan, got $actualKind plan.",
    [$6317368273b77e46$export$9318fa904fe94ef2]: "Expected a successful transaction plan result. I.e. there is at least one failed or cancelled transaction in the plan.",
    [$6317368273b77e46$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$6317368273b77e46$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$6317368273b77e46$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$6317368273b77e46$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$6317368273b77e46$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$6317368273b77e46$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$6317368273b77e46$export$8b0d360227f3435e]: "Invariant violation: This data publisher does not publish to the channel named `$channelName`. Supported channels include $supportedChannelNames.",
    [$6317368273b77e46$export$d5b3c70e0e0f470a]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$6317368273b77e46$export$a12ca71185bd51db]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$6317368273b77e46$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$6317368273b77e46$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$6317368273b77e46$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$6317368273b77e46$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$6317368273b77e46$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$6317368273b77e46$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$6317368273b77e46$export$1b90c411626421b1]: "$__serverMessage",
    [$6317368273b77e46$export$6ae475e85fe02aad]: "$__serverMessage",
    [$6317368273b77e46$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$6317368273b77e46$export$65235469ebe9845e]: "$__serverMessage",
    [$6317368273b77e46$export$1e95c50f9776ce34]: "Epoch rewards period still active at slot $slot",
    [$6317368273b77e46$export$54dea2286c43ec1e]: "$__serverMessage",
    [$6317368273b77e46$export$e71fbee92648fc61]: "$__serverMessage",
    [$6317368273b77e46$export$35d837f314929752]: "Failed to query long-term storage; please try again",
    [$6317368273b77e46$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$6317368273b77e46$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$6317368273b77e46$export$eb4f7515ff6aa19d]: "No snapshot",
    [$6317368273b77e46$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$6317368273b77e46$export$86fc15c41ff3dc9c]: "Rewards cannot be found because slot $slot is not the epoch boundary. This may be due to gap in the queried node's local ledger or long-term storage",
    [$6317368273b77e46$export$d21075fd06730e]: "$__serverMessage",
    [$6317368273b77e46$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$6317368273b77e46$export$d964b43bb02eacdf]: "$__serverMessage",
    [$6317368273b77e46$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$6317368273b77e46$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$6317368273b77e46$export$f7685139153f9191]: "$__serverMessage",
    [$6317368273b77e46$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$6317368273b77e46$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$6317368273b77e46$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$6317368273b77e46$export$436df06ce5af77b3]: "The provided private key does not match the provided public key.",
    [$6317368273b77e46$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$6317368273b77e46$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$6317368273b77e46$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$6317368273b77e46$export$1cf7bba40d7d2361]: "$message",
    [$6317368273b77e46$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$6317368273b77e46$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$6317368273b77e46$export$13efb168b2f8723b]: "Expected base58 encoded application domain to decode to a byte array of length 32. Actual length: $actualLength.",
    [$6317368273b77e46$export$a722215db3dceeea]: "Attempted to sign an offchain message with an address that is not a signer for it",
    [$6317368273b77e46$export$c2666c33001f9716]: "Expected base58-encoded application domain string of length in the range [32, 44]. Actual length: $actualLength.",
    [$6317368273b77e46$export$ac41328a8c021f1d]: "The signer addresses in this offchain message envelope do not match the list of required signers in the message preamble. These unexpected signers were present in the envelope: `[$unexpectedSigners]`. These required signers were missing from the envelope `[$missingSigners]`.",
    [$6317368273b77e46$export$e095feafa627ab93]: "The message body provided has a byte-length of $actualBytes. The maximum allowable byte-length is $maxBytes",
    [$6317368273b77e46$export$47bddc6d96d8aafe]: "Expected message format $expectedMessageFormat, got $actualMessageFormat",
    [$6317368273b77e46$export$16aa99698ba98923]: "The message length specified in the message preamble is $specifiedLength bytes. The actual length of the message is $actualLength bytes.",
    [$6317368273b77e46$export$24dfb058e3a278af]: "Offchain message content must be non-empty",
    [$6317368273b77e46$export$ca446d431d3e0795]: "Offchain message must specify the address of at least one required signer",
    [$6317368273b77e46$export$5de6608bb79088df]: "Offchain message envelope must reserve space for at least one signature",
    [$6317368273b77e46$export$cdd46422e6064873]: "The offchain message preamble specifies $numRequiredSignatures required signature(s), got $signaturesLength.",
    [$6317368273b77e46$export$7be41df2aa4d6598]: "The signatories of this offchain message must be listed in lexicographical order",
    [$6317368273b77e46$export$f4c0dc856ca8d3c6]: "An address must be listed no more than once among the signatories of an offchain message",
    [$6317368273b77e46$export$5b7facf9eb8f4fc1]: "Offchain message is missing signatures for addresses: $addresses.",
    [$6317368273b77e46$export$3abfcff57e9c6b21]: "Offchain message signature verification failed. Signature mismatch for required signatories [$signatoriesWithInvalidSignatures]. Missing signatures for signatories [$signatoriesWithMissingSignatures]",
    [$6317368273b77e46$export$1bd1351c3c04dffb]: "The message body provided contains characters whose codes fall outside the allowed range. In order to ensure clear-signing compatiblity with hardware wallets, the message may only contain line feeds and characters in the range [\\x20-\\x7e].",
    [$6317368273b77e46$export$c0e832e2b8c6c75c]: "Expected offchain message version $expectedVersion. Got $actualVersion.",
    [$6317368273b77e46$export$7b86ea017e7c65a8]: "This version of Kit does not support decoding offchain messages with version $unsupportedVersion. The current max supported version is 0.",
    [$6317368273b77e46$export$c32108b180210fc5]: "The notification name must end in 'Notifications' and the API must supply a subscription plan creator function for the notification '$notificationName'.",
    [$6317368273b77e46$export$ae8da83a78732501]: "WebSocket was closed before payload could be added to the send buffer",
    [$6317368273b77e46$export$73f01f46f9a97cf0]: "WebSocket connection closed",
    [$6317368273b77e46$export$5293460f390d6127]: "WebSocket failed to connect",
    [$6317368273b77e46$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$6317368273b77e46$export$119023a74b281384]: "Could not find an API plan for RPC method: `$method`",
    [$6317368273b77e46$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$6317368273b77e46$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$6317368273b77e46$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$6317368273b77e46$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$6317368273b77e46$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$6317368273b77e46$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$6317368273b77e46$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$6317368273b77e46$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$6317368273b77e46$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$6317368273b77e46$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$6317368273b77e46$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$6317368273b77e46$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$6317368273b77e46$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$6317368273b77e46$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `TransactionWithSingleSendingSigner` transaction.",
    [$6317368273b77e46$export$1d51c4c8b2c49e09]: "Wallet account signers do not support signing multiple messages/transactions in a single operation",
    [$6317368273b77e46$export$b6497aaa1c3cb4a7]: "Cannot export a non-extractable key.",
    [$6317368273b77e46$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$6317368273b77e46$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$6317368273b77e46$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$6317368273b77e46$export$69c08c51e1841f29]: "No signature verification implementation could be found.",
    [$6317368273b77e46$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$6317368273b77e46$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$6317368273b77e46$export$a73c064bb32a7c36]: "No key export implementation could be found.",
    [$6317368273b77e46$export$8b23617676679e2d]: "Timestamp value must be in the range [-(2n ** 63n), (2n ** 63n) - 1]. `$value` given",
    [$6317368273b77e46$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$6317368273b77e46$export$a746609ecc2f6acf]: "Account in use",
    [$6317368273b77e46$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$6317368273b77e46$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$6317368273b77e46$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$6317368273b77e46$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$6317368273b77e46$export$e108dd5343c4c11]: "Blockhash not found",
    [$6317368273b77e46$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$6317368273b77e46$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$6317368273b77e46$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$6317368273b77e46$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$6317368273b77e46$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$6317368273b77e46$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$6317368273b77e46$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$6317368273b77e46$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$6317368273b77e46$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$6317368273b77e46$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$6317368273b77e46$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$6317368273b77e46$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$6317368273b77e46$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$6317368273b77e46$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$6317368273b77e46$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$6317368273b77e46$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$6317368273b77e46$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$6317368273b77e46$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$6317368273b77e46$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$6317368273b77e46$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$6317368273b77e46$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$6317368273b77e46$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$6317368273b77e46$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$6317368273b77e46$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$6317368273b77e46$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$6317368273b77e46$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$6317368273b77e46$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$6317368273b77e46$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$6317368273b77e46$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$6317368273b77e46$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$6317368273b77e46$export$36c2547c3c4d823f]: "Attempted to sign a transaction with an address that is not a signer for it",
    [$6317368273b77e46$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$6317368273b77e46$export$de92784c954d1b84]: "Transaction has no expected signers therefore it cannot be encoded",
    [$6317368273b77e46$export$980469bdb5d5bd4f]: "Transaction size $transactionSize exceeds limit of $transactionSizeLimit bytes",
    [$6317368273b77e46$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$6317368273b77e46$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$6317368273b77e46$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$6317368273b77e46$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$6317368273b77e46$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$6317368273b77e46$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$6317368273b77e46$export$4e4582c633fc423e]: "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more",
    [$6317368273b77e46$export$923893d5c076a47c]: "Transaction failed when it was simulated in order to estimate the compute unit consumption. The compute unit estimate provided is for a transaction that failed when simulated and may not be representative of the compute units this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$6317368273b77e46$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$6317368273b77e46$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$6317368273b77e46$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$6317368273b77e46$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$6317368273b77e46$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$6317368273b77e46$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$6317368273b77e46$export$b55a3eb3d894ad9f]: "The transaction message expected the transaction to have $numRequiredSignatures signatures, got $signaturesLength.",
    [$6317368273b77e46$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$6317368273b77e46$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given",
    [$6317368273b77e46$export$8ff97fea1326b6e7]: "This version of Kit does not support decoding transactions with version $unsupportedVersion. The current max supported version is 0.",
    [$6317368273b77e46$export$204c62c0e8d2efcc]: "The transaction has a durable nonce lifetime (with nonce `$nonce`), but the nonce account address is in a lookup table. The lifetime constraint cannot be constructed without fetching the lookup tables for the transaction."
};
// src/message-formatter.ts
var $6317368273b77e46$var$START_INDEX = "i";
var $6317368273b77e46$var$TYPE = "t";
function $6317368273b77e46$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $6317368273b77e46$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    let state;
    function commitStateUpTo(endIndex) {
        if (state[$6317368273b77e46$var$TYPE] === 2 /* Variable */ ) {
            const variableName = messageFormatString.slice(state[$6317368273b77e46$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${context[variableName]}` : `$${variableName}`);
        } else if (state[$6317368273b77e46$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$6317368273b77e46$var$START_INDEX], endIndex));
    }
    const fragments = [];
    messageFormatString.split("").forEach((char, ii)=>{
        if (ii === 0) {
            state = {
                [$6317368273b77e46$var$START_INDEX]: 0,
                [$6317368273b77e46$var$TYPE]: messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ 
            };
            return;
        }
        let nextState;
        switch(state[$6317368273b77e46$var$TYPE]){
            case 0 /* EscapeSequence */ :
                nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 1 /* Text */ 
                };
                break;
            case 1 /* Text */ :
                if (char === "\\") nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 2 /* Variable */ 
                };
                break;
            case 2 /* Variable */ :
                if (char === "\\") nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 2 /* Variable */ 
                };
                else if (!char.match(/\w/)) nextState = {
                    [$6317368273b77e46$var$START_INDEX]: ii,
                    [$6317368273b77e46$var$TYPE]: 1 /* Text */ 
                };
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    return fragments.join("");
}
function $6317368273b77e46$var$getErrorMessage(code, context = {}) {
    {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode -- ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` '${$6317368273b77e46$var$encodeContextObject(context)}'`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $6317368273b77e46$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $6317368273b77e46$export$8349fd9adaaed269 = class extends Error {
    /**
   * Indicates the root cause of this {@link SolanaError}, if any.
   *
   * For example, a transaction error might have an instruction error as its root cause. In this
   * case, you will be able to access the instruction error on the transaction error as `cause`.
   */ cause = this.cause;
    /**
   * Contains context that can assist in understanding or recovering from a {@link SolanaError}.
   */ context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) Object.entries(Object.getOwnPropertyDescriptors(contextAndErrorOptions)).forEach(([name, descriptor])=>{
            if (name === "cause") errorOptions = {
                cause: descriptor.value
            };
            else {
                if (context === void 0) context = {
                    __code: code
                };
                Object.defineProperty(context, name, descriptor);
            }
        });
        const message = $6317368273b77e46$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = Object.freeze(context === void 0 ? {
            __code: code
        } : context);
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $6317368273b77e46$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $6317368273b77e46$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $6317368273b77e46$export$8349fd9adaaed269(errorCode, errorContext);
    $6317368273b77e46$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $6317368273b77e46$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/solana-sdk/blob/master/instruction-error/src/lib.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $6317368273b77e46$export$4e38d43e41953f9e(index, instructionError) {
    const numberIndex = Number(index);
    return $6317368273b77e46$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $6317368273b77e46$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: numberIndex,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $6317368273b77e46$export$5abe2d1d040bf6cf) return {
                code: Number(rpcErrorContext),
                index: numberIndex
            };
            return {
                index: numberIndex
            };
        },
        orderedErrorNames: $6317368273b77e46$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $6317368273b77e46$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $6317368273b77e46$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $6317368273b77e46$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $6317368273b77e46$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $6317368273b77e46$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $6317368273b77e46$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $6317368273b77e46$export$e3a4007020a2e8f5) return {
                index: Number(rpcErrorContext)
            };
            else if (errorCode === $6317368273b77e46$export$2ecc275dffbc087c || errorCode === $6317368273b77e46$export$1cd0de5dfcdeb99d) return {
                accountIndex: Number(rpcErrorContext.account_index)
            };
        },
        orderedErrorNames: $6317368273b77e46$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $6317368273b77e46$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $6317368273b77e46$export$1f67f8d128316a6d(putativeErrorResponse) {
    let out;
    if ($6317368273b77e46$var$isRpcErrorResponse(putativeErrorResponse)) {
        const { code: rawCode, data: data, message: message } = putativeErrorResponse;
        const code = Number(rawCode);
        if (code === $6317368273b77e46$export$426cc73f5ad00f38) {
            const { err: err, ...preflightErrorContext } = data;
            const causeObject = err ? {
                cause: $6317368273b77e46$export$c10ce7a2fd9c66f0(err)
            } : null;
            out = new $6317368273b77e46$export$8349fd9adaaed269($6317368273b77e46$export$426cc73f5ad00f38, {
                ...preflightErrorContext,
                ...causeObject
            });
        } else {
            let errorContext;
            switch(code){
                case $6317368273b77e46$export$afa40fd3fc01204:
                case $6317368273b77e46$export$2981978a530b1a7c:
                case $6317368273b77e46$export$23cb4efd59427895:
                case $6317368273b77e46$export$5ec955cc8b7e8cf9:
                case $6317368273b77e46$export$e09e3905081e44fe:
                case $6317368273b77e46$export$1b90c411626421b1:
                case $6317368273b77e46$export$6ae475e85fe02aad:
                case $6317368273b77e46$export$bfbf8b75e865efa0:
                case $6317368273b77e46$export$65235469ebe9845e:
                case $6317368273b77e46$export$54dea2286c43ec1e:
                case $6317368273b77e46$export$e71fbee92648fc61:
                case $6317368273b77e46$export$d21075fd06730e:
                case $6317368273b77e46$export$d964b43bb02eacdf:
                case $6317368273b77e46$export$f7685139153f9191:
                    errorContext = {
                        __serverMessage: message
                    };
                    break;
                default:
                    if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
            }
            out = new $6317368273b77e46$export$8349fd9adaaed269(code, errorContext);
        }
    } else {
        const message = typeof putativeErrorResponse === "object" && putativeErrorResponse !== null && "message" in putativeErrorResponse && typeof putativeErrorResponse.message === "string" ? putativeErrorResponse.message : "Malformed JSON-RPC error with no message attribute";
        out = new $6317368273b77e46$export$8349fd9adaaed269($6317368273b77e46$export$1cf7bba40d7d2361, {
            error: putativeErrorResponse,
            message: message
        });
    }
    $6317368273b77e46$export$4608fd6508cb51(out, $6317368273b77e46$export$1f67f8d128316a6d);
    return out;
}
function $6317368273b77e46$var$isRpcErrorResponse(value) {
    return typeof value === "object" && value !== null && "code" in value && "message" in value && (typeof value.code === "number" || typeof value.code === "bigint") && typeof value.message === "string";
}
// src/simulation-errors.ts
function $6317368273b77e46$export$ddd98780b31b44b0(error) {
    const simulationCodes = [
        $6317368273b77e46$export$426cc73f5ad00f38,
        $6317368273b77e46$export$923893d5c076a47c
    ];
    if ($6317368273b77e46$export$cfead212e52d9961(error) && !!error.cause && simulationCodes.includes(error.context.__code)) return error.cause;
    return error;
}
 //# sourceMappingURL=index.browser.mjs.map

});

parcelRegister("amDIA", function(module, exports) {

$parcel$export(module.exports, "createEncoder", () => $014f45425e6fc660$export$4e76eeb6df88c889);
$parcel$export(module.exports, "createDecoder", () => $014f45425e6fc660$export$f8c898e83b60faaa);
$parcel$export(module.exports, "combineCodec", () => $014f45425e6fc660$export$b88681b853abde79);
$parcel$export(module.exports, "assertByteArrayIsNotEmptyForCodec", () => $014f45425e6fc660$export$bf929351331b7b89);
$parcel$export(module.exports, "assertByteArrayHasEnoughBytesForCodec", () => $014f45425e6fc660$export$4a981e7c9ed0b6bf);
$parcel$export(module.exports, "toArrayBuffer", () => $014f45425e6fc660$export$8b22b05f429b130c);

var $jzZdh = parcelRequire("jzZdh");
// src/add-codec-sentinel.ts
// src/bytes.ts
var $014f45425e6fc660$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
function $014f45425e6fc660$export$4c6b868113605df3(bytes, length) {
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
}
var $014f45425e6fc660$export$11b3146a4f4702ef = (bytes, length)=>$014f45425e6fc660$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $014f45425e6fc660$export$1b62aef2a79e6b21(data, bytes, offset) {
    const slice = offset === 0 && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    return $014f45425e6fc660$export$c663ab80cce302c5(slice, bytes);
}
function $014f45425e6fc660$export$c663ab80cce302c5(bytes1, bytes2) {
    return bytes1.length === bytes2.length && bytes1.every((value, index)=>value === bytes2[index]);
}
function $014f45425e6fc660$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $014f45425e6fc660$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($014f45425e6fc660$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $014f45425e6fc660$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $014f45425e6fc660$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($014f45425e6fc660$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $014f45425e6fc660$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $014f45425e6fc660$export$4e85b7423fd6bc55(codec) {
    if (!$014f45425e6fc660$export$f9d60229c95384d4(codec)) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_FIXED_LENGTH));
}
function $014f45425e6fc660$export$d76fd0b6e42f051a(codec) {
    return !$014f45425e6fc660$export$f9d60229c95384d4(codec);
}
function $014f45425e6fc660$export$6bf5fc425e413c8a(codec) {
    if (!$014f45425e6fc660$export$d76fd0b6e42f051a(codec)) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_VARIABLE_LENGTH));
}
function $014f45425e6fc660$export$b88681b853abde79(encoder, decoder) {
    if ($014f45425e6fc660$export$f9d60229c95384d4(encoder) !== $014f45425e6fc660$export$f9d60229c95384d4(decoder)) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__ENCODER_DECODER_SIZE_COMPATIBILITY_MISMATCH));
    if ($014f45425e6fc660$export$f9d60229c95384d4(encoder) && $014f45425e6fc660$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__ENCODER_DECODER_FIXED_SIZE_MISMATCH), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$014f45425e6fc660$export$f9d60229c95384d4(encoder) && !$014f45425e6fc660$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__ENCODER_DECODER_MAX_SIZE_MISMATCH), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/add-codec-sentinel.ts
function $014f45425e6fc660$export$e98b1308839de22(encoder, sentinel) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        if ($014f45425e6fc660$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__ENCODED_BYTES_MUST_NOT_INCLUDE_SENTINEL), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $014f45425e6fc660$var$hexBytes(encoderBytes),
            hexSentinel: $014f45425e6fc660$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($014f45425e6fc660$export$f9d60229c95384d4(encoder)) return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    });
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        ...encoder.maxSize != null ? {
            maxSize: encoder.maxSize + sentinel.length
        } : {},
        getSizeFromValue: (value)=>encoder.getSizeFromValue(value) + sentinel.length,
        write: write
    });
}
function $014f45425e6fc660$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    const read = (bytes, offset)=>{
        const candidateBytes = offset === 0 ? bytes : bytes.slice(offset);
        const sentinelIndex = $014f45425e6fc660$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__SENTINEL_MISSING_IN_DECODED_BYTES), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $014f45425e6fc660$var$hexBytes(candidateBytes),
            hexSentinel: $014f45425e6fc660$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        const preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($014f45425e6fc660$export$f9d60229c95384d4(decoder)) return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    });
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        ...decoder.maxSize != null ? {
            maxSize: decoder.maxSize + sentinel.length
        } : {},
        read: read
    });
}
function $014f45425e6fc660$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$e98b1308839de22(codec, sentinel), $014f45425e6fc660$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $014f45425e6fc660$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex((byte, index, arr)=>{
        if (sentinel.length === 1) return byte === sentinel[0];
        return $014f45425e6fc660$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $014f45425e6fc660$var$hexBytes(bytes) {
    return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
}
function $014f45425e6fc660$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__CANNOT_DECODE_EMPTY_BYTE_ARRAY), {
        codecDescription: codecDescription
    });
}
function $014f45425e6fc660$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__INVALID_BYTE_LENGTH), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $014f45425e6fc660$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__OFFSET_OUT_OF_RANGE), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $014f45425e6fc660$export$37e5b12cb5a8d560(encoder, prefix) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($014f45425e6fc660$export$f9d60229c95384d4(prefix) && $014f45425e6fc660$export$f9d60229c95384d4(encoder)) return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    });
    const prefixMaxSize = $014f45425e6fc660$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const encoderMaxSize = $014f45425e6fc660$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : encoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (value)=>{
            const encoderSize = $014f45425e6fc660$export$30f3257599397621(value, encoder);
            return $014f45425e6fc660$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    });
}
function $014f45425e6fc660$export$fe2b33c81523b294(decoder, prefix) {
    const read = (bytes, offset)=>{
        const [bigintSize, decoderOffset] = prefix.read(bytes, offset);
        const size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $014f45425e6fc660$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($014f45425e6fc660$export$f9d60229c95384d4(prefix) && $014f45425e6fc660$export$f9d60229c95384d4(decoder)) return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    });
    const prefixMaxSize = $014f45425e6fc660$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const decoderMaxSize = $014f45425e6fc660$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : decoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $014f45425e6fc660$export$ec85c1caba397ab2(codec, prefix) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$37e5b12cb5a8d560(codec, prefix), $014f45425e6fc660$export$fe2b33c81523b294(codec, prefix));
}
// src/array-buffers.ts
function $014f45425e6fc660$export$8b22b05f429b130c(bytes, offset, length) {
    const bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    let buffer;
    if (typeof SharedArrayBuffer === "undefined") buffer = bytes.buffer;
    else if (bytes.buffer instanceof SharedArrayBuffer) {
        buffer = new ArrayBuffer(bytes.length);
        new Uint8Array(buffer).set(new Uint8Array(bytes));
    } else buffer = bytes.buffer;
    return (bytesOffset === 0 || bytesOffset === -bytes.byteLength) && bytesLength === bytes.byteLength ? buffer : buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
function $014f45425e6fc660$export$9fde90fcc5ed41ea(decoder) {
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        read (bytes, offset) {
            const [value, newOffset] = decoder.read(bytes, offset);
            if (bytes.length > newOffset) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_DECODER_TO_CONSUME_ENTIRE_BYTE_ARRAY), {
                expectedLength: newOffset,
                numExcessBytes: bytes.length - newOffset
            });
            return [
                value,
                newOffset
            ];
        }
    });
}
// src/fix-codec-size.ts
function $014f45425e6fc660$export$cbdfce031443a1(encoder, fixedBytes) {
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $014f45425e6fc660$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $014f45425e6fc660$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($014f45425e6fc660$export$f9d60229c95384d4(decoder)) bytes = $014f45425e6fc660$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $014f45425e6fc660$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$cbdfce031443a1(codec, fixedBytes), $014f45425e6fc660$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $014f45425e6fc660$export$92407871fbff8926(encoder, config) {
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$014f45425e6fc660$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $014f45425e6fc660$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $014f45425e6fc660$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $014f45425e6fc660$export$24667feddece166a(decoder, config) {
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$014f45425e6fc660$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $014f45425e6fc660$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $014f45425e6fc660$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $014f45425e6fc660$export$8170ddca0f3f53ea(codec, config) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$92407871fbff8926(codec, config), $014f45425e6fc660$export$24667feddece166a(codec, config));
}
function $014f45425e6fc660$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $014f45425e6fc660$export$d41c2ca858573bc6(encoder, resize) {
    if ($014f45425e6fc660$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $014f45425e6fc660$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $014f45425e6fc660$export$7369e12a03366140(decoder, resize) {
    if ($014f45425e6fc660$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $jzZdh.SolanaError)((0, $jzZdh.SOLANA_ERROR__CODECS__EXPECTED_POSITIVE_BYTE_LENGTH), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $014f45425e6fc660$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $014f45425e6fc660$export$aff234b7657ae683(codec, resize) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$d41c2ca858573bc6(codec, resize), $014f45425e6fc660$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $014f45425e6fc660$export$66b1746799cd3030(encoder, offset) {
    return $014f45425e6fc660$export$92407871fbff8926($014f45425e6fc660$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $014f45425e6fc660$export$770586d1e6f1e5b(encoder, offset) {
    return $014f45425e6fc660$export$92407871fbff8926($014f45425e6fc660$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $014f45425e6fc660$export$d88f5bbaa5c2e177(decoder, offset) {
    return $014f45425e6fc660$export$24667feddece166a($014f45425e6fc660$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $014f45425e6fc660$export$57a7baba87e0aed9(decoder, offset) {
    return $014f45425e6fc660$export$24667feddece166a($014f45425e6fc660$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $014f45425e6fc660$export$d6ed5bbf596a5505(codec, offset) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$66b1746799cd3030(codec, offset), $014f45425e6fc660$export$d88f5bbaa5c2e177(codec, offset));
}
function $014f45425e6fc660$export$b11ce69168faaa31(codec, offset) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$770586d1e6f1e5b(codec, offset), $014f45425e6fc660$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $014f45425e6fc660$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength, targetOffset = 0) {
    while(sourceOffset < --sourceLength){
        const leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $014f45425e6fc660$export$290b4b66fdcc682c(encoder) {
    $014f45425e6fc660$export$4e85b7423fd6bc55(encoder);
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            $014f45425e6fc660$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    });
}
function $014f45425e6fc660$export$1dded7e9fb3087ff(decoder) {
    $014f45425e6fc660$export$4e85b7423fd6bc55(decoder);
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reversedBytes = bytes.slice();
            $014f45425e6fc660$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $014f45425e6fc660$export$e1ef688f83355e2e(codec) {
    return $014f45425e6fc660$export$b88681b853abde79($014f45425e6fc660$export$290b4b66fdcc682c(codec), $014f45425e6fc660$export$1dded7e9fb3087ff(codec));
}
// src/transform-codec.ts
function $014f45425e6fc660$export$30169aca64409a56(encoder, unmap) {
    return $014f45425e6fc660$export$4e76eeb6df88c889({
        ...$014f45425e6fc660$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $014f45425e6fc660$export$605b10ee38669daa(decoder, map) {
    return $014f45425e6fc660$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $014f45425e6fc660$export$59b20038bbe52b5f(codec, unmap, map) {
    return $014f45425e6fc660$export$a4cf2f585987cc8({
        ...$014f45425e6fc660$export$30169aca64409a56(codec, unmap),
        read: map ? $014f45425e6fc660$export$605b10ee38669daa(codec, map).read : codec.read
    });
}
 //# sourceMappingURL=index.browser.mjs.map

});


parcelRegister("5DqgT", function(module, exports) {

$parcel$export(module.exports, "assert", () => $d36cd0d29f3bcaa8$export$a7a9523472993e97);
$parcel$export(module.exports, "create", () => $d36cd0d29f3bcaa8$export$185802fd694ee1f5);
$parcel$export(module.exports, "type", () => $d36cd0d29f3bcaa8$export$bf9fb029d174d554);
$parcel$export(module.exports, "optional", () => $d36cd0d29f3bcaa8$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "any", () => $d36cd0d29f3bcaa8$export$4154a199d7d90455);
$parcel$export(module.exports, "array", () => $d36cd0d29f3bcaa8$export$2f23118c22fb2630);
$parcel$export(module.exports, "boolean", () => $d36cd0d29f3bcaa8$export$4a21f16c33752377);
$parcel$export(module.exports, "instance", () => $d36cd0d29f3bcaa8$export$9544d5bb712b01ea);
$parcel$export(module.exports, "literal", () => $d36cd0d29f3bcaa8$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "nullable", () => $d36cd0d29f3bcaa8$export$133fc36489ac9add);
$parcel$export(module.exports, "number", () => $d36cd0d29f3bcaa8$export$98e628dec113755e);
$parcel$export(module.exports, "record", () => $d36cd0d29f3bcaa8$export$e5185e241753e543);
$parcel$export(module.exports, "string", () => $d36cd0d29f3bcaa8$export$22b082955e083ec3);
$parcel$export(module.exports, "tuple", () => $d36cd0d29f3bcaa8$export$65e3907585753458);
$parcel$export(module.exports, "union", () => $d36cd0d29f3bcaa8$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "unknown", () => $d36cd0d29f3bcaa8$export$19282c40b967aec6);
$parcel$export(module.exports, "coerce", () => $d36cd0d29f3bcaa8$export$8c14e57e778d3873);
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $d36cd0d29f3bcaa8$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join('.')} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $d36cd0d29f3bcaa8$var$isIterable(x) {
    return $d36cd0d29f3bcaa8$var$isObject(x) && typeof x[Symbol.iterator] === 'function';
}
/**
 * Check if a value is a plain object.
 */ function $d36cd0d29f3bcaa8$var$isObject(x) {
    return typeof x === 'object' && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function $d36cd0d29f3bcaa8$var$isNonArrayObject(x) {
    return $d36cd0d29f3bcaa8$var$isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function $d36cd0d29f3bcaa8$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $d36cd0d29f3bcaa8$var$print(value) {
    if (typeof value === 'symbol') return value.toString();
    return typeof value === 'string' ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $d36cd0d29f3bcaa8$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $d36cd0d29f3bcaa8$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === 'string') result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ''}, but received: \`${$d36cd0d29f3bcaa8$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $d36cd0d29f3bcaa8$var$toFailures(result, context, struct, value) {
    if (!$d36cd0d29f3bcaa8$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $d36cd0d29f3bcaa8$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $d36cd0d29f3bcaa8$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch,
        mask: mask
    };
    if (coerce) value = struct.coercer(value, ctx);
    let status = 'valid';
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = 'not_valid';
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $d36cd0d29f3bcaa8$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? 'not_refined' : 'not_valid';
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($d36cd0d29f3bcaa8$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== 'not_valid') for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = 'not_refined';
        yield [
            failure,
            undefined
        ];
    }
    if (status === 'valid') yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $d36cd0d29f3bcaa8$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $d36cd0d29f3bcaa8$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $d36cd0d29f3bcaa8$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $d36cd0d29f3bcaa8$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $d36cd0d29f3bcaa8$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $d36cd0d29f3bcaa8$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ mask(value, message) {
        return $d36cd0d29f3bcaa8$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ validate(value, options = {}) {
        return $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $d36cd0d29f3bcaa8$export$a7a9523472993e97(value, struct, message) {
    const result = $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $d36cd0d29f3bcaa8$export$185802fd694ee1f5(value, struct, message) {
    const result = $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $d36cd0d29f3bcaa8$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $d36cd0d29f3bcaa8$export$226b3eccf92c9ed9(value, struct) {
    const result = $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $d36cd0d29f3bcaa8$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $d36cd0d29f3bcaa8$var$run(value, struct, options);
    const tuple = $d36cd0d29f3bcaa8$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $d36cd0d29f3bcaa8$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $d36cd0d29f3bcaa8$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === 'type';
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $d36cd0d29f3bcaa8$export$bf9fb029d174d554(schema) : $d36cd0d29f3bcaa8$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e(name, validator) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $d36cd0d29f3bcaa8$export$cdd73fc4100a6ef4(struct, log) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $d36cd0d29f3bcaa8$export$7077912c31975674(fn) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'dynamic',
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $d36cd0d29f3bcaa8$export$488013bae63b21da(fn) {
    let struct;
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'lazy',
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $d36cd0d29f3bcaa8$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case 'type':
            return $d36cd0d29f3bcaa8$export$bf9fb029d174d554(subschema);
        default:
            return $d36cd0d29f3bcaa8$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $d36cd0d29f3bcaa8$export$e45945969df8035a(struct) {
    const isStruct = struct instanceof $d36cd0d29f3bcaa8$export$eabc71f011df675a;
    const schema = isStruct ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $d36cd0d29f3bcaa8$export$516e28dec6a4b6d4(schema[key]);
    if (isStruct && struct.type === 'type') return $d36cd0d29f3bcaa8$export$bf9fb029d174d554(schema);
    return $d36cd0d29f3bcaa8$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $d36cd0d29f3bcaa8$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    switch(struct.type){
        case 'type':
            return $d36cd0d29f3bcaa8$export$bf9fb029d174d554(subschema);
        default:
            return $d36cd0d29f3bcaa8$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $d36cd0d29f3bcaa8$export$8cf3da7c1c9174ea(name, validator) {
    console.warn('superstruct@0.11 - The `struct` helper has been renamed to `define`.');
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $d36cd0d29f3bcaa8$export$4154a199d7d90455() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('any', ()=>true);
}
function $d36cd0d29f3bcaa8$export$2f23118c22fb2630(Element) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'array',
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $d36cd0d29f3bcaa8$export$a0f65b52274bcc00() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('bigint', (value)=>{
        return typeof value === 'bigint';
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $d36cd0d29f3bcaa8$export$4a21f16c33752377() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('boolean', (value)=>{
        return typeof value === 'boolean';
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $d36cd0d29f3bcaa8$export$324d90190a8b822a() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('date', (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
function $d36cd0d29f3bcaa8$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$d36cd0d29f3bcaa8$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'enums',
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $d36cd0d29f3bcaa8$export$86951950244e2001() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('func', (value)=>{
        return typeof value === 'function' || `Expected a function, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $d36cd0d29f3bcaa8$export$9544d5bb712b01ea(Class) {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('instance', (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $d36cd0d29f3bcaa8$export$32744b5b3bba4764() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('integer', (value)=>{
        return typeof value === 'number' && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $d36cd0d29f3bcaa8$export$bc86dfbf7795668c(Structs) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'intersection',
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $d36cd0d29f3bcaa8$export$c8ec6e1ec9fefcb0(constant) {
    const description = $d36cd0d29f3bcaa8$var$print(constant);
    const t = typeof constant;
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'literal',
        schema: t === 'string' || t === 'number' || t === 'boolean' ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        }
    });
}
function $d36cd0d29f3bcaa8$export$871de8747c9eaa88(Key, Value) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'map',
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $d36cd0d29f3bcaa8$export$b3e22bcfd64c1022() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('never', ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $d36cd0d29f3bcaa8$export$133fc36489ac9add(struct) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $d36cd0d29f3bcaa8$export$98e628dec113755e() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('number', (value)=>{
        return typeof value === 'number' && !isNaN(value) || `Expected a number, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
function $d36cd0d29f3bcaa8$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $d36cd0d29f3bcaa8$export$b3e22bcfd64c1022();
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'object',
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $d36cd0d29f3bcaa8$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $d36cd0d29f3bcaa8$var$isNonArrayObject(value) || `Expected an object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        },
        coercer (value, ctx) {
            if (!$d36cd0d29f3bcaa8$var$isNonArrayObject(value)) return value;
            const coerced = {
                ...value
            };
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(const key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $d36cd0d29f3bcaa8$export$516e28dec6a4b6d4(struct) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $d36cd0d29f3bcaa8$export$e5185e241753e543(Key, Value) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'record',
        schema: null,
        *entries (value) {
            if ($d36cd0d29f3bcaa8$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $d36cd0d29f3bcaa8$var$isNonArrayObject(value) || `Expected an object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        },
        coercer (value) {
            return $d36cd0d29f3bcaa8$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $d36cd0d29f3bcaa8$export$efdc1e5bdb609bb() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('regexp', (value)=>{
        return value instanceof RegExp;
    });
}
function $d36cd0d29f3bcaa8$export$adaa4cf7ef1b65be(Element) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'set',
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $d36cd0d29f3bcaa8$export$22b082955e083ec3() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('string', (value)=>{
        return typeof value === 'string' || `Expected a string, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $d36cd0d29f3bcaa8$export$65e3907585753458(Structs) {
    const Never = $d36cd0d29f3bcaa8$export$b3e22bcfd64c1022();
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'tuple',
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $d36cd0d29f3bcaa8$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'type',
        schema: schema,
        *entries (value) {
            if ($d36cd0d29f3bcaa8$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $d36cd0d29f3bcaa8$var$isNonArrayObject(value) || `Expected an object, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`;
        },
        coercer (value) {
            return $d36cd0d29f3bcaa8$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $d36cd0d29f3bcaa8$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(' | ');
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        type: 'union',
        schema: null,
        coercer (value, ctx) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true,
                    mask: ctx.mask
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $d36cd0d29f3bcaa8$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$d36cd0d29f3bcaa8$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $d36cd0d29f3bcaa8$export$19282c40b967aec6() {
    return $d36cd0d29f3bcaa8$export$f36d6a7a5c09a23e('unknown', ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d36cd0d29f3bcaa8$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $d36cd0d29f3bcaa8$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d36cd0d29f3bcaa8$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $d36cd0d29f3bcaa8$export$8c14e57e778d3873(struct, $d36cd0d29f3bcaa8$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === 'function' ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $d36cd0d29f3bcaa8$var$isPlainObject(x) && $d36cd0d29f3bcaa8$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $d36cd0d29f3bcaa8$export$41f369984ed28930(struct) {
    return $d36cd0d29f3bcaa8$export$8c14e57e778d3873(struct, $d36cd0d29f3bcaa8$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $d36cd0d29f3bcaa8$export$6e22c362a0406a2c(struct) {
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'empty', (value)=>{
        const size = $d36cd0d29f3bcaa8$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $d36cd0d29f3bcaa8$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $d36cd0d29f3bcaa8$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'max', (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? '' : 'or equal to '}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $d36cd0d29f3bcaa8$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'min', (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? '' : 'or equal to '}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $d36cd0d29f3bcaa8$export$6ce6c9218151d511(struct) {
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'nonempty', (value)=>{
        const size = $d36cd0d29f3bcaa8$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $d36cd0d29f3bcaa8$export$24f82734ea047e6f(struct, regexp) {
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'pattern', (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $d36cd0d29f3bcaa8$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, 'size', (value)=>{
        if (typeof value === 'number' || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $d36cd0d29f3bcaa8$export$edc9d475108b3212(struct, name, refiner) {
    return new $d36cd0d29f3bcaa8$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $d36cd0d29f3bcaa8$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("7pfXJ", function(module, exports) {
'use strict';

var $5sKyw = parcelRequire("5sKyw");
var $5647400503806718$require$uuid = $5sKyw.default;

var $4kTUs = parcelRequire("4kTUs");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $5647400503806718$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $5647400503806718$var$ClientBrowser)) return new $5647400503806718$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== 'undefined' ? options.reviver : null,
        replacer: typeof options.replacer !== 'undefined' ? options.replacer : null,
        generator: typeof options.generator !== 'undefined' ? options.generator : function() {
            return $5647400503806718$require$uuid();
        },
        version: typeof options.version !== 'undefined' ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === 'boolean' ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $5647400503806718$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $5647400503806718$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === 'function';
    if (this.options.version === 1 && isBatch) throw new TypeError('JSON-RPC 1.0 does not support batching');
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === 'object' && typeof params === 'function';
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === 'function') {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === 'function';
        try {
            request = $4kTUs(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) {
                callback(err);
                return;
            }
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        callback(err);
        return;
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $5647400503806718$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) {
        // empty response text, assume that is correct because it could be a
        // notification which jayson does not give any body for
        callback();
        return;
    }
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        callback(err);
        return;
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // necessary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== 'undefined';
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            callback(null, response.filter(isError), response.filter(isNotError));
            return;
        } else {
            // split regardless of validity
            callback(null, response.error, response.result);
            return;
        }
    }
    callback(null, response);
};

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.default)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0137947e8554ce$export$2e2bcd8739ae039);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("4kTUs", function(module, exports) {
'use strict';

var $5sKyw = parcelRequire("5sKyw");
var $3284662ae09c2cc1$require$uuid = $5sKyw.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $3284662ae09c2cc1$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== 'string') throw new TypeError(method + ' must be a string');
    options = options || {};
    // check valid version provided
    const version = typeof options.version === 'number' ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + ' must be 1 or 2');
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = '2.0';
    if (params) {
        // params given, but invalid?
        if (typeof params !== 'object' && !Array.isArray(params)) throw new TypeError(params + ' must be an object, array or omitted');
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === 'undefined') {
        const generator = typeof options.generator === 'function' ? options.generator : function() {
            return $3284662ae09c2cc1$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $3284662ae09c2cc1$var$generateRequest;

});


parcelRegister("ga6mf", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $c01611184c7492cd$export$3909fb301d3dc8c9);
$parcel$export(module.exports, "CommonClient", () => $c01611184c7492cd$export$b43a6d9568fa5272);

var $6ZWSX = parcelRequire("6ZWSX");
parcelRequire("1jgjz");
var $3vRz3 = parcelRequire("3vRz3");
// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $c01611184c7492cd$var$WebSocketBrowserImpl = class extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    socket;
    /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {WebSocketBrowserOptions} options - websocket options
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */ constructor(address, options){
        super();
        this.socket = new window.WebSocket(address, options.protocols);
        this.socket.onopen = ()=>this.emit("open");
        this.socket.onmessage = (event)=>this.emit("message", event.data);
        this.socket.onerror = (error)=>this.emit("error", error);
        this.socket.onclose = (event)=>{
            this.emit("close", event.code, event.reason);
        };
    }
    /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ send(data, optionsOrCallback, callback) {
        const cb = callback || optionsOrCallback;
        try {
            this.socket.send(data);
            cb();
        } catch (error) {
            cb(error);
        }
    }
    /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ close(code, reason) {
        this.socket.close(code, reason);
    }
    addEventListener(type, listener, options) {
        this.socket.addEventListener(type, listener, options);
    }
};
function $c01611184c7492cd$export$3909fb301d3dc8c9(address, options) {
    return new $c01611184c7492cd$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $c01611184c7492cd$export$9fd32f4b4353d82d = class {
    encode(value) {
        return JSON.stringify(value);
    }
    decode(value) {
        return JSON.parse(value);
    }
};
// src/lib/client.ts
var $c01611184c7492cd$export$b43a6d9568fa5272 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    address;
    rpc_id;
    queue;
    options;
    autoconnect;
    ready;
    reconnect;
    reconnect_timer_id;
    reconnect_interval;
    max_reconnects;
    rest_options;
    current_reconnects;
    generate_request_id;
    socket;
    webSocketFactory;
    dataPack;
    /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */ constructor(webSocketFactory, address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5, ...rest_options } = {}, generate_request_id, dataPack){
        super();
        this.webSocketFactory = webSocketFactory;
        this.queue = {};
        this.rpc_id = 0;
        this.address = address;
        this.autoconnect = autoconnect;
        this.ready = false;
        this.reconnect = reconnect;
        this.reconnect_timer_id = void 0;
        this.reconnect_interval = reconnect_interval;
        this.max_reconnects = max_reconnects;
        this.rest_options = rest_options;
        this.current_reconnects = 0;
        this.generate_request_id = generate_request_id || (()=>typeof this.rpc_id === "number" ? ++this.rpc_id : Number(this.rpc_id) + 1);
        if (!dataPack) this.dataPack = new $c01611184c7492cd$export$9fd32f4b4353d82d();
        else this.dataPack = dataPack;
        if (this.autoconnect) this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ connect() {
        if (this.socket) return;
        this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ call(method, params, timeout, ws_opts) {
        if (!ws_opts && "object" === typeof timeout) {
            ws_opts = timeout;
            timeout = null;
        }
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const rpc_id = this.generate_request_id(method, params);
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params || void 0,
                id: rpc_id
            };
            this.socket.send(this.dataPack.encode(message), ws_opts, (error)=>{
                if (error) return reject(error);
                this.queue[rpc_id] = {
                    promise: [
                        resolve,
                        reject
                    ]
                };
                if (timeout) this.queue[rpc_id].timeout = setTimeout(()=>{
                    delete this.queue[rpc_id];
                    reject(new Error("reply timeout"));
                }, timeout);
            });
        });
    }
    /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ async login(params) {
        const resp = await this.call("rpc.login", params);
        if (!resp) throw new Error("authentication failed");
        return resp;
    }
    /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ async listMethods() {
        return await this.call("__listMethods");
    }
    /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ notify(method, params) {
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params
            };
            this.socket.send(this.dataPack.encode(message), (error)=>{
                if (error) return reject(error);
                resolve();
            });
        });
    }
    /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async subscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.on", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
        return result;
    }
    /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async unsubscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.off", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
        return result;
    }
    /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ close(code, data) {
        if (this.socket) this.socket.close(code || 1e3, data);
    }
    /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ setAutoReconnect(reconnect) {
        this.reconnect = reconnect;
    }
    /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ setReconnectInterval(interval) {
        this.reconnect_interval = interval;
    }
    /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ setMaxReconnects(max_reconnects) {
        this.max_reconnects = max_reconnects;
    }
    /**
  * Get the current number of reconnection attempts made.
  * @method
  * @return {Number} current reconnection attempts
  */ getCurrentReconnects() {
        return this.current_reconnects;
    }
    /**
  * Get the maximum number of reconnection attempts.
  * @method
  * @return {Number} maximum reconnection attempts
  */ getMaxReconnects() {
        return this.max_reconnects;
    }
    /**
  * Check if the client is currently attempting to reconnect.
  * @method
  * @return {Boolean} true if reconnection is in progress
  */ isReconnecting() {
        return this.reconnect_timer_id !== void 0;
    }
    /**
  * Check if the client will attempt to reconnect on the next close event.
  * @method
  * @return {Boolean} true if reconnection will be attempted
  */ willReconnect() {
        return this.reconnect && (this.max_reconnects === 0 || this.current_reconnects < this.max_reconnects);
    }
    /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ _connect(address, options) {
        clearTimeout(this.reconnect_timer_id);
        this.socket = this.webSocketFactory(address, options);
        this.socket.addEventListener("open", ()=>{
            this.ready = true;
            this.emit("open");
            this.current_reconnects = 0;
        });
        this.socket.addEventListener("message", ({ data: message })=>{
            if (message instanceof ArrayBuffer) message = (0, $6ZWSX.Buffer).from(message).toString();
            try {
                message = this.dataPack.decode(message);
            } catch (_error) {
                return;
            }
            if (message.notification && this.listeners(message.notification).length) {
                if (!Object.keys(message.params).length) return this.emit(message.notification);
                const args = [
                    message.notification
                ];
                if (message.params.constructor === Object) args.push(message.params);
                else for(let i = 0; i < message.params.length; i++)args.push(message.params[i]);
                return Promise.resolve().then(()=>{
                    this.emit.apply(this, args);
                });
            }
            if (!this.queue[message.id]) {
                if (message.method) return Promise.resolve().then(()=>{
                    this.emit(message.method, message?.params);
                });
                return;
            }
            if ("error" in message === "result" in message) this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
            if (this.queue[message.id].timeout) clearTimeout(this.queue[message.id].timeout);
            if (message.error) this.queue[message.id].promise[1](message.error);
            else this.queue[message.id].promise[0](message.result);
            delete this.queue[message.id];
        });
        this.socket.addEventListener("error", (error)=>this.emit("error", error));
        this.socket.addEventListener("close", ({ code: code, reason: reason })=>{
            if (this.ready) setTimeout(()=>this.emit("close", code, reason), 0);
            this.ready = false;
            this.socket = void 0;
            if (code === 1e3) return;
            this.current_reconnects++;
            if (this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0)) this.reconnect_timer_id = setTimeout(()=>this._connect(address, options), this.reconnect_interval);
            else if (this.reconnect && this.max_reconnects > 0 && this.current_reconnects >= this.max_reconnects) setTimeout(()=>this.emit("max_reconnects_reached", code, reason), 1);
        });
    }
};
// src/index.browser.ts
var $c01611184c7492cd$export$1f2bb630327ac4b6 = class extends $c01611184c7492cd$export$b43a6d9568fa5272 {
    constructor(address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5, ...rest_options } = {}, generate_request_id){
        super($c01611184c7492cd$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects,
            ...rest_options
        }, generate_request_id);
    }
};
 //# sourceMappingURL=index.browser.mjs.map

});
parcelRegister("1jgjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $70aaa28ae275c84c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3vRz3")))));

var $3vRz3 = parcelRequire("3vRz3");
var $70aaa28ae275c84c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)));

});
parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});



parcelRegister("lk8ID", function(module, exports) {

$parcel$export(module.exports, "keccak_256", () => $f8623aa08548521b$export$860ddaa9ca84a66d);
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
var $eH71W = parcelRequire("eH71W");

var $aX27w = parcelRequire("aX27w");
// No __PURE__ annotations in sha3 header:
// EVERYTHING is in fact used on every export.
// Various per round constants calculations
const $f8623aa08548521b$var$_0n = BigInt(0);
const $f8623aa08548521b$var$_1n = BigInt(1);
const $f8623aa08548521b$var$_2n = BigInt(2);
const $f8623aa08548521b$var$_7n = BigInt(7);
const $f8623aa08548521b$var$_256n = BigInt(256);
const $f8623aa08548521b$var$_0x71n = BigInt(0x71);
const $f8623aa08548521b$var$SHA3_PI = [];
const $f8623aa08548521b$var$SHA3_ROTL = [];
const $f8623aa08548521b$var$_SHA3_IOTA = [];
for(let round = 0, R = $f8623aa08548521b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $f8623aa08548521b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $f8623aa08548521b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $f8623aa08548521b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $f8623aa08548521b$var$_1n ^ (R >> $f8623aa08548521b$var$_7n) * $f8623aa08548521b$var$_0x71n) % $f8623aa08548521b$var$_256n;
        if (R & $f8623aa08548521b$var$_2n) t ^= $f8623aa08548521b$var$_1n << ($f8623aa08548521b$var$_1n << /* @__PURE__ */ BigInt(j)) - $f8623aa08548521b$var$_1n;
    }
    $f8623aa08548521b$var$_SHA3_IOTA.push(t);
}
const $f8623aa08548521b$var$IOTAS = (0, $eH71W.split)($f8623aa08548521b$var$_SHA3_IOTA, true);
const $f8623aa08548521b$var$SHA3_IOTA_H = $f8623aa08548521b$var$IOTAS[0];
const $f8623aa08548521b$var$SHA3_IOTA_L = $f8623aa08548521b$var$IOTAS[1];
// Left rotation (without 0, 32, 64)
const $f8623aa08548521b$var$rotlH = (h, l, s)=>s > 32 ? (0, $eH71W.rotlBH)(h, l, s) : (0, $eH71W.rotlSH)(h, l, s);
const $f8623aa08548521b$var$rotlL = (h, l, s)=>s > 32 ? (0, $eH71W.rotlBL)(h, l, s) : (0, $eH71W.rotlSL)(h, l, s);
function $f8623aa08548521b$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $f8623aa08548521b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $f8623aa08548521b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $f8623aa08548521b$var$SHA3_ROTL[t];
            const Th = $f8623aa08548521b$var$rotlH(curH, curL, shift);
            const Tl = $f8623aa08548521b$var$rotlL(curH, curL, shift);
            const PI = $f8623aa08548521b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $f8623aa08548521b$var$SHA3_IOTA_H[round];
        s[1] ^= $f8623aa08548521b$var$SHA3_IOTA_L[round];
    }
    (0, $aX27w.clean)(B);
}
class $f8623aa08548521b$export$f7374b8b4498bc2e extends (0, $aX27w.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        this.enableXOF = false;
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        // Can be passed from user as dkLen
        (0, $aX27w.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (!(0 < blockLen && blockLen < 200)) throw new Error('only keccak-f1600 function is supported');
        this.state = new Uint8Array(200);
        this.state32 = (0, $aX27w.u32)(this.state);
    }
    clone() {
        return this._cloneInto();
    }
    keccak() {
        (0, $aX27w.swap32IfBE)(this.state32);
        $f8623aa08548521b$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        (0, $aX27w.swap32IfBE)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $aX27w.aexists)(this);
        data = (0, $aX27w.toBytes)(data);
        (0, $aX27w.abytes)(data);
        const { blockLen: blockLen, state: state } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $aX27w.aexists)(this, false);
        (0, $aX27w.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $aX27w.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $aX27w.aoutput)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        (0, $aX27w.clean)(this.state);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $f8623aa08548521b$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $f8623aa08548521b$var$gen = (suffix, blockLen, outputLen)=>(0, $aX27w.createHasher)(()=>new $f8623aa08548521b$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $f8623aa08548521b$export$fe6c2b96a79338e9 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x06, 144, 28))();
const $f8623aa08548521b$export$76e19b6966813b14 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x06, 136, 32))();
const $f8623aa08548521b$export$a58509fa80f30d15 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x06, 104, 48))();
const $f8623aa08548521b$export$20ed324dbdf09b7c = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x06, 72, 64))();
const $f8623aa08548521b$export$2f7fb3c6fac246bc = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x01, 144, 28))();
const $f8623aa08548521b$export$860ddaa9ca84a66d = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x01, 136, 32))();
const $f8623aa08548521b$export$46fcdeb4c5686552 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x01, 104, 48))();
const $f8623aa08548521b$export$aec1ddaf6c1ba495 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$gen(0x01, 72, 64))();
const $f8623aa08548521b$var$genShake = (suffix, blockLen, outputLen)=>(0, $aX27w.createXOFer)((opts = {})=>new $f8623aa08548521b$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $f8623aa08548521b$export$f43dc3bb86efbba2 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$genShake(0x1f, 168, 16))();
const $f8623aa08548521b$export$c240d011f1520440 = /* @__PURE__ */ (()=>$f8623aa08548521b$var$genShake(0x1f, 136, 32))();

});

parcelRegister("4hazQ", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $31d0f45e263a2bb2$export$529e6123e9353a90);
/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $93IJ3 = parcelRequire("93IJ3");

var $aX27w = parcelRequire("aX27w");

var $fQ5mI = parcelRequire("fQ5mI");

var $jRTZM = parcelRequire("jRTZM");

var $f8jNy = parcelRequire("f8jNy");

var $kWjYw = parcelRequire("kWjYw");

var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
var $aX27w = parcelRequire("aX27w");
// Seems like generator was produced from some seed:
// `Point.BASE.multiply(Point.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const $31d0f45e263a2bb2$var$secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')
};
const $31d0f45e263a2bb2$var$secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [
            BigInt('0x3086d221a7d46bcde86c90e49284eb15'),
            -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')
        ],
        [
            BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'),
            BigInt('0x3086d221a7d46bcde86c90e49284eb15')
        ]
    ]
};
const $31d0f45e263a2bb2$var$_0n = /* @__PURE__ */ BigInt(0);
const $31d0f45e263a2bb2$var$_1n = /* @__PURE__ */ BigInt(1);
const $31d0f45e263a2bb2$var$_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $31d0f45e263a2bb2$var$sqrtMod(y) {
    const P = $31d0f45e263a2bb2$var$secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $f8jNy.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $f8jNy.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $f8jNy.pow2)(b9, $31d0f45e263a2bb2$var$_2n, P) * b2 % P;
    const b22 = (0, $f8jNy.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $f8jNy.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $f8jNy.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $f8jNy.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $f8jNy.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $f8jNy.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $f8jNy.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $f8jNy.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $f8jNy.pow2)(t2, $31d0f45e263a2bb2$var$_2n, P);
    if (!$31d0f45e263a2bb2$var$Fpk1.eql($31d0f45e263a2bb2$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $31d0f45e263a2bb2$var$Fpk1 = (0, $f8jNy.Field)($31d0f45e263a2bb2$var$secp256k1_CURVE.p, {
    sqrt: $31d0f45e263a2bb2$var$sqrtMod
});
const $31d0f45e263a2bb2$export$529e6123e9353a90 = (0, $fQ5mI.createCurve)({
    ...$31d0f45e263a2bb2$var$secp256k1_CURVE,
    Fp: $31d0f45e263a2bb2$var$Fpk1,
    lowS: true,
    endo: $31d0f45e263a2bb2$var$secp256k1_ENDO
}, (0, $93IJ3.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $31d0f45e263a2bb2$var$TAGGED_HASH_PREFIXES = {};
function $31d0f45e263a2bb2$var$taggedHash(tag, ...messages) {
    let tagP = $31d0f45e263a2bb2$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $93IJ3.sha256)((0, $aX27w.utf8ToBytes)(tag));
        tagP = (0, $aX27w.concatBytes)(tagH, tagH);
        $31d0f45e263a2bb2$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $93IJ3.sha256)((0, $aX27w.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $31d0f45e263a2bb2$var$pointToBytes = (point)=>point.toBytes(true).slice(1);
const $31d0f45e263a2bb2$var$Pointk1 = /* @__PURE__ */ (()=>$31d0f45e263a2bb2$export$529e6123e9353a90.Point)();
const $31d0f45e263a2bb2$var$hasEven = (y)=>y % $31d0f45e263a2bb2$var$_2n === $31d0f45e263a2bb2$var$_0n;
// Calculate point, scalar and bytes
function $31d0f45e263a2bb2$var$schnorrGetExtPubKey(priv) {
    const { Fn: Fn, BASE: BASE } = $31d0f45e263a2bb2$var$Pointk1;
    const d_ = (0, $kWjYw._normFnElement)(Fn, priv);
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = $31d0f45e263a2bb2$var$hasEven(p.y) ? d_ : Fn.neg(d_);
    return {
        scalar: scalar,
        bytes: $31d0f45e263a2bb2$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $31d0f45e263a2bb2$var$lift_x(x) {
    const Fp = $31d0f45e263a2bb2$var$Fpk1;
    if (!Fp.isValidNot0(x)) throw new Error("invalid x: Fail if x \u2265 p");
    const xx = Fp.create(x * x);
    const c = Fp.create(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!$31d0f45e263a2bb2$var$hasEven(y)) y = Fp.neg(y);
    const p = $31d0f45e263a2bb2$var$Pointk1.fromAffine({
        x: x,
        y: y
    });
    p.assertValidity();
    return p;
}
const $31d0f45e263a2bb2$var$num = (0, $3TGEu.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $31d0f45e263a2bb2$var$challenge(...args) {
    return $31d0f45e263a2bb2$var$Pointk1.Fn.create($31d0f45e263a2bb2$var$num($31d0f45e263a2bb2$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $31d0f45e263a2bb2$var$schnorrGetPublicKey(secretKey) {
    return $31d0f45e263a2bb2$var$schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $31d0f45e263a2bb2$var$schnorrSign(message, secretKey, auxRand = (0, $aX27w.randomBytes)(32)) {
    const { Fn: Fn } = $31d0f45e263a2bb2$var$Pointk1;
    const m = (0, $3TGEu.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = $31d0f45e263a2bb2$var$schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = (0, $3TGEu.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = Fn.toBytes(d ^ $31d0f45e263a2bb2$var$num($31d0f45e263a2bb2$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $31d0f45e263a2bb2$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G
    const { bytes: rx, scalar: k } = $31d0f45e263a2bb2$var$schnorrGetExtPubKey(rand);
    const e = $31d0f45e263a2bb2$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$31d0f45e263a2bb2$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $31d0f45e263a2bb2$var$schnorrVerify(signature, message, publicKey) {
    const { Fn: Fn, BASE: BASE } = $31d0f45e263a2bb2$var$Pointk1;
    const sig = (0, $3TGEu.ensureBytes)('signature', signature, 64);
    const m = (0, $3TGEu.ensureBytes)('message', message);
    const pub = (0, $3TGEu.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = $31d0f45e263a2bb2$var$lift_x($31d0f45e263a2bb2$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $31d0f45e263a2bb2$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $3TGEu.inRange)(r, $31d0f45e263a2bb2$var$_1n, $31d0f45e263a2bb2$var$secp256k1_CURVE.p)) return false;
        const s = $31d0f45e263a2bb2$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $3TGEu.inRange)(s, $31d0f45e263a2bb2$var$_1n, $31d0f45e263a2bb2$var$secp256k1_CURVE.n)) return false;
        // int(challenge(bytes(r)||bytes(P)||m))%n
        const e = $31d0f45e263a2bb2$var$challenge(Fn.toBytes(r), $31d0f45e263a2bb2$var$pointToBytes(P), m);
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.multiplyUnsafe(s).add(P.multiplyUnsafe(Fn.neg(e)));
        const { x: x, y: y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !$31d0f45e263a2bb2$var$hasEven(y) || x !== r) return false;
        return true;
    } catch (error) {
        return false;
    }
}
const $31d0f45e263a2bb2$export$1f2401df071be9f = /* @__PURE__ */ (()=>{
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed = (0, $aX27w.randomBytes)(seedLength))=>{
        return (0, $f8jNy.mapHashToField)(seed, $31d0f45e263a2bb2$var$secp256k1_CURVE.n);
    };
    // TODO: remove
    $31d0f45e263a2bb2$export$529e6123e9353a90.utils.randomSecretKey;
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: $31d0f45e263a2bb2$var$schnorrGetPublicKey(secretKey)
        };
    }
    return {
        keygen: keygen,
        getPublicKey: $31d0f45e263a2bb2$var$schnorrGetPublicKey,
        sign: $31d0f45e263a2bb2$var$schnorrSign,
        verify: $31d0f45e263a2bb2$var$schnorrVerify,
        Point: $31d0f45e263a2bb2$var$Pointk1,
        utils: {
            randomSecretKey: randomSecretKey,
            randomPrivateKey: randomSecretKey,
            taggedHash: $31d0f45e263a2bb2$var$taggedHash,
            lift_x: // TODO: remove
            $31d0f45e263a2bb2$var$lift_x,
            pointToBytes: $31d0f45e263a2bb2$var$pointToBytes,
            numberToBytesBE: $3TGEu.numberToBytesBE,
            bytesToNumberBE: $3TGEu.bytesToNumberBE,
            mod: $f8jNy.mod
        },
        lengths: {
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength
        }
    };
})();
const $31d0f45e263a2bb2$var$isoMap = /* @__PURE__ */ (()=>(0, $jRTZM.isogenyMap)($31d0f45e263a2bb2$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $31d0f45e263a2bb2$var$mapSWU = /* @__PURE__ */ (()=>(0, $kWjYw.mapToCurveSimpleSWU)($31d0f45e263a2bb2$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $31d0f45e263a2bb2$var$Fpk1.create(BigInt('-11'))
    }))();
const $31d0f45e263a2bb2$export$e7a33585c78e532a = /* @__PURE__ */ (()=>(0, $jRTZM.createHasher)($31d0f45e263a2bb2$export$529e6123e9353a90.Point, (scalars)=>{
        const { x: x, y: y } = $31d0f45e263a2bb2$var$mapSWU($31d0f45e263a2bb2$var$Fpk1.create(scalars[0]));
        return $31d0f45e263a2bb2$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $31d0f45e263a2bb2$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $93IJ3.sha256)
    }))();
const $31d0f45e263a2bb2$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$31d0f45e263a2bb2$export$e7a33585c78e532a.hashToCurve)();
const $31d0f45e263a2bb2$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$31d0f45e263a2bb2$export$e7a33585c78e532a.encodeToCurve)();

});
parcelRegister("fQ5mI", function(module, exports) {

$parcel$export(module.exports, "createCurve", () => $b87fdfc5bec8aa51$export$3f2f6721dd02558a);
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $kWjYw = parcelRequire("kWjYw");
function $b87fdfc5bec8aa51$export$adaba664e531641c(hash) {
    return {
        hash: hash
    };
}
function $b87fdfc5bec8aa51$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $kWjYw.weierstrass)({
            ...curveDef,
            hash: hash
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("kWjYw", function(module, exports) {

$parcel$export(module.exports, "_normFnElement", () => $f3e8b812bfa912c0$export$e10a6dd187c1fa22);
$parcel$export(module.exports, "mapToCurveSimpleSWU", () => $f3e8b812bfa912c0$export$cc7fea9756a17416);
$parcel$export(module.exports, "weierstrass", () => $f3e8b812bfa912c0$export$350b8ea6f1c27fae);
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $kyUE9 = parcelRequire("kyUE9");

var $aX27w = parcelRequire("aX27w");

var $3TGEu = parcelRequire("3TGEu");
var $aX27w = parcelRequire("aX27w");
var $aX27w = parcelRequire("aX27w");

var $gaxAZ = parcelRequire("gaxAZ");

var $f8jNy = parcelRequire("f8jNy");
// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const $f3e8b812bfa912c0$var$divNearest = (num, den)=>(num + (num >= 0 ? den : -den) / $f3e8b812bfa912c0$var$_2n) / den;
function $f3e8b812bfa912c0$export$2e78c1c514ef8576(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = $f3e8b812bfa912c0$var$divNearest(b2 * k, n);
    const c2 = $f3e8b812bfa912c0$var$divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < $f3e8b812bfa912c0$var$_0n;
    const k2neg = k2 < $f3e8b812bfa912c0$var$_0n;
    if (k1neg) k1 = -k1;
    if (k2neg) k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = (0, $3TGEu.bitMask)(Math.ceil((0, $3TGEu.bitLen)(n) / 2)) + $f3e8b812bfa912c0$var$_1n; // Half bits of N
    if (k1 < $f3e8b812bfa912c0$var$_0n || k1 >= MAX_NUM || k2 < $f3e8b812bfa912c0$var$_0n || k2 >= MAX_NUM) throw new Error('splitScalar (endomorphism): failed, k=' + k);
    return {
        k1neg: k1neg,
        k1: k1,
        k2neg: k2neg,
        k2: k2
    };
}
function $f3e8b812bfa912c0$var$validateSigFormat(format) {
    if (![
        'compact',
        'recovered',
        'der'
    ].includes(format)) throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function $f3e8b812bfa912c0$var$validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def))// @ts-ignore
    optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    (0, $3TGEu._abool2)(optsn.lowS, 'lowS');
    (0, $3TGEu._abool2)(optsn.prehash, 'prehash');
    if (optsn.format !== undefined) $f3e8b812bfa912c0$var$validateSigFormat(optsn.format);
    return optsn;
}
class $f3e8b812bfa912c0$export$523a36accd0afb37 extends Error {
    constructor(m = ''){
        super(m);
    }
}
const $f3e8b812bfa912c0$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: $f3e8b812bfa912c0$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $f3e8b812bfa912c0$export$56ac33195d7076db;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, $3TGEu.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $3TGEu.numberToHexUnpadded)(len.length / 2 | 128) : '';
            const t = (0, $3TGEu.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $f3e8b812bfa912c0$export$56ac33195d7076db;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $f3e8b812bfa912c0$export$56ac33195d7076db;
            if (num < $f3e8b812bfa912c0$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, $3TGEu.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = $f3e8b812bfa912c0$export$56ac33195d7076db;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, $3TGEu.bytesToNumberBE)(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $f3e8b812bfa912c0$export$56ac33195d7076db;
        const data = (0, $3TGEu.ensureBytes)('signature', hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $f3e8b812bfa912c0$export$56ac33195d7076db;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $f3e8b812bfa912c0$var$_0n = BigInt(0), $f3e8b812bfa912c0$var$_1n = BigInt(1), $f3e8b812bfa912c0$var$_2n = BigInt(2), $f3e8b812bfa912c0$var$_3n = BigInt(3), $f3e8b812bfa912c0$var$_4n = BigInt(4);
function $f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, key) {
    const { BYTES: expected } = Fn;
    let num;
    if (typeof key === 'bigint') num = key;
    else {
        let bytes = (0, $3TGEu.ensureBytes)('private key', key);
        try {
            num = Fn.fromBytes(bytes);
        } catch (error) {
            throw new Error(`invalid private key: expected ui8a of size ${expected}, got ${typeof key}`);
        }
    }
    if (!Fn.isValidNot0(num)) throw new Error('invalid private key: out of range [1..N-1]');
    return num;
}
function $f3e8b812bfa912c0$export$66856fb9690920c4(params, extraOpts = {}) {
    const validated = (0, $gaxAZ._createCurveFields)('weierstrass', params, extraOpts);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    (0, $3TGEu._validateObject)(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
        wrapPrivateKey: 'boolean'
    });
    const { endo: endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) throw new Error('invalid endo: expected "beta": bigint and "basises": array');
    }
    const lengths = $f3e8b812bfa912c0$var$getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd) throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x: x, y: y } = point.toAffine();
        const bx = Fp.toBytes(x);
        (0, $3TGEu._abool2)(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return (0, $aX27w.concatBytes)($f3e8b812bfa912c0$var$pprefix(hasEvenY), bx);
        } else return (0, $aX27w.concatBytes)(Uint8Array.of(0x04), bx, Fp.toBytes(y));
    }
    function pointFromBytes(bytes) {
        (0, $3TGEu._abytes2)(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x)) throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            } catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const isYOdd = Fp.isOdd(y); // (y & _1n) === _1n;
            const isHeadOdd = (head & 1) === 1; // ECDSA-specific
            if (isHeadOdd !== isYOdd) y = Fp.neg(y);
            return {
                x: x,
                y: y
            };
        } else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y)) throw new Error('bad point: is not on curve');
            return {
                x: x,
                y: y
            };
        } else throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */ function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $f3e8b812bfa912c0$var$_3n), $f3e8b812bfa912c0$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */ function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || banZero && Fp.is0(n)) throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises) throw new Error('no endo');
        return $f3e8b812bfa912c0$export$2e78c1c514ef8576(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = (0, $3TGEu.memoized)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE)) return {
            x: X,
            y: Y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $3TGEu.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = (0, $gaxAZ.negateCt)(k1neg, k1p);
        k2p = (0, $gaxAZ.negateCt)(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ constructor(X, Y, Z){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint((0, $3TGEu._abytes2)(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes((0, $3TGEu.ensureBytes)('pointHex', hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */ precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($f3e8b812bfa912c0$var$_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */ assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */ equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */ negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $f3e8b812bfa912c0$var$_3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $f3e8b812bfa912c0$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo } = extraOpts;
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n)=>wnaf.cached(this, n, (p)=>(0, $gaxAZ.normalizeZ)(Point, p));
            /** See docs for {@link EndomorphismOpts} */ if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            } else {
                const { p: p, f: f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return (0, $gaxAZ.normalizeZ)(Point, [
                point,
                fake
            ])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc)) throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === $f3e8b812bfa912c0$var$_0n || p.is0()) return Point.ZERO;
            if (sc === $f3e8b812bfa912c0$var$_1n) return p; // fast-path
            if (wnaf.hasCache(this)) return this.multiply(sc);
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(sc);
                const { p1: p1, p2: p2 } = (0, $gaxAZ.mulEndoUnsafe)(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            } else return wnaf.unsafe(p, sc);
        }
        multiplyAndAddUnsafe(Q, a, b) {
            const sum = this.multiplyUnsafe(a).add(Q.multiplyUnsafe(b));
            return sum.is0() ? undefined : sum;
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */ toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */ isTorsionFree() {
            const { isTorsionFree: isTorsionFree } = extraOpts;
            if (cofactor === $f3e8b812bfa912c0$var$_1n) return true;
            if (isTorsionFree) return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor: clearCofactor } = extraOpts;
            if (cofactor === $f3e8b812bfa912c0$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            (0, $3TGEu._abool2)(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return (0, $aX27w.bytesToHex)(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get px() {
            return this.X;
        }
        get py() {
            return this.X;
        }
        get pz() {
            return this.Z;
        }
        toRawBytes(isCompressed = true) {
            return this.toBytes(isCompressed);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        static normalizeZ(points) {
            return (0, $gaxAZ.normalizeZ)(Point, points);
        }
        static msm(points, scalars) {
            return (0, $gaxAZ.pippenger)(Point, Fn, points, scalars);
        }
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply($f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, privateKey));
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    // zero / infinity / identity point
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const bits = Fn.BITS;
    const wnaf = new (0, $gaxAZ.wNAF)(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function $f3e8b812bfa912c0$var$pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
function $f3e8b812bfa912c0$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $f3e8b812bfa912c0$var$_0n;
    for(let o = q - $f3e8b812bfa912c0$var$_1n; o % $f3e8b812bfa912c0$var$_2n === $f3e8b812bfa912c0$var$_0n; o /= $f3e8b812bfa912c0$var$_2n)l += $f3e8b812bfa912c0$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $f3e8b812bfa912c0$var$_2n << c1 - $f3e8b812bfa912c0$var$_1n - $f3e8b812bfa912c0$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $f3e8b812bfa912c0$var$_2n;
    const c2 = (q - $f3e8b812bfa912c0$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $f3e8b812bfa912c0$var$_1n) / $f3e8b812bfa912c0$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $f3e8b812bfa912c0$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $f3e8b812bfa912c0$var$_1n) / $f3e8b812bfa912c0$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $f3e8b812bfa912c0$var$_1n; i--){
            let tv5 = i - $f3e8b812bfa912c0$var$_2n; // 18.    tv5 = i - 2
            tv5 = $f3e8b812bfa912c0$var$_2n << tv5 - $f3e8b812bfa912c0$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $f3e8b812bfa912c0$var$_4n === $f3e8b812bfa912c0$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $f3e8b812bfa912c0$var$_3n) / $f3e8b812bfa912c0$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $f3e8b812bfa912c0$export$cc7fea9756a17416(Fp, opts) {
    (0, $f8jNy.validateField)(Fp);
    const { A: A, B: B, Z: Z } = opts;
    if (!Fp.isValid(A) || !Fp.isValid(B) || !Fp.isValid(Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $f3e8b812bfa912c0$export$8324ae9483e33241(Fp, Z);
    if (!Fp.isOdd) throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $f8jNy.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
function $f3e8b812bfa912c0$var$getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES
    };
}
function $f3e8b812bfa912c0$export$cb44b25bcf287f5d(Point, ecdhOpts = {}) {
    const { Fn: Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || (0, $aX27w.randomBytes);
    const lengths = Object.assign($f3e8b812bfa912c0$var$getWLengths(Point.Fp, Fn), {
        seed: (0, $f8jNy.getMinHashLength)(Fn.ORDER)
    });
    function isValidSecretKey(secretKey) {
        try {
            return !!$f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, secretKey);
        } catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp) return false;
            if (isCompressed === false && l !== publicKeyUncompressed) return false;
            return !!Point.fromBytes(publicKey);
        } catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return (0, $f8jNy.mapHashToField)((0, $3TGEu._abytes2)(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply($f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, secretKey)).toBytes(isCompressed);
    }
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        if (typeof item === 'bigint') return false;
        if (item instanceof Point) return true;
        const { secretKey: secretKey, publicKey: publicKey, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        if (Fn.allowedLengths || secretKey === publicKey) return undefined;
        const l = (0, $3TGEu.ensureBytes)('key', item).length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true) throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false) throw new Error('second arg must be public key');
        const s = $f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, secretKeyA);
        const b = Point.fromHex(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        randomSecretKey: randomSecretKey,
        // TODO: remove
        isValidPrivateKey: isValidSecretKey,
        randomPrivateKey: randomSecretKey,
        normPrivateKeyToScalar: (key)=>$f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, key),
        precompute (windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        }
    };
    return Object.freeze({
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        keygen: keygen,
        Point: Point,
        utils: utils,
        lengths: lengths
    });
}
function $f3e8b812bfa912c0$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts = {}) {
    (0, $aX27w.ahash)(hash);
    (0, $3TGEu._validateObject)(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function'
    });
    const randomBytes = ecdsaOpts.randomBytes || (0, $aX27w.randomBytes);
    const hmac = ecdsaOpts.hmac || ((key, ...msgs)=>(0, $kyUE9.hmac)(hash, key, (0, $aX27w.concatBytes)(...msgs)));
    const { Fp: Fp, Fn: Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen: keygen, getPublicKey: getPublicKey, getSharedSecret: getSharedSecret, utils: utils, lengths: lengths } = $f3e8b812bfa912c0$export$cb44b25bcf287f5d(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: false,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : false,
        format: undefined,
        extraEntropy: false
    };
    const defaultSigOpts_format = 'compact';
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $f3e8b812bfa912c0$var$_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num)) throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function validateSigLength(bytes, format) {
        $f3e8b812bfa912c0$var$validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return (0, $3TGEu._abytes2)(bytes, sizer, `${format} signature`);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) this.recovery = recovery;
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts_format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r: r, s: s } = $f3e8b812bfa912c0$export$56ac33195d7076db.toSig((0, $3TGEu._abytes2)(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = Fn.BYTES;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes((0, $aX27w.hexToBytes)(hex), format);
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const FIELD_ORDER = Fp.ORDER;
            const { r: r, s: s, recovery: rec } = this;
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            // ECDSA recovery is hard for cofactor > 1 curves.
            // In sign, `r = q.x mod n`, and here we recover q.x from r.
            // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
            // However, for cofactor>1, r+n may not get q.x:
            // r+n*i would need to be done instead where i is unknown.
            // To easily get i, we either need to:
            // a. increase amount of valid recid values (4, 5...); OR
            // b. prohibit non-prime-order signatures (recid > 1).
            const hasCofactor = CURVE_ORDER * $f3e8b812bfa912c0$var$_2n < FIELD_ORDER;
            if (hasCofactor && rec > 1) throw new Error('recovery id is ambiguous for h>1 curve');
            const radj = rec === 2 || rec === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj)) throw new Error('recovery id 2 or 3 invalid');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes((0, $aX27w.concatBytes)($f3e8b812bfa912c0$var$pprefix((rec & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN((0, $3TGEu.ensureBytes)('msgHash', messageHash)); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0()) throw new Error('point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts_format) {
            $f3e8b812bfa912c0$var$validateSigFormat(format);
            if (format === 'der') return (0, $aX27w.hexToBytes)($f3e8b812bfa912c0$export$56ac33195d7076db.hexFromSig(this));
            const r = Fn.toBytes(this.r);
            const s = Fn.toBytes(this.s);
            if (format === 'recovered') {
                if (this.recovery == null) throw new Error('recovery bit must be present');
                return (0, $aX27w.concatBytes)(Uint8Array.of(this.recovery), r, s);
            }
            return (0, $aX27w.concatBytes)(r, s);
        }
        toHex(format) {
            return (0, $aX27w.bytesToHex)(this.toBytes(format));
        }
        // TODO: remove
        assertValidity() {}
        static fromCompact(hex) {
            return Signature.fromBytes((0, $3TGEu.ensureBytes)('sig', hex), 'compact');
        }
        static fromDER(hex) {
            return Signature.fromBytes((0, $3TGEu.ensureBytes)('sig', hex), 'der');
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, Fn.neg(this.s), this.recovery) : this;
        }
        toDERRawBytes() {
            return this.toBytes('der');
        }
        toDERHex() {
            return (0, $aX27w.bytesToHex)(this.toBytes('der'));
        }
        toCompactRawBytes() {
            return this.toBytes('compact');
        }
        toCompactHex() {
            return (0, $aX27w.bytesToHex)(this.toBytes('compact'));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int || function bits2int_def(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $3TGEu.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = ecdsaOpts.bits2int_modN || function bits2int_modN_def(bytes) {
        return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // Pads output with zero as per spec
    const ORDER_MASK = (0, $3TGEu.bitMask)(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */ function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        (0, $3TGEu.aInRange)('num < 2^' + fnBits, num, $f3e8b812bfa912c0$var$_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        (0, $3TGEu._abytes2)(message, undefined, 'message');
        return prehash ? (0, $3TGEu._abytes2)(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */ function prepSig(message, privateKey, opts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { lowS: lowS, prehash: prehash, extraEntropy: extraEntropy } = $f3e8b812bfa912c0$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = $f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, privateKey); // validate secret key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push((0, $3TGEu.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = (0, $aX27w.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // mod n, not mod p
            if (!Fn.isValidNot0(k)) return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === $f3e8b812bfa912c0$var$_0n) return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // Not using blinding here, see comment above
            if (s === $f3e8b812bfa912c0$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $f3e8b812bfa912c0$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */ function sign(message, secretKey, opts = {}) {
        message = (0, $3TGEu.ensureBytes)('message', message);
        const { seed: seed, k2sig: k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = (0, $3TGEu.createHmacDrbg)(hash.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig;
    }
    function tryParsingSig(sg) {
        // Try to deduce format
        let sig = undefined;
        const isHex = typeof sg === 'string' || (0, $aX27w.isBytes)(sg);
        const isObj = !isHex && sg !== null && typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        if (isObj) sig = new Signature(sg.r, sg.s);
        else if (isHex) {
            try {
                sig = Signature.fromBytes((0, $3TGEu.ensureBytes)('sig', sg), 'der');
            } catch (derError) {
                if (!(derError instanceof $f3e8b812bfa912c0$export$56ac33195d7076db.Err)) throw derError;
            }
            if (!sig) try {
                sig = Signature.fromBytes((0, $3TGEu.ensureBytes)('sig', sg), 'compact');
            } catch (error) {
                return false;
            }
        }
        if (!sig) return false;
        return sig;
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, message, publicKey, opts = {}) {
        const { lowS: lowS, prehash: prehash, format: format } = $f3e8b812bfa912c0$var$validateSigOpts(opts, defaultSigOpts);
        publicKey = (0, $3TGEu.ensureBytes)('publicKey', publicKey);
        message = validateMsgAndHash((0, $3TGEu.ensureBytes)('message', message), prehash);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        const sig = format === undefined ? tryParsingSig(signature) : Signature.fromBytes((0, $3TGEu.ensureBytes)('sig', signature), format);
        if (sig === false) return false;
        try {
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS()) return false;
            const { r: r, s: s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0()) return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        } catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash: prehash } = $f3e8b812bfa912c0$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        utils: utils,
        lengths: lengths,
        Point: Point,
        sign: sign,
        verify: verify,
        recoverPublicKey: recoverPublicKey,
        Signature: Signature,
        hash: hash
    });
}
function $f3e8b812bfa912c0$export$fa783af82e4fe0fc(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $f3e8b812bfa912c0$var$_weierstrass_legacy_opts_to_new(c);
    const Point = $f3e8b812bfa912c0$export$66856fb9690920c4(CURVE, curveOpts);
    return $f3e8b812bfa912c0$var$_weierstrass_new_output_to_legacy(c, Point);
}
function $f3e8b812bfa912c0$var$_weierstrass_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        b: c.b,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy
    };
    const Fp = c.Fp;
    let allowedLengths = c.allowedPrivateKeyLengths ? Array.from(new Set(c.allowedPrivateKeyLengths.map((l)=>Math.ceil(l / 2)))) : undefined;
    const Fn = (0, $f8jNy.Field)(CURVE.n, {
        BITS: c.nBitLength,
        allowedLengths: allowedLengths,
        modFromBytes: c.wrapPrivateKey
    });
    const curveOpts = {
        Fp: Fp,
        Fn: Fn,
        allowInfinityPoint: c.allowInfinityPoint,
        endo: c.endo,
        isTorsionFree: c.isTorsionFree,
        clearCofactor: c.clearCofactor,
        fromBytes: c.fromBytes,
        toBytes: c.toBytes
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts
    };
}
function $f3e8b812bfa912c0$var$_ecdsa_legacy_opts_to_new(c) {
    const { CURVE: CURVE, curveOpts: curveOpts } = $f3e8b812bfa912c0$var$_weierstrass_legacy_opts_to_new(c);
    const ecdsaOpts = {
        hmac: c.hmac,
        randomBytes: c.randomBytes,
        lowS: c.lowS,
        bits2int: c.bits2int,
        bits2int_modN: c.bits2int_modN
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts,
        hash: c.hash,
        ecdsaOpts: ecdsaOpts
    };
}
function $f3e8b812bfa912c0$export$69061cf37a03f1(Fp, a, b) {
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula. Takes x, returns y².
     * @returns y²
     */ function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x³ + a * x + b
    }
    return weierstrassEquation;
}
function $f3e8b812bfa912c0$var$_weierstrass_new_output_to_legacy(c, Point) {
    const { Fp: Fp, Fn: Fn } = Point;
    function isWithinCurveOrder(num) {
        return (0, $3TGEu.inRange)(num, $f3e8b812bfa912c0$var$_1n, Fn.ORDER);
    }
    const weierstrassEquation = $f3e8b812bfa912c0$export$69061cf37a03f1(Fp, c.a, c.b);
    return Object.assign({}, {
        CURVE: c,
        Point: Point,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: (key)=>$f3e8b812bfa912c0$export$e10a6dd187c1fa22(Fn, key),
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    });
}
function $f3e8b812bfa912c0$var$_ecdsa_new_output_to_legacy(c, _ecdsa) {
    const Point = _ecdsa.Point;
    return Object.assign({}, _ecdsa, {
        ProjectivePoint: Point,
        CURVE: Object.assign({}, c, (0, $f8jNy.nLength)(Point.Fn.ORDER, Point.Fn.BITS))
    });
}
function $f3e8b812bfa912c0$export$350b8ea6f1c27fae(c) {
    const { CURVE: CURVE, curveOpts: curveOpts, hash: hash, ecdsaOpts: ecdsaOpts } = $f3e8b812bfa912c0$var$_ecdsa_legacy_opts_to_new(c);
    const Point = $f3e8b812bfa912c0$export$66856fb9690920c4(CURVE, curveOpts);
    const signs = $f3e8b812bfa912c0$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts);
    return $f3e8b812bfa912c0$var$_ecdsa_new_output_to_legacy(c, signs);
}

});
parcelRegister("kyUE9", function(module, exports) {

$parcel$export(module.exports, "hmac", () => $ef82ec7274293ecc$export$355af40f8ab02f34);
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
var $aX27w = parcelRequire("aX27w");
class $ef82ec7274293ecc$export$7b9cf41ebec74f45 extends (0, $aX27w.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $aX27w.ahash)(hash);
        const key = (0, $aX27w.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $aX27w.clean)(pad);
    }
    update(buf) {
        (0, $aX27w.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $aX27w.aexists)(this);
        (0, $aX27w.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $ef82ec7274293ecc$export$355af40f8ab02f34 = (hash, key, message)=>new $ef82ec7274293ecc$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$ef82ec7274293ecc$export$355af40f8ab02f34.create = (hash, key)=>new $ef82ec7274293ecc$export$7b9cf41ebec74f45(hash, key);

});





parcelRegister("R5nvG", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("ebfZx", function(module, exports) {
module.exports = import("avSDn").then(()=>parcelRequire('88wHM'));

});

parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});


var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $acw62 = parcelRequire("acw62");

function $98110fe2c21af7aa$export$6d3a98bdec8985cb(pathname) {
    const { search: search } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    return (0, $acw62.useMemo)(()=>({
            pathname: pathname,
            search: search
        }), [
        pathname,
        search
    ]);
}



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $9c00ffc6a7ba2f4f$export$999f810846f9d31d = /*#__PURE__*/ function(PaymentStatus) {
    PaymentStatus["New"] = "New";
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Confirmed"] = "Confirmed";
    PaymentStatus["Valid"] = "Valid";
    PaymentStatus["Invalid"] = "Invalid";
    PaymentStatus["Finalized"] = "Finalized";
    return PaymentStatus;
}({});
const $9c00ffc6a7ba2f4f$export$d46d0749977ea231 = (0, $acw62.createContext)({});
function $9c00ffc6a7ba2f4f$export$68637662b7cd615c() {
    return (0, $acw62.useContext)($9c00ffc6a7ba2f4f$export$d46d0749977ea231);
}



parcelRequire("acw62");

parcelRequire("acw62");
const $84fee2cbb0ee7f10$export$1c641004b5485fed = ({ width: width = 20, height: height = 20 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m15 18-6-6 6-6",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};


var $18b937262e407146$export$2ba01fb71ed41cb6;
$18b937262e407146$export$2ba01fb71ed41cb6 = `_4LMoBa_button`;


const $69ffbf78f8ecebca$export$e0d897ee21382f67 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: $18b937262e407146$export$2ba01fb71ed41cb6,
        type: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84fee2cbb0ee7f10$export$1c641004b5485fed), {}),
            children
        ]
    });
};



parcelRequire("acw62");
var $585bdbcc7e56c6f1$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $585bdbcc7e56c6f1$exports = factory((parcelRequire("acw62")));
})($585bdbcc7e56c6f1$exports, (__WEBPACK_EXTERNAL_MODULE_react__)=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/css-mediaquery/index.js": /*!**********************************************!*\
  !*** ./node_modules/css-mediaquery/index.js ***!
  \**********************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ exports.match = matchQuery;
                exports.parse = parseQuery;
                // -----------------------------------------------------------------------------
                var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
                function matchQuery(mediaQuery, values) {
                    return parseQuery(mediaQuery).some(function(query) {
                        var inverse = query.inverse;
                        // Either the parsed or specified `type` is "all", or the types must be
                        // equal for a match.
                        var typeMatch = query.type === 'all' || values.type === query.type;
                        // Quit early when `type` doesn't match, but take "not" into account.
                        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
                        var expressionsMatch = query.expressions.every(function(expression) {
                            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                            // Missing or falsy values don't match.
                            if (!value) return false;
                            switch(feature){
                                case 'orientation':
                                case 'scan':
                                    return value.toLowerCase() === expValue.toLowerCase();
                                case 'width':
                                case 'height':
                                case 'device-width':
                                case 'device-height':
                                    expValue = toPx(expValue);
                                    value = toPx(value);
                                    break;
                                case 'resolution':
                                    expValue = toDpi(expValue);
                                    value = toDpi(value);
                                    break;
                                case 'aspect-ratio':
                                case 'device-aspect-ratio':
                                case /* Deprecated */ 'device-pixel-ratio':
                                    expValue = toDecimal(expValue);
                                    value = toDecimal(value);
                                    break;
                                case 'grid':
                                case 'color':
                                case 'color-index':
                                case 'monochrome':
                                    expValue = parseInt(expValue, 10) || 1;
                                    value = parseInt(value, 10) || 0;
                                    break;
                            }
                            switch(modifier){
                                case 'min':
                                    return value >= expValue;
                                case 'max':
                                    return value <= expValue;
                                default:
                                    return value === expValue;
                            }
                        });
                        return expressionsMatch && !inverse || !expressionsMatch && inverse;
                    });
                }
                function parseQuery(mediaQuery) {
                    return mediaQuery.split(',').map(function(query) {
                        query = query.trim();
                        var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || '', parsed = {};
                        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
                        parsed.type = type ? type.toLowerCase() : 'all';
                        // Split expressions into a list.
                        expressions = expressions.match(/\([^\)]+\)/g) || [];
                        parsed.expressions = expressions.map(function(expression) {
                            var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                            return {
                                modifier: feature[1],
                                feature: feature[2],
                                value: captures[2]
                            };
                        });
                        return parsed;
                    });
                }
                // -- Utilities ----------------------------------------------------------------
                function toDecimal(ratio) {
                    var decimal = Number(ratio), numbers;
                    if (!decimal) {
                        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                        decimal = numbers[1] / numbers[2];
                    }
                    return decimal;
                }
                function toDpi(resolution) {
                    var value = parseFloat(resolution), units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
                    switch(units){
                        case 'dpcm':
                            return value / 2.54;
                        case 'dppx':
                            return value * 96;
                        default:
                            return value;
                    }
                }
                function toPx(length) {
                    var value = parseFloat(length), units = String(length).match(RE_LENGTH_UNIT)[1];
                    switch(units){
                        case 'em':
                            return value * 16;
                        case 'rem':
                            return value * 16;
                        case 'cm':
                            return value * 96 / 2.54;
                        case 'mm':
                            return value * 96 / 2.54 / 10;
                        case 'in':
                            return value * 96;
                        case 'pt':
                            return value * 72;
                        case 'pc':
                            return value * 72 / 12;
                        default:
                            return value;
                    }
                }
            /***/ },
            /***/ "./node_modules/hyphenate-style-name/index.js": /*!****************************************************!*\
  !*** ./node_modules/hyphenate-style-name/index.js ***!
  \****************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                /* eslint-disable no-var, prefer-template */ var uppercasePattern = /[A-Z]/g;
                var msPattern = /^ms-/;
                var cache = {};
                function toHyphenLower(match) {
                    return '-' + match.toLowerCase();
                }
                function hyphenateStyleName(name) {
                    if (cache.hasOwnProperty(name)) return cache[name];
                    var hName = name.replace(uppercasePattern, toHyphenLower);
                    return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
                }
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;
            /***/ },
            /***/ "./node_modules/matchmediaquery/index.js": /*!***********************************************!*\
  !*** ./node_modules/matchmediaquery/index.js ***!
  \***********************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var staticMatch = __webpack_require__(/*! css-mediaquery */ "./node_modules/css-mediaquery/index.js").match;
                var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
                // our fake MediaQueryList
                function Mql(query, values, forceStatic) {
                    var self = this;
                    if (dynamicMatch && !forceStatic) {
                        var mql = dynamicMatch.call(window, query);
                        this.matches = mql.matches;
                        this.media = mql.media;
                        // TODO: is there a time it makes sense to remove this listener?
                        mql.addListener(update);
                    } else {
                        this.matches = staticMatch(query, values);
                        this.media = query;
                    }
                    this.addListener = addListener;
                    this.removeListener = removeListener;
                    this.dispose = dispose;
                    function addListener(listener) {
                        if (mql) mql.addListener(listener);
                    }
                    function removeListener(listener) {
                        if (mql) mql.removeListener(listener);
                    }
                    // update ourselves!
                    function update(evt) {
                        self.matches = evt.matches;
                        self.media = evt.media;
                    }
                    function dispose() {
                        if (mql) mql.removeListener(update);
                    }
                }
                function matchMedia(query, values, forceStatic) {
                    return new Mql(query, values, forceStatic);
                }
                module1.exports = matchMedia;
            /***/ },
            /***/ "./node_modules/object-assign/index.js": /*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/ /***/ (module1)=>{
                "use strict";
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
                        test1[5] = 'de';
                        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join('') !== '0123456789') return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            /***/ },
            /***/ "./node_modules/prop-types/checkPropTypes.js": /*!***************************************************!*\
  !*** ./node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var printWarning = function() {};
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var loggedTypeFailures = {};
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                printWarning = function(text) {
                    var message = 'Warning: ' + text;
                    if (typeof console !== 'undefined') console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                /**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            if (typeof typeSpecs[typeSpecName] !== 'function') {
                                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                                err.name = 'Invariant Violation';
                                throw err;
                            }
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        if (error && !(error instanceof Error)) printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : '';
                            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
                        }
                    }
                }
                /**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
                    loggedTypeFailures = {};
                };
                module1.exports = checkPropTypes;
            /***/ },
            /***/ "./node_modules/prop-types/factoryWithTypeCheckers.js": /*!************************************************************!*\
  !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
  \************************************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                var assign = __webpack_require__(/*! object-assign */ "./node_modules/object-assign/index.js");
                var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "./node_modules/prop-types/lib/ReactPropTypesSecret.js");
                var has = __webpack_require__(/*! ./lib/has */ "./node_modules/prop-types/lib/has.js");
                var checkPropTypes = __webpack_require__(/*! ./checkPropTypes */ "./node_modules/prop-types/checkPropTypes.js");
                var printWarning = function() {};
                printWarning = function(text) {
                    var message = 'Warning: ' + text;
                    if (typeof console !== 'undefined') console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                function emptyFunctionThatReturnsNull() {
                    return null;
                }
                module1.exports = function(isValidElement, throwOnDirectAccess) {
                    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
                    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
                    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
                        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                        if (typeof iteratorFn === 'function') return iteratorFn;
                    }
                    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
                    // Important!
                    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                    var ReactPropTypes = {
                        array: createPrimitiveTypeChecker('array'),
                        bigint: createPrimitiveTypeChecker('bigint'),
                        bool: createPrimitiveTypeChecker('boolean'),
                        func: createPrimitiveTypeChecker('function'),
                        number: createPrimitiveTypeChecker('number'),
                        object: createPrimitiveTypeChecker('object'),
                        string: createPrimitiveTypeChecker('string'),
                        symbol: createPrimitiveTypeChecker('symbol'),
                        any: createAnyTypeChecker(),
                        arrayOf: createArrayOfTypeChecker,
                        element: createElementTypeChecker(),
                        elementType: createElementTypeTypeChecker(),
                        instanceOf: createInstanceTypeChecker,
                        node: createNodeChecker(),
                        objectOf: createObjectOfTypeChecker,
                        oneOf: createEnumTypeChecker,
                        oneOfType: createUnionTypeChecker,
                        shape: createShapeTypeChecker,
                        exact: createStrictShapeTypeChecker
                    };
                    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                        // SameValue algorithm
                        if (x === y) // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                        else // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
                        this.message = message;
                        this.data = data && typeof data === 'object' ? data : {};
                        this.stack = '';
                    }
                    // Make `instanceof Error` still work for returned errors.
                    PropTypeError.prototype = Error.prototype;
                    function createChainableTypeChecker(validate) {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                            componentName = componentName || ANONYMOUS;
                            propFullName = propFullName || propName;
                            if (secret !== ReactPropTypesSecret) {
                                if (throwOnDirectAccess) {
                                    // New behavior only for users of `prop-types` package
                                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                                    err.name = 'Invariant Violation';
                                    throw err;
                                } else if (typeof console !== 'undefined') {
                                    // Old behavior for people using React.PropTypes
                                    var cacheKey = componentName + ':' + propName;
                                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                    manualPropTypeWarningCount < 3) {
                                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                                        manualPropTypeCallCache[cacheKey] = true;
                                        manualPropTypeWarningCount++;
                                    }
                                }
                            }
                            if (props[propName] == null) {
                                if (isRequired) {
                                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                                }
                                return null;
                            } else return validate(props, propName, componentName, location, propFullName);
                        }
                        var chainedCheckType = checkType.bind(null, false);
                        chainedCheckType.isRequired = checkType.bind(null, true);
                        return chainedCheckType;
                    }
                    function createPrimitiveTypeChecker(expectedType) {
                        function validate(props, propName, componentName, location, propFullName, secret) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== expectedType) {
                                // `propValue` being instance of, say, date/regexp, pass the 'object'
                                // check, but we can offer a more precise error message here rather than
                                // 'of type `object`'.
                                var preciseType = getPreciseType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                                    expectedType: expectedType
                                });
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createAnyTypeChecker() {
                        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                    }
                    function createArrayOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                            var propValue = props[propName];
                            if (!Array.isArray(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
                            }
                            for(var i = 0; i < propValue.length; i++){
                                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createElementTypeTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!ReactIs.isValidElementType(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createInstanceTypeChecker(expectedClass) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!(props[propName] instanceof expectedClass)) {
                                var expectedClassName = expectedClass.name || ANONYMOUS;
                                var actualClassName = getClassName(props[propName]);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createEnumTypeChecker(expectedValues) {
                        if (!Array.isArray(expectedValues)) {
                            {
                                if (arguments.length > 1) printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                                else printWarning('Invalid argument supplied to oneOf, expected an array.');
                            }
                            return emptyFunctionThatReturnsNull;
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            for(var i = 0; i < expectedValues.length; i++){
                                if (is(propValue, expectedValues[i])) return null;
                            }
                            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                                var type = getPreciseType(value);
                                if (type === 'symbol') return String(value);
                                return value;
                            });
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createObjectOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
                            for(var key in propValue)if (has(propValue, key)) {
                                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                if (error instanceof Error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createUnionTypeChecker(arrayOfTypeCheckers) {
                        if (!Array.isArray(arrayOfTypeCheckers)) {
                            printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
                            return emptyFunctionThatReturnsNull;
                        }
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (typeof checker !== 'function') {
                                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                                return emptyFunctionThatReturnsNull;
                            }
                        }
                        function validate(props, propName, componentName, location, propFullName) {
                            var expectedTypes = [];
                            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                                var checker = arrayOfTypeCheckers[i];
                                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                                if (checkerResult == null) return null;
                                if (checkerResult.data && has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
                            }
                            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createNodeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function invalidValidatorError(componentName, location, propFullName, key, type) {
                        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
                    }
                    function createShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                            for(var key in shapeTypes){
                                var checker = shapeTypes[key];
                                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function createStrictShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                            // We need to check all keys in case some are required but missing from props.
                            var allKeys = assign({}, props[propName], shapeTypes);
                            for(var key in allKeys){
                                var checker = shapeTypes[key];
                                if (has(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                if (error) return error;
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }
                    function isNode(propValue) {
                        switch(typeof propValue){
                            case 'number':
                            case 'string':
                            case 'undefined':
                                return true;
                            case 'boolean':
                                return !propValue;
                            case 'object':
                                if (Array.isArray(propValue)) return propValue.every(isNode);
                                if (propValue === null || isValidElement(propValue)) return true;
                                var iteratorFn = getIteratorFn(propValue);
                                if (iteratorFn) {
                                    var iterator = iteratorFn.call(propValue);
                                    var step;
                                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                        if (!isNode(step.value)) return false;
                                    }
                                    else // Iterator will provide entry [k,v] tuples rather than values.
                                    while(!(step = iterator.next()).done){
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) return false;
                                        }
                                    }
                                } else return false;
                                return true;
                            default:
                                return false;
                        }
                    }
                    function isSymbol(propType, propValue) {
                        // Native Symbol.
                        if (propType === 'symbol') return true;
                        // falsy value can't be a Symbol
                        if (!propValue) return false;
                        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                        if (propValue['@@toStringTag'] === 'Symbol') return true;
                        // Fallback for non-spec compliant Symbols which are polyfilled.
                        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
                        return false;
                    }
                    // Equivalent of `typeof` but with special handling for array and regexp.
                    function getPropType(propValue) {
                        var propType = typeof propValue;
                        if (Array.isArray(propValue)) return 'array';
                        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return 'object';
                        if (isSymbol(propType, propValue)) return 'symbol';
                        return propType;
                    }
                    // This handles more types than `getPropType`. Only used for error messages.
                    // See `createPrimitiveTypeChecker`.
                    function getPreciseType(propValue) {
                        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
                        var propType = getPropType(propValue);
                        if (propType === 'object') {
                            if (propValue instanceof Date) return 'date';
                            else if (propValue instanceof RegExp) return 'regexp';
                        }
                        return propType;
                    }
                    // Returns a string that is postfixed to a warning about an invalid type.
                    // For example, "undefined" or "of type array"
                    function getPostfixForTypeWarning(value) {
                        var type = getPreciseType(value);
                        switch(type){
                            case 'array':
                            case 'object':
                                return 'an ' + type;
                            case 'boolean':
                            case 'date':
                            case 'regexp':
                                return 'a ' + type;
                            default:
                                return type;
                        }
                    }
                    // Returns class name of the object, if any.
                    function getClassName(propValue) {
                        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                        return propValue.constructor.name;
                    }
                    ReactPropTypes.checkPropTypes = checkPropTypes;
                    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                    ReactPropTypes.PropTypes = ReactPropTypes;
                    return ReactPropTypes;
                };
            /***/ },
            /***/ "./node_modules/prop-types/index.js": /*!******************************************!*\
  !*** ./node_modules/prop-types/index.js ***!
  \******************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                var ReactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(/*! ./factoryWithTypeCheckers */ "./node_modules/prop-types/factoryWithTypeCheckers.js")(ReactIs.isElement, throwOnDirectAccess);
            /***/ },
            /***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js": /*!*************************************************************!*\
  !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************/ /***/ (module1)=>{
                "use strict";
                /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
                module1.exports = ReactPropTypesSecret;
            /***/ },
            /***/ "./node_modules/prop-types/lib/has.js": /*!********************************************!*\
  !*** ./node_modules/prop-types/lib/has.js ***!
  \********************************************/ /***/ (module1)=>{
                module1.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            /***/ },
            /***/ "./node_modules/react-is/cjs/react-is.development.js": /*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/ /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                (function() {
                    'use strict';
                    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
                    // nor polyfill, then a plain number is used for performance.
                    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
                    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
                    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
                    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
                    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
                    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
                    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
                    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
                    // (unstable) APIs that have been removed. Can we remove the symbols?
                    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
                    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
                    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
                    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
                    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
                    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
                    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
                    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
                    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
                    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
                    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
                    function isValidElementType(type) {
                        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
                    }
                    function typeOf(object) {
                        if (typeof object === 'object' && object !== null) {
                            var $$typeof = object.$$typeof;
                            switch($$typeof){
                                case REACT_ELEMENT_TYPE:
                                    var type = object.type;
                                    switch(type){
                                        case REACT_ASYNC_MODE_TYPE:
                                        case REACT_CONCURRENT_MODE_TYPE:
                                        case REACT_FRAGMENT_TYPE:
                                        case REACT_PROFILER_TYPE:
                                        case REACT_STRICT_MODE_TYPE:
                                        case REACT_SUSPENSE_TYPE:
                                            return type;
                                        default:
                                            var $$typeofType = type && type.$$typeof;
                                            switch($$typeofType){
                                                case REACT_CONTEXT_TYPE:
                                                case REACT_FORWARD_REF_TYPE:
                                                case REACT_LAZY_TYPE:
                                                case REACT_MEMO_TYPE:
                                                case REACT_PROVIDER_TYPE:
                                                    return $$typeofType;
                                                default:
                                                    return $$typeof;
                                            }
                                    }
                                case REACT_PORTAL_TYPE:
                                    return $$typeof;
                            }
                        }
                        return undefined;
                    } // AsyncMode is deprecated along with isAsyncMode
                    var AsyncMode = REACT_ASYNC_MODE_TYPE;
                    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                    var ContextConsumer = REACT_CONTEXT_TYPE;
                    var ContextProvider = REACT_PROVIDER_TYPE;
                    var Element = REACT_ELEMENT_TYPE;
                    var ForwardRef = REACT_FORWARD_REF_TYPE;
                    var Fragment = REACT_FRAGMENT_TYPE;
                    var Lazy = REACT_LAZY_TYPE;
                    var Memo = REACT_MEMO_TYPE;
                    var Portal = REACT_PORTAL_TYPE;
                    var Profiler = REACT_PROFILER_TYPE;
                    var StrictMode = REACT_STRICT_MODE_TYPE;
                    var Suspense = REACT_SUSPENSE_TYPE;
                    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
                    function isAsyncMode(object) {
                        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
                            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                        }
                        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
                    }
                    function isConcurrentMode(object) {
                        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
                    }
                    function isContextConsumer(object) {
                        return typeOf(object) === REACT_CONTEXT_TYPE;
                    }
                    function isContextProvider(object) {
                        return typeOf(object) === REACT_PROVIDER_TYPE;
                    }
                    function isElement(object) {
                        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                    }
                    function isForwardRef(object) {
                        return typeOf(object) === REACT_FORWARD_REF_TYPE;
                    }
                    function isFragment(object) {
                        return typeOf(object) === REACT_FRAGMENT_TYPE;
                    }
                    function isLazy(object) {
                        return typeOf(object) === REACT_LAZY_TYPE;
                    }
                    function isMemo(object) {
                        return typeOf(object) === REACT_MEMO_TYPE;
                    }
                    function isPortal(object) {
                        return typeOf(object) === REACT_PORTAL_TYPE;
                    }
                    function isProfiler(object) {
                        return typeOf(object) === REACT_PROFILER_TYPE;
                    }
                    function isStrictMode(object) {
                        return typeOf(object) === REACT_STRICT_MODE_TYPE;
                    }
                    function isSuspense(object) {
                        return typeOf(object) === REACT_SUSPENSE_TYPE;
                    }
                    exports.AsyncMode = AsyncMode;
                    exports.ConcurrentMode = ConcurrentMode;
                    exports.ContextConsumer = ContextConsumer;
                    exports.ContextProvider = ContextProvider;
                    exports.Element = Element;
                    exports.ForwardRef = ForwardRef;
                    exports.Fragment = Fragment;
                    exports.Lazy = Lazy;
                    exports.Memo = Memo;
                    exports.Portal = Portal;
                    exports.Profiler = Profiler;
                    exports.StrictMode = StrictMode;
                    exports.Suspense = Suspense;
                    exports.isAsyncMode = isAsyncMode;
                    exports.isConcurrentMode = isConcurrentMode;
                    exports.isContextConsumer = isContextConsumer;
                    exports.isContextProvider = isContextProvider;
                    exports.isElement = isElement;
                    exports.isForwardRef = isForwardRef;
                    exports.isFragment = isFragment;
                    exports.isLazy = isLazy;
                    exports.isMemo = isMemo;
                    exports.isPortal = isPortal;
                    exports.isProfiler = isProfiler;
                    exports.isStrictMode = isStrictMode;
                    exports.isSuspense = isSuspense;
                    exports.isValidElementType = isValidElementType;
                    exports.typeOf = typeOf;
                })();
            /***/ },
            /***/ "./node_modules/react-is/index.js": /*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/ /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
            /***/ },
            /***/ "./node_modules/shallow-equal/dist/index.esm.js": /*!******************************************************!*\
  !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
  \******************************************************/ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "shallowEqualArrays": ()=>/* binding */ shallowEqualArrays,
                    /* harmony export */ "shallowEqualObjects": ()=>/* binding */ shallowEqualObjects
                });
                function shallowEqualObjects(objA, objB) {
                    if (objA === objB) return true;
                    if (!objA || !objB) return false;
                    var aKeys = Object.keys(objA);
                    var bKeys = Object.keys(objB);
                    var len = aKeys.length;
                    if (bKeys.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        var key = aKeys[i];
                        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
                    }
                    return true;
                }
                function shallowEqualArrays(arrA, arrB) {
                    if (arrA === arrB) return true;
                    if (!arrA || !arrB) return false;
                    var len = arrA.length;
                    if (arrB.length !== len) return false;
                    for(var i = 0; i < len; i++){
                        if (arrA[i] !== arrB[i]) return false;
                    }
                    return true;
                }
            /***/ },
            /***/ "./src/Component.ts": /*!**************************!*\
  !*** ./src/Component.ts ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                // ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
                var MediaQuery = function(_a) {
                    var children = _a.children, device = _a.device, onChange = _a.onChange, settings = __rest(_a, [
                        "children",
                        "device",
                        "onChange"
                    ]);
                    var matches = (0, useMediaQuery_1.default)(settings, device, onChange);
                    if (typeof children === 'function') return children(matches);
                    return matches ? children : null;
                };
                exports["default"] = MediaQuery;
            /***/ },
            /***/ "./src/Context.ts": /*!************************!*\
  !*** ./src/Context.ts ***!
  \************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var Context = (0, react_1.createContext)(undefined);
                exports["default"] = Context;
            /***/ },
            /***/ "./src/index.ts": /*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Context = exports.toQuery = exports.useMediaQuery = exports["default"] = void 0;
                var useMediaQuery_1 = __importDefault(__webpack_require__(/*! ./useMediaQuery */ "./src/useMediaQuery.ts"));
                exports.useMediaQuery = useMediaQuery_1.default;
                var Component_1 = __importDefault(__webpack_require__(/*! ./Component */ "./src/Component.ts"));
                exports["default"] = Component_1.default;
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                exports.toQuery = toQuery_1.default;
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                exports.Context = Context_1.default;
            /***/ },
            /***/ "./src/mediaQuery.ts": /*!***************************!*\
  !*** ./src/mediaQuery.ts ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __rest = this && this.__rest || function(s, e) {
                    var t = {};
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                    }
                    return t;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var prop_types_1 = __importDefault(__webpack_require__(/*! prop-types */ "./node_modules/prop-types/index.js"));
                var stringOrNumber = prop_types_1.default.oneOfType([
                    prop_types_1.default.string,
                    prop_types_1.default.number
                ]);
                // media types
                var types = {
                    all: prop_types_1.default.bool,
                    grid: prop_types_1.default.bool,
                    aural: prop_types_1.default.bool,
                    braille: prop_types_1.default.bool,
                    handheld: prop_types_1.default.bool,
                    print: prop_types_1.default.bool,
                    projection: prop_types_1.default.bool,
                    screen: prop_types_1.default.bool,
                    tty: prop_types_1.default.bool,
                    tv: prop_types_1.default.bool,
                    embossed: prop_types_1.default.bool
                };
                // properties that match media queries
                var matchers = {
                    orientation: prop_types_1.default.oneOf([
                        'portrait',
                        'landscape'
                    ]),
                    scan: prop_types_1.default.oneOf([
                        'progressive',
                        'interlace'
                    ]),
                    aspectRatio: prop_types_1.default.string,
                    deviceAspectRatio: prop_types_1.default.string,
                    height: stringOrNumber,
                    deviceHeight: stringOrNumber,
                    width: stringOrNumber,
                    deviceWidth: stringOrNumber,
                    color: prop_types_1.default.bool,
                    colorIndex: prop_types_1.default.bool,
                    monochrome: prop_types_1.default.bool,
                    resolution: stringOrNumber,
                    type: Object.keys(types)
                };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var type = matchers.type, featureMatchers = __rest(matchers, [
                    "type"
                ]);
                // media features
                var features = __assign({
                    minAspectRatio: prop_types_1.default.string,
                    maxAspectRatio: prop_types_1.default.string,
                    minDeviceAspectRatio: prop_types_1.default.string,
                    maxDeviceAspectRatio: prop_types_1.default.string,
                    minHeight: stringOrNumber,
                    maxHeight: stringOrNumber,
                    minDeviceHeight: stringOrNumber,
                    maxDeviceHeight: stringOrNumber,
                    minWidth: stringOrNumber,
                    maxWidth: stringOrNumber,
                    minDeviceWidth: stringOrNumber,
                    maxDeviceWidth: stringOrNumber,
                    minColor: prop_types_1.default.number,
                    maxColor: prop_types_1.default.number,
                    minColorIndex: prop_types_1.default.number,
                    maxColorIndex: prop_types_1.default.number,
                    minMonochrome: prop_types_1.default.number,
                    maxMonochrome: prop_types_1.default.number,
                    minResolution: stringOrNumber,
                    maxResolution: stringOrNumber
                }, featureMatchers);
                var all = __assign(__assign({}, types), features);
                exports["default"] = {
                    all: all,
                    types: types,
                    matchers: matchers,
                    features: features
                };
            /***/ },
            /***/ "./src/toQuery.ts": /*!************************!*\
  !*** ./src/toQuery.ts ***!
  \************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var mediaQuery_1 = __importDefault(__webpack_require__(/*! ./mediaQuery */ "./src/mediaQuery.ts"));
                var negate = function(cond) {
                    return "not ".concat(cond);
                };
                var keyVal = function(k, v) {
                    var realKey = (0, hyphenate_style_name_1.default)(k);
                    // px shorthand
                    if (typeof v === 'number') v = "".concat(v, "px");
                    if (v === true) return realKey;
                    if (v === false) return negate(realKey);
                    return "(".concat(realKey, ": ").concat(v, ")");
                };
                var join = function(conds) {
                    return conds.join(' and ');
                };
                var toQuery = function(obj) {
                    var rules = [];
                    Object.keys(mediaQuery_1.default.all).forEach(function(k) {
                        var v = obj[k];
                        if (v != null) rules.push(keyVal(k, v));
                    });
                    return join(rules);
                };
                exports["default"] = toQuery;
            /***/ },
            /***/ "./src/useMediaQuery.ts": /*!******************************!*\
  !*** ./src/useMediaQuery.ts ***!
  \******************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var matchmediaquery_1 = __importDefault(__webpack_require__(/*! matchmediaquery */ "./node_modules/matchmediaquery/index.js"));
                var hyphenate_style_name_1 = __importDefault(__webpack_require__(/*! hyphenate-style-name */ "./node_modules/hyphenate-style-name/index.js"));
                var shallow_equal_1 = __webpack_require__(/*! shallow-equal */ "./node_modules/shallow-equal/dist/index.esm.js");
                var toQuery_1 = __importDefault(__webpack_require__(/*! ./toQuery */ "./src/toQuery.ts"));
                var Context_1 = __importDefault(__webpack_require__(/*! ./Context */ "./src/Context.ts"));
                var makeQuery = function(settings) {
                    return settings.query || (0, toQuery_1.default)(settings);
                };
                var hyphenateKeys = function(obj) {
                    if (!obj) return undefined;
                    var keys = Object.keys(obj);
                    return keys.reduce(function(result, key) {
                        result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                        return result;
                    }, {});
                };
                var useIsUpdate = function() {
                    var ref = (0, react_1.useRef)(false);
                    (0, react_1.useEffect)(function() {
                        ref.current = true;
                    }, []);
                    return ref.current;
                };
                var useDevice = function(deviceFromProps) {
                    var deviceFromContext = (0, react_1.useContext)(Context_1.default);
                    var getDevice = function() {
                        return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
                    };
                    var _a = (0, react_1.useState)(getDevice), device = _a[0], setDevice = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newDevice = getDevice();
                        if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) setDevice(newDevice);
                    }, [
                        deviceFromProps,
                        deviceFromContext
                    ]);
                    return device;
                };
                var useQuery = function(settings) {
                    var getQuery = function() {
                        return makeQuery(settings);
                    };
                    var _a = (0, react_1.useState)(getQuery), query = _a[0], setQuery = _a[1];
                    (0, react_1.useEffect)(function() {
                        var newQuery = getQuery();
                        if (query !== newQuery) setQuery(newQuery);
                    }, [
                        settings
                    ]);
                    return query;
                };
                var useMatchMedia = function(query, device) {
                    var getMatchMedia = function() {
                        return (0, matchmediaquery_1.default)(query, device || {}, !!device);
                    };
                    var _a = (0, react_1.useState)(getMatchMedia), mq = _a[0], setMq = _a[1];
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate) {
                            // skip on mounting, it has already been set
                            var newMq_1 = getMatchMedia();
                            setMq(newMq_1);
                            return function() {
                                if (newMq_1) newMq_1.dispose();
                            };
                        }
                    }, [
                        query,
                        device
                    ]);
                    return mq;
                };
                var useMatches = function(mediaQuery) {
                    var _a = (0, react_1.useState)(mediaQuery.matches), matches = _a[0], setMatches = _a[1];
                    (0, react_1.useEffect)(function() {
                        var updateMatches = function(ev) {
                            setMatches(ev.matches);
                        };
                        mediaQuery.addListener(updateMatches);
                        setMatches(mediaQuery.matches);
                        return function() {
                            mediaQuery.removeListener(updateMatches);
                        };
                    }, [
                        mediaQuery
                    ]);
                    return matches;
                };
                var useMediaQuery = function(settings, device, onChange) {
                    var deviceSettings = useDevice(device);
                    var query = useQuery(settings);
                    if (!query) throw new Error('Invalid or missing MediaQuery!');
                    var mq = useMatchMedia(query, deviceSettings);
                    var matches = useMatches(mq);
                    var isUpdate = useIsUpdate();
                    (0, react_1.useEffect)(function() {
                        if (isUpdate && onChange) onChange(matches);
                    }, [
                        matches
                    ]);
                    (0, react_1.useEffect)(function() {
                        return function() {
                            if (mq) mq.dispose();
                        };
                    }, []);
                    return matches;
                };
                exports["default"] = useMediaQuery;
            /***/ },
            /***/ "react": /*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/ /***/ (module1)=>{
                "use strict";
                module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/index.ts");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});





parcelRequire("acw62");
const $9a54ab13c2199ebe$export$6fb48dc3079cee11 = ({ width: width = 20, height: height = 20 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m13 2-10 12h9l-1 8 10-12h-9z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    });
};


var $74f6dbb109e5b716$export$9c30223ca0a664fb;
$74f6dbb109e5b716$export$9c30223ca0a664fb = `NG8PaG_link`;


const $af3c66d7b5a8b8ae$export$fa72d1da6a8e16c8 = ()=>{
    const to = (0, $98110fe2c21af7aa$export$6d3a98bdec8985cb)('/transactions');
    const phone = (0, $585bdbcc7e56c6f1$exports.useMediaQuery)({
        query: '(max-width: 767px)'
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        to: to,
        className: $74f6dbb109e5b716$export$9c30223ca0a664fb,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a54ab13c2199ebe$export$6fb48dc3079cee11), {}),
            phone ? null : 'Recent Transactions'
        ]
    });
};



parcelRequire("acw62");

parcelRequire("acw62");
const $c4cc807dfa418ba7$export$200d3d30c8dde009 = ({ width: width = 60, height: height = 22 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 60 22",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "1.34093",
                x2: "14.0922",
                y1: "18.4332",
                y2: "3.77438",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".08",
                        stopColor: "#9945ff"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".3",
                        stopColor: "#8752f3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".5",
                        stopColor: "#5497d5"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".6",
                        stopColor: "#43b4ca"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".72",
                        stopColor: "#28e0b9"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".97",
                        stopColor: "#19fb9b"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m53.7996 15.3534-3.4639-7.56849h-2.875l4.9484 10.21209-.0891.3075c-.1239.4087-.3855.7617-.7402.9987-.3546.237-.7804.3433-1.2045.3007-.4965-.0046-.9836-.136-1.4152-.3819l-.4602 2.1873c.6641.2743 1.3748.4174 2.0931.4215 1.9794 0 3.1769-.7291 4.1666-2.8766l5.2404-11.16929h-2.7761z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m29.3187 4.1792h-8.3034v13.912h2.7216v-5.1135h5.5818c3.0334 0 5.0276-1.5325 5.0276-4.39923 0-2.86672-1.9942-4.39927-5.0276-4.39927zm-.1484 6.3633h-5.4433v-3.96776h5.4433c1.5735 0 2.4742.71916 2.4742 1.98389s-.9007 1.98387-2.4742 1.98387z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "m45.7249 15.4526v-4.1909c0-2.47988-1.7764-3.76445-4.8247-3.76445-2.4742 0-4.6416 1.15562-5.2502 2.93115l2.2367.7936c.3315-.8878 1.4845-1.54247 2.9195-1.54247 1.7023 0 2.4198.69437 2.4198 1.54247v.2728l-4.0478.4464c-2.3307.2479-3.8647 1.2944-3.8647 3.1643 0 2.0483 1.7567 3.1494 4.0874 3.1494 1.5023.0469 2.9653-.4857 4.0874-1.4879.4057.9919.8214 1.6565 3.5876 1.3044v-2.0732c-1.1085.2678-1.351 0-1.351-.5456zm-2.4742-1.3292c0 1.3491-1.8853 2.0633-3.4639 2.0633-1.2024 0-1.9249-.3869-1.9249-1.1556 0-.7688.5938-1.0465 1.7419-1.1805l3.6568-.4265z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m15.8678 14.8277c.0193.0579.0193.1206 0 .1785-.0112.0578-.0386.1112-.0792.1538l-2.6177 2.7526c-.0577.0595-.1267.1067-.2029.1389-.0764.0336-.159.0505-.2424.0496h-12.415618c-.057498.0005-.114013-.0149-.163297-.0446-.0492514-.0336-.0885667-.0799-.1138136-.1339-.0174364-.0549-.0174364-.1138 0-.1687.0102614-.0571.0359328-.1102.0742256-.1537l2.622663-2.7527c.05768-.0594.12667-.1066.20288-.1388.07627-.034.15902-.051.24248-.0496h12.39578c.0598-.0012.1186.0161.1682.0496.0557.023.1014.0652.1287.119zm-2.6919-5.22755c-.059-.05787-.1277-.10488-.2029-.13887-.0772-.0312-.1593-.048-.2425-.0496h-12.420518c-.058217.00086-.115031.01804-.164007.04959-.0489763.03156-.088157.07623-.1131036.12896-.0171157.0549-.0171157.11373 0 .16863.0083338.0577.0342593.1114.0742256.15375l2.622663 2.75759c.05897.0579.12764.1049.20288.1389.07701.0316.15926.0484.24248.0496h12.39578c.0598.0011.1186-.0162.1682-.0496.05-.0292.0884-.0747.1089-.129.0254-.0527.0338-.1121.024-.1698-.0097-.0578-.0371-.1111-.0784-.1525zm-13.029215-2.03348c.049284.02969.105799.04513.163297.04464h12.420518c.0834.00086.1661-.01604.2425-.0496.0762-.03223.1452-.07945.2029-.13887l2.6177-2.75265c.0405-.04259.068-.09596.0792-.15375.0171-.0549.0171-.11373 0-.16863-.0205-.05422-.0589-.09974-.1089-.12895-.0497-.03342-.1084-.05074-.1683-.0496h-12.44028c-.08346-.00133-.1662.01559-.24247.0496-.07621.03223-.1452.07945-.20288.13887l-2.6177172 2.76256c-.0415084.04189-.0691515.09557-.0791755.15375-.01743638.05486-.01743638.11378 0 .16863.0321173.05302.0783988.09597.1336077.124z",
                fill: "url(#a)"
            })
        ]
    });
};


var $4ab2c2cbe9ac086c$export$e8e78c978b129247;
var $4ab2c2cbe9ac086c$export$6f093cfa640b7166;
$4ab2c2cbe9ac086c$export$e8e78c978b129247 = `NaW7Ta_root`;
$4ab2c2cbe9ac086c$export$6f093cfa640b7166 = `NaW7Ta_text`;


const $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $4ab2c2cbe9ac086c$export$e8e78c978b129247,
        children: [
            "Powered by ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4cc807dfa418ba7$export$200d3d30c8dde009), {})
        ]
    });
};



var $e21c2cddc76cf875$exports = {};
'use strict';
var $5481cadd51b98557$exports = {};
/**
 * @module color-parse
 */ 'use strict';

var $jVuP9 = parcelRequire("jVuP9");
$5481cadd51b98557$exports = $5481cadd51b98557$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $5481cadd51b98557$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $5481cadd51b98557$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    if (typeof cstr === 'string') {
        cstr = cstr.toLowerCase();
        //keyword
        if ($jVuP9[cstr]) {
            parts = $jVuP9[cstr].slice();
            space = 'rgb';
        } else if (cstr === 'transparent') {
            alpha = 0;
            space = 'rgb';
            parts = [
                0,
                0,
                0
            ];
        } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
            var base = cstr.slice(1);
            var size = base.length;
            var isShort = size <= 4;
            alpha = 1;
            if (isShort) {
                parts = [
                    parseInt(base[0] + base[0], 16),
                    parseInt(base[1] + base[1], 16),
                    parseInt(base[2] + base[2], 16)
                ];
                if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
            } else {
                parts = [
                    parseInt(base[0] + base[1], 16),
                    parseInt(base[2] + base[3], 16),
                    parseInt(base[4] + base[5], 16)
                ];
                if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
            }
            if (!parts[0]) parts[0] = 0;
            if (!parts[1]) parts[1] = 0;
            if (!parts[2]) parts[2] = 0;
            space = 'rgb';
        } else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
            var name = m[1];
            var isRGB = name === 'rgb';
            var base = name.replace(/a$/, '');
            space = base;
            var size = base === 'cmyk' ? 4 : base === 'gray' ? 1 : 3;
            parts = m[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(x, i) {
                //<percentage>
                if (/%$/.test(x)) {
                    //alpha
                    if (i === size) return parseFloat(x) / 100;
                    //rgb
                    if (base === 'rgb') return parseFloat(x) * 255 / 100;
                    return parseFloat(x);
                } else if (base[i] === 'h') {
                    //<deg>
                    if (/deg$/.test(x)) return parseFloat(x);
                    else if ($5481cadd51b98557$var$baseHues[x] !== undefined) return $5481cadd51b98557$var$baseHues[x];
                }
                return parseFloat(x);
            });
            if (name === base) parts.push(1);
            alpha = isRGB ? 1 : parts[size] === undefined ? 1 : parts[size];
            parts = parts.slice(0, size);
        } else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
            parts = cstr.match(/([0-9]+)/g).map(function(value) {
                return parseFloat(value);
            });
            space = cstr.match(/([a-z])/ig).join('').toLowerCase();
        }
    } else if (!isNaN(cstr)) {
        space = 'rgb';
        parts = [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ];
    } else if (Array.isArray(cstr) || cstr.length) {
        parts = [
            cstr[0],
            cstr[1],
            cstr[2]
        ];
        space = 'rgb';
        alpha = cstr.length === 4 ? cstr[3] : 1;
    } else if (cstr instanceof Object) {
        if (cstr.r != null || cstr.red != null || cstr.R != null) {
            space = 'rgb';
            parts = [
                cstr.r || cstr.red || cstr.R || 0,
                cstr.g || cstr.green || cstr.G || 0,
                cstr.b || cstr.blue || cstr.B || 0
            ];
        } else {
            space = 'hsl';
            parts = [
                cstr.h || cstr.hue || cstr.H || 0,
                cstr.s || cstr.saturation || cstr.S || 0,
                cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
            ];
        }
        alpha = cstr.a || cstr.alpha || cstr.opacity || 1;
        if (cstr.opacity != null) alpha /= 100;
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


var $4b161c5b6bfbd933$exports = {};
/**
 * @module color-space/hsl
 */ 'use strict';
var $3751ab4954229b70$exports = {};
/**
 * RGB space.
 *
 * @module  color-space/rgb
 */ 'use strict';
$3751ab4954229b70$exports = {
    name: 'rgb',
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        'red',
        'green',
        'blue'
    ],
    alias: [
        'RGB'
    ]
};


$4b161c5b6bfbd933$exports = {
    name: 'hsl',
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        'hue',
        'saturation',
        'lightness'
    ],
    alias: [
        'HSL'
    ],
    rgb: function(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val;
        if (s === 0) {
            val = l * 255;
            return [
                val,
                val,
                val
            ];
        }
        if (l < 0.5) t2 = l * (1 + s);
        else t2 = l + s - l * s;
        t1 = 2 * l - t2;
        rgb = [
            0,
            0,
            0
        ];
        for(var i = 0; i < 3; i++){
            t3 = h + 1 / 3 * -(i - 1);
            if (t3 < 0) t3++;
            else if (t3 > 1) t3--;
            if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
            else if (2 * t3 < 1) val = t2;
            else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
            else val = t1;
            rgb[i] = val * 255;
        }
        return rgb;
    }
};
//extend rgb
$3751ab4954229b70$exports.hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};


function $e21c2cddc76cf875$var$clamp(value, min, max) {
    return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}
function $e21c2cddc76cf875$var$lerp(start, stop, step) {
    return start * (1 - step) + stop * step;
}
$e21c2cddc76cf875$exports = $e21c2cddc76cf875$var$interpolate;
function $e21c2cddc76cf875$var$interpolate(palette) {
    palette = palette.map(function(c) {
        c = $5481cadd51b98557$exports(c);
        if (c.space != 'rgb') {
            if (c.space != 'hsl') throw "c.spacespace is not supported.";
            c.values = $4b161c5b6bfbd933$exports.rgb(c.values);
        }
        c.values.push(c.alpha);
        return c.values;
    });
    return function(t, mix) {
        mix = mix || $e21c2cddc76cf875$var$lerp;
        t = $e21c2cddc76cf875$var$clamp(t, 0, 1);
        var idx = (palette.length - 1) * t, lIdx = Math.floor(idx), rIdx = Math.ceil(idx);
        t = idx - lIdx;
        var lColor = palette[lIdx], rColor = palette[rIdx];
        var result = lColor.map(function(v, i) {
            v = mix(v, rColor[i], t);
            if (i < 3) v = Math.round(v);
            return v;
        });
        if (result[3] === 1) return 'rgb(' + result.slice(0, 3) + ')';
        return 'rgba(' + result + ')';
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $94a0b690fd9978ec$var$extendStatics = function(d, b) {
    $94a0b690fd9978ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $94a0b690fd9978ec$var$extendStatics(d, b);
};
function $94a0b690fd9978ec$var$__extends(d, b) {
    $94a0b690fd9978ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $94a0b690fd9978ec$var$__assign = function() {
    $94a0b690fd9978ec$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $94a0b690fd9978ec$var$__assign.apply(this, arguments);
};
function $94a0b690fd9978ec$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $94a0b690fd9978ec$var$VIEWBOX_WIDTH = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_X = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y = 50;
function $94a0b690fd9978ec$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $94a0b690fd9978ec$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $94a0b690fd9978ec$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $94a0b690fd9978ec$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $94a0b690fd9978ec$var$VIEWBOX_CENTER_X + "," + $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $94a0b690fd9978ec$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $94a0b690fd9978ec$export$14082143029b37c8 = function(_super) {
    $94a0b690fd9978ec$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $94a0b690fd9978ec$var$VIEWBOX_WIDTH + " " + $94a0b690fd9978ec$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            cy: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y,
            r: $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            y: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background'
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ''
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $94a0b690fd9978ec$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $94a0b690fd9978ec$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: '100%'
        }
    }, (0, $acw62.createElement)($94a0b690fd9978ec$export$14082143029b37c8, $94a0b690fd9978ec$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            marginTop: '-100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, props.children) : null));
}
function $94a0b690fd9978ec$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $94a0b690fd9978ec$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}




var $d06e0de4fc86417e$export$e8e78c978b129247;
var $d06e0de4fc86417e$export$6f093cfa640b7166;
$d06e0de4fc86417e$export$e8e78c978b129247 = `pS7n6W_root`;
$d06e0de4fc86417e$export$6f093cfa640b7166 = `pS7n6W_text`;


const $fa897a99a69a6392$export$b25a304ec7d746bb = ()=>{
    const { status: status, progress: progress } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    const [value, text] = (0, $acw62.useMemo)(()=>{
        switch(status){
            case (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Finalized:
                return [
                    1,
                    'Complete'
                ];
            case (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Confirmed:
            case (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Valid:
                return progress >= 1 ? [
                    1,
                    'Complete'
                ] : [
                    progress,
                    Math.floor(progress * 100) + '%'
                ];
            default:
                return [
                    0,
                    status
                ];
        }
    }, [
        status,
        progress
    ]);
    const interpolated = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($e21c2cddc76cf875$exports)))([
            '#8752f3',
            '#5497d5',
            '#43b4ca',
            '#28e0b9',
            '#19fb9b'
        ]), []);
    const styles = (0, $acw62.useMemo)(()=>(0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
            pathTransitionDuration: 0.5,
            pathColor: interpolated(value),
            trailColor: 'rgba(0,0,0,.1)'
        }), [
        interpolated,
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $d06e0de4fc86417e$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                maxValue: 1,
                value: value,
                styles: styles
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $d06e0de4fc86417e$export$6f093cfa640b7166,
                children: text
            })
        ]
    });
};


var $2ee9b801112e0eef$export$adb608be33961c98;
var $2ee9b801112e0eef$export$38e42c68cf43b5d4;
var $2ee9b801112e0eef$export$f22da7240b7add18;
var $2ee9b801112e0eef$export$e8e78c978b129247;
$2ee9b801112e0eef$export$adb608be33961c98 = `p34E7a_footer`;
$2ee9b801112e0eef$export$38e42c68cf43b5d4 = `p34E7a_header`;
$2ee9b801112e0eef$export$f22da7240b7add18 = `p34E7a_main`;
$2ee9b801112e0eef$export$e8e78c978b129247 = `p34E7a_root`;


const $ba4a8c4b11255531$export$72af88ed99d024ff = ()=>{
    const { reset: reset } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $2ee9b801112e0eef$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $2ee9b801112e0eef$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69ffbf78f8ecebca$export$e0d897ee21382f67), {
                        onClick: reset,
                        children: "Start Over"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af3c66d7b5a8b8ae$export$fa72d1da6a8e16c8), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $2ee9b801112e0eef$export$f22da7240b7add18,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa897a99a69a6392$export$b25a304ec7d746bb), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $2ee9b801112e0eef$export$adb608be33961c98,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24), {})
            })
        ]
    });
};



parcelRequire("acw62");


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $7373bd93423a38b6$export$2ba283291ae215b4 = (0, $acw62.createContext)({});
function $7373bd93423a38b6$export$873ff9d3a24fe223() {
    return (0, $acw62.useContext)($7373bd93423a38b6$export$2ba283291ae215b4);
}



parcelRequire("acw62");
const $15e4423706589635$export$ad8cd11d6f0ad24c = ({ width: width = 20, height: height = 20 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m15 3h6v6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m9 21h-6v-6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m21 3-7 7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m3 21 7-7"
                })
            ]
        })
    });
};



parcelRequire("acw62");
const $695413e946a294d7$export$95300d23f5f56d39 = ({ width: width = 20, height: height = 20 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m4 14h6v6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m20 10h-6v-6"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m14 10 7-7"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "m3 21 7-7"
                })
            ]
        })
    });
};


var $2f072233858a67b0$export$2ba01fb71ed41cb6;
$2f072233858a67b0$export$2ba01fb71ed41cb6 = `NI2HRW_button`;


const $1cfa077b59a1fad6$export$305be705ce696d42 = ()=>{
    const { fullscreen: fullscreen, toggleFullscreen: toggleFullscreen } = (0, $7373bd93423a38b6$export$873ff9d3a24fe223)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: $2f072233858a67b0$export$2ba01fb71ed41cb6,
        type: "button",
        onClick: toggleFullscreen,
        children: fullscreen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $695413e946a294d7$export$95300d23f5f56d39), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e4423706589635$export$ad8cd11d6f0ad24c), {})
    });
};



parcelRequire("acw62");

var $da55e825de5c19a9$export$e8e78c978b129247;
$da55e825de5c19a9$export$e8e78c978b129247 = `RvLhwW_root`;


const $9a1624aa8d074ee2$export$49445b09fc6713d3 = ()=>{
    const { amount: amount, generate: generate } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: $da55e825de5c19a9$export$e8e78c978b129247,
        type: "button",
        onClick: generate,
        disabled: !amount || amount.isLessThanOrEqualTo(0),
        children: "Generate Payment Code"
    });
};





var $dws6U = parcelRequire("dws6U");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $e019fb9064ab9dfa$export$a92f85ab3e9ad68b = (0, $acw62.createContext)({});
function $e019fb9064ab9dfa$export$b3611e87cd5ba6ce() {
    return (0, $acw62.useContext)($e019fb9064ab9dfa$export$a92f85ab3e9ad68b);
}




parcelRequire("acw62");
const $88d1b0b035476dbb$export$12a4185d7caff8bd = ({ width: width = 36, height: height = 36 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: width,
        height: width,
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m6.81504 4.20001c-.31434 0-.61038.1478-.79928.39904l-5.563909 7.40005c-.267629.3559-.267629.8459 0 1.2019l5.563909 7.4c.1889.2512.48494.399.79928.399h16.18496c.5523 0 1-.4477 1-1v-14.79999c0-.55228-.4477-1-1-1zm2.37103 13.60929c-.24809-.2543-.24809-.6666 0-.9209l4.31553-4.4232-4.05238-4.15357c-.2481-.2543-.2481-.66659 0-.92088.2481-.2543.65038-.2543.89848 0l4.0523 4.15355 4.0523-4.15357c.2481-.25429.6504-.25429.8985 0 .2481.2543.2481.66659 0 .92088l-4.0524 4.15359 4.3155 4.4232c.2481.2543.2481.6666 0 .9209s-.6503.2543-.8984 0l-4.3155-4.4233-4.3155 4.4233c-.24808.2543-.65033.2543-.89843 0z",
            fill: "currentColor"
        })
    });
};


var $4783fbf7ab12c36f$export$2ba01fb71ed41cb6;
var $4783fbf7ab12c36f$export$bbea856fdb3e3c5f;
var $4783fbf7ab12c36f$export$e8e78c978b129247;
var $4783fbf7ab12c36f$export$120ff0929b202a6d;
var $4783fbf7ab12c36f$export$6f093cfa640b7166;
var $4783fbf7ab12c36f$export$2ab9a8f9f1186f14;
$4783fbf7ab12c36f$export$2ba01fb71ed41cb6 = `jFXhIW_button`;
$4783fbf7ab12c36f$export$bbea856fdb3e3c5f = `jFXhIW_buttons`;
$4783fbf7ab12c36f$export$e8e78c978b129247 = `jFXhIW_root`;
$4783fbf7ab12c36f$export$120ff0929b202a6d = `jFXhIW_row`;
$4783fbf7ab12c36f$export$6f093cfa640b7166 = `jFXhIW_text`;
$4783fbf7ab12c36f$export$2ab9a8f9f1186f14 = `jFXhIW_value`;


const $ee2e712173b9961f$var$NumPadButton = ({ input: input, onInput: onInput })=>{
    const onClick = (0, $acw62.useCallback)(()=>onInput(input), [
        onInput,
        input
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: $4783fbf7ab12c36f$export$2ba01fb71ed41cb6,
        type: "button",
        onClick: onClick,
        children: input
    });
};
const $ee2e712173b9961f$export$52cea4e667a8296a = ()=>{
    const { symbol: symbol, decimals: decimals } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const regExp = (0, $acw62.useMemo)(()=>new RegExp('^\\d*([.,]\\d{0,' + decimals + '})?$'), [
        decimals
    ]);
    const [value, setValue] = (0, $acw62.useState)('0');
    const onInput = (0, $acw62.useCallback)((key)=>setValue((value)=>{
            let newValue = (value + key).trim().replace(/^0{2,}/, '0');
            if (newValue) {
                newValue = /^[.,]/.test(newValue) ? `0${newValue}` : newValue.replace(/^0+(\d)/, '$1');
                if (regExp.test(newValue)) return newValue;
            }
            return value;
        }), [
        regExp
    ]);
    const onBackspace = (0, $acw62.useCallback)(()=>setValue((value)=>value.length ? value.slice(0, -1) || '0' : value), []);
    const { setAmount: setAmount } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    (0, $acw62.useEffect)(()=>setAmount(value ? new (0, $dws6U.default)(value) : undefined), [
        setAmount,
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $4783fbf7ab12c36f$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $4783fbf7ab12c36f$export$6f093cfa640b7166,
                children: [
                    "Enter amount in ",
                    symbol
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $4783fbf7ab12c36f$export$2ab9a8f9f1186f14,
                children: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $4783fbf7ab12c36f$export$bbea856fdb3e3c5f,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $4783fbf7ab12c36f$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 1,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 2,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 3,
                                onInput: onInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $4783fbf7ab12c36f$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 4,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 5,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 6,
                                onInput: onInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $4783fbf7ab12c36f$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 7,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 8,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 9,
                                onInput: onInput
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $4783fbf7ab12c36f$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: ".",
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ee2e712173b9961f$var$NumPadButton, {
                                input: 0,
                                onInput: onInput
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: $4783fbf7ab12c36f$export$2ba01fb71ed41cb6,
                                type: "button",
                                onClick: onBackspace,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88d1b0b035476dbb$export$12a4185d7caff8bd), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $gNDby = parcelRequire("gNDby");
const $c3c4612a04ae44e4$export$d1c6250ed44053f0 = 32;
const $c3c4612a04ae44e4$export$5692c2d0651ebabe = '\u00a0';
const $c3c4612a04ae44e4$export$2416cc3545b31c3b = (0, $gNDby.clusterApiUrl)('devnet');
const $c3c4612a04ae44e4$export$9462d80112b287bf = 'https://solanapay.genesysgo.net';
const $c3c4612a04ae44e4$export$407c7682e36ba598 = new (0, $gNDby.PublicKey)('Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr');
const $c3c4612a04ae44e4$export$345906519ca69d44 = new (0, $gNDby.PublicKey)('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v');


const $1cb71ddbb0c9a1f3$export$5a2795e4838b67d2 = ({ amount: amount, showZero: showZero })=>{
    const { minDecimals: minDecimals } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const value = (0, $acw62.useMemo)(()=>{
        if (!amount) return 0, $c3c4612a04ae44e4$export$5692c2d0651ebabe;
        if (amount.isGreaterThan(0)) return amount.toFormat(amount.decimalPlaces() < minDecimals ? minDecimals : amount.decimalPlaces());
        else return showZero ? '0' : (0, $c3c4612a04ae44e4$export$5692c2d0651ebabe);
    }, [
        amount,
        minDecimals,
        showZero
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: value
    });
};


var $d20ce5aebb5e5ba9$export$802cfe72001a1ee;
var $d20ce5aebb5e5ba9$export$e8e78c978b129247;
var $d20ce5aebb5e5ba9$export$8f701197936bc2a6;
var $d20ce5aebb5e5ba9$export$fb184b623420d9be;
var $d20ce5aebb5e5ba9$export$9086bb9c16b2b5b;
var $d20ce5aebb5e5ba9$export$99a3dcde488cb48a;
var $d20ce5aebb5e5ba9$export$23a0ecf046456a83;
$d20ce5aebb5e5ba9$export$802cfe72001a1ee = `_8F2YqW_amount`;
$d20ce5aebb5e5ba9$export$e8e78c978b129247 = `_8F2YqW_root`;
$d20ce5aebb5e5ba9$export$8f701197936bc2a6 = `_8F2YqW_symbol`;
$d20ce5aebb5e5ba9$export$fb184b623420d9be = `_8F2YqW_title`;
$d20ce5aebb5e5ba9$export$9086bb9c16b2b5b = `_8F2YqW_total`;
$d20ce5aebb5e5ba9$export$99a3dcde488cb48a = `_8F2YqW_totalLeft`;
$d20ce5aebb5e5ba9$export$23a0ecf046456a83 = `_8F2YqW_totalRight`;


const $448449d5013a6638$export$46453a0401d6cd1a = ()=>{
    const { symbol: symbol } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const { amount: amount } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $d20ce5aebb5e5ba9$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $d20ce5aebb5e5ba9$export$fb184b623420d9be,
                children: "Balance Due"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $d20ce5aebb5e5ba9$export$9086bb9c16b2b5b,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $d20ce5aebb5e5ba9$export$99a3dcde488cb48a,
                        children: "Total"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $d20ce5aebb5e5ba9$export$23a0ecf046456a83,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: $d20ce5aebb5e5ba9$export$8f701197936bc2a6,
                                children: symbol
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: $d20ce5aebb5e5ba9$export$802cfe72001a1ee,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cb71ddbb0c9a1f3$export$5a2795e4838b67d2), {
                                    amount: amount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


var $b9039f7656642a66$export$32180ef41b15b513;
var $b9039f7656642a66$export$40e543e69a8b3fbb;
var $b9039f7656642a66$export$f22da7240b7add18;
var $b9039f7656642a66$export$e8e78c978b129247;
var $b9039f7656642a66$export$56a7b65538036bea;
var $b9039f7656642a66$export$9a2dbef7a17e2e58;
var $b9039f7656642a66$export$1e95b668f3b82d;
$b9039f7656642a66$export$32180ef41b15b513 = `YMnBfW_body`;
$b9039f7656642a66$export$40e543e69a8b3fbb = `YMnBfW_bottom`;
$b9039f7656642a66$export$f22da7240b7add18 = `YMnBfW_main`;
$b9039f7656642a66$export$e8e78c978b129247 = `YMnBfW_root`;
$b9039f7656642a66$export$56a7b65538036bea = `YMnBfW_side`;
$b9039f7656642a66$export$9a2dbef7a17e2e58 = `YMnBfW_summary`;
$b9039f7656642a66$export$1e95b668f3b82d = `YMnBfW_top`;


const $aef8e6ccd0a71b25$export$d9b48143d220099f = ()=>{
    const phone = (0, $585bdbcc7e56c6f1$exports.useMediaQuery)({
        query: '(max-width: 767px)'
    });
    return phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $b9039f7656642a66$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $b9039f7656642a66$export$1e95b668f3b82d,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfa077b59a1fad6$export$305be705ce696d42), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af3c66d7b5a8b8ae$export$fa72d1da6a8e16c8), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $b9039f7656642a66$export$32180ef41b15b513,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee2e712173b9961f$export$52cea4e667a8296a), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a1624aa8d074ee2$export$49445b09fc6713d3), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24), {})
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $b9039f7656642a66$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $b9039f7656642a66$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $b9039f7656642a66$export$1e95b668f3b82d,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cfa077b59a1fad6$export$305be705ce696d42), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $b9039f7656642a66$export$32180ef41b15b513,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee2e712173b9961f$export$52cea4e667a8296a), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $b9039f7656642a66$export$56a7b65538036bea,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $b9039f7656642a66$export$9a2dbef7a17e2e58,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $448449d5013a6638$export$46453a0401d6cd1a), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a1624aa8d074ee2$export$49445b09fc6713d3), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $b9039f7656642a66$export$40e543e69a8b3fbb,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af3c66d7b5a8b8ae$export$fa72d1da6a8e16c8), {})
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
const $3aa6d87558212265$var$EMPTY_ARRAY = [];
const $3aa6d87558212265$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select () {
        $3aa6d87558212265$var$logMissingProviderError('call', 'select');
    },
    connect () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'connect'));
    },
    disconnect () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'disconnect'));
    },
    sendTransaction () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'sendTransaction'));
    },
    signTransaction () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'signTransaction'));
    },
    signAllTransactions () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'signAllTransactions'));
    },
    signMessage () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'signMessage'));
    },
    signIn () {
        return Promise.reject($3aa6d87558212265$var$logMissingProviderError('call', 'signIn'));
    }
};
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, 'wallets', {
    get () {
        $3aa6d87558212265$var$logMissingProviderError('read', 'wallets');
        return $3aa6d87558212265$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, 'wallet', {
    get () {
        $3aa6d87558212265$var$logMissingProviderError('read', 'wallet');
        return null;
    }
});
Object.defineProperty($3aa6d87558212265$var$DEFAULT_CONTEXT, 'publicKey', {
    get () {
        $3aa6d87558212265$var$logMissingProviderError('read', 'publicKey');
        return null;
    }
});
function $3aa6d87558212265$var$logMissingProviderError(action, property) {
    const error = new Error(`You have tried to ${action} "${property}" on a WalletContext without providing one. ` + 'Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.');
    console.error(error);
    return error;
}
const $3aa6d87558212265$export$19648c908dc8d0bf = (0, $acw62.createContext)($3aa6d87558212265$var$DEFAULT_CONTEXT);
function $3aa6d87558212265$export$c34addee860b0acb() {
    return (0, $acw62.useContext)($3aa6d87558212265$export$19648c908dc8d0bf);
}



var $acw62 = parcelRequire("acw62");
const $ca40ecc6394b8d2e$var$DEFAULT_CONTEXT = {
    setVisible (_open) {
        console.error($ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage('call', 'setVisible'));
    },
    visible: false
};
Object.defineProperty($ca40ecc6394b8d2e$var$DEFAULT_CONTEXT, 'visible', {
    get () {
        console.error($ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage('read', 'visible'));
        return false;
    }
});
function $ca40ecc6394b8d2e$var$constructMissingProviderErrorMessage(action, valueName) {
    return 'You have tried to ' + ` ${action} "${valueName}"` + ' on a WalletModalContext without providing one.' + ' Make sure to render a WalletModalProvider' + ' as an ancestor of the component that uses ' + 'WalletModalContext';
}
const $ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87 = (0, $acw62.createContext)($ca40ecc6394b8d2e$var$DEFAULT_CONTEXT);
function $ca40ecc6394b8d2e$export$6fdf0454adae214b() {
    return (0, $acw62.useContext)($ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87);
}


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $f5ec975d3f9bb9fc$export$629f18756d2627db({ onSelectWallet: onSelectWallet }) {
    const { connect: connect, connected: connected, connecting: connecting, disconnect: disconnect, disconnecting: disconnecting, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    let buttonState;
    if (connecting) buttonState = 'connecting';
    else if (connected) buttonState = 'connected';
    else if (disconnecting) buttonState = 'disconnecting';
    else if (wallet) buttonState = 'has-wallet';
    else buttonState = 'no-wallet';
    const handleConnect = (0, $acw62.useCallback)(()=>{
        connect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    const handleDisconnect = (0, $acw62.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    const handleSelectWallet = (0, $acw62.useCallback)(()=>{
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === 'has-wallet' ? handleConnect : undefined,
        onDisconnect: buttonState !== 'disconnecting' && buttonState !== 'no-wallet' ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey ?? undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $ed43aee2b6d2385b$export$353f5b6fc5456de1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `wallet-adapter-button ${props.className || ''}`,
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $acw62 = parcelRequire("acw62");
const $74cea3e5b753b58c$export$deff84e7338ee5a5 = ({ wallet: wallet, ...props })=>{
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: wallet.adapter.icon,
        alt: `${wallet.adapter.name} icon`,
        ...props
    });
};


function $b22e3674ed9a2d26$export$a0d4a8038508425f({ walletIcon: walletIcon, walletName: walletName, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed43aee2b6d2385b$export$353f5b6fc5456de1), {
        ...props,
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74cea3e5b753b58c$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    });
}



function $79c7c16679bb5b21$export$50382f20865178f9({ children: children, labels: labels, ...props }) {
    const { setVisible: setModalVisible } = (0, $ca40ecc6394b8d2e$export$6fdf0454adae214b)();
    const { buttonState: buttonState, onConnect: onConnect, onDisconnect: onDisconnect, publicKey: publicKey, walletIcon: walletIcon, walletName: walletName } = (0, $f5ec975d3f9bb9fc$export$629f18756d2627db)({
        onSelectWallet () {
            setModalVisible(true);
        }
    });
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const listener = (event)=>{
            const node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return ()=>{
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, []);
    const content = (0, $acw62.useMemo)(()=>{
        if (children) return children;
        else if (publicKey) {
            const base58 = publicKey.toBase58();
            return base58.slice(0, 4) + '..' + base58.slice(-4);
        } else if (buttonState === 'connecting' || buttonState === 'has-wallet') return labels[buttonState];
        else return labels['no-wallet'];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b22e3674ed9a2d26$export$a0d4a8038508425f), {
        ...props,
        "aria-expanded": menuOpen,
        style: {
            pointerEvents: menuOpen ? 'none' : 'auto',
            ...props.style
        },
        onClick: ()=>{
            switch(buttonState){
                case 'no-wallet':
                    setModalVisible(true);
                    break;
                case 'has-wallet':
                    if (onConnect) onConnect();
                    break;
                case 'connected':
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: `wallet-adapter-dropdown-list ${menuOpen && 'wallet-adapter-dropdown-list-active'}`,
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: async ()=>{
            await navigator.clipboard.writeText(publicKey.toBase58());
            setCopied(true);
            setTimeout(()=>setCopied(false), 400);
        },
        role: "menuitem"
    }, copied ? labels['copied'] : labels['copy-address']) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels['change-wallet']), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels['disconnect']) : null));
}


const $b30bad04ca015373$var$LABELS = {
    'change-wallet': 'Change wallet',
    connecting: 'Connecting ...',
    'copy-address': 'Copy address',
    copied: 'Copied',
    disconnect: 'Disconnect',
    'has-wallet': 'Connect',
    'no-wallet': 'Select Wallet'
};
function $b30bad04ca015373$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $79c7c16679bb5b21$export$50382f20865178f9), {
        ...props,
        labels: $b30bad04ca015373$var$LABELS
    });
}



var $acw62 = parcelRequire("acw62");







var $gNDby = parcelRequire("gNDby");

var $dws6U = parcelRequire("dws6U");
const $f49a3504c5beffd8$export$2546bf70c51987d9 = 'solana:';
const $f49a3504c5beffd8$export$68da760adb1ea70f = 'https:';
const $f49a3504c5beffd8$export$8187fb71f6d8e245 = new (0, $gNDby.PublicKey)('MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr');
const $f49a3504c5beffd8$export$68a35e92ed907a83 = 9;
const $f49a3504c5beffd8$export$119bd8bf66781cd5 = new (0, $dws6U.default)(10);


var $35c4bfa083870778$exports = {};
!function(t, e) {
    $35c4bfa083870778$exports = e();
}($35c4bfa083870778$exports, function() {
    return (()=>{
        var t = {
            192: (t, e)=>{
                var r, n, i = function() {
                    var t = function(t, e) {
                        var r = t, n = a[e], i = null, o = 0, u = null, v = [], w = {}, m = function(t, e) {
                            i = function(t) {
                                for(var e = new Array(t), r = 0; r < t; r += 1){
                                    e[r] = new Array(t);
                                    for(var n = 0; n < t; n += 1)e[r][n] = null;
                                }
                                return e;
                            }(o = 4 * r + 17), _(0, 0), _(o - 7, 0), _(0, o - 7), x(), b(), C(t, e), r >= 7 && S(t), null == u && (u = M(r, n, v)), A(u, e);
                        }, _ = function(t, e) {
                            for(var r = -1; r <= 7; r += 1)if (!(t + r <= -1 || o <= t + r)) for(var n = -1; n <= 7; n += 1)e + n <= -1 || o <= e + n || (i[t + r][e + n] = 0 <= r && r <= 6 && (0 == n || 6 == n) || 0 <= n && n <= 6 && (0 == r || 6 == r) || 2 <= r && r <= 4 && 2 <= n && n <= 4);
                        }, b = function() {
                            for(var t = 8; t < o - 8; t += 1)null == i[t][6] && (i[t][6] = t % 2 == 0);
                            for(var e = 8; e < o - 8; e += 1)null == i[6][e] && (i[6][e] = e % 2 == 0);
                        }, x = function() {
                            for(var t = s.getPatternPosition(r), e = 0; e < t.length; e += 1)for(var n = 0; n < t.length; n += 1){
                                var o = t[e], a = t[n];
                                if (null == i[o][a]) for(var u = -2; u <= 2; u += 1)for(var h = -2; h <= 2; h += 1)i[o + u][a + h] = -2 == u || 2 == u || -2 == h || 2 == h || 0 == u && 0 == h;
                            }
                        }, S = function(t) {
                            for(var e = s.getBCHTypeNumber(r), n = 0; n < 18; n += 1){
                                var a = !t && 1 == (e >> n & 1);
                                i[Math.floor(n / 3)][n % 3 + o - 8 - 3] = a;
                            }
                            for(n = 0; n < 18; n += 1)a = !t && 1 == (e >> n & 1), i[n % 3 + o - 8 - 3][Math.floor(n / 3)] = a;
                        }, C = function(t, e) {
                            for(var r = n << 3 | e, a = s.getBCHTypeInfo(r), u = 0; u < 15; u += 1){
                                var h = !t && 1 == (a >> u & 1);
                                u < 6 ? i[u][8] = h : u < 8 ? i[u + 1][8] = h : i[o - 15 + u][8] = h;
                            }
                            for(u = 0; u < 15; u += 1)h = !t && 1 == (a >> u & 1), u < 8 ? i[8][o - u - 1] = h : u < 9 ? i[8][15 - u - 1 + 1] = h : i[8][15 - u - 1] = h;
                            i[o - 8][8] = !t;
                        }, A = function(t, e) {
                            for(var r = -1, n = o - 1, a = 7, u = 0, h = s.getMaskFunction(e), c = o - 1; c > 0; c -= 2)for(6 == c && (c -= 1);;){
                                for(var l = 0; l < 2; l += 1)if (null == i[n][c - l]) {
                                    var d = !1;
                                    u < t.length && (d = 1 == (t[u] >>> a & 1)), h(n, c - l) && (d = !d), i[n][c - l] = d, -1 == (a -= 1) && (u += 1, a = 7);
                                }
                                if ((n += r) < 0 || o <= n) {
                                    n -= r, r = -r;
                                    break;
                                }
                            }
                        }, M = function(t, e, r) {
                            for(var n = c.getRSBlocks(t, e), i = l(), o = 0; o < r.length; o += 1){
                                var a = r[o];
                                i.put(a.getMode(), 4), i.put(a.getLength(), s.getLengthInBits(a.getMode(), t)), a.write(i);
                            }
                            var u = 0;
                            for(o = 0; o < n.length; o += 1)u += n[o].dataCount;
                            if (i.getLengthInBits() > 8 * u) throw "code length overflow. (" + i.getLengthInBits() + ">" + 8 * u + ")";
                            for(i.getLengthInBits() + 4 <= 8 * u && i.put(0, 4); i.getLengthInBits() % 8 != 0;)i.putBit(!1);
                            for(; !(i.getLengthInBits() >= 8 * u || (i.put(236, 8), i.getLengthInBits() >= 8 * u));)i.put(17, 8);
                            return function(t, e) {
                                for(var r = 0, n = 0, i = 0, o = new Array(e.length), a = new Array(e.length), u = 0; u < e.length; u += 1){
                                    var c = e[u].dataCount, l = e[u].totalCount - c;
                                    n = Math.max(n, c), i = Math.max(i, l), o[u] = new Array(c);
                                    for(var d = 0; d < o[u].length; d += 1)o[u][d] = 255 & t.getBuffer()[d + r];
                                    r += c;
                                    var f = s.getErrorCorrectPolynomial(l), g = h(o[u], f.getLength() - 1).mod(f);
                                    for(a[u] = new Array(f.getLength() - 1), d = 0; d < a[u].length; d += 1){
                                        var p = d + g.getLength() - a[u].length;
                                        a[u][d] = p >= 0 ? g.getAt(p) : 0;
                                    }
                                }
                                var v = 0;
                                for(d = 0; d < e.length; d += 1)v += e[d].totalCount;
                                var w = new Array(v), y = 0;
                                for(d = 0; d < n; d += 1)for(u = 0; u < e.length; u += 1)d < o[u].length && (w[y] = o[u][d], y += 1);
                                for(d = 0; d < i; d += 1)for(u = 0; u < e.length; u += 1)d < a[u].length && (w[y] = a[u][d], y += 1);
                                return w;
                            }(i, n);
                        };
                        w.addData = function(t, e) {
                            var r = null;
                            switch(e = e || "Byte"){
                                case "Numeric":
                                    r = d(t);
                                    break;
                                case "Alphanumeric":
                                    r = f(t);
                                    break;
                                case "Byte":
                                    r = g(t);
                                    break;
                                case "Kanji":
                                    r = p(t);
                                    break;
                                default:
                                    throw "mode:" + e;
                            }
                            v.push(r), u = null;
                        }, w.isDark = function(t, e) {
                            if (t < 0 || o <= t || e < 0 || o <= e) throw t + "," + e;
                            return i[t][e];
                        }, w.getModuleCount = function() {
                            return o;
                        }, w.make = function() {
                            if (r < 1) {
                                for(var t = 1; t < 40; t++){
                                    for(var e = c.getRSBlocks(t, n), i = l(), o = 0; o < v.length; o++){
                                        var a = v[o];
                                        i.put(a.getMode(), 4), i.put(a.getLength(), s.getLengthInBits(a.getMode(), t)), a.write(i);
                                    }
                                    var u = 0;
                                    for(o = 0; o < e.length; o++)u += e[o].dataCount;
                                    if (i.getLengthInBits() <= 8 * u) break;
                                }
                                r = t;
                            }
                            m(!1, function() {
                                for(var t = 0, e = 0, r = 0; r < 8; r += 1){
                                    m(!0, r);
                                    var n = s.getLostPoint(w);
                                    (0 == r || t > n) && (t = n, e = r);
                                }
                                return e;
                            }());
                        }, w.createTableTag = function(t, e) {
                            t = t || 2;
                            var r = "";
                            r += '<table style="', r += " border-width: 0px; border-style: none;", r += " border-collapse: collapse;", r += " padding: 0px; margin: " + (e = void 0 === e ? 4 * t : e) + "px;", r += '">', r += "<tbody>";
                            for(var n = 0; n < w.getModuleCount(); n += 1){
                                r += "<tr>";
                                for(var i = 0; i < w.getModuleCount(); i += 1)r += '<td style="', r += " border-width: 0px; border-style: none;", r += " border-collapse: collapse;", r += " padding: 0px; margin: 0px;", r += " width: " + t + "px;", r += " height: " + t + "px;", r += " background-color: ", r += w.isDark(n, i) ? "#000000" : "#ffffff", r += ";", r += '"/>';
                                r += "</tr>";
                            }
                            return (r += "</tbody>") + "</table>";
                        }, w.createSvgTag = function(t, e, r, n) {
                            var i = {};
                            "object" == typeof arguments[0] && (t = (i = arguments[0]).cellSize, e = i.margin, r = i.alt, n = i.title), t = t || 2, e = void 0 === e ? 4 * t : e, (r = "string" == typeof r ? {
                                text: r
                            } : r || {}).text = r.text || null, r.id = r.text ? r.id || "qrcode-description" : null, (n = "string" == typeof n ? {
                                text: n
                            } : n || {}).text = n.text || null, n.id = n.text ? n.id || "qrcode-title" : null;
                            var o, a, s, u, h = w.getModuleCount() * t + 2 * e, c = "";
                            for(u = "l" + t + ",0 0," + t + " -" + t + ",0 0,-" + t + "z ", c += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"', c += i.scalable ? "" : ' width="' + h + 'px" height="' + h + 'px"', c += ' viewBox="0 0 ' + h + " " + h + '" ', c += ' preserveAspectRatio="xMinYMin meet"', c += n.text || r.text ? ' role="img" aria-labelledby="' + k([
                                n.id,
                                r.id
                            ].join(" ").trim()) + '"' : "", c += ">", c += n.text ? '<title id="' + k(n.id) + '">' + k(n.text) + "</title>" : "", c += r.text ? '<description id="' + k(r.id) + '">' + k(r.text) + "</description>" : "", c += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>', c += '<path d="', a = 0; a < w.getModuleCount(); a += 1)for(s = a * t + e, o = 0; o < w.getModuleCount(); o += 1)w.isDark(a, o) && (c += "M" + (o * t + e) + "," + s + u);
                            return (c += '" stroke="transparent" fill="black"/>') + "</svg>";
                        }, w.createDataURL = function(t, e) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var r = w.getModuleCount() * t + 2 * e, n = e, i = r - e;
                            return y(r, r, function(e, r) {
                                if (n <= e && e < i && n <= r && r < i) {
                                    var o = Math.floor((e - n) / t), a = Math.floor((r - n) / t);
                                    return w.isDark(a, o) ? 0 : 1;
                                }
                                return 1;
                            });
                        }, w.createImgTag = function(t, e, r) {
                            t = t || 2, e = void 0 === e ? 4 * t : e;
                            var n = w.getModuleCount() * t + 2 * e, i = "";
                            return i += "<img", i += ' src="', i += w.createDataURL(t, e), i += '"', i += ' width="', i += n, i += '"', i += ' height="', i += n, i += '"', r && (i += ' alt="', i += k(r), i += '"'), i + "/>";
                        };
                        var k = function(t) {
                            for(var e = "", r = 0; r < t.length; r += 1){
                                var n = t.charAt(r);
                                switch(n){
                                    case "<":
                                        e += "&lt;";
                                        break;
                                    case ">":
                                        e += "&gt;";
                                        break;
                                    case "&":
                                        e += "&amp;";
                                        break;
                                    case '"':
                                        e += "&quot;";
                                        break;
                                    default:
                                        e += n;
                                }
                            }
                            return e;
                        };
                        return w.createASCII = function(t, e) {
                            if ((t = t || 1) < 2) return function(t) {
                                t = void 0 === t ? 2 : t;
                                var e, r, n, i, o, a = 1 * w.getModuleCount() + 2 * t, s = t, u = a - t, h = {
                                    "\u2588\u2588": "\u2588",
                                    "\u2588 ": "\u2580",
                                    " \u2588": "\u2584",
                                    "  ": " "
                                }, c = {
                                    "\u2588\u2588": "\u2580",
                                    "\u2588 ": "\u2580",
                                    " \u2588": " ",
                                    "  ": " "
                                }, l = "";
                                for(e = 0; e < a; e += 2){
                                    for(n = Math.floor((e - s) / 1), i = Math.floor((e + 1 - s) / 1), r = 0; r < a; r += 1)o = "\u2588", s <= r && r < u && s <= e && e < u && w.isDark(n, Math.floor((r - s) / 1)) && (o = " "), s <= r && r < u && s <= e + 1 && e + 1 < u && w.isDark(i, Math.floor((r - s) / 1)) ? o += " " : o += "\u2588", l += t < 1 && e + 1 >= u ? c[o] : h[o];
                                    l += "\n";
                                }
                                return a % 2 && t > 0 ? l.substring(0, l.length - a - 1) + Array(a + 1).join("\u2580") : l.substring(0, l.length - 1);
                            }(e);
                            t -= 1, e = void 0 === e ? 2 * t : e;
                            var r, n, i, o, a = w.getModuleCount() * t + 2 * e, s = e, u = a - e, h = Array(t + 1).join("\u2588\u2588"), c = Array(t + 1).join("  "), l = "", d = "";
                            for(r = 0; r < a; r += 1){
                                for(i = Math.floor((r - s) / t), d = "", n = 0; n < a; n += 1)o = 1, s <= n && n < u && s <= r && r < u && w.isDark(i, Math.floor((n - s) / t)) && (o = 0), d += o ? h : c;
                                for(i = 0; i < t; i += 1)l += d + "\n";
                            }
                            return l.substring(0, l.length - 1);
                        }, w.renderTo2dContext = function(t, e) {
                            e = e || 2;
                            for(var r = w.getModuleCount(), n = 0; n < r; n++)for(var i = 0; i < r; i++)t.fillStyle = w.isDark(n, i) ? "black" : "white", t.fillRect(n * e, i * e, e, e);
                        }, w;
                    };
                    t.stringToBytes = (t.stringToBytesFuncs = {
                        default: function(t) {
                            for(var e = [], r = 0; r < t.length; r += 1){
                                var n = t.charCodeAt(r);
                                e.push(255 & n);
                            }
                            return e;
                        }
                    }).default, t.createStringToBytes = function(t, e) {
                        var r = function() {
                            for(var r = w(t), n = function() {
                                var t = r.read();
                                if (-1 == t) throw "eof";
                                return t;
                            }, i = 0, o = {};;){
                                var a = r.read();
                                if (-1 == a) break;
                                var s = n(), u = n() << 8 | n();
                                o[String.fromCharCode(a << 8 | s)] = u, i += 1;
                            }
                            if (i != e) throw i + " != " + e;
                            return o;
                        }(), n = "?".charCodeAt(0);
                        return function(t) {
                            for(var e = [], i = 0; i < t.length; i += 1){
                                var o = t.charCodeAt(i);
                                if (o < 128) e.push(o);
                                else {
                                    var a = r[t.charAt(i)];
                                    "number" == typeof a ? (255 & a) == a ? e.push(a) : (e.push(a >>> 8), e.push(255 & a)) : e.push(n);
                                }
                            }
                            return e;
                        };
                    };
                    var e, r, n, i, o, a = {
                        L: 1,
                        M: 0,
                        Q: 3,
                        H: 2
                    }, s = (e = [
                        [],
                        [
                            6,
                            18
                        ],
                        [
                            6,
                            22
                        ],
                        [
                            6,
                            26
                        ],
                        [
                            6,
                            30
                        ],
                        [
                            6,
                            34
                        ],
                        [
                            6,
                            22,
                            38
                        ],
                        [
                            6,
                            24,
                            42
                        ],
                        [
                            6,
                            26,
                            46
                        ],
                        [
                            6,
                            28,
                            50
                        ],
                        [
                            6,
                            30,
                            54
                        ],
                        [
                            6,
                            32,
                            58
                        ],
                        [
                            6,
                            34,
                            62
                        ],
                        [
                            6,
                            26,
                            46,
                            66
                        ],
                        [
                            6,
                            26,
                            48,
                            70
                        ],
                        [
                            6,
                            26,
                            50,
                            74
                        ],
                        [
                            6,
                            30,
                            54,
                            78
                        ],
                        [
                            6,
                            30,
                            56,
                            82
                        ],
                        [
                            6,
                            30,
                            58,
                            86
                        ],
                        [
                            6,
                            34,
                            62,
                            90
                        ],
                        [
                            6,
                            28,
                            50,
                            72,
                            94
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118
                        ],
                        [
                            6,
                            26,
                            50,
                            74,
                            98,
                            122
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126
                        ],
                        [
                            6,
                            26,
                            52,
                            78,
                            104,
                            130
                        ],
                        [
                            6,
                            30,
                            56,
                            82,
                            108,
                            134
                        ],
                        [
                            6,
                            34,
                            60,
                            86,
                            112,
                            138
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142
                        ],
                        [
                            6,
                            34,
                            62,
                            90,
                            118,
                            146
                        ],
                        [
                            6,
                            30,
                            54,
                            78,
                            102,
                            126,
                            150
                        ],
                        [
                            6,
                            24,
                            50,
                            76,
                            102,
                            128,
                            154
                        ],
                        [
                            6,
                            28,
                            54,
                            80,
                            106,
                            132,
                            158
                        ],
                        [
                            6,
                            32,
                            58,
                            84,
                            110,
                            136,
                            162
                        ],
                        [
                            6,
                            26,
                            54,
                            82,
                            110,
                            138,
                            166
                        ],
                        [
                            6,
                            30,
                            58,
                            86,
                            114,
                            142,
                            170
                        ]
                    ], r = 1335, n = 7973, o = function(t) {
                        for(var e = 0; 0 != t;)e += 1, t >>>= 1;
                        return e;
                    }, (i = {}).getBCHTypeInfo = function(t) {
                        for(var e = t << 10; o(e) - o(r) >= 0;)e ^= r << o(e) - o(r);
                        return 21522 ^ (t << 10 | e);
                    }, i.getBCHTypeNumber = function(t) {
                        for(var e = t << 12; o(e) - o(n) >= 0;)e ^= n << o(e) - o(n);
                        return t << 12 | e;
                    }, i.getPatternPosition = function(t) {
                        return e[t - 1];
                    }, i.getMaskFunction = function(t) {
                        switch(t){
                            case 0:
                                return function(t, e) {
                                    return (t + e) % 2 == 0;
                                };
                            case 1:
                                return function(t, e) {
                                    return t % 2 == 0;
                                };
                            case 2:
                                return function(t, e) {
                                    return e % 3 == 0;
                                };
                            case 3:
                                return function(t, e) {
                                    return (t + e) % 3 == 0;
                                };
                            case 4:
                                return function(t, e) {
                                    return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
                                };
                            case 5:
                                return function(t, e) {
                                    return t * e % 2 + t * e % 3 == 0;
                                };
                            case 6:
                                return function(t, e) {
                                    return (t * e % 2 + t * e % 3) % 2 == 0;
                                };
                            case 7:
                                return function(t, e) {
                                    return (t * e % 3 + (t + e) % 2) % 2 == 0;
                                };
                            default:
                                throw "bad maskPattern:" + t;
                        }
                    }, i.getErrorCorrectPolynomial = function(t) {
                        for(var e = h([
                            1
                        ], 0), r = 0; r < t; r += 1)e = e.multiply(h([
                            1,
                            u.gexp(r)
                        ], 0));
                        return e;
                    }, i.getLengthInBits = function(t, e) {
                        if (1 <= e && e < 10) switch(t){
                            case 1:
                                return 10;
                            case 2:
                                return 9;
                            case 4:
                            case 8:
                                return 8;
                            default:
                                throw "mode:" + t;
                        }
                        else if (e < 27) switch(t){
                            case 1:
                                return 12;
                            case 2:
                                return 11;
                            case 4:
                                return 16;
                            case 8:
                                return 10;
                            default:
                                throw "mode:" + t;
                        }
                        else {
                            if (!(e < 41)) throw "type:" + e;
                            switch(t){
                                case 1:
                                    return 14;
                                case 2:
                                    return 13;
                                case 4:
                                    return 16;
                                case 8:
                                    return 12;
                                default:
                                    throw "mode:" + t;
                            }
                        }
                    }, i.getLostPoint = function(t) {
                        for(var e = t.getModuleCount(), r = 0, n = 0; n < e; n += 1)for(var i = 0; i < e; i += 1){
                            for(var o = 0, a = t.isDark(n, i), s = -1; s <= 1; s += 1)if (!(n + s < 0 || e <= n + s)) for(var u = -1; u <= 1; u += 1)i + u < 0 || e <= i + u || 0 == s && 0 == u || a == t.isDark(n + s, i + u) && (o += 1);
                            o > 5 && (r += 3 + o - 5);
                        }
                        for(n = 0; n < e - 1; n += 1)for(i = 0; i < e - 1; i += 1){
                            var h = 0;
                            t.isDark(n, i) && (h += 1), t.isDark(n + 1, i) && (h += 1), t.isDark(n, i + 1) && (h += 1), t.isDark(n + 1, i + 1) && (h += 1), 0 != h && 4 != h || (r += 3);
                        }
                        for(n = 0; n < e; n += 1)for(i = 0; i < e - 6; i += 1)t.isDark(n, i) && !t.isDark(n, i + 1) && t.isDark(n, i + 2) && t.isDark(n, i + 3) && t.isDark(n, i + 4) && !t.isDark(n, i + 5) && t.isDark(n, i + 6) && (r += 40);
                        for(i = 0; i < e; i += 1)for(n = 0; n < e - 6; n += 1)t.isDark(n, i) && !t.isDark(n + 1, i) && t.isDark(n + 2, i) && t.isDark(n + 3, i) && t.isDark(n + 4, i) && !t.isDark(n + 5, i) && t.isDark(n + 6, i) && (r += 40);
                        var c = 0;
                        for(i = 0; i < e; i += 1)for(n = 0; n < e; n += 1)t.isDark(n, i) && (c += 1);
                        return r + Math.abs(100 * c / e / e - 50) / 5 * 10;
                    }, i), u = function() {
                        for(var t = new Array(256), e = new Array(256), r = 0; r < 8; r += 1)t[r] = 1 << r;
                        for(r = 8; r < 256; r += 1)t[r] = t[r - 4] ^ t[r - 5] ^ t[r - 6] ^ t[r - 8];
                        for(r = 0; r < 255; r += 1)e[t[r]] = r;
                        return {
                            glog: function(t) {
                                if (t < 1) throw "glog(" + t + ")";
                                return e[t];
                            },
                            gexp: function(e) {
                                for(; e < 0;)e += 255;
                                for(; e >= 256;)e -= 255;
                                return t[e];
                            }
                        };
                    }();
                    function h(t, e) {
                        if (void 0 === t.length) throw t.length + "/" + e;
                        var r = function() {
                            for(var r = 0; r < t.length && 0 == t[r];)r += 1;
                            for(var n = new Array(t.length - r + e), i = 0; i < t.length - r; i += 1)n[i] = t[i + r];
                            return n;
                        }(), n = {
                            getAt: function(t) {
                                return r[t];
                            },
                            getLength: function() {
                                return r.length;
                            },
                            multiply: function(t) {
                                for(var e = new Array(n.getLength() + t.getLength() - 1), r = 0; r < n.getLength(); r += 1)for(var i = 0; i < t.getLength(); i += 1)e[r + i] ^= u.gexp(u.glog(n.getAt(r)) + u.glog(t.getAt(i)));
                                return h(e, 0);
                            },
                            mod: function(t) {
                                if (n.getLength() - t.getLength() < 0) return n;
                                for(var e = u.glog(n.getAt(0)) - u.glog(t.getAt(0)), r = new Array(n.getLength()), i = 0; i < n.getLength(); i += 1)r[i] = n.getAt(i);
                                for(i = 0; i < t.getLength(); i += 1)r[i] ^= u.gexp(u.glog(t.getAt(i)) + e);
                                return h(r, 0).mod(t);
                            }
                        };
                        return n;
                    }
                    var c = function() {
                        var t = [
                            [
                                1,
                                26,
                                19
                            ],
                            [
                                1,
                                26,
                                16
                            ],
                            [
                                1,
                                26,
                                13
                            ],
                            [
                                1,
                                26,
                                9
                            ],
                            [
                                1,
                                44,
                                34
                            ],
                            [
                                1,
                                44,
                                28
                            ],
                            [
                                1,
                                44,
                                22
                            ],
                            [
                                1,
                                44,
                                16
                            ],
                            [
                                1,
                                70,
                                55
                            ],
                            [
                                1,
                                70,
                                44
                            ],
                            [
                                2,
                                35,
                                17
                            ],
                            [
                                2,
                                35,
                                13
                            ],
                            [
                                1,
                                100,
                                80
                            ],
                            [
                                2,
                                50,
                                32
                            ],
                            [
                                2,
                                50,
                                24
                            ],
                            [
                                4,
                                25,
                                9
                            ],
                            [
                                1,
                                134,
                                108
                            ],
                            [
                                2,
                                67,
                                43
                            ],
                            [
                                2,
                                33,
                                15,
                                2,
                                34,
                                16
                            ],
                            [
                                2,
                                33,
                                11,
                                2,
                                34,
                                12
                            ],
                            [
                                2,
                                86,
                                68
                            ],
                            [
                                4,
                                43,
                                27
                            ],
                            [
                                4,
                                43,
                                19
                            ],
                            [
                                4,
                                43,
                                15
                            ],
                            [
                                2,
                                98,
                                78
                            ],
                            [
                                4,
                                49,
                                31
                            ],
                            [
                                2,
                                32,
                                14,
                                4,
                                33,
                                15
                            ],
                            [
                                4,
                                39,
                                13,
                                1,
                                40,
                                14
                            ],
                            [
                                2,
                                121,
                                97
                            ],
                            [
                                2,
                                60,
                                38,
                                2,
                                61,
                                39
                            ],
                            [
                                4,
                                40,
                                18,
                                2,
                                41,
                                19
                            ],
                            [
                                4,
                                40,
                                14,
                                2,
                                41,
                                15
                            ],
                            [
                                2,
                                146,
                                116
                            ],
                            [
                                3,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                36,
                                16,
                                4,
                                37,
                                17
                            ],
                            [
                                4,
                                36,
                                12,
                                4,
                                37,
                                13
                            ],
                            [
                                2,
                                86,
                                68,
                                2,
                                87,
                                69
                            ],
                            [
                                4,
                                69,
                                43,
                                1,
                                70,
                                44
                            ],
                            [
                                6,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                6,
                                43,
                                15,
                                2,
                                44,
                                16
                            ],
                            [
                                4,
                                101,
                                81
                            ],
                            [
                                1,
                                80,
                                50,
                                4,
                                81,
                                51
                            ],
                            [
                                4,
                                50,
                                22,
                                4,
                                51,
                                23
                            ],
                            [
                                3,
                                36,
                                12,
                                8,
                                37,
                                13
                            ],
                            [
                                2,
                                116,
                                92,
                                2,
                                117,
                                93
                            ],
                            [
                                6,
                                58,
                                36,
                                2,
                                59,
                                37
                            ],
                            [
                                4,
                                46,
                                20,
                                6,
                                47,
                                21
                            ],
                            [
                                7,
                                42,
                                14,
                                4,
                                43,
                                15
                            ],
                            [
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                59,
                                37,
                                1,
                                60,
                                38
                            ],
                            [
                                8,
                                44,
                                20,
                                4,
                                45,
                                21
                            ],
                            [
                                12,
                                33,
                                11,
                                4,
                                34,
                                12
                            ],
                            [
                                3,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                4,
                                64,
                                40,
                                5,
                                65,
                                41
                            ],
                            [
                                11,
                                36,
                                16,
                                5,
                                37,
                                17
                            ],
                            [
                                11,
                                36,
                                12,
                                5,
                                37,
                                13
                            ],
                            [
                                5,
                                109,
                                87,
                                1,
                                110,
                                88
                            ],
                            [
                                5,
                                65,
                                41,
                                5,
                                66,
                                42
                            ],
                            [
                                5,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                11,
                                36,
                                12,
                                7,
                                37,
                                13
                            ],
                            [
                                5,
                                122,
                                98,
                                1,
                                123,
                                99
                            ],
                            [
                                7,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                15,
                                43,
                                19,
                                2,
                                44,
                                20
                            ],
                            [
                                3,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                1,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                10,
                                74,
                                46,
                                1,
                                75,
                                47
                            ],
                            [
                                1,
                                50,
                                22,
                                15,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                17,
                                43,
                                15
                            ],
                            [
                                5,
                                150,
                                120,
                                1,
                                151,
                                121
                            ],
                            [
                                9,
                                69,
                                43,
                                4,
                                70,
                                44
                            ],
                            [
                                17,
                                50,
                                22,
                                1,
                                51,
                                23
                            ],
                            [
                                2,
                                42,
                                14,
                                19,
                                43,
                                15
                            ],
                            [
                                3,
                                141,
                                113,
                                4,
                                142,
                                114
                            ],
                            [
                                3,
                                70,
                                44,
                                11,
                                71,
                                45
                            ],
                            [
                                17,
                                47,
                                21,
                                4,
                                48,
                                22
                            ],
                            [
                                9,
                                39,
                                13,
                                16,
                                40,
                                14
                            ],
                            [
                                3,
                                135,
                                107,
                                5,
                                136,
                                108
                            ],
                            [
                                3,
                                67,
                                41,
                                13,
                                68,
                                42
                            ],
                            [
                                15,
                                54,
                                24,
                                5,
                                55,
                                25
                            ],
                            [
                                15,
                                43,
                                15,
                                10,
                                44,
                                16
                            ],
                            [
                                4,
                                144,
                                116,
                                4,
                                145,
                                117
                            ],
                            [
                                17,
                                68,
                                42
                            ],
                            [
                                17,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                19,
                                46,
                                16,
                                6,
                                47,
                                17
                            ],
                            [
                                2,
                                139,
                                111,
                                7,
                                140,
                                112
                            ],
                            [
                                17,
                                74,
                                46
                            ],
                            [
                                7,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                34,
                                37,
                                13
                            ],
                            [
                                4,
                                151,
                                121,
                                5,
                                152,
                                122
                            ],
                            [
                                4,
                                75,
                                47,
                                14,
                                76,
                                48
                            ],
                            [
                                11,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                16,
                                45,
                                15,
                                14,
                                46,
                                16
                            ],
                            [
                                6,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                6,
                                73,
                                45,
                                14,
                                74,
                                46
                            ],
                            [
                                11,
                                54,
                                24,
                                16,
                                55,
                                25
                            ],
                            [
                                30,
                                46,
                                16,
                                2,
                                47,
                                17
                            ],
                            [
                                8,
                                132,
                                106,
                                4,
                                133,
                                107
                            ],
                            [
                                8,
                                75,
                                47,
                                13,
                                76,
                                48
                            ],
                            [
                                7,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                13,
                                46,
                                16
                            ],
                            [
                                10,
                                142,
                                114,
                                2,
                                143,
                                115
                            ],
                            [
                                19,
                                74,
                                46,
                                4,
                                75,
                                47
                            ],
                            [
                                28,
                                50,
                                22,
                                6,
                                51,
                                23
                            ],
                            [
                                33,
                                46,
                                16,
                                4,
                                47,
                                17
                            ],
                            [
                                8,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                22,
                                73,
                                45,
                                3,
                                74,
                                46
                            ],
                            [
                                8,
                                53,
                                23,
                                26,
                                54,
                                24
                            ],
                            [
                                12,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                3,
                                147,
                                117,
                                10,
                                148,
                                118
                            ],
                            [
                                3,
                                73,
                                45,
                                23,
                                74,
                                46
                            ],
                            [
                                4,
                                54,
                                24,
                                31,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                31,
                                46,
                                16
                            ],
                            [
                                7,
                                146,
                                116,
                                7,
                                147,
                                117
                            ],
                            [
                                21,
                                73,
                                45,
                                7,
                                74,
                                46
                            ],
                            [
                                1,
                                53,
                                23,
                                37,
                                54,
                                24
                            ],
                            [
                                19,
                                45,
                                15,
                                26,
                                46,
                                16
                            ],
                            [
                                5,
                                145,
                                115,
                                10,
                                146,
                                116
                            ],
                            [
                                19,
                                75,
                                47,
                                10,
                                76,
                                48
                            ],
                            [
                                15,
                                54,
                                24,
                                25,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                25,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                3,
                                146,
                                116
                            ],
                            [
                                2,
                                74,
                                46,
                                29,
                                75,
                                47
                            ],
                            [
                                42,
                                54,
                                24,
                                1,
                                55,
                                25
                            ],
                            [
                                23,
                                45,
                                15,
                                28,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115
                            ],
                            [
                                10,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                10,
                                54,
                                24,
                                35,
                                55,
                                25
                            ],
                            [
                                19,
                                45,
                                15,
                                35,
                                46,
                                16
                            ],
                            [
                                17,
                                145,
                                115,
                                1,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                21,
                                75,
                                47
                            ],
                            [
                                29,
                                54,
                                24,
                                19,
                                55,
                                25
                            ],
                            [
                                11,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                13,
                                145,
                                115,
                                6,
                                146,
                                116
                            ],
                            [
                                14,
                                74,
                                46,
                                23,
                                75,
                                47
                            ],
                            [
                                44,
                                54,
                                24,
                                7,
                                55,
                                25
                            ],
                            [
                                59,
                                46,
                                16,
                                1,
                                47,
                                17
                            ],
                            [
                                12,
                                151,
                                121,
                                7,
                                152,
                                122
                            ],
                            [
                                12,
                                75,
                                47,
                                26,
                                76,
                                48
                            ],
                            [
                                39,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                22,
                                45,
                                15,
                                41,
                                46,
                                16
                            ],
                            [
                                6,
                                151,
                                121,
                                14,
                                152,
                                122
                            ],
                            [
                                6,
                                75,
                                47,
                                34,
                                76,
                                48
                            ],
                            [
                                46,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                2,
                                45,
                                15,
                                64,
                                46,
                                16
                            ],
                            [
                                17,
                                152,
                                122,
                                4,
                                153,
                                123
                            ],
                            [
                                29,
                                74,
                                46,
                                14,
                                75,
                                47
                            ],
                            [
                                49,
                                54,
                                24,
                                10,
                                55,
                                25
                            ],
                            [
                                24,
                                45,
                                15,
                                46,
                                46,
                                16
                            ],
                            [
                                4,
                                152,
                                122,
                                18,
                                153,
                                123
                            ],
                            [
                                13,
                                74,
                                46,
                                32,
                                75,
                                47
                            ],
                            [
                                48,
                                54,
                                24,
                                14,
                                55,
                                25
                            ],
                            [
                                42,
                                45,
                                15,
                                32,
                                46,
                                16
                            ],
                            [
                                20,
                                147,
                                117,
                                4,
                                148,
                                118
                            ],
                            [
                                40,
                                75,
                                47,
                                7,
                                76,
                                48
                            ],
                            [
                                43,
                                54,
                                24,
                                22,
                                55,
                                25
                            ],
                            [
                                10,
                                45,
                                15,
                                67,
                                46,
                                16
                            ],
                            [
                                19,
                                148,
                                118,
                                6,
                                149,
                                119
                            ],
                            [
                                18,
                                75,
                                47,
                                31,
                                76,
                                48
                            ],
                            [
                                34,
                                54,
                                24,
                                34,
                                55,
                                25
                            ],
                            [
                                20,
                                45,
                                15,
                                61,
                                46,
                                16
                            ]
                        ], e = function(t, e) {
                            var r = {};
                            return r.totalCount = t, r.dataCount = e, r;
                        }, r = {
                            getRSBlocks: function(r, n) {
                                var i = function(e, r) {
                                    switch(r){
                                        case a.L:
                                            return t[4 * (e - 1) + 0];
                                        case a.M:
                                            return t[4 * (e - 1) + 1];
                                        case a.Q:
                                            return t[4 * (e - 1) + 2];
                                        case a.H:
                                            return t[4 * (e - 1) + 3];
                                        default:
                                            return;
                                    }
                                }(r, n);
                                if (void 0 === i) throw "bad rs block @ typeNumber:" + r + "/errorCorrectionLevel:" + n;
                                for(var o = i.length / 3, s = [], u = 0; u < o; u += 1)for(var h = i[3 * u + 0], c = i[3 * u + 1], l = i[3 * u + 2], d = 0; d < h; d += 1)s.push(e(c, l));
                                return s;
                            }
                        };
                        return r;
                    }(), l = function() {
                        var t = [], e = 0, r = {
                            getBuffer: function() {
                                return t;
                            },
                            getAt: function(e) {
                                var r = Math.floor(e / 8);
                                return 1 == (t[r] >>> 7 - e % 8 & 1);
                            },
                            put: function(t, e) {
                                for(var n = 0; n < e; n += 1)r.putBit(1 == (t >>> e - n - 1 & 1));
                            },
                            getLengthInBits: function() {
                                return e;
                            },
                            putBit: function(r) {
                                var n = Math.floor(e / 8);
                                t.length <= n && t.push(0), r && (t[n] |= 128 >>> e % 8), e += 1;
                            }
                        };
                        return r;
                    }, d = function(t) {
                        var e = t, r = {
                            getMode: function() {
                                return 1;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var r = e, i = 0; i + 2 < r.length;)t.put(n(r.substring(i, i + 3)), 10), i += 3;
                                i < r.length && (r.length - i == 1 ? t.put(n(r.substring(i, i + 1)), 4) : r.length - i == 2 && t.put(n(r.substring(i, i + 2)), 7));
                            }
                        }, n = function(t) {
                            for(var e = 0, r = 0; r < t.length; r += 1)e = 10 * e + i(t.charAt(r));
                            return e;
                        }, i = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            throw "illegal char :" + t;
                        };
                        return r;
                    }, f = function(t) {
                        var e = t, r = {
                            getMode: function() {
                                return 2;
                            },
                            getLength: function(t) {
                                return e.length;
                            },
                            write: function(t) {
                                for(var r = e, i = 0; i + 1 < r.length;)t.put(45 * n(r.charAt(i)) + n(r.charAt(i + 1)), 11), i += 2;
                                i < r.length && t.put(n(r.charAt(i)), 6);
                            }
                        }, n = function(t) {
                            if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                            if ("A" <= t && t <= "Z") return t.charCodeAt(0) - "A".charCodeAt(0) + 10;
                            switch(t){
                                case " ":
                                    return 36;
                                case "$":
                                    return 37;
                                case "%":
                                    return 38;
                                case "*":
                                    return 39;
                                case "+":
                                    return 40;
                                case "-":
                                    return 41;
                                case ".":
                                    return 42;
                                case "/":
                                    return 43;
                                case ":":
                                    return 44;
                                default:
                                    throw "illegal char :" + t;
                            }
                        };
                        return r;
                    }, g = function(e) {
                        var r = t.stringToBytes(e);
                        return {
                            getMode: function() {
                                return 4;
                            },
                            getLength: function(t) {
                                return r.length;
                            },
                            write: function(t) {
                                for(var e = 0; e < r.length; e += 1)t.put(r[e], 8);
                            }
                        };
                    }, p = function(e) {
                        var r = t.stringToBytesFuncs.SJIS;
                        if (!r) throw "sjis not supported.";
                        !function(t, e) {
                            var n = r("\u53CB");
                            if (2 != n.length || 38726 != (n[0] << 8 | n[1])) throw "sjis not supported.";
                        }();
                        var n = r(e), i = {
                            getMode: function() {
                                return 8;
                            },
                            getLength: function(t) {
                                return ~~(n.length / 2);
                            },
                            write: function(t) {
                                for(var e = n, r = 0; r + 1 < e.length;){
                                    var i = (255 & e[r]) << 8 | 255 & e[r + 1];
                                    if (33088 <= i && i <= 40956) i -= 33088;
                                    else {
                                        if (!(57408 <= i && i <= 60351)) throw "illegal char at " + (r + 1) + "/" + i;
                                        i -= 49472;
                                    }
                                    i = 192 * (i >>> 8 & 255) + (255 & i), t.put(i, 13), r += 2;
                                }
                                if (r < e.length) throw "illegal char at " + (r + 1);
                            }
                        };
                        return i;
                    }, v = function() {
                        var t = [], e = {
                            writeByte: function(e) {
                                t.push(255 & e);
                            },
                            writeShort: function(t) {
                                e.writeByte(t), e.writeByte(t >>> 8);
                            },
                            writeBytes: function(t, r, n) {
                                r = r || 0, n = n || t.length;
                                for(var i = 0; i < n; i += 1)e.writeByte(t[i + r]);
                            },
                            writeString: function(t) {
                                for(var r = 0; r < t.length; r += 1)e.writeByte(t.charCodeAt(r));
                            },
                            toByteArray: function() {
                                return t;
                            },
                            toString: function() {
                                var e = "";
                                e += "[";
                                for(var r = 0; r < t.length; r += 1)r > 0 && (e += ","), e += t[r];
                                return e + "]";
                            }
                        };
                        return e;
                    }, w = function(t) {
                        var e = t, r = 0, n = 0, i = 0, o = {
                            read: function() {
                                for(; i < 8;){
                                    if (r >= e.length) {
                                        if (0 == i) return -1;
                                        throw "unexpected end of file./" + i;
                                    }
                                    var t = e.charAt(r);
                                    if (r += 1, "=" == t) return i = 0, -1;
                                    t.match(/^\s$/) || (n = n << 6 | a(t.charCodeAt(0)), i += 6);
                                }
                                var o = n >>> i - 8 & 255;
                                return i -= 8, o;
                            }
                        }, a = function(t) {
                            if (65 <= t && t <= 90) return t - 65;
                            if (97 <= t && t <= 122) return t - 97 + 26;
                            if (48 <= t && t <= 57) return t - 48 + 52;
                            if (43 == t) return 62;
                            if (47 == t) return 63;
                            throw "c:" + t;
                        };
                        return o;
                    }, y = function(t, e, r) {
                        for(var n = function(t, e) {
                            var r = t, n = e, i = new Array(t * e), o = {
                                setPixel: function(t, e, n) {
                                    i[e * r + t] = n;
                                },
                                write: function(t) {
                                    t.writeString("GIF87a"), t.writeShort(r), t.writeShort(n), t.writeByte(128), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(255), t.writeByte(255), t.writeByte(255), t.writeString(","), t.writeShort(0), t.writeShort(0), t.writeShort(r), t.writeShort(n), t.writeByte(0);
                                    var e = a(2);
                                    t.writeByte(2);
                                    for(var i = 0; e.length - i > 255;)t.writeByte(255), t.writeBytes(e, i, 255), i += 255;
                                    t.writeByte(e.length - i), t.writeBytes(e, i, e.length - i), t.writeByte(0), t.writeString(";");
                                }
                            }, a = function(t) {
                                for(var e = 1 << t, r = 1 + (1 << t), n = t + 1, o = s(), a = 0; a < e; a += 1)o.add(String.fromCharCode(a));
                                o.add(String.fromCharCode(e)), o.add(String.fromCharCode(r));
                                var u, h, c, l = v(), d = (u = l, h = 0, c = 0, {
                                    write: function(t, e) {
                                        if (t >>> e != 0) throw "length over";
                                        for(; h + e >= 8;)u.writeByte(255 & (t << h | c)), e -= 8 - h, t >>>= 8 - h, c = 0, h = 0;
                                        c |= t << h, h += e;
                                    },
                                    flush: function() {
                                        h > 0 && u.writeByte(c);
                                    }
                                });
                                d.write(e, n);
                                var f = 0, g = String.fromCharCode(i[f]);
                                for(f += 1; f < i.length;){
                                    var p = String.fromCharCode(i[f]);
                                    f += 1, o.contains(g + p) ? g += p : (d.write(o.indexOf(g), n), o.size() < 4095 && (o.size() == 1 << n && (n += 1), o.add(g + p)), g = p);
                                }
                                return d.write(o.indexOf(g), n), d.write(r, n), d.flush(), l.toByteArray();
                            }, s = function() {
                                var t = {}, e = 0, r = {
                                    add: function(n) {
                                        if (r.contains(n)) throw "dup key:" + n;
                                        t[n] = e, e += 1;
                                    },
                                    size: function() {
                                        return e;
                                    },
                                    indexOf: function(e) {
                                        return t[e];
                                    },
                                    contains: function(e) {
                                        return void 0 !== t[e];
                                    }
                                };
                                return r;
                            };
                            return o;
                        }(t, e), i = 0; i < e; i += 1)for(var o = 0; o < t; o += 1)n.setPixel(o, i, r(o, i));
                        var a = v();
                        n.write(a);
                        for(var s = function() {
                            var t = 0, e = 0, r = 0, n = "", i = {}, o = function(t) {
                                n += String.fromCharCode(a(63 & t));
                            }, a = function(t) {
                                if (t < 0) ;
                                else {
                                    if (t < 26) return 65 + t;
                                    if (t < 52) return t - 26 + 97;
                                    if (t < 62) return t - 52 + 48;
                                    if (62 == t) return 43;
                                    if (63 == t) return 47;
                                }
                                throw "n:" + t;
                            };
                            return i.writeByte = function(n) {
                                for(t = t << 8 | 255 & n, e += 8, r += 1; e >= 6;)o(t >>> e - 6), e -= 6;
                            }, i.flush = function() {
                                if (e > 0 && (o(t << 6 - e), t = 0, e = 0), r % 3 != 0) for(var i = 3 - r % 3, a = 0; a < i; a += 1)n += "=";
                            }, i.toString = function() {
                                return n;
                            }, i;
                        }(), u = a.toByteArray(), h = 0; h < u.length; h += 1)s.writeByte(u[h]);
                        return s.flush(), "data:image/gif;base64," + s;
                    };
                    return t;
                }();
                i.stringToBytesFuncs["UTF-8"] = function(t) {
                    return function(t) {
                        for(var e = [], r = 0; r < t.length; r++){
                            var n = t.charCodeAt(r);
                            n < 128 ? e.push(n) : n < 2048 ? e.push(192 | n >> 6, 128 | 63 & n) : n < 55296 || n >= 57344 ? e.push(224 | n >> 12, 128 | n >> 6 & 63, 128 | 63 & n) : (r++, n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(r)), e.push(240 | n >> 18, 128 | n >> 12 & 63, 128 | n >> 6 & 63, 128 | 63 & n));
                        }
                        return e;
                    }(t);
                }, void 0 === (n = "function" == typeof (r = function() {
                    return i;
                }) ? r.apply(e, []) : r) || (t.exports = n);
            },
            676: (t, e, r)=>{
                "use strict";
                r.d(e, {
                    default: ()=>F
                });
                const n = "Numeric", i = "Alphanumeric", o = "Byte";
                var a = function() {
                    return a = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                        return t;
                    }, a.apply(this, arguments);
                }, s = function() {
                    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
                    var n = Array(t), i = 0;
                    for(e = 0; e < r; e++)for(var o = arguments[e], a = 0, s = o.length; a < s; a++, i++)n[i] = o[a];
                    return n;
                }, u = function(t) {
                    return !!t && "object" == typeof t && !Array.isArray(t);
                };
                function h(t) {
                    for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                    if (!e.length) return t;
                    var n = e.shift();
                    return void 0 !== n && u(t) && u(n) ? (t = a({}, t), Object.keys(n).forEach(function(e) {
                        var r = t[e], i = n[e];
                        Array.isArray(r) && Array.isArray(i) ? t[e] = i : u(r) && u(i) ? t[e] = h(Object.assign({}, r), i) : t[e] = i;
                    }), h.apply(void 0, s([
                        t
                    ], e))) : t;
                }
                function c(t, e) {
                    var r = document.createElement("a");
                    r.download = e, r.href = t, document.body.appendChild(r), r.click(), document.body.removeChild(r);
                }
                var l = function(t, e, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(a, s);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, d = function(t, e) {
                    var r, n, i, o, a = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function s(o) {
                        return function(s) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                    switch(n = 0, i && (o = [
                                        2 & o[0],
                                        i.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            i = o;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                a.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && a.label < i[1]) {
                                                a.label = i[1], i = o;
                                                break;
                                            }
                                            if (i && a.label < i[2]) {
                                                a.label = i[2], a.ops.push(o);
                                                break;
                                            }
                                            i[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    o = e.call(t, a);
                                } catch (t) {
                                    o = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = i = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                s
                            ]);
                        };
                    }
                };
                function f(t) {
                    return l(this, void 0, void 0, function() {
                        return d(this, function(e) {
                            return [
                                2,
                                new Promise(function(e) {
                                    var r = new XMLHttpRequest;
                                    r.onload = function() {
                                        var t = new FileReader;
                                        t.onloadend = function() {
                                            e(t.result);
                                        }, t.readAsDataURL(r.response);
                                    }, r.open("GET", t), r.responseType = "blob", r.send();
                                })
                            ];
                        });
                    });
                }
                const g = {
                    L: .07,
                    M: .15,
                    Q: .25,
                    H: .3
                };
                var p = function() {
                    return p = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                        return t;
                    }, p.apply(this, arguments);
                }, v = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        var i;
                        switch(this._type){
                            case "dots":
                                i = this._drawDot;
                                break;
                            case "classy":
                                i = this._drawClassy;
                                break;
                            case "classy-rounded":
                                i = this._drawClassyRounded;
                                break;
                            case "rounded":
                                i = this._drawRounded;
                                break;
                            case "extra-rounded":
                                i = this._drawExtraRounded;
                                break;
                            default:
                                i = this._drawSquare;
                        }
                        i.call(this, {
                            x: t,
                            y: e,
                            size: r,
                            getNeighbor: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, i = t.size, o = t.rotation, a = void 0 === o ? 0 : o, s = r + i / 2, u = n + i / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), e._element.setAttribute("cx", String(n + r / 2)), e._element.setAttribute("cy", String(i + r / 2)), e._element.setAttribute("r", String(r / 2));
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), e._element.setAttribute("x", String(n)), e._element.setAttribute("y", String(i)), e._element.setAttribute("width", String(r)), e._element.setAttribute("height", String(r));
                            }
                        }));
                    }, t.prototype._basicSideRounded = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + i + "v " + r + "h " + r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, 0 " + -r);
                            }
                        }));
                    }, t.prototype._basicCornerRounded = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + i + "v " + r + "h " + r + "v " + -r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + -r / 2 + " " + -r / 2);
                            }
                        }));
                    }, t.prototype._basicCornerExtraRounded = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + i + "v " + r + "h " + r + "a " + r + " " + r + ", 0, 0, 0, " + -r + " " + -r);
                            }
                        }));
                    }, t.prototype._basicCornersRounded = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(p(p({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("d", "M " + n + " " + i + "v " + r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + r / 2 + " " + r / 2 + "h " + r / 2 + "v " + -r / 2 + "a " + r / 2 + " " + r / 2 + ", 0, 0, 0, " + -r / 2 + " " + -r / 2);
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.getNeighbor, o = i ? +i(-1, 0) : 0, a = i ? +i(1, 0) : 0, s = i ? +i(0, -1) : 0, u = i ? +i(0, 1) : 0, h = o + a + s + u;
                        if (0 !== h) {
                            if (h > 2 || o && a || s && u) this._basicSquare({
                                x: e,
                                y: r,
                                size: n,
                                rotation: 0
                            });
                            else {
                                if (2 === h) {
                                    var c = 0;
                                    return o && s ? c = Math.PI / 2 : s && a ? c = Math.PI : a && u && (c = -Math.PI / 2), void this._basicCornerRounded({
                                        x: e,
                                        y: r,
                                        size: n,
                                        rotation: c
                                    });
                                }
                                if (1 === h) return c = 0, s ? c = Math.PI / 2 : a ? c = Math.PI : u && (c = -Math.PI / 2), void this._basicSideRounded({
                                    x: e,
                                    y: r,
                                    size: n,
                                    rotation: c
                                });
                            }
                        } else this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawExtraRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.getNeighbor, o = i ? +i(-1, 0) : 0, a = i ? +i(1, 0) : 0, s = i ? +i(0, -1) : 0, u = i ? +i(0, 1) : 0, h = o + a + s + u;
                        if (0 !== h) {
                            if (h > 2 || o && a || s && u) this._basicSquare({
                                x: e,
                                y: r,
                                size: n,
                                rotation: 0
                            });
                            else {
                                if (2 === h) {
                                    var c = 0;
                                    return o && s ? c = Math.PI / 2 : s && a ? c = Math.PI : a && u && (c = -Math.PI / 2), void this._basicCornerExtraRounded({
                                        x: e,
                                        y: r,
                                        size: n,
                                        rotation: c
                                    });
                                }
                                if (1 === h) return c = 0, s ? c = Math.PI / 2 : a ? c = Math.PI : u && (c = -Math.PI / 2), void this._basicSideRounded({
                                    x: e,
                                    y: r,
                                    size: n,
                                    rotation: c
                                });
                            }
                        } else this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        });
                    }, t.prototype._drawClassy = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.getNeighbor, o = i ? +i(-1, 0) : 0, a = i ? +i(1, 0) : 0, s = i ? +i(0, -1) : 0, u = i ? +i(0, 1) : 0;
                        0 !== o + a + s + u ? o || s ? a || u ? this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        }) : this._basicCornerRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        }) : this._basicCornerRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: -Math.PI / 2
                        }) : this._basicCornersRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        });
                    }, t.prototype._drawClassyRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.getNeighbor, o = i ? +i(-1, 0) : 0, a = i ? +i(1, 0) : 0, s = i ? +i(0, -1) : 0, u = i ? +i(0, 1) : 0;
                        0 !== o + a + s + u ? o || s ? a || u ? this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: 0
                        }) : this._basicCornerExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        }) : this._basicCornerExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: -Math.PI / 2
                        }) : this._basicCornersRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: Math.PI / 2
                        });
                    }, t;
                }();
                const w = v;
                var y = function() {
                    return y = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                        return t;
                    }, y.apply(this, arguments);
                }, m = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        var i;
                        switch(this._type){
                            case "square":
                                i = this._drawSquare;
                                break;
                            case "extra-rounded":
                                i = this._drawExtraRounded;
                                break;
                            default:
                                i = this._drawDot;
                        }
                        i.call(this, {
                            x: t,
                            y: e,
                            size: r,
                            rotation: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, i = t.size, o = t.rotation, a = void 0 === o ? 0 : o, s = r + i / 2, u = n + i / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y, o = r / 7;
                        this._rotateFigure(y(y({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + (n + r / 2) + " " + i + "a " + r / 2 + " " + r / 2 + " 0 1 0 0.1 0zm 0 " + o + "a " + (r / 2 - o) + " " + (r / 2 - o) + " 0 1 1 -0.1 0Z");
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y, o = r / 7;
                        this._rotateFigure(y(y({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + n + " " + i + "v " + r + "h " + r + "v " + -r + "zM " + (n + o) + " " + (i + o) + "h " + (r - 2 * o) + "v " + (r - 2 * o) + "h " + (2 * o - r) + "z");
                            }
                        }));
                    }, t.prototype._basicExtraRounded = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y, o = r / 7;
                        this._rotateFigure(y(y({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "path"), e._element.setAttribute("clip-rule", "evenodd"), e._element.setAttribute("d", "M " + n + " " + (i + 2.5 * o) + "v " + 2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * o + " " + 2.5 * o + "h " + 2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * o + " " + 2.5 * -o + "v " + -2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * -o + " " + 2.5 * -o + "h " + -2 * o + "a " + 2.5 * o + " " + 2.5 * o + ", 0, 0, 0, " + 2.5 * -o + " " + 2.5 * o + "M " + (n + 2.5 * o) + " " + (i + o) + "h " + 2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * o + " " + 1.5 * o + "v " + 2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * -o + " " + 1.5 * o + "h " + -2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * -o + " " + 1.5 * -o + "v " + -2 * o + "a " + 1.5 * o + " " + 1.5 * o + ", 0, 0, 1, " + 1.5 * o + " " + 1.5 * -o);
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.rotation;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: i
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.rotation;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: i
                        });
                    }, t.prototype._drawExtraRounded = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.rotation;
                        this._basicExtraRounded({
                            x: e,
                            y: r,
                            size: n,
                            rotation: i
                        });
                    }, t;
                }();
                const _ = m;
                var b = function() {
                    return b = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                        return t;
                    }, b.apply(this, arguments);
                }, x = function() {
                    function t(t) {
                        var e = t.svg, r = t.type;
                        this._svg = e, this._type = r;
                    }
                    return t.prototype.draw = function(t, e, r, n) {
                        ("square" === this._type ? this._drawSquare : this._drawDot).call(this, {
                            x: t,
                            y: e,
                            size: r,
                            rotation: n
                        });
                    }, t.prototype._rotateFigure = function(t) {
                        var e, r = t.x, n = t.y, i = t.size, o = t.rotation, a = void 0 === o ? 0 : o, s = r + i / 2, u = n + i / 2;
                        (0, t.draw)(), null === (e = this._element) || void 0 === e || e.setAttribute("transform", "rotate(" + 180 * a / Math.PI + "," + s + "," + u + ")");
                    }, t.prototype._basicDot = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(b(b({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "circle"), e._element.setAttribute("cx", String(n + r / 2)), e._element.setAttribute("cy", String(i + r / 2)), e._element.setAttribute("r", String(r / 2));
                            }
                        }));
                    }, t.prototype._basicSquare = function(t) {
                        var e = this, r = t.size, n = t.x, i = t.y;
                        this._rotateFigure(b(b({}, t), {
                            draw: function() {
                                e._element = document.createElementNS("http://www.w3.org/2000/svg", "rect"), e._element.setAttribute("x", String(n)), e._element.setAttribute("y", String(i)), e._element.setAttribute("width", String(r)), e._element.setAttribute("height", String(r));
                            }
                        }));
                    }, t.prototype._drawDot = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.rotation;
                        this._basicDot({
                            x: e,
                            y: r,
                            size: n,
                            rotation: i
                        });
                    }, t.prototype._drawSquare = function(t) {
                        var e = t.x, r = t.y, n = t.size, i = t.rotation;
                        this._basicSquare({
                            x: e,
                            y: r,
                            size: n,
                            rotation: i
                        });
                    }, t;
                }();
                const S = x, C = "circle";
                var A = function(t, e, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(a, s);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, M = function(t, e) {
                    var r, n, i, o, a = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function s(o) {
                        return function(s) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                    switch(n = 0, i && (o = [
                                        2 & o[0],
                                        i.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            i = o;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                a.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && a.label < i[1]) {
                                                a.label = i[1], i = o;
                                                break;
                                            }
                                            if (i && a.label < i[2]) {
                                                a.label = i[2], a.ops.push(o);
                                                break;
                                            }
                                            i[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    o = e.call(t, a);
                                } catch (t) {
                                    o = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = i = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                s
                            ]);
                        };
                    }
                }, k = [
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ]
                ], O = [
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        1,
                        1,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                const D = function() {
                    function t(e) {
                        this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("width", String(e.width)), this._element.setAttribute("height", String(e.height)), this._defs = document.createElementNS("http://www.w3.org/2000/svg", "defs"), this._element.appendChild(this._defs), this._instanceId = t.instanceCount++, this._options = e;
                    }
                    return Object.defineProperty(t.prototype, "width", {
                        get: function() {
                            return this._options.width;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "height", {
                        get: function() {
                            return this._options.height;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.getElement = function() {
                        return this._element;
                    }, t.prototype.drawQR = function(t) {
                        return A(this, void 0, void 0, function() {
                            var e, r, n, i, o, a, s, u, h, c, l = this;
                            return M(this, function(d) {
                                switch(d.label){
                                    case 0:
                                        return e = t.getModuleCount(), r = Math.min(this._options.width, this._options.height) - 2 * this._options.margin, n = this._options.shape === C ? r / Math.sqrt(2) : r, i = n / e, o = {
                                            hideXDots: 0,
                                            hideYDots: 0,
                                            width: 0,
                                            height: 0
                                        }, this._qr = t, this._options.image ? [
                                            4,
                                            this.loadImage()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        if (d.sent(), !this._image) return [
                                            2
                                        ];
                                        a = this._options, s = a.imageOptions, u = a.qrOptions, h = s.imageSize * g[u.errorCorrectionLevel], c = Math.floor(h * e * e), o = function(t) {
                                            var e = t.originalHeight, r = t.originalWidth, n = t.maxHiddenDots, i = t.maxHiddenAxisDots, o = t.dotSize, a = {
                                                x: 0,
                                                y: 0
                                            }, s = {
                                                x: 0,
                                                y: 0
                                            };
                                            if (e <= 0 || r <= 0 || n <= 0 || o <= 0) return {
                                                height: 0,
                                                width: 0,
                                                hideYDots: 0,
                                                hideXDots: 0
                                            };
                                            var u = e / r;
                                            return a.x = Math.floor(Math.sqrt(n / u)), a.x <= 0 && (a.x = 1), i && i < a.x && (a.x = i), a.x % 2 == 0 && a.x--, s.x = a.x * o, a.y = 1 + 2 * Math.ceil((a.x * u - 1) / 2), s.y = Math.round(s.x * u), (a.y * a.x > n || i && i < a.y) && (i && i < a.y ? (a.y = i, a.y % 2 == 0 && a.x--) : a.y -= 2, s.y = a.y * o, a.x = 1 + 2 * Math.ceil((a.y / u - 1) / 2), s.x = Math.round(s.y / u)), {
                                                height: s.y,
                                                width: s.x,
                                                hideYDots: a.y,
                                                hideXDots: a.x
                                            };
                                        }({
                                            originalWidth: this._image.width,
                                            originalHeight: this._image.height,
                                            maxHiddenDots: c,
                                            maxHiddenAxisDots: e - 14,
                                            dotSize: i
                                        }), d.label = 2;
                                    case 2:
                                        return this.drawBackground(), this.drawDots(function(t, r) {
                                            var n, i, a, s, u, h;
                                            return !(l._options.imageOptions.hideBackgroundDots && t >= (e - o.hideXDots) / 2 && t < (e + o.hideXDots) / 2 && r >= (e - o.hideYDots) / 2 && r < (e + o.hideYDots) / 2 || (null === (n = k[t]) || void 0 === n ? void 0 : n[r]) || (null === (i = k[t - e + 7]) || void 0 === i ? void 0 : i[r]) || (null === (a = k[t]) || void 0 === a ? void 0 : a[r - e + 7]) || (null === (s = O[t]) || void 0 === s ? void 0 : s[r]) || (null === (u = O[t - e + 7]) || void 0 === u ? void 0 : u[r]) || (null === (h = O[t]) || void 0 === h ? void 0 : h[r - e + 7]));
                                        }), this.drawCorners(), this._options.image ? [
                                            4,
                                            this.drawImage({
                                                width: o.width,
                                                height: o.height,
                                                count: e,
                                                dotSize: i
                                            })
                                        ] : [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        d.sent(), d.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype.drawBackground = function() {
                        var t, e, r, n = this._element, i = this._options;
                        if (n) {
                            var o = null === (t = i.backgroundOptions) || void 0 === t ? void 0 : t.gradient, a = null === (e = i.backgroundOptions) || void 0 === e ? void 0 : e.color;
                            if ((o || a) && this._createColor({
                                options: o,
                                color: a,
                                additionalRotation: 0,
                                x: 0,
                                y: 0,
                                height: i.height,
                                width: i.width,
                                name: "background-color"
                            }), null === (r = i.backgroundOptions) || void 0 === r ? void 0 : r.round) {
                                var s = Math.min(i.width, i.height), u = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                                this._backgroundClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._backgroundClipPath.setAttribute("id", "clip-path-background-color"), this._defs.appendChild(this._backgroundClipPath), u.setAttribute("x", String((i.width - s) / 2)), u.setAttribute("y", String((i.height - s) / 2)), u.setAttribute("width", String(s)), u.setAttribute("height", String(s)), u.setAttribute("rx", String(s / 2 * i.backgroundOptions.round)), this._backgroundClipPath.appendChild(u);
                            }
                        }
                    }, t.prototype.drawDots = function(t) {
                        var e, r, n = this;
                        if (!this._qr) throw "QR code is not defined";
                        var i = this._options, o = this._qr.getModuleCount();
                        if (o > i.width || o > i.height) throw "The canvas is too small.";
                        var a = Math.min(i.width, i.height) - 2 * i.margin, s = (i.shape === C ? a / Math.sqrt(2) : a) / o, u = (i.width - o * s) / 2, h = (i.height - o * s) / 2, c = new w({
                            svg: this._element,
                            type: i.dotsOptions.type
                        });
                        this._dotsClipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath"), this._dotsClipPath.setAttribute("id", "clip-path-dot-color-" + this._instanceId), this._defs.appendChild(this._dotsClipPath), this._createColor({
                            options: null === (e = i.dotsOptions) || void 0 === e ? void 0 : e.gradient,
                            color: i.dotsOptions.color,
                            additionalRotation: 0,
                            x: 0,
                            y: 0,
                            height: i.height,
                            width: i.width,
                            name: "dot-color-" + this._instanceId
                        });
                        for(var l = function(e) {
                            for(var i = function(i) {
                                return t && !t(e, i) ? "continue" : (null === (r = d._qr) || void 0 === r ? void 0 : r.isDark(e, i)) ? (c.draw(u + e * s, h + i * s, s, function(r, a) {
                                    return !(e + r < 0 || i + a < 0 || e + r >= o || i + a >= o) && !(t && !t(e + r, i + a)) && !!n._qr && n._qr.isDark(e + r, i + a);
                                }), void (c._element && d._dotsClipPath && d._dotsClipPath.appendChild(c._element))) : "continue";
                            }, a = 0; a < o; a++)i(a);
                        }, d = this, f = 0; f < o; f++)l(f);
                        if (i.shape === C) {
                            var g = Math.floor((a / s - o) / 2), p = o + 2 * g, v = u - g * s, y = h - g * s, m = [], _ = Math.floor(p / 2);
                            for(f = 0; f < p; f++){
                                m[f] = [];
                                for(var b = 0; b < p; b++)f >= g - 1 && f <= p - g && b >= g - 1 && b <= p - g || Math.sqrt((f - _) * (f - _) + (b - _) * (b - _)) > _ ? m[f][b] = 0 : m[f][b] = this._qr.isDark(b - 2 * g < 0 ? b : b >= o ? b - 2 * g : b - g, f - 2 * g < 0 ? f : f >= o ? f - 2 * g : f - g) ? 1 : 0;
                            }
                            var x = function(t) {
                                for(var e = function(e) {
                                    if (!m[t][e]) return "continue";
                                    c.draw(v + t * s, y + e * s, s, function(r, n) {
                                        var i;
                                        return !!(null === (i = m[t + r]) || void 0 === i ? void 0 : i[e + n]);
                                    }), c._element && S._dotsClipPath && S._dotsClipPath.appendChild(c._element);
                                }, r = 0; r < p; r++)e(r);
                            }, S = this;
                            for(f = 0; f < p; f++)x(f);
                        }
                    }, t.prototype.drawCorners = function() {
                        var t = this;
                        if (!this._qr) throw "QR code is not defined";
                        var e = this._element, r = this._options;
                        if (!e) throw "Element code is not defined";
                        var n = this._qr.getModuleCount(), i = Math.min(r.width, r.height) - 2 * r.margin, o = (r.shape === C ? i / Math.sqrt(2) : i) / n, a = 7 * o, s = 3 * o, u = (r.width - n * o) / 2, h = (r.height - n * o) / 2;
                        [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                1,
                                0,
                                Math.PI / 2
                            ],
                            [
                                0,
                                1,
                                -Math.PI / 2
                            ]
                        ].forEach(function(e) {
                            var i, c, l, d, f, g, p, v, y, m, b, x, C = e[0], A = e[1], M = e[2], D = u + C * o * (n - 7), P = h + A * o * (n - 7), z = t._dotsClipPath, B = t._dotsClipPath;
                            if (((null === (i = r.cornersSquareOptions) || void 0 === i ? void 0 : i.gradient) || (null === (c = r.cornersSquareOptions) || void 0 === c ? void 0 : c.color)) && ((z = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-square-color-" + C + "-" + A), t._defs.appendChild(z), t._cornersSquareClipPath = t._cornersDotClipPath = B = z, t._createColor({
                                options: null === (l = r.cornersSquareOptions) || void 0 === l ? void 0 : l.gradient,
                                color: null === (d = r.cornersSquareOptions) || void 0 === d ? void 0 : d.color,
                                additionalRotation: M,
                                x: D,
                                y: P,
                                height: a,
                                width: a,
                                name: "corners-square-color-" + C + "-" + A
                            })), null === (f = r.cornersSquareOptions) || void 0 === f ? void 0 : f.type) {
                                var q = new _({
                                    svg: t._element,
                                    type: r.cornersSquareOptions.type
                                });
                                q.draw(D, P, a, M), q._element && z && z.appendChild(q._element);
                            } else for(var I = new w({
                                svg: t._element,
                                type: r.dotsOptions.type
                            }), E = function(t) {
                                for(var e = function(e) {
                                    if (!(null === (g = k[t]) || void 0 === g ? void 0 : g[e])) return "continue";
                                    I.draw(D + t * o, P + e * o, o, function(r, n) {
                                        var i;
                                        return !!(null === (i = k[t + r]) || void 0 === i ? void 0 : i[e + n]);
                                    }), I._element && z && z.appendChild(I._element);
                                }, r = 0; r < k[t].length; r++)e(r);
                            }, L = 0; L < k.length; L++)E(L);
                            if (((null === (p = r.cornersDotOptions) || void 0 === p ? void 0 : p.gradient) || (null === (v = r.cornersDotOptions) || void 0 === v ? void 0 : v.color)) && ((B = document.createElementNS("http://www.w3.org/2000/svg", "clipPath")).setAttribute("id", "clip-path-corners-dot-color-" + C + "-" + A), t._defs.appendChild(B), t._cornersDotClipPath = B, t._createColor({
                                options: null === (y = r.cornersDotOptions) || void 0 === y ? void 0 : y.gradient,
                                color: null === (m = r.cornersDotOptions) || void 0 === m ? void 0 : m.color,
                                additionalRotation: M,
                                x: D + 2 * o,
                                y: P + 2 * o,
                                height: s,
                                width: s,
                                name: "corners-dot-color-" + C + "-" + A
                            })), null === (b = r.cornersDotOptions) || void 0 === b ? void 0 : b.type) {
                                var R = new S({
                                    svg: t._element,
                                    type: r.cornersDotOptions.type
                                });
                                R.draw(D + 2 * o, P + 2 * o, s, M), R._element && B && B.appendChild(R._element);
                            } else {
                                I = new w({
                                    svg: t._element,
                                    type: r.dotsOptions.type
                                });
                                var N = function(t) {
                                    for(var e = function(e) {
                                        if (!(null === (x = O[t]) || void 0 === x ? void 0 : x[e])) return "continue";
                                        I.draw(D + t * o, P + e * o, o, function(r, n) {
                                            var i;
                                            return !!(null === (i = O[t + r]) || void 0 === i ? void 0 : i[e + n]);
                                        }), I._element && B && B.appendChild(I._element);
                                    }, r = 0; r < O[t].length; r++)e(r);
                                };
                                for(L = 0; L < O.length; L++)N(L);
                            }
                        });
                    }, t.prototype.loadImage = function() {
                        var t = this;
                        return new Promise(function(e, r) {
                            var n = t._options, i = new Image;
                            if (!n.image) return r("Image is not defined");
                            "string" == typeof n.imageOptions.crossOrigin && (i.crossOrigin = n.imageOptions.crossOrigin), t._image = i, i.onload = function() {
                                e();
                            }, i.src = n.image;
                        });
                    }, t.prototype.drawImage = function(t) {
                        var e = t.width, r = t.height, n = t.count, i = t.dotSize;
                        return A(this, void 0, void 0, function() {
                            var t, o, a, s, u, h, c, l, d;
                            return M(this, function(g) {
                                switch(g.label){
                                    case 0:
                                        return t = this._options, o = (t.width - n * i) / 2, a = (t.height - n * i) / 2, s = o + t.imageOptions.margin + (n * i - e) / 2, u = a + t.imageOptions.margin + (n * i - r) / 2, h = e - 2 * t.imageOptions.margin, c = r - 2 * t.imageOptions.margin, (l = document.createElementNS("http://www.w3.org/2000/svg", "image")).setAttribute("x", String(s)), l.setAttribute("y", String(u)), l.setAttribute("width", h + "px"), l.setAttribute("height", c + "px"), [
                                            4,
                                            f(t.image || "")
                                        ];
                                    case 1:
                                        return d = g.sent(), l.setAttribute("href", d || ""), this._element.appendChild(l), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype._createColor = function(t) {
                        var e = t.options, r = t.color, n = t.additionalRotation, i = t.x, o = t.y, a = t.height, s = t.width, u = t.name, h = s > a ? s : a, c = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                        if (c.setAttribute("x", String(i)), c.setAttribute("y", String(o)), c.setAttribute("height", String(a)), c.setAttribute("width", String(s)), c.setAttribute("clip-path", "url('#clip-path-" + u + "')"), e) {
                            var l;
                            if ("radial" === e.type) (l = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient")).setAttribute("id", u), l.setAttribute("gradientUnits", "userSpaceOnUse"), l.setAttribute("fx", String(i + s / 2)), l.setAttribute("fy", String(o + a / 2)), l.setAttribute("cx", String(i + s / 2)), l.setAttribute("cy", String(o + a / 2)), l.setAttribute("r", String(h / 2));
                            else {
                                var d = ((e.rotation || 0) + n) % (2 * Math.PI), f = (d + 2 * Math.PI) % (2 * Math.PI), g = i + s / 2, p = o + a / 2, v = i + s / 2, w = o + a / 2;
                                f >= 0 && f <= .25 * Math.PI || f > 1.75 * Math.PI && f <= 2 * Math.PI ? (g -= s / 2, p -= a / 2 * Math.tan(d), v += s / 2, w += a / 2 * Math.tan(d)) : f > .25 * Math.PI && f <= .75 * Math.PI ? (p -= a / 2, g -= s / 2 / Math.tan(d), w += a / 2, v += s / 2 / Math.tan(d)) : f > .75 * Math.PI && f <= 1.25 * Math.PI ? (g += s / 2, p += a / 2 * Math.tan(d), v -= s / 2, w -= a / 2 * Math.tan(d)) : f > 1.25 * Math.PI && f <= 1.75 * Math.PI && (p += a / 2, g += s / 2 / Math.tan(d), w -= a / 2, v -= s / 2 / Math.tan(d)), (l = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient")).setAttribute("id", u), l.setAttribute("gradientUnits", "userSpaceOnUse"), l.setAttribute("x1", String(Math.round(g))), l.setAttribute("y1", String(Math.round(p))), l.setAttribute("x2", String(Math.round(v))), l.setAttribute("y2", String(Math.round(w)));
                            }
                            e.colorStops.forEach(function(t) {
                                var e = t.offset, r = t.color, n = document.createElementNS("http://www.w3.org/2000/svg", "stop");
                                n.setAttribute("offset", 100 * e + "%"), n.setAttribute("stop-color", r), l.appendChild(n);
                            }), c.setAttribute("fill", "url('#" + u + "')"), this._defs.appendChild(l);
                        } else r && c.setAttribute("fill", r);
                        this._element.appendChild(c);
                    }, t.instanceCount = 0, t;
                }(), P = "canvas";
                for(var z = {}, B = 0; B <= 40; B++)z[B] = B;
                const q = {
                    type: P,
                    shape: "square",
                    width: 300,
                    height: 300,
                    data: "",
                    margin: 0,
                    qrOptions: {
                        typeNumber: z[0],
                        mode: void 0,
                        errorCorrectionLevel: "Q"
                    },
                    imageOptions: {
                        hideBackgroundDots: !0,
                        imageSize: .4,
                        crossOrigin: void 0,
                        margin: 0
                    },
                    dotsOptions: {
                        type: "square",
                        color: "#000"
                    },
                    backgroundOptions: {
                        round: 0,
                        color: "#fff"
                    }
                };
                var I = function() {
                    return I = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var i in e = arguments[r])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                        return t;
                    }, I.apply(this, arguments);
                };
                function E(t) {
                    var e = I({}, t);
                    if (!e.colorStops || !e.colorStops.length) throw "Field 'colorStops' is required in gradient";
                    return e.rotation ? e.rotation = Number(e.rotation) : e.rotation = 0, e.colorStops = e.colorStops.map(function(t) {
                        return I(I({}, t), {
                            offset: Number(t.offset)
                        });
                    }), e;
                }
                function L(t) {
                    var e = I({}, t);
                    return e.width = Number(e.width), e.height = Number(e.height), e.margin = Number(e.margin), e.imageOptions = I(I({}, e.imageOptions), {
                        hideBackgroundDots: Boolean(e.imageOptions.hideBackgroundDots),
                        imageSize: Number(e.imageOptions.imageSize),
                        margin: Number(e.imageOptions.margin)
                    }), e.margin > Math.min(e.width, e.height) && (e.margin = Math.min(e.width, e.height)), e.dotsOptions = I({}, e.dotsOptions), e.dotsOptions.gradient && (e.dotsOptions.gradient = E(e.dotsOptions.gradient)), e.cornersSquareOptions && (e.cornersSquareOptions = I({}, e.cornersSquareOptions), e.cornersSquareOptions.gradient && (e.cornersSquareOptions.gradient = E(e.cornersSquareOptions.gradient))), e.cornersDotOptions && (e.cornersDotOptions = I({}, e.cornersDotOptions), e.cornersDotOptions.gradient && (e.cornersDotOptions.gradient = E(e.cornersDotOptions.gradient))), e.backgroundOptions && (e.backgroundOptions = I({}, e.backgroundOptions), e.backgroundOptions.gradient && (e.backgroundOptions.gradient = E(e.backgroundOptions.gradient))), e;
                }
                var R = r(192), N = r.n(R), j = function(t, e, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function s(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? i(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(a, s);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, T = function(t, e) {
                    var r, n, i, o, a = {
                        label: 0,
                        sent: function() {
                            if (1 & i[0]) throw i[1];
                            return i[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function s(o) {
                        return function(s) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; a;)try {
                                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                    switch(n = 0, i && (o = [
                                        2 & o[0],
                                        i.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            i = o;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                a.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && a.label < i[1]) {
                                                a.label = i[1], i = o;
                                                break;
                                            }
                                            if (i && a.label < i[2]) {
                                                a.label = i[2], a.ops.push(o);
                                                break;
                                            }
                                            i[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    o = e.call(t, a);
                                } catch (t) {
                                    o = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = i = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                s
                            ]);
                        };
                    }
                };
                const F = function() {
                    function t(t) {
                        this._options = t ? L(h(q, t)) : q, this.update();
                    }
                    return t._clearContainer = function(t) {
                        t && (t.innerHTML = "");
                    }, t.prototype._setupSvg = function() {
                        var t = this;
                        if (this._qr) {
                            var e = new D(this._options);
                            this._svg = e.getElement(), this._svgDrawingPromise = e.drawQR(this._qr).then(function() {
                                var r;
                                t._svg && (null === (r = t._extension) || void 0 === r || r.call(t, e.getElement(), t._options));
                            });
                        }
                    }, t.prototype._setupCanvas = function() {
                        var t, e = this;
                        this._qr && (this._canvas = document.createElement("canvas"), this._canvas.width = this._options.width, this._canvas.height = this._options.height, this._setupSvg(), this._canvasDrawingPromise = null === (t = this._svgDrawingPromise) || void 0 === t ? void 0 : t.then(function() {
                            if (e._svg) {
                                var t = e._svg, r = (new XMLSerializer).serializeToString(t), n = "data:image/svg+xml;base64," + btoa(r), i = new Image;
                                return new Promise(function(t) {
                                    i.onload = function() {
                                        var r, n;
                                        null === (n = null === (r = e._canvas) || void 0 === r ? void 0 : r.getContext("2d")) || void 0 === n || n.drawImage(i, 0, 0), t();
                                    }, i.src = n;
                                });
                            }
                        }));
                    }, t.prototype._getElement = function(t) {
                        return void 0 === t && (t = "png"), j(this, void 0, void 0, function() {
                            return T(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return "svg" !== t.toLowerCase() ? [
                                            3,
                                            2
                                        ] : (this._svg && this._svgDrawingPromise || this._setupSvg(), [
                                            4,
                                            this._svgDrawingPromise
                                        ]);
                                    case 1:
                                        return e.sent(), [
                                            2,
                                            this._svg
                                        ];
                                    case 2:
                                        return this._canvas && this._canvasDrawingPromise || this._setupCanvas(), [
                                            4,
                                            this._canvasDrawingPromise
                                        ];
                                    case 3:
                                        return e.sent(), [
                                            2,
                                            this._canvas
                                        ];
                                }
                            });
                        });
                    }, t.prototype.update = function(e) {
                        t._clearContainer(this._container), this._options = e ? L(h(this._options, e)) : this._options, this._options.data && (this._qr = N()(this._options.qrOptions.typeNumber, this._options.qrOptions.errorCorrectionLevel), this._qr.addData(this._options.data, this._options.qrOptions.mode || function(t) {
                            switch(!0){
                                case /^[0-9]*$/.test(t):
                                    return n;
                                case /^[0-9A-Z $%*+\-./:]*$/.test(t):
                                    return i;
                                default:
                                    return o;
                            }
                        }(this._options.data)), this._qr.make(), this._options.type === P ? this._setupCanvas() : this._setupSvg(), this.append(this._container));
                    }, t.prototype.append = function(t) {
                        if (t) {
                            if ("function" != typeof t.appendChild) throw "Container should be a single DOM node";
                            this._options.type === P ? this._canvas && t.appendChild(this._canvas) : this._svg && t.appendChild(this._svg), this._container = t;
                        }
                    }, t.prototype.applyExtension = function(t) {
                        if (!t) throw "Extension function should be defined.";
                        this._extension = t, this.update();
                    }, t.prototype.deleteExtension = function() {
                        this._extension = void 0, this.update();
                    }, t.prototype.getRawData = function(t) {
                        return void 0 === t && (t = "png"), j(this, void 0, void 0, function() {
                            var e, r, n;
                            return T(this, function(i) {
                                switch(i.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return [
                                            4,
                                            this._getElement(t)
                                        ];
                                    case 1:
                                        return (e = i.sent()) ? "svg" === t.toLowerCase() ? (r = new XMLSerializer, n = r.serializeToString(e), [
                                            2,
                                            new Blob([
                                                '<?xml version="1.0" standalone="no"?>\r\n' + n
                                            ], {
                                                type: "image/svg+xml"
                                            })
                                        ]) : [
                                            2,
                                            new Promise(function(r) {
                                                return e.toBlob(r, "image/" + t, 1);
                                            })
                                        ] : [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                    }, t.prototype.download = function(t) {
                        return j(this, void 0, void 0, function() {
                            var e, r, n, i, o;
                            return T(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (!this._qr) throw "QR code is empty";
                                        return e = "png", r = "qr", "string" == typeof t ? (e = t, console.warn("Extension is deprecated as argument for 'download' method, please pass object { name: '...', extension: '...' } as argument")) : "object" == typeof t && null !== t && (t.name && (r = t.name), t.extension && (e = t.extension)), [
                                            4,
                                            this._getElement(e)
                                        ];
                                    case 1:
                                        return (n = a.sent()) ? ("svg" === e.toLowerCase() ? (i = new XMLSerializer, o = '<?xml version="1.0" standalone="no"?>\r\n' + (o = i.serializeToString(n)), c("data:image/svg+xml;charset=utf-8," + encodeURIComponent(o), r + ".svg")) : c(n.toDataURL("image/" + e), r + "." + e), [
                                            2
                                        ]) : [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t;
                }();
            }
        }, e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
                exports: {}
            };
            return t[n](i, i.exports, r), i.exports;
        }
        return r.n = (t)=>{
            var e = t && t.__esModule ? ()=>t.default : ()=>t;
            return r.d(e, {
                a: e
            }), e;
        }, r.d = (t, e)=>{
            for(var n in e)r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), r(676);
    })().default;
});


function $d4bb63e69eb90953$export$6efde3394a132068(url, size = 512, background = 'white', color = 'black') {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($35c4bfa083870778$exports)))($d4bb63e69eb90953$export$348d27b6b9c6b2cf(url, size, background, color));
}
function $d4bb63e69eb90953$export$348d27b6b9c6b2cf(url, size = 512, background = 'white', color = 'black') {
    return {
        type: 'svg',
        width: size,
        height: size,
        data: String(url),
        margin: 16,
        qrOptions: {
            typeNumber: 0,
            mode: 'Byte',
            errorCorrectionLevel: 'Q'
        },
        backgroundOptions: {
            color: background
        },
        dotsOptions: {
            type: 'extra-rounded',
            color: color
        },
        cornersSquareOptions: {
            type: 'extra-rounded',
            color: color
        },
        cornersDotOptions: {
            type: 'square',
            color: color
        },
        imageOptions: {
            hideBackgroundDots: true,
            imageSize: 0.15,
            margin: 8
        },
        image: `data:image/svg+xml;utf8,<svg fill="${encodeURIComponent(color)}" height="16" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m15.9176 11.038-2.6413 2.7713c-.0574.0602-.1269.1082-.2041.141s-.1604.0497-.2446.0497h-12.520966c-.059744 0-.118187-.0171-.168147-.0491-.0499596-.0321-.0892609-.0777-.1130745-.1313-.02381372-.0536-.03110249-.1129-.02097081-.1705.01013171-.0576.03724251-.111.07800141-.1538l2.6432769-2.7713c.05726-.06.12651-.1079.20346-.1407s.15996-.0498.2439-.05h12.52032c.0597 0 .1182.0171.1681.0492.05.032.0893.0776.1131.1313.0238.0536.0311.1128.021.1704-.0102.0576-.0373.1111-.078.1538zm-2.6413-5.58067c-.0574-.0602-.1269-.1082-.2041-.141s-.1604-.04971-.2446-.04966h-12.520966c-.059744 0-.118187.01708-.168147.04913-.0499596.03205-.0892609.07768-.1130745.13129-.02381372.0536-.03110249.11285-.02097081.17045.01013171.05761.03724251.11106.07800141.15379l2.6432769 2.77134c.05726.06004.12651.10794.20346.14073.07695.0328.15996.04979.2439.04993h12.52032c.0597 0 .1182-.01707.1681-.04913.05-.03205.0893-.07768.1131-.13129.0238-.0536.0311-.11285.021-.17045-.0102-.05761-.0373-.11106-.078-.15379zm-12.969666-1.99066h12.520966c.0842.00004.1674-.01687.2446-.04967s.1467-.0808.2041-.141l2.6413-2.771333c.0407-.042736.0678-.096189.078-.153792.0101-.057603.0028-.116847-.021-.170453s-.0631-.0992385-.1131-.1312911c-.0499-.0320526-.1084-.04912893-.1681-.0491309h-12.52032c-.08394.00013975-.16695.0171339-.2439.0499304s-.1462.0806976-.20346.1407366l-2.6425955 2.771333c-.0407196.04269-.0678184.09609-.07797306.15363-.01015467.05754-.00292373.11673.02080606.17031.0237297.05358.0629266.09922.1127835.13132.049857.03211.108207.04928.167893.04941z"/></svg>`
    };
}


/** Instructions defined by the program */ var $b9e868e37c405652$export$236c07be390a0994;
(function(TokenInstruction) {
    TokenInstruction[TokenInstruction["InitializeMint"] = 0] = "InitializeMint";
    TokenInstruction[TokenInstruction["InitializeAccount"] = 1] = "InitializeAccount";
    TokenInstruction[TokenInstruction["InitializeMultisig"] = 2] = "InitializeMultisig";
    TokenInstruction[TokenInstruction["Transfer"] = 3] = "Transfer";
    TokenInstruction[TokenInstruction["Approve"] = 4] = "Approve";
    TokenInstruction[TokenInstruction["Revoke"] = 5] = "Revoke";
    TokenInstruction[TokenInstruction["SetAuthority"] = 6] = "SetAuthority";
    TokenInstruction[TokenInstruction["MintTo"] = 7] = "MintTo";
    TokenInstruction[TokenInstruction["Burn"] = 8] = "Burn";
    TokenInstruction[TokenInstruction["CloseAccount"] = 9] = "CloseAccount";
    TokenInstruction[TokenInstruction["FreezeAccount"] = 10] = "FreezeAccount";
    TokenInstruction[TokenInstruction["ThawAccount"] = 11] = "ThawAccount";
    TokenInstruction[TokenInstruction["TransferChecked"] = 12] = "TransferChecked";
    TokenInstruction[TokenInstruction["ApproveChecked"] = 13] = "ApproveChecked";
    TokenInstruction[TokenInstruction["MintToChecked"] = 14] = "MintToChecked";
    TokenInstruction[TokenInstruction["BurnChecked"] = 15] = "BurnChecked";
    TokenInstruction[TokenInstruction["InitializeAccount2"] = 16] = "InitializeAccount2";
    TokenInstruction[TokenInstruction["SyncNative"] = 17] = "SyncNative";
    TokenInstruction[TokenInstruction["InitializeAccount3"] = 18] = "InitializeAccount3";
    TokenInstruction[TokenInstruction["InitializeMultisig2"] = 19] = "InitializeMultisig2";
    TokenInstruction[TokenInstruction["InitializeMint2"] = 20] = "InitializeMint2";
})($b9e868e37c405652$export$236c07be390a0994 || ($b9e868e37c405652$export$236c07be390a0994 = {}));



var $Q02IV = parcelRequire("Q02IV");
const $908a1012fc8b4d28$export$15db02dbfcaf60e0 = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};



var $Q02IV = parcelRequire("Q02IV");
var $c0e94fe1a84d811b$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c0e94fe1a84d811b$require$Buffer = $6ZWSX.Buffer;
'use strict';
Object.defineProperty($c0e94fe1a84d811b$exports, "__esModule", {
    value: true
});
let $c0e94fe1a84d811b$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $c0e94fe1a84d811b$var$toBigIntLE(buf) {
    {
        const reversed = $c0e94fe1a84d811b$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString('hex');
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $c0e94fe1a84d811b$var$converter.toBigInt(buf, false);
}
$c0e94fe1a84d811b$exports.toBigIntLE = $c0e94fe1a84d811b$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $c0e94fe1a84d811b$var$toBigIntBE(buf) {
    {
        const hex = buf.toString('hex');
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $c0e94fe1a84d811b$var$converter.toBigInt(buf, true);
}
$c0e94fe1a84d811b$exports.toBigIntBE = $c0e94fe1a84d811b$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $c0e94fe1a84d811b$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $c0e94fe1a84d811b$require$Buffer.from(hex.padStart(width * 2, '0').slice(0, width * 2), 'hex');
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $c0e94fe1a84d811b$var$converter.fromBigInt(num, $c0e94fe1a84d811b$require$Buffer.allocUnsafe(width), false);
}
$c0e94fe1a84d811b$exports.toBufferLE = $c0e94fe1a84d811b$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $c0e94fe1a84d811b$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $c0e94fe1a84d811b$require$Buffer.from(hex.padStart(width * 2, '0').slice(0, width * 2), 'hex');
    }
    return $c0e94fe1a84d811b$var$converter.fromBigInt(num, $c0e94fe1a84d811b$require$Buffer.allocUnsafe(width), true);
}
$c0e94fe1a84d811b$exports.toBufferBE = $c0e94fe1a84d811b$var$toBufferBE;




var $6ZWSX = parcelRequire("6ZWSX");
var $617399e00c93be74$require$Buffer = $6ZWSX.Buffer;
const $617399e00c93be74$export$c97e695afb26d84 = (length)=>(property)=>{
        const layout = (0, $Q02IV.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $908a1012fc8b4d28$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $c0e94fe1a84d811b$exports.toBigIntLE)($617399e00c93be74$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $c0e94fe1a84d811b$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $617399e00c93be74$export$8fa7afc0d3e063a4 = (length)=>(property)=>{
        const layout = (0, $Q02IV.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $908a1012fc8b4d28$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $c0e94fe1a84d811b$exports.toBigIntBE)($617399e00c93be74$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $c0e94fe1a84d811b$exports.toBufferBE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $617399e00c93be74$export$cd1442401e54cffa = $617399e00c93be74$export$c97e695afb26d84(8);
const $617399e00c93be74$export$7f18746cf5292838 = $617399e00c93be74$export$8fa7afc0d3e063a4(8);
const $617399e00c93be74$export$6cebf8c93d35ecb4 = $617399e00c93be74$export$c97e695afb26d84(16);
const $617399e00c93be74$export$327689723be22772 = $617399e00c93be74$export$8fa7afc0d3e063a4(16);
const $617399e00c93be74$export$8f928ec3e6d68946 = $617399e00c93be74$export$c97e695afb26d84(24);
const $617399e00c93be74$export$559ccecc3c5a7252 = $617399e00c93be74$export$8fa7afc0d3e063a4(24);
const $617399e00c93be74$export$c6d3c723c6dee16b = $617399e00c93be74$export$c97e695afb26d84(32);
const $617399e00c93be74$export$667f357a9402d24c = $617399e00c93be74$export$8fa7afc0d3e063a4(32);



var $dws6U = parcelRequire("dws6U");


const $80fc431285965bdd$export$23054672248b2c43 = new (0, $dws6U.default)('1e+18');
const $80fc431285965bdd$export$78a48a3d1e5dbe89 = (property)=>{
    const layout = (0, $617399e00c93be74$export$6cebf8c93d35ecb4)(property);
    const { encode: encode, decode: decode } = (0, $908a1012fc8b4d28$export$15db02dbfcaf60e0)(layout);
    const decimalLayout = layout;
    decimalLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset).toString();
        return new (0, $dws6U.default)(src).div($80fc431285965bdd$export$23054672248b2c43);
    };
    decimalLayout.encode = (decimal, buffer, offset)=>{
        const src = BigInt(decimal.times($80fc431285965bdd$export$23054672248b2c43).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};



var $Q02IV = parcelRequire("Q02IV");

const $f86b8e02dedf4e39$export$87b259aa03e3d267 = (property)=>{
    const layout = (0, $Q02IV.u8)(property);
    const { encode: encode, decode: decode } = (0, $908a1012fc8b4d28$export$15db02dbfcaf60e0)(layout);
    const boolLayout = layout;
    boolLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = (bool, buffer, offset)=>{
        const src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");

const $d5c40539f12254c9$export$86f13247979de5d7 = (property)=>{
    const layout = (0, $Q02IV.blob)(32, property);
    const { encode: encode, decode: decode } = (0, $908a1012fc8b4d28$export$15db02dbfcaf60e0)(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return new (0, $gNDby.PublicKey)(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset)=>{
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};





var $gNDby = parcelRequire("gNDby");

var $gNDby = parcelRequire("gNDby");
const $2d517843a01c61a3$export$79de3e3c2b1ca801 = new (0, $gNDby.PublicKey)('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
const $2d517843a01c61a3$export$57a4f33bcc1767fa = new (0, $gNDby.PublicKey)('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL');
const $2d517843a01c61a3$export$71f490c6a4aef7af = new (0, $gNDby.PublicKey)('So11111111111111111111111111111111111111112');


/** Base class for errors */ class $ac590afd90e938f5$export$ed0b8b496332122d extends Error {
    constructor(message){
        super(message);
    }
}
class $ac590afd90e938f5$export$a09a5e48de2f3404 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenAccountNotFoundError';
    }
}
class $ac590afd90e938f5$export$abb470453474d51 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidAccountOwnerError';
    }
}
class $ac590afd90e938f5$export$250d31de4ddb7ca5 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidAccountSizeError';
    }
}
class $ac590afd90e938f5$export$871debb212ec395 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidMintError';
    }
}
class $ac590afd90e938f5$export$9d3e0012e0e06993 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidOwnerError';
    }
}
class $ac590afd90e938f5$export$c431a85da6f99bf0 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenOwnerOffCurveError';
    }
}
class $ac590afd90e938f5$export$a241007212c884f6 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidInstructionProgramError';
    }
}
class $ac590afd90e938f5$export$3882cbbd44973a88 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidInstructionKeysError';
    }
}
class $ac590afd90e938f5$export$f96a822f391c3cc4 extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidInstructionDataError';
    }
}
class $ac590afd90e938f5$export$e1301365d704141e extends $ac590afd90e938f5$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = 'TokenInvalidInstructionTypeError';
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $f37d6c3b204bb2ee$require$Buffer = $6ZWSX.Buffer;
const $f37d6c3b204bb2ee$export$37d52352dda283b1 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $Q02IV.u8)('decimals'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('mintAuthority'),
    (0, $Q02IV.u8)('freezeAuthorityOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('freezeAuthority')
]);
function $f37d6c3b204bb2ee$export$25a2c50cb893982f(mint, decimals, mintAuthority, freezeAuthority, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = [
        {
            pubkey: mint,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
            isSigner: false,
            isWritable: false
        }
    ];
    const data = $f37d6c3b204bb2ee$require$Buffer.alloc($f37d6c3b204bb2ee$export$37d52352dda283b1.span);
    $f37d6c3b204bb2ee$export$37d52352dda283b1.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMint,
        decimals: decimals,
        mintAuthority: mintAuthority,
        freezeAuthorityOption: freezeAuthority ? 1 : 0,
        freezeAuthority: freezeAuthority || new (0, $gNDby.PublicKey)(0)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $f37d6c3b204bb2ee$export$cdfc2dbfd11013bc(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $f37d6c3b204bb2ee$export$37d52352dda283b1.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { mint: mint, rent: rent }, data: data } = $f37d6c3b204bb2ee$export$6e123b0a58dfae6a(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMint) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!mint || !rent) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            mint: mint,
            rent: rent
        },
        data: data
    };
}
function $f37d6c3b204bb2ee$export$6e123b0a58dfae6a({ programId: programId, keys: [mint, rent], data: data }) {
    const { instruction: instruction, decimals: decimals, mintAuthority: mintAuthority, freezeAuthorityOption: freezeAuthorityOption, freezeAuthority: freezeAuthority } = $f37d6c3b204bb2ee$export$37d52352dda283b1.decode(data);
    return {
        programId: programId,
        keys: {
            mint: mint,
            rent: rent
        },
        data: {
            instruction: instruction,
            decimals: decimals,
            mintAuthority: mintAuthority,
            freezeAuthority: freezeAuthorityOption ? freezeAuthority : null
        }
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");




var $6ZWSX = parcelRequire("6ZWSX");
var $faa52ec80b06983e$require$Buffer = $6ZWSX.Buffer;
const $faa52ec80b06983e$export$1df1b864f5b8f06 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $faa52ec80b06983e$export$d2c7d24f6cca7beb(account, mint, owner, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = [
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: owner,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
            isSigner: false,
            isWritable: false
        }
    ];
    const data = $faa52ec80b06983e$require$Buffer.alloc($faa52ec80b06983e$export$1df1b864f5b8f06.span);
    $faa52ec80b06983e$export$1df1b864f5b8f06.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $faa52ec80b06983e$export$8d0237e5b532e544(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $faa52ec80b06983e$export$1df1b864f5b8f06.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, owner: owner, rent: rent }, data: data } = $faa52ec80b06983e$export$2120cecc6896b60b(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !owner || !rent) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            rent: rent
        },
        data: data
    };
}
function $faa52ec80b06983e$export$2120cecc6896b60b({ programId: programId, keys: [account, mint, owner, rent], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            rent: rent
        },
        data: $faa52ec80b06983e$export$1df1b864f5b8f06.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");




var $6ZWSX = parcelRequire("6ZWSX");
var $2d0cb51e3236b63c$require$Buffer = $6ZWSX.Buffer;
const $2d0cb51e3236b63c$export$888076b5a4f3890a = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $Q02IV.u8)('m')
]);
function $2d0cb51e3236b63c$export$eb57bdd85d0d8c83(account, signers, m, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = [
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
            isSigner: false,
            isWritable: false
        }
    ];
    for (const signer of signers)keys.push({
        pubkey: signer,
        isSigner: false,
        isWritable: false
    });
    const data = $2d0cb51e3236b63c$require$Buffer.alloc($2d0cb51e3236b63c$export$888076b5a4f3890a.span);
    $2d0cb51e3236b63c$export$888076b5a4f3890a.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMultisig,
        m: m
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $2d0cb51e3236b63c$export$b7cb5c4660417270(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $2d0cb51e3236b63c$export$888076b5a4f3890a.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, rent: rent, signers: signers }, data: data } = $2d0cb51e3236b63c$export$ff086ab32cae4a7(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMultisig) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !rent || !signers.length) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            rent: rent,
            signers: signers
        },
        data: data
    };
}
function $2d0cb51e3236b63c$export$ff086ab32cae4a7({ programId: programId, keys: [account, rent, ...signers], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            rent: rent,
            signers: signers
        },
        data: $2d0cb51e3236b63c$export$888076b5a4f3890a.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");


/** @internal */ function $11280619b145ccb3$export$fde60050662f8c02(keys, ownerOrAuthority, multiSigners) {
    if (multiSigners.length) {
        keys.push({
            pubkey: ownerOrAuthority,
            isSigner: false,
            isWritable: false
        });
        for (const signer of multiSigners)keys.push({
            pubkey: signer.publicKey,
            isSigner: true,
            isWritable: false
        });
    } else keys.push({
        pubkey: ownerOrAuthority,
        isSigner: true,
        isWritable: false
    });
    return keys;
}




var $6ZWSX = parcelRequire("6ZWSX");
var $e83b680ad6ab8252$require$Buffer = $6ZWSX.Buffer;
const $e83b680ad6ab8252$export$36b3d03efc16d305 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount')
]);
function $e83b680ad6ab8252$export$b274d5cebe357db9(source, destination, owner, amount, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: source,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $e83b680ad6ab8252$require$Buffer.alloc($e83b680ad6ab8252$export$36b3d03efc16d305.span);
    $e83b680ad6ab8252$export$36b3d03efc16d305.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).Transfer,
        amount: BigInt(amount)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $e83b680ad6ab8252$export$d4ef34cde439b107(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $e83b680ad6ab8252$export$36b3d03efc16d305.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { source: source, destination: destination, owner: owner, multiSigners: multiSigners }, data: data } = $e83b680ad6ab8252$export$f64172008a79e2e1(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).Transfer) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!source || !destination || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $e83b680ad6ab8252$export$f64172008a79e2e1({ programId: programId, keys: [source, destination, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $e83b680ad6ab8252$export$36b3d03efc16d305.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $ab33fa935ce1c104$require$Buffer = $6ZWSX.Buffer;
const $ab33fa935ce1c104$export$81534eec16649c78 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount')
]);
function $ab33fa935ce1c104$export$777c38f0c8b4fab(account, delegate, owner, amount, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: delegate,
            isSigner: false,
            isWritable: false
        }
    ], owner, multiSigners);
    const data = $ab33fa935ce1c104$require$Buffer.alloc($ab33fa935ce1c104$export$81534eec16649c78.span);
    $ab33fa935ce1c104$export$81534eec16649c78.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).Approve,
        amount: BigInt(amount)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $ab33fa935ce1c104$export$e17e93069086368e(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $ab33fa935ce1c104$export$81534eec16649c78.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, delegate: delegate, owner: owner, multiSigners: multiSigners }, data: data } = $ab33fa935ce1c104$export$b9312ce40f5c8670(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).Approve) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !delegate || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            delegate: delegate,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $ab33fa935ce1c104$export$b9312ce40f5c8670({ programId: programId, keys: [account, delegate, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            delegate: delegate,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $ab33fa935ce1c104$export$81534eec16649c78.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $9871ee14dd00cdce$require$Buffer = $6ZWSX.Buffer;
const $9871ee14dd00cdce$export$2b31c32e0ae3e4b7 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $9871ee14dd00cdce$export$95ab20528db957d9(account, owner, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $9871ee14dd00cdce$require$Buffer.alloc($9871ee14dd00cdce$export$2b31c32e0ae3e4b7.span);
    $9871ee14dd00cdce$export$2b31c32e0ae3e4b7.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).Revoke
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $9871ee14dd00cdce$export$8ec83be7f2d0eb71(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $9871ee14dd00cdce$export$2b31c32e0ae3e4b7.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, owner: owner, multiSigners: multiSigners }, data: data } = $9871ee14dd00cdce$export$7c4a73983fb699eb(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).Revoke) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $9871ee14dd00cdce$export$7c4a73983fb699eb({ programId: programId, keys: [account, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $9871ee14dd00cdce$export$2b31c32e0ae3e4b7.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $6e282d3cd5411099$require$Buffer = $6ZWSX.Buffer;
var $6e282d3cd5411099$export$cd82032b224a3839;
(function(AuthorityType) {
    AuthorityType[AuthorityType["MintTokens"] = 0] = "MintTokens";
    AuthorityType[AuthorityType["FreezeAccount"] = 1] = "FreezeAccount";
    AuthorityType[AuthorityType["AccountOwner"] = 2] = "AccountOwner";
    AuthorityType[AuthorityType["CloseAccount"] = 3] = "CloseAccount";
})($6e282d3cd5411099$export$cd82032b224a3839 || ($6e282d3cd5411099$export$cd82032b224a3839 = {}));
const $6e282d3cd5411099$export$2535570c9ace1fc4 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $Q02IV.u8)('authorityType'),
    (0, $Q02IV.u8)('newAuthorityOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('newAuthority')
]);
function $6e282d3cd5411099$export$96565b3fb1f7396a(account, currentAuthority, authorityType, newAuthority, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        }
    ], currentAuthority, multiSigners);
    const data = $6e282d3cd5411099$require$Buffer.alloc($6e282d3cd5411099$export$2535570c9ace1fc4.span);
    $6e282d3cd5411099$export$2535570c9ace1fc4.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).SetAuthority,
        authorityType: authorityType,
        newAuthorityOption: newAuthority ? 1 : 0,
        newAuthority: newAuthority || new (0, $gNDby.PublicKey)(0)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $6e282d3cd5411099$export$e635707a3d887353(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $6e282d3cd5411099$export$2535570c9ace1fc4.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, currentAuthority: currentAuthority, multiSigners: multiSigners }, data: data } = $6e282d3cd5411099$export$d756f440af3139c9(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).SetAuthority) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !currentAuthority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            currentAuthority: currentAuthority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $6e282d3cd5411099$export$d756f440af3139c9({ programId: programId, keys: [account, currentAuthority, ...multiSigners], data: data }) {
    const { instruction: instruction, authorityType: authorityType, newAuthorityOption: newAuthorityOption, newAuthority: newAuthority } = $6e282d3cd5411099$export$2535570c9ace1fc4.decode(data);
    return {
        programId: programId,
        keys: {
            account: account,
            currentAuthority: currentAuthority,
            multiSigners: multiSigners
        },
        data: {
            instruction: instruction,
            authorityType: authorityType,
            newAuthority: newAuthorityOption ? newAuthority : null
        }
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $ff3192d7cb03dffd$require$Buffer = $6ZWSX.Buffer;
const $ff3192d7cb03dffd$export$7c5205e286efe49c = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount')
]);
function $ff3192d7cb03dffd$export$14725c5da878fcde(mint, destination, authority, amount, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: mint,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], authority, multiSigners);
    const data = $ff3192d7cb03dffd$require$Buffer.alloc($ff3192d7cb03dffd$export$7c5205e286efe49c.span);
    $ff3192d7cb03dffd$export$7c5205e286efe49c.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).MintTo,
        amount: BigInt(amount)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $ff3192d7cb03dffd$export$fb60b55576849cb4(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $ff3192d7cb03dffd$export$7c5205e286efe49c.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { mint: mint, destination: destination, authority: authority, multiSigners: multiSigners }, data: data } = $ff3192d7cb03dffd$export$3c3dca3b317218aa(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).MintTo) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!mint || !destination || !authority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            mint: mint,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $ff3192d7cb03dffd$export$3c3dca3b317218aa({ programId: programId, keys: [mint, destination, authority, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            mint: mint,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: $ff3192d7cb03dffd$export$7c5205e286efe49c.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $640b093a2388fec2$require$Buffer = $6ZWSX.Buffer;
const $640b093a2388fec2$export$d7489578819f81f1 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount')
]);
function $640b093a2388fec2$export$547a3ccf609483d6(account, mint, owner, amount, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $640b093a2388fec2$require$Buffer.alloc($640b093a2388fec2$export$d7489578819f81f1.span);
    $640b093a2388fec2$export$d7489578819f81f1.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).Burn,
        amount: BigInt(amount)
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $640b093a2388fec2$export$57f4bdd23f27fd38(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $640b093a2388fec2$export$d7489578819f81f1.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, owner: owner, multiSigners: multiSigners }, data: data } = $640b093a2388fec2$export$70dd153883ac1fbe(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).Burn) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $640b093a2388fec2$export$70dd153883ac1fbe({ programId: programId, keys: [account, mint, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $640b093a2388fec2$export$d7489578819f81f1.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $7db2bd8aab2c1986$require$Buffer = $6ZWSX.Buffer;
const $7db2bd8aab2c1986$export$a4176b7dab20a6a7 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $7db2bd8aab2c1986$export$71154645a2247f78(account, destination, authority, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], authority, multiSigners);
    const data = $7db2bd8aab2c1986$require$Buffer.alloc($7db2bd8aab2c1986$export$a4176b7dab20a6a7.span);
    $7db2bd8aab2c1986$export$a4176b7dab20a6a7.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).CloseAccount
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $7db2bd8aab2c1986$export$4e76322ea70c0684(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $7db2bd8aab2c1986$export$a4176b7dab20a6a7.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, destination: destination, authority: authority, multiSigners: multiSigners }, data: data } = $7db2bd8aab2c1986$export$7f09b00ae0c7f6f7(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).CloseAccount) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !destination || !authority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $7db2bd8aab2c1986$export$7f09b00ae0c7f6f7({ programId: programId, keys: [account, destination, authority, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: $7db2bd8aab2c1986$export$a4176b7dab20a6a7.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $a3133dd453e05b62$require$Buffer = $6ZWSX.Buffer;
const $a3133dd453e05b62$export$7483006f735eb3cc = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $a3133dd453e05b62$export$5347ad2971e00422(account, mint, authority, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        }
    ], authority, multiSigners);
    const data = $a3133dd453e05b62$require$Buffer.alloc($a3133dd453e05b62$export$7483006f735eb3cc.span);
    $a3133dd453e05b62$export$7483006f735eb3cc.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).FreezeAccount
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $a3133dd453e05b62$export$9d8cf7f28ebde4f(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $a3133dd453e05b62$export$7483006f735eb3cc.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, authority: authority, multiSigners: multiSigners }, data: data } = $a3133dd453e05b62$export$9465dfdd650fdaf8(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).FreezeAccount) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !authority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            authority: authority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $a3133dd453e05b62$export$9465dfdd650fdaf8({ programId: programId, keys: [account, mint, authority, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            authority: authority,
            multiSigners: multiSigners
        },
        data: $a3133dd453e05b62$export$7483006f735eb3cc.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $9b1ed2d930444cd6$require$Buffer = $6ZWSX.Buffer;
const $9b1ed2d930444cd6$export$531c31755158aa3a = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $9b1ed2d930444cd6$export$7664459346e9ca76(account, mint, authority, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        }
    ], authority, multiSigners);
    const data = $9b1ed2d930444cd6$require$Buffer.alloc($9b1ed2d930444cd6$export$531c31755158aa3a.span);
    $9b1ed2d930444cd6$export$531c31755158aa3a.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).ThawAccount
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $9b1ed2d930444cd6$export$d5ee1866b4c45e48(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $9b1ed2d930444cd6$export$531c31755158aa3a.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, authority: authority, multiSigners: multiSigners }, data: data } = $9b1ed2d930444cd6$export$d8f0e80e15e9c942(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).ThawAccount) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !authority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            authority: authority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $9b1ed2d930444cd6$export$d8f0e80e15e9c942({ programId: programId, keys: [account, mint, authority, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            authority: authority,
            multiSigners: multiSigners
        },
        data: $9b1ed2d930444cd6$export$531c31755158aa3a.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $f83c4af7f7b56323$require$Buffer = $6ZWSX.Buffer;
const $f83c4af7f7b56323$export$759164dfc0df7ab2 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount'),
    (0, $Q02IV.u8)('decimals')
]);
function $f83c4af7f7b56323$export$8532a7098883409f(source, mint, destination, owner, amount, decimals, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: source,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $f83c4af7f7b56323$require$Buffer.alloc($f83c4af7f7b56323$export$759164dfc0df7ab2.span);
    $f83c4af7f7b56323$export$759164dfc0df7ab2.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).TransferChecked,
        amount: BigInt(amount),
        decimals: decimals
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $f83c4af7f7b56323$export$9d52162c8ba07641(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $f83c4af7f7b56323$export$759164dfc0df7ab2.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { source: source, mint: mint, destination: destination, owner: owner, multiSigners: multiSigners }, data: data } = $f83c4af7f7b56323$export$7e840031fe1a6405(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).TransferChecked) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!source || !mint || !destination || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            source: source,
            mint: mint,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $f83c4af7f7b56323$export$7e840031fe1a6405({ programId: programId, keys: [source, mint, destination, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            source: source,
            mint: mint,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $f83c4af7f7b56323$export$759164dfc0df7ab2.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $f1c777739879dbc7$require$Buffer = $6ZWSX.Buffer;
const $f1c777739879dbc7$export$3a37045f1829a601 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount'),
    (0, $Q02IV.u8)('decimals')
]);
function $f1c777739879dbc7$export$237b05e65d9605fa(account, mint, delegate, owner, amount, decimals, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: delegate,
            isSigner: false,
            isWritable: false
        }
    ], owner, multiSigners);
    const data = $f1c777739879dbc7$require$Buffer.alloc($f1c777739879dbc7$export$3a37045f1829a601.span);
    $f1c777739879dbc7$export$3a37045f1829a601.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).ApproveChecked,
        amount: BigInt(amount),
        decimals: decimals
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $f1c777739879dbc7$export$e27a94667bf1cbd9(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $f1c777739879dbc7$export$3a37045f1829a601.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, delegate: delegate, owner: owner, multiSigners: multiSigners }, data: data } = $f1c777739879dbc7$export$6eba9b29ff01f796(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).ApproveChecked) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !delegate || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            delegate: delegate,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $f1c777739879dbc7$export$6eba9b29ff01f796({ programId: programId, keys: [account, mint, delegate, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            delegate: delegate,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $f1c777739879dbc7$export$3a37045f1829a601.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $63db01dd4d7810dd$require$Buffer = $6ZWSX.Buffer;
const $63db01dd4d7810dd$export$a0120243d50a4d5c = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount'),
    (0, $Q02IV.u8)('decimals')
]);
function $63db01dd4d7810dd$export$2df3bc3366873487(mint, destination, authority, amount, decimals, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: mint,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], authority, multiSigners);
    const data = $63db01dd4d7810dd$require$Buffer.alloc($63db01dd4d7810dd$export$a0120243d50a4d5c.span);
    $63db01dd4d7810dd$export$a0120243d50a4d5c.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).MintToChecked,
        amount: BigInt(amount),
        decimals: decimals
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $63db01dd4d7810dd$export$ccc0b6ea4a7664ac(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $63db01dd4d7810dd$export$a0120243d50a4d5c.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { mint: mint, destination: destination, authority: authority, multiSigners: multiSigners }, data: data } = $63db01dd4d7810dd$export$ba230ce52a14c859(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).MintToChecked) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!mint || !destination || !authority) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            mint: mint,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $63db01dd4d7810dd$export$ba230ce52a14c859({ programId: programId, keys: [mint, destination, authority, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            mint: mint,
            destination: destination,
            authority: authority,
            multiSigners: multiSigners
        },
        data: $63db01dd4d7810dd$export$a0120243d50a4d5c.decode(data)
    };
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");





var $6ZWSX = parcelRequire("6ZWSX");
var $e27da1abbacb176d$require$Buffer = $6ZWSX.Buffer;
const $e27da1abbacb176d$export$df92185183ada10c = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount'),
    (0, $Q02IV.u8)('decimals')
]);
function $e27da1abbacb176d$export$35b7885163683ba7(account, mint, owner, amount, decimals, multiSigners = [], programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = (0, $11280619b145ccb3$export$fde60050662f8c02)([
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $e27da1abbacb176d$require$Buffer.alloc($e27da1abbacb176d$export$df92185183ada10c.span);
    $e27da1abbacb176d$export$df92185183ada10c.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).BurnChecked,
        amount: BigInt(amount),
        decimals: decimals
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $e27da1abbacb176d$export$8fee70dfe820dbb9(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $e27da1abbacb176d$export$df92185183ada10c.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account, mint: mint, owner: owner, multiSigners: multiSigners }, data: data } = $e27da1abbacb176d$export$2e48400650bfc33d(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).BurnChecked) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account || !mint || !owner) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $e27da1abbacb176d$export$2e48400650bfc33d({ programId: programId, keys: [account, mint, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account,
            mint: mint,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $e27da1abbacb176d$export$df92185183ada10c.decode(data)
    };
}





var $Q02IV = parcelRequire("Q02IV");

var $gNDby = parcelRequire("gNDby");




var $6ZWSX = parcelRequire("6ZWSX");
var $b1a574f108db7116$require$Buffer = $6ZWSX.Buffer;
const $b1a574f108db7116$export$25a6b310bb2e4fdc = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('instruction')
]);
function $b1a574f108db7116$export$15b5ddb75e49fdd1(account, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const keys = [
        {
            pubkey: account,
            isSigner: false,
            isWritable: true
        }
    ];
    const data = $b1a574f108db7116$require$Buffer.alloc($b1a574f108db7116$export$25a6b310bb2e4fdc.span);
    $b1a574f108db7116$export$25a6b310bb2e4fdc.encode({
        instruction: (0, $b9e868e37c405652$export$236c07be390a0994).SyncNative
    }, data);
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $b1a574f108db7116$export$220d2eee9ff3dbca(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $ac590afd90e938f5$export$a241007212c884f6)();
    if (instruction.data.length !== $b1a574f108db7116$export$25a6b310bb2e4fdc.span) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const { keys: { account: account }, data: data } = $b1a574f108db7116$export$15c60f186ae07b9d(instruction);
    if (data.instruction !== (0, $b9e868e37c405652$export$236c07be390a0994).SyncNative) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (!account) throw new (0, $ac590afd90e938f5$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            account: account
        },
        data: data
    };
}
function $b1a574f108db7116$export$15c60f186ae07b9d({ programId: programId, keys: [account], data: data }) {
    return {
        programId: programId,
        keys: {
            account: account
        },
        data: $b1a574f108db7116$export$25a6b310bb2e4fdc.decode(data)
    };
}









var $Q02IV = parcelRequire("Q02IV");




















function $6b8806b69d9d4c77$export$10b35c04f330bef9(instruction, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    if (!instruction.data.length) throw new (0, $ac590afd90e938f5$export$f96a822f391c3cc4)();
    const type = (0, $Q02IV.u8)().decode(instruction.data);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMint) return (0, $f37d6c3b204bb2ee$export$cdfc2dbfd11013bc)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount) return (0, $faa52ec80b06983e$export$8d0237e5b532e544)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMultisig) return (0, $2d0cb51e3236b63c$export$b7cb5c4660417270)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).Transfer) return (0, $e83b680ad6ab8252$export$d4ef34cde439b107)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).Approve) return (0, $ab33fa935ce1c104$export$e17e93069086368e)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).Revoke) return (0, $9871ee14dd00cdce$export$8ec83be7f2d0eb71)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).SetAuthority) return (0, $6e282d3cd5411099$export$e635707a3d887353)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).MintTo) return (0, $ff3192d7cb03dffd$export$fb60b55576849cb4)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).Burn) return (0, $640b093a2388fec2$export$57f4bdd23f27fd38)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).CloseAccount) return (0, $7db2bd8aab2c1986$export$4e76322ea70c0684)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).FreezeAccount) return (0, $a3133dd453e05b62$export$9d8cf7f28ebde4f)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).ThawAccount) return (0, $9b1ed2d930444cd6$export$d5ee1866b4c45e48)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).TransferChecked) return (0, $f83c4af7f7b56323$export$9d52162c8ba07641)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).ApproveChecked) return (0, $f1c777739879dbc7$export$e27a94667bf1cbd9)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).MintToChecked) return (0, $63db01dd4d7810dd$export$ccc0b6ea4a7664ac)(instruction, programId);
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).BurnChecked) return (0, $e27da1abbacb176d$export$8fee70dfe820dbb9)(instruction, programId);
    // TODO: implement
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount2) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).SyncNative) return (0, $b1a574f108db7116$export$220d2eee9ff3dbca)(instruction, programId);
    // TODO: implement
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount3) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    // TODO: implement
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMultisig2) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    // TODO: implement
    if (type === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMint2) throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
    throw new (0, $ac590afd90e938f5$export$e1301365d704141e)();
}
function $6b8806b69d9d4c77$export$9e2b6c4d135520c0(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMint;
}
function $6b8806b69d9d4c77$export$2b7b41049aff0050(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeAccount;
}
function $6b8806b69d9d4c77$export$f19afd6dc7d3d65e(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).InitializeMultisig;
}
function $6b8806b69d9d4c77$export$f7500a03ea602a2d(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).Transfer;
}
function $6b8806b69d9d4c77$export$ea1a219b9a5ef98e(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).Approve;
}
function $6b8806b69d9d4c77$export$f28e4137fd3c1883(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).Revoke;
}
function $6b8806b69d9d4c77$export$d534c848c95e29fc(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).SetAuthority;
}
function $6b8806b69d9d4c77$export$f16a7fef74a00b10(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).MintTo;
}
function $6b8806b69d9d4c77$export$4ccd86ffc0dbec4b(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).Burn;
}
function $6b8806b69d9d4c77$export$db51388aad519a1(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).CloseAccount;
}
function $6b8806b69d9d4c77$export$56b8ab944a6f6508(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).FreezeAccount;
}
function $6b8806b69d9d4c77$export$f843fb86d176ad5f(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).ThawAccount;
}
function $6b8806b69d9d4c77$export$835c5cebf3708c89(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).TransferChecked;
}
function $6b8806b69d9d4c77$export$916075b687788da6(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).ApproveChecked;
}
function $6b8806b69d9d4c77$export$336d324307647be2(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).MintToChecked;
}
function $6b8806b69d9d4c77$export$5488394296f387f2(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).BurnChecked;
}
function $6b8806b69d9d4c77$export$a71168273249af78(decoded) {
    return decoded.data.instruction === (0, $b9e868e37c405652$export$236c07be390a0994).SyncNative;
} /** TODO: docs, implement */  // export function isInitializeAccount3Instruction(
 //     decoded: DecodedInstruction
 // ): decoded is DecodedInitializeAccount3Instruction {
 //     return decoded.data.instruction === TokenInstruction.InitializeAccount3;
 // }
 /** TODO: docs, implement */  // export function isInitializeMultisig2Instruction(
 //     decoded: DecodedInstruction
 // ): decoded is DecodedInitializeMultisig2Instruction {
 //     return decoded.data.instruction === TokenInstruction.InitializeMultisig2;
 // }
 /** TODO: docs, implement */  // export function isInitializeMint2Instruction(
 //     decoded: DecodedInstruction
 // ): decoded is DecodedInitializeMint2Instruction {
 //     return decoded.data.instruction === TokenInstruction.InitializeMint2;
 // }



var $gNDby = parcelRequire("gNDby");


var $6ZWSX = parcelRequire("6ZWSX");
var $688335c02a23acb9$require$Buffer = $6ZWSX.Buffer;
function $688335c02a23acb9$export$65d7d2fa066d6cc6(payer, associatedToken, owner, mint, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $2d517843a01c61a3$export$57a4f33bcc1767fa)) {
    const keys = [
        {
            pubkey: payer,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: associatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: owner,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $gNDby.SystemProgram).programId,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $gNDby.SYSVAR_RENT_PUBKEY),
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $gNDby.TransactionInstruction)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: $688335c02a23acb9$require$Buffer.alloc(0)
    });
}





var $Q02IV = parcelRequire("Q02IV");



var $8e8ff53861892a60$export$70504fba2ce56d52;
(function(AccountState) {
    AccountState[AccountState["Uninitialized"] = 0] = "Uninitialized";
    AccountState[AccountState["Initialized"] = 1] = "Initialized";
    AccountState[AccountState["Frozen"] = 2] = "Frozen";
})($8e8ff53861892a60$export$70504fba2ce56d52 || ($8e8ff53861892a60$export$70504fba2ce56d52 = {}));
const $8e8ff53861892a60$export$cab31ec27f6c5fa = (0, $Q02IV.struct)([
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('mint'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('owner'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('amount'),
    (0, $Q02IV.u32)('delegateOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('delegate'),
    (0, $Q02IV.u8)('state'),
    (0, $Q02IV.u32)('isNativeOption'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('isNative'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('delegatedAmount'),
    (0, $Q02IV.u32)('closeAuthorityOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('closeAuthority')
]);
const $8e8ff53861892a60$export$66ab21ef808e9dc6 = $8e8ff53861892a60$export$cab31ec27f6c5fa.span;
async function $8e8ff53861892a60$export$4f9234baf34abd0(connection, address, commitment, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    if (!info) throw new (0, $ac590afd90e938f5$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $ac590afd90e938f5$export$abb470453474d51)();
    if (info.data.length != $8e8ff53861892a60$export$66ab21ef808e9dc6) throw new (0, $ac590afd90e938f5$export$250d31de4ddb7ca5)();
    const rawAccount = $8e8ff53861892a60$export$cab31ec27f6c5fa.decode(info.data);
    return {
        address: address,
        mint: rawAccount.mint,
        owner: rawAccount.owner,
        amount: rawAccount.amount,
        delegate: rawAccount.delegateOption ? rawAccount.delegate : null,
        delegatedAmount: rawAccount.delegatedAmount,
        isInitialized: rawAccount.state !== $8e8ff53861892a60$export$70504fba2ce56d52.Uninitialized,
        isFrozen: rawAccount.state === $8e8ff53861892a60$export$70504fba2ce56d52.Frozen,
        isNative: !!rawAccount.isNativeOption,
        rentExemptReserve: rawAccount.isNativeOption ? rawAccount.isNative : null,
        closeAuthority: rawAccount.closeAuthorityOption ? rawAccount.closeAuthority : null
    };
}
async function $8e8ff53861892a60$export$22f9b1d0cdd74bb0(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($8e8ff53861892a60$export$66ab21ef808e9dc6, commitment);
}



var $Q02IV = parcelRequire("Q02IV");


var $gNDby = parcelRequire("gNDby");


const $8bce0b6b9c22831c$export$1374e91decd2fbe5 = (0, $Q02IV.struct)([
    (0, $Q02IV.u32)('mintAuthorityOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('mintAuthority'),
    (0, $617399e00c93be74$export$cd1442401e54cffa)('supply'),
    (0, $Q02IV.u8)('decimals'),
    (0, $f86b8e02dedf4e39$export$87b259aa03e3d267)('isInitialized'),
    (0, $Q02IV.u32)('freezeAuthorityOption'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('freezeAuthority')
]);
const $8bce0b6b9c22831c$export$1e66c79f18e1c0c4 = $8bce0b6b9c22831c$export$1374e91decd2fbe5.span;
async function $8bce0b6b9c22831c$export$aa28710f9c948d46(connection, address, commitment, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    if (!info) throw new (0, $ac590afd90e938f5$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $ac590afd90e938f5$export$abb470453474d51)();
    if (info.data.length != $8bce0b6b9c22831c$export$1e66c79f18e1c0c4) throw new (0, $ac590afd90e938f5$export$250d31de4ddb7ca5)();
    const rawMint = $8bce0b6b9c22831c$export$1374e91decd2fbe5.decode(info.data);
    return {
        address: address,
        mintAuthority: rawMint.mintAuthorityOption ? rawMint.mintAuthority : null,
        supply: rawMint.supply,
        decimals: rawMint.decimals,
        isInitialized: rawMint.isInitialized,
        freezeAuthority: rawMint.freezeAuthorityOption ? rawMint.freezeAuthority : null
    };
}
async function $8bce0b6b9c22831c$export$ee29e619ed2e153c(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($8bce0b6b9c22831c$export$1e66c79f18e1c0c4, commitment);
}
async function $8bce0b6b9c22831c$export$d776e5c4182d21cc(mint, owner, allowOwnerOffCurve = false, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $2d517843a01c61a3$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $gNDby.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $ac590afd90e938f5$export$c431a85da6f99bf0)();
    const [address] = await (0, $gNDby.PublicKey).findProgramAddress([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}



var $Q02IV = parcelRequire("Q02IV");



const $969c7c7a160e3652$export$c23cd279ce124ca0 = (0, $Q02IV.struct)([
    (0, $Q02IV.u8)('m'),
    (0, $Q02IV.u8)('n'),
    (0, $f86b8e02dedf4e39$export$87b259aa03e3d267)('isInitialized'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer1'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer2'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer3'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer4'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer5'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer6'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer7'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer8'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer9'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer10'),
    (0, $d5c40539f12254c9$export$86f13247979de5d7)('signer11')
]);
const $969c7c7a160e3652$export$c2abf71f91a1605b = $969c7c7a160e3652$export$c23cd279ce124ca0.span;
async function $969c7c7a160e3652$export$257dfa65916d8d24(connection, address, commitment, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    if (!info) throw new (0, $ac590afd90e938f5$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $ac590afd90e938f5$export$abb470453474d51)();
    if (info.data.length != $969c7c7a160e3652$export$c2abf71f91a1605b) throw new (0, $ac590afd90e938f5$export$250d31de4ddb7ca5)();
    return {
        address: address,
        ...$969c7c7a160e3652$export$c23cd279ce124ca0.decode(info.data)
    };
}
async function $969c7c7a160e3652$export$cd6dc5245600da53(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($969c7c7a160e3652$export$c2abf71f91a1605b, commitment);
}





var $gNDby = parcelRequire("gNDby");



async function $9abe7ce1e4e0eac2$export$6a685cc2f89e9f9d(connection, payer, mintAuthority, freezeAuthority, decimals, keypair = (0, $gNDby.Keypair).generate(), confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const lamports = await (0, $8bce0b6b9c22831c$export$ee29e619ed2e153c)(connection);
    const transaction = new (0, $gNDby.Transaction)().add((0, $gNDby.SystemProgram).createAccount({
        fromPubkey: payer.publicKey,
        newAccountPubkey: keypair.publicKey,
        space: (0, $8bce0b6b9c22831c$export$1e66c79f18e1c0c4),
        lamports: lamports,
        programId: programId
    }), (0, $f37d6c3b204bb2ee$export$25a2c50cb893982f)(keypair.publicKey, decimals, mintAuthority, freezeAuthority, programId));
    await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        keypair
    ], confirmOptions);
    return keypair.publicKey;
}



var $gNDby = parcelRequire("gNDby");




var $gNDby = parcelRequire("gNDby");



async function $27057ec7e4dec243$export$18adbcacd0b66977(connection, payer, mint, owner, confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $2d517843a01c61a3$export$57a4f33bcc1767fa)) {
    const associatedToken = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(mint, owner, false, programId, associatedTokenProgramId);
    const transaction = new (0, $gNDby.Transaction)().add((0, $688335c02a23acb9$export$65d7d2fa066d6cc6)(payer.publicKey, associatedToken, owner, mint, programId, associatedTokenProgramId));
    await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer
    ], confirmOptions);
    return associatedToken;
}


async function $697001c8d8231568$export$6f5378aa3397b877(connection, payer, mint, owner, keypair, confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    // If a keypair isn't provided, create the associated token account and return its address
    if (!keypair) return await (0, $27057ec7e4dec243$export$18adbcacd0b66977)(connection, payer, mint, owner, confirmOptions, programId);
    // Otherwise, create the account with the provided keypair and return its public key
    const lamports = await (0, $8e8ff53861892a60$export$22f9b1d0cdd74bb0)(connection);
    const transaction = new (0, $gNDby.Transaction)().add((0, $gNDby.SystemProgram).createAccount({
        fromPubkey: payer.publicKey,
        newAccountPubkey: keypair.publicKey,
        space: (0, $8e8ff53861892a60$export$66ab21ef808e9dc6),
        lamports: lamports,
        programId: programId
    }), (0, $faa52ec80b06983e$export$d2c7d24f6cca7beb)(keypair.publicKey, mint, owner, programId));
    await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        keypair
    ], confirmOptions);
    return keypair.publicKey;
}



var $gNDby = parcelRequire("gNDby");




async function $282b3ef606d4227b$export$e522ef7ad0446b60(connection, payer, owner, amount, keypair, confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    // If the amount provided is explicitly 0 or NaN, just create the account without funding it
    if (!amount) return await (0, $697001c8d8231568$export$6f5378aa3397b877)(connection, payer, (0, $2d517843a01c61a3$export$71f490c6a4aef7af), owner, keypair, confirmOptions, programId);
    // If a keypair isn't provided, create the account at the owner's ATA for the native mint and return its address
    if (!keypair) {
        const associatedToken = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)((0, $2d517843a01c61a3$export$71f490c6a4aef7af), owner, false, programId, (0, $2d517843a01c61a3$export$57a4f33bcc1767fa));
        const transaction = new (0, $gNDby.Transaction)().add((0, $688335c02a23acb9$export$65d7d2fa066d6cc6)(payer.publicKey, associatedToken, owner, (0, $2d517843a01c61a3$export$71f490c6a4aef7af), programId, (0, $2d517843a01c61a3$export$57a4f33bcc1767fa)), (0, $gNDby.SystemProgram).transfer({
            fromPubkey: payer.publicKey,
            toPubkey: associatedToken,
            lamports: amount
        }), (0, $b1a574f108db7116$export$15b5ddb75e49fdd1)(associatedToken, programId));
        await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
            payer
        ], confirmOptions);
        return associatedToken;
    }
    // Otherwise, create the account with the provided keypair and return its public key
    const lamports = await (0, $8e8ff53861892a60$export$22f9b1d0cdd74bb0)(connection);
    const transaction = new (0, $gNDby.Transaction)().add((0, $gNDby.SystemProgram).createAccount({
        fromPubkey: payer.publicKey,
        newAccountPubkey: keypair.publicKey,
        space: (0, $8e8ff53861892a60$export$66ab21ef808e9dc6),
        lamports: lamports,
        programId: programId
    }), (0, $gNDby.SystemProgram).transfer({
        fromPubkey: payer.publicKey,
        toPubkey: keypair.publicKey,
        lamports: amount
    }), (0, $faa52ec80b06983e$export$d2c7d24f6cca7beb)(keypair.publicKey, (0, $2d517843a01c61a3$export$71f490c6a4aef7af), owner, programId));
    await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        keypair
    ], confirmOptions);
    return keypair.publicKey;
}



var $gNDby = parcelRequire("gNDby");



async function $1531d6d349930722$export$2b9e5b26054a5ab2(connection, payer, signers, m, keypair = (0, $gNDby.Keypair).generate(), confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const lamports = await (0, $969c7c7a160e3652$export$cd6dc5245600da53)(connection);
    const transaction = new (0, $gNDby.Transaction)().add((0, $gNDby.SystemProgram).createAccount({
        fromPubkey: payer.publicKey,
        newAccountPubkey: keypair.publicKey,
        space: (0, $969c7c7a160e3652$export$c2abf71f91a1605b),
        lamports: lamports,
        programId: programId
    }), (0, $2d0cb51e3236b63c$export$eb57bdd85d0d8c83)(keypair.publicKey, signers, m, programId));
    await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        keypair
    ], confirmOptions);
    return keypair.publicKey;
}



var $gNDby = parcelRequire("gNDby");



var $gNDby = parcelRequire("gNDby");
function $bad3e91355c008d4$export$6352a17a50193ded(signerOrMultisig, multiSigners) {
    return signerOrMultisig instanceof (0, $gNDby.PublicKey) ? [
        signerOrMultisig,
        multiSigners
    ] : [
        signerOrMultisig.publicKey,
        [
            signerOrMultisig
        ]
    ];
}


async function $76529eb8102a75f1$export$c9b234447cf4ef7c(connection, payer, source, destination, owner, amount, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $e83b680ad6ab8252$export$b274d5cebe357db9)(source, destination, ownerPublicKey, amount, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $1e318aa7f623f2df$export$5ba7c78c9d5e2122(connection, payer, account, delegate, owner, amount, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $ab33fa935ce1c104$export$777c38f0c8b4fab)(account, delegate, ownerPublicKey, amount, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $012796cc3a5284d0$export$573f8dbbf6fbef75(connection, payer, account, owner, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $9871ee14dd00cdce$export$95ab20528db957d9)(account, ownerPublicKey, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $7eac135154ff8113$export$ea13ae8cce099fbd(connection, payer, account, currentAuthority, authorityType, newAuthority, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [currentAuthorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(currentAuthority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $6e282d3cd5411099$export$96565b3fb1f7396a)(account, currentAuthorityPublicKey, authorityType, newAuthority, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $30f6ecd8cf975a22$export$a41226d5e63a53ff(connection, payer, mint, destination, authority, amount, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [authorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(authority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $ff3192d7cb03dffd$export$14725c5da878fcde)(mint, destination, authorityPublicKey, amount, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $dbe39c16dca61e6b$export$9c0bd85cee0180d7(connection, payer, account, mint, owner, amount, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $640b093a2388fec2$export$547a3ccf609483d6)(account, mint, ownerPublicKey, amount, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $3e930a6642aafaa7$export$cbb3ed31bbf98fbe(connection, payer, account, destination, authority, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [authorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(authority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $7db2bd8aab2c1986$export$71154645a2247f78)(account, destination, authorityPublicKey, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $ffcc2418f12dc97a$export$ac209b91c16e86a(connection, payer, account, mint, authority, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [authorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(authority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $a3133dd453e05b62$export$5347ad2971e00422)(account, mint, authorityPublicKey, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $570f01f9cdb6c73b$export$f79a2a0e3ba025e9(connection, payer, account, mint, authority, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [authorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(authority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $9b1ed2d930444cd6$export$7664459346e9ca76)(account, mint, authorityPublicKey, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $6624399d962a7033$export$3d1ee621bfb1fd7d(connection, payer, source, mint, destination, owner, amount, decimals, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $f83c4af7f7b56323$export$8532a7098883409f)(source, mint, destination, ownerPublicKey, amount, decimals, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $df7430fe2e6175e1$export$d9d1a043ea41d9df(connection, payer, mint, account, delegate, owner, amount, decimals, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $f1c777739879dbc7$export$237b05e65d9605fa)(account, mint, delegate, ownerPublicKey, amount, decimals, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $8735683fda674f3d$export$c054256c947a2ecf(connection, payer, mint, destination, authority, amount, decimals, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [authorityPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(authority, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $63db01dd4d7810dd$export$2df3bc3366873487)(mint, destination, authorityPublicKey, amount, decimals, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");



async function $8f4ed085764dbe46$export$f5522baa2d11fbd2(connection, payer, account, mint, owner, amount, decimals, multiSigners = [], confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const [ownerPublicKey, signers] = (0, $bad3e91355c008d4$export$6352a17a50193ded)(owner, multiSigners);
    const transaction = new (0, $gNDby.Transaction)().add((0, $e27da1abbacb176d$export$35b7885163683ba7)(account, mint, ownerPublicKey, amount, decimals, multiSigners, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer,
        ...signers
    ], confirmOptions);
}



var $gNDby = parcelRequire("gNDby");


async function $598279d05716ae86$export$1ddb8795e77e1c6f(connection, payer, account, confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801)) {
    const transaction = new (0, $gNDby.Transaction)().add((0, $b1a574f108db7116$export$15b5ddb75e49fdd1)(account, programId));
    return await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
        payer
    ], confirmOptions);
}




var $gNDby = parcelRequire("gNDby");




async function $b825a95e9a39c3a7$export$1473534aefa47d36(connection, payer, mint, owner, allowOwnerOffCurve = false, commitment, confirmOptions, programId = (0, $2d517843a01c61a3$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $2d517843a01c61a3$export$57a4f33bcc1767fa)) {
    const associatedToken = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(mint, owner, allowOwnerOffCurve, programId, associatedTokenProgramId);
    // This is the optimal logic, considering TX fee, client-side computation, RPC roundtrips and guaranteed idempotent.
    // Sadly we can't do this atomically.
    let account;
    try {
        account = await (0, $8e8ff53861892a60$export$4f9234baf34abd0)(connection, associatedToken, commitment, programId);
    } catch (error) {
        // TokenAccountNotFoundError can be possible if the associated address has already received some lamports,
        // becoming a system account. Assuming program derived addressing is safe, this is the only case for the
        // TokenInvalidAccountOwnerError in this code path.
        if (error instanceof (0, $ac590afd90e938f5$export$a09a5e48de2f3404) || error instanceof (0, $ac590afd90e938f5$export$abb470453474d51)) {
            // As this isn't atomic, it's possible others can create associated accounts meanwhile.
            try {
                const transaction = new (0, $gNDby.Transaction)().add((0, $688335c02a23acb9$export$65d7d2fa066d6cc6)(payer.publicKey, associatedToken, owner, mint, programId, associatedTokenProgramId));
                await (0, $gNDby.sendAndConfirmTransaction)(connection, transaction, [
                    payer
                ], confirmOptions);
            } catch (error) {
            // Ignore all errors; for now there is no API-compatible way to selectively ignore the expected
            // instruction error if the associated account exists already.
            }
            // Now this should always succeed
            account = await (0, $8e8ff53861892a60$export$4f9234baf34abd0)(connection, associatedToken, commitment, programId);
        } else throw error;
    }
    if (!account.mint.equals(mint)) throw new (0, $ac590afd90e938f5$export$871debb212ec395)();
    if (!account.owner.equals(owner)) throw new (0, $ac590afd90e938f5$export$9d3e0012e0e06993)();
    return account;
}









var $gNDby = parcelRequire("gNDby");

var $dws6U = parcelRequire("dws6U");


var $6ZWSX = parcelRequire("6ZWSX");
var $8f1af5f862f41861$require$Buffer = $6ZWSX.Buffer;
class $8f1af5f862f41861$export$c02c1aba4b5e1904 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'CreateTransferError';
    }
}
async function $8f1af5f862f41861$export$4496203d8e8ed8bf(connection, sender, { recipient: recipient, amount: amount, splToken: splToken, reference: reference, memo: memo }, { commitment: commitment } = {}) {
    // Check that the sender and recipient accounts exist
    const senderInfo = await connection.getAccountInfo(sender);
    if (!senderInfo) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender not found');
    const recipientInfo = await connection.getAccountInfo(recipient);
    if (!recipientInfo) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient not found');
    // A native SOL or SPL token transfer instruction
    const instruction = splToken ? await $8f1af5f862f41861$var$createSPLTokenInstruction(recipient, amount, splToken, sender, connection) : await $8f1af5f862f41861$var$createSystemInstruction(recipient, amount, sender, connection);
    // If reference accounts are provided, add them to the transfer instruction
    if (reference) {
        if (!Array.isArray(reference)) reference = [
            reference
        ];
        for (const pubkey of reference)instruction.keys.push({
            pubkey: pubkey,
            isWritable: false,
            isSigner: false
        });
    }
    // Create the transaction
    const transaction = new (0, $gNDby.Transaction)();
    transaction.feePayer = sender;
    transaction.recentBlockhash = (await connection.getRecentBlockhash(commitment)).blockhash;
    // If a memo is provided, add it to the transaction before adding the transfer instruction
    if (memo != null) transaction.add(new (0, $gNDby.TransactionInstruction)({
        programId: (0, $f49a3504c5beffd8$export$8187fb71f6d8e245),
        keys: [],
        data: $8f1af5f862f41861$require$Buffer.from(memo, 'utf8')
    }));
    // Add the transfer instruction to the transaction
    transaction.add(instruction);
    return transaction;
}
async function $8f1af5f862f41861$var$createSystemInstruction(recipient, amount, sender, connection) {
    // Check that the sender and recipient accounts exist
    const senderInfo = await connection.getAccountInfo(sender);
    if (!senderInfo) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender not found');
    const recipientInfo = await connection.getAccountInfo(recipient);
    if (!recipientInfo) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient not found');
    // Check that the sender and recipient are valid native accounts
    if (!senderInfo.owner.equals((0, $gNDby.SystemProgram).programId)) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender owner invalid');
    if (senderInfo.executable) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender executable');
    if (!recipientInfo.owner.equals((0, $gNDby.SystemProgram).programId)) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient owner invalid');
    if (recipientInfo.executable) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient executable');
    // Check that the amount provided doesn't have greater precision than SOL
    if (amount.decimalPlaces() > (0, $f49a3504c5beffd8$export$68a35e92ed907a83)) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('amount decimals invalid');
    // Convert input decimal amount to integer lamports
    amount = amount.times((0, $gNDby.LAMPORTS_PER_SOL)).integerValue((0, $dws6U.default).ROUND_FLOOR);
    // Check that the sender has enough lamports
    const lamports = amount.toNumber();
    if (lamports > senderInfo.lamports) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('insufficient funds');
    // Create an instruction to transfer native SOL
    return (0, $gNDby.SystemProgram).transfer({
        fromPubkey: sender,
        toPubkey: recipient,
        lamports: lamports
    });
}
async function $8f1af5f862f41861$var$createSPLTokenInstruction(recipient, amount, splToken, sender, connection) {
    // Check that the token provided is an initialized mint
    const mint = await (0, $8bce0b6b9c22831c$export$aa28710f9c948d46)(connection, splToken);
    if (!mint.isInitialized) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('mint not initialized');
    // Check that the amount provided doesn't have greater precision than the mint
    if (amount.decimalPlaces() > mint.decimals) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('amount decimals invalid');
    // Convert input decimal amount to integer tokens according to the mint decimals
    amount = amount.times((0, $f49a3504c5beffd8$export$119bd8bf66781cd5).pow(mint.decimals)).integerValue((0, $dws6U.default).ROUND_FLOOR);
    // Get the sender's ATA and check that the account exists and can send tokens
    const senderATA = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(splToken, sender);
    const senderAccount = await (0, $8e8ff53861892a60$export$4f9234baf34abd0)(connection, senderATA);
    if (!senderAccount.isInitialized) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender not initialized');
    if (senderAccount.isFrozen) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('sender frozen');
    // Get the recipient's ATA and check that the account exists and can receive tokens
    const recipientATA = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(splToken, recipient);
    const recipientAccount = await (0, $8e8ff53861892a60$export$4f9234baf34abd0)(connection, recipientATA);
    if (!recipientAccount.isInitialized) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient not initialized');
    if (recipientAccount.isFrozen) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('recipient frozen');
    // Check that the sender has enough tokens
    const tokens = BigInt(String(amount));
    if (tokens > senderAccount.amount) throw new $8f1af5f862f41861$export$c02c1aba4b5e1904('insufficient funds');
    // Create an instruction to transfer SPL tokens, asserting the mint and decimals match
    return (0, $f83c4af7f7b56323$export$8532a7098883409f)(senderATA, splToken, recipientATA, sender, tokens, mint.decimals);
}



function $affe003e4d11b80a$export$1b3b10c8ada4b5e7(fields) {
    return 'link' in fields ? $affe003e4d11b80a$var$encodeTransactionRequestURL(fields) : $affe003e4d11b80a$var$encodeTransferRequestURL(fields);
}
function $affe003e4d11b80a$var$encodeTransactionRequestURL({ link: link, label: label, message: message }) {
    // Remove trailing slashes
    const pathname = link.search ? encodeURIComponent(String(link).replace(/\/\?/, '?')) : String(link).replace(/\/$/, '');
    const url = new URL((0, $f49a3504c5beffd8$export$2546bf70c51987d9) + pathname);
    if (label) url.searchParams.append('label', label);
    if (message) url.searchParams.append('message', message);
    return url;
}
function $affe003e4d11b80a$var$encodeTransferRequestURL({ recipient: recipient, amount: amount, splToken: splToken, reference: reference, label: label, message: message, memo: memo }) {
    const pathname = recipient.toBase58();
    const url = new URL((0, $f49a3504c5beffd8$export$2546bf70c51987d9) + pathname);
    if (amount) url.searchParams.append('amount', amount.toFixed(amount.decimalPlaces()));
    if (splToken) url.searchParams.append('spl-token', splToken.toBase58());
    if (reference) {
        if (!Array.isArray(reference)) reference = [
            reference
        ];
        for (const pubkey of reference)url.searchParams.append('reference', pubkey.toBase58());
    }
    if (label) url.searchParams.append('label', label);
    if (message) url.searchParams.append('message', message);
    if (memo) url.searchParams.append('memo', memo);
    return url;
}



var $gNDby = parcelRequire("gNDby");

var $R5nvG = parcelRequire("R5nvG");
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ const $7ca0d9e2d8e201da$export$83d89fbfd8236492 = '3.9.4';
/**
 * @deprecated use lowercase `version`.
 */ const $7ca0d9e2d8e201da$export$a4ad2735b021c132 = $7ca0d9e2d8e201da$export$83d89fbfd8236492;
const $7ca0d9e2d8e201da$var$_TD = typeof TextDecoder === 'function' ? new TextDecoder('utf-8', {
    ignoreBOM: true
}) : undefined;
const $7ca0d9e2d8e201da$var$_TE = typeof TextEncoder === 'function' ? new TextEncoder() : undefined;
const $7ca0d9e2d8e201da$var$b64ch = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const $7ca0d9e2d8e201da$var$b64chs = Array.prototype.slice.call($7ca0d9e2d8e201da$var$b64ch);
const $7ca0d9e2d8e201da$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7ca0d9e2d8e201da$var$b64chs);
const $7ca0d9e2d8e201da$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7ca0d9e2d8e201da$var$_fromCC = String.fromCharCode.bind(String);
const $7ca0d9e2d8e201da$var$_U8Afrom = typeof Uint8Array.from === 'function' ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $7ca0d9e2d8e201da$var$_mkUriSafe = (src)=>src.replace(/=/g, '').replace(/[+\/]/g, (m0)=>m0 == '+' ? '-' : '_');
const $7ca0d9e2d8e201da$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, '');
/**
 * polyfill version of `btoa`
 */ const $7ca0d9e2d8e201da$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = '';
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError('invalid character found');
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7ca0d9e2d8e201da$var$b64chs[u32 >> 18 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 12 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 6 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7ca0d9e2d8e201da$export$a32219e24f8d1e2 = typeof btoa === 'function' ? (bin)=>btoa(bin) : $7ca0d9e2d8e201da$export$ec0fb543302ee251;
const $7ca0d9e2d8e201da$var$_fromUint8Array = typeof Uint8Array.prototype.toBase64 === 'function' ? (u8a)=>u8a.toBase64() : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7ca0d9e2d8e201da$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7ca0d9e2d8e201da$export$a32219e24f8d1e2(strs.join(''));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_fromUint8Array(u8a)) : $7ca0d9e2d8e201da$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7ca0d9e2d8e201da$var$_fromCC(0xc0 | cc >>> 6) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f) : $7ca0d9e2d8e201da$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7ca0d9e2d8e201da$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7ca0d9e2d8e201da$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7ca0d9e2d8e201da$export$10d4b9bd20a66b0 = (u)=>u.replace($7ca0d9e2d8e201da$var$re_utob, $7ca0d9e2d8e201da$var$cb_utob);
//
const $7ca0d9e2d8e201da$var$_encode = $7ca0d9e2d8e201da$var$_TE ? (s)=>$7ca0d9e2d8e201da$var$_fromUint8Array($7ca0d9e2d8e201da$var$_TE.encode(s)) : (s)=>$7ca0d9e2d8e201da$export$a32219e24f8d1e2($7ca0d9e2d8e201da$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$c564cdbbe6da493 = (src, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_encode(src)) : $7ca0d9e2d8e201da$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$90c31d5baa78df44 = (src)=>$7ca0d9e2d8e201da$export$c564cdbbe6da493(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7ca0d9e2d8e201da$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7ca0d9e2d8e201da$var$_fromCC((offset >>> 10) + 0xD800) + $7ca0d9e2d8e201da$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7ca0d9e2d8e201da$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7ca0d9e2d8e201da$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$67e9defdeac3dd95 = (b)=>b.replace($7ca0d9e2d8e201da$var$re_btou, $7ca0d9e2d8e201da$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7ca0d9e2d8e201da$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, '');
    if (!$7ca0d9e2d8e201da$var$b64re.test(asc)) throw new TypeError('malformed base64.');
    asc += '=='.slice(2 - (asc.length & 3));
    let u24, r1, r2;
    let binArray = []; // use array to avoid minor gc in loop
    for(let i = 0; i < asc.length;){
        u24 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 18 | $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]);
        if (r1 === 64) binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255));
        else if (r2 === 64) binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255));
        else binArray.push($7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255));
    }
    return binArray.join('');
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a = typeof atob === 'function' ? (asc)=>atob($7ca0d9e2d8e201da$var$_tidyB64(asc)) : $7ca0d9e2d8e201da$export$7f16d8e674ddec24;
//
const $7ca0d9e2d8e201da$var$_toUint8Array = typeof Uint8Array.fromBase64 === 'function' ? (a)=>Uint8Array.fromBase64(a) : (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a).split('').map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7ca0d9e2d8e201da$export$73470fd2221e6aef = (a)=>$7ca0d9e2d8e201da$var$_toUint8Array($7ca0d9e2d8e201da$var$_unURI(a));
//
const $7ca0d9e2d8e201da$var$_decode = $7ca0d9e2d8e201da$var$_TD ? (a)=>$7ca0d9e2d8e201da$var$_TD.decode($7ca0d9e2d8e201da$var$_toUint8Array(a)) : (a)=>$7ca0d9e2d8e201da$export$67e9defdeac3dd95($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a));
const $7ca0d9e2d8e201da$var$_unURI = (a)=>$7ca0d9e2d8e201da$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == '-' ? '+' : '/'));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$2f872c0f2117be69 = (src)=>$7ca0d9e2d8e201da$var$_decode($7ca0d9e2d8e201da$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7ca0d9e2d8e201da$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== 'string') return false;
    const s = src.replace(/\s+/g, '').replace(/={0,2}$/, '');
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7ca0d9e2d8e201da$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add('fromBase64', function() {
        return $7ca0d9e2d8e201da$export$2f872c0f2117be69(this);
    });
    _add('toBase64', function(urlsafe) {
        return $7ca0d9e2d8e201da$export$c564cdbbe6da493(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $7ca0d9e2d8e201da$export$c564cdbbe6da493(this, true);
    });
    _add('toBase64URL', function() {
        return $7ca0d9e2d8e201da$export$c564cdbbe6da493(this, true);
    });
    _add('toUint8Array', function() {
        return $7ca0d9e2d8e201da$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add('toBase64', function(urlsafe) {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, urlsafe);
    });
    _add('toBase64URI', function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
    _add('toBase64URL', function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245 = ()=>{
    $7ca0d9e2d8e201da$export$4678ebf2295c49b();
    $7ca0d9e2d8e201da$export$a105d6a15258bd2();
};
const $7ca0d9e2d8e201da$export$f436b0c2107cbd35 = {
    version: $7ca0d9e2d8e201da$export$83d89fbfd8236492,
    VERSION: $7ca0d9e2d8e201da$export$a4ad2735b021c132,
    atob: $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7ca0d9e2d8e201da$export$7f16d8e674ddec24,
    btoa: $7ca0d9e2d8e201da$export$a32219e24f8d1e2,
    btoaPolyfill: $7ca0d9e2d8e201da$export$ec0fb543302ee251,
    fromBase64: $7ca0d9e2d8e201da$export$2f872c0f2117be69,
    toBase64: $7ca0d9e2d8e201da$export$c564cdbbe6da493,
    encode: $7ca0d9e2d8e201da$export$c564cdbbe6da493,
    encodeURI: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    encodeURL: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    utob: $7ca0d9e2d8e201da$export$10d4b9bd20a66b0,
    btou: $7ca0d9e2d8e201da$export$67e9defdeac3dd95,
    decode: $7ca0d9e2d8e201da$export$2f872c0f2117be69,
    isValid: $7ca0d9e2d8e201da$export$1ea939691cdc45b8,
    fromUint8Array: $7ca0d9e2d8e201da$export$27bbb4e040978768,
    toUint8Array: $7ca0d9e2d8e201da$export$73470fd2221e6aef,
    extendString: $7ca0d9e2d8e201da$export$4678ebf2295c49b,
    extendUint8Array: $7ca0d9e2d8e201da$export$a105d6a15258bd2,
    extendBuiltins: $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245
};


var $12f84db871cc444b$exports = {};

(function(nacl) {
    'use strict';
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error('no PRNG');
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError('unexpected type, use Uint8Array');
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
        if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error('bad secret key size');
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error('bad public key size');
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error('bad signature size');
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error('bad public key size');
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error('bad secret key size');
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error('bad seed size');
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("kjyEk"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})($12f84db871cc444b$exports ? $12f84db871cc444b$exports : self.nacl = self.nacl || {});


class $1a37b54c47d0530a$export$1aebfbe0e993b56c extends Error {
    constructor(){
        super(...arguments);
        this.name = 'FetchTransactionError';
    }
}
async function $1a37b54c47d0530a$export$a163d2e4b7be6d57(connection, account, link, { commitment: commitment } = {}) {
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(String(link), {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            account: account
        })
    });
    const json = await response.json();
    if (!(json === null || json === void 0 ? void 0 : json.transaction)) throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('missing transaction');
    if (typeof json.transaction !== 'string') throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('invalid transaction');
    const transaction = (0, $gNDby.Transaction).from((0, $7ca0d9e2d8e201da$export$73470fd2221e6aef)(json.transaction));
    const { signatures: signatures, feePayer: feePayer, recentBlockhash: recentBlockhash } = transaction;
    if (signatures.length) {
        if (!feePayer) throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('missing fee payer');
        if (!feePayer.equals(signatures[0].publicKey)) throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('invalid fee payer');
        if (!recentBlockhash) throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('missing recent blockhash');
        // A valid signature for everything except `account` must be provided.
        const message = transaction.serializeMessage();
        for (const { signature: signature, publicKey: publicKey } of signatures){
            if (signature) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($12f84db871cc444b$exports))).sign.detached.verify(message, signature, publicKey.toBuffer())) throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('invalid signature');
            } else if (publicKey.equals(account)) // If the only signature expected is for `account`, ignore the recent blockhash in the transaction.
            {
                if (signatures.length === 1) transaction.recentBlockhash = (await connection.getRecentBlockhash(commitment)).blockhash;
            } else throw new $1a37b54c47d0530a$export$1aebfbe0e993b56c('missing signature');
        }
    } else {
        // Ignore the fee payer and recent blockhash in the transaction and initialize them.
        transaction.feePayer = account;
        transaction.recentBlockhash = (await connection.getRecentBlockhash(commitment)).blockhash;
    }
    return transaction;
}


/**
 * Thrown when no transaction signature can be found referencing a given public key.
 */ class $551a75e0b78a9257$export$aee33619f6db7629 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'FindReferenceError';
    }
}
async function $551a75e0b78a9257$export$d6236817627ac6ff(connection, reference, { finality: finality, ...options } = {}) {
    const signatures = await connection.getSignaturesForAddress(reference, options, finality);
    const length = signatures.length;
    if (!length) throw new $551a75e0b78a9257$export$aee33619f6db7629('not found');
    // If one or more transaction signatures are found under the limit, return the oldest one.
    const oldest = signatures[length - 1];
    if (length < ((options === null || options === void 0 ? void 0 : options.limit) || 1000)) return oldest;
    try {
        // In the unlikely event that signatures up to the limit are found, recursively find the oldest one.
        return await $551a75e0b78a9257$export$d6236817627ac6ff(connection, reference, {
            finality: finality,
            ...options,
            before: oldest.signature
        });
    } catch (error) {
        // If the signatures found were exactly at the limit, there won't be more to find, so return the oldest one.
        if (error instanceof $551a75e0b78a9257$export$aee33619f6db7629) return oldest;
        throw error;
    }
}



var $gNDby = parcelRequire("gNDby");

var $dws6U = parcelRequire("dws6U");

class $f1d60412d4adebb9$export$7ddb3d48f61471ef extends Error {
    constructor(){
        super(...arguments);
        this.name = 'ParseURLError';
    }
}
function $f1d60412d4adebb9$export$4b3d9a5bae55976(url) {
    if (typeof url === 'string') {
        if (url.length > 2048) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('length invalid');
        url = new URL(url);
    }
    if (url.protocol !== (0, $f49a3504c5beffd8$export$2546bf70c51987d9)) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('protocol invalid');
    if (!url.pathname) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('pathname missing');
    return /[:%]/.test(url.pathname) ? $f1d60412d4adebb9$var$parseTransactionRequestURL(url) : $f1d60412d4adebb9$var$parseTransferRequestURL(url);
}
function $f1d60412d4adebb9$var$parseTransactionRequestURL({ pathname: pathname, searchParams: searchParams }) {
    const link = new URL(decodeURIComponent(pathname));
    if (link.protocol !== (0, $f49a3504c5beffd8$export$68da760adb1ea70f)) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('link invalid');
    const label = searchParams.get('label') || undefined;
    const message = searchParams.get('message') || undefined;
    return {
        link: link,
        label: label,
        message: message
    };
}
function $f1d60412d4adebb9$var$parseTransferRequestURL({ pathname: pathname, searchParams: searchParams }) {
    let recipient;
    try {
        recipient = new (0, $gNDby.PublicKey)(pathname);
    } catch (error) {
        throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('recipient invalid');
    }
    let amount;
    const amountParam = searchParams.get('amount');
    if (amountParam != null) {
        if (!/^\d+(\.\d+)?$/.test(amountParam)) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('amount invalid');
        amount = new (0, $dws6U.default)(amountParam);
        if (amount.isNaN()) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('amount NaN');
        if (amount.isNegative()) throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('amount negative');
    }
    let splToken;
    const splTokenParam = searchParams.get('spl-token');
    if (splTokenParam != null) try {
        splToken = new (0, $gNDby.PublicKey)(splTokenParam);
    } catch (error) {
        throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('spl-token invalid');
    }
    let reference;
    const referenceParams = searchParams.getAll('reference');
    if (referenceParams.length) try {
        reference = referenceParams.map((reference)=>new (0, $gNDby.PublicKey)(reference));
    } catch (error) {
        throw new $f1d60412d4adebb9$export$7ddb3d48f61471ef('reference invalid');
    }
    const label = searchParams.get('label') || undefined;
    const message = searchParams.get('message') || undefined;
    const memo = searchParams.get('memo') || undefined;
    return {
        recipient: recipient,
        amount: amount,
        splToken: splToken,
        reference: reference,
        label: label,
        message: message,
        memo: memo
    };
}






var $gNDby = parcelRequire("gNDby");

var $dws6U = parcelRequire("dws6U");


var $6ZWSX = parcelRequire("6ZWSX");
var $6deb862192182b13$require$Buffer = $6ZWSX.Buffer;
class $6deb862192182b13$export$6f9800600a484b30 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'ValidateTransferError';
    }
}
async function $6deb862192182b13$export$c93b909123043a2c(connection, signature, { recipient: recipient, amount: amount, splToken: splToken, reference: reference, memo: memo }, options) {
    const response = await connection.getTransaction(signature, options);
    if (!response) throw new $6deb862192182b13$export$6f9800600a484b30('not found');
    const message = response.transaction.message;
    const meta = response.meta;
    if (!meta) throw new $6deb862192182b13$export$6f9800600a484b30('missing meta');
    if (meta.err) throw meta.err;
    if (reference && !Array.isArray(reference)) reference = [
        reference
    ];
    const [preAmount, postAmount] = splToken ? await $6deb862192182b13$var$validateSPLTokenTransfer(message, meta, recipient, splToken, reference) : await $6deb862192182b13$var$validateSystemTransfer(message, meta, recipient, reference);
    if (postAmount.minus(preAmount).lt(amount)) throw new $6deb862192182b13$export$6f9800600a484b30('amount not transferred');
    if (memo) {
        // Check that the second instruction is a memo instruction with the expected memo.
        const transaction = (0, $gNDby.Transaction).populate(message);
        const instruction = transaction.instructions[1];
        if (!instruction) throw new $6deb862192182b13$export$6f9800600a484b30('missing memo instruction');
        if (!instruction.programId.equals((0, $f49a3504c5beffd8$export$8187fb71f6d8e245))) throw new $6deb862192182b13$export$6f9800600a484b30('invalid memo program');
        if (!instruction.data.equals($6deb862192182b13$require$Buffer.from(memo, 'utf8'))) throw new $6deb862192182b13$export$6f9800600a484b30('invalid memo');
    }
    return response;
}
async function $6deb862192182b13$var$validateSystemTransfer(message, meta, recipient, references) {
    if (references) {
        // Check that the first instruction is a system transfer instruction.
        const transaction = (0, $gNDby.Transaction).populate(message);
        const instruction = transaction.instructions[0];
        (0, $gNDby.SystemInstruction).decodeTransfer(instruction);
        // Check that the expected reference keys exactly match the extra keys provided to the instruction.
        const [_from, _to, ...extraKeys] = instruction.keys;
        const length = extraKeys.length;
        if (length !== references.length) throw new $6deb862192182b13$export$6f9800600a484b30('invalid references');
        for(let i = 0; i < length; i++){
            if (!extraKeys[i].pubkey.equals(references[i])) throw new $6deb862192182b13$export$6f9800600a484b30(`invalid reference ${i}`);
        }
    }
    const accountIndex = message.accountKeys.findIndex((pubkey)=>pubkey.equals(recipient));
    if (accountIndex === -1) throw new $6deb862192182b13$export$6f9800600a484b30('recipient not found');
    return [
        new (0, $dws6U.default)(meta.preBalances[accountIndex] || 0).div((0, $gNDby.LAMPORTS_PER_SOL)),
        new (0, $dws6U.default)(meta.postBalances[accountIndex] || 0).div((0, $gNDby.LAMPORTS_PER_SOL))
    ];
}
async function $6deb862192182b13$var$validateSPLTokenTransfer(message, meta, recipient, splToken, references) {
    var _a, _b;
    if (references) {
        // Check that the first instruction is an SPL token transfer instruction.
        const transaction = (0, $gNDby.Transaction).populate(message);
        const instruction = (0, $6b8806b69d9d4c77$export$10b35c04f330bef9)(transaction.instructions[0]);
        if (!(0, $6b8806b69d9d4c77$export$835c5cebf3708c89)(instruction) && !(0, $6b8806b69d9d4c77$export$f7500a03ea602a2d)(instruction)) throw new $6deb862192182b13$export$6f9800600a484b30('invalid transfer');
        // Check that the expected reference keys exactly match the extra keys provided to the instruction.
        const extraKeys = instruction.keys.multiSigners;
        const length = extraKeys.length;
        if (length !== references.length) throw new $6deb862192182b13$export$6f9800600a484b30('invalid references');
        for(let i = 0; i < length; i++){
            if (!extraKeys[i].pubkey.equals(references[i])) throw new $6deb862192182b13$export$6f9800600a484b30(`invalid reference ${i}`);
        }
    }
    const recipientATA = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(splToken, recipient);
    const accountIndex = message.accountKeys.findIndex((pubkey)=>pubkey.equals(recipientATA));
    if (accountIndex === -1) throw new $6deb862192182b13$export$6f9800600a484b30('recipient not found');
    const preBalance = (_a = meta.preTokenBalances) === null || _a === void 0 ? void 0 : _a.find((x)=>x.accountIndex === accountIndex);
    const postBalance = (_b = meta.postTokenBalances) === null || _b === void 0 ? void 0 : _b.find((x)=>x.accountIndex === accountIndex);
    return [
        new (0, $dws6U.default)((preBalance === null || preBalance === void 0 ? void 0 : preBalance.uiTokenAmount.uiAmountString) || 0),
        new (0, $dws6U.default)((postBalance === null || postBalance === void 0 ? void 0 : postBalance.uiTokenAmount.uiAmountString) || 0)
    ];
}






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $f4af075fe47980ed$export$2c657da244d00bd6 = (0, $acw62.createContext)({});
function $f4af075fe47980ed$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($f4af075fe47980ed$export$2c657da244d00bd6);
}


var $a896f08b209e1107$export$e8e78c978b129247;
$a896f08b209e1107$export$e8e78c978b129247 = `WZEg6q_root`;


const $7cdb5f87eb6a7099$export$a77d98f00e648d58 = ()=>{
    const [size, setSize] = (0, $acw62.useState)(()=>typeof window === 'undefined' ? 400 : Math.min(window.screen.availWidth, 400));
    (0, $acw62.useLayoutEffect)(()=>{
        const listener = ()=>setSize(Math.min(window.screen.availWidth, 400));
        window.addEventListener('resize', listener);
        return ()=>window.removeEventListener('resize', listener);
    }, []);
    const { theme: theme } = (0, $f4af075fe47980ed$export$93d4e7f90805808f)();
    const [background, color] = (0, $acw62.useMemo)(()=>theme === 'light' ? [
            '#eff2f3',
            '#2a2a2a'
        ] : [
            '#eef5f6',
            '#2a2a2a'
        ], [
        theme
    ]);
    const { url: url } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    const options = (0, $acw62.useMemo)(()=>(0, $d4bb63e69eb90953$export$348d27b6b9c6b2cf)(url, size, background, color), [
        url,
        size,
        background,
        color
    ]);
    const qr = (0, $acw62.useMemo)(()=>new (0, (/*@__PURE__*/$parcel$interopDefault($35c4bfa083870778$exports)))(), []);
    (0, $acw62.useLayoutEffect)(()=>qr.update(options), [
        qr,
        options
    ]);
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (ref.current) qr.append(ref.current);
    }, [
        ref,
        qr
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: $a896f08b209e1107$export$e8e78c978b129247
    });
};


var $3480b33867e87875$export$802cfe72001a1ee;
var $3480b33867e87875$export$6565f9f03506010b;
var $3480b33867e87875$export$715f9d76bb8c1fea;
var $3480b33867e87875$export$adb608be33961c98;
var $3480b33867e87875$export$38e42c68cf43b5d4;
var $3480b33867e87875$export$f22da7240b7add18;
var $3480b33867e87875$export$e8e78c978b129247;
var $3480b33867e87875$export$c87d910e63d22ed6;
var $3480b33867e87875$export$8f701197936bc2a6;
var $3480b33867e87875$export$9086bb9c16b2b5b;
$3480b33867e87875$export$802cfe72001a1ee = `DOpjnW_amount`;
$3480b33867e87875$export$6565f9f03506010b = `DOpjnW_code`;
$3480b33867e87875$export$715f9d76bb8c1fea = `DOpjnW_confirm`;
$3480b33867e87875$export$adb608be33961c98 = `DOpjnW_footer`;
$3480b33867e87875$export$38e42c68cf43b5d4 = `DOpjnW_header`;
$3480b33867e87875$export$f22da7240b7add18 = `DOpjnW_main`;
$3480b33867e87875$export$e8e78c978b129247 = `DOpjnW_root`;
$3480b33867e87875$export$c87d910e63d22ed6 = `DOpjnW_scan`;
$3480b33867e87875$export$8f701197936bc2a6 = `DOpjnW_symbol`;
$3480b33867e87875$export$9086bb9c16b2b5b = `DOpjnW_total`;


const $bed87405b8c4def6$export$37cb6e010e1a0f69 = ()=>{
    const { symbol: symbol, connectWallet: connectWallet } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const { amount: amount, reset: reset } = (0, $9c00ffc6a7ba2f4f$export$68637662b7cd615c)();
    const { publicKey: publicKey } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $ca40ecc6394b8d2e$export$6fdf0454adae214b)();
    (0, $acw62.useEffect)(()=>{
        if (connectWallet && !publicKey) setVisible(true);
    }, [
        connectWallet,
        publicKey,
        setVisible
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $3480b33867e87875$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $3480b33867e87875$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69ffbf78f8ecebca$export$e0d897ee21382f67), {
                        onClick: reset,
                        children: "Cancel"
                    }),
                    connectWallet ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b30bad04ca015373$export$968d144f04194cbb), {}) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $3480b33867e87875$export$f22da7240b7add18,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3480b33867e87875$export$802cfe72001a1ee,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cb71ddbb0c9a1f3$export$5a2795e4838b67d2), {
                            amount: amount
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3480b33867e87875$export$8f701197936bc2a6,
                        children: symbol
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3480b33867e87875$export$6565f9f03506010b,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7cdb5f87eb6a7099$export$a77d98f00e648d58), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3480b33867e87875$export$c87d910e63d22ed6,
                        children: "Scan this code with your Solana Pay wallet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3480b33867e87875$export$715f9d76bb8c1fea,
                        children: "You'll be asked to approve the transaction"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $3480b33867e87875$export$adb608be33961c98,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24), {})
            })
        ]
    });
};




var $1jgjz = parcelRequire("1jgjz");
class $92c515b2e16b5c4e$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $92c515b2e16b5c4e$export$d65db264eda99cd7 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletNotReadyError';
    }
}
class $92c515b2e16b5c4e$export$9a551f94af9b0bf8 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletLoadError';
    }
}
class $92c515b2e16b5c4e$export$9525019988612a5e extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletConfigError';
    }
}
class $92c515b2e16b5c4e$export$38f21f1c810261c7 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletConnectionError';
    }
}
class $92c515b2e16b5c4e$export$bf7028c52ebda81e extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletDisconnectedError';
    }
}
class $92c515b2e16b5c4e$export$92e2b26fad5723ee extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletDisconnectionError';
    }
}
class $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletAccountError';
    }
}
class $92c515b2e16b5c4e$export$735bef3bfb0f2c86 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletPublicKeyError';
    }
}
class $92c515b2e16b5c4e$export$c2957028686b1575 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletKeypairError';
    }
}
class $92c515b2e16b5c4e$export$313d299817c74896 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletNotConnectedError';
    }
}
class $92c515b2e16b5c4e$export$769332ac3f90f46c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletSendTransactionError';
    }
}
class $92c515b2e16b5c4e$export$96f177062fdd8180 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletSignTransactionError';
    }
}
class $92c515b2e16b5c4e$export$2622c1721bbd4b17 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletSignMessageError';
    }
}
class $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletSignInError';
    }
}
class $92c515b2e16b5c4e$export$ec3efbdc71ef5c8c extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletTimeoutError';
    }
}
class $92c515b2e16b5c4e$export$c87b9320dc154c95 extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletWindowBlockedError';
    }
}
class $92c515b2e16b5c4e$export$d02b2d00a97edcea extends $92c515b2e16b5c4e$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = 'WalletWindowClosedError';
    }
}


var $a27aaf340df890aa$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($a27aaf340df890aa$export$2a7b8071105d05b6 || ($a27aaf340df890aa$export$2a7b8071105d05b6 = {}));
class $a27aaf340df890aa$export$2af1ea2892adc469 extends (0, $1jgjz.default) {
    get connected() {
        return !!this.publicKey;
    }
    async autoConnect() {
        await this.connect();
    }
    async prepareTransaction(transaction, connection, options = {}) {
        const publicKey = this.publicKey;
        if (!publicKey) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        transaction.feePayer = transaction.feePayer || publicKey;
        transaction.recentBlockhash = transaction.recentBlockhash || (await connection.getLatestBlockhash({
            commitment: options.preflightCommitment,
            minContextSlot: options.minContextSlot
        })).blockhash;
        return transaction;
    }
}
function $a27aaf340df890aa$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) for (const dispose of disposers)dispose();
    }
    // Strategy #1: Try detecting every second.
    const interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(()=>clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', detectAndDispose, {
            once: true
        });
        disposers.push(()=>document.removeEventListener('DOMContentLoaded', detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== 'complete') {
        window.addEventListener('load', detectAndDispose, {
            once: true
        });
        disposers.push(()=>window.removeEventListener('load', detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $a27aaf340df890aa$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    const userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    const isIos = userAgent.includes('iphone') || userAgent.includes('ipad');
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    const isSafari = userAgent.includes('safari');
    return isIos && isSafari;
}



function $afa5c06c212ba160$export$37ce1cc82e255d8(transaction) {
    return 'version' in transaction;
}


class $71b3859dfb523e38$export$9a51bf5d1bea9e98 extends (0, $a27aaf340df890aa$export$2af1ea2892adc469) {
    async sendTransaction(transaction, connection, options = {}) {
        let emit = true;
        try {
            if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
                if (!this.supportedTransactionVersions) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(`Sending versioned transactions isn't supported by this wallet`);
                if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(`Sending transaction version ${transaction.version} isn't supported by this wallet`);
                try {
                    transaction = await this.signTransaction(transaction);
                    const rawTransaction = transaction.serialize();
                    return await connection.sendRawTransaction(rawTransaction, options);
                } catch (error) {
                    // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                    if (error instanceof (0, $92c515b2e16b5c4e$export$96f177062fdd8180)) {
                        emit = false;
                        throw error;
                    }
                    throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
                }
            } else try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                transaction = await this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return await connection.sendRawTransaction(rawTransaction, sendOptions);
            } catch (error) {
                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                if (error instanceof (0, $92c515b2e16b5c4e$export$96f177062fdd8180)) {
                    emit = false;
                    throw error;
                }
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            if (emit) this.emit('error', error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        for (const transaction of transactions)if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
            if (!this.supportedTransactionVersions) throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(`Signing versioned transactions isn't supported by this wallet`);
            if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(`Signing transaction version ${transaction.version} isn't supported by this wallet`);
        }
        const signedTransactions = [];
        for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
        return signedTransactions;
    }
}
class $71b3859dfb523e38$export$9db08bcddd106c96 extends $71b3859dfb523e38$export$9a51bf5d1bea9e98 {
}
class $71b3859dfb523e38$export$9779f871ffdb3d87 extends $71b3859dfb523e38$export$9db08bcddd106c96 {
}



var $gNDby = parcelRequire("gNDby");
const $27b337e06adc69ec$export$37766f30d842581a = 'Phantom';
class $27b337e06adc69ec$export$a8fff984faa686f6 extends (0, $71b3859dfb523e38$export$9db08bcddd106c96) {
    constructor(config = {}){
        super();
        this.name = $27b337e06adc69ec$export$37766f30d842581a;
        this.url = 'https://phantom.app';
        this.icon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiB2aWV3Qm94PSIwIDAgMTA4IDEwOCIgZmlsbD0ibm9uZSI+CjxyZWN0IHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiByeD0iMjYiIGZpbGw9IiNBQjlGRjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni41MjY3IDY5LjkyMjlDNDIuMDA1NCA3Ni44NTA5IDM0LjQyOTIgODUuNjE4MiAyNC4zNDggODUuNjE4MkMxOS41ODI0IDg1LjYxODIgMTUgODMuNjU2MyAxNSA3NS4xMzQyQzE1IDUzLjQzMDUgNDQuNjMyNiAxOS44MzI3IDcyLjEyNjggMTkuODMyN0M4Ny43NjggMTkuODMyNyA5NCAzMC42ODQ2IDk0IDQzLjAwNzlDOTQgNTguODI1OCA4My43MzU1IDc2LjkxMjIgNzMuNTMyMSA3Ni45MTIyQzcwLjI5MzkgNzYuOTEyMiA2OC43MDUzIDc1LjEzNDIgNjguNzA1MyA3Mi4zMTRDNjguNzA1MyA3MS41NzgzIDY4LjgyNzUgNzAuNzgxMiA2OS4wNzE5IDY5LjkyMjlDNjUuNTg5MyA3NS44Njk5IDU4Ljg2ODUgODEuMzg3OCA1Mi41NzU0IDgxLjM4NzhDNDcuOTkzIDgxLjM4NzggNDUuNjcxMyA3OC41MDYzIDQ1LjY3MTMgNzQuNDU5OEM0NS42NzEzIDcyLjk4ODQgNDUuOTc2OCA3MS40NTU2IDQ2LjUyNjcgNjkuOTIyOVpNODMuNjc2MSA0Mi41Nzk0QzgzLjY3NjEgNDYuMTcwNCA4MS41NTc1IDQ3Ljk2NTggNzkuMTg3NSA0Ny45NjU4Qzc2Ljc4MTYgNDcuOTY1OCA3NC42OTg5IDQ2LjE3MDQgNzQuNjk4OSA0Mi41Nzk0Qzc0LjY5ODkgMzguOTg4NSA3Ni43ODE2IDM3LjE5MzEgNzkuMTg3NSAzNy4xOTMxQzgxLjU1NzUgMzcuMTkzMSA4My42NzYxIDM4Ljk4ODUgODMuNjc2MSA0Mi41Nzk0Wk03MC4yMTAzIDQyLjU3OTVDNzAuMjEwMyA0Ni4xNzA0IDY4LjA5MTYgNDcuOTY1OCA2NS43MjE2IDQ3Ljk2NThDNjMuMzE1NyA0Ny45NjU4IDYxLjIzMyA0Ni4xNzA0IDYxLjIzMyA0Mi41Nzk1QzYxLjIzMyAzOC45ODg1IDYzLjMxNTcgMzcuMTkzMSA2NS43MjE2IDM3LjE5MzFDNjguMDkxNiAzNy4xOTMxIDcwLjIxMDMgMzguOTg4NSA3MC4yMTAzIDQyLjU3OTVaIiBmaWxsPSIjRkZGREY4Ii8+Cjwvc3ZnPg==';
        this.supportedTransactionVersions = new Set([
            'legacy',
            0
        ]);
        this._readyState = typeof window === 'undefined' || typeof document === 'undefined' ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).NotDetected;
        this._disconnected = ()=>{
            const wallet = this._wallet;
            if (wallet) {
                wallet.off('disconnect', this._disconnected);
                wallet.off('accountChanged', this._accountChanged);
                this._wallet = null;
                this._publicKey = null;
                this.emit('error', new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)());
                this.emit('disconnect');
            }
        };
        this._accountChanged = (newPublicKey)=>{
            const publicKey = this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $gNDby.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                this.emit('error', new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            this._publicKey = newPublicKey;
            this.emit('connect', newPublicKey);
        };
        this._connecting = false;
        this._wallet = null;
        this._publicKey = null;
        if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported) {
            if ((0, $a27aaf340df890aa$export$bf89b558d1e273a2)()) {
                // when in iOS (not webview), set Phantom as loadable instead of checking for install
                this._readyState = (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable;
                this.emit('readyStateChange', this._readyState);
            } else (0, $a27aaf340df890aa$export$378bae4c88e0b46e)(()=>{
                if (window?.isPhantomInstalled && (window.phantom?.solana?.isPhantom || window.solana?.isPhantom)) {
                    this._readyState = (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed;
                    this.emit('readyStateChange', this._readyState);
                    return true;
                }
                return false;
            });
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    async autoConnect() {
        // Skip autoconnect in the Loadable state
        // We can't redirect to a universal link without user input
        if (this.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) await this.connect();
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) {
                // redirect to the Phantom /browse universal link
                // this will open the current URL in the Phantom in-wallet browser
                const url = encodeURIComponent(window.location.href);
                const ref = encodeURIComponent(window.location.origin);
                window.location.href = `https://phantom.app/ul/browse/${url}?ref=${ref}`;
                return;
            }
            if (this.readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            this._connecting = true;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const wallet = window.phantom?.solana || window.solana;
            if (!wallet.isConnected) try {
                await wallet.connect();
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
            }
            if (!wallet.publicKey) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
            let publicKey;
            try {
                publicKey = new (0, $gNDby.PublicKey)(wallet.publicKey.toBytes());
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
            }
            wallet.on('disconnect', this._disconnected);
            wallet.on('accountChanged', this._accountChanged);
            this._wallet = wallet;
            this._publicKey = publicKey;
            this.emit('connect', publicKey);
        } catch (error) {
            this.emit('error', error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const wallet = this._wallet;
        if (wallet) {
            wallet.off('disconnect', this._disconnected);
            wallet.off('accountChanged', this._accountChanged);
            this._wallet = null;
            this._publicKey = null;
            try {
                await wallet.disconnect();
            } catch (error) {
                this.emit('error', new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit('disconnect');
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                const { signers: signers, ...sendOptions } = options;
                if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) signers?.length && transaction.sign(signers);
                else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                }
                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                const { signature: signature } = await wallet.signAndSendTransaction(transaction, sendOptions);
                return signature;
            } catch (error) {
                if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signTransaction(transaction) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signTransaction(transaction) || transaction;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signAllTransactions(transactions) || transactions;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signMessage(message) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                const { signature: signature } = await wallet.signMessage(message);
                return signature;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
}



var $gNDby = parcelRequire("gNDby");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $86c338e4d5b0d511$export$af54d3055d90c64e = (0, $acw62.createContext)({});
function $86c338e4d5b0d511$export$985e8768c0e91dbc() {
    return (0, $acw62.useContext)($86c338e4d5b0d511$export$af54d3055d90c64e);
}


const $95b24e620787a529$export$fd685cf7c99624bd = ({ children: children, endpoint: endpoint, config: config = {
    commitment: 'confirmed'
} })=>{
    const connection = (0, $acw62.useMemo)(()=>new (0, $gNDby.Connection)(endpoint, config), [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $86c338e4d5b0d511$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


/** Name of the feature. */ const $da368ee8f406d58d$export$dd64f32469f35f81 = 'solana:signAndSendTransaction';

/** Name of the feature. */ const $29a99a74b28f2560$export$8adeab75f48a3607 = 'solana:signIn';

/** Name of the feature. */ const $5a4be9421d6e6c61$export$22c7939a38084172 = 'solana:signMessage';

/** Name of the feature. */ const $97e08ae06ec466db$export$54187c3796d0ecb = 'solana:signTransaction';



var $gNDby = parcelRequire("gNDby");
// src/codes.ts
var $d289d6e522f3d127$export$637a712014b81b9c = 1;
var $d289d6e522f3d127$export$2b45309b0547a9c4 = 2;
var $d289d6e522f3d127$export$7cf14cde1226b7cb = 3;
var $d289d6e522f3d127$export$6ad19ea5e363a944 = 4;
var $d289d6e522f3d127$export$c37fe345cc9b38e7 = 5;
var $d289d6e522f3d127$export$cf7b28c4ea07497b = 6;
var $d289d6e522f3d127$export$e8ff0c73a3d6800d = 7;
var $d289d6e522f3d127$export$7dd7d17f1f93a166 = 8;
var $d289d6e522f3d127$export$8b23617676679e2d = 9;
var $d289d6e522f3d127$export$1cf7bba40d7d2361 = 10;
var $d289d6e522f3d127$export$7cb3af4590511eb4 = 11;
var $d289d6e522f3d127$export$5dac493019b18473 = 12;
var $d289d6e522f3d127$export$e09e3905081e44fe = -32700;
var $d289d6e522f3d127$export$afa40fd3fc01204 = -32603;
var $d289d6e522f3d127$export$2981978a530b1a7c = -32602;
var $d289d6e522f3d127$export$5ec955cc8b7e8cf9 = -32601;
var $d289d6e522f3d127$export$23cb4efd59427895 = -32600;
var $d289d6e522f3d127$export$690667cf4da3ba9d = -32021;
var $d289d6e522f3d127$export$8dfce16ef39ea58c = -32020;
var $d289d6e522f3d127$export$35d837f314929752 = -32019;
var $d289d6e522f3d127$export$86fc15c41ff3dc9c = -32018;
var $d289d6e522f3d127$export$1e95c50f9776ce34 = -32017;
var $d289d6e522f3d127$export$4f93db3d1b48599e = -32016;
var $d289d6e522f3d127$export$f7685139153f9191 = -32015;
var $d289d6e522f3d127$export$65235469ebe9845e = -32014;
var $d289d6e522f3d127$export$bdeebdca616ef1f3 = -32013;
var $d289d6e522f3d127$export$1b90c411626421b1 = -32012;
var $d289d6e522f3d127$export$8e678bf9b4e5cb64 = -32011;
var $d289d6e522f3d127$export$54dea2286c43ec1e = -32010;
var $d289d6e522f3d127$export$e71fbee92648fc61 = -32009;
var $d289d6e522f3d127$export$eb4f7515ff6aa19d = -32008;
var $d289d6e522f3d127$export$d21075fd06730e = -32007;
var $d289d6e522f3d127$export$d964b43bb02eacdf = -32006;
var $d289d6e522f3d127$export$6bad0f4fb625ae6e = -32005;
var $d289d6e522f3d127$export$bfbf8b75e865efa0 = -32004;
var $d289d6e522f3d127$export$83dce8c0aef70463 = -32003;
var $d289d6e522f3d127$export$426cc73f5ad00f38 = -32002;
var $d289d6e522f3d127$export$6ae475e85fe02aad = -32001;
var $d289d6e522f3d127$export$fe284a92110eab86 = 28e5;
var $d289d6e522f3d127$export$8aae3518bf4ea38c = 2800001;
var $d289d6e522f3d127$export$e31a90a3bf6aebaa = 2800002;
var $d289d6e522f3d127$export$adaec66b544981e7 = 2800003;
var $d289d6e522f3d127$export$523a769cce7318bf = 2800004;
var $d289d6e522f3d127$export$68473acf744cabf5 = 2800005;
var $d289d6e522f3d127$export$940d17d3b63dba7c = 2800006;
var $d289d6e522f3d127$export$a1cf857da540ee2e = 2800007;
var $d289d6e522f3d127$export$30501b98da9564bb = 2800008;
var $d289d6e522f3d127$export$123d01dd469dc2ef = 2800009;
var $d289d6e522f3d127$export$2a7684440f52314e = 2800010;
var $d289d6e522f3d127$export$7ada2ae349acb674 = 2800011;
var $d289d6e522f3d127$export$8f39956700e64760 = 323e4;
var $d289d6e522f3d127$export$1239089c4564c858 = 32300001;
var $d289d6e522f3d127$export$afc08ee11abbc257 = 3230002;
var $d289d6e522f3d127$export$57836d13a84f54b0 = 3230003;
var $d289d6e522f3d127$export$f080cd056a56cd54 = 3230004;
var $d289d6e522f3d127$export$f2bbb3c14e29977e = 361e4;
var $d289d6e522f3d127$export$f18173f573d8bb21 = 3610001;
var $d289d6e522f3d127$export$7ad09900bd645a86 = 3610002;
var $d289d6e522f3d127$export$69c08c51e1841f29 = 3610003;
var $d289d6e522f3d127$export$325dad4e0a6bd514 = 3610004;
var $d289d6e522f3d127$export$242c341c7c464bee = 3610005;
var $d289d6e522f3d127$export$a73c064bb32a7c36 = 3610006;
var $d289d6e522f3d127$export$b6497aaa1c3cb4a7 = 3610007;
var $d289d6e522f3d127$export$bc2b26beee0f9a0b = 3611e3;
var $d289d6e522f3d127$export$bc1242deaa4d848d = 3704e3;
var $d289d6e522f3d127$export$44352af09ecae39f = 3704001;
var $d289d6e522f3d127$export$d2a0e93e506be463 = 3704002;
var $d289d6e522f3d127$export$bbe4ed5687bc7f55 = 3704003;
var $d289d6e522f3d127$export$436df06ce5af77b3 = 3704004;
var $d289d6e522f3d127$export$bc24f4f6bff910ad = 3704005;
var $d289d6e522f3d127$export$a33e1278cd08ba37 = 3704006;
var $d289d6e522f3d127$export$1c659240f0b07a02 = 3712e3;
var $d289d6e522f3d127$export$552eeff1216c4a1e = 4128e3;
var $d289d6e522f3d127$export$b260fc8c8d3cde52 = 4128001;
var $d289d6e522f3d127$export$b81e507604713b9b = 4128002;
var $d289d6e522f3d127$export$d308cb6df5c28ff6 = 4615e3;
var $d289d6e522f3d127$export$ab2273c84ffc5d61 = 4615001;
var $d289d6e522f3d127$export$23cc359156888c7f = 4615002;
var $d289d6e522f3d127$export$a4193356408e9ff0 = 4615003;
var $d289d6e522f3d127$export$f9ae264f831e3bcf = 4615004;
var $d289d6e522f3d127$export$e170b44d99a3d17c = 4615005;
var $d289d6e522f3d127$export$84ec8e94b54ae7d2 = 4615006;
var $d289d6e522f3d127$export$4063fe8d5aed84a5 = 4615007;
var $d289d6e522f3d127$export$ecdd3388f6a493b1 = 4615008;
var $d289d6e522f3d127$export$df0a6d6cbb0d96a1 = 4615009;
var $d289d6e522f3d127$export$e45bdcd5a97f01d1 = 4615010;
var $d289d6e522f3d127$export$c2bfe7e903a0febb = 4615011;
var $d289d6e522f3d127$export$fa2d8ac69bd6117e = 4615012;
var $d289d6e522f3d127$export$2b7e7e6bd3d5b8c4 = 4615013;
var $d289d6e522f3d127$export$72e64aed285de589 = 4615014;
var $d289d6e522f3d127$export$95d7c72146ee65c6 = 4615015;
var $d289d6e522f3d127$export$aa03f185732dc00b = 4615016;
var $d289d6e522f3d127$export$c390f45549d7336b = 4615017;
var $d289d6e522f3d127$export$2ea2f2f9a9e26449 = 4615018;
var $d289d6e522f3d127$export$c9ece88629d0d2d8 = 4615019;
var $d289d6e522f3d127$export$2f331454431511bf = 4615020;
var $d289d6e522f3d127$export$3c4b9377ed4116a0 = 4615021;
var $d289d6e522f3d127$export$211b990ef3bd19ce = 4615022;
var $d289d6e522f3d127$export$ef486e0fcc8262b = 4615023;
var $d289d6e522f3d127$export$afcb9eeb4bf056b5 = 4615024;
var $d289d6e522f3d127$export$4db39a3a67e51db2 = 4615025;
var $d289d6e522f3d127$export$5abe2d1d040bf6cf = 4615026;
var $d289d6e522f3d127$export$35a7a209cf9aaee8 = 4615027;
var $d289d6e522f3d127$export$203fce7ce63eb278 = 4615028;
var $d289d6e522f3d127$export$c65d87b69a4b86e5 = 4615029;
var $d289d6e522f3d127$export$d13686e596713674 = 4615030;
var $d289d6e522f3d127$export$a070310f29fe959b = 4615031;
var $d289d6e522f3d127$export$8eb8ce58a8afa4d8 = 4615032;
var $d289d6e522f3d127$export$1224afa7bd705d3d = 4615033;
var $d289d6e522f3d127$export$547fdb4fff65c547 = 4615034;
var $d289d6e522f3d127$export$cbeea52e947eb081 = 4615035;
var $d289d6e522f3d127$export$fd7a98f0746b6c8a = 4615036;
var $d289d6e522f3d127$export$8e6d399c8fb88eaa = 4615037;
var $d289d6e522f3d127$export$2c001ce75e66180d = 4615038;
var $d289d6e522f3d127$export$ec7d592dad68aa12 = 4615039;
var $d289d6e522f3d127$export$8815da3ec592d05a = 4615040;
var $d289d6e522f3d127$export$b1b9bf899899a525 = 4615041;
var $d289d6e522f3d127$export$67715a67add5645f = 4615042;
var $d289d6e522f3d127$export$e343a153899b82e9 = 4615043;
var $d289d6e522f3d127$export$2199fb95c7d85b85 = 4615044;
var $d289d6e522f3d127$export$57c1675a0c20931f = 4615045;
var $d289d6e522f3d127$export$9e62f446da191370 = 4615046;
var $d289d6e522f3d127$export$b5ccaf975fe486a0 = 4615047;
var $d289d6e522f3d127$export$4d39d4c2f04b41a8 = 4615048;
var $d289d6e522f3d127$export$1997554dc67e9c4e = 4615049;
var $d289d6e522f3d127$export$8a65209e9cece2cd = 4615050;
var $d289d6e522f3d127$export$6b675123aa59300c = 4615051;
var $d289d6e522f3d127$export$70b4e2dd1496c5a3 = 4615052;
var $d289d6e522f3d127$export$43d5111034db211a = 4615053;
var $d289d6e522f3d127$export$8aebe3e76f515046 = 4615054;
var $d289d6e522f3d127$export$ee84b29a9985e516 = 5508e3;
var $d289d6e522f3d127$export$9998b265c986beaa = 5508001;
var $d289d6e522f3d127$export$dd792e9d67cd031b = 5508002;
var $d289d6e522f3d127$export$14d32fbdad2233cd = 5508003;
var $d289d6e522f3d127$export$8c6fc1cfcec8440c = 5508004;
var $d289d6e522f3d127$export$dcec7171cff295d1 = 5508005;
var $d289d6e522f3d127$export$200acbfc722e322b = 5508006;
var $d289d6e522f3d127$export$4c96d9a95880ae4b = 5508007;
var $d289d6e522f3d127$export$bba76b21ada319a5 = 5508008;
var $d289d6e522f3d127$export$3cb3b480d2bfdacc = 5508009;
var $d289d6e522f3d127$export$1f5fbaa83776feec = 5508010;
var $d289d6e522f3d127$export$1d51c4c8b2c49e09 = 5508011;
var $d289d6e522f3d127$export$96a986fd198910e9 = 5508012;
var $d289d6e522f3d127$export$e095feafa627ab93 = 5607e3;
var $d289d6e522f3d127$export$1bd1351c3c04dffb = 5607001;
var $d289d6e522f3d127$export$c2666c33001f9716 = 5607002;
var $d289d6e522f3d127$export$13efb168b2f8723b = 5607003;
var $d289d6e522f3d127$export$cdd46422e6064873 = 5607004;
var $d289d6e522f3d127$export$ca446d431d3e0795 = 5607005;
var $d289d6e522f3d127$export$7b86ea017e7c65a8 = 5607006;
var $d289d6e522f3d127$export$47bddc6d96d8aafe = 5607007;
var $d289d6e522f3d127$export$16aa99698ba98923 = 5607008;
var $d289d6e522f3d127$export$24dfb058e3a278af = 5607009;
var $d289d6e522f3d127$export$5de6608bb79088df = 5607010;
var $d289d6e522f3d127$export$5b7facf9eb8f4fc1 = 5607011;
var $d289d6e522f3d127$export$ac41328a8c021f1d = 5607012;
var $d289d6e522f3d127$export$a722215db3dceeea = 5607013;
var $d289d6e522f3d127$export$c0e832e2b8c6c75c = 5607014;
var $d289d6e522f3d127$export$7be41df2aa4d6598 = 5607015;
var $d289d6e522f3d127$export$f4c0dc856ca8d3c6 = 5607016;
var $d289d6e522f3d127$export$3abfcff57e9c6b21 = 5607017;
var $d289d6e522f3d127$export$bb317ddcc34ed03d = 5607018;
var $d289d6e522f3d127$export$7fb8ee8f1d153f7d = 5607019;
var $d289d6e522f3d127$export$694fd435994bcca = 5663e3;
var $d289d6e522f3d127$export$707576ec00ca24d6 = 5663001;
var $d289d6e522f3d127$export$e33d07a7526bded0 = 5663002;
var $d289d6e522f3d127$export$a20747f749dd4515 = 5663003;
var $d289d6e522f3d127$export$3963d9bca4091810 = 5663004;
var $d289d6e522f3d127$export$b34a16b8adbffdc1 = 5663005;
var $d289d6e522f3d127$export$3764bbcfb0679211 = 5663006;
var $d289d6e522f3d127$export$ed2bdee7953e467f = 5663007;
var $d289d6e522f3d127$export$11bea4440904349c = 5663008;
var $d289d6e522f3d127$export$6d61b980429516bd = 5663009;
var $d289d6e522f3d127$export$819b1b0603d2a966 = 5663010;
var $d289d6e522f3d127$export$592862d1b11e32ac = 5663011;
var $d289d6e522f3d127$export$242af5597d94abaf = 5663012;
var $d289d6e522f3d127$export$802b3ebe5297e360 = 5663013;
var $d289d6e522f3d127$export$bed6f92dafea0623 = 5663014;
var $d289d6e522f3d127$export$36c2547c3c4d823f = 5663015;
var $d289d6e522f3d127$export$de92784c954d1b84 = 5663016;
var $d289d6e522f3d127$export$b55a3eb3d894ad9f = 5663017;
var $d289d6e522f3d127$export$4e4582c633fc423e = 5663018;
var $d289d6e522f3d127$export$923893d5c076a47c = 5663019;
var $d289d6e522f3d127$export$980469bdb5d5bd4f = 5663020;
var $d289d6e522f3d127$export$8ff97fea1326b6e7 = 5663021;
var $d289d6e522f3d127$export$204c62c0e8d2efcc = 5663022;
var $d289d6e522f3d127$export$102de27de91bf32b = 5663023;
var $d289d6e522f3d127$export$15d93ee95a0fbfee = 5663024;
var $d289d6e522f3d127$export$4641ca456c9ac65a = 5663025;
var $d289d6e522f3d127$export$db5d0ad0319baeab = 5663026;
var $d289d6e522f3d127$export$c94bf194991c6a40 = 5663027;
var $d289d6e522f3d127$export$ee92f61088a1066a = 5663028;
var $d289d6e522f3d127$export$ce102cf7a4dc8c26 = 5663029;
var $d289d6e522f3d127$export$bb954aa95380cc07 = 5663030;
var $d289d6e522f3d127$export$70cf12a7af68a7bb = 5663031;
var $d289d6e522f3d127$export$3da8c24b63df7026 = 5663032;
var $d289d6e522f3d127$export$24ca3e569f030a48 = 5663033;
var $d289d6e522f3d127$export$7d52b2fdc6c6f4fd = 5663034;
var $d289d6e522f3d127$export$d463b452862201a4 = 5663035;
var $d289d6e522f3d127$export$7a52a9f8bedc82c0 = 5663036;
var $d289d6e522f3d127$export$7774c611982e038 = 5663037;
var $d289d6e522f3d127$export$a0d8e792371f738d = 5663038;
var $d289d6e522f3d127$export$a05704ad9908bda9 = 5664e3;
var $d289d6e522f3d127$export$302ce5f895eb18ab = 5664001;
var $d289d6e522f3d127$export$8c82dde5b12c9789 = 705e4;
var $d289d6e522f3d127$export$a746609ecc2f6acf = 7050001;
var $d289d6e522f3d127$export$c4d8217d3eb3eaf8 = 7050002;
var $d289d6e522f3d127$export$5d0f06cd8bc8e3af = 7050003;
var $d289d6e522f3d127$export$83c8fe2717d1b271 = 7050004;
var $d289d6e522f3d127$export$39ead28cf48a604c = 7050005;
var $d289d6e522f3d127$export$624f65633216eb57 = 7050006;
var $d289d6e522f3d127$export$2bbd9403cb117ea7 = 7050007;
var $d289d6e522f3d127$export$e108dd5343c4c11 = 7050008;
var $d289d6e522f3d127$export$a504ed6cab09ce4a = 7050009;
var $d289d6e522f3d127$export$8c1ae05eccc11ef9 = 7050010;
var $d289d6e522f3d127$export$47df44101c6f04b0 = 7050011;
var $d289d6e522f3d127$export$89ae0c424691fbcb = 7050012;
var $d289d6e522f3d127$export$bea5f92951bc42e7 = 7050013;
var $d289d6e522f3d127$export$91a668e132084ecf = 7050014;
var $d289d6e522f3d127$export$211b9b84186690f0 = 7050015;
var $d289d6e522f3d127$export$291ea8d5a7496fde = 7050016;
var $d289d6e522f3d127$export$5f027a86397cba92 = 7050017;
var $d289d6e522f3d127$export$58bf90c73afbc02e = 7050018;
var $d289d6e522f3d127$export$b8b2610c9a910763 = 7050019;
var $d289d6e522f3d127$export$fb693aebffa32676 = 7050020;
var $d289d6e522f3d127$export$572954173bc64b66 = 7050021;
var $d289d6e522f3d127$export$fa9a13f1b40ee2fb = 7050022;
var $d289d6e522f3d127$export$95c94f6ea500f1ab = 7050023;
var $d289d6e522f3d127$export$11d69fb6993b2cf5 = 7050024;
var $d289d6e522f3d127$export$bd54a9a85614b3a7 = 7050025;
var $d289d6e522f3d127$export$df4ef1824fd194a3 = 7050026;
var $d289d6e522f3d127$export$2725d50dd432fb3a = 7050027;
var $d289d6e522f3d127$export$41f13726b04d8d05 = 7050028;
var $d289d6e522f3d127$export$7b4a7eebff68ca7b = 7050029;
var $d289d6e522f3d127$export$e3a4007020a2e8f5 = 7050030;
var $d289d6e522f3d127$export$2ecc275dffbc087c = 7050031;
var $d289d6e522f3d127$export$e3289c5954208202 = 7050032;
var $d289d6e522f3d127$export$3569c6c71e349538 = 7050033;
var $d289d6e522f3d127$export$4f413e02d5e82221 = 7050034;
var $d289d6e522f3d127$export$1cd0de5dfcdeb99d = 7050035;
var $d289d6e522f3d127$export$87e01307d368f511 = 7050036;
var $d289d6e522f3d127$export$4758b9d97c7acd49 = 7618e3;
var $d289d6e522f3d127$export$2e5fda8b40bc9396 = 7618001;
var $d289d6e522f3d127$export$b22811c3929e985a = 7618002;
var $d289d6e522f3d127$export$12d6d18d48ba64e9 = 7618003;
var $d289d6e522f3d127$export$e4bc7cf62067d898 = 7618004;
var $d289d6e522f3d127$export$f988935bbec3c348 = 7618005;
var $d289d6e522f3d127$export$a55985b9459d2f3b = 7618006;
var $d289d6e522f3d127$export$dba3fa3abd2194c6 = 7618007;
var $d289d6e522f3d127$export$a751080bf117630f = 7618008;
var $d289d6e522f3d127$export$9318fa904fe94ef2 = 7618009;
var $d289d6e522f3d127$export$9bfc7de894c3d9da = 7618010;
var $d289d6e522f3d127$export$58f34489822f32f1 = 7618011;
var $d289d6e522f3d127$export$9c9326ce1e3df40c = 8078e3;
var $d289d6e522f3d127$export$18fbf24f19efc69b = 8078001;
var $d289d6e522f3d127$export$93561b31b951410d = 8078002;
var $d289d6e522f3d127$export$3417da5bc6bcb45 = 8078003;
var $d289d6e522f3d127$export$c4c73ab3c0833591 = 8078004;
var $d289d6e522f3d127$export$824d79ab1779d517 = 8078005;
var $d289d6e522f3d127$export$c464f3b291f1f3d0 = 8078006;
var $d289d6e522f3d127$export$c04710d31ef4d278 = 8078007;
var $d289d6e522f3d127$export$1fa107ead8489cf2 = 8078008;
var $d289d6e522f3d127$export$2bb0703affb8fe68 = 8078009;
var $d289d6e522f3d127$export$f6bf8a7c1f3defe4 = 8078010;
var $d289d6e522f3d127$export$8653c145864f47f4 = 8078011;
var $d289d6e522f3d127$export$89b582b06852d433 = 8078012;
var $d289d6e522f3d127$export$4c1fcb4bd20b2951 = 8078013;
var $d289d6e522f3d127$export$a617dff403944ec6 = 8078014;
var $d289d6e522f3d127$export$c89f43f0d783cd50 = 8078015;
var $d289d6e522f3d127$export$f73fb8ecbd4b2395 = 8078016;
var $d289d6e522f3d127$export$efbd199de191d2aa = 8078017;
var $d289d6e522f3d127$export$cb77f5a0f0fa7f18 = 8078018;
var $d289d6e522f3d127$export$47278510a511031b = 8078019;
var $d289d6e522f3d127$export$a9282ed13660c9f6 = 8078020;
var $d289d6e522f3d127$export$5bdfee6423bc35ce = 8078021;
var $d289d6e522f3d127$export$a2e9526594022372 = 8078022;
var $d289d6e522f3d127$export$11a7243580452ad8 = 8078023;
var $d289d6e522f3d127$export$917fb07617f2d1fb = 8078024;
var $d289d6e522f3d127$export$345850eef23c927d = 8078025;
var $d289d6e522f3d127$export$e7d6af6e57db8b2b = 809e4;
var $d289d6e522f3d127$export$92d7c36d7c6d6326 = 8090001;
var $d289d6e522f3d127$export$929704b13825ef1d = 8090002;
var $d289d6e522f3d127$export$72468d0872763e95 = 8090003;
var $d289d6e522f3d127$export$b02d235d3b45fb86 = 8090004;
var $d289d6e522f3d127$export$183ade6d1821d3b6 = 8090005;
var $d289d6e522f3d127$export$85a626151643ef3b = 8090006;
var $d289d6e522f3d127$export$2feecdeb7a6034df = 8090007;
var $d289d6e522f3d127$export$9e032cc8893e9cb9 = 8090008;
var $d289d6e522f3d127$export$ea486bd2871daf4e = 8090009;
var $d289d6e522f3d127$export$8911b5c0a403a5af = 8090010;
var $d289d6e522f3d127$export$974c80374b7537fd = 8090011;
var $d289d6e522f3d127$export$dfd6489d84297a17 = 8090012;
var $d289d6e522f3d127$export$ef742b7036fb9005 = 81e5;
var $d289d6e522f3d127$export$2a2f0f75708d1697 = 8100001;
var $d289d6e522f3d127$export$7f6822f75edb8f41 = 8100002;
var $d289d6e522f3d127$export$119023a74b281384 = 8100003;
var $d289d6e522f3d127$export$c32108b180210fc5 = 819e4;
var $d289d6e522f3d127$export$e1a3658b043aad8e = 8190001;
var $d289d6e522f3d127$export$ae8da83a78732501 = 8190002;
var $d289d6e522f3d127$export$73f01f46f9a97cf0 = 8190003;
var $d289d6e522f3d127$export$5293460f390d6127 = 8190004;
var $d289d6e522f3d127$export$15c87714768dc01d = 8195e3;
var $d289d6e522f3d127$export$55e9fe02b4fcdcf4 = 8195001;
var $d289d6e522f3d127$export$7a470f3bbbd2358 = 85e5;
var $d289d6e522f3d127$export$28c1d89d6f82797c = 8500001;
var $d289d6e522f3d127$export$a35cab87219e2726 = 8500002;
var $d289d6e522f3d127$export$a46c9b68bd6e4f3c = 8500003;
var $d289d6e522f3d127$export$85e194a892d0127e = 8500004;
var $d289d6e522f3d127$export$5397ee6ba4d6d1bc = 8500005;
var $d289d6e522f3d127$export$6a51b1679eb0ed12 = 8500006;
var $d289d6e522f3d127$export$eff143d04ba1c763 = 89e5;
var $d289d6e522f3d127$export$c312471e35f2eb26 = 8900001;
var $d289d6e522f3d127$export$199c235749811d11 = 8900002;
var $d289d6e522f3d127$export$26183083c720a8a4 = 8900003;
var $d289d6e522f3d127$export$100e4d6784b74743 = 9e6;
var $d289d6e522f3d127$export$53a95e64cc3268a = 9000001;
var $d289d6e522f3d127$export$ece10101ca3fdef = 9000002;
var $d289d6e522f3d127$export$a12ca71185bd51db = 99e5;
var $d289d6e522f3d127$export$d5b3c70e0e0f470a = 9900001;
var $d289d6e522f3d127$export$b57ffff6ec11f63 = 9900002;
var $d289d6e522f3d127$export$6fe73388375373f = 9900003;
var $d289d6e522f3d127$export$8b0d360227f3435e = 9900004;
var $d289d6e522f3d127$export$bcbc513a8682960f = 9900005;
var $d289d6e522f3d127$export$8f646bf76fb27ec0 = 9900006;
// src/context.ts
function $d289d6e522f3d127$var$encodeValue(value) {
    if (Array.isArray(value)) {
        const commaSeparatedValues = value.map($d289d6e522f3d127$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $d289d6e522f3d127$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$d289d6e522f3d127$var$encodeValue(value)}`;
}
function $d289d6e522f3d127$var$encodeContextObject(context) {
    const searchParamsString = Object.entries(context).map($d289d6e522f3d127$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
// src/messages.ts
var $d289d6e522f3d127$var$SolanaErrorMessages = {
    [$d289d6e522f3d127$export$8f39956700e64760]: "Account not found at address: $address",
    [$d289d6e522f3d127$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$d289d6e522f3d127$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$d289d6e522f3d127$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$d289d6e522f3d127$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$d289d6e522f3d127$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$d289d6e522f3d127$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$d289d6e522f3d127$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$d289d6e522f3d127$export$7ada2ae349acb674]: "$putativeOffCurveAddress is not a base58-encoded off-curve address.",
    [$d289d6e522f3d127$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$d289d6e522f3d127$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$d289d6e522f3d127$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$d289d6e522f3d127$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$d289d6e522f3d127$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$d289d6e522f3d127$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$d289d6e522f3d127$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$6ad19ea5e363a944]: "Expected base58-encoded blockhash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$d289d6e522f3d127$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$d289d6e522f3d127$export$a2e9526594022372]: "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.",
    [$d289d6e522f3d127$export$a9282ed13660c9f6]: "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].",
    [$d289d6e522f3d127$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$d289d6e522f3d127$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$d289d6e522f3d127$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$d289d6e522f3d127$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.",
    [$d289d6e522f3d127$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$d289d6e522f3d127$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$d289d6e522f3d127$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$d289d6e522f3d127$export$47278510a511031b]: "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].",
    [$d289d6e522f3d127$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$d289d6e522f3d127$export$cb77f5a0f0fa7f18]: "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].",
    [$d289d6e522f3d127$export$2bb0703affb8fe68]: "Invalid discriminated union variant. Expected one of [$variants], got $value.",
    [$d289d6e522f3d127$export$f6bf8a7c1f3defe4]: "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.",
    [$d289d6e522f3d127$export$c89f43f0d783cd50]: "Invalid literal union variant. Expected one of [$variants], got $value.",
    [$d289d6e522f3d127$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$d289d6e522f3d127$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$d289d6e522f3d127$export$f73fb8ecbd4b2395]: "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$d289d6e522f3d127$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$d289d6e522f3d127$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$d289d6e522f3d127$export$5bdfee6423bc35ce]: "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].",
    [$d289d6e522f3d127$export$efbd199de191d2aa]: "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.",
    [$d289d6e522f3d127$export$11a7243580452ad8]: "This decoder expected a byte array of exactly $expectedLength bytes, but $numExcessBytes unexpected excess bytes remained after decoding. Are you sure that you have chosen the correct decoder for this data?",
    [$d289d6e522f3d127$export$917fb07617f2d1fb]: "Invalid pattern match value. The provided value does not match any of the specified patterns.",
    [$d289d6e522f3d127$export$345850eef23c927d]: "Invalid pattern match bytes. The provided byte array does not match any of the specified patterns.",
    [$d289d6e522f3d127$export$bc2b26beee0f9a0b]: "No random values implementation could be found.",
    [$d289d6e522f3d127$export$7cb3af4590511eb4]: "Failed to send transaction$causeMessage",
    [$d289d6e522f3d127$export$5dac493019b18473]: "Failed to send transactions$causeMessages",
    [$d289d6e522f3d127$export$2feecdeb7a6034df]: "Fixed-point operation `$operation` of kind `$kind` overflowed. Expected a raw bigint in [$min, $max], got $result.",
    [$d289d6e522f3d127$export$ea486bd2871daf4e]: "Fixed-point division by zero for value of kind `$kind` ($signedness, $totalBits bits).",
    [$d289d6e522f3d127$export$72468d0872763e95]: "`fractionalBits` ($fractionalBits) must not exceed `totalBits` ($totalBits).",
    [$d289d6e522f3d127$export$929704b13825ef1d]: "Invalid `decimals`. Expected a non-negative integer, got $decimals.",
    [$d289d6e522f3d127$export$92d7c36d7c6d6326]: "Invalid `fractionalBits`. Expected a non-negative integer, got $fractionalBits.",
    [$d289d6e522f3d127$export$183ade6d1821d3b6]: "Invalid string `$input` for fixed-point value of kind `$kind`.",
    [$d289d6e522f3d127$export$e7d6af6e57db8b2b]: "Invalid `totalBits`. Expected a positive integer, got $totalBits.",
    [$d289d6e522f3d127$export$85a626151643ef3b]: "Invalid ratio $numerator/$denominator for fixed-point value of kind `$kind`. Denominator must be non-zero.",
    [$d289d6e522f3d127$export$974c80374b7537fd]: "Fixed-point value of kind `$kind` has a malformed `raw` field. Expected a bigint, got `$raw`.",
    [$d289d6e522f3d127$export$9e032cc8893e9cb9]: "Fixed-point `$operation` operation expected $expectedKind ($expectedSignedness, $expectedTotalBits bits, $expectedScale $expectedScaleLabel); got $actualKind ($actualSignedness, $actualTotalBits bits, $actualScale $actualScaleLabel).",
    [$d289d6e522f3d127$export$8911b5c0a403a5af]: "Fixed-point operation `$operation` of kind `$kind` cannot be performed exactly; pass a rounding mode other than `strict` to allow a rounded result.",
    [$d289d6e522f3d127$export$dfd6489d84297a17]: "Fixed-point codec of kind `$kind` requires `totalBits` to be a multiple of 8; got $totalBits.",
    [$d289d6e522f3d127$export$b02d235d3b45fb86]: "Fixed-point value of kind `$kind` is out of range for $signedness $totalBits-bit storage. Expected a raw bigint in [$min, $max], got $raw.",
    [$d289d6e522f3d127$export$1c659240f0b07a02]: "Filesystem operation `$operation` is not supported in this environment.",
    [$d289d6e522f3d127$export$df0a6d6cbb0d96a1]: "Instruction requires an uninitialized account",
    [$d289d6e522f3d127$export$ef486e0fcc8262b]: "Instruction tries to borrow reference for an account which is already borrowed",
    [$d289d6e522f3d127$export$afcb9eeb4bf056b5]: "Instruction left account with an outstanding borrowed reference",
    [$d289d6e522f3d127$export$3c4b9377ed4116a0]: "Program other than the account's owner changed the size of the account data",
    [$d289d6e522f3d127$export$e170b44d99a3d17c]: "Account data too small for instruction",
    [$d289d6e522f3d127$export$211b990ef3bd19ce]: "Instruction expected an executable account",
    [$d289d6e522f3d127$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$d289d6e522f3d127$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$d289d6e522f3d127$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data",
    [$d289d6e522f3d127$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$d289d6e522f3d127$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$d289d6e522f3d127$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$d289d6e522f3d127$export$5abe2d1d040bf6cf]: "Custom program error: #$code",
    [$d289d6e522f3d127$export$c390f45549d7336b]: "Instruction contains duplicate accounts",
    [$d289d6e522f3d127$export$4db39a3a67e51db2]: "Instruction modifications of multiply-passed account differ",
    [$d289d6e522f3d127$export$d13686e596713674]: "Executable accounts must be rent exempt",
    [$d289d6e522f3d127$export$203fce7ce63eb278]: "Instruction changed executable accounts data",
    [$d289d6e522f3d127$export$c65d87b69a4b86e5]: "Instruction changed the balance of an executable account",
    [$d289d6e522f3d127$export$2ea2f2f9a9e26449]: "Instruction changed executable bit of an account",
    [$d289d6e522f3d127$export$72e64aed285de589]: "Instruction modified data of an account it does not own",
    [$d289d6e522f3d127$export$2b7e7e6bd3d5b8c4]: "Instruction spent from the balance of an account it does not own",
    [$d289d6e522f3d127$export$ab2273c84ffc5d61]: "Generic instruction error",
    [$d289d6e522f3d127$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$d289d6e522f3d127$export$e343a153899b82e9]: "Account is immutable",
    [$d289d6e522f3d127$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$d289d6e522f3d127$export$4063fe8d5aed84a5]: "Incorrect program id for instruction",
    [$d289d6e522f3d127$export$84ec8e94b54ae7d2]: "Insufficient funds for instruction",
    [$d289d6e522f3d127$export$f9ae264f831e3bcf]: "Invalid account data for instruction",
    [$d289d6e522f3d127$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$d289d6e522f3d127$export$23cc359156888c7f]: "Invalid program argument",
    [$d289d6e522f3d127$export$35a7a209cf9aaee8]: "Program returned invalid error code",
    [$d289d6e522f3d127$export$a4193356408e9ff0]: "Invalid instruction data",
    [$d289d6e522f3d127$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$d289d6e522f3d127$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$d289d6e522f3d127$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$d289d6e522f3d127$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$d289d6e522f3d127$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$d289d6e522f3d127$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$d289d6e522f3d127$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$d289d6e522f3d127$export$ecdd3388f6a493b1]: "Missing required signature for instruction",
    [$d289d6e522f3d127$export$fa2d8ac69bd6117e]: "Instruction illegally modified the program id of an account",
    [$d289d6e522f3d127$export$2f331454431511bf]: "Insufficient account keys for instruction",
    [$d289d6e522f3d127$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$d289d6e522f3d127$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$d289d6e522f3d127$export$67715a67add5645f]: "Program failed to compile",
    [$d289d6e522f3d127$export$b1b9bf899899a525]: "Program failed to complete",
    [$d289d6e522f3d127$export$aa03f185732dc00b]: "Instruction modified data of a read-only account",
    [$d289d6e522f3d127$export$95d7c72146ee65c6]: "Instruction changed the balance of a read-only account",
    [$d289d6e522f3d127$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$d289d6e522f3d127$export$c9ece88629d0d2d8]: "Instruction modified rent epoch of an account",
    [$d289d6e522f3d127$export$c2bfe7e903a0febb]: "Sum of account balances before and after instruction do not match",
    [$d289d6e522f3d127$export$e45bdcd5a97f01d1]: "Instruction requires an initialized account",
    [$d289d6e522f3d127$export$d308cb6df5c28ff6]: "The instruction failed with the error: $errorName",
    [$d289d6e522f3d127$export$a070310f29fe959b]: "Unsupported program id",
    [$d289d6e522f3d127$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$d289d6e522f3d127$export$bcbc513a8682960f]: "Invalid instruction plan kind: $kind.",
    [$d289d6e522f3d127$export$b22811c3929e985a]: "The provided instruction plan is empty.",
    [$d289d6e522f3d127$export$f988935bbec3c348]: "No failed transaction plan result was found in the provided transaction plan result.",
    [$d289d6e522f3d127$export$e4bc7cf62067d898]: "This transaction plan executor does not support non-divisible sequential plans. To support them, you may create your own executor such that multi-transaction atomicity is preserved \u2014 e.g. by targetting RPCs that support transaction bundles.",
    [$d289d6e522f3d127$export$12d6d18d48ba64e9]: "The provided transaction plan failed to execute. See the `transactionPlanResult` attribute for more details. Note that the `cause` property is deprecated, and a future version will not set it.",
    [$d289d6e522f3d127$export$58f34489822f32f1]: "The configured maximum of $maxInstructions instructions per transaction is invalid. It must be a positive integer no greater than the transaction format limit of $transactionInstructionLimit instructions per transaction. Provide a `maxInstructionsPerTransaction` (on the transaction planner) or `maxInstructions` (on the message packer) value between 1 and $transactionInstructionLimit.",
    [$d289d6e522f3d127$export$9bfc7de894c3d9da]: "Planning this transaction message would require $numInstructions instructions, which exceeds the configured maximum of $maxInstructions instructions per transaction. This limit is configurable, and intended to leave headroom for inner instructions which are included in the maximum instruction limit for transactions. Increase `maxInstructionsPerTransaction` on the transaction planner (or `maxInstructions` on the message packer) to allow more instructions per transaction.",
    [$d289d6e522f3d127$export$4758b9d97c7acd49]: "The provided message has insufficient capacity to accommodate the next instruction(s) in this plan. Expected at least $numBytesRequired free byte(s), got $numFreeBytes byte(s).",
    [$d289d6e522f3d127$export$8f646bf76fb27ec0]: "Invalid transaction plan kind: $kind.",
    [$d289d6e522f3d127$export$2e5fda8b40bc9396]: "No more instructions to pack; the message packer has completed the instruction plan.",
    [$d289d6e522f3d127$export$a55985b9459d2f3b]: "Unexpected instruction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$d289d6e522f3d127$export$dba3fa3abd2194c6]: "Unexpected transaction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$d289d6e522f3d127$export$a751080bf117630f]: "Unexpected transaction plan result. Expected $expectedKind plan, got $actualKind plan.",
    [$d289d6e522f3d127$export$9318fa904fe94ef2]: "Expected a successful transaction plan result. I.e. there is at least one failed or cancelled transaction in the plan.",
    [$d289d6e522f3d127$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$d289d6e522f3d127$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$d289d6e522f3d127$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$d289d6e522f3d127$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$d289d6e522f3d127$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$d289d6e522f3d127$export$8b0d360227f3435e]: "Invariant violation: This data publisher does not publish to the channel named `$channelName`. Supported channels include $supportedChannelNames.",
    [$d289d6e522f3d127$export$d5b3c70e0e0f470a]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$d289d6e522f3d127$export$a12ca71185bd51db]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$d289d6e522f3d127$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$d289d6e522f3d127$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$d289d6e522f3d127$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$d289d6e522f3d127$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$d289d6e522f3d127$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$d289d6e522f3d127$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$d289d6e522f3d127$export$1b90c411626421b1]: "$__serverMessage",
    [$d289d6e522f3d127$export$6ae475e85fe02aad]: "$__serverMessage",
    [$d289d6e522f3d127$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$d289d6e522f3d127$export$65235469ebe9845e]: "$__serverMessage",
    [$d289d6e522f3d127$export$1e95c50f9776ce34]: "Epoch rewards period still active at slot $slot",
    [$d289d6e522f3d127$export$8dfce16ef39ea58c]: "$__serverMessage",
    [$d289d6e522f3d127$export$54dea2286c43ec1e]: "$__serverMessage",
    [$d289d6e522f3d127$export$e71fbee92648fc61]: "$__serverMessage",
    [$d289d6e522f3d127$export$35d837f314929752]: "Failed to query long-term storage; please try again",
    [$d289d6e522f3d127$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$d289d6e522f3d127$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$d289d6e522f3d127$export$690667cf4da3ba9d]: "No slot history",
    [$d289d6e522f3d127$export$eb4f7515ff6aa19d]: "No snapshot",
    [$d289d6e522f3d127$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$d289d6e522f3d127$export$86fc15c41ff3dc9c]: "Rewards cannot be found because slot $slot is not the epoch boundary. This may be due to gap in the queried node's local ledger or long-term storage",
    [$d289d6e522f3d127$export$d21075fd06730e]: "$__serverMessage",
    [$d289d6e522f3d127$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$d289d6e522f3d127$export$d964b43bb02eacdf]: "$__serverMessage",
    [$d289d6e522f3d127$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$d289d6e522f3d127$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$d289d6e522f3d127$export$f7685139153f9191]: "$__serverMessage",
    [$d289d6e522f3d127$export$bc24f4f6bff910ad]: "The grind regex `/$source/` contains the character `$character`, which is not in the base58 alphabet and can never match a Solana address.",
    [$d289d6e522f3d127$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$d289d6e522f3d127$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$436df06ce5af77b3]: "The provided private key does not match the provided public key.",
    [$d289d6e522f3d127$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$a33e1278cd08ba37]: "Writing a key pair to disk is not supported in this environment.",
    [$d289d6e522f3d127$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$d289d6e522f3d127$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$d289d6e522f3d127$export$1cf7bba40d7d2361]: "$message",
    [$d289d6e522f3d127$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$d289d6e522f3d127$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$d289d6e522f3d127$export$13efb168b2f8723b]: "Expected base58 encoded application domain to decode to a byte array of length 32. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$a722215db3dceeea]: "Attempted to sign an offchain message with an address that is not a signer for it",
    [$d289d6e522f3d127$export$c2666c33001f9716]: "Expected base58-encoded application domain string of length in the range [32, 44]. Actual length: $actualLength.",
    [$d289d6e522f3d127$export$bb317ddcc34ed03d]: "The content of the offchain message does not match the content that was expected. Expected content with a byte-length of $expectedBytes; got content with a byte-length of $actualBytes. The signer may have signed different data than was requested; do not trust its signature.",
    [$d289d6e522f3d127$export$ac41328a8c021f1d]: "The signer addresses in this offchain message envelope do not match the list of required signers in the message preamble. These unexpected signers were present in the envelope: `[$unexpectedSigners]`. These required signers were missing from the envelope `[$missingSigners]`.",
    [$d289d6e522f3d127$export$e095feafa627ab93]: "The message body provided has a byte-length of $actualBytes. The maximum allowable byte-length is $maxBytes",
    [$d289d6e522f3d127$export$47bddc6d96d8aafe]: "Expected message format $expectedMessageFormat, got $actualMessageFormat",
    [$d289d6e522f3d127$export$16aa99698ba98923]: "The message length specified in the message preamble is $specifiedLength bytes. The actual length of the message is $actualLength bytes.",
    [$d289d6e522f3d127$export$24dfb058e3a278af]: "Offchain message content must be non-empty",
    [$d289d6e522f3d127$export$ca446d431d3e0795]: "Offchain message must specify the address of at least one required signer",
    [$d289d6e522f3d127$export$5de6608bb79088df]: "Offchain message envelope must reserve space for at least one signature",
    [$d289d6e522f3d127$export$cdd46422e6064873]: "The offchain message preamble specifies $numRequiredSignatures required signature(s), got $signaturesLength.",
    [$d289d6e522f3d127$export$7fb8ee8f1d153f7d]: "The offchain message lists different required signatories than was expected. Expected [$expectedAddresses]. Got [$actualAddresses]. The signer may have signed different data than was requested; do not trust its signature.",
    [$d289d6e522f3d127$export$7be41df2aa4d6598]: "The signatories of this offchain message must be listed in lexicographical order",
    [$d289d6e522f3d127$export$f4c0dc856ca8d3c6]: "An address must be listed no more than once among the signatories of an offchain message",
    [$d289d6e522f3d127$export$5b7facf9eb8f4fc1]: "Offchain message is missing signatures for addresses: $addresses.",
    [$d289d6e522f3d127$export$3abfcff57e9c6b21]: "Offchain message signature verification failed. Signature mismatch for required signatories [$signatoriesWithInvalidSignatures]. Missing signatures for signatories [$signatoriesWithMissingSignatures]",
    [$d289d6e522f3d127$export$1bd1351c3c04dffb]: "The message body provided contains characters whose codes fall outside the allowed range. In order to ensure clear-signing compatiblity with hardware wallets, the message may only contain line feeds and characters in the range [\\x20-\\x7e].",
    [$d289d6e522f3d127$export$c0e832e2b8c6c75c]: "Expected offchain message version $expectedVersion. Got $actualVersion.",
    [$d289d6e522f3d127$export$7b86ea017e7c65a8]: "This version of Kit does not support decoding offchain messages with version $unsupportedVersion. The current max supported version is 0.",
    [$d289d6e522f3d127$export$6a51b1679eb0ed12]: "The provided account could not be identified as an account from the $programName program.",
    [$d289d6e522f3d127$export$a35cab87219e2726]: "The provided instruction could not be identified as an instruction from the $programName program.",
    [$d289d6e522f3d127$export$7a470f3bbbd2358]: "The provided instruction is missing some accounts. Expected at least $expectedAccountMetas account(s), got $actualAccountMetas.",
    [$d289d6e522f3d127$export$85e194a892d0127e]: "Expected resolved instruction input '$inputName' to be non-null.",
    [$d289d6e522f3d127$export$a46c9b68bd6e4f3c]: "Expected resolved instruction input '$inputName' to be of type `$expectedType`.",
    [$d289d6e522f3d127$export$5397ee6ba4d6d1bc]: "Unrecognized account type '$accountType' for the $programName program.",
    [$d289d6e522f3d127$export$28c1d89d6f82797c]: "Unrecognized instruction type '$instructionType' for the $programName program.",
    [$d289d6e522f3d127$export$c32108b180210fc5]: "The notification name must end in 'Notifications' and the API must supply a subscription plan creator function for the notification '$notificationName'.",
    [$d289d6e522f3d127$export$ae8da83a78732501]: "WebSocket was closed before payload could be added to the send buffer",
    [$d289d6e522f3d127$export$73f01f46f9a97cf0]: "WebSocket connection closed",
    [$d289d6e522f3d127$export$5293460f390d6127]: "WebSocket failed to connect",
    [$d289d6e522f3d127$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$d289d6e522f3d127$export$119023a74b281384]: "Could not find an API plan for RPC method: `$method`",
    [$d289d6e522f3d127$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$d289d6e522f3d127$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$d289d6e522f3d127$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$d289d6e522f3d127$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$d289d6e522f3d127$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$d289d6e522f3d127$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$d289d6e522f3d127$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$d289d6e522f3d127$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$d289d6e522f3d127$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$d289d6e522f3d127$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$d289d6e522f3d127$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$d289d6e522f3d127$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$d289d6e522f3d127$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$d289d6e522f3d127$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `TransactionWithSingleSendingSigner` transaction.",
    [$d289d6e522f3d127$export$96a986fd198910e9]: "The wallet account $address cannot be used to create a transaction signer because it does not implement either the `solana:signTransaction` or `solana:signAndSendTransaction` feature. At least one of these features is required. The account supports the following features: $supportedFeatures.",
    [$d289d6e522f3d127$export$1d51c4c8b2c49e09]: "Wallet account signers do not support signing multiple messages/transactions in a single operation",
    [$d289d6e522f3d127$export$15c87714768dc01d]: "This `ReactiveStreamStore` does not support retry. Use `createReactiveStoreFromDataPublisherFactory` to construct a retryable store.",
    [$d289d6e522f3d127$export$55e9fe02b4fcdcf4]: "The stream store closed in an error state but did not report an error.",
    [$d289d6e522f3d127$export$b6497aaa1c3cb4a7]: "Cannot export a non-extractable key.",
    [$d289d6e522f3d127$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$d289d6e522f3d127$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$d289d6e522f3d127$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$d289d6e522f3d127$export$69c08c51e1841f29]: "No key export implementation could be found.",
    [$d289d6e522f3d127$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$d289d6e522f3d127$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$d289d6e522f3d127$export$a73c064bb32a7c36]: "No signature verification implementation could be found.",
    [$d289d6e522f3d127$export$8b23617676679e2d]: "Timestamp value must be in the range [-(2n ** 63n), (2n ** 63n) - 1]. `$value` given",
    [$d289d6e522f3d127$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$d289d6e522f3d127$export$a746609ecc2f6acf]: "Account in use",
    [$d289d6e522f3d127$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$d289d6e522f3d127$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$d289d6e522f3d127$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$d289d6e522f3d127$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$d289d6e522f3d127$export$e108dd5343c4c11]: "Blockhash not found",
    [$d289d6e522f3d127$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$d289d6e522f3d127$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$d289d6e522f3d127$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$d289d6e522f3d127$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$d289d6e522f3d127$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$d289d6e522f3d127$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$d289d6e522f3d127$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$d289d6e522f3d127$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$d289d6e522f3d127$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$d289d6e522f3d127$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$d289d6e522f3d127$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$d289d6e522f3d127$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$d289d6e522f3d127$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$d289d6e522f3d127$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$d289d6e522f3d127$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$d289d6e522f3d127$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$d289d6e522f3d127$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$d289d6e522f3d127$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$d289d6e522f3d127$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$d289d6e522f3d127$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$d289d6e522f3d127$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$d289d6e522f3d127$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$d289d6e522f3d127$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$d289d6e522f3d127$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$d289d6e522f3d127$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$d289d6e522f3d127$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$d289d6e522f3d127$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$d289d6e522f3d127$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$d289d6e522f3d127$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$d289d6e522f3d127$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$d289d6e522f3d127$export$36c2547c3c4d823f]: "Attempted to sign a transaction with an address that is not a signer for it",
    [$d289d6e522f3d127$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$d289d6e522f3d127$export$de92784c954d1b84]: "Transaction has no expected signers therefore it cannot be encoded",
    [$d289d6e522f3d127$export$980469bdb5d5bd4f]: "Transaction size $transactionSize exceeds limit of $transactionSizeLimit bytes",
    [$d289d6e522f3d127$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$d289d6e522f3d127$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$d289d6e522f3d127$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$d289d6e522f3d127$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$d289d6e522f3d127$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$d289d6e522f3d127$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$d289d6e522f3d127$export$4e4582c633fc423e]: "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more",
    [$d289d6e522f3d127$export$7a52a9f8bedc82c0]: "Failed to estimate the loaded accounts data size for this transaction message. The RPC did not return a `loadedAccountsDataSize` value from simulation. This value is required for version 1 transactions",
    [$d289d6e522f3d127$export$923893d5c076a47c]: "Transaction failed when it was simulated in order to estimate the compute unit consumption. The compute unit estimate provided is for a transaction that failed when simulated and may not be representative of the compute units this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$d289d6e522f3d127$export$7774c611982e038]: "Transaction failed when it was simulated in order to estimate its resource limits. The resource limit estimates provided are for a transaction that failed when simulated and may not be representative of the resources this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$d289d6e522f3d127$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$d289d6e522f3d127$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$d289d6e522f3d127$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$d289d6e522f3d127$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$d289d6e522f3d127$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$d289d6e522f3d127$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$d289d6e522f3d127$export$b55a3eb3d894ad9f]: "The transaction message expected the transaction to have $numRequiredSignatures signatures, got $signaturesLength.",
    [$d289d6e522f3d127$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$d289d6e522f3d127$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given",
    [$d289d6e522f3d127$export$8ff97fea1326b6e7]: "This version of Kit does not support decoding transactions with version $unsupportedVersion. The current max supported version is 1.",
    [$d289d6e522f3d127$export$204c62c0e8d2efcc]: "The transaction has a durable nonce lifetime (with nonce `$nonce`), but the nonce account address is in a lookup table. The lifetime constraint cannot be constructed without fetching the lookup tables for the transaction.",
    [$d289d6e522f3d127$export$ee92f61088a1066a]: "Invalid transaction config mask: $mask. Bits 0 and 1 must match (both set or both unset)",
    [$d289d6e522f3d127$export$102de27de91bf32b]: "Transaction message bytes are malformed: $messageBytes",
    [$d289d6e522f3d127$export$15d93ee95a0fbfee]: "Transaction message bytes are empty, so the transaction cannot be encoded",
    [$d289d6e522f3d127$export$4641ca456c9ac65a]: "Transaction bytes are empty, so no transaction can be decoded",
    [$d289d6e522f3d127$export$db5d0ad0319baeab]: "Transaction version 0 must be encoded with signatures first. This transaction was encoded with first byte $firstByte, which is expected to be a signature count for v0 transactions.",
    [$d289d6e522f3d127$export$c94bf194991c6a40]: "The provided transaction bytes expect that there should be $numExpectedSignatures signatures, but the bytes are not long enough to contain a transaction message with this many signatures. The provided bytes are $transactionBytesLength bytes long.",
    [$d289d6e522f3d127$export$ce102cf7a4dc8c26]: "The transaction has a durable nonce lifetime, but the nonce account index is invalid. Expected a nonce account index less than $numberOfStaticAccounts, got $nonceAccountIndex.",
    [$d289d6e522f3d127$export$bb954aa95380cc07]: "The transaction config value for $configName has the incorrect kind. Expected $expectedKind, got $actualKind.",
    [$d289d6e522f3d127$export$70cf12a7af68a7bb]: "The transaction does not have the same number of instruction headers and instruction payloads. Got $numInstructionHeaders instruction headers, and $numInstructionPayloads instruction payloads.",
    [$d289d6e522f3d127$export$3da8c24b63df7026]: "Transaction has $actualCount unique signer addresses but the maximum allowed is $maxAllowed",
    [$d289d6e522f3d127$export$24ca3e569f030a48]: "Transaction has $actualCount unique account addresses but the maximum allowed is $maxAllowed",
    [$d289d6e522f3d127$export$7d52b2fdc6c6f4fd]: "Transaction has $actualCount instructions but the maximum allowed is $maxAllowed",
    [$d289d6e522f3d127$export$d463b452862201a4]: "The instruction at index $instructionIndex has $actualCount account references but the maximum allowed is $maxAllowed",
    [$d289d6e522f3d127$export$a0d8e792371f738d]: "Could not find an account address at index $index while decompiling an instruction",
    [$d289d6e522f3d127$export$a05704ad9908bda9]: "`getTransaction` responses fetched with `encoding: 'jsonParsed'` cannot be decoded. Re-fetch the transaction with `encoding: 'base64'`, `'base58'`, or `'json'`",
    [$d289d6e522f3d127$export$302ce5f895eb18ab]: "Could not recognize the shape of this `getTransaction` response. Expected a response fetched with `encoding: 'base64'`, `'base58'`, or `'json'`",
    [$d289d6e522f3d127$export$53a95e64cc3268a]: "`$hookName` requires the following capabilities to be installed on the client: [$capabilities]. $providerHint",
    [$d289d6e522f3d127$export$100e4d6784b74743]: "`$hookName` was called outside of a `ClientProvider`. Mount a `<ClientProvider client={client}>` in the ancestor tree.",
    [$d289d6e522f3d127$export$ece10101ca3fdef]: "The subscription closed in an error state but did not report an error.",
    [$d289d6e522f3d127$export$eff143d04ba1c763]: "Cannot $operation: no wallet connected",
    [$d289d6e522f3d127$export$c312471e35f2eb26]: "No signing wallet connected (status: $status)",
    [$d289d6e522f3d127$export$199c235749811d11]: "Connected wallet does not support signing",
    [$d289d6e522f3d127$export$26183083c720a8a4]: 'Account $address is not available in wallet "$walletName"'
};
// src/message-formatter.ts
var $d289d6e522f3d127$var$INSTRUCTION_ERROR_RANGE_SIZE = 1e3;
var $d289d6e522f3d127$var$START_INDEX = "i";
var $d289d6e522f3d127$var$TYPE = "t";
function $d289d6e522f3d127$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $d289d6e522f3d127$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    let state;
    function commitStateUpTo(endIndex) {
        if (state[$d289d6e522f3d127$var$TYPE] === 2 /* Variable */ ) {
            const variableName = messageFormatString.slice(state[$d289d6e522f3d127$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${context[variableName]}` : `$${variableName}`);
        } else if (state[$d289d6e522f3d127$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$d289d6e522f3d127$var$START_INDEX], endIndex));
    }
    const fragments = [];
    messageFormatString.split("").forEach((char, ii)=>{
        if (ii === 0) {
            state = {
                [$d289d6e522f3d127$var$START_INDEX]: 0,
                [$d289d6e522f3d127$var$TYPE]: messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ 
            };
            return;
        }
        let nextState;
        switch(state[$d289d6e522f3d127$var$TYPE]){
            case 0 /* EscapeSequence */ :
                nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 1 /* Text */ 
                };
                break;
            case 1 /* Text */ :
                if (char === "\\") nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 2 /* Variable */ 
                };
                break;
            case 2 /* Variable */ :
                if (char === "\\") nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 2 /* Variable */ 
                };
                else if (!char.match(/\w/)) nextState = {
                    [$d289d6e522f3d127$var$START_INDEX]: ii,
                    [$d289d6e522f3d127$var$TYPE]: 1 /* Text */ 
                };
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    let message = fragments.join("");
    if (code >= $d289d6e522f3d127$export$d308cb6df5c28ff6 && code < $d289d6e522f3d127$export$d308cb6df5c28ff6 + $d289d6e522f3d127$var$INSTRUCTION_ERROR_RANGE_SIZE && "index" in context) message += ` (instruction #${context.index + 1})`;
    return message;
}
function $d289d6e522f3d127$var$getErrorMessage(code, context = {}) {
    {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode -- ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` '${$d289d6e522f3d127$var$encodeContextObject(context)}'`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $d289d6e522f3d127$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $d289d6e522f3d127$export$8349fd9adaaed269 = class extends Error {
    /**
   * Indicates the root cause of this {@link SolanaError}, if any.
   *
   * For example, a transaction error might have an instruction error as its root cause. In this
   * case, you will be able to access the instruction error on the transaction error as `cause`.
   */ cause = this.cause;
    /**
   * Contains context that can assist in understanding or recovering from a {@link SolanaError}.
   */ context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) Object.entries(Object.getOwnPropertyDescriptors(contextAndErrorOptions)).forEach(([name, descriptor])=>{
            if (name === "cause") errorOptions = {
                cause: descriptor.value
            };
            else {
                if (context === void 0) context = {
                    __code: code
                };
                Object.defineProperty(context, name, descriptor);
            }
        });
        const message = $d289d6e522f3d127$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = Object.freeze(context === void 0 ? {
            __code: code
        } : context);
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $d289d6e522f3d127$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $d289d6e522f3d127$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $d289d6e522f3d127$export$8349fd9adaaed269(errorCode, errorContext);
    $d289d6e522f3d127$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $d289d6e522f3d127$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/solana-sdk/blob/master/instruction-error/src/lib.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $d289d6e522f3d127$export$4e38d43e41953f9e(index, instructionError) {
    const numberIndex = Number(index);
    return $d289d6e522f3d127$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $d289d6e522f3d127$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: numberIndex,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $d289d6e522f3d127$export$5abe2d1d040bf6cf) return {
                code: Number(rpcErrorContext),
                index: numberIndex
            };
            return {
                index: numberIndex
            };
        },
        orderedErrorNames: $d289d6e522f3d127$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $d289d6e522f3d127$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $d289d6e522f3d127$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $d289d6e522f3d127$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $d289d6e522f3d127$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $d289d6e522f3d127$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $d289d6e522f3d127$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $d289d6e522f3d127$export$e3a4007020a2e8f5) return {
                index: Number(rpcErrorContext)
            };
            else if (errorCode === $d289d6e522f3d127$export$2ecc275dffbc087c || errorCode === $d289d6e522f3d127$export$1cd0de5dfcdeb99d) return {
                accountIndex: Number(rpcErrorContext.account_index)
            };
        },
        orderedErrorNames: $d289d6e522f3d127$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $d289d6e522f3d127$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $d289d6e522f3d127$export$1f67f8d128316a6d(putativeErrorResponse) {
    let out;
    if ($d289d6e522f3d127$var$isRpcErrorResponse(putativeErrorResponse)) {
        const { code: rawCode, data: data, message: message } = putativeErrorResponse;
        const code = Number(rawCode);
        if (code === $d289d6e522f3d127$export$426cc73f5ad00f38) {
            const { err: err, ...preflightErrorContext } = data;
            const causeObject = err ? {
                cause: $d289d6e522f3d127$export$c10ce7a2fd9c66f0(err)
            } : null;
            out = new $d289d6e522f3d127$export$8349fd9adaaed269($d289d6e522f3d127$export$426cc73f5ad00f38, {
                ...preflightErrorContext,
                ...causeObject
            });
        } else {
            let errorContext;
            switch(code){
                case $d289d6e522f3d127$export$afa40fd3fc01204:
                case $d289d6e522f3d127$export$2981978a530b1a7c:
                case $d289d6e522f3d127$export$23cb4efd59427895:
                case $d289d6e522f3d127$export$5ec955cc8b7e8cf9:
                case $d289d6e522f3d127$export$e09e3905081e44fe:
                case $d289d6e522f3d127$export$1b90c411626421b1:
                case $d289d6e522f3d127$export$6ae475e85fe02aad:
                case $d289d6e522f3d127$export$bfbf8b75e865efa0:
                case $d289d6e522f3d127$export$65235469ebe9845e:
                case $d289d6e522f3d127$export$8dfce16ef39ea58c:
                case $d289d6e522f3d127$export$54dea2286c43ec1e:
                case $d289d6e522f3d127$export$e71fbee92648fc61:
                case $d289d6e522f3d127$export$d21075fd06730e:
                case $d289d6e522f3d127$export$d964b43bb02eacdf:
                case $d289d6e522f3d127$export$f7685139153f9191:
                    errorContext = {
                        __serverMessage: message
                    };
                    break;
                default:
                    if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
            }
            out = new $d289d6e522f3d127$export$8349fd9adaaed269(code, errorContext);
        }
    } else {
        const message = typeof putativeErrorResponse === "object" && putativeErrorResponse !== null && "message" in putativeErrorResponse && typeof putativeErrorResponse.message === "string" ? putativeErrorResponse.message : "Malformed JSON-RPC error with no message attribute";
        out = new $d289d6e522f3d127$export$8349fd9adaaed269($d289d6e522f3d127$export$1cf7bba40d7d2361, {
            error: putativeErrorResponse,
            message: message
        });
    }
    $d289d6e522f3d127$export$4608fd6508cb51(out, $d289d6e522f3d127$export$1f67f8d128316a6d);
    return out;
}
function $d289d6e522f3d127$var$isRpcErrorResponse(value) {
    return typeof value === "object" && value !== null && "code" in value && "message" in value && (typeof value.code === "number" || typeof value.code === "bigint") && typeof value.message === "string";
}
// src/simulation-errors.ts
function $d289d6e522f3d127$export$ddd98780b31b44b0(error) {
    const simulationCodes = [
        $d289d6e522f3d127$export$426cc73f5ad00f38,
        $d289d6e522f3d127$export$923893d5c076a47c,
        $d289d6e522f3d127$export$7774c611982e038
    ];
    if ($d289d6e522f3d127$export$cfead212e52d9961(error) && !!error.cause && simulationCodes.includes(error.context.__code)) return error.cause;
    return error;
}
 //# sourceMappingURL=index.browser.mjs.map



// src/add-codec-sentinel.ts
// src/bytes.ts
var $fbcf8ca8805b5da2$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
function $fbcf8ca8805b5da2$export$4c6b868113605df3(bytes, length) {
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
}
var $fbcf8ca8805b5da2$export$11b3146a4f4702ef = (bytes, length)=>$fbcf8ca8805b5da2$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $fbcf8ca8805b5da2$export$1b62aef2a79e6b21(data, bytes, offset) {
    const slice = (offset === 0 || offset <= -data.byteLength) && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    return $fbcf8ca8805b5da2$export$c663ab80cce302c5(slice, bytes);
}
function $fbcf8ca8805b5da2$export$c663ab80cce302c5(bytes1, bytes2) {
    return bytes1.length === bytes2.length && bytes1.every((value, index)=>value === bytes2[index]);
}
function $fbcf8ca8805b5da2$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $fbcf8ca8805b5da2$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($fbcf8ca8805b5da2$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $fbcf8ca8805b5da2$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $fbcf8ca8805b5da2$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($fbcf8ca8805b5da2$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $fbcf8ca8805b5da2$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $fbcf8ca8805b5da2$export$4e85b7423fd6bc55(codec) {
    if (!$fbcf8ca8805b5da2$export$f9d60229c95384d4(codec)) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$93561b31b951410d));
}
function $fbcf8ca8805b5da2$export$d76fd0b6e42f051a(codec) {
    return !$fbcf8ca8805b5da2$export$f9d60229c95384d4(codec);
}
function $fbcf8ca8805b5da2$export$6bf5fc425e413c8a(codec) {
    if (!$fbcf8ca8805b5da2$export$d76fd0b6e42f051a(codec)) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$3417da5bc6bcb45));
}
function $fbcf8ca8805b5da2$export$b88681b853abde79(encoder, decoder) {
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder) !== $fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder)) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$c4c73ab3c0833591));
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder) && $fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder) && !$fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/add-codec-sentinel.ts
function $fbcf8ca8805b5da2$export$e98b1308839de22(encoder, sentinel) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        if ($fbcf8ca8805b5da2$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$a9282ed13660c9f6), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $fbcf8ca8805b5da2$var$hexBytes(encoderBytes),
            hexSentinel: $fbcf8ca8805b5da2$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder)) return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    });
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        ...encoder.maxSize != null ? {
            maxSize: encoder.maxSize + sentinel.length
        } : {},
        getSizeFromValue: (value)=>encoder.getSizeFromValue(value) + sentinel.length,
        write: write
    });
}
function $fbcf8ca8805b5da2$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    const read = (bytes, offset)=>{
        const candidateBytes = offset === 0 || offset <= -bytes.byteLength ? bytes : bytes.slice(offset);
        const sentinelIndex = $fbcf8ca8805b5da2$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$5bdfee6423bc35ce), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $fbcf8ca8805b5da2$var$hexBytes(candidateBytes),
            hexSentinel: $fbcf8ca8805b5da2$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        const preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder)) return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    });
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        ...decoder.maxSize != null ? {
            maxSize: decoder.maxSize + sentinel.length
        } : {},
        read: read
    });
}
function $fbcf8ca8805b5da2$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$e98b1308839de22(codec, sentinel), $fbcf8ca8805b5da2$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $fbcf8ca8805b5da2$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex((byte, index, arr)=>{
        if (sentinel.length === 1) return byte === sentinel[0];
        return $fbcf8ca8805b5da2$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $fbcf8ca8805b5da2$var$hexBytes(bytes) {
    return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
}
function $fbcf8ca8805b5da2$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $fbcf8ca8805b5da2$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $fbcf8ca8805b5da2$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $fbcf8ca8805b5da2$export$37e5b12cb5a8d560(encoder, prefix) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(prefix) && $fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder)) return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    });
    const prefixMaxSize = $fbcf8ca8805b5da2$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const encoderMaxSize = $fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : encoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (value)=>{
            const encoderSize = $fbcf8ca8805b5da2$export$30f3257599397621(value, encoder);
            return $fbcf8ca8805b5da2$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    });
}
function $fbcf8ca8805b5da2$export$fe2b33c81523b294(decoder, prefix) {
    const read = (bytes, offset)=>{
        const [bigintSize, decoderOffset] = prefix.read(bytes, offset);
        const size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $fbcf8ca8805b5da2$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(prefix) && $fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder)) return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    });
    const prefixMaxSize = $fbcf8ca8805b5da2$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const decoderMaxSize = $fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : decoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $fbcf8ca8805b5da2$export$ec85c1caba397ab2(codec, prefix) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$37e5b12cb5a8d560(codec, prefix), $fbcf8ca8805b5da2$export$fe2b33c81523b294(codec, prefix));
}
// src/array-buffers.ts
function $fbcf8ca8805b5da2$export$8b22b05f429b130c(bytes, offset, length) {
    const bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    let buffer;
    if (typeof SharedArrayBuffer === "undefined") buffer = bytes.buffer;
    else if (bytes.buffer instanceof SharedArrayBuffer) {
        buffer = new ArrayBuffer(bytes.length);
        new Uint8Array(buffer).set(new Uint8Array(bytes));
    } else buffer = bytes.buffer;
    return (bytesOffset === 0 || bytesOffset === -bytes.byteLength) && bytesLength === bytes.byteLength ? buffer : buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
function $fbcf8ca8805b5da2$export$9fde90fcc5ed41ea(decoder) {
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        read (bytes, offset) {
            const [value, newOffset] = decoder.read(bytes, offset);
            if (bytes.length > newOffset) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$11a7243580452ad8), {
                expectedLength: newOffset,
                numExcessBytes: bytes.length - newOffset
            });
            return [
                value,
                newOffset
            ];
        }
    });
}
// src/fix-codec-size.ts
function $fbcf8ca8805b5da2$export$cbdfce031443a1(encoder, fixedBytes) {
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $fbcf8ca8805b5da2$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $fbcf8ca8805b5da2$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder)) bytes = $fbcf8ca8805b5da2$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $fbcf8ca8805b5da2$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$cbdfce031443a1(codec, fixedBytes), $fbcf8ca8805b5da2$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $fbcf8ca8805b5da2$export$92407871fbff8926(encoder, config) {
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$fbcf8ca8805b5da2$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $fbcf8ca8805b5da2$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $fbcf8ca8805b5da2$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $fbcf8ca8805b5da2$export$24667feddece166a(decoder, config) {
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$fbcf8ca8805b5da2$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $fbcf8ca8805b5da2$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $fbcf8ca8805b5da2$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $fbcf8ca8805b5da2$export$8170ddca0f3f53ea(codec, config) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$92407871fbff8926(codec, config), $fbcf8ca8805b5da2$export$24667feddece166a(codec, config));
}
function $fbcf8ca8805b5da2$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $fbcf8ca8805b5da2$export$d41c2ca858573bc6(encoder, resize) {
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $fbcf8ca8805b5da2$export$7369e12a03366140(decoder, resize) {
    if ($fbcf8ca8805b5da2$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $fbcf8ca8805b5da2$export$aff234b7657ae683(codec, resize) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$d41c2ca858573bc6(codec, resize), $fbcf8ca8805b5da2$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $fbcf8ca8805b5da2$export$66b1746799cd3030(encoder, offset) {
    return $fbcf8ca8805b5da2$export$92407871fbff8926($fbcf8ca8805b5da2$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $fbcf8ca8805b5da2$export$770586d1e6f1e5b(encoder, offset) {
    return $fbcf8ca8805b5da2$export$92407871fbff8926($fbcf8ca8805b5da2$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $fbcf8ca8805b5da2$export$d88f5bbaa5c2e177(decoder, offset) {
    return $fbcf8ca8805b5da2$export$24667feddece166a($fbcf8ca8805b5da2$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $fbcf8ca8805b5da2$export$57a7baba87e0aed9(decoder, offset) {
    return $fbcf8ca8805b5da2$export$24667feddece166a($fbcf8ca8805b5da2$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $fbcf8ca8805b5da2$export$d6ed5bbf596a5505(codec, offset) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$66b1746799cd3030(codec, offset), $fbcf8ca8805b5da2$export$d88f5bbaa5c2e177(codec, offset));
}
function $fbcf8ca8805b5da2$export$b11ce69168faaa31(codec, offset) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$770586d1e6f1e5b(codec, offset), $fbcf8ca8805b5da2$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $fbcf8ca8805b5da2$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength, targetOffset = 0) {
    while(sourceOffset < --sourceLength){
        const leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $fbcf8ca8805b5da2$export$290b4b66fdcc682c(encoder) {
    $fbcf8ca8805b5da2$export$4e85b7423fd6bc55(encoder);
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            $fbcf8ca8805b5da2$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    });
}
function $fbcf8ca8805b5da2$export$1dded7e9fb3087ff(decoder) {
    $fbcf8ca8805b5da2$export$4e85b7423fd6bc55(decoder);
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reversedBytes = bytes.slice();
            $fbcf8ca8805b5da2$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $fbcf8ca8805b5da2$export$e1ef688f83355e2e(codec) {
    return $fbcf8ca8805b5da2$export$b88681b853abde79($fbcf8ca8805b5da2$export$290b4b66fdcc682c(codec), $fbcf8ca8805b5da2$export$1dded7e9fb3087ff(codec));
}
// src/transform-codec.ts
function $fbcf8ca8805b5da2$export$30169aca64409a56(encoder, unmap) {
    return $fbcf8ca8805b5da2$export$4e76eeb6df88c889({
        ...$fbcf8ca8805b5da2$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $fbcf8ca8805b5da2$export$605b10ee38669daa(decoder, map) {
    return $fbcf8ca8805b5da2$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $fbcf8ca8805b5da2$export$59b20038bbe52b5f(codec, unmap, map) {
    return $fbcf8ca8805b5da2$export$a4cf2f585987cc8({
        ...$fbcf8ca8805b5da2$export$30169aca64409a56(codec, unmap),
        read: map ? $fbcf8ca8805b5da2$export$605b10ee38669daa(codec, map).read : codec.read
    });
}
 //# sourceMappingURL=index.browser.mjs.map


// src/assertions.ts
function $9cdecb384b3c2c43$export$d81fb78fd5af226e(alphabet4, testValue, givenValue = testValue) {
    if (!testValue.match(new RegExp(`^[${alphabet4}]*$`))) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$89b582b06852d433), {
        alphabet: alphabet4,
        base: alphabet4.length,
        value: givenValue
    });
}
var $9cdecb384b3c2c43$export$604e39a60e9aaee6 = (alphabet4)=>{
    return (0, $fbcf8ca8805b5da2$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            const [leadingZeroes, tailChars] = $9cdecb384b3c2c43$var$partitionLeadingZeroes(value, alphabet4[0]);
            if (!tailChars) return value.length;
            const base10Number = $9cdecb384b3c2c43$var$getBigIntFromBaseX(tailChars, alphabet4);
            return leadingZeroes.length + Math.ceil(base10Number.toString(16).length / 2);
        },
        write (value, bytes, offset) {
            $9cdecb384b3c2c43$export$d81fb78fd5af226e(alphabet4, value);
            if (value === "") return offset;
            const [leadingZeroes, tailChars] = $9cdecb384b3c2c43$var$partitionLeadingZeroes(value, alphabet4[0]);
            if (!tailChars) {
                bytes.set(new Uint8Array(leadingZeroes.length).fill(0), offset);
                return offset + leadingZeroes.length;
            }
            let base10Number = $9cdecb384b3c2c43$var$getBigIntFromBaseX(tailChars, alphabet4);
            const tailBytes = [];
            while(base10Number > 0n){
                tailBytes.unshift(Number(base10Number % 256n));
                base10Number /= 256n;
            }
            const bytesToAdd = [
                ...Array(leadingZeroes.length).fill(0),
                ...tailBytes
            ];
            bytes.set(bytesToAdd, offset);
            return offset + bytesToAdd.length;
        }
    });
};
var $9cdecb384b3c2c43$export$4637bf000c106942 = (alphabet4)=>{
    return (0, $fbcf8ca8805b5da2$export$f8c898e83b60faaa)({
        read (rawBytes, offset) {
            const bytes = offset === 0 || offset <= -rawBytes.byteLength ? rawBytes : rawBytes.slice(offset);
            if (bytes.length === 0) return [
                "",
                rawBytes.length
            ];
            let trailIndex = bytes.findIndex((n)=>n !== 0);
            trailIndex = trailIndex === -1 ? bytes.length : trailIndex;
            const leadingZeroes = alphabet4[0].repeat(trailIndex);
            if (trailIndex === bytes.length) return [
                leadingZeroes,
                rawBytes.length
            ];
            const base10Number = bytes.slice(trailIndex).reduce((sum, byte)=>sum * 256n + BigInt(byte), 0n);
            const tailChars = $9cdecb384b3c2c43$var$getBaseXFromBigInt(base10Number, alphabet4);
            return [
                leadingZeroes + tailChars,
                rawBytes.length
            ];
        }
    });
};
var $9cdecb384b3c2c43$export$fb7555f212ab1005 = (alphabet4)=>(0, $fbcf8ca8805b5da2$export$b88681b853abde79)($9cdecb384b3c2c43$export$604e39a60e9aaee6(alphabet4), $9cdecb384b3c2c43$export$4637bf000c106942(alphabet4));
function $9cdecb384b3c2c43$var$partitionLeadingZeroes(value, zeroCharacter) {
    const [leadingZeros, tailChars] = value.split(new RegExp(`((?!${zeroCharacter}).*)`));
    return [
        leadingZeros,
        tailChars
    ];
}
function $9cdecb384b3c2c43$var$getBigIntFromBaseX(value, alphabet4) {
    const base = BigInt(alphabet4.length);
    let sum = 0n;
    for (const char of value){
        sum *= base;
        sum += BigInt(alphabet4.indexOf(char));
    }
    return sum;
}
function $9cdecb384b3c2c43$var$getBaseXFromBigInt(value, alphabet4) {
    const base = BigInt(alphabet4.length);
    const tailChars = [];
    while(value > 0n){
        tailChars.unshift(alphabet4[Number(value % base)]);
        value /= base;
    }
    return tailChars.join("");
}
// src/base10.ts
var $9cdecb384b3c2c43$var$alphabet = "0123456789";
var $9cdecb384b3c2c43$export$2c0b6b55e979e1c1 = ()=>$9cdecb384b3c2c43$export$604e39a60e9aaee6($9cdecb384b3c2c43$var$alphabet);
var $9cdecb384b3c2c43$export$f430205c15d46a26 = ()=>$9cdecb384b3c2c43$export$4637bf000c106942($9cdecb384b3c2c43$var$alphabet);
var $9cdecb384b3c2c43$export$582e4cb05e79b066 = ()=>$9cdecb384b3c2c43$export$fb7555f212ab1005($9cdecb384b3c2c43$var$alphabet);
var $9cdecb384b3c2c43$var$INVALID_STRING_ERROR_BASE_CONFIG = {
    alphabet: "0123456789abcdef",
    base: 16
};
function $9cdecb384b3c2c43$var$charCodeToBase16(char) {
    if (char >= 48 /* ZERO */  && char <= 57 /* NINE */ ) return char - 48 /* ZERO */ ;
    if (char >= 65 /* A_UP */  && char <= 70 /* F_UP */ ) return char - 55;
    if (char >= 97 /* A_LO */  && char <= 102 /* F_LO */ ) return char - 87;
}
var $9cdecb384b3c2c43$export$4e36ea5b8d948c7 = ()=>(0, $fbcf8ca8805b5da2$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>Math.ceil(value.length / 2),
        write (value, bytes, offset) {
            const len = value.length;
            const al = len / 2;
            if (len === 1) {
                const c = value.charCodeAt(0);
                const n = $9cdecb384b3c2c43$var$charCodeToBase16(c);
                if (n === void 0) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$89b582b06852d433), {
                    ...$9cdecb384b3c2c43$var$INVALID_STRING_ERROR_BASE_CONFIG,
                    value: value
                });
                bytes.set([
                    n
                ], offset);
                return 1 + offset;
            }
            const hexBytes = new Uint8Array(al);
            for(let i = 0, j = 0; i < al; i++){
                const c1 = value.charCodeAt(j++);
                const c2 = value.charCodeAt(j++);
                const n1 = $9cdecb384b3c2c43$var$charCodeToBase16(c1);
                const n2 = $9cdecb384b3c2c43$var$charCodeToBase16(c2);
                if (n1 === void 0 || n2 === void 0 && !Number.isNaN(c2)) throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$89b582b06852d433), {
                    ...$9cdecb384b3c2c43$var$INVALID_STRING_ERROR_BASE_CONFIG,
                    value: value
                });
                hexBytes[i] = !Number.isNaN(c2) ? n1 << 4 | (n2 ?? 0) : n1;
            }
            bytes.set(hexBytes, offset);
            return hexBytes.length + offset;
        }
    });
var $9cdecb384b3c2c43$export$a8743d71ec78d9cd = ()=>(0, $fbcf8ca8805b5da2$export$f8c898e83b60faaa)({
        read (bytes, offset) {
            const value = bytes.slice(offset).reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
            return [
                value,
                bytes.length
            ];
        }
    });
var $9cdecb384b3c2c43$export$38b0279df5920b98 = ()=>(0, $fbcf8ca8805b5da2$export$b88681b853abde79)($9cdecb384b3c2c43$export$4e36ea5b8d948c7(), $9cdecb384b3c2c43$export$a8743d71ec78d9cd());
// src/base58.ts
var $9cdecb384b3c2c43$var$alphabet2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $9cdecb384b3c2c43$export$c9b1da42c197e8e5 = ()=>$9cdecb384b3c2c43$export$604e39a60e9aaee6($9cdecb384b3c2c43$var$alphabet2);
var $9cdecb384b3c2c43$export$81723918e05f84c7 = ()=>$9cdecb384b3c2c43$export$4637bf000c106942($9cdecb384b3c2c43$var$alphabet2);
var $9cdecb384b3c2c43$export$6edf7801eef2b1bb = ()=>$9cdecb384b3c2c43$export$fb7555f212ab1005($9cdecb384b3c2c43$var$alphabet2);
var $9cdecb384b3c2c43$export$72d35c538ba15ebf = (alphabet4, bits)=>(0, $fbcf8ca8805b5da2$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>Math.floor(value.length * bits / 8),
        write (value, bytes, offset) {
            $9cdecb384b3c2c43$export$d81fb78fd5af226e(alphabet4, value);
            if (value === "") return offset;
            const charIndices = [
                ...value
            ].map((c)=>alphabet4.indexOf(c));
            const reslicedBytes = $9cdecb384b3c2c43$var$reslice(charIndices, bits, 8, false);
            bytes.set(reslicedBytes, offset);
            return reslicedBytes.length + offset;
        }
    });
var $9cdecb384b3c2c43$export$ae1f0b87cf8eee1e = (alphabet4, bits)=>(0, $fbcf8ca8805b5da2$export$f8c898e83b60faaa)({
        read (rawBytes, offset = 0) {
            const bytes = offset === 0 || offset <= -rawBytes.byteLength ? rawBytes : rawBytes.slice(offset);
            if (bytes.length === 0) return [
                "",
                rawBytes.length
            ];
            const charIndices = $9cdecb384b3c2c43$var$reslice([
                ...bytes
            ], 8, bits, true);
            return [
                charIndices.map((i)=>alphabet4[i]).join(""),
                rawBytes.length
            ];
        }
    });
var $9cdecb384b3c2c43$export$d828ca4fa0b3e3bb = (alphabet4, bits)=>(0, $fbcf8ca8805b5da2$export$b88681b853abde79)($9cdecb384b3c2c43$export$72d35c538ba15ebf(alphabet4, bits), $9cdecb384b3c2c43$export$ae1f0b87cf8eee1e(alphabet4, bits));
function $9cdecb384b3c2c43$var$reslice(input, inputBits, outputBits, useRemainder) {
    const output = [];
    let accumulator = 0;
    let bitsInAccumulator = 0;
    const mask = (1 << outputBits) - 1;
    for (const value of input){
        accumulator = accumulator << inputBits | value;
        bitsInAccumulator += inputBits;
        while(bitsInAccumulator >= outputBits){
            bitsInAccumulator -= outputBits;
            output.push(accumulator >> bitsInAccumulator & mask);
        }
    }
    if (useRemainder && bitsInAccumulator > 0) output.push(accumulator << outputBits - bitsInAccumulator & mask);
    return output;
}
// src/base64.ts
var $9cdecb384b3c2c43$var$alphabet3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $9cdecb384b3c2c43$export$7a87b201ca045431 = ()=>{
    return (0, $fbcf8ca8805b5da2$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            try {
                return atob(value).length;
            } catch  {
                throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$89b582b06852d433), {
                    alphabet: $9cdecb384b3c2c43$var$alphabet3,
                    base: 64,
                    value: value
                });
            }
        },
        write (value, bytes, offset) {
            try {
                const bytesToAdd = atob(value).split("").map((c)=>c.charCodeAt(0));
                bytes.set(bytesToAdd, offset);
                return bytesToAdd.length + offset;
            } catch  {
                throw new (0, $d289d6e522f3d127$export$8349fd9adaaed269)((0, $d289d6e522f3d127$export$89b582b06852d433), {
                    alphabet: $9cdecb384b3c2c43$var$alphabet3,
                    base: 64,
                    value: value
                });
            }
        }
    });
};
var $9cdecb384b3c2c43$export$ee20ac553cec1cb2 = ()=>{
    return (0, $fbcf8ca8805b5da2$export$f8c898e83b60faaa)({
        read (bytes, offset = 0) {
            const slice = bytes.slice(offset);
            const value = btoa(String.fromCharCode(...slice));
            return [
                value,
                bytes.length
            ];
        }
    });
};
var $9cdecb384b3c2c43$export$90e6baef93ad018a = ()=>(0, $fbcf8ca8805b5da2$export$b88681b853abde79)($9cdecb384b3c2c43$export$7a87b201ca045431(), $9cdecb384b3c2c43$export$ee20ac553cec1cb2());
// src/null-characters.ts
var $9cdecb384b3c2c43$export$33e68217e0ffdbfd = (value)=>// eslint-disable-next-line no-control-regex
    value.replace(/\u0000/g, "");
var $9cdecb384b3c2c43$export$f9f4f744d6dfac88 = (value, chars)=>value.padEnd(chars, "\0");
// ../text-encoding-impl/dist/index.browser.mjs
var $9cdecb384b3c2c43$var$e = globalThis.TextDecoder;
var $9cdecb384b3c2c43$var$o = globalThis.TextEncoder;
// src/utf8.ts
var $9cdecb384b3c2c43$export$9a335ef9e29610a7 = ()=>{
    let textEncoder;
    return (0, $fbcf8ca8805b5da2$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>(textEncoder ||= new $9cdecb384b3c2c43$var$o()).encode(value).length,
        write: (value, bytes, offset)=>{
            const bytesToAdd = (textEncoder ||= new $9cdecb384b3c2c43$var$o()).encode(value);
            bytes.set(bytesToAdd, offset);
            return offset + bytesToAdd.length;
        }
    });
};
var $9cdecb384b3c2c43$export$3cdd8a41d7d6b55d = ()=>{
    let textDecoder;
    return (0, $fbcf8ca8805b5da2$export$f8c898e83b60faaa)({
        read (bytes, offset) {
            const value = (textDecoder ||= new $9cdecb384b3c2c43$var$e()).decode(bytes.slice(offset));
            return [
                $9cdecb384b3c2c43$export$33e68217e0ffdbfd(value),
                bytes.length
            ];
        }
    });
};
var $9cdecb384b3c2c43$export$7c78620cf2c2b679 = ()=>(0, $fbcf8ca8805b5da2$export$b88681b853abde79)($9cdecb384b3c2c43$export$9a335ef9e29610a7(), $9cdecb384b3c2c43$export$3cdd8a41d7d6b55d());
 //# sourceMappingURL=index.browser.mjs.map


//#region src/base64Utils.ts
function $f97c98ce9ab46f75$export$2d1720544b23b823(input) {
    return (0, $9cdecb384b3c2c43$export$ee20ac553cec1cb2)().decode((0, $9cdecb384b3c2c43$export$9a335ef9e29610a7)().encode(input));
}
function $f97c98ce9ab46f75$export$ffb5f4729a158638(byteArray, urlsafe) {
    const base64 = (0, $9cdecb384b3c2c43$export$ee20ac553cec1cb2)().decode(byteArray);
    if (urlsafe) return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    else return base64;
}
function $f97c98ce9ab46f75$export$953cecd6e717a553(base64EncodedByteArray) {
    return (0, $9cdecb384b3c2c43$export$7a87b201ca045431)().encode(base64EncodedByteArray);
}
//#endregion
//#region src/base58Utils.ts
function $f97c98ce9ab46f75$var$fromUint8Array(byteArray) {
    return (0, $9cdecb384b3c2c43$export$81723918e05f84c7)().decode(byteArray);
}
function $f97c98ce9ab46f75$var$toUint8Array(base58EncodedByteArray) {
    return (0, $9cdecb384b3c2c43$export$c9b1da42c197e8e5)().encode(base58EncodedByteArray);
}
function $f97c98ce9ab46f75$export$4368d992c4eafac0(base64EncodedString) {
    return $f97c98ce9ab46f75$var$fromUint8Array($f97c98ce9ab46f75$export$953cecd6e717a553(base64EncodedString));
}
//#endregion
//#region src/arrayBufferToBase64String.ts
function $f97c98ce9ab46f75$export$3b14a55fb2447963(buffer) {
    return $f97c98ce9ab46f75$export$ffb5f4729a158638(new Uint8Array(buffer));
}
//#endregion
//#region src/encoding.ts
function $f97c98ce9ab46f75$export$625550452a3fa3ec(byteArray) {
    return $f97c98ce9ab46f75$var$fromUint8Array(byteArray);
}
function $f97c98ce9ab46f75$export$7ccc53e8f1e7dfc5(base58EncodedByteArray) {
    return $f97c98ce9ab46f75$var$toUint8Array(base58EncodedByteArray);
}
function $f97c98ce9ab46f75$export$43caf9889c228507(input) {
    return $f97c98ce9ab46f75$export$2d1720544b23b823(input);
}
function $f97c98ce9ab46f75$export$23f2a1d2818174ef(byteArray) {
    return $f97c98ce9ab46f75$export$ffb5f4729a158638(byteArray);
}
function $f97c98ce9ab46f75$export$407448d2b89b1813(base64EncodedString) {
    return $f97c98ce9ab46f75$export$4368d992c4eafac0(base64EncodedString);
}
function $f97c98ce9ab46f75$export$ae1af26003f05816(base64EncodedByteArray) {
    return $f97c98ce9ab46f75$export$953cecd6e717a553(base64EncodedByteArray);
}
function $f97c98ce9ab46f75$export$2408f22a0fab9ae5(byteArray) {
    return $f97c98ce9ab46f75$export$ffb5f4729a158638(byteArray, true);
}
function $f97c98ce9ab46f75$export$db3b6bfb95261072(byteArray) {
    return (0, $9cdecb384b3c2c43$export$3cdd8a41d7d6b55d)().decode(byteArray);
}
function $f97c98ce9ab46f75$export$882b5998b3b9117c(input) {
    return (0, $9cdecb384b3c2c43$export$9a335ef9e29610a7)().encode(input);
}





/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $54a90126d2f96ce7$export$bba9a228295b3963 = 'solana:mainnet';
const $54a90126d2f96ce7$export$654cc095bd2e650 = 'solana:devnet';
const $54a90126d2f96ce7$export$76575b7bf4de1f40 = 'solana:testnet';
const $54a90126d2f96ce7$export$483699a75281444c = 'solana:localnet';
const $54a90126d2f96ce7$export$d77e7f94b1f6bf7d = [
    $54a90126d2f96ce7$export$bba9a228295b3963,
    $54a90126d2f96ce7$export$654cc095bd2e650,
    $54a90126d2f96ce7$export$76575b7bf4de1f40,
    $54a90126d2f96ce7$export$483699a75281444c
];
function $54a90126d2f96ce7$export$d8f86f4d3d9fc2b5(chain) {
    return $54a90126d2f96ce7$export$d77e7f94b1f6bf7d.includes(chain);
}


var $aff560f1983590b4$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $aff560f1983590b4$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $aff560f1983590b4$var$_RegisterWalletEvent_detail;
function $aff560f1983590b4$export$ecffa18c0543eceb(wallet) {
    const callback = ({ register: register })=>register(wallet);
    try {
        window.dispatchEvent(new $aff560f1983590b4$var$RegisterWalletEvent(callback));
    } catch (error) {
        console.error('wallet-standard:register-wallet event could not be dispatched\n', error);
    }
    try {
        window.addEventListener('wallet-standard:app-ready', ({ detail: api })=>callback(api));
    } catch (error) {
        console.error('wallet-standard:app-ready event listener could not be added\n', error);
    }
}
class $aff560f1983590b4$var$RegisterWalletEvent extends Event {
    get detail() {
        return $aff560f1983590b4$var$__classPrivateFieldGet(this, $aff560f1983590b4$var$_RegisterWalletEvent_detail, "f");
    }
    get type() {
        return 'wallet-standard:register-wallet';
    }
    constructor(callback){
        super('wallet-standard:register-wallet', {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $aff560f1983590b4$var$_RegisterWalletEvent_detail.set(this, void 0);
        $aff560f1983590b4$var$__classPrivateFieldSet(this, $aff560f1983590b4$var$_RegisterWalletEvent_detail, callback, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error('preventDefault cannot be called');
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error('stopImmediatePropagation cannot be called');
    }
    /** @deprecated */ stopPropagation() {
        throw new Error('stopPropagation cannot be called');
    }
}
$aff560f1983590b4$var$_RegisterWalletEvent_detail = new WeakMap();
function $aff560f1983590b4$export$2dd0e8edbdeb04ec(wallet) {
    var _a;
    $aff560f1983590b4$export$ecffa18c0543eceb(wallet);
    try {
        ((_a = window.navigator).wallets || (_a.wallets = [])).push(({ register: register })=>register(wallet));
    } catch (error) {
        console.error('window.navigator.wallets could not be pushed\n', error);
    }
}



/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out {@link https://www.rfc-editor.org/rfc/rfc4634 | RFC 4634} and
 * {@link https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf | FIPS 180-4}.
 * @module
 */ /**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ const $844bc8fa7cf06207$var$U32_MASK64 = /* @__PURE__ */ (()=>BigInt(2 ** 32 - 1))();
const $844bc8fa7cf06207$var$_32n = /* @__PURE__ */ BigInt(32);
// Split bigint into two 32-bit halves. With `le=true`, returned fields become `{ h: low, l: high
// }` to match little-endian word order rather than the property names.
function $844bc8fa7cf06207$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $844bc8fa7cf06207$var$U32_MASK64),
        l: Number(n >> $844bc8fa7cf06207$var$_32n & $844bc8fa7cf06207$var$U32_MASK64)
    };
    return {
        h: Number(n >> $844bc8fa7cf06207$var$_32n & $844bc8fa7cf06207$var$U32_MASK64) | 0,
        l: Number(n & $844bc8fa7cf06207$var$U32_MASK64) | 0
    };
}
// Split bigint list into `[highWords, lowWords]` when `le=false`; with `le=true`, the first array
// holds the low halves because `fromBig(...)` swaps the semantic meaning of `h` and `l`.
function $844bc8fa7cf06207$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $844bc8fa7cf06207$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
// Combine explicit `(high, low)` 32-bit halves into a bigint; `>>> 0` normalizes signed JS
// bitwise results back to uint32 first, and little-endian callers must swap.
const $844bc8fa7cf06207$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $844bc8fa7cf06207$var$_32n | BigInt(l >>> 0);
// Split a JS number into u32 halves without a BigInt allocation. Exact only for integers
// `0 <= n < 2**53`; callers use it on byte / bit counters, which JS length math caps far below
// that (an ArrayBuffer cannot exceed 2**53 - 1 bytes).
const $844bc8fa7cf06207$export$66f9cb10aa7fd285 = (n)=>n / 2 ** 32 | 0;
const $844bc8fa7cf06207$export$750dc5bcc38722de = (n)=>n >>> 0;
// Drop-in replacement for `view.setBigUint64(byteOffset, BigInt(n), isLE)` without the per-call
// BigInt allocation. Same `n < 2**53` precondition as `fromNumH`/`fromNumL`.
function $844bc8fa7cf06207$export$5cfb625c85abf059(view, byteOffset, n, isLE) {
    const h = $844bc8fa7cf06207$export$66f9cb10aa7fd285(n);
    const l = $844bc8fa7cf06207$export$750dc5bcc38722de(n);
    view.setUint32(byteOffset, isLE ? l : h, isLE);
    view.setUint32(byteOffset + 4, isLE ? h : l, isLE);
}
// High 32-bit half of a 64-bit logical right shift for `s` in `0..31`.
const $844bc8fa7cf06207$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
// Low 32-bit half of a 64-bit logical right shift, valid for `s` in `1..31`.
const $844bc8fa7cf06207$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// High 32-bit half of a 64-bit right rotate, valid for `s` in `1..31`.
const $844bc8fa7cf06207$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
// Low 32-bit half of a 64-bit right rotate, valid for `s` in `1..31`.
const $844bc8fa7cf06207$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// High 32-bit half of a 64-bit right rotate, valid for `s` in `33..63`; `32` uses `rotr32*`.
const $844bc8fa7cf06207$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
// Low 32-bit half of a 64-bit right rotate, valid for `s` in `33..63`; `32` uses `rotr32*`.
const $844bc8fa7cf06207$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// High 32-bit half of a 64-bit right rotate for `s === 32`; this is just the swapped low half.
const $844bc8fa7cf06207$export$a088d44bd387d2a3 = (_h, l)=>l;
// Low 32-bit half of a 64-bit right rotate for `s === 32`; this is just the swapped high half.
const $844bc8fa7cf06207$export$8415aae4d1f69577 = (h, _l)=>h;
// 64-bit left rotates (rotl*) are not defined here: sha3.ts, their only consumer, keeps
// local copies so V8 inlines them into keccakP.
// Add two split 64-bit words and return the split `{ h, l }` sum.
// JS uses 32-bit signed integers for bitwise operations, so we cannot simply shift the carry out
// of the low sum and instead use division.
function $844bc8fa7cf06207$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
// Unmasked low-word accumulator for 3-way addition; pass the raw result into `add3H(...)`.
const $844bc8fa7cf06207$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
// High-word finalize step for 3-way addition; `low` must be the untruncated output of `add3L(...)`.
const $844bc8fa7cf06207$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
// Unmasked low-word accumulator for 4-way addition; pass the raw result into `add4H(...)`.
const $844bc8fa7cf06207$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
// High-word finalize step for 4-way addition; `low` must be the untruncated output of `add4L(...)`.
const $844bc8fa7cf06207$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
// Unmasked low-word accumulator for 5-way addition; pass the raw result into `add5H(...)`.
const $844bc8fa7cf06207$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
// High-word finalize step for 5-way addition; `low` must be the untruncated output of `add5L(...)`.
const $844bc8fa7cf06207$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;


/**
 * Checks if something is Uint8Array. Be careful: nodejs Buffer will return true.
 * @param a - value to test
 * @returns `true` when the value is a Uint8Array-compatible view.
 * @example
 * Check whether a value is a Uint8Array-compatible view.
 * ```ts
 * isBytes(new Uint8Array([1, 2, 3]));
 * ```
 */ function $3c6c2c802c119f83$export$c6fabfbfd097fc30(a) {
    // Plain `instanceof Uint8Array` is too strict for some Buffer / proxy / cross-realm cases.
    // The fallback still requires a real ArrayBuffer view, so plain
    // JSON-deserialized `{ constructor: ... }` spoofing is rejected, and
    // `BYTES_PER_ELEMENT === 1` keeps the fallback on byte-oriented views.
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array' && 'BYTES_PER_ELEMENT' in a && a.BYTES_PER_ELEMENT === 1;
}
// Shared error-message prefix builder. Only called on throw paths, so assert
// success paths never pay for the string concatenation.
const $3c6c2c802c119f83$var$atitle = (title)=>title ? `"${title}" ` : '';
function $3c6c2c802c119f83$export$75364c6cb16d43b6(n, title = '') {
    if (typeof n !== 'number') throw new TypeError($3c6c2c802c119f83$var$atitle(title) + 'expected number, got ' + typeof n);
    if (!Number.isSafeInteger(n) || n < 0) throw new RangeError($3c6c2c802c119f83$var$atitle(title) + 'expected integer >= 0, got ' + n);
    return n;
}
function $3c6c2c802c119f83$export$809304d28d77d92d(value, title = '') {
    if (typeof value !== 'boolean') throw new TypeError($3c6c2c802c119f83$var$atitle(title) + 'expected boolean, got type=' + typeof value);
    return value;
}
function $3c6c2c802c119f83$export$e8a750b9efad93f5(value, length, title = '') {
    // Success path first: this runs at the start of every update() / digestInto(), and the
    // common `abytes(data)` form must not pay for length handling it does not use.
    if ($3c6c2c802c119f83$export$c6fabfbfd097fc30(value) && (length === undefined || value.length === length)) return value;
    // Error path: recompute freely to build the exact message.
    if (length !== undefined) $3c6c2c802c119f83$export$75364c6cb16d43b6(length, 'length');
    const bytes = $3c6c2c802c119f83$export$c6fabfbfd097fc30(value);
    const ofLen = length !== undefined ? ` of length ${length}` : '';
    const got = bytes ? `length=${value.length}` : `type=${typeof value}`;
    const message = $3c6c2c802c119f83$var$atitle(title) + 'expected Uint8Array' + ofLen + ', got ' + got;
    if (!bytes) throw new TypeError(message);
    throw new RangeError(message);
}
function $3c6c2c802c119f83$export$56728fb2d7dba34e(bytes) {
    // `Uint8Array.from(...)` would also accept arrays / other typed arrays. Keep this helper strict
    // because callers use it at byte-validation boundaries before mutating the detached copy.
    return Uint8Array.from($3c6c2c802c119f83$export$e8a750b9efad93f5(bytes));
}
function $3c6c2c802c119f83$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new TypeError('expected hash wrapped by utils.createHasher');
    $3c6c2c802c119f83$export$75364c6cb16d43b6(h.outputLen);
    $3c6c2c802c119f83$export$75364c6cb16d43b6(h.blockLen);
    // HMAC and KDF callers treat these as real byte lengths; allowing zero lets fake wrappers pass
    // validation and can produce empty outputs instead of failing fast.
    if (h.outputLen < 1 || h.blockLen < 1) throw new Error('hash blockLen / outputLen must be >= 1');
}
const $3c6c2c802c119f83$var$aobject = (value, label)=>{
    if (value === null || typeof value !== 'object' || Array.isArray(value)) throw new TypeError((label === 'object' ? '' : `"${label}" `) + 'expected object, got type=' + typeof value);
};
const $3c6c2c802c119f83$var$aopts = (value, label)=>{
    $3c6c2c802c119f83$var$aobject(value, label);
    const proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) throw new TypeError(`"${label}" expected plain object`);
    // Object.assign() treats an own "__proto__" source key as a write to the target's legacy
    // prototype setter. Reject it before merging so inherited option values cannot be injected.
    if (Object.hasOwn(value, '__proto__')) throw new TypeError(`"${label}.__proto__" is not allowed`);
};
function $3c6c2c802c119f83$export$20871f6b1d047d77(instance, checkFinished = true) {
    // Runs on every update()/digestInto(); the flags are library-owned booleans, so only their
    // truthiness is checked - re-validating their type per call was pure hot-path overhead.
    if (instance.destroyed) throw new Error('hash was destroyed');
    if (checkFinished && instance.finished) throw new Error('digest() was already called');
}
function $3c6c2c802c119f83$export$e8e53abee12b995e(out, instance) {
    $3c6c2c802c119f83$export$e8a750b9efad93f5(out, undefined, 'output');
    // `outputLen` is a library-owned readonly number; the negated comparison keeps failing fast
    // when it is missing/NaN (comparisons with undefined/NaN are false) without an anumber() call.
    const min = instance.outputLen;
    if (!(out.length >= min)) throw new RangeError('"output" expected length >= ' + min);
}
function $3c6c2c802c119f83$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $3c6c2c802c119f83$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $3c6c2c802c119f83$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $3c6c2c802c119f83$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $3c6c2c802c119f83$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $3c6c2c802c119f83$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $3c6c2c802c119f83$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $3c6c2c802c119f83$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $3c6c2c802c119f83$export$e108944b32ae0e38 = $3c6c2c802c119f83$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$3c6c2c802c119f83$export$a4170f7f8be47425(n) >>> 0;
function $3c6c2c802c119f83$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $3c6c2c802c119f83$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $3c6c2c802c119f83$export$f3e5ccb1e5f96d20 = $3c6c2c802c119f83$export$a0f88e38d4cf9577 ? (u)=>u : $3c6c2c802c119f83$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $3c6c2c802c119f83$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $3c6c2c802c119f83$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $3c6c2c802c119f83$export$58b867e287a802c8(bytes) {
    $3c6c2c802c119f83$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($3c6c2c802c119f83$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $3c6c2c802c119f83$var$hexes[bytes[i]];
    return hex;
}
// Strict ASCII nibble parser: non-ASCII hex lookalikes are rejected as undefined.
// ASCII codes: '0'..'9' = 48..57, 'A'..'F' = 65..70, 'a'..'f' = 97..102.
// prettier-ignore
function $3c6c2c802c119f83$var$asciiToBase16(ch) {
    return ch >= 48 && ch <= 57 ? ch - 48 // '2' => 50-48
     : ch >= 65 && ch <= 70 ? ch - 55 // 'B' => 66-(65-10)
     : ch >= 97 && ch <= 102 ? ch - 87 // 'b' => 98-(97-10)
     : undefined;
}
function $3c6c2c802c119f83$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new TypeError('hex string expected, got ' + typeof hex);
    if ($3c6c2c802c119f83$var$hasHexBuiltin) try {
        return Uint8Array.fromHex(hex);
    } catch (error) {
        if (error instanceof SyntaxError) throw new RangeError(error.message);
        throw error;
    }
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new RangeError('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $3c6c2c802c119f83$var$asciiToBase16(hex.charCodeAt(hi)); // parse first char, multiply it by 16
        const n2 = $3c6c2c802c119f83$var$asciiToBase16(hex.charCodeAt(hi + 1)); // parse second char
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new RangeError('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // example: 'A9' => 10*16 + 9
    }
    return array;
}
function $3c6c2c802c119f83$export$bdd553fddd433dcb(onReject) {
    const host = globalThis;
    if (typeof host.scheduler?.yield === 'function') {
        const promise = host.scheduler.yield();
        // Keep the original scheduler rejection; this handler exists only for cleanup.
        if (onReject) promise.catch(onReject);
        return promise;
    }
    return new Promise((resolve)=>host.setTimeout(resolve, 0));
}
async function $3c6c2c802c119f83$export$57207d71b8c929c8(iters, tick, cb, onReject) {
    $3c6c2c802c119f83$export$75364c6cb16d43b6(iters, 'iters');
    $3c6c2c802c119f83$export$75364c6cb16d43b6(tick, 'tick');
    if (typeof cb !== 'function') throw new TypeError('callback must be a function');
    // Callback is synchronous by contract; asyncLoop only yields between sync work windows.
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $3c6c2c802c119f83$export$bdd553fddd433dcb(onReject);
        // Track only synchronous work time; scheduler delay after yielding is outside our budget.
        ts = Date.now();
    }
}
function $3c6c2c802c119f83$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new TypeError('string expected');
    const encoded = new TextEncoder().encode(str);
    try {
        // Copy into the current realm for Firefox extension contexts. Callers that own the returned
        // buffer can then wipe it independently of TextEncoder's temporary result.
        return new Uint8Array(encoded); // https://bugzil.la/1681809
    } finally{
        $3c6c2c802c119f83$export$cf0b2a6c63f9e656(encoded);
    }
}
function $3c6c2c802c119f83$export$e01ba4a527b8942d(data, errorTitle = '') {
    if (typeof data === 'string') return $3c6c2c802c119f83$export$3df70a15530b5e81(data);
    return $3c6c2c802c119f83$export$e8a750b9efad93f5(data, undefined, errorTitle);
}
function $3c6c2c802c119f83$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $3c6c2c802c119f83$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
const $3c6c2c802c119f83$export$381bae2d0f08004f = (object, fields = {}, optFields = {}, title = 'object')=>{
    $3c6c2c802c119f83$var$aobject(object, title);
    $3c6c2c802c119f83$var$aobject(fields, 'fields');
    $3c6c2c802c119f83$var$aobject(optFields, 'optFields');
    function checkField(fieldName, expectedType, isOpt) {
        const label = title === 'object' ? `param "${String(fieldName)}"` : `"${title}.${String(fieldName)}"`;
        // Config fields must be explicit own properties. Optional inherited values are rejected too
        // because callers keep reading the same options object after validation.
        const val = object[fieldName];
        // Runtime objects such as Field instances intentionally satisfy required method slots
        // via their shared prototype.
        if (!Object.hasOwn(object, fieldName) && (isOpt ? val !== undefined : expectedType !== 'function')) throw new TypeError(`${label} is invalid: expected own property`);
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new TypeError(`${label} is invalid: expected ${expectedType}, got ${current}`);
    }
    const iter = (f, isOpt)=>Object.entries(f).forEach(([k, v])=>checkField(k, v, isOpt));
    iter(fields, false);
    iter(optFields, true);
};
function $3c6c2c802c119f83$export$6fcee72895eceb1e(defaults, opts, title = 'opts') {
    $3c6c2c802c119f83$var$aopts(defaults, 'defaults');
    if (opts !== undefined) $3c6c2c802c119f83$var$aopts(opts, title);
    // Callers read optional fields directly, so omitted values must not fall through to ambient
    // Object.prototype pollution (for example a forged `dkLen` changing SHAKE's default output).
    const merged = Object.assign(Object.create(null), defaults, opts);
    return merged;
}
function $3c6c2c802c119f83$export$14b114effbc08b6b(hashCons, info = {}) {
    if (typeof hashCons !== 'function') throw new TypeError('"hashCons" expected function, got type=' + typeof hashCons);
    info = $3c6c2c802c119f83$export$6fcee72895eceb1e({}, info, 'info');
    const hashC = (msg, opts)=>hashCons(opts).update(msg).digest();
    const tmp = hashCons(undefined);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.canXOF = tmp.canXOF;
    hashC.create = (opts)=>hashCons(opts);
    Object.assign(hashC, info);
    return Object.freeze(hashC);
}
function $3c6c2c802c119f83$export$5f828d93ff035aa8(bytesLength = 32) {
    // Match the repo's other length-taking helpers instead of relying on Uint8Array coercion.
    $3c6c2c802c119f83$export$75364c6cb16d43b6(bytesLength, 'bytesLength');
    const cr = typeof globalThis === 'object' ? globalThis.crypto : null;
    if (typeof cr?.getRandomValues !== 'function') throw new Error('crypto.getRandomValues must be defined');
    // Web Cryptography API Level 2 §10.1.1:
    // if `byteLength > 65536`, throw `QuotaExceededError`.
    // Keep the guard explicit so callers can see the quota in code
    // instead of discovering it by reading the spec or host errors.
    // This wrapper surfaces the same quota as a stable library RangeError.
    if (bytesLength > 65536) throw new RangeError(`"bytesLength" expected <= 65536, got ${bytesLength}`);
    return cr.getRandomValues(new Uint8Array(bytesLength));
}
const $3c6c2c802c119f83$export$6befe166550a2fc1 = (suffix)=>({
        // Current NIST hashAlgs suffixes used here fit in one DER subidentifier octet.
        // Larger suffix values would need base-128 OID encoding and a different length byte.
        oid: Uint8Array.from([
            0x06,
            0x09,
            0x60,
            0x86,
            0x48,
            0x01,
            0x65,
            0x03,
            0x04,
            0x02,
            suffix
        ])
    });


function $5412d243d3a838f0$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $5412d243d3a838f0$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $5412d243d3a838f0$export$f9f830659f932cb2 {
    blockLen;
    outputLen;
    canXOF = false;
    padOffset;
    isLE;
    // For partial updates less than block size
    buffer;
    view;
    finished = false;
    length = 0;
    pos = 0;
    destroyed = false;
    constructor(blockLen, outputLen, padOffset, isLE){
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3c6c2c802c119f83$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $3c6c2c802c119f83$export$20871f6b1d047d77)(this);
        (0, $3c6c2c802c119f83$export$e8a750b9efad93f5)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        let processed = false;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path only when there is no buffered partial block: `take === blockLen` implies
            // `this.pos === 0`, so we can process full blocks directly from the input view.
            if (take === blockLen) {
                const dataView = (0, $3c6c2c802c119f83$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                processed = true;
                continue;
            }
            // When the whole input is buffered in one go (common for short messages), passing `data`
            // directly avoids allocating a subarray view.
            buffer.set(pos === 0 && take === len ? data : data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
                processed = true;
            }
        }
        this.length += data.length;
        // Shared schedule buffers only pick up input-derived words inside process(); if everything
        // was buffered without processing, there is nothing to zero.
        if (processed) this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3c6c2c802c119f83$export$20871f6b1d047d77)(this);
        (0, $3c6c2c802c119f83$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message, then zero-pad the rest of the block
        buffer[pos++] = 128;
        buffer.fill(0, pos);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            buffer.fill(0);
        }
        // `padOffset` reserves the whole length field. For SHA-384/512 the high 64 bits stay zero from
        // the padding fill above, and JS will overflow before user input can make that half non-zero.
        // So we only need to write the low 64 bits here (`length * 8` only scales the exponent of an
        // integer below 2**53, so the split inside the helper stays exact).
        (0, $844bc8fa7cf06207$export$5cfb625c85abf059)(view, blockLen - 8, this.length * 8, isLE);
        this.process(view, 0);
        // The final block above is processed outside update(), so the shared message-schedule
        // buffers (e.g. SHA256_W) would otherwise retain input-derived words after digest().
        this.roundClean();
        // digest() passes our own `buffer` as `out`; reuse its cached view instead of allocating one.
        const oview = out === buffer ? view : (0, $3c6c2c802c119f83$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which must be fused in single op with modulo by JIT
        const outLen = len / 4;
        const state = this.get();
        // Subclass-misconfiguration invariant: outputLen must be 32-bit aligned and fit the state.
        if (len % 4 || outLen > state.length) throw new Error('invalid outputLen');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        // Copy before destroy(): subclasses wipe `buffer` during cleanup, but `digest()` must return
        // fresh bytes to the caller.
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneIntoMeta(to) {
        const { buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        // Only partial-block bytes need copying: when `length % blockLen === 0`, `pos === 0` and
        // later `update()` / `digestInto()` overwrite `to.buffer` from the start before reading it.
        if (pos) to.buffer.set(buffer); // Avoid a hot modulo guard.
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $5412d243d3a838f0$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $5412d243d3a838f0$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $5412d243d3a838f0$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $5412d243d3a838f0$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);




/**
 * SHA-224 / SHA-256 round constants from RFC 6234 §5.1: the first 32 bits
 * of the cube roots of the first 64 primes (2..311).
 */ // prettier-ignore
const $3000ec301818b27b$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable SHA-224 / SHA-256 message schedule buffer `W_t` from RFC 6234 §6.2 step 1. */ const $3000ec301818b27b$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
/** Internal SHA-224 / SHA-256 compression engine from RFC 6234 §6.2. */ class $3000ec301818b27b$var$SHA2_32B extends (0, $5412d243d3a838f0$export$f9f830659f932cb2) {
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    // Numeric initializers matter: starting the fields as `undefined` changes
    // V8's field representation and makes sha256 3x slower (measured).
    A = 0;
    B = 0;
    C = 0;
    D = 0;
    E = 0;
    F = 0;
    G = 0;
    H = 0;
    constructor(outputLen, IV){
        super(64, outputLen, 8, false);
        this.A = IV[0] | 0;
        this.B = IV[1] | 0;
        this.C = IV[2] | 0;
        this.D = IV[3] | 0;
        this.E = IV[4] | 0;
        this.F = IV[5] | 0;
        this.G = IV[6] | 0;
        this.H = IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    _cloneInto(to) {
        (to ||= new this.constructor()).set(...this.get());
        return this._cloneIntoMeta(to);
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$3000ec301818b27b$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $3000ec301818b27b$var$SHA256_W[i - 15];
            const W2 = $3000ec301818b27b$var$SHA256_W[i - 2];
            const s0 = (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(W15, 7) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(W2, 17) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $3000ec301818b27b$var$SHA256_W[i] = s1 + $3000ec301818b27b$var$SHA256_W[i - 7] + s0 + $3000ec301818b27b$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(E, 6) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(E, 11) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $5412d243d3a838f0$export$d0d97f016526eaf0)(E, F, G) + $3000ec301818b27b$var$SHA256_K[i] + $3000ec301818b27b$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(A, 2) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(A, 13) ^ (0, $3c6c2c802c119f83$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $5412d243d3a838f0$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $3c6c2c802c119f83$export$cf0b2a6c63f9e656)($3000ec301818b27b$var$SHA256_W);
    }
    destroy() {
        // HashMD callers route post-destroy usability through `destroyed`; zeroizing alone still leaves
        // update()/digest() callable on reused instances.
        this.destroyed = true;
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $3c6c2c802c119f83$export$cf0b2a6c63f9e656)(this.buffer);
    }
}
class $3000ec301818b27b$export$978b14127c36190d extends $3000ec301818b27b$var$SHA2_32B {
    constructor(){
        super(32, (0, $5412d243d3a838f0$export$a986fdf7a5bdfdf8));
    }
}
class $3000ec301818b27b$export$bb11dd29d05650f6 extends $3000ec301818b27b$var$SHA2_32B {
    constructor(){
        super(28, (0, $5412d243d3a838f0$export$104dc246f4c65f21));
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// SHA-384 / SHA-512 round constants from RFC 6234 §5.2:
// 80 full 64-bit words split into high/low halves.
// prettier-ignore
const $3000ec301818b27b$var$K512 = /* @__PURE__ */ (()=>$844bc8fa7cf06207$export$65980d18b75784e2([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $3000ec301818b27b$var$SHA512_Kh = /* @__PURE__ */ (()=>$3000ec301818b27b$var$K512[0])();
const $3000ec301818b27b$var$SHA512_Kl = /* @__PURE__ */ (()=>$3000ec301818b27b$var$K512[1])();
// Reusable high-half schedule buffer for the RFC 6234 §6.4 64-bit `W_t` words.
const $3000ec301818b27b$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
// Reusable low-half schedule buffer for the RFC 6234 §6.4 64-bit `W_t` words.
const $3000ec301818b27b$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
/** Internal SHA-384 / SHA-512 compression engine from RFC 6234 §6.4. */ class $3000ec301818b27b$var$SHA2_64B extends (0, $5412d243d3a838f0$export$f9f830659f932cb2) {
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    // h -- high 32 bits, l -- low 32 bits
    // Numeric initializers matter: starting the fields as `undefined` changes
    // V8's field representation and slows hashing down (measured on sha256).
    Ah = 0;
    Al = 0;
    Bh = 0;
    Bl = 0;
    Ch = 0;
    Cl = 0;
    Dh = 0;
    Dl = 0;
    Eh = 0;
    El = 0;
    Fh = 0;
    Fl = 0;
    Gh = 0;
    Gl = 0;
    Hh = 0;
    Hl = 0;
    constructor(outputLen, IV){
        super(128, outputLen, 16, false);
        this.Ah = IV[0] | 0;
        this.Al = IV[1] | 0;
        this.Bh = IV[2] | 0;
        this.Bl = IV[3] | 0;
        this.Ch = IV[4] | 0;
        this.Cl = IV[5] | 0;
        this.Dh = IV[6] | 0;
        this.Dl = IV[7] | 0;
        this.Eh = IV[8] | 0;
        this.El = IV[9] | 0;
        this.Fh = IV[10] | 0;
        this.Fl = IV[11] | 0;
        this.Gh = IV[12] | 0;
        this.Gl = IV[13] | 0;
        this.Hh = IV[14] | 0;
        this.Hl = IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    _cloneInto(to) {
        (to ||= new this.constructor()).set(...this.get());
        return this._cloneIntoMeta(to);
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $3000ec301818b27b$var$SHA512_W_H[i] = view.getUint32(offset);
            $3000ec301818b27b$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $3000ec301818b27b$var$SHA512_W_H[i - 15] | 0;
            const W15l = $3000ec301818b27b$var$SHA512_W_L[i - 15] | 0;
            const s0h = $844bc8fa7cf06207$export$97f812dfd830ca87(W15h, W15l, 1) ^ $844bc8fa7cf06207$export$97f812dfd830ca87(W15h, W15l, 8) ^ $844bc8fa7cf06207$export$75aa78dc5bd52853(W15h, W15l, 7);
            const s0l = $844bc8fa7cf06207$export$60987e30e2c9d9d(W15h, W15l, 1) ^ $844bc8fa7cf06207$export$60987e30e2c9d9d(W15h, W15l, 8) ^ $844bc8fa7cf06207$export$a0225ff0aee14e25(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $3000ec301818b27b$var$SHA512_W_H[i - 2] | 0;
            const W2l = $3000ec301818b27b$var$SHA512_W_L[i - 2] | 0;
            const s1h = $844bc8fa7cf06207$export$97f812dfd830ca87(W2h, W2l, 19) ^ $844bc8fa7cf06207$export$af9c7fbac44dcb76(W2h, W2l, 61) ^ $844bc8fa7cf06207$export$75aa78dc5bd52853(W2h, W2l, 6);
            const s1l = $844bc8fa7cf06207$export$60987e30e2c9d9d(W2h, W2l, 19) ^ $844bc8fa7cf06207$export$f619171d6d5ac414(W2h, W2l, 61) ^ $844bc8fa7cf06207$export$a0225ff0aee14e25(W2h, W2l, 6);
            // SHA512_W[i] = s0 + s1 + SHA512_W[i - 7] + SHA512_W[i - 16];
            const SUMl = $844bc8fa7cf06207$export$2f4e199c560f545d(s0l, s1l, $3000ec301818b27b$var$SHA512_W_L[i - 7], $3000ec301818b27b$var$SHA512_W_L[i - 16]);
            const SUMh = $844bc8fa7cf06207$export$e909220d675a7741(SUMl, s0h, s1h, $3000ec301818b27b$var$SHA512_W_H[i - 7], $3000ec301818b27b$var$SHA512_W_H[i - 16]);
            $3000ec301818b27b$var$SHA512_W_H[i] = SUMh | 0;
            $3000ec301818b27b$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $844bc8fa7cf06207$export$97f812dfd830ca87(Eh, El, 14) ^ $844bc8fa7cf06207$export$97f812dfd830ca87(Eh, El, 18) ^ $844bc8fa7cf06207$export$af9c7fbac44dcb76(Eh, El, 41);
            const sigma1l = $844bc8fa7cf06207$export$60987e30e2c9d9d(Eh, El, 14) ^ $844bc8fa7cf06207$export$60987e30e2c9d9d(Eh, El, 18) ^ $844bc8fa7cf06207$export$f619171d6d5ac414(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $844bc8fa7cf06207$export$d732b061fe9c9ae4(Hl, sigma1l, CHIl, $3000ec301818b27b$var$SHA512_Kl[i], $3000ec301818b27b$var$SHA512_W_L[i]);
            const T1h = $844bc8fa7cf06207$export$b45ee8d78c965098(T1ll, Hh, sigma1h, CHIh, $3000ec301818b27b$var$SHA512_Kh[i], $3000ec301818b27b$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $844bc8fa7cf06207$export$97f812dfd830ca87(Ah, Al, 28) ^ $844bc8fa7cf06207$export$af9c7fbac44dcb76(Ah, Al, 34) ^ $844bc8fa7cf06207$export$af9c7fbac44dcb76(Ah, Al, 39);
            const sigma0l = $844bc8fa7cf06207$export$60987e30e2c9d9d(Ah, Al, 28) ^ $844bc8fa7cf06207$export$f619171d6d5ac414(Ah, Al, 34) ^ $844bc8fa7cf06207$export$f619171d6d5ac414(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $844bc8fa7cf06207$export$e16d8520af44a096(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $844bc8fa7cf06207$export$c0c22b91f08911f(T1l, sigma0l, MAJl);
            Ah = $844bc8fa7cf06207$export$ef7b26044977a8ec(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $844bc8fa7cf06207$export$e16d8520af44a096(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $3c6c2c802c119f83$export$cf0b2a6c63f9e656)($3000ec301818b27b$var$SHA512_W_H, $3000ec301818b27b$var$SHA512_W_L);
    }
    destroy() {
        // HashMD callers route post-destroy usability through `destroyed`; zeroizing alone still leaves
        // update()/digest() callable on reused instances.
        this.destroyed = true;
        (0, $3c6c2c802c119f83$export$cf0b2a6c63f9e656)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $3000ec301818b27b$export$f1b13c91499a6586 extends $3000ec301818b27b$var$SHA2_64B {
    constructor(){
        super(64, (0, $5412d243d3a838f0$export$f2cbb88a1784d2d1));
    }
}
class $3000ec301818b27b$export$f4ad3bd28f228957 extends $3000ec301818b27b$var$SHA2_64B {
    constructor(){
        super(48, (0, $5412d243d3a838f0$export$b5217b4b948279ee));
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See the repo-side derivation recipe in `test/misc/sha2-gen-iv.js`.
 * These IV literals are checked against that script rather than a dedicated
 * local RFC section.
 */ /** SHA-512/224 IV derived by the SHA-512/t recipe in `test/misc/sha2-gen-iv.js` and
 * stored as sixteen big-endian 32-bit halves. */ const $3000ec301818b27b$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA-512/256 IV derived by the SHA-512/t recipe in `test/misc/sha2-gen-iv.js` and
 * stored as sixteen big-endian 32-bit halves. */ const $3000ec301818b27b$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $3000ec301818b27b$export$224cfee675191366 extends $3000ec301818b27b$var$SHA2_64B {
    constructor(){
        super(28, $3000ec301818b27b$var$T224_IV);
    }
}
class $3000ec301818b27b$export$9705f0e3a7ee4586 extends $3000ec301818b27b$var$SHA2_64B {
    constructor(){
        super(32, $3000ec301818b27b$var$T256_IV);
    }
}
const $3000ec301818b27b$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$978b14127c36190d(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x01));
const $3000ec301818b27b$export$97b70509d4e397ea = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$bb11dd29d05650f6(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x04));
const $3000ec301818b27b$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$f1b13c91499a6586(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x03));
const $3000ec301818b27b$export$612d47d55dedde45 = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$f4ad3bd28f228957(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x02));
const $3000ec301818b27b$export$c78786b6da86db2a = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$9705f0e3a7ee4586(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x06));
const $3000ec301818b27b$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $3c6c2c802c119f83$export$14b114effbc08b6b)(()=>new $3000ec301818b27b$export$224cfee675191366(), /* @__PURE__ */ (0, $3c6c2c802c119f83$export$6befe166550a2fc1)(0x05));



/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF-based ScalarMultiplier, pippenger.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
function $e129040e856338dd$export$c9895e5868d4e385(item, title, inner = ()=>{}) {
    if (!Array.isArray(item)) throw new TypeError(`"${title}" expected array, got type=${typeof item}`);
    for(let i = 0; i < item.length; i++)inner(item[i], `${title}[${i}]`);
    return item;
}
const $e129040e856338dd$export$e8a750b9efad93f5 = (value, length, title)=>(0, $3c6c2c802c119f83$export$e8a750b9efad93f5)(value, length, title);
const $e129040e856338dd$export$75364c6cb16d43b6 = (0, $3c6c2c802c119f83$export$75364c6cb16d43b6);
function $e129040e856338dd$export$e32658751cad4ab1(value, title = '') {
    if (typeof value !== 'string') {
        const prefix = title && `"${title}" `;
        throw new TypeError(prefix + 'expected string, got type=' + typeof value);
    }
    return value;
}
function $e129040e856338dd$export$829bca09b0bfc27a(value, title = 'object') {
    if (value === null || typeof value !== 'object' || Array.isArray(value)) throw new TypeError(title === 'object' ? 'expected valid options object' : `"${title}" expected object, got type=${typeof value}`);
    return value;
}
function $e129040e856338dd$export$c0acea525719deb8(value, title) {
    if (typeof value !== 'function') throw new TypeError(`"${title}" is invalid: expected function, got ${typeof value}`);
    return value;
}
const $e129040e856338dd$export$58b867e287a802c8 = (0, $3c6c2c802c119f83$export$58b867e287a802c8);
const $e129040e856338dd$export$287dd7971339c972 = (...arrays)=>(0, $3c6c2c802c119f83$export$287dd7971339c972)(...arrays);
const $e129040e856338dd$export$31c96b9df38bc8d4 = (hex)=>(0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(hex);
const $e129040e856338dd$export$c6fabfbfd097fc30 = (0, $3c6c2c802c119f83$export$c6fabfbfd097fc30);
const $e129040e856338dd$export$5f828d93ff035aa8 = (bytesLength)=>(0, $3c6c2c802c119f83$export$5f828d93ff035aa8)(bytesLength);
const $e129040e856338dd$var$_0n = /* @__PURE__ */ BigInt(0);
const $e129040e856338dd$var$_1n = /* @__PURE__ */ BigInt(1);
// Shared error-message prefix builder. Only called on throw paths, so assert
// success paths never pay for the string concatenation.
const $e129040e856338dd$var$atitle = (title)=>title ? `"${title}" ` : '';
function $e129040e856338dd$export$809304d28d77d92d(value, title = '') {
    if (typeof value !== 'boolean') throw new TypeError($e129040e856338dd$var$atitle(title) + 'expected boolean, got type=' + typeof value);
    return value;
}
function $e129040e856338dd$export$288eb97b5b0dec03(n) {
    if (typeof n === 'bigint') {
        if (!$e129040e856338dd$export$ca489aba7178a82(n)) throw new RangeError('positive bigint expected, got ' + n);
    } else $e129040e856338dd$export$75364c6cb16d43b6(n);
    return n;
}
function $e129040e856338dd$export$4f3315d97e288446(value, title = '') {
    if (typeof value !== 'number') {
        const prefix = title && `"${title}" `;
        throw new TypeError(prefix + 'expected number, got type=' + typeof value);
    }
    if (!Number.isSafeInteger(value)) {
        const prefix = title && `"${title}" `;
        throw new RangeError(prefix + 'expected safe integer, got ' + value);
    }
}
function $e129040e856338dd$export$4ed2545b622827c1(num) {
    const hex = $e129040e856338dd$export$288eb97b5b0dec03(num).toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $e129040e856338dd$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new TypeError('hex string expected, got ' + typeof hex);
    return hex === '' ? $e129040e856338dd$var$_0n : BigInt('0x' + hex); // Big Endian
}
function $e129040e856338dd$export$d609354794974f8(bytes) {
    return $e129040e856338dd$export$d57f2bacc26b4249((0, $3c6c2c802c119f83$export$58b867e287a802c8)(bytes));
}
function $e129040e856338dd$export$d67b1d03392107e7(bytes) {
    return $e129040e856338dd$export$d57f2bacc26b4249((0, $3c6c2c802c119f83$export$58b867e287a802c8)($e129040e856338dd$export$56728fb2d7dba34e((0, $3c6c2c802c119f83$export$e8a750b9efad93f5)(bytes)).reverse()));
}
function $e129040e856338dd$export$1459dafd057611cb(n, len) {
    (0, $3c6c2c802c119f83$export$75364c6cb16d43b6)(len);
    if (len === 0) throw new Error('zero output length is invalid');
    n = $e129040e856338dd$export$288eb97b5b0dec03(n);
    const expectedLen = len * 2;
    const hex = n.toString(16);
    // Detect overflow before hex parsing so oversized values don't leak the shared odd-hex error.
    if (hex.length > expectedLen) throw new RangeError('number is too large');
    return (0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(hex.padStart(expectedLen, '0'));
}
function $e129040e856338dd$export$ba2172e58d139f6d(n, len) {
    return $e129040e856338dd$export$1459dafd057611cb(n, len).reverse();
}
function $e129040e856338dd$export$80ee8c1914de6dde(n) {
    return (0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)($e129040e856338dd$export$4ed2545b622827c1($e129040e856338dd$export$288eb97b5b0dec03(n)));
}
function $e129040e856338dd$export$2aa59cef064b0333(a, b) {
    a = $e129040e856338dd$export$e8a750b9efad93f5(a);
    b = $e129040e856338dd$export$e8a750b9efad93f5(b);
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $e129040e856338dd$export$56728fb2d7dba34e(bytes) {
    // `Uint8Array.from(...)` would also accept arrays / other typed arrays. Keep this helper strict
    // because callers use it at byte-validation boundaries before mutating the detached copy.
    return Uint8Array.from($e129040e856338dd$export$e8a750b9efad93f5(bytes));
}
function $e129040e856338dd$export$e151636497a65339(ascii) {
    if (typeof ascii !== 'string') throw new TypeError('ascii string expected, got ' + typeof ascii);
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new RangeError(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
function $e129040e856338dd$export$ca489aba7178a82(n) {
    return typeof n === 'bigint' && $e129040e856338dd$var$_0n <= n;
}
function $e129040e856338dd$export$ddf89a9c5af38f94(n, min, max) {
    return $e129040e856338dd$export$ca489aba7178a82(n) && $e129040e856338dd$export$ca489aba7178a82(min) && $e129040e856338dd$export$ca489aba7178a82(max) && min <= n && n < max;
}
function $e129040e856338dd$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$e129040e856338dd$export$ddf89a9c5af38f94(n, min, max)) throw new RangeError('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
function $e129040e856338dd$export$e93ef600c41761a9(n) {
    // Size callers in this repo only use non-negative orders / scalars, so negative inputs are a
    // contract bug and must not silently collapse to zero bits.
    if (n < $e129040e856338dd$var$_0n) throw new Error('expected non-negative bigint, got ' + n);
    // Native radix conversion beats a shift loop at every size, and the loop is quadratic in bits.
    return n === $e129040e856338dd$var$_0n ? 0 : n.toString(2).length;
}
function $e129040e856338dd$export$9577d112d1fd46ad(n, pos) {
    if (typeof n !== 'bigint') throw new TypeError('"n" expected bigint, got type=' + typeof n);
    $e129040e856338dd$export$4f3315d97e288446(pos, 'pos');
    return n >> BigInt(pos) & $e129040e856338dd$var$_1n;
}
function $e129040e856338dd$export$967bb2b9787441cb(n, pos, value) {
    if (typeof n !== 'bigint') throw new TypeError('"n" expected bigint, got type=' + typeof n);
    $e129040e856338dd$export$4f3315d97e288446(pos, 'pos');
    $e129040e856338dd$export$809304d28d77d92d(value, 'value');
    const mask = $e129040e856338dd$var$_1n << BigInt(pos);
    // Clearing needs AND-not here; OR with zero leaves an already-set bit untouched.
    return value ? n | mask : n & ~mask;
}
const $e129040e856338dd$export$803efa2fa1c7279 = (n)=>{
    $e129040e856338dd$export$4f3315d97e288446(n, 'n');
    return ($e129040e856338dd$var$_1n << BigInt(n)) - $e129040e856338dd$var$_1n;
};
function $e129040e856338dd$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    (0, $3c6c2c802c119f83$export$75364c6cb16d43b6)(hashLen, 'hashLen');
    (0, $3c6c2c802c119f83$export$75364c6cb16d43b6)(qByteLen, 'qByteLen');
    if (typeof hmacFn !== 'function') throw new TypeError('hmacFn must be a function');
    // creates Uint8Array
    const u8n = (len)=>new Uint8Array(len);
    const NULL = Uint8Array.of();
    const byte0 = Uint8Array.of(0x00);
    const byte1 = Uint8Array.of(0x01);
    const _maxDrbgIters = 1000;
    // Step B, Step C: set hashLen to 8*ceil(hlen/8).
    // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 signatures.
    let v = u8n(hashLen);
    // Steps B and C of RFC6979 3.2.
    let k = u8n(hashLen);
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    // hmac(k)(v, ...values)
    const h = (...msgs)=>hmacFn(k, $e129040e856338dd$export$287dd7971339c972(v, ...msgs));
    const reseed = (seed = NULL)=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(byte0, seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(byte1, seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= _maxDrbgIters) throw new Error('drbg: tried max amount of iterations');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $e129040e856338dd$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until the predicate accepts a candidate.
        // Falsy values like 0 are valid outputs.
        while((res = pred(gen())) === undefined)reseed();
        reset();
        return res;
    };
    return genUntil;
}
function $e129040e856338dd$export$381bae2d0f08004f(object, fields = {}, optFields = {}, title = 'object') {
    $e129040e856338dd$export$829bca09b0bfc27a(object, title);
    $e129040e856338dd$export$829bca09b0bfc27a(fields, 'fields');
    $e129040e856338dd$export$829bca09b0bfc27a(optFields, 'optFields');
    function checkField(fieldName, expectedType, isOpt) {
        const label = title === 'object' ? `param "${String(fieldName)}"` : `"${title}.${String(fieldName)}"`;
        // Config fields must be explicit own properties. Optional inherited values are rejected too
        // because callers keep reading the same options object after validation.
        const val = object[fieldName];
        // Runtime objects such as Field instances intentionally satisfy required method slots
        // via their shared prototype.
        if (!Object.hasOwn(object, fieldName) && (isOpt ? val !== undefined : expectedType !== 'function')) throw new TypeError(`${label} is invalid: expected own property`);
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new TypeError(`${label} is invalid: expected ${expectedType}, got ${current}`);
    }
    const iter = (f, isOpt)=>Object.entries(f).forEach(([k, v])=>checkField(k, v, isOpt));
    iter(fields, false);
    iter(optFields, true);
}
const $e129040e856338dd$export$94a5f06e658f87e2 = ()=>{
    throw new Error('not implemented');
};


/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
// Numbers aren't used in x25519 / x448 builds
// prettier-ignore
const $eaac85f28e130c0a$var$_0n = /* @__PURE__ */ BigInt(0), $eaac85f28e130c0a$var$_1n = /* @__PURE__ */ BigInt(1), $eaac85f28e130c0a$var$_2n = /* @__PURE__ */ BigInt(2);
// prettier-ignore
const $eaac85f28e130c0a$var$_3n = /* @__PURE__ */ BigInt(3), $eaac85f28e130c0a$var$_4n = /* @__PURE__ */ BigInt(4), $eaac85f28e130c0a$var$_5n = /* @__PURE__ */ BigInt(5);
// prettier-ignore
const $eaac85f28e130c0a$var$_7n = /* @__PURE__ */ BigInt(7), $eaac85f28e130c0a$var$_8n = /* @__PURE__ */ BigInt(8), $eaac85f28e130c0a$var$_9n = /* @__PURE__ */ BigInt(9);
const $eaac85f28e130c0a$var$_15n = /* @__PURE__ */ BigInt(15), $eaac85f28e130c0a$var$_16n = /* @__PURE__ */ BigInt(16);
// 2^64: exponents below this use plain square-and-multiply in pow()/FpPow(); the windowed path's
// table build (14 multiplications) only pays off for longer exponents (break-even ~50 bits).
const $eaac85f28e130c0a$var$POW_WINDOWED_MIN = /* @__PURE__ */ BigInt('0x10000000000000000');
function $eaac85f28e130c0a$export$842a2cf37af977e1(a, b) {
    if (b <= $eaac85f28e130c0a$var$_0n) throw new Error('mod: expected positive modulus, got ' + b);
    const result = a % b;
    return result >= $eaac85f28e130c0a$var$_0n ? result : b + result;
}
function $eaac85f28e130c0a$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $eaac85f28e130c0a$var$_1n) throw new Error('pow: expected modulus > 1, got ' + modulo);
    // Non-bigint exponents coerce every comparison below to false and would silently return 1.
    if (typeof power !== 'bigint') throw new TypeError('invalid exponent: expected bigint, got ' + typeof power);
    if (power < $eaac85f28e130c0a$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $eaac85f28e130c0a$var$_0n) return $eaac85f28e130c0a$var$_1n;
    if (power === $eaac85f28e130c0a$var$_1n) return num;
    let d = num % modulo;
    if (d < $eaac85f28e130c0a$var$_0n) d += modulo;
    // Control flow in both branches below depends only on the exponent, never on `num` — invertCt()
    // relies on that for its (public-exponent) secret-independence guarantee.
    if (power < $eaac85f28e130c0a$var$POW_WINDOWED_MIN) {
        // Square-and-multiply: cheaper than the windowed path for short exponents.
        let p = $eaac85f28e130c0a$var$_1n;
        while(power > $eaac85f28e130c0a$var$_0n){
            if (power & $eaac85f28e130c0a$var$_1n) p = p * d % modulo;
            d = d * d % modulo;
            power >>= $eaac85f28e130c0a$var$_1n;
        }
        return p;
    }
    // Fixed 4-bit windows, MSB-first: a 14-multiplication table drops per-window cost to <1
    // multiplication (vs ~2 per window for square-and-multiply), ~25-30% faster for the dense
    // 256-bit exponents of sqrt / Legendre / invertCt.
    const digits = [];
    while(power > $eaac85f28e130c0a$var$_0n){
        digits.push(Number(power & $eaac85f28e130c0a$var$_15n));
        power >>= $eaac85f28e130c0a$var$_4n;
    }
    const table = new Array(16);
    table[0] = $eaac85f28e130c0a$var$_1n;
    table[1] = d;
    for(let i = 2; i < 16; i++)table[i] = table[i - 1] * d % modulo;
    let p = table[digits[digits.length - 1]]; // top digit is nonzero: the loop above stops on 0
    for(let w = digits.length - 2; w >= 0; w--){
        p = p * p % modulo;
        p = p * p % modulo;
        p = p * p % modulo;
        p = p * p % modulo;
        const digit = digits[w];
        if (digit !== 0) p = p * table[digit] % modulo;
    }
    return p;
}
function $eaac85f28e130c0a$export$fa569bd808b67eef(x, power, modulo) {
    if (modulo <= $eaac85f28e130c0a$var$_1n) throw new Error('pow2: expected modulus > 1, got ' + modulo);
    if (power < $eaac85f28e130c0a$var$_0n) throw new Error('pow2: expected non-negative exponent, got ' + power);
    let res = x;
    while(power-- > $eaac85f28e130c0a$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $eaac85f28e130c0a$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $eaac85f28e130c0a$var$_0n) throw new Error('invert: expected non-zero number');
    // modulo = 1 is the zero ring: gcd(x, 1) = 1 makes the loop below "succeed" and return the
    // useless inverse 0. Reject it like pow() and invertCt() do.
    if (modulo <= $eaac85f28e130c0a$var$_1n) throw new Error('invert: expected modulus > 1, got ' + modulo);
    // This is variable-time: the loop count depends on `number`. For a secret-independent
    // (Fermat) alternative over a prime modulus, see {@link invertCt} (~4x slower).
    let a = $eaac85f28e130c0a$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // Only the Bézout coefficient of `number` (x/u chain) is tracked; the coefficient of `modulo`
    // never affects the output, so it is not computed.
    // prettier-ignore
    let x = $eaac85f28e130c0a$var$_0n, u = $eaac85f28e130c0a$var$_1n;
    while(a !== $eaac85f28e130c0a$var$_0n){
        const q = b / a;
        const r = b - a * q;
        const m = x - u * q;
        // prettier-ignore
        b = a, a = r, x = u, u = m;
    }
    const gcd = b;
    if (gcd !== $eaac85f28e130c0a$var$_1n) throw new Error('invert: does not exist');
    return $eaac85f28e130c0a$export$842a2cf37af977e1(x, modulo);
}
function $eaac85f28e130c0a$export$1dc1e1728368e49e(a, prime) {
    if (prime <= $eaac85f28e130c0a$var$_1n) throw new Error('invertCt: expected prime modulus > 1, got ' + prime);
    const an = $eaac85f28e130c0a$export$842a2cf37af977e1(a, prime);
    if (an === $eaac85f28e130c0a$var$_0n) throw new Error('invertCt: expected non-zero number');
    // Exponent (prime - 2) is public, so FpPow's square-and-multiply is secret-independent.
    const inverse = $eaac85f28e130c0a$export$9c297f60e22e3389(an, prime - $eaac85f28e130c0a$var$_2n, prime);
    // O(1) safety net: verifies the inverse and rejects composite moduli where a^(p-2) is not one.
    if ($eaac85f28e130c0a$export$842a2cf37af977e1(an * inverse, prime) !== $eaac85f28e130c0a$var$_1n) throw new Error('invertCt: does not exist');
    return inverse;
}
function $eaac85f28e130c0a$var$assertIsSquare(Fp, root, n) {
    const F = Fp;
    if (!F.eql(F.sqr(root), n)) throw new Error('Cannot find square root');
}
// The Legendre symbol and every sqrt variant here are only defined over an odd (prime) modulus.
// An even ORDER makes their integer divisions — (p-1)/2, (p+1)/4, (p-5)/8, (p+7)/16 — truncate and
// silently return a wrong result, so reject it explicitly at the entry points instead. This is a
// cheap necessary-condition check, not a primality test (composite odd moduli are caught later by
// the Legendre-result / assertIsSquare checks).
function $eaac85f28e130c0a$var$aoddModulus(order, fnName) {
    if ((order & $eaac85f28e130c0a$var$_1n) === $eaac85f28e130c0a$var$_0n) throw new Error(fnName + ': expected odd modulus, got ' + order);
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $eaac85f28e130c0a$var$sqrt3mod4(Fp, n) {
    const F = Fp;
    const p1div4 = (F.ORDER + $eaac85f28e130c0a$var$_1n) / $eaac85f28e130c0a$var$_4n;
    const root = F.pow(n, p1div4);
    $eaac85f28e130c0a$var$assertIsSquare(F, root, n);
    return root;
}
// Equivalent `q = 5 (mod 8)` square-root formula (Atkin-style), not the RFC Appendix I.2 CMOV
// pseudocode verbatim.
function $eaac85f28e130c0a$var$sqrt5mod8(Fp, n) {
    const F = Fp;
    const p5div8 = (F.ORDER - $eaac85f28e130c0a$var$_5n) / $eaac85f28e130c0a$var$_8n;
    const n2 = F.mul(n, $eaac85f28e130c0a$var$_2n);
    const v = F.pow(n2, p5div8);
    const nv = F.mul(n, v);
    const i = F.mul(F.mul(nv, $eaac85f28e130c0a$var$_2n), v);
    const root = F.mul(nv, F.sub(i, F.ONE));
    $eaac85f28e130c0a$var$assertIsSquare(F, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $eaac85f28e130c0a$var$sqrt9mod16(P) {
    const Fp_ = $eaac85f28e130c0a$export$a455218a85c89869(P);
    const tn = $eaac85f28e130c0a$export$69f29ab1f3e9a234(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $eaac85f28e130c0a$var$_7n) / $eaac85f28e130c0a$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        const F = Fp;
        let tv1 = F.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = F.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = F.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = F.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = F.eql(F.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = F.eql(F.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = F.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = F.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = F.eql(F.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = F.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $eaac85f28e130c0a$var$assertIsSquare(F, root, n);
        return root;
    };
}
function $eaac85f28e130c0a$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $eaac85f28e130c0a$var$_3n) throw new Error('sqrt is not defined for small field');
    $eaac85f28e130c0a$var$aoddModulus(P, 'tonelliShanks');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $eaac85f28e130c0a$var$_1n;
    let S = 0;
    while(Q % $eaac85f28e130c0a$var$_2n === $eaac85f28e130c0a$var$_0n){
        Q /= $eaac85f28e130c0a$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $eaac85f28e130c0a$var$_2n;
    const _Fp = $eaac85f28e130c0a$export$a455218a85c89869(P);
    while($eaac85f28e130c0a$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $eaac85f28e130c0a$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $eaac85f28e130c0a$var$_1n) / $eaac85f28e130c0a$var$_2n;
    return function tonelliSlow(Fp, n) {
        const F = Fp;
        if (F.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($eaac85f28e130c0a$export$77ed22730026dd0d(F, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = F.mul(F.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = F.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = F.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!F.eql(t, F.ONE)){
            // Unreachable over a genuine field (no zero divisors; n=0 already returned above). A zero t
            // means composite ORDER, where a fabricated root would be wrong: fail closed instead.
            if (F.is0(t)) throw new Error('Cannot find square root: probably non-prime P');
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = F.sqr(t); // t^(2^1)
            while(!F.eql(t_tmp, F.ONE)){
                i++;
                t_tmp = F.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $eaac85f28e130c0a$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = F.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = F.sqr(b); // c = b^2
            t = F.mul(t, c); // t = (t * b^2)
            R = F.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $eaac85f28e130c0a$export$33bda048c6b8ea7d(P) {
    $eaac85f28e130c0a$var$aoddModulus(P, 'Fp.sqrt');
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $eaac85f28e130c0a$var$_4n === $eaac85f28e130c0a$var$_3n) return $eaac85f28e130c0a$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $eaac85f28e130c0a$var$_8n === $eaac85f28e130c0a$var$_5n) return $eaac85f28e130c0a$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $eaac85f28e130c0a$var$_16n === $eaac85f28e130c0a$var$_9n) return $eaac85f28e130c0a$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $eaac85f28e130c0a$export$69f29ab1f3e9a234(P);
}
const $eaac85f28e130c0a$export$7806f13ad5078b2f = (num, modulo)=>($eaac85f28e130c0a$export$842a2cf37af977e1(num, modulo) & $eaac85f28e130c0a$var$_1n) === $eaac85f28e130c0a$var$_1n;
// prettier-ignore
// Arithmetic-only subset checked by validateField(). This is intentionally not the full runtime
// IField contract: helpers like `isValidNot0`, `invertBatch`, `toBytes`, `fromBytes`, `cmov`, and
// field-specific extras like `isOdd` are left to the callers that actually need them.
const $eaac85f28e130c0a$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $eaac85f28e130c0a$export$bd454f0cef11418d(field) {
    (0, $e129040e856338dd$export$829bca09b0bfc27a)(field, 'field');
    if (typeof field.ORDER !== 'bigint') throw new TypeError('param "ORDER" is invalid: expected bigint, got ' + typeof field.ORDER);
    // Runtime field implementations must expose real integer byte/bit sizes; fractional / NaN /
    // infinite metadata breaks encoders and caches.
    (0, $e129040e856338dd$export$4f3315d97e288446)(field.BYTES, 'BYTES');
    (0, $e129040e856338dd$export$4f3315d97e288446)(field.BITS, 'BITS');
    for (const name of $eaac85f28e130c0a$var$FIELD_FIELDS)(0, $e129040e856338dd$export$c0acea525719deb8)(field[name], 'field.' + name);
    // Runtime field implementations must expose positive byte/bit sizes; zero leaks through the
    // numeric shape checks above but still breaks encoding helpers and cached-length assumptions.
    if (field.BYTES < 1 || field.BITS < 1) throw new Error('invalid field: expected BYTES/BITS > 0');
    if (field.ORDER <= $eaac85f28e130c0a$var$_1n) throw new Error('invalid field: expected ORDER > 1, got ' + field.ORDER);
    return field;
}
function $eaac85f28e130c0a$export$5d8ce3717733a987(Fp, num, power) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    const F = Fp;
    // Non-bigint exponents (e.g. an accidental field element) coerce every comparison below to
    // false and would silently return ONE.
    if (typeof power !== 'bigint') throw new TypeError('invalid exponent: expected bigint, got ' + typeof power);
    if (power < $eaac85f28e130c0a$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $eaac85f28e130c0a$var$_0n) return F.ONE;
    if (power === $eaac85f28e130c0a$var$_1n) return num;
    if (power < $eaac85f28e130c0a$var$POW_WINDOWED_MIN) {
        // Square-and-multiply: cheaper than the windowed path for short exponents (e.g. poseidon
        // sbox x^5), which would waste the 14-multiplication table build.
        let p = F.ONE;
        let d = num;
        while(power > $eaac85f28e130c0a$var$_0n){
            if (power & $eaac85f28e130c0a$var$_1n) p = F.mul(p, d);
            d = F.sqr(d);
            power >>= $eaac85f28e130c0a$var$_1n;
        }
        return p;
    }
    // Fixed 4-bit windows, MSB-first — same shape as pow() above, over generic field ops.
    // Speeds up dense long exponents (extension-field sqrt / Legendre, e.g. Fp2 decompression).
    const digits = [];
    while(power > $eaac85f28e130c0a$var$_0n){
        digits.push(Number(power & $eaac85f28e130c0a$var$_15n));
        power >>= $eaac85f28e130c0a$var$_4n;
    }
    const table = new Array(16);
    table[0] = F.ONE;
    table[1] = num;
    for(let i = 2; i < 16; i++)table[i] = F.mul(table[i - 1], num);
    let p = table[digits[digits.length - 1]]; // top digit is nonzero: the loop above stops on 0
    for(let w = digits.length - 2; w >= 0; w--){
        p = F.sqr(F.sqr(F.sqr(F.sqr(p))));
        const digit = digits[w];
        if (digit !== 0) p = F.mul(p, table[digit]);
    }
    return p;
}
function $eaac85f28e130c0a$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    (0, $e129040e856338dd$export$c9895e5868d4e385)(nums, 'nums');
    (0, $e129040e856338dd$export$809304d28d77d92d)(passZero, 'passZero');
    const F = Fp;
    const inverted = new Array(nums.length).fill(passZero ? F.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (F.is0(num)) return acc;
        inverted[i] = acc;
        return F.mul(acc, num);
    }, F.ONE);
    // Invert last element
    const invertedAcc = F.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (F.is0(num)) return acc;
        // Non-zero `num` means the forward pass already stored a defined prefix product at index i.
        inverted[i] = F.mul(acc, inverted[i]);
        return F.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $eaac85f28e130c0a$export$e74c665040343df6(Fp, lhs, rhs) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    const F = Fp;
    return F.mul(lhs, typeof rhs === 'bigint' ? $eaac85f28e130c0a$export$6897c284b6f9f4dc(rhs, F.ORDER) : F.inv(rhs));
}
function $eaac85f28e130c0a$export$77ed22730026dd0d(Fp, n) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    const F = Fp;
    $eaac85f28e130c0a$var$aoddModulus(F.ORDER, 'FpLegendre');
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (F.ORDER - $eaac85f28e130c0a$var$_1n) / $eaac85f28e130c0a$var$_2n;
    const powered = F.pow(n, p1mod2);
    const yes = F.eql(powered, F.ONE);
    const zero = F.eql(powered, F.ZERO);
    const no = F.eql(powered, F.neg(F.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
function $eaac85f28e130c0a$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $eaac85f28e130c0a$export$77ed22730026dd0d(Fp, n);
    // Zero is a square too: 0 = 0^2, and Fp.sqrt(0) already returns 0.
    return l !== -1;
}
function $eaac85f28e130c0a$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $e129040e856338dd$export$75364c6cb16d43b6)(nBitLength);
    if (n <= $eaac85f28e130c0a$var$_0n) throw new Error('invalid n length: expected positive n, got ' + n);
    if (nBitLength !== undefined && nBitLength < 1) throw new Error('invalid n length: expected positive bit length, got ' + nBitLength);
    const bits = (0, $e129040e856338dd$export$e93ef600c41761a9)(n);
    // Cached bit lengths smaller than ORDER would truncate serialized scalars/elements and poison
    // any math that relies on the derived field metadata.
    if (nBitLength !== undefined && nBitLength < bits) throw new Error(`invalid n length: expected nBitLength (${nBitLength}) >= bitLen(n) (${bits})`);
    const _nBitLength = nBitLength !== undefined ? nBitLength : bits;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
// Keep the lazy sqrt cache off-instance so Field(...) can return a frozen object. Otherwise the
// cached helper write would keep the field surface externally mutable.
const $eaac85f28e130c0a$var$FIELD_SQRT = new WeakMap();
class $eaac85f28e130c0a$var$_Field {
    ORDER;
    BITS;
    BYTES;
    isLE;
    ZERO = $eaac85f28e130c0a$var$_0n;
    ONE = $eaac85f28e130c0a$var$_1n;
    _lengths;
    _mod;
    constructor(ORDER, opts = {}){
        // ORDER <= 1 is degenerate: ONE would not be a valid field element and helpers like pow/inv
        // would stop modeling field arithmetic.
        if (ORDER <= $eaac85f28e130c0a$var$_1n) throw new Error('invalid field: expected ORDER > 1, got ' + ORDER);
        let _nbitLength = undefined;
        this.isLE = false;
        if (opts != null && typeof opts === 'object') {
            // Cached bit lengths are trusted here and should already be positive / consistent with ORDER.
            if (typeof opts.BITS === 'number') _nbitLength = opts.BITS;
            if (typeof opts.sqrt === 'function') // `_Field.prototype` is frozen below, so custom sqrt hooks must become own properties
            // explicitly instead of relying on writable prototype shadowing via assignment.
            Object.defineProperty(this, 'sqrt', {
                value: opts.sqrt,
                enumerable: true
            });
            if (typeof opts.isLE === 'boolean') this.isLE = opts.isLE;
            if (opts.allowedLengths) this._lengths = Object.freeze(opts.allowedLengths.slice());
            if (typeof opts.modFromBytes === 'boolean') this._mod = opts.modFromBytes;
        }
        const { nBitLength: nBitLength, nByteLength: nByteLength } = $eaac85f28e130c0a$export$c79df43ecd7e66c2(ORDER, _nbitLength);
        if (nByteLength > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
        this.ORDER = ORDER;
        this.BITS = nBitLength;
        this.BYTES = nByteLength;
        Object.freeze(this);
    }
    create(num) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(num, this.ORDER);
    }
    isValid(num) {
        if (typeof num !== 'bigint') throw new TypeError('invalid field element: expected bigint, got ' + typeof num);
        return $eaac85f28e130c0a$var$_0n <= num && num < this.ORDER; // 0 is valid element, but it's not invertible
    }
    is0(num) {
        return num === $eaac85f28e130c0a$var$_0n;
    }
    // is valid and invertible
    isValidNot0(num) {
        return !this.is0(num) && this.isValid(num);
    }
    isOdd(num) {
        return (num & $eaac85f28e130c0a$var$_1n) === $eaac85f28e130c0a$var$_1n;
    }
    neg(num) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(-num, this.ORDER);
    }
    eql(lhs, rhs) {
        return lhs === rhs;
    }
    sqr(num) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(num * num, this.ORDER);
    }
    add(lhs, rhs) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(lhs + rhs, this.ORDER);
    }
    sub(lhs, rhs) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(lhs - rhs, this.ORDER);
    }
    mul(lhs, rhs) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(lhs * rhs, this.ORDER);
    }
    pow(num, power) {
        return $eaac85f28e130c0a$export$9c297f60e22e3389(num, power, this.ORDER);
    }
    div(lhs, rhs) {
        return $eaac85f28e130c0a$export$842a2cf37af977e1(lhs * $eaac85f28e130c0a$export$6897c284b6f9f4dc(rhs, this.ORDER), this.ORDER);
    }
    // Same as above, but doesn't normalize
    sqrN(num) {
        return num * num;
    }
    addN(lhs, rhs) {
        return lhs + rhs;
    }
    subN(lhs, rhs) {
        return lhs - rhs;
    }
    mulN(lhs, rhs) {
        return lhs * rhs;
    }
    inv(num) {
        return $eaac85f28e130c0a$export$6897c284b6f9f4dc(num, this.ORDER);
    }
    sqrt(num) {
        // Caching sqrt helpers speeds up sqrt9mod16 by 5x and Tonelli-Shanks by about 10% without keeping
        // the field instance itself mutable.
        let sqrt = $eaac85f28e130c0a$var$FIELD_SQRT.get(this);
        if (!sqrt) $eaac85f28e130c0a$var$FIELD_SQRT.set(this, sqrt = $eaac85f28e130c0a$export$33bda048c6b8ea7d(this.ORDER));
        return sqrt(this, num);
    }
    toBytes(num) {
        // Serialize fixed-width limbs without re-validating the field range. Callers that need a
        // canonical encoding must pass a valid element; some protocols intentionally serialize raw
        // residues here and reduce or validate them elsewhere.
        return this.isLE ? (0, $e129040e856338dd$export$ba2172e58d139f6d)(num, this.BYTES) : (0, $e129040e856338dd$export$1459dafd057611cb)(num, this.BYTES);
    }
    fromBytes(bytes, skipValidation = false) {
        (0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes);
        const { _lengths: allowedLengths, BYTES: BYTES, isLE: isLE, ORDER: ORDER, _mod: modFromBytes } = this;
        if (allowedLengths) {
            // `allowedLengths` must list real positive byte lengths; otherwise empty input would get
            // padded into zero and silently decode as a field element.
            if (bytes.length < 1 || !allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
            const padded = new Uint8Array(BYTES);
            // isLE add 0 to right, !isLE to the left.
            padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
            bytes = padded;
        }
        if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
        let scalar = isLE ? (0, $e129040e856338dd$export$d67b1d03392107e7)(bytes) : (0, $e129040e856338dd$export$d609354794974f8)(bytes);
        if (modFromBytes) scalar = $eaac85f28e130c0a$export$842a2cf37af977e1(scalar, ORDER);
        if (!skipValidation) {
            if (!this.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
        }
        // Range validation is optional here because some protocols intentionally decode raw residues
        // and reduce or validate them elsewhere.
        return scalar;
    }
    // TODO: we don't need it here, move out to separate fn
    invertBatch(lst) {
        // `passZero` keeps the `bigint[]` contract honest: zero inputs map to `0` instead of leaking
        // `undefined` into a `bigint[]`. Callers that must distinguish non-invertible inputs should use
        // `FpInvertBatch` directly, whose default omits `passZero` and returns `(bigint | undefined)[]`.
        return $eaac85f28e130c0a$export$a492e3387142c0e9(this, lst, true);
    }
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov(a, b, condition) {
        // Field elements have `isValid(...)`; the CMOV branch bit is a direct runtime input, so reject
        // non-boolean selectors here instead of letting JS truthiness silently change arithmetic.
        (0, $e129040e856338dd$export$809304d28d77d92d)(condition, 'condition');
        return condition ? b : a;
    }
}
function $eaac85f28e130c0a$export$a455218a85c89869(ORDER, opts = {}) {
    // Freeze the shared method surface before any instance is reachable; otherwise callers can
    // poison every Field instance by monkey-patching `_Field.prototype` even if each instance is
    // frozen. Freezing here instead of module scope keeps `_Field` tree-shakeable for importers
    // that never construct a field; the call is idempotent and cheap.
    Object.freeze($eaac85f28e130c0a$var$_Field.prototype);
    return new $eaac85f28e130c0a$var$_Field(ORDER, opts);
}
function $eaac85f28e130c0a$export$7acc54692c525d2a(Fp, elm) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    const F = Fp;
    if (!F.isOdd) throw new Error("Field doesn't have isOdd");
    const root = F.sqrt(elm);
    return F.isOdd(root) ? root : F.neg(root);
}
function $eaac85f28e130c0a$export$1d7b691df0888e02(Fp, elm) {
    $eaac85f28e130c0a$export$bd454f0cef11418d(Fp);
    const F = Fp;
    if (!F.isOdd) throw new Error("Field doesn't have isOdd");
    const root = F.sqrt(elm);
    return F.isOdd(root) ? F.neg(root) : root;
}
function $eaac85f28e130c0a$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    // Valid field elements are in 0..ORDER-1, so ORDER <= 1 would make the encoded range degenerate.
    if (fieldOrder <= $eaac85f28e130c0a$var$_1n) throw new Error('field order must be greater than 1');
    // Valid field elements are < ORDER, so the maximal encoded element is ORDER - 1.
    const bitLength = (0, $e129040e856338dd$export$e93ef600c41761a9)(fieldOrder - $eaac85f28e130c0a$var$_1n);
    return Math.ceil(bitLength / 8);
}
function $eaac85f28e130c0a$export$d058763b563056af(fieldOrder) {
    const length = $eaac85f28e130c0a$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $eaac85f28e130c0a$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    (0, $e129040e856338dd$export$e8a750b9efad93f5)(key);
    const len = key.length;
    const fieldLen = $eaac85f28e130c0a$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = Math.max($eaac85f28e130c0a$export$d058763b563056af(fieldOrder), 16);
    // No toy-small inputs: the helper is for real scalar derivation, not tiny test curves. No huge
    // inputs: easier to reason about JS timing / allocation behavior.
    if (len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $e129040e856338dd$export$d67b1d03392107e7)(key) : (0, $e129040e856338dd$export$d609354794974f8)(key);
    // Map into the non-zero scalar range [1, fieldOrder-1]: reduce mod (fieldOrder-1) to land in
    // [0, fieldOrder-2], then add 1. This shifts the range off zero; it is NOT equal to
    // `mod(num, fieldOrder)` (which spans [0, fieldOrder-1] and can be 0). A residual modulo bias
    // remains but is negligible (~2^-(nBits/2), e.g. ~2^-128 for a 256-bit order) because `key` is
    // required to be at least `getMinHashLength(fieldOrder)` (~1.5x field size) bytes of input.
    const reduced = $eaac85f28e130c0a$export$842a2cf37af977e1(num, fieldOrder - $eaac85f28e130c0a$var$_1n) + $eaac85f28e130c0a$var$_1n;
    return isLE ? (0, $e129040e856338dd$export$ba2172e58d139f6d)(reduced, fieldLen) : (0, $e129040e856338dd$export$1459dafd057611cb)(reduced, fieldLen);
}


const $4f109436b1b5c1eb$var$_0n = /* @__PURE__ */ BigInt(0);
const $4f109436b1b5c1eb$var$_1n = /* @__PURE__ */ BigInt(1);
const $4f109436b1b5c1eb$var$_4n = /* @__PURE__ */ BigInt(4);
const $4f109436b1b5c1eb$var$BLIND_BYTES = 16;
const $4f109436b1b5c1eb$var$BLIND_BITS = 128;
// Fixed-window width for the constant-time multiply of un-precomputed points (W===1).
// A flat 2^FW_WINDOW table has a small, scalar-independent build cost that amortizes over a single
// multiply, unlike the larger per-point wNAF tables that only pay off when cached.
const $4f109436b1b5c1eb$var$FW_WINDOW = 5;
// Precompute tables are capped at ~2 GiB of estimated heap. Rejecting larger windows up front
// turns a typo'd window size into an immediate error instead of a multi-GB allocation (or an
// effective hang) when the lazy table is built on first multiply.
const $4f109436b1b5c1eb$var$TABLE_BYTES_MAX = /* @__PURE__ */ (()=>2 ** 31)();
function $4f109436b1b5c1eb$export$facc60e77e5ab0c2(Point) {
    const pc = Point;
    if (typeof pc !== 'function') throw new TypeError('"Point" expected constructor, got type=' + typeof Point);
    (0, $e129040e856338dd$export$c0acea525719deb8)(pc.fromAffine, 'Point.fromAffine');
    (0, $e129040e856338dd$export$c0acea525719deb8)(pc.fromBytes, 'Point.fromBytes');
    (0, $e129040e856338dd$export$c0acea525719deb8)(pc.fromHex, 'Point.fromHex');
    // Generic helpers (ScalarMultiplier, normalizeZ, MSM) dereference BASE / ZERO:
    // fail here with a typed error instead of an `undefined` access later.
    (0, $e129040e856338dd$export$829bca09b0bfc27a)(pc.BASE, 'Point.BASE');
    (0, $e129040e856338dd$export$829bca09b0bfc27a)(pc.ZERO, 'Point.ZERO');
    (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(pc.Fp);
    (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(pc.Fn);
}
function $4f109436b1b5c1eb$export$bc27bc65d7bff1c7(c, points) {
    // Match MSM helpers: reject malformed public inputs before reading projective internals.
    $4f109436b1b5c1eb$export$facc60e77e5ab0c2(c);
    $4f109436b1b5c1eb$var$validateMSMPoints(points, c);
    // Identity points (Z=0) rely on an implicit contract: FpInvertBatch without `passZero`
    // yields `undefined` for zero inputs, and `toAffine(undefined)` falls back to its internal
    // is0 handling instead of using the batch inverse.
    const invertedZs = (0, $eaac85f28e130c0a$export$a492e3387142c0e9)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $4f109436b1b5c1eb$var$validateW(W, bits, min = 1) {
    if (!Number.isSafeInteger(W) || W < min || W > bits) throw new Error('invalid window size, expected [' + min + '..' + bits + '], got W=' + W);
}
// Rough per-point heap estimate for the {@link TABLE_BYTES_MAX} cap: up to 4 projective/extended
// coordinates of Fp.BYTES each, plus bigint/object overhead. Callers pass the point count of the
// largest table the checked parameters can produce.
function $4f109436b1b5c1eb$var$validateTableBytes(numPoints, fpBytes) {
    const bytes = numPoints * (4 * fpBytes + 128);
    if (bytes > $4f109436b1b5c1eb$var$TABLE_BYTES_MAX) throw new Error('invalid window size: table would need ~' + Math.ceil(bytes / 2 ** 20) + ' MiB, max ' + $4f109436b1b5c1eb$var$TABLE_BYTES_MAX / 2 ** 20 + ' MiB');
}
function $4f109436b1b5c1eb$export$c3ee88a08062d41c(randomBytes, length) {
    if (randomBytes === undefined) return undefined;
    (0, $e129040e856338dd$export$c0acea525719deb8)(randomBytes, 'randomBytes');
    try {
        const probe = randomBytes(length);
        if (!(0, $e129040e856338dd$export$c6fabfbfd097fc30)(probe) || probe.length !== length) return undefined;
    } catch  {
        return undefined;
    }
    return randomBytes;
}
function $4f109436b1b5c1eb$var$validateMSMPoints(points, c) {
    (0, $e129040e856338dd$export$c9895e5868d4e385)(points, 'points');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
// Default bound is field membership (0 <= s < field.ORDER); a `maxScalar` override widens it
// to 0 <= s < maxScalar for callers that accept oversized scalars.
function $4f109436b1b5c1eb$var$validateMSMScalars(scalars, field, maxScalar) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        const ok = maxScalar === undefined ? field.isValid(s) : (0, $e129040e856338dd$export$ca489aba7178a82)(s) && s < maxScalar;
        if (!ok) throw new Error('invalid scalar at index ' + i);
    });
}
const $4f109436b1b5c1eb$var$pointWindowSizes = new WeakMap();
function $4f109436b1b5c1eb$var$getWindowSize(P) {
    // `1` is the uncached sentinel: use the non-precomputed (wNAF / fixed-window) path.
    return $4f109436b1b5c1eb$var$pointWindowSizes.get(P) || 1;
}
/** Table of odd multiples [1P, 3P, ..., (2⋅size−1)P]; width-W wNAF uses size = 2^(W−2). */ function $4f109436b1b5c1eb$var$oddMultiples(p, size) {
    const dbl = p.double();
    const t = [
        p
    ];
    for(let j = 1; j < size; j++)t.push(t[j - 1].add(dbl));
    return t;
}
/**
 * Width-W wNAF signed-digit recoding (W >= 2), LSB-first: digits are 0 or odd with
 * |digit| < 2^(W−1); nonzero density ~1/(W+1) (a nonzero digit is followed by W−1 zeros).
 */ function $4f109436b1b5c1eb$var$wnafDigits(n, W) {
    const size = 2 ** W;
    const half = size / 2;
    const mask = BigInt(size - 1);
    const d = [];
    while(n > $4f109436b1b5c1eb$var$_0n){
        let w = 0;
        if (n & $4f109436b1b5c1eb$var$_1n) {
            w = Number(n & mask); // n mod 2^W, odd
            if (w >= half) w -= size; // signed residue
            n -= BigInt(w); // n - w ≡ 0 mod 2^W: next W−1 digits are zero
        }
        d.push(w);
        n >>= $4f109436b1b5c1eb$var$_1n;
    }
    return d;
}
/**
 * Fixed-position signed-window recoding for precomputed wNAF: `n = Σ digits[w]⋅2^(w⋅W)` with
 * digits in `[−2^(W−1)+1, 2^(W−1)]`. Digit count is fixed by `windows` (callers reserve one
 * extra window for the final carry), so recoding length does not depend on the scalar.
 */ function $4f109436b1b5c1eb$var$signedWindowDigits(n, W, windows) {
    const size = 2 ** W;
    const half = size / 2;
    const mask = BigInt(size - 1);
    const shiftBy = BigInt(W);
    const d = [];
    for(let w = 0; w < windows; w++){
        let v = Number(n & mask);
        n >>= shiftBy;
        if (v > half) {
            v -= size; // negative digit, carry into the next window
            n += $4f109436b1b5c1eb$var$_1n;
        }
        d.push(v);
    }
    // Internal invariant: leftover bits mean the window count did not cover the scalar.
    if (n !== $4f109436b1b5c1eb$var$_0n) throw new Error('invalid wnaf');
    return d;
}
/**
 * Shared vartime walk over per-scalar wNAF digit streams: one doubling of a single shared
 * accumulator per bit position of the longest recoding, one signed table addition per
 * nonzero digit. `tables[i]` must hold the odd multiples of the i-th point.
 */ function $4f109436b1b5c1eb$var$wnafWalk(zero, tables, digits) {
    let max = 0;
    for (const d of digits)max = Math.max(max, d.length);
    let acc = zero;
    for(let bit = max - 1; bit >= 0; bit--){
        if (bit !== max - 1) acc = acc.double();
        for(let i = 0; i < digits.length; i++){
            const w = digits[i][bit]; // reads past shorter recodings yield undefined, skipped below
            if (w) {
                const item = tables[i][Math.abs(w) - 1 >> 1];
                acc = acc.add(w < 0 ? item.negate() : item);
            }
        }
    }
    return acc;
}
class $4f109436b1b5c1eb$export$e102566b07be6df2 {
    Point;
    BASE;
    ZERO;
    randomBytes;
    wnafPrecomputes = new WeakMap();
    baseCanBeBlinded;
    bits;
    // Parametrized with a given Point class (not individual point)
    constructor(Point, randomBytes){
        $4f109436b1b5c1eb$export$facc60e77e5ab0c2(Point);
        // Probe the RNG once (see {@link probeRandomBytes}): in environments without working
        // randomness (e.g. no WebCrypto), shouldBlind() then routes secret multiplication to the
        // unblinded constant-time path instead of throwing on every multiply(). The shape of
        // returned bytes is still validated on every blinded call, where breakage fails closed.
        this.randomBytes = $4f109436b1b5c1eb$export$c3ee88a08062d41c(randomBytes, $4f109436b1b5c1eb$var$BLIND_BYTES);
        this.Point = Point;
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.bits = Point.Fn.BITS;
    }
    /**
     * Creates a signed fixed-window wNAF precomputation table: for every window w, the
     * multiples `[1..2^(W−1)]⋅2^(w⋅W)⋅P`, flattened. All doublings are baked into the table,
     * so cached multiplication is additions-only. `windows = ceil(bits/W) + 1`: the extra
     * window absorbs the final carry of signed-digit recoding.
     * For a 256-bit curve and W=6, the table is 44⋅32 = 1408 points.
     * @param point - Point instance
     * @param W - window size
     * @param bits - scalar bitlength the table must cover
     */ buildWnafTable(point, W, bits) {
        // W needs no re-validation: its only source is setWindowSize(), which enforces
        // 1 <= W <= Fn.BITS <= bits (the blinded path only ever widens bits) and caps the
        // resulting table at ~2 GiB (sized against the wider blinded layout).
        const windows = Math.ceil(bits / W) + 1;
        const half = 2 ** (W - 1);
        const comp = [];
        let base = point;
        for(let w = 0; w < windows; w++){
            let acc = base;
            for(let i = 0; i < half; i++){
                comp.push(acc);
                acc = acc.add(base);
            }
            base = comp[comp.length - 1].double(); // 2⋅(2^(W−1)⋅base) = next window's base
        }
        return {
            W: W,
            bits: bits,
            windows: windows,
            comp: comp
        };
    }
    /**
     * Implements ec multiplication using precomputed signed fixed-window wNAF tables.
     * Constant-time: fixed window count with one table addition per window — zero digits feed
     * the fake accumulator — and no doublings; the lookup scans the whole window slice.
     * Scalar bounds are validated by the public entry points ({@link ScalarMultiplier.mulCT},
     * {@link ScalarMultiplier.mulCTBlinded}, {@link ScalarMultiplier.mulUnsafe});
     * signedWindowDigits throws if `n` exceeds the table.
     * @returns real and fake (for const-time) points
     */ wnafCachedCT(precomputes, n) {
        const { W: W, windows: windows, comp: comp } = precomputes;
        const half = 2 ** (W - 1);
        const digits = $4f109436b1b5c1eb$var$signedWindowDigits(n, W, windows);
        let p = this.ZERO;
        let f = this.BASE;
        for(let w = 0; w < windows; w++){
            const digit = digits[w];
            const start = w * half;
            // Data-oblivious select: touch every entry of the window before the digit branch.
            const idx = Math.abs(digit) - 1; // -1 for zero digits: matches nothing, `sel` unused
            let sel = comp[start];
            for(let i = 1; i < half; i++)sel = i === idx ? comp[start + i] : sel;
            const neg = sel.negate(); // compute both signs; the digit only picks one
            if (digit === 0) f = f.add(comp[start]);
            else p = p.add(digit < 0 ? neg : sel);
        }
        return {
            p: p,
            f: f
        };
    }
    // Cache key is point identity plus (W, bits); at most two entries exist per point (public-width
    // `Fn.BITS` and blinded `Fn.BITS + BLIND_BITS`). Callers must not reuse the same point with
    // incompatible `transform(...)` layouts and expect a separate cache entry.
    getWnafPrecomputes(W, point, bits, transform) {
        let entries = this.wnafPrecomputes.get(point);
        let comp = entries?.find((entry)=>entry.W === W && entry.bits === bits);
        if (!comp) {
            comp = this.buildWnafTable(point, W, bits);
            if (typeof transform === 'function') comp = {
                ...comp,
                comp: transform(comp.comp)
            };
            if (!entries) {
                entries = [];
                this.wnafPrecomputes.set(point, entries);
            }
            entries.push(comp);
        }
        return comp;
    }
    assertPoint(point) {
        if (!(point instanceof this.Point)) throw new TypeError('"point" expected Point instance, got type=' + typeof point);
    }
    // Shared prologue of the constant-time entry points. Rejects scalar 0: in key/signature-style
    // callers a zero scalar means broken upstream plumbing, and concrete Points already reject it.
    // Uses inRange instead of Fn.isValidNot0: validateField() only certifies the arithmetic subset.
    validateMulInput(point, scalar) {
        this.assertPoint(point);
        if (!(0, $e129040e856338dd$export$ddf89a9c5af38f94)(scalar, $4f109436b1b5c1eb$var$_1n, this.Point.Fn.ORDER)) throw new Error('invalid scalar');
    }
    // Constant-time dispatch shared by mulCT / mulCTBlinded. Un-precomputed points (W===1, e.g.
    // ECDH peer keys) skip building a throwaway cached table in favor of a small fixed-window
    // multiply. `n` must be < 2^bits.
    runCT(point, n, bits, transform) {
        const W = $4f109436b1b5c1eb$var$getWindowSize(point);
        if (W === 1) return this.fixedWindowCT(point, n, bits);
        return this.wnafCachedCT(this.getWnafPrecomputes(W, point, bits, transform), n);
    }
    mulCT(point, scalar, transform) {
        this.validateMulInput(point, scalar);
        return this.runCT(point, scalar, this.bits, transform);
    }
    mulCTBlinded(point, scalar, transform) {
        this.validateMulInput(point, scalar);
        // Blinding computes n = scalar + blind*Fn.ORDER, then n*P via a constant-time multiply. This
        // equals scalar*P only when Fn.ORDER*P == O; callers guarantee that via shouldBlind() (always
        // for cofactor-1 curves; for cofactored curves only BASE, and only after checking BASE*n == O).
        // Fail before building the (large) precompute table if randomness is unavailable.
        if (this.randomBytes === undefined) throw new Error('randomBytes is required for scalar blinding');
        const bits = this.Point.Fn.BITS + $4f109436b1b5c1eb$var$BLIND_BITS;
        const blind = this.randomBytes($4f109436b1b5c1eb$var$BLIND_BYTES);
        if (!(0, $e129040e856338dd$export$c6fabfbfd097fc30)(blind) || blind.length !== $4f109436b1b5c1eb$var$BLIND_BYTES) throw new Error('randomBytes returned invalid byte array');
        // Force the top two bits of the 128-bit blind to 10xxxxxx, so blind is in [2^127, 1.5*2^127):
        // * `| 0x80` (bit 127 = 1) is the load-bearing part: it guarantees blind >= 2^127, so the blind
        //   is always a full-width, nonzero factor and the scalar is masked even with a degenerate RNG.
        // * `& 0x3f` (bit 126 = 0) is a safety margin: it caps blind < 1.5*2^127, keeping
        //   blind*Fn.ORDER + scalar < 0.75*2^(nBits+128), i.e. ~half a window below the 2^(nBits+128)
        //   ceiling. Not strictly required for the bound (see below), but it reserves headroom so the
        //   guarantee does not rest on the tight `Fn.ORDER < 2^Fn.BITS` fact and the final carry window
        //   only ever holds a small carry, never a full digit.
        blind[0] = blind[0] & 0x3f | 0x80;
        // Even at the extreme (blind < 2^128, scalar < Fn.ORDER < 2^nBits): n <= 2^128*Fn.ORDER - 1 <
        // 2^(nBits+128), so n stays below 2^bits and within the blinded table's
        // window count. Both cached CT kernels run a fixed number of windows/rows with one point-add
        // each, so the add count is independent of scalar (constant-time).
        const n = scalar + (0, $e129040e856338dd$export$d609354794974f8)(blind) * this.Point.Fn.ORDER;
        return this.runCT(point, n, bits, transform);
    }
    /**
     * Constant-time multiplication `n*point` for an un-precomputed point, via a small fixed window.
     * A cached wNAF table only pays off when reused; a flat 2^FW_WINDOW table (`size-1` adds) is
     * far cheaper to build for a single use. The point-operation sequence is independent of `n`:
     * build the table, then per window exactly FW_WINDOW doublings, a data-oblivious scan over
     * every table entry, and one addition (adds the identity when the window digit is 0 — never
     * skipped).
     *
     * `n` must be `< 2^bits`. Assumes complete addition (adding the identity costs the same as any
     * add), which holds for the Weierstrass/Edwards point types used here. The table is left in
     * projective form (no normalizeZ): normalizing this small a table costs more than the
     * mixed-add savings it would buy for a single multiply.
     * @returns real point `p`; `f` duplicates it only to match {@link wnafCachedCT}'s return shape
     * (this path needs no fake accumulator — its op-count is already scalar-independent).
     */ fixedWindowCT(point, n, bits) {
        const W = $4f109436b1b5c1eb$var$FW_WINDOW;
        const size = 1 << W;
        const mask = (0, $e129040e856338dd$export$803efa2fa1c7279)(W);
        // Flat table [O, point, 2*point, ..., (size-1)*point].
        const table = new Array(size);
        table[0] = this.ZERO;
        for(let i = 1; i < size; i++)table[i] = table[i - 1].add(point);
        // Horner MSB->LSB. windows*W >= bits and n < 2^bits, so every bit of n is consumed.
        const windows = Math.ceil(bits / W);
        let acc = this.ZERO;
        for(let window = windows - 1; window >= 0; window--){
            // W doublings per window; skipped for the first (topmost) window, where acc is still the
            // identity. The skip is scalar-independent: it depends only on the loop index.
            if (window !== windows - 1) for(let d = 0; d < W; d++)acc = acc.double();
            const digit = Number(n >> BigInt(window * W) & mask);
            // Data-oblivious select: touch every entry, same as wnafCachedCT.
            let sel = table[0];
            for(let i = 1; i < size; i++)sel = i === digit ? table[i] : sel;
            acc = acc.add(sel); // one add per window, even for digit 0
        }
        return {
            p: acc,
            f: acc
        };
    }
    shouldBlind(point, cofactor) {
        // No usable RNG (probed in the constructor): blinding is impossible, use the plain CT path.
        if (this.randomBytes === undefined) return false;
        if (cofactor === $4f109436b1b5c1eb$var$_1n) return true;
        if (point !== this.BASE) return false;
        if (this.baseCanBeBlinded === undefined) this.baseCanBeBlinded = this.mulUnsafe(this.BASE, this.Point.Fn.ORDER).is0();
        return this.baseCanBeBlinded;
    }
    mulSecret(point, scalar, cofactor, transform) {
        return this.shouldBlind(point, cofactor) ? this.mulCTBlinded(point, scalar, transform) : this.mulCT(point, scalar, transform);
    }
    mulUnsafe(point, scalar, transform) {
        this.assertPoint(point);
        if (!(0, $e129040e856338dd$export$ca489aba7178a82)(scalar)) throw new Error('invalid scalar');
        const W = $4f109436b1b5c1eb$var$getWindowSize(point);
        // W === 1 (un-precomputed): one-shot width-4 wNAF via {@link mulAddUnsafe} with L=1 —
        // a cached table would be thrown away after one use. `allowOversized` swaps the
        // `s < Fn.ORDER` check for mulAddUnsafe's `Fn.ORDER^4` DoS cap.
        //
        // Oversized scalar could happen when:
        // a) user passes large scalar on their own (rare)
        // b) `assertValidity()` calls `isTorsionFree()`, which multiplies point by `Fn.ORDER`
        if (W === 1 || scalar >= this.Point.Fn.ORDER) return $4f109436b1b5c1eb$export$4eb79287de74dd6(this.Point, [
            point
        ], [
            scalar
        ], true);
        // Precomputed points reuse the CT kernel (fake accumulator discarded): with W=6 only
        // ~1/64 of window-adds are skippable, so a dedicated vartime kernel saved just ~6% on
        // this path while doubling the cached-table code surface.
        const precomputes = this.getWnafPrecomputes(W, point, this.bits, transform);
        return this.wnafCachedCT(precomputes, scalar).p;
    }
    // Remembers the window size used for precomputed wNAF multiplication of the given point
    // and drops any previously built tables. Usually only the base point is precomputed.
    // W=1 resets the point to the un-precomputed (table-less) paths.
    // W is additionally capped so tables stay under ~2 GiB ({@link TABLE_BYTES_MAX}).
    setWindowSize(point, W) {
        this.assertPoint(point);
        $4f109436b1b5c1eb$var$validateW(W, this.bits);
        // Size against the widest table this W can produce: the blinded path adds BLIND_BITS.
        const windows = Math.ceil((this.bits + $4f109436b1b5c1eb$var$BLIND_BITS) / W) + 1;
        $4f109436b1b5c1eb$var$validateTableBytes(windows * 2 ** (W - 1), this.Point.Fp.BYTES);
        $4f109436b1b5c1eb$var$pointWindowSizes.set(point, W);
        this.wnafPrecomputes.delete(point);
    }
    // True when a window size is set: tables themselves are built lazily on first multiply.
    hasWindowSize(point) {
        return $4f109436b1b5c1eb$var$getWindowSize(point) !== 1;
    }
}
function $4f109436b1b5c1eb$export$4eb79287de74dd6(c, points, scalars, allowOversized = false) {
    $4f109436b1b5c1eb$export$facc60e77e5ab0c2(c);
    $4f109436b1b5c1eb$var$validateMSMPoints(points, c);
    (0, $e129040e856338dd$export$809304d28d77d92d)(allowOversized, 'allowOversized');
    // Oversized cap is ORDER^4: hard bound to mitigate DoS, walk length grows with bitLen(s).
    $4f109436b1b5c1eb$var$validateMSMScalars(scalars, c.Fn, allowOversized ? c.Fn.ORDER ** $4f109436b1b5c1eb$var$_4n : undefined);
    if (points.length !== scalars.length) throw new Error('arrays of points and scalars must have equal length');
    const tables = points.map((p)=>$4f109436b1b5c1eb$var$oddMultiples(p, 4));
    const digits = scalars.map((n)=>$4f109436b1b5c1eb$var$wnafDigits(n, 4));
    return $4f109436b1b5c1eb$var$wnafWalk(c.ZERO, tables, digits);
}
function $4f109436b1b5c1eb$export$8e2f6717424463a3(c, points, scalars) {
    // 0 is accepted in scalars
    $4f109436b1b5c1eb$export$facc60e77e5ab0c2(c);
    const fieldN = c.Fn;
    $4f109436b1b5c1eb$var$validateMSMPoints(points, c);
    $4f109436b1b5c1eb$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    const zero = c.ZERO;
    // Without this, the window loop below would still run ~Fn.BITS doublings of ZERO.
    if (plength === 0) return zero;
    const wbits = (0, $e129040e856338dd$export$e93ef600c41761a9)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $e129040e856338dd$export$803efa2fa1c7279)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function $4f109436b1b5c1eb$export$c4614785255c78d6(c, points, windowSize) {
    $4f109436b1b5c1eb$export$facc60e77e5ab0c2(c);
    const fieldN = c.Fn;
    // Signed odd digits need at least width 2 (W=2 is plain NAF with a single-entry table).
    $4f109436b1b5c1eb$var$validateW(windowSize, fieldN.BITS, 2);
    $4f109436b1b5c1eb$var$validateMSMPoints(points, c);
    $4f109436b1b5c1eb$var$validateTableBytes(points.length * 2 ** (windowSize - 2), c.Fp.BYTES);
    const tables = points.map((p)=>$4f109436b1b5c1eb$var$oddMultiples(p, 2 ** (windowSize - 2)));
    return (scalars)=>{
        $4f109436b1b5c1eb$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must not be larger than array of points');
        return $4f109436b1b5c1eb$var$wnafWalk(c.ZERO, tables, scalars.map((n)=>$4f109436b1b5c1eb$var$wnafDigits(n, windowSize)));
    };
}
function $4f109436b1b5c1eb$var$createField(order, field, isLE) {
    if (field) {
        // Reuse supplied field overrides as-is; `isLE` only affects freshly constructed fallback
        // fields, and validateField() below only checks the arithmetic subset, not full byte/cmov
        // behavior.
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(field);
        return field;
    } else return (0, $eaac85f28e130c0a$export$a455218a85c89869)(order, {
        isLE: isLE
    });
}
function $4f109436b1b5c1eb$export$1fe76009d71a4957(type, CURVE, curveOpts = {}, FpFnLE) {
    if (type !== 'weierstrass' && type !== 'edwards') throw new Error('expected curve type "weierstrass" or "edwards"');
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    // Validate before reading Fp/Fn so explicit null fails with an options-object error.
    (0, $e129040e856338dd$export$381bae2d0f08004f)(curveOpts);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!((0, $e129040e856338dd$export$ca489aba7178a82)(val) && val !== $4f109436b1b5c1eb$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $4f109436b1b5c1eb$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $4f109436b1b5c1eb$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}
function $4f109436b1b5c1eb$export$f3f81ccca4e43a9b(randomSecretKey, getPublicKey) {
    return function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    };
}


/**
 * FROST: Flexible Round-Optimized Schnorr Threshold Protocol for Two-Round Schnorr Signatures.
 *
 * See {@link https://datatracker.ietf.org/doc/rfc9591/ | RFC 9591} and
 * {@link https://frost.zfnd.org | frost.zfnd.org}.
 * @module
 */ 


/**
 * Experimental implementation of NTT / FFT (Fast Fourier Transform) over finite fields.
 * API may change at any time. The code has not been audited. Feature requests are welcome.
 * @module
 */ 

function $fbf8e91788516fb2$var$checkU32(n, title = 'n') {
    // 0xff_ff_ff_ff
    if (typeof n !== 'number') throw new TypeError(`wrong u32 integer "${title}": expected number, got type=${typeof n}`);
    if (!Number.isSafeInteger(n) || n < 0 || n > 0xffffffff) throw new RangeError(`wrong u32 integer "${title}": expected 0..4294967295, got ${n}`);
    return n;
}
function $fbf8e91788516fb2$export$b9e43d1765415474(x) {
    $fbf8e91788516fb2$var$checkU32(x, 'x');
    return (x & x - 1) === 0 && x !== 0;
}
function $fbf8e91788516fb2$export$239a7ba740cbf2bf(n) {
    $fbf8e91788516fb2$var$checkU32(n);
    if (n <= 1) return 1;
    // FFT sizes here are used as JS array lengths, so `2^32` is not a meaningful result:
    // keep the fast u32 bit-twiddling path and fail explicitly instead of wrapping to 1.
    if (n > 0x80000000) throw new Error('nextPowerOfTwo overflow: result does not fit u32');
    return 1 << $fbf8e91788516fb2$export$b9fae0bba9d9094d(n - 1) + 1 >>> 0;
}
function $fbf8e91788516fb2$export$efa94c94777a40b4(n, bits) {
    $fbf8e91788516fb2$var$checkU32(n);
    if (typeof bits !== 'number') throw new TypeError('"bits" expected number, got type=' + typeof bits);
    if (!Number.isSafeInteger(bits) || bits < 0 || bits > 32) throw new Error(`expected integer 0 <= bits <= 32, got ${bits}`);
    let reversed = 0;
    for(let i = 0; i < bits; i++, n >>>= 1)reversed = reversed << 1 | n & 1;
    // JS bitwise ops are signed i32; cast back so 32-bit reversals stay in the unsigned u32 domain.
    return reversed >>> 0;
}
function $fbf8e91788516fb2$export$b9fae0bba9d9094d(n) {
    $fbf8e91788516fb2$var$checkU32(n);
    return 31 - Math.clz32(n);
}
function $fbf8e91788516fb2$export$73c02b8e328c7ddf(values) {
    if (!values || typeof values !== 'object' || typeof values.length !== 'number') throw new TypeError('"values" expected array-like, got type=' + typeof values);
    const n = values.length;
    // Size-1 FFT is the identity, so bit-reversal must stay a no-op there instead of rejecting it.
    if (!$fbf8e91788516fb2$export$b9e43d1765415474(n)) throw new Error('expected positive power-of-two length, got ' + n);
    const bits = $fbf8e91788516fb2$export$b9fae0bba9d9094d(n);
    for(let i = 0; i < n; i++){
        const j = $fbf8e91788516fb2$export$efa94c94777a40b4(i, bits);
        if (i < j) {
            const tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
    }
    return values;
}
function $fbf8e91788516fb2$export$8658a80bb8ef6889(values) {
    (0, $e129040e856338dd$export$c9895e5868d4e385)(values, 'values');
    return $fbf8e91788516fb2$export$73c02b8e328c7ddf(values.slice());
}
const $fbf8e91788516fb2$var$_1n = /** @__PURE__ */ BigInt(1);
function $fbf8e91788516fb2$var$findGenerator(field) {
    let G = BigInt(2);
    for(; field.eql(field.pow(G, field.ORDER >> $fbf8e91788516fb2$var$_1n), field.ONE); G++);
    return G;
}
function $fbf8e91788516fb2$export$5e60bb11dae8e64b(field, generator) {
    (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(field);
    if (generator !== undefined && typeof generator !== 'bigint') throw new TypeError('"generator" expected bigint, got type=' + typeof generator);
    // Factor field.ORDER-1 as oddFactor * 2^powerOfTwo
    let oddFactor = field.ORDER - $fbf8e91788516fb2$var$_1n;
    let powerOfTwo = 0;
    for(; (oddFactor & $fbf8e91788516fb2$var$_1n) !== $fbf8e91788516fb2$var$_1n; powerOfTwo++, oddFactor >>= $fbf8e91788516fb2$var$_1n);
    // Find non quadratic residue
    let G = generator !== undefined ? BigInt(generator) : $fbf8e91788516fb2$var$findGenerator(field);
    // Powers of generator
    const omegas = new Array(powerOfTwo + 1);
    omegas[powerOfTwo] = field.pow(G, oddFactor);
    for(let i = powerOfTwo; i > 0; i--)omegas[i - 1] = field.sqr(omegas[i]);
    // Compute all roots of unity for powers up to maxPower
    const rootsCache = [];
    const checkBits = (bits)=>{
        $fbf8e91788516fb2$var$checkU32(bits, 'bits');
        if (bits > 31 || bits > powerOfTwo) throw new Error('rootsOfUnity: wrong bits ' + bits + ' powerOfTwo=' + powerOfTwo);
        return bits;
    };
    const precomputeRoots = (maxPower)=>{
        checkBits(maxPower);
        for(let power = maxPower; power >= 0; power--){
            if (rootsCache[power]) continue; // Skip if we've already computed roots for this power
            const above = rootsCache[power + 1];
            const rootsAtPower = [];
            if (above) // ω_{2^p} = ω_{2^{p+1}}², so the smaller table is the even-index stride of the bigger
            // one: only the largest requested power pays for the multiplication chain.
            for(let j = 0; j < 2 ** power; j++)rootsAtPower.push(above[2 * j]);
            else for(let j = 0, cur = field.ONE; j < 2 ** power; j++, cur = field.mul(cur, omegas[power]))rootsAtPower.push(cur);
            rootsCache[power] = rootsAtPower;
        }
        return rootsCache[maxPower];
    };
    const brpCache = new Map();
    const inverseCache = new Map();
    // roots()/brp()/inverse() expose shared cached arrays by reference for speed; callers must treat them as read-only.
    // NOTE: we use bits instead of power, because power = 2**bits,
    // but power is not necessarily isPowerOfTwo(power)!
    return {
        info: {
            G: G,
            powerOfTwo: powerOfTwo,
            oddFactor: oddFactor
        },
        roots: (bits)=>{
            const b = checkBits(bits);
            return precomputeRoots(b);
        },
        brp (bits) {
            const b = checkBits(bits);
            if (brpCache.has(b)) return brpCache.get(b);
            else {
                const res = $fbf8e91788516fb2$export$8658a80bb8ef6889(this.roots(b));
                brpCache.set(b, res);
                return res;
            }
        },
        inverse (bits) {
            const b = checkBits(bits);
            if (inverseCache.has(b)) return inverseCache.get(b);
            else {
                // ωᴺ = 1, so inv(ωᵏ) = ωᴺ⁻ᵏ: the inverse table is the reversed roots table.
                // Value-identical to field.invertBatch(roots), but skips its 3N muls + inversion.
                const r = this.roots(b);
                const res = [
                    r[0]
                ].concat(r.slice(1).reverse());
                inverseCache.set(b, res);
                return res;
            }
        },
        omega: (bits)=>omegas[checkBits(bits)],
        clear: ()=>{
            rootsCache.splice(0, rootsCache.length);
            brpCache.clear();
            inverseCache.clear();
        }
    };
}
const $fbf8e91788516fb2$export$1d40aecb69f294cd = (F, coreOpts)=>{
    (0, $e129040e856338dd$export$381bae2d0f08004f)(coreOpts, {
        N: 'number',
        roots: 'object',
        dit: 'boolean'
    }, {
        invertButterflies: 'boolean',
        skipStages: 'number',
        brp: 'boolean'
    }, 'coreOpts');
    const { N: N, roots: roots, dit: dit, invertButterflies: invertButterflies = false, skipStages: skipStages = 0, brp: brp = true } = coreOpts;
    $fbf8e91788516fb2$var$checkU32(N, 'coreOpts.N');
    const bits = $fbf8e91788516fb2$export$b9fae0bba9d9094d(N);
    if (!$fbf8e91788516fb2$export$b9e43d1765415474(N)) throw new Error('FFT: Polynomial size should be power of two');
    $fbf8e91788516fb2$var$checkU32(skipStages, 'coreOpts.skipStages');
    const maxSkipStages = bits === 0 ? 0 : bits - 1;
    // Skipping every stage leaves only boundary layout changes, not a valid FFT loop shape.
    if (skipStages > maxSkipStages) throw new Error(`FFT: wrong skipStages: expected 0 <= skipStages <= ${maxSkipStages}`);
    // Wrong-sized root tables can stay in-bounds for some loop shapes and silently compute nonsense.
    if (roots.length !== N) throw new Error(`FFT: wrong roots length: expected ${N}, got ${roots.length}`);
    const isDit = dit !== invertButterflies;
    return (values)=>{
        if (values.length !== N) throw new Error('FFT: wrong Polynomial length');
        if (dit && brp) $fbf8e91788516fb2$export$73c02b8e328c7ddf(values);
        for(let i = 0, g = 1; i < bits - skipStages; i++){
            // For each stage s (sub-FFT length m = 2^s)
            const s = dit ? i + 1 + skipStages : bits - i;
            const m = 1 << s;
            const m2 = m >> 1;
            const stride = N >> s;
            // Loop over each subarray of length m
            for(let k = 0; k < N; k += m)// Loop over each butterfly within the subarray
            for(let j = 0, grp = g++; j < m2; j++){
                const rootPos = invertButterflies ? dit ? N - grp : grp : j * stride;
                const i0 = k + j;
                const i1 = k + j + m2;
                const omega = roots[rootPos];
                const b = values[i1];
                const a = values[i0];
                // Inlining gives us 10% perf in kyber vs functions
                if (isDit) {
                    const t = F.mul(b, omega); // Standard DIT butterfly
                    values[i0] = F.add(a, t);
                    values[i1] = F.sub(a, t);
                } else if (invertButterflies) {
                    values[i0] = F.add(b, a); // DIT loop + inverted butterflies (Kyber decode)
                    values[i1] = F.mul(F.sub(b, a), omega);
                } else {
                    values[i0] = F.add(a, b); // Standard DIF butterfly
                    values[i1] = F.mul(F.sub(a, b), omega);
                }
            }
        }
        if (!dit && brp) $fbf8e91788516fb2$export$73c02b8e328c7ddf(values);
        return values;
    };
};
function $fbf8e91788516fb2$export$677347237c014ba(roots, opts) {
    // Loops are cached per (size, direction, brp flags): FFTCore construction validates options
    // and allocates closures, which costs more than a small transform itself. The cached loop
    // closes over the root table active at first use; `roots.clear()` rebuilds value-identical
    // tables, so a stale reference stays correct.
    const loops = new Map();
    const getLoop = (N, rootsTable, key)=>{
        const cached = loops.get(key);
        if (cached) return cached;
        const brpInput = !!(key & 2);
        const brpOutput = !!(key & 1);
        let loop;
        if (brpInput && brpOutput) {
            // we cannot optimize this case, but lets support it anyway
            const core = $fbf8e91788516fb2$export$1d40aecb69f294cd(opts, {
                N: N,
                roots: rootsTable,
                dit: false,
                brp: false
            });
            loop = (values)=>core($fbf8e91788516fb2$export$73c02b8e328c7ddf(values));
        } else if (brpInput) loop = $fbf8e91788516fb2$export$1d40aecb69f294cd(opts, {
            N: N,
            roots: rootsTable,
            dit: true,
            brp: false
        });
        else if (brpOutput) loop = $fbf8e91788516fb2$export$1d40aecb69f294cd(opts, {
            N: N,
            roots: rootsTable,
            dit: false,
            brp: false
        });
        else loop = $fbf8e91788516fb2$export$1d40aecb69f294cd(opts, {
            N: N,
            roots: rootsTable,
            dit: true,
            brp: true
        }); // all natural
        loops.set(key, loop);
        return loop;
    };
    const loopKey = (bits, isInverse, brpInput, brpOutput)=>bits << 3 | (isInverse ? 4 : 0) | (brpInput ? 2 : 0) | (brpOutput ? 1 : 0);
    return {
        direct (values, brpInput = false, brpOutput = false) {
            const N = values.length;
            if (!$fbf8e91788516fb2$export$b9e43d1765415474(N)) throw new Error('FFT: Polynomial size should be power of two');
            const bits = $fbf8e91788516fb2$export$b9fae0bba9d9094d(N);
            const key = loopKey(bits, false, brpInput, brpOutput);
            return getLoop(N, roots.roots(bits), key)(values.slice());
        },
        inverse (values, brpInput = false, brpOutput = false) {
            const N = values.length;
            if (!$fbf8e91788516fb2$export$b9e43d1765415474(N)) throw new Error('FFT: Polynomial size should be power of two');
            const bits = $fbf8e91788516fb2$export$b9fae0bba9d9094d(N);
            const key = loopKey(bits, true, brpInput, brpOutput);
            const res = getLoop(N, roots.inverse(bits), key)(values.slice());
            const ivm = opts.inv(BigInt(values.length)); // scale
            // we can get brp output if we use dif instead of dit!
            for(let i = 0; i < res.length; i++)res[i] = opts.mul(res[i], ivm);
            // Allows to re-use non-inverted roots, but is VERY fragile
            // return [res[0]].concat(res.slice(1).reverse());
            // inverse calculated as pow(-1), which transforms into ω^{-kn} (-> reverses indices)
            return res;
        }
    };
}
function $fbf8e91788516fb2$export$9ff171bb1bc5cfbc(field, roots, create, fft, length) {
    (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(field);
    const F = field;
    const _create = create || ((len, elm)=>new Array(len).fill(elm ?? F.ZERO));
    // `poly.mul(a, b)` distinguishes polynomial-vs-scalar at runtime, so keep accepted
    // polynomial containers concrete instead of trying to support arbitrary wrappers.
    const isPoly = (x)=>{
        if (Array.isArray(x)) return true;
        if (!ArrayBuffer.isView(x)) return false;
        const v = x;
        return typeof v.length === 'number' && typeof v.slice === 'function' && typeof v[Symbol.iterator] === 'function';
    };
    const checkPoly = (title, value)=>{
        if (!isPoly(value)) throw new TypeError(`"${title}" expected polynomial, got type=${typeof value}`);
    };
    const checkLength = (a, b)=>{
        checkPoly('a', a);
        const L = a.length;
        if (b !== undefined) {
            checkPoly('b', b);
            if (b.length !== L) throw new Error(`poly: mismatched lengths ${L} vs ${b.length}`);
        }
        if (length !== undefined && L !== length) throw new Error(`poly: expected fixed length ${length}, got ${L}`);
        return L;
    };
    function findOmegaIndex(x, n, brp = false, weights) {
        if (!$fbf8e91788516fb2$export$b9e43d1765415474(n)) throw new Error('poly.lagrange: expected power of two length, got ' + n);
        // Explicit weights define the interpolation domain, including the Kronecker-δ shortcut.
        const omega = weights || (brp ? roots.brp($fbf8e91788516fb2$export$b9fae0bba9d9094d(n)) : roots.roots($fbf8e91788516fb2$export$b9fae0bba9d9094d(n)));
        for(let i = 0; i < n; i++)if (F.eql(x, omega[i])) return i;
        return -1;
    }
    // TODO: mutating versions for mlkem/mldsa
    return {
        roots: roots,
        create: _create,
        length: length,
        extend: (a, len)=>{
            checkLength(a);
            const out = _create(len, F.ZERO);
            // Plain arrays grow when writing past `out.length`, so cap the copy explicitly to keep
            // `extend()` consistent with typed arrays and with its documented truncate behavior.
            for(let i = 0; i < Math.min(a.length, len); i++)out[i] = a[i];
            return out;
        },
        degree: (a)=>{
            checkLength(a);
            for(let i = a.length - 1; i >= 0; i--)if (!F.is0(a[i])) return i;
            return -1;
        },
        add: (a, b)=>{
            const len = checkLength(a, b);
            const out = _create(len);
            for(let i = 0; i < len; i++)out[i] = F.add(a[i], b[i]);
            return out;
        },
        sub: (a, b)=>{
            const len = checkLength(a, b);
            const out = _create(len);
            for(let i = 0; i < len; i++)out[i] = F.sub(a[i], b[i]);
            return out;
        },
        dot: (a, b)=>{
            const len = checkLength(a, b);
            const out = _create(len);
            for(let i = 0; i < len; i++)out[i] = F.mul(a[i], b[i]);
            return out;
        },
        mul: (a, b)=>{
            if (isPoly(b)) {
                const len = checkLength(a, b);
                if (fft) {
                    const A = fft.direct(a, false, true);
                    const B = fft.direct(b, false, true);
                    for(let i = 0; i < A.length; i++)A[i] = F.mul(A[i], B[i]);
                    return fft.inverse(A, true, false);
                } else {
                    // NOTE: this is quadratic and mostly for compat tests with FFT
                    const res = _create(len);
                    for(let i = 0; i < len; i++)for(let j = 0; j < len; j++){
                        const k = (i + j) % len; // wrap mod length
                        res[k] = F.add(res[k], F.mul(a[i], b[j]));
                    }
                    return res;
                }
            } else {
                const out = _create(checkLength(a));
                for(let i = 0; i < out.length; i++)out[i] = F.mul(a[i], b);
                return out;
            }
        },
        convolve (a, b) {
            checkPoly('a', a);
            checkPoly('b', b);
            const len = $fbf8e91788516fb2$export$239a7ba740cbf2bf(a.length + b.length - 1);
            return this.mul(this.extend(a, len), this.extend(b, len));
        },
        shift (p, factor) {
            checkPoly('p', p);
            const out = _create(p.length);
            if (length !== undefined && p.length !== length) throw new Error(`poly: expected fixed length ${length}, got ${p.length}`);
            if (!p.length) return out;
            out[0] = p[0];
            for(let i = 1, power = F.ONE; i < p.length; i++){
                power = F.mul(power, factor);
                out[i] = F.mul(p[i], power);
            }
            return out;
        },
        clone: (a)=>{
            checkLength(a);
            const out = _create(a.length);
            for(let i = 0; i < a.length; i++)out[i] = a[i];
            return out;
        },
        eval: (a, basis)=>{
            checkLength(a, basis);
            let acc = F.ZERO;
            for(let i = 0; i < a.length; i++)acc = F.add(acc, F.mul(a[i], basis[i]));
            return acc;
        },
        monomial: {
            basis: (x, n)=>{
                const out = _create(n);
                let pow = F.ONE;
                for(let i = 0; i < n; i++){
                    out[i] = pow;
                    pow = F.mul(pow, x);
                }
                return out;
            },
            eval: (a, x)=>{
                checkLength(a);
                // Same as eval(a, monomialBasis(x, a.length)), but it is faster this way
                let acc = F.ZERO;
                for(let i = a.length - 1; i >= 0; i--)acc = F.add(F.mul(acc, x), a[i]);
                return acc;
            }
        },
        lagrange: {
            basis: (x, n, brp = false, weights)=>{
                if (!$fbf8e91788516fb2$export$b9e43d1765415474(n)) throw new Error('poly.lagrange: expected power of two length, got ' + n);
                const bits = $fbf8e91788516fb2$export$b9fae0bba9d9094d(n);
                const cache = weights || (brp ? roots.brp(bits) : roots.roots(bits)); // [ω⁰, ω¹, ..., ωⁿ⁻¹]
                const out = _create(n);
                // Fast Kronecker-δ shortcut
                const idx = findOmegaIndex(x, n, brp, weights);
                if (idx !== -1) {
                    out[idx] = F.ONE;
                    return out;
                }
                const tm = F.pow(x, BigInt(n));
                const c = F.mul(F.sub(tm, F.ONE), F.inv(BigInt(n))); // c = (xⁿ - 1)/n
                const denom = _create(n);
                for(let i = 0; i < n; i++)denom[i] = F.sub(x, cache[i]);
                const inv = F.invertBatch(denom);
                for(let i = 0; i < n; i++)out[i] = F.mul(c, F.mul(cache[i], inv[i]));
                return out;
            },
            eval (a, x, brp = false) {
                checkLength(a);
                const idx = findOmegaIndex(x, a.length, brp);
                if (idx !== -1) return a[idx]; // fast path
                const L = this.basis(x, a.length, brp); // Lᵢ(x)
                let acc = F.ZERO;
                for(let i = 0; i < a.length; i++)if (!F.is0(a[i])) acc = F.add(acc, F.mul(a[i], L[i]));
                return acc;
            }
        },
        vanishing (roots) {
            checkPoly('roots', roots);
            if (length !== undefined && roots.length !== length) throw new Error(`poly: expected fixed length ${length}, got ${roots.length}`);
            const out = _create(roots.length + 1, F.ZERO);
            out[0] = F.ONE;
            for (const r of roots){
                const neg = F.neg(r);
                for(let j = out.length - 1; j > 0; j--)out[j] = F.add(F.mul(out[j], neg), out[j - 1]);
                out[0] = F.mul(out[0], neg);
            }
            return out;
        }
    };
}




// PubKey = commitments, verifyingShares
// PrivKey = id, signingShare, commitment
const $47167bfa62af68b8$var$validateSigners = (signers, title = 'signers')=>{
    (0, $e129040e856338dd$export$381bae2d0f08004f)(signers, {
        min: 'number',
        max: 'number'
    }, {}, title);
    (0, $e129040e856338dd$export$4f3315d97e288446)(signers.min, title + '.min');
    (0, $e129040e856338dd$export$4f3315d97e288446)(signers.max, title + '.max');
    // Compatibility with frost-rs intentionally narrows RFC 9591's positive-nonzero threshold rule
    // to `min >= 2`, even though the RFC text itself allows `MIN_PARTICIPANTS = 1`.
    // This API is for actual threshold signing across participants; 1-of-n degenerates to ordinary
    // single-signer mode, which does not need FROST's network/coordination machinery at all.
    if (signers.min < 2 || signers.max < 2 || signers.min > signers.max) throw new Error('Wrong signers info: min=' + signers.min + ' max=' + signers.max);
};
const $47167bfa62af68b8$var$validateCommitmentsNum = (signers, len)=>{
    // RFC 9591 Sections 5.2/5.3 require MIN_PARTICIPANTS <= NUM_PARTICIPANTS <= MAX_PARTICIPANTS.
    if (len < signers.min || len > signers.max) throw new Error('Wrong number of commitments=' + len);
};
class $47167bfa62af68b8$var$AggErr extends Error {
    // Empty means aggregation failed before per-share verification could attribute a signer.
    cheaters;
    constructor(msg, cheaters){
        super(msg);
        this.cheaters = cheaters;
    }
}
function $47167bfa62af68b8$export$761a5c594301a577(opts) {
    (0, $e129040e856338dd$export$381bae2d0f08004f)(opts, {
        name: 'string',
        hash: 'function'
    }, {
        hashToScalar: 'function',
        validatePoint: 'function',
        parsePublicKey: 'function',
        adjustScalar: 'function',
        adjustPoint: 'function',
        challenge: 'function',
        adjustNonces: 'function',
        adjustSecret: 'function',
        adjustPublic: 'function',
        adjustGroupCommitmentShare: 'function',
        adjustTx: 'object',
        adjustDKG: 'function'
    });
    // Cheap constructor-surface sanity check only: this verifies the generic static hooks/fields that
    // FROST consumes, but it does not certify point semantics like BASE/ZERO correctness.
    (0, $4f109436b1b5c1eb$export$facc60e77e5ab0c2)(opts.Point);
    const { Point: Point, validatePoint: validatePoint, parsePublicKey: parsePublicKey, adjustScalar: adjustScalar, adjustPoint: adjustPointHook, challenge: challenge, adjustNonces: adjustNonces, adjustSecret: adjustSecret, adjustPublic: adjustPublic, adjustGroupCommitmentShare: adjustGroupCommitmentShare, adjustDKG: adjustDKG } = opts;
    const Fn = opts.Fn === undefined ? Point.Fn : opts.Fn;
    const adjustTx = opts.adjustTx === undefined ? undefined : {
        encode: opts.adjustTx.encode,
        decode: opts.adjustTx.decode
    };
    if (adjustTx) (0, $e129040e856338dd$export$381bae2d0f08004f)(adjustTx, {
        encode: 'function',
        decode: 'function'
    });
    // Hashes
    const hashBytes = opts.hash;
    const hashToScalar = opts.hashToScalar === undefined ? (msg, opts = {
        DST: new Uint8Array()
    })=>{
        const t = hashBytes((0, $e129040e856338dd$export$287dd7971339c972)(opts.DST, msg));
        return Fn.create(Fn.isLE ? (0, $e129040e856338dd$export$d67b1d03392107e7)(t) : (0, $e129040e856338dd$export$d609354794974f8)(t));
    } : opts.hashToScalar;
    const H1Prefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.H1 !== undefined ? opts.H1 : opts.name + 'rho');
    const H2Prefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.H2 !== undefined ? opts.H2 : opts.name + 'chal');
    const H3Prefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.H3 !== undefined ? opts.H3 : opts.name + 'nonce');
    const H4Prefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.H4 !== undefined ? opts.H4 : opts.name + 'msg');
    const H5Prefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.H5 !== undefined ? opts.H5 : opts.name + 'com');
    const HDKGPrefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.HDKG !== undefined ? opts.HDKG : opts.name + 'dkg');
    const HIDPrefix = (0, $3c6c2c802c119f83$export$3df70a15530b5e81)(opts.HID !== undefined ? opts.HID : opts.name + 'id');
    const H1 = (msg)=>hashToScalar(msg, {
            DST: H1Prefix
        });
    // Empty H2 still passes `{ DST: new Uint8Array() }` into custom hashToScalar hooks.
    // The built-in fallback hashes that identically to omitted DST, which is how
    // the Ed25519 suite models RFC 9591's undecorated H2 challenge hash.
    const H2 = (msg)=>hashToScalar(msg, {
            DST: H2Prefix
        });
    const H3 = (msg)=>hashToScalar(msg, {
            DST: H3Prefix
        });
    const H4 = (msg)=>hashBytes((0, $e129040e856338dd$export$287dd7971339c972)(H4Prefix, msg));
    const H5 = (msg)=>hashBytes((0, $e129040e856338dd$export$287dd7971339c972)(H5Prefix, msg));
    const HDKG = (msg)=>hashToScalar(msg, {
            DST: HDKGPrefix
        });
    const HID = (msg)=>hashToScalar(msg, {
            DST: HIDPrefix
        });
    // /Hashes
    const randomScalar = (rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>{
        if (typeof rng !== 'function') throw new TypeError('"rng" expected function, got type=' + typeof rng);
        // Intentional divergence from RFC 9591 §4.1 / §5.1: the RFC nonce_generate helper outputs a
        // Scalar in [0, p-1], but round-one commit publishes ScalarBaseMult(nonce) values and §3.1
        // requires SerializeElement / DeserializeElement to reject the identity element. Keep noble's
        // mapHashToField generation here so round-one public nonce commitments stay in 1..n-1.
        const t = (0, $eaac85f28e130c0a$export$20cb21dbfa61dac3)(rng((0, $eaac85f28e130c0a$export$d058763b563056af)(Fn.ORDER)), Fn.ORDER, Fn.isLE);
        // We cannot use Fn.fromBytes here because the field can have a different
        // byte width, like ed448.
        return Fn.isLE ? (0, $e129040e856338dd$export$d67b1d03392107e7)(t) : (0, $e129040e856338dd$export$d609354794974f8)(t);
    };
    const serializePoint = (p)=>p.toBytes();
    const validatePublicPoint = (p)=>{
        // RFC 9591 Section 3.1 DeserializeElement rejects off-curve, identity, and non-prime-order
        // elements. This remains mandatory when parsePublicKey replaces the normal byte decoder.
        p.assertValidity();
        if (p.is0()) throw new Error('invalid point: identity');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        if (validatePoint) validatePoint(p);
        return p;
    };
    const parsePoint = (bytes)=>validatePublicPoint(Point.fromBytes(bytes));
    // RFC 9591 Sections 4.1/5.1 model each participant's round-one output as two public commitments.
    const nonceCommitments = (identifier, nonces)=>({
            identifier: identifier,
            hiding: serializePoint(Point.BASE.multiply(Fn.fromBytes(nonces.hiding))),
            binding: serializePoint(Point.BASE.multiply(Fn.fromBytes(nonces.binding)))
        });
    const adjustPoint = adjustPointHook === undefined ? (n)=>n : adjustPointHook;
    // We use hex to make it easier to use inside objects
    const validateIdentifier = (n)=>{
        // Identifiers are canonical non-zero scalars. Custom / derived identifiers are allowed, so this
        // is intentionally not bounded by the current signers.max slot count.
        if (!Fn.isValid(n) || Fn.is0(n)) throw new Error('Invalid identifier ' + n);
        return n;
    };
    const serializeIdentifier = (id)=>(0, $e129040e856338dd$export$58b867e287a802c8)(Fn.toBytes(validateIdentifier(id)));
    const parseIdentifier = (id, title = 'identifier')=>{
        (0, $e129040e856338dd$export$e32658751cad4ab1)(id, title);
        const n = validateIdentifier(Fn.fromBytes((0, $e129040e856338dd$export$31c96b9df38bc8d4)(id)));
        // Keep string-keyed maps stable by accepting only the canonical serialized form.
        if (serializeIdentifier(n) !== id) throw new Error('expected canonical identifier hex');
        return n;
    };
    const copyRound1Package = (p)=>({
            identifier: serializeIdentifier(parseIdentifier(p.identifier)),
            commitment: p.commitment.map((c)=>(0, $e129040e856338dd$export$56728fb2d7dba34e)(c)),
            proofOfKnowledge: (0, $e129040e856338dd$export$56728fb2d7dba34e)(p.proofOfKnowledge)
        });
    const canonicalRound1Packages = (packages)=>{
        const snapshot = packages.map(copyRound1Package);
        snapshot.sort((a, b)=>{
            const ai = parseIdentifier(a.identifier);
            const bi = parseIdentifier(b.identifier);
            return ai < bi ? -1 : ai > bi ? 1 : 0;
        });
        return snapshot;
    };
    const equalRound1Transcripts = (a, b)=>{
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            const p = a[i];
            const q = b[i];
            if (p.identifier !== q.identifier || p.commitment.length !== q.commitment.length) return false;
            for(let j = 0; j < p.commitment.length; j++){
                if (!(0, $e129040e856338dd$export$2aa59cef064b0333)(p.commitment[j], q.commitment[j])) return false;
            }
            if (!(0, $e129040e856338dd$export$2aa59cef064b0333)(p.proofOfKnowledge, q.proofOfKnowledge)) return false;
        }
        return true;
    };
    const Signature = {
        // RFC 9591 Appendix A encodes signatures canonically as
        // SerializeElement(R) || SerializeScalar(z).
        encode: (R, z)=>{
            let res = (0, $e129040e856338dd$export$287dd7971339c972)(serializePoint(R), Fn.toBytes(z));
            if (adjustTx) res = adjustTx.encode(res);
            return res;
        },
        decode: (sig)=>{
            if (adjustTx) sig = adjustTx.decode(sig);
            // We don't know size of point, but we know size of scalar
            const Rbytes = sig.subarray(0, -Fn.BYTES);
            const R = parsePoint(Rbytes);
            // RFC 9591 Section 3.1 SerializeElement is canonical: a signature must not verify under an
            // alternative point encoding (e.g. re-encoding a weierstrass R uncompressed as 65 bytes).
            if (serializePoint(R).length !== Rbytes.length) throw new Error('invalid signature encoding');
            const z = Fn.fromBytes(sig.subarray(-Fn.BYTES));
            return {
                R: R,
                z: z
            };
        }
    };
    // Generates pair of (scalar, point)
    const genPointScalarPair = (rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>{
        let n = randomScalar(rng);
        if (adjustScalar) n = adjustScalar(n);
        let p = Point.BASE.multiply(n);
        return {
            scalar: n,
            point: p
        };
    };
    // No roots here: root-based methods will throw.
    // `poly` expects a structured roots-of-unity domain, but FROST uses an
    // arbitrary domain and only needs the non-root operations below.
    const nrErr = 'roots are unavailable in FROST polynomial mode';
    const noRoots = {
        info: {
            G: Fn.ZERO,
            oddFactor: Fn.ZERO,
            powerOfTwo: 0
        },
        roots () {
            throw new Error(nrErr);
        },
        brp () {
            throw new Error(nrErr);
        },
        inverse () {
            throw new Error(nrErr);
        },
        omega () {
            throw new Error(nrErr);
        },
        clear () {}
    };
    const Poly = (0, $fbf8e91788516fb2$export$9ff171bb1bc5cfbc)(Fn, noRoots);
    // Variable-time MSM over public inputs only (VSS / nonce commitments, binding factors).
    // Interleaved wNAF beats pippenger ~3x at FROST-sized inputs (n <= dozens of signers).
    const msm = (points, scalars)=>(0, $4f109436b1b5c1eb$export$4eb79287de74dd6)(Point, points, scalars);
    // Internal stuff uses bigints & Points, external Uint8Arrays
    const polynomialEvaluate = (x, coeffs)=>{
        if (!coeffs.length) throw new Error('empty coefficients');
        return Poly.monomial.eval(coeffs, x);
    };
    const deriveInterpolatingValue = (L, xi)=>{
        const err = 'invalid parameters';
        // Generates lagrange coefficient
        if (!L.some((x)=>Fn.eql(x, xi))) throw new Error(err);
        // Throws error if any x-coordinate is represented more than once in L.
        const Lset = new Set(L);
        if (Lset.size !== L.length) throw new Error(err);
        // Or if xi is missing
        if (!Lset.has(xi)) throw new Error(err);
        let num = Fn.ONE;
        let den = Fn.ONE;
        for (const x of L){
            if (Fn.eql(x, xi)) continue;
            num = Fn.mul(num, x); // num *= x
            den = Fn.mul(den, Fn.sub(x, xi)); // RFC 9591 §4.2: denominator *= x_j - x_i
        }
        return Fn.div(num, den);
    };
    const evalutateVSS = (identifier, commitment)=>{
        // RFC 9591 Appendix C.2: S_i' = Σ_j ScalarMult(vss_commitment[j], i^j).
        const monomial = Poly.monomial.basis(identifier, commitment.length);
        return msm(commitment, monomial);
    };
    // High-level internal stuff
    const generateSecretPolynomial = (signers, secret, coeffs, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>{
        $47167bfa62af68b8$var$validateSigners(signers);
        if (secret !== undefined) (0, $e129040e856338dd$export$e8a750b9efad93f5)(secret, Fn.BYTES, 'secret');
        if (coeffs !== undefined) (0, $e129040e856338dd$export$c9895e5868d4e385)(coeffs, 'coeffs');
        if (typeof rng !== 'function') throw new TypeError('"rng" expected function, got type=' + typeof rng);
        // Dealer/DKG polynomial sampling reuses the same hardened scalar derivation as round-one
        // nonces: overriding `rng` only swaps the entropy source, not the non-zero `1..n-1` policy.
        const secretScalar = secret === undefined ? randomScalar(rng) : Fn.fromBytes(secret);
        if (!coeffs) {
            coeffs = [];
            for(let i = 0; i < signers.min - 1; i++)coeffs.push(randomScalar(rng));
        }
        if (coeffs.length !== signers.min - 1) throw new Error('wrong coefficients length');
        const coefficients = [
            secretScalar,
            ...coeffs
        ];
        // RFC 9591 Appendix C.2 commits to every polynomial coefficient with ScalarBaseMult.
        const commitment = coefficients.map((i)=>Point.BASE.multiply(i));
        return {
            coefficients: coefficients,
            commitment: commitment,
            secret: secretScalar
        };
    };
    // Pretty much sign+verify, same as basic
    const ProofOfKnowledge = {
        challenge: (id, verKey, R)=>HDKG((0, $e129040e856338dd$export$287dd7971339c972)(Fn.toBytes(id), serializePoint(verKey), serializePoint(R))),
        compute (id, coefficents, commitments, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8)) {
            if (coefficents.length < 1) throw new Error('coefficients should have at least one element');
            const { point: R, scalar: k } = genPointScalarPair(rng);
            const verKey = commitments[0]; // verify key is first one
            const c = this.challenge(id, verKey, R);
            const mu = Fn.add(k, Fn.mul(coefficents[0], c)); // mu = k + coeff[0] * c
            return Signature.encode(R, mu);
        },
        validate (id, commitment, proof) {
            if (commitment.length < 1) throw new Error('commitment should have at least one element');
            const { R: R, z: z } = Signature.decode(proof);
            const phi = parsePoint(commitment[0]);
            const c = this.challenge(id, phi, R);
            // R === z*G - phi*c. All inputs are public: variable-time multiplication is safe here.
            if (!R.equals(Point.BASE.multiplyUnsafe(z).subtract(phi.multiplyUnsafe(c)))) throw new Error('invalid proof of knowledge');
        }
    };
    const Basic = {
        challenge: (R, PK, msg)=>{
            if (challenge) return challenge(R, PK, msg);
            return H2((0, $e129040e856338dd$export$287dd7971339c972)(serializePoint(R), serializePoint(PK), msg));
        },
        sign (msg, sk, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8)) {
            const { point: R, scalar: r } = genPointScalarPair(rng);
            const PK = Point.BASE.multiply(sk); // sk*G
            const c = this.challenge(R, PK, msg);
            const z = Fn.add(r, Fn.mul(c, sk)); // r + c * sk
            return [
                R,
                z
            ];
        },
        verify (msg, R, z, PK) {
            if (adjustPointHook) PK = adjustPointHook(PK);
            if (adjustPointHook) R = adjustPointHook(R);
            // Signature, message and public key are all public: variable-time is safe on this path.
            const c = this.challenge(R, PK, msg);
            const zB = Point.BASE.multiplyUnsafe(z); // z*G
            const cA = PK.multiplyUnsafe(c); // c*PK
            let check = zB.subtract(cA).subtract(R); // zB - cA - R
            // No clearCoffactor on ristretto
            if (check.clearCofactor) check = check.clearCofactor();
            return Point.ZERO.equals(check);
        }
    };
    // === vssVerify
    const validateSecretShare = (identifier, commitment, signingShare)=>{
        // RFC 9591 Appendix C.2 `vss_verify(share_i, vss_commitment)` is purely algebraic.
        // Public FROST packages still go through Section 3.1 element encoding,
        // which rejects identity points, so a zero share or commitment does not
        // become valid wire data just because VSS matches.
        if (!Point.BASE.multiply(signingShare).equals(evalutateVSS(identifier, commitment))) throw new Error('invalid secret share');
    };
    const Identifier = {
        fromNumber (n) {
            if (!Number.isSafeInteger(n)) throw new Error('expected safe interger');
            return serializeIdentifier(BigInt(n));
        },
        // Not in spec, but in FROST implementation,
        // seems useful and nice, no need to sync identifiers (would require more interactions)
        derive (s) {
            (0, $e129040e856338dd$export$e32658751cad4ab1)(s, 's');
            // Derived identifiers may land anywhere in the scalar field; they are not restricted to
            // sequential `1..max_signers` values.
            return serializeIdentifier(HID((0, $3c6c2c802c119f83$export$3df70a15530b5e81)(s)));
        }
    };
    // RFC 9591 §4.1: nonce_generate() hashes 32 fresh RNG bytes with SerializeScalar(secret).
    const generateNonce = (secret, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>H3((0, $e129040e856338dd$export$287dd7971339c972)(rng(32), Fn.toBytes(secret)));
    const getGroupCommitment = (GPK, commitmentList, msg)=>{
        const CL = commitmentList.map((i)=>[
                i.identifier,
                parseIdentifier(i.identifier),
                parsePoint(i.hiding),
                parsePoint(i.binding)
            ]);
        // RFC 9591 Sections 4.3/4.4/4.5 and 5.2/5.3 treat commitment_list as sorted by identifier.
        CL.sort((a, b)=>a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0);
        // Encode commitment list
        const Cbytes = [];
        for (const [_, id, hC, bC] of CL)Cbytes.push(Fn.toBytes(id), serializePoint(hC), serializePoint(bC));
        const encodedCommitmentHash = H5((0, $e129040e856338dd$export$287dd7971339c972)(...Cbytes));
        const rhoPrefix = (0, $e129040e856338dd$export$287dd7971339c972)(serializePoint(GPK), H4(msg), encodedCommitmentHash);
        // Compute binding factors
        const bindingFactors = {};
        for (const [i, id] of CL)bindingFactors[i] = H1((0, $e129040e856338dd$export$287dd7971339c972)(rhoPrefix, Fn.toBytes(id)));
        // Hiding commitments all carry scalar 1, so add them directly and keep only the
        // binding commitments in the MSM: same result, half the MSM size.
        let hidingSum = Point.ZERO;
        const points = [];
        const scalars = [];
        for (const [i, _, hC, bC] of CL){
            if (Point.ZERO.equals(hC) || Point.ZERO.equals(bC)) throw new Error('infinity commitment');
            hidingSum = hidingSum.add(hC);
            points.push(bC);
            scalars.push(bindingFactors[i]);
        }
        const groupCommitment = hidingSum.add(msm(points, scalars)); //  GC += hC + bC*bindingFactor
        const identifiers = CL.map((i)=>i[1]);
        return {
            identifiers: identifiers,
            groupCommitment: groupCommitment,
            bindingFactors: bindingFactors
        };
    };
    const prepareShare = (PK, commitmentList, msg, identifier)=>{
        // RFC 9591 Sections 4.4/4.5/4.6 feed directly into the Section 5.2 signer computation.
        const GPK = adjustPoint(parsePoint(PK));
        const id = parseIdentifier(identifier);
        const { identifiers: identifiers, groupCommitment: groupCommitment, bindingFactors: bindingFactors } = getGroupCommitment(GPK, commitmentList, msg);
        const bindingFactor = bindingFactors[identifier];
        const lambda = deriveInterpolatingValue(identifiers, id);
        const challenge = Basic.challenge(groupCommitment, GPK, msg);
        return {
            lambda: lambda,
            challenge: challenge,
            bindingFactor: bindingFactor,
            groupCommitment: groupCommitment
        };
    };
    Object.freeze(Identifier);
    const frost = {
        Identifier: Identifier,
        // DKG is Distributed Key Generation, not Trusted Dealer Key Generation.
        DKG: Object.freeze({
            // NOTE: we allow to pass secret scalar from user side,
            // this way it can be derived, instead of random generation
            round1: (id, signers, secret, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>{
                const idNum = parseIdentifier(id, 'id');
                $47167bfa62af68b8$var$validateSigners(signers);
                const { coefficients: coefficients, commitment: commitment } = generateSecretPolynomial(signers, secret, undefined, rng);
                const proofOfKnowledge = ProofOfKnowledge.compute(idNum, coefficients, commitment, rng);
                const commitmentBytes = commitment.map(serializePoint);
                const round1Public = {
                    identifier: serializeIdentifier(idNum),
                    commitment: commitmentBytes,
                    proofOfKnowledge: proofOfKnowledge
                };
                // store secret information for signing
                const round1Secret = {
                    identifier: idNum,
                    coefficients: coefficients,
                    commitment: commitment.map(serializePoint),
                    // Copy threshold metadata instead of retaining the caller-owned object by reference.
                    signers: {
                        min: signers.min,
                        max: signers.max
                    },
                    step: 1
                };
                return {
                    public: round1Public,
                    secret: round1Secret
                };
            },
            round2: (secret, others)=>{
                (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                    identifier: 'bigint',
                    commitment: 'object',
                    signers: 'object'
                }, {
                    coefficients: 'object',
                    round1Cache: 'object',
                    round2Cache: 'object',
                    step: 'number'
                }, 'secret');
                $47167bfa62af68b8$var$validateSigners(secret.signers, 'secret.signers');
                (0, $e129040e856338dd$export$c9895e5868d4e385)(others, 'others');
                if (others.length !== secret.signers.max - 1) throw new Error('wrong number of round1 packages');
                if (!secret.coefficients || secret.step === 3) throw new Error('round3 package used in round2');
                // Snapshot before validation, then authenticate and cache this exact owned transcript.
                const authenticatedRound1 = canonicalRound1Packages(others);
                if (secret.round2Cache !== undefined) {
                    if (secret.round1Cache === undefined || !equalRound1Transcripts(secret.round1Cache, authenticatedRound1)) throw new Error('round1 packages do not match authenticated transcript');
                    return secret.round2Cache;
                }
                const res = {};
                for (const p of authenticatedRound1){
                    if (p.commitment.length !== secret.signers.min) throw new Error('wrong number of commitments');
                    const id = parseIdentifier(p.identifier);
                    if (id === secret.identifier) throw new Error('duplicate id=' + serializeIdentifier(id));
                    ProofOfKnowledge.validate(id, p.commitment, p.proofOfKnowledge);
                    for (const c of p.commitment)parsePoint(c);
                    if (res[p.identifier]) throw new Error('Duplicate id=' + id);
                    const signingShare = Fn.toBytes(polynomialEvaluate(id, secret.coefficients));
                    res[p.identifier] = {
                        identifier: serializeIdentifier(secret.identifier),
                        signingShare: signingShare
                    };
                }
                secret.round1Cache = authenticatedRound1;
                secret.round2Cache = res;
                secret.step = 2;
                return res;
            },
            round3: (secret, round1, round2)=>{
                (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                    identifier: 'bigint',
                    commitment: 'object',
                    signers: 'object'
                }, {
                    coefficients: 'object',
                    round1Cache: 'object',
                    round2Cache: 'object',
                    step: 'number'
                }, 'secret');
                $47167bfa62af68b8$var$validateSigners(secret.signers, 'secret.signers');
                (0, $e129040e856338dd$export$c9895e5868d4e385)(round1, 'round1');
                (0, $e129040e856338dd$export$c9895e5868d4e385)(round2, 'round2');
                if (round1.length !== secret.signers.max - 1) throw new Error('wrong length of round1 packages');
                if (!secret.coefficients || secret.step !== 2 || !secret.round1Cache) throw new Error('round2 package used in round3');
                const suppliedRound1 = canonicalRound1Packages(round1);
                const authenticatedRound1 = secret.round1Cache;
                if (!equalRound1Transcripts(authenticatedRound1, suppliedRound1)) throw new Error('round1 packages do not match authenticated transcript');
                if (round2.length !== authenticatedRound1.length) throw new Error('wrong length of round2 packages');
                const merged = {};
                // Use the authenticated owned transcript after comparison; never re-read caller input.
                for (const r1 of authenticatedRound1){
                    if (!r1.identifier || !r1.commitment) throw new Error('wrong round1 share');
                    merged[r1.identifier] = {
                        ...r1
                    };
                }
                for (const r2 of round2){
                    if (!r2.identifier || !r2.signingShare) throw new Error('wrong round2 share');
                    if (!merged[r2.identifier]) throw new Error('round1 share for ' + r2.identifier + ' is missing');
                    merged[r2.identifier].signingShare = r2.signingShare;
                }
                if (Object.keys(merged).length !== authenticatedRound1.length) throw new Error('mismatch identifiers between rounds');
                let signingShare = Fn.ZERO;
                if (secret.commitment.length !== secret.signers.min) throw new Error('wrong commitments length');
                const localCommitment = secret.commitment.map(parsePoint);
                const localShare = polynomialEvaluate(secret.identifier, secret.coefficients);
                validateSecretShare(secret.identifier, localCommitment, localShare);
                const localCommitmentBytes = localCommitment.map(serializePoint);
                const commitments = {
                    [serializeIdentifier(secret.identifier)]: localCommitmentBytes
                };
                for(const k in merged){
                    const v = merged[k];
                    if (!v.signingShare || !v.commitment) throw new Error('mismatch identifiers');
                    const id = parseIdentifier(k); // from
                    const signingSharePart = Fn.fromBytes(v.signingShare);
                    const commitment = v.commitment.map(parsePoint);
                    validateSecretShare(secret.identifier, commitment, signingSharePart);
                    signingShare = Fn.add(signingShare, signingSharePart);
                    const idSer = serializeIdentifier(id);
                    if (commitments[idSer]) throw new Error('duplicated id=' + idSer);
                    commitments[idSer] = v.commitment;
                }
                signingShare = Fn.add(signingShare, localShare);
                const mergedCommitment = new Array(secret.signers.min).fill(Point.ZERO);
                for(const k in commitments){
                    const v = commitments[k];
                    if (v.length !== secret.signers.min) throw new Error('wrong commitments length');
                    for(let i = 0; i < v.length; i++)mergedCommitment[i] = mergedCommitment[i].add(parsePoint(v[i]));
                }
                const mergedCommitmentBytes = mergedCommitment.map(serializePoint);
                const verifyingShares = {};
                for(const k in commitments)verifyingShares[k] = serializePoint(evalutateVSS(parseIdentifier(k), mergedCommitment));
                // This is enough to sign stuff
                let res = {
                    public: {
                        signers: {
                            min: secret.signers.min,
                            max: secret.signers.max
                        },
                        commitments: mergedCommitmentBytes,
                        verifyingShares: Object.fromEntries(Object.entries(verifyingShares).map(([k, v])=>[
                                k,
                                v.slice()
                            ]))
                    },
                    secret: {
                        identifier: serializeIdentifier(secret.identifier),
                        signingShare: Fn.toBytes(signingShare)
                    }
                };
                if (adjustDKG) res = adjustDKG(res);
                for(let i = 0; i < secret.coefficients.length; i++)secret.coefficients[i] -= secret.coefficients[i];
                delete secret.coefficients;
                delete secret.round1Cache;
                delete secret.round2Cache;
                secret.step = 3;
                return res;
            },
            clean (secret) {
                (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                    identifier: 'bigint',
                    commitment: 'object',
                    signers: 'object'
                }, {
                    coefficients: 'object',
                    round1Cache: 'object',
                    round2Cache: 'object',
                    step: 'number'
                }, 'secret');
                // Instead of replacing secret bigint with another (zero?), we subtract it from itself
                // in the hope that JIT will modify it inplace, instead of creating new value.
                // This is unverified and may not work, but it is best we can do in regard of bigints.
                secret.identifier -= secret.identifier;
                if (secret.coefficients) for(let i = 0; i < secret.coefficients.length; i++)secret.coefficients[i] -= secret.coefficients[i];
                // for (const c of secret.commitment) c.fill(0);
                delete secret.round1Cache;
                delete secret.round2Cache;
                secret.step = 3;
            }
        }),
        // Trusted dealer setup
        // Generates keys for all participants
        trustedDealer (signers, identifiers, secret, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8)) {
            // if no identifiers provided, we generated default identifiers
            $47167bfa62af68b8$var$validateSigners(signers);
            if (identifiers === undefined) {
                identifiers = [];
                for(let i = 1; i <= signers.max; i++)identifiers.push(Identifier.fromNumber(i));
            } else {
                (0, $e129040e856338dd$export$c9895e5868d4e385)(identifiers, 'identifiers');
                if (identifiers.length !== signers.max) throw new Error('identifiers should be array of ' + signers.max);
            }
            const identifierNums = {};
            for (const id of identifiers){
                const idNum = parseIdentifier(id);
                if (id in identifierNums) throw new Error('duplicated id=' + id);
                identifierNums[id] = idNum;
            }
            const sp = generateSecretPolynomial(signers, secret, undefined, rng);
            const commitmentBytes = sp.commitment.map(serializePoint);
            const secretShares = {};
            const verifyingShares = {};
            for (const id of identifiers){
                const signingShare = polynomialEvaluate(identifierNums[id], sp.coefficients);
                verifyingShares[id] = serializePoint(Point.BASE.multiply(signingShare));
                secretShares[id] = {
                    identifier: id,
                    signingShare: Fn.toBytes(signingShare)
                };
            }
            return {
                public: {
                    signers: {
                        min: signers.min,
                        max: signers.max
                    },
                    commitments: commitmentBytes,
                    verifyingShares: verifyingShares
                },
                secretShares: secretShares
            };
        },
        // Validate secret (from trusted dealer or DKG)
        validateSecret (secret, pub) {
            (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                identifier: 'string',
                signingShare: 'object'
            }, {}, 'secret');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(secret.signingShare, Fn.BYTES, 'secret.signingShare');
            (0, $e129040e856338dd$export$381bae2d0f08004f)(pub, {
                signers: 'object',
                commitments: 'object',
                verifyingShares: 'object'
            }, {}, 'pub');
            $47167bfa62af68b8$var$validateSigners(pub.signers, 'pub.signers');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(pub.commitments, 'pub.commitments');
            const id = parseIdentifier(secret.identifier);
            const commitment = pub.commitments.map(parsePoint);
            const signingShare = Fn.fromBytes(secret.signingShare);
            validateSecretShare(id, commitment, signingShare);
        },
        // Actual signing
        // Round 1: each participant commit to nonces
        // Nonces kept private, commitments sent to coordinator (or every other participant)
        // NOTE: we don't need the message at this point, which lets a coordinator
        // keep multiple nonce commitments per participant in advance and skip
        // round1 for signing.
        // But then each participant needs to remember generated shares
        commit (secret, rng = (0, $e129040e856338dd$export$5f828d93ff035aa8)) {
            (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                identifier: 'string',
                signingShare: 'object'
            }, {}, 'secret');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(secret.signingShare, Fn.BYTES, 'secret.signingShare');
            if (typeof rng !== 'function') throw new TypeError('"rng" expected function, got type=' + typeof rng);
            const secretScalar = Fn.fromBytes(secret.signingShare);
            const hiding = generateNonce(secretScalar, rng);
            const binding = generateNonce(secretScalar, rng);
            const nonces = {
                hiding: Fn.toBytes(hiding),
                binding: Fn.toBytes(binding)
            };
            return {
                nonces: nonces,
                commitments: nonceCommitments(secret.identifier, nonces)
            };
        },
        // Round2: sign. Each participant creates a signature share from the secret
        // and the selected nonce commitments.
        signShare (secret, pub, nonces, commitmentList, msg) {
            (0, $e129040e856338dd$export$381bae2d0f08004f)(secret, {
                identifier: 'string',
                signingShare: 'object'
            }, {}, 'secret');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(secret.signingShare, Fn.BYTES, 'secret.signingShare');
            (0, $e129040e856338dd$export$381bae2d0f08004f)(pub, {
                signers: 'object',
                commitments: 'object',
                verifyingShares: 'object'
            }, {}, 'pub');
            $47167bfa62af68b8$var$validateSigners(pub.signers, 'pub.signers');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(pub.commitments, 'pub.commitments');
            (0, $e129040e856338dd$export$381bae2d0f08004f)(nonces, {
                hiding: 'object',
                binding: 'object'
            }, {}, 'nonces');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(nonces.hiding, Fn.BYTES, 'nonces.hiding');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(nonces.binding, Fn.BYTES, 'nonces.binding');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(commitmentList, 'commitmentList');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg, undefined, 'msg');
            $47167bfa62af68b8$var$validateCommitmentsNum(pub.signers, commitmentList.length);
            const hidingNonce0 = Fn.fromBytes(nonces.hiding);
            const bindingNonce0 = Fn.fromBytes(nonces.binding);
            if (Fn.is0(hidingNonce0) || Fn.is0(bindingNonce0)) throw new Error('signing nonces already used');
            // Reject a coordinator-assigned commitment pair that does not match the signer's own nonce
            // pair. This must happen before suite-specific nonce adjustment; secp256k1-tr may negate the
            // actual signing nonces later, but the coordinator still assigns the original commitments.
            const expectedCommitment = {
                identifier: secret.identifier,
                hiding: serializePoint(Point.BASE.multiply(hidingNonce0)),
                binding: serializePoint(Point.BASE.multiply(bindingNonce0))
            };
            const commitment = commitmentList.find((i)=>i.identifier === secret.identifier);
            if (!commitment) throw new Error('missing signer commitment');
            if ((0, $e129040e856338dd$export$58b867e287a802c8)(commitment.hiding) !== (0, $e129040e856338dd$export$58b867e287a802c8)(expectedCommitment.hiding) || (0, $e129040e856338dd$export$58b867e287a802c8)(commitment.binding) !== (0, $e129040e856338dd$export$58b867e287a802c8)(expectedCommitment.binding)) throw new Error('incorrect signer commitment');
            if (adjustSecret) secret = adjustSecret(secret, pub);
            if (adjustPublic) pub = adjustPublic(pub);
            const SK = Fn.fromBytes(secret.signingShare);
            const { lambda: lambda, challenge: challenge, bindingFactor: bindingFactor, groupCommitment: groupCommitment } = prepareShare(pub.commitments[0], commitmentList, msg, secret.identifier);
            const N = adjustNonces ? adjustNonces(groupCommitment, nonces) : nonces;
            const hidingNonce = adjustNonces ? Fn.fromBytes(N.hiding) : hidingNonce0;
            const bindingNonce = adjustNonces ? Fn.fromBytes(N.binding) : bindingNonce0;
            const t = Fn.mul(Fn.mul(lambda, SK), challenge); // challenge * lambda * SK
            const t2 = Fn.mul(bindingNonce, bindingFactor); // bindingNonce * bindingFactor
            const r = Fn.toBytes(Fn.add(Fn.add(hidingNonce, t2), t)); // t + t2 + hidingNonce
            // RFC 9591 round-one commitments are one-time-use, and round two must use the nonce
            // corresponding to the published commitment. This API returns mutable local nonce bytes,
            // so consume them after a successful signShare() call: later all-zero reuse fails closed.
            nonces.hiding.fill(0);
            nonces.binding.fill(0);
            return r;
        },
        // Each participant (or coordinator) can verify signatures from other participants
        verifyShare (pub, commitmentList, msg, identifier, sigShare) {
            (0, $e129040e856338dd$export$381bae2d0f08004f)(pub, {
                signers: 'object',
                commitments: 'object',
                verifyingShares: 'object'
            }, {}, 'pub');
            $47167bfa62af68b8$var$validateSigners(pub.signers, 'pub.signers');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(pub.commitments, 'pub.commitments');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(commitmentList, 'commitmentList');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg, undefined, 'msg');
            parseIdentifier(identifier);
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(sigShare, Fn.BYTES, 'sigShare');
            if (adjustPublic) pub = adjustPublic(pub);
            const comm = commitmentList.find((i)=>i.identifier === identifier);
            if (!comm) throw new Error('cannot find identifier commitment');
            const PK = parsePoint(pub.verifyingShares[identifier]);
            const hidingNonceCommitment = parsePoint(comm.hiding);
            const bindingNonceCommitment = parsePoint(comm.binding);
            const { lambda: lambda, challenge: challenge, bindingFactor: bindingFactor, groupCommitment: groupCommitment } = prepareShare(pub.commitments[0], commitmentList, msg, identifier);
            // Signature shares, commitments and verifying shares are public: vartime is safe here.
            // hC + bC * bF
            let commShare = hidingNonceCommitment.add(bindingNonceCommitment.multiplyUnsafe(bindingFactor));
            if (adjustGroupCommitmentShare) commShare = adjustGroupCommitmentShare(groupCommitment, commShare);
            const l = Point.BASE.multiplyUnsafe(Fn.fromBytes(sigShare)); // sigShare*G
            // commShare + PK * (challenge * lambda)
            const r = commShare.add(PK.multiplyUnsafe(Fn.mul(challenge, lambda)));
            return l.equals(r);
        },
        // Aggregate multiple signature shares into groupSignature
        aggregate (pub, commitmentList, msg, sigShares) {
            (0, $e129040e856338dd$export$381bae2d0f08004f)(pub, {
                signers: 'object',
                commitments: 'object',
                verifyingShares: 'object'
            }, {}, 'pub');
            $47167bfa62af68b8$var$validateSigners(pub.signers, 'pub.signers');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(pub.commitments, 'pub.commitments');
            (0, $e129040e856338dd$export$c9895e5868d4e385)(commitmentList, 'commitmentList');
            (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg, undefined, 'msg');
            (0, $e129040e856338dd$export$381bae2d0f08004f)(sigShares, {}, {}, 'sigShares');
            // verifyShare() applies adjustPublic too, so keep the original package for attribution.
            const rawPub = pub;
            if (adjustPublic) pub = adjustPublic(pub);
            try {
                $47167bfa62af68b8$var$validateCommitmentsNum(pub.signers, commitmentList.length);
            } catch  {
                throw new $47167bfa62af68b8$var$AggErr('aggregation failed', []);
            }
            const ids = commitmentList.map((i)=>i.identifier);
            const seen = new Set();
            for (const id of ids){
                // `sigShares` is identifier-keyed, so duplicate commitments would reuse one share twice.
                if (seen.has(id)) throw new $47167bfa62af68b8$var$AggErr('aggregation failed', []);
                seen.add(id);
            }
            if (ids.length !== Object.keys(sigShares).length) throw new $47167bfa62af68b8$var$AggErr('aggregation failed', []);
            for (const id of ids){
                if (!(id in sigShares) || !(id in pub.verifyingShares)) throw new $47167bfa62af68b8$var$AggErr('aggregation failed', []);
            }
            const GPK = parsePoint(pub.commitments[0]);
            const { groupCommitment: groupCommitment } = getGroupCommitment(GPK, commitmentList, msg);
            let z = Fn.ZERO;
            // RFC 9591 Section 5.3 aggregates by summing the validated signature shares.
            for (const id of ids)z = Fn.add(z, Fn.fromBytes(sigShares[id])); // z += zi
            if (!Basic.verify(msg, groupCommitment, z, GPK)) {
                const cheaters = [];
                for (const id of ids)if (!this.verifyShare(rawPub, commitmentList, msg, id, sigShares[id])) cheaters.push(id);
                throw new $47167bfa62af68b8$var$AggErr('aggregation failed', cheaters);
            }
            return Signature.encode(groupCommitment, z);
        },
        // Basic sign/verify using single key
        sign (msg, secretKey) {
            let sk = Fn.fromBytes(secretKey);
            // Taproot single-key signing needs the same scalar normalization as threshold keys.
            if (adjustScalar) sk = adjustScalar(sk);
            const [R, z] = Basic.sign(msg, sk);
            return Signature.encode(R, z);
        },
        verify (sig, msg, publicKey) {
            const PK = parsePublicKey ? validatePublicPoint(parsePublicKey(publicKey)) : parsePoint(publicKey);
            const { R: R, z: z } = Signature.decode(sig);
            return Basic.verify(msg, R, z, PK);
        },
        // Combine multiple secret shares to restore secret
        combineSecret (shares, signers) {
            (0, $e129040e856338dd$export$c9895e5868d4e385)(shares, 'shares');
            $47167bfa62af68b8$var$validateSigners(signers);
            if (shares.length < signers.min || shares.length > signers.max) throw new Error('wrong secret shares array');
            const points = [];
            const seen = {};
            // Interpolate over the full provided share set and reject duplicate identifiers.
            for (const s of shares){
                const idNum = parseIdentifier(s.identifier);
                const id = serializeIdentifier(idNum);
                if (seen[id]) throw new Error('duplicated id=' + id);
                seen[id] = true;
                points.push([
                    idNum,
                    Fn.fromBytes(s.signingShare)
                ]);
            }
            const xCoords = points.map(([x])=>x);
            let res = Fn.ZERO;
            for (const [x, y] of points)res = Fn.add(res, Fn.mul(y, deriveInterpolatingValue(xCoords, x)));
            return Fn.toBytes(res);
        },
        // Utils
        utils: Object.freeze({
            Fn: Fn,
            // Test RNG overrides still go through noble's non-zero scalar derivation; this is not a raw
            // "bytes become scalar" escape hatch.
            randomScalar: (rng = (0, $e129040e856338dd$export$5f828d93ff035aa8))=>Fn.toBytes(genPointScalarPair(rng).scalar),
            generateSecretPolynomial: (signers, secret, coeffs, rng)=>{
                const res = generateSecretPolynomial(signers, secret, coeffs, rng);
                return {
                    ...res,
                    commitment: res.commitment.map(serializePoint)
                };
            }
        })
    };
    return Object.freeze(frost);
}




// prettier-ignore
const $d6ac2d93e738b522$var$_0n = /* @__PURE__ */ BigInt(0), $d6ac2d93e738b522$var$_1n = /* @__PURE__ */ BigInt(1), $d6ac2d93e738b522$var$_2n = /* @__PURE__ */ BigInt(2), $d6ac2d93e738b522$var$_3n = /* @__PURE__ */ BigInt(3), $d6ac2d93e738b522$var$_4n = /* @__PURE__ */ BigInt(4);
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $d6ac2d93e738b522$var$os2ip = (0, $e129040e856338dd$export$d609354794974f8);
// Integer to Octet Stream (numberToBytesBE).
function $d6ac2d93e738b522$var$i2osp(value, length) {
    (0, $e129040e856338dd$export$4f3315d97e288446)(value);
    (0, $e129040e856338dd$export$4f3315d97e288446)(length);
    // This helper stays on the JS bitwise/u32 fast-path. Callers that need wider encodings should
    // use bigint + numberToBytesBE instead of routing large widths through this small helper.
    if (length < 0 || length > 4) throw new Error('invalid I2OSP length: ' + length);
    if (value < 0 || value > 2 ** (8 * length) - 1) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
// RFC 9380 only applies strxor() to equal-length strings; callers must preserve that invariant.
function $d6ac2d93e738b522$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
// User can always use utf8 if they want, by passing Uint8Array.
// If string is passed, we treat it as ASCII: other formats are likely a mistake.
function $d6ac2d93e738b522$var$normDST(DST) {
    if (!(0, $e129040e856338dd$export$c6fabfbfd097fc30)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or ascii string');
    const dst = typeof DST === 'string' ? (0, $e129040e856338dd$export$e151636497a65339)(DST) : DST;
    // RFC 9380 §3.1 requirement 2: tags "MUST have nonzero length".
    if (dst.length === 0) throw new Error('DST must be non-empty');
    return dst;
}
function $d6ac2d93e738b522$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg);
    (0, $e129040e856338dd$export$4f3315d97e288446)(lenInBytes);
    if (typeof H !== 'function') throw new Error('expand_message_xmd: expected hash function');
    (0, $e129040e856338dd$export$4f3315d97e288446)(H.outputLen, 'hash.outputLen');
    (0, $e129040e856338dd$export$4f3315d97e288446)(H.blockLen, 'hash.blockLen');
    DST = $d6ac2d93e738b522$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $e129040e856338dd$export$287dd7971339c972)((0, $e129040e856338dd$export$e151636497a65339)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $e129040e856338dd$export$287dd7971339c972)(DST, $d6ac2d93e738b522$var$i2osp(DST.length, 1));
    const Z_pad = new Uint8Array(r_in_bytes); // RFC 9380: Z_pad = I2OSP(0, s_in_bytes)
    const l_i_b_str = $d6ac2d93e738b522$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $e129040e856338dd$export$287dd7971339c972)(Z_pad, msg, l_i_b_str, $d6ac2d93e738b522$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $e129040e856338dd$export$287dd7971339c972)(b_0, $d6ac2d93e738b522$var$i2osp(1, 1), DST_prime));
    // `b[0]` already stores RFC `b_1`, so only derive `b_2..b_ell` here. The old `<= ell`
    // loop computed one extra tail block, which was usually sliced away but broke at max `ell=255`
    // by reaching `I2OSP(256, 1)`.
    for(let i = 1; i < ell; i++){
        const args = [
            $d6ac2d93e738b522$var$strxor(b_0, b[i - 1]),
            $d6ac2d93e738b522$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $e129040e856338dd$export$287dd7971339c972)(...args));
    }
    const pseudo_random_bytes = (0, $e129040e856338dd$export$287dd7971339c972)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $d6ac2d93e738b522$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg);
    (0, $e129040e856338dd$export$4f3315d97e288446)(lenInBytes);
    (0, $e129040e856338dd$export$4f3315d97e288446)(k, 'k');
    if (k < 0) throw new Error('expand_message_xof: invalid k');
    if (typeof H !== 'function') throw new Error('expand_message_xof: expected XOF function');
    if (typeof H.create !== 'function') throw new Error('expand_message_xof: expected XOF create');
    DST = $d6ac2d93e738b522$var$normDST(DST);
    if (lenInBytes < 0 || lenInBytes > 65535) throw new Error('expand_message_xof: invalid lenInBytes');
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // RFC 9380 §5.3.3: DST = H("H2C-OVERSIZE-DST-" || a_very_long_DST, ceil(2 * k / 8)).
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $e129040e856338dd$export$e151636497a65339)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    // Oversize DSTs are compressed above; fail closed if a custom XOF still returns one
    // (possible when k > 1020 makes the compression dkLen itself exceed 255 bytes).
    if (DST.length > 255) throw new Error('expand_message_xof: invalid DST');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($d6ac2d93e738b522$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($d6ac2d93e738b522$var$i2osp(DST.length, 1)).digest();
}
function $d6ac2d93e738b522$export$97cdd5ee18de8172(msg, count, options) {
    (0, $e129040e856338dd$export$381bae2d0f08004f)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    (0, $e129040e856338dd$export$4f3315d97e288446)(hash.outputLen, 'valid hash');
    (0, $e129040e856338dd$export$e8a750b9efad93f5)(msg);
    (0, $e129040e856338dd$export$4f3315d97e288446)(count);
    (0, $e129040e856338dd$export$4f3315d97e288446)(m, 'm');
    (0, $e129040e856338dd$export$4f3315d97e288446)(k, 'k');
    // RFC 9380 §5.2 defines hash_to_field over a list of one or more field elements and an integer
    // extension degree `m >= 1`; rejecting here avoids degenerate `[]` / `[[]]` helper outputs.
    // The RFC also treats `p` as a finite-field characteristic; bad values degenerate log2/mod.
    if (p <= BigInt(1)) throw new Error('hash_to_field: expected valid field characteristic');
    if (count < 1) throw new Error('hash_to_field: expected count >= 1');
    if (m < 1) throw new Error('hash_to_field: expected m >= 1');
    if (k < 0) throw new Error('hash_to_field: invalid k');
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $d6ac2d93e738b522$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $d6ac2d93e738b522$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only: msg is used as the uniform bytes directly. Short msg is allowed
    // on purpose (subarray() slices are short): zkcrypto map_scalar vectors feed empty okm.
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $eaac85f28e130c0a$export$842a2cf37af977e1)($d6ac2d93e738b522$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $d6ac2d93e738b522$export$9393380cf1075f28(field, map) {
    (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(field);
    // Make same order as in spec
    (0, $e129040e856338dd$export$c9895e5868d4e385)(map, 'map');
    const coeff = map.map((i, row)=>{
        (0, $e129040e856338dd$export$c9895e5868d4e385)(i, 'map[' + row + ']');
        if (i.length < 1) throw new Error('isogenyMap: expected non-empty coefficients');
        return Array.from(i).reverse();
    });
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        const isZero = field.is0(xd) || field.is0(yd);
        // Shipped Weierstrass consumers encode that affine identity as all-zero
        // coordinates, so `passZero=true` intentionally collapses zero
        // denominators to `{ x: 0, y: 0 }`.
        const [xd_inv, yd_inv] = (0, $eaac85f28e130c0a$export$a492e3387142c0e9)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        // RFC 9380 §6.6.3: if the denominator of either isogeny rational function is
        // zero, the exceptional case must return the identity point on E.
        return isZero ? {
            x: field.ZERO,
            y: field.ZERO
        } : {
            x: x,
            y: y
        };
    };
}
const $d6ac2d93e738b522$export$eaf8c8caa9e37fdf = 'HashToScalar-';
function $d6ac2d93e738b522$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    (0, $e129040e856338dd$export$381bae2d0f08004f)(defaults);
    // `Point` is intentionally not shape-validated eagerly here: point constructors vary across
    // curve families, so this helper only checks the hooks it can validate cheaply. Misconfigured
    // suites fail later when hashing first touches Point.fromAffine / Point.ZERO / clearCofactor().
    const snapshot = (src)=>Object.freeze({
            ...src,
            DST: (0, $e129040e856338dd$export$c6fabfbfd097fc30)(src.DST) ? (0, $e129040e856338dd$export$56728fb2d7dba34e)(src.DST) : src.DST,
            ...src.encodeDST === undefined ? {} : {
                encodeDST: (0, $e129040e856338dd$export$c6fabfbfd097fc30)(src.encodeDST) ? (0, $e129040e856338dd$export$56728fb2d7dba34e)(src.encodeDST) : src.encodeDST
            }
        });
    // Keep one private defaults snapshot for actual hashing and expose fresh
    // detached snapshots via the public getter.
    // Otherwise a caller could mutate `hasher.defaults.DST` in place and poison
    // the singleton hasher for every other consumer in the same process.
    const safeDefaults = snapshot(defaults);
    // Per-call options are H2CDSTOpts: only DST may be overridden. Copying just that key keeps
    // off-type option objects from silently replacing suite parameters (p/m/k/hash/expand) at
    // runtime — same pinning hashToScalar always did for p/m.
    const dstOverride = (options)=>options && options.DST !== undefined ? {
            DST: options.DST
        } : undefined;
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        // Keep ZERO as the algebraic cofactor-clearing result here; strict public point-validity
        // surfaces may still reject it later, but createHasher.clear() itself is not that boundary.
        if (P.equals(Point.ZERO)) return Point.ZERO;
        P.assertValidity();
        return P;
    }
    return Object.freeze({
        get defaults () {
            return snapshot(safeDefaults);
        },
        Point: Point,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, safeDefaults, dstOverride(options));
            const u = $d6ac2d93e738b522$export$97cdd5ee18de8172(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = safeDefaults.encodeDST === undefined ? {} : {
                DST: safeDefaults.encodeDST
            };
            const opts = Object.assign({}, safeDefaults, optsDst, dstOverride(options));
            const u = $d6ac2d93e738b522$export$97cdd5ee18de8172(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            // Curves with m=1 accept only single scalar
            if (safeDefaults.m === 1) {
                if (typeof scalars !== 'bigint') throw new Error('expected bigint (m=1)');
                return clear(map([
                    scalars
                ]));
            }
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            // RFC 9380 represents one GF(p^m) element as exactly m base-field scalars.
            if (scalars.length !== safeDefaults.m) throw new Error(`expected array of ${safeDefaults.m} bigints`);
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08. Default scalar DST is the shared generic
        // `HashToScalar-` prefix above unless the caller overrides it per invocation.
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, safeDefaults, {
                DST: $d6ac2d93e738b522$export$eaf8c8caa9e37fdf
            }, dstOverride(options), {
                p: N,
                m: 1
            });
            return $d6ac2d93e738b522$export$97cdd5ee18de8172(msg, 1, opts)[0][0];
        }
    });
}
function $d6ac2d93e738b522$export$8324ae9483e33241(Fp, Z) {
    // Fail with the usual field-shape error before touching pow/cmov on malformed field shims.
    const F = (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(Fp);
    // Generic implementation
    const q = F.ORDER;
    let l = $d6ac2d93e738b522$var$_0n;
    for(let o = q - $d6ac2d93e738b522$var$_1n; o % $d6ac2d93e738b522$var$_2n === $d6ac2d93e738b522$var$_0n; o /= $d6ac2d93e738b522$var$_2n)l += $d6ac2d93e738b522$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $d6ac2d93e738b522$var$_2n << c1 - $d6ac2d93e738b522$var$_1n - $d6ac2d93e738b522$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $d6ac2d93e738b522$var$_2n;
    const c2 = (q - $d6ac2d93e738b522$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $d6ac2d93e738b522$var$_1n) / $d6ac2d93e738b522$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $d6ac2d93e738b522$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = F.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = F.pow(Z, (c2 + $d6ac2d93e738b522$var$_1n) / $d6ac2d93e738b522$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    // RFC 9380 Appendix F.2.1.1 defines sqrt_ratio(u, v) only for v != 0.
    // We keep v=0 on the regular result path with isValid=false instead of
    // throwing so the helper stays closer to the RFC's fixed control flow.
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = F.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = F.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = F.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = F.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = F.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = F.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = F.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = F.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = F.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = F.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = F.eql(tv5, F.ONE); // 12. isQR = tv5 == 1
        tv2 = F.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = F.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = F.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = F.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $d6ac2d93e738b522$var$_1n; i--){
            let tv5 = i - $d6ac2d93e738b522$var$_2n; // 18.    tv5 = i - 2
            tv5 = $d6ac2d93e738b522$var$_2n << tv5 - $d6ac2d93e738b522$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = F.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = F.eql(tvv5, F.ONE); // 21.    e1 = tv5 == 1
            tv2 = F.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = F.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = F.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = F.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = F.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        // RFC 9380 Appendix F.2.1.1 defines sqrt_ratio(u, v) for v != 0.
        // When u = 0 and v != 0, u / v = 0 is square and the computed root is
        // still 0, so widen only the final flag and keep the full control flow.
        return {
            isValid: !F.is0(v) && (isQR || F.is0(u)),
            value: tv3
        };
    };
    if (F.ORDER % $d6ac2d93e738b522$var$_4n === $d6ac2d93e738b522$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (F.ORDER - $d6ac2d93e738b522$var$_3n) / $d6ac2d93e738b522$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = F.sqrt(F.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = F.sqr(v); // 1. tv1 = v^2
            const tv2 = F.mul(u, v); // 2. tv2 = u * v
            tv1 = F.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = F.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = F.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = F.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = F.mul(F.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = F.eql(tv3, u); // 9. isQR = tv3 == u
            let y = F.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: !F.is0(v) && isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $d6ac2d93e738b522$export$cc7fea9756a17416(Fp, opts) {
    const F = (0, $eaac85f28e130c0a$export$bd454f0cef11418d)(Fp);
    (0, $e129040e856338dd$export$381bae2d0f08004f)(opts, {}, {}, 'opts');
    const { A: A, B: B, Z: Z } = opts;
    if (!F.isValidNot0(A) || !F.isValidNot0(B) || !F.isValid(Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    // RFC 9380 §6.6.2 and Appendix H.2 require:
    // 1. Z is non-square in F
    // 2. Z != -1 in F
    // 3. g(x) - Z is irreducible over F
    // 4. g(B / (Z * A)) is square in F
    // We can enforce 1, 2, and 4 with the current field API.
    // Criterion 3 is not checked here because generic `IField<T>` does not expose
    // polynomial-ring / irreducibility operations, and this helper is used for
    // both prime and extension fields.
    if (F.eql(Z, F.neg(F.ONE)) || (0, $eaac85f28e130c0a$export$5e2b6e87f2891ea7)(F, Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    // RFC 9380 Appendix H.2 criterion 4: g(B / (Z * A)) is square in F.
    // x = B / (Z * A)
    const x = F.mul(B, F.inv(F.mul(Z, A)));
    // g(x) = x^3 + A*x + B
    const gx = F.add(F.add(F.mul(F.sqr(x), x), F.mul(A, x)), B);
    if (!(0, $eaac85f28e130c0a$export$5e2b6e87f2891ea7)(F, gx)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $d6ac2d93e738b522$export$8324ae9483e33241(F, Z);
    if (!F.isOdd) throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = F.sqr(u); // 1.  tv1 = u^2
        tv1 = F.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = F.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = F.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = F.add(tv2, F.ONE); // 5.  tv3 = tv2 + 1
        tv3 = F.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = F.cmov(Z, F.neg(tv2), !F.eql(tv2, F.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = F.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = F.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = F.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = F.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = F.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = F.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = F.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = F.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = F.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = F.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = F.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = F.mul(y, value); // 20.   y = y * y1
        x = F.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = F.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = F.isOdd(u) === F.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = F.cmov(F.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $eaac85f28e130c0a$export$a492e3387142c0e9)(F, [
            tv4
        ], true)[0];
        x = F.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}



/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
class $4d9ab8f4330b1bc7$export$7d0ef403e43ad532 {
    oHash;
    iHash;
    blockLen;
    outputLen;
    canXOF = false;
    finished = false;
    destroyed = false;
    constructor(hash, key){
        (0, $3c6c2c802c119f83$export$3ff5a4f04de7e52e)(hash);
        (0, $3c6c2c802c119f83$export$e8a750b9efad93f5)(key, undefined, 'key');
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('expected Hash instance');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of the first block) of the outer hash here,
        // we can re-use it between multiple calls via clone.
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $3c6c2c802c119f83$export$cf0b2a6c63f9e656)(pad);
    }
    update(buf) {
        (0, $3c6c2c802c119f83$export$20871f6b1d047d77)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3c6c2c802c119f83$export$20871f6b1d047d77)(this);
        (0, $3c6c2c802c119f83$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        const buf = out.subarray(0, this.outputLen);
        // Reuse the first outputLen bytes for the inner digest; the outer hash consumes them before
        // overwriting that same prefix with the final tag, leaving any oversized tail untouched.
        this.iHash.digestInto(buf);
        this.oHash.update(buf);
        this.oHash.digestInto(buf);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since the key
        // is already in state and we don't know it.
        to ||= Object.create(Object.getPrototypeOf(this), {});
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen, canXOF: canXOF } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.canXOF = canXOF;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $4d9ab8f4330b1bc7$export$355af40f8ab02f34 = /* @__PURE__ */ (()=>{
    const hmac_ = (hash, key, message)=>new $4d9ab8f4330b1bc7$export$7d0ef403e43ad532(hash, key).update(message).digest();
    hmac_.create = (hash, key)=>new $4d9ab8f4330b1bc7$export$7d0ef403e43ad532(hash, key);
    return hmac_;
})();





/**
 * ASN.1 DER (Distinguished Encoding Rules) helpers for ECDSA signatures.
 * Only implements the tiny subset needed for `SEQUENCE(INTEGER r, INTEGER s)`.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $5f57a9b3c292b71f$var$_0n = /* @__PURE__ */ BigInt(0);
class $5f57a9b3c292b71f$export$523a36accd0afb37 extends Error {
    constructor(m = ''){
        super(m);
    }
}
// Plain const so the freezes can live inside the pure initializer of the `DER` export below:
// bare top-level `Object.freeze(...)` calls would defeat tree-shaking for every importer.
const $5f57a9b3c292b71f$var$_DER = {
    // asn.1 DER encoding utils
    Err: $5f57a9b3c292b71f$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $5f57a9b3c292b71f$var$_DER;
            (0, $e129040e856338dd$export$4f3315d97e288446)(tag, 'tag');
            if (tag < 0 || tag > 255) throw new E('tlv.encode: wrong tag');
            (0, $e129040e856338dd$export$e32658751cad4ab1)(data, 'data');
            // Internal helper: callers hand this already-validated hex payload, so we only enforce
            // byte alignment here instead of re-validating every nibble.
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, $e129040e856338dd$export$4ed2545b622827c1)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $e129040e856338dd$export$4ed2545b622827c1)(len.length / 2 | 128) : '';
            const t = (0, $e129040e856338dd$export$4ed2545b622827c1)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $5f57a9b3c292b71f$var$_DER;
            data = (0, $e129040e856338dd$export$e8a750b9efad93f5)(data, undefined, 'DER data');
            let pos = 0;
            if (tag < 0 || tag > 255) throw new E('tlv.decode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            // First bit of first length byte is the short/long form flag.
            const isLong = !!(first & 128);
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                // This would overflow u32 in JS.
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big');
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $5f57a9b3c292b71f$var$_DER;
            (0, $e129040e856338dd$export$288eb97b5b0dec03)(num);
            if (num < $5f57a9b3c292b71f$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, $e129040e856338dd$export$4ed2545b622827c1)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = $5f57a9b3c292b71f$var$_DER;
            if (data.length < 1) throw new E('invalid signature integer: empty');
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            // Single-byte zero `00` is the canonical DER INTEGER encoding for zero.
            if (data.length > 1 && data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, $e129040e856338dd$export$d609354794974f8)(data);
        }
    },
    toSig (bytes, maxScalarBytes) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $5f57a9b3c292b71f$var$_DER;
        if (maxScalarBytes !== undefined) {
            (0, $e129040e856338dd$export$4f3315d97e288446)(maxScalarBytes, 'maxScalarBytes');
            if (maxScalarBytes < 1) throw new E('invalid signature: maxScalarBytes must be positive');
        }
        const data = (0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes, undefined, 'signature');
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        // Enforce curve-provided bounds before bytes-to-hex-to-BigInt conversion can amplify memory.
        if (maxScalarBytes !== undefined && (rBytes.length > maxScalarBytes || sBytes.length > maxScalarBytes)) throw new E('invalid signature: integer too large');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $5f57a9b3c292b71f$var$_DER;
        (0, $e129040e856338dd$export$381bae2d0f08004f)(sig, {
            r: 'bigint',
            s: 'bigint'
        }, {}, 'sig');
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
const $5f57a9b3c292b71f$export$56ac33195d7076db = /* @__PURE__ */ (()=>{
    Object.freeze($5f57a9b3c292b71f$var$_DER._tlv);
    Object.freeze($5f57a9b3c292b71f$var$_DER._int);
    return Object.freeze($5f57a9b3c292b71f$var$_DER);
})();



// We construct the basis so `den` is always positive and equals `n`,
// but the `num` sign depends on the basis, not on the secret value.
// Exact half-way cases round away from zero, which keeps the split symmetric
// around the reduced-basis boundaries used by endomorphism decomposition.
const $84b2ae616b59ae0e$var$divNearest = (num, den)=>(num + (num >= 0 ? den : -den) / $84b2ae616b59ae0e$var$_2n) / den;
function $84b2ae616b59ae0e$export$2e78c1c514ef8576(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // Callers must provide a reduced GLV basis whose vectors satisfy
    // `a + b * lambda ≡ 0 (mod n)`; this helper only sees the basis and `n`.
    // Reject unreduced scalars instead of silently treating them mod n.
    (0, $e129040e856338dd$export$86cc12b5dde3c1e4)('scalar', k, $84b2ae616b59ae0e$var$_0n, n);
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = $84b2ae616b59ae0e$var$divNearest(b2 * k, n);
    const c2 = $84b2ae616b59ae0e$var$divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < $84b2ae616b59ae0e$var$_0n;
    const k2neg = k2 < $84b2ae616b59ae0e$var$_0n;
    if (k1neg) k1 = -k1;
    if (k2neg) k2 = -k2;
    // Double check that resulting scalar is less than half bits of N: the wNAF pair walk
    // relies on the halves being short. This should only happen on wrong bases.
    // Also, the math inside is complex enough that this guard is worth keeping.
    const MAX_NUM = (0, $e129040e856338dd$export$803efa2fa1c7279)(Math.ceil((0, $e129040e856338dd$export$e93ef600c41761a9)(n) / 2)) + $84b2ae616b59ae0e$var$_1n; // Half bits of N
    if (k1 < $84b2ae616b59ae0e$var$_0n || k1 >= MAX_NUM || k2 < $84b2ae616b59ae0e$var$_0n || k2 >= MAX_NUM) throw new Error('splitScalar (endomorphism): failed for k');
    return {
        k1neg: k1neg,
        k1: k1,
        k2neg: k2neg,
        k2: k2
    };
}
function $84b2ae616b59ae0e$var$validateSigFormat(format) {
    if (![
        'compact',
        'recovered',
        'der'
    ].includes(format)) throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function $84b2ae616b59ae0e$var$validateSigOpts(opts, def) {
    (0, $e129040e856338dd$export$381bae2d0f08004f)(opts);
    const optsn = {};
    // Normalize only the declared option subset from `def`; unknown keys are
    // intentionally ignored so shared / superset option bags stay valid here too.
    // `extraEntropy` stays an opaque payload until the signing path consumes it.
    for (let optName of Object.keys(def))// @ts-ignore
    optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    (0, $e129040e856338dd$export$809304d28d77d92d)(optsn.lowS, 'lowS');
    (0, $e129040e856338dd$export$809304d28d77d92d)(optsn.prehash, 'prehash');
    if (optsn.format !== undefined) $84b2ae616b59ae0e$var$validateSigFormat(optsn.format);
    return optsn;
}
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $84b2ae616b59ae0e$var$_0n = /* @__PURE__ */ BigInt(0), $84b2ae616b59ae0e$var$_1n = /* @__PURE__ */ BigInt(1), $84b2ae616b59ae0e$var$_2n = /* @__PURE__ */ BigInt(2), $84b2ae616b59ae0e$var$_3n = /* @__PURE__ */ BigInt(3), $84b2ae616b59ae0e$var$_4n = /* @__PURE__ */ BigInt(4);
function $84b2ae616b59ae0e$export$350b8ea6f1c27fae(params, extraOpts = {}) {
    const validated = (0, $4f109436b1b5c1eb$export$1fe76009d71a4957)('weierstrass', params, extraOpts);
    const Fp = validated.Fp;
    const Fn = validated.Fn;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    (0, $e129040e856338dd$export$381bae2d0f08004f)(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object',
        randomBytes: 'function'
    });
    // Snapshot every hook and take an owned copy of nested GLV configuration. Later mutations of
    // the caller's options must not change arithmetic, subgroup, or codec policy.
    const { endo: endoOpts, allowInfinityPoint: allowInfinityPoint, clearCofactor: clearCofactor, isTorsionFree: isTorsionFree, fromBytes: fromBytes, toBytes: toBytes } = extraOpts;
    const randomBytes = extraOpts.randomBytes === undefined ? (0, $e129040e856338dd$export$5f828d93ff035aa8) : extraOpts.randomBytes;
    if (endoOpts) {
        if (!Fp.is0(CURVE.a) || typeof endoOpts.beta !== 'bigint' || !Array.isArray(endoOpts.basises)) throw new Error('invalid endo: expected "beta": bigint and "basises": array');
    }
    const endo = endoOpts ? {
        beta: endoOpts.beta,
        basises: endoOpts.basises.map((basis)=>[
                ...basis
            ])
    } : undefined;
    const lengths = $84b2ae616b59ae0e$var$getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd) throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        // Handle infinity before toAffine(), which maps ZERO to (0, 0) silently: without this the
        // encoder would emit an all-zero byte string that decodes back as a different point. Only
        // curves that opt into infinity as a public point value get the SEC 1 byte form.
        if (point.is0()) {
            if (!allowInfinityPoint) throw new Error('bad point: ZERO');
            return Uint8Array.of(0); // SEC 1 v2.0 §2.3.3
        }
        const { x: x, y: y } = point.toAffine();
        const bx = Fp.toBytes(x);
        (0, $e129040e856338dd$export$809304d28d77d92d)(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return (0, $e129040e856338dd$export$287dd7971339c972)($84b2ae616b59ae0e$var$pprefix(hasEvenY), bx);
        } else return (0, $e129040e856338dd$export$287dd7971339c972)(Uint8Array.of(0x04), bx, Fp.toBytes(y));
    }
    function pointFromBytes(bytes) {
        (0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // SEC 1 v2.0 §2.3.4 decodes 0x00 as infinity, but §3.2.2 rejects infinity as a public key.
        // Leaving 0x00 undecodable by default makes that rejection structural rather than a check:
        // callers reuse this parser as the strict key boundary, and infinity is simply not
        // expressible. Curves where infinity is a real wire value opt into the codec instead.
        // secp256k1 crosstests show OpenSSL raw point codecs accept 0x00 too.
        if (allowInfinityPoint && length === 1 && head === 0x00) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x)) throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            } catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const evenY = Fp.isOdd(y);
            const evenH = (head & 1) === 1; // ECDSA-specific
            if (evenH !== evenY) y = Fp.neg(y);
            return {
                x: x,
                y: y
            };
        } else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y)) throw new Error('bad point: is not on curve');
            return {
                x: x,
                y: y
            };
        } else throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
    }
    const encodePoint = toBytes === undefined ? pointToBytes : toBytes;
    const decodePoint = fromBytes === undefined ? pointFromBytes : fromBytes;
    // Hoisted from double() / add(): curve params never change after construction.
    // Koblitz curves (a=0, e.g. secp256k1) skip the three a-multiplications per operation;
    // the selection depends only on public curve constants.
    const b3 = Fp.mul(CURVE.b, $84b2ae616b59ae0e$var$_3n);
    const mulA = Fp.is0(CURVE.a) ? (_)=>Fp.ZERO : (x)=>Fp.mul(CURVE.a, x);
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x);
        const x3 = Fp.mul(x2, x);
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */ function isValidXY(x, y) {
        const left = Fp.sqr(y);
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Keep constructor-time generator validation cheap: callers are responsible for supplying the
    // correct prime-order base point, while eager subgroup checks here would slow heavy module imports.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $84b2ae616b59ae0e$var$_3n), $84b2ae616b59ae0e$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */ function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || banZero && Fp.is0(n)) throw new Error(`bad point coordinate ${title}`);
        // Extension-field elements are objects. Keep point coordinates detached from caller-owned
        // objects so their mutation cannot invalidate cached on-curve / subgroup checks. Primitive
        // field elements (bigints in shipped prime fields) are already immutable values.
        return typeof n === 'object' && n !== null ? Fp.create(n) : n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('Weierstrass Point expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises) throw new Error('no endo');
        return $84b2ae616b59ae0e$export$2e78c1c514ef8576(k, endo.basises, Fn.ORDER);
    }
    /**
     * Appends a (point, scalar) pair to the inputs of a vartime wNAF walk
     * ({@link mulAddUnsafe}). With GLV endomorphism the scalar is split into two half-width
     * pairs against P and ψ(P) = (β⋅x, y), halving the walk's shared doubling chain;
     * split signs fold into the points.
     */ function pushWnafPair(points, scalars, p, k) {
        if (!Fn.isValid(k)) throw new RangeError('invalid scalar: out of range'); // 0 is valid
        if (endo) {
            const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(k);
            const psi = new Point(Fp.mul(p.X, endo.beta), p.Y, p.Z);
            points.push(k1neg ? p.negate() : p, k2neg ? psi.negate() : psi);
            scalars.push(k1, k2);
        } else {
            points.push(p);
            scalars.push(k);
        }
    }
    // Successful assertValidity() results are cached: Point instances are frozen at construction,
    // so on-curve + subgroup facts cannot change afterwards. Only success is cached — invalid
    // points re-throw on every call. This matters most for pairing curves, where subgroup checks
    // cost a scalar multiplication and the same instance is re-validated across layers
    // (signature fromBytes, pairingBatch) or across repeated verifies with a cached public key.
    const validityCache = new WeakSet();
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        static BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
        static ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
        static Fp = Fp;
        static Fn = Fn;
        X;
        Y;
        Z;
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ constructor(X, Y, Z){
            this.X = acoord('x', X);
            // This is not just about ZERO / infinity: ambient curves can have real
            // finite points with y=0. Those points are 2-torsion, so they cannot lie
            // in the odd prime-order subgroups this point type is meant to represent.
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint((0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes((0, $e129040e856338dd$export$31c96b9df38bc8d4)(hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * @param isLazy - true will defer table computation until the first multiplication
         */ precompute(windowSize = 6, isLazy = true) {
            wnaf.setWindowSize(this, windowSize);
            if (!isLazy) this.multiply($84b2ae616b59ae0e$var$_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */ assertValidity() {
            const p = this;
            if (p.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // Keep the accepted infinity encoding canonical: projective-equivalent (X, Y, 0) points
                // like (1, 1, 0) compare equal to ZERO, but only (0, 1, 0) should pass this guard.
                if (allowInfinityPoint && Fp.is0(p.X) && Fp.eql(p.Y, Fp.ONE) && Fp.is0(p.Z)) return;
                throw new Error('bad point: ZERO');
            }
            if (validityCache.has(p)) return;
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = p.toAffine();
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not field elements');
            if (!isValidXY(x, y)) throw new Error('bad point: equation left != right');
            if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
            validityCache.add(p);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */ equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */ negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = mulA(Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = mulA(t2);
            t3 = Fp.sub(t0, t2);
            t3 = mulA(t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = mulA(t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = mulA(t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = mulA(t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            // Validate before calling `negate()` so wrong inputs fail with the point guard
            // instead of leaking a foreign `negate()` error.
            aprjpoint(other);
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses precomputed tables (signed fixed-window wNAF) when available.
         * Uses scalar blinding and avoids endomorphism splitting in the secret-scalar path.
         * @param scalar - by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            // Keep the subgroup-scalar contract strict instead of reducing 0 / n to ZERO.
            // In key/signature-style callers, those values usually mean broken hash/scalar plumbing,
            // and failing closed is safer than silently producing the identity point.
            if (!Fn.isValidNot0(scalar)) throw new RangeError('invalid scalar: out of range'); // 0 is invalid
            const { p: p, f: f } = wnaf.mulSecret(this, scalar, cofactor, normalize);
            return normalize([
                p,
                f
            ])[0];
        }
        /**
         * Non-constant-time multiplication. Uses width-4 wNAF with GLV endomorphism splitting
         * when available (two half-width scalars sharing one halved doubling chain).
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(scalar) {
            const p = this;
            const sc = scalar;
            // Public-scalar callers may need 0, but n and larger values stay rejected here too.
            // Reducing them mod n would turn bad caller input into an accidental identity point.
            if (!Fn.isValid(sc)) throw new RangeError('invalid scalar: out of range'); // 0 is valid
            if (sc === $84b2ae616b59ae0e$var$_0n || p.is0()) return Point.ZERO;
            if (sc === $84b2ae616b59ae0e$var$_1n) return p;
            if (wnaf.hasWindowSize(this)) return wnaf.mulUnsafe(p, sc, normalize); // precomputes
            const points = [];
            const scalars = [];
            pushWnafPair(points, scalars, p, sc);
            return (0, $4f109436b1b5c1eb$export$4eb79287de74dd6)(Point, points, scalars);
        }
        /**
         * Non-constant-time double-scalar multiplication `a⋅this + b⋅other` (Strauss–Shamir).
         * Both walks share one doubling chain via {@link mulAddUnsafe}, and GLV endomorphism
         * (when available) halves the chain again by splitting each scalar into two half-width
         * parts. Used by ECDSA verification and public-key recovery for `R = u1⋅G + u2⋅P`.
         * Only for public scalars.
         */ mulAddUnsafe(a, other, b) {
            aprjpoint(other);
            const points = [];
            const scalars = [];
            pushWnafPair(points, scalars, this, a);
            pushWnafPair(points, scalars, other, b);
            return (0, $4f109436b1b5c1eb$export$4eb79287de74dd6)(Point, points, scalars);
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * (X, Y, Z) ∋ (x=X/Z, y=Y/Z).
         * @param invertedZ - Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */ toAffine(invertedZ) {
            const p = this;
            let iz = invertedZ;
            if (iz != null && !Fp.isValid(iz)) throw new RangeError('"invertedZ" expected valid field element');
            const { X: X, Y: Y, Z: Z } = p;
            // Fast-path for normalized points
            if (Fp.eql(Z, Fp.ONE)) return {
                x: X,
                y: Y
            };
            const is0 = p.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(Z);
            const x = Fp.mul(X, iz);
            const y = Fp.mul(Y, iz);
            const zz = Fp.mul(Z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
            return {
                x: x,
                y: y
            };
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */ isTorsionFree() {
            if (cofactor === $84b2ae616b59ae0e$var$_1n) return true;
            if (isTorsionFree) return isTorsionFree(Point, this);
            // unsafe() will use the uncached wNAF path internally, since CURVE_ORDER >= Fn.ORDER
            return wnaf.mulUnsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            if (cofactor === $84b2ae616b59ae0e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            // Default fallback assumes the cofactor fits the usual subgroup-scalar
            // multiplyUnsafe() contract. Curves with larger / structured cofactors
            // should define a clearCofactor override anyway (e.g. psi/Frobenius maps).
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            if (cofactor === $84b2ae616b59ae0e$var$_1n) return this.is0(); // Fast-path
            return this.clearCofactor().is0();
        }
        toBytes(isCompressed = true) {
            (0, $e129040e856338dd$export$809304d28d77d92d)(isCompressed, 'isCompressed');
            // assertValidity() covers on-curve and subgroup membership. The encoder below repeats the
            // infinity check rather than relying on this call, so it stays correct for any caller.
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return (0, $e129040e856338dd$export$58b867e287a802c8)(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
    }
    const normalize = (points)=>(0, $4f109436b1b5c1eb$export$bc27bc65d7bff1c7)(Point, points);
    const wnaf = new (0, $4f109436b1b5c1eb$export$e102566b07be6df2)(Point, randomBytes);
    // Enable W=6 wNAF precomputes. Slows down first publicKey computation.
    // Disable for tiny toy curves, with scalar fields < 6 bits.
    if (wnaf.bits >= 6) Point.BASE.precompute(6);
    Object.freeze(Point.prototype);
    Object.freeze(Point);
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function $84b2ae616b59ae0e$var$pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
function $84b2ae616b59ae0e$var$getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        // Raw compact `(r || s)` signature width; DER and recovered signatures use
        // different lengths outside this helper.
        signature: 2 * Fn.BYTES
    };
}
function $84b2ae616b59ae0e$export$cb44b25bcf287f5d(Point, ecdhOpts = {}) {
    (0, $4f109436b1b5c1eb$export$facc60e77e5ab0c2)(Point);
    const { Fn: Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes === undefined ? (0, $e129040e856338dd$export$5f828d93ff035aa8) : ecdhOpts.randomBytes;
    // Keep the advertised seed length aligned with mapHashToField(), which keeps a hard 16-byte
    // minimum even on toy curves.
    const lengths = Object.assign($84b2ae616b59ae0e$var$getWLengths(Point.Fp, Fn), {
        seed: Math.max((0, $eaac85f28e130c0a$export$d058763b563056af)(Fn.ORDER), 16)
    });
    function isValidSecretKey(secretKey) {
        try {
            const num = Fn.fromBytes(secretKey);
            return Fn.isValidNot0(num);
        } catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp) return false;
            if (isCompressed === false && l !== publicKeyUncompressed) return false;
            // SEC 1 §3.2.2: the identity is never a valid public key, even on curves whose codec
            // can decode it.
            return !Point.fromBytes(publicKey).is0();
        } catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ function randomSecretKey(seed) {
        seed = seed === undefined ? randomBytes_(lengths.seed) : seed;
        return (0, $eaac85f28e130c0a$export$20cb21dbfa61dac3)((0, $e129040e856338dd$export$e8a750b9efad93f5)(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed - whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply(Fn.fromBytes(secretKey)).toBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const { secretKey: secretKey, publicKey: publicKey, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        const allowedLengths = Fn._lengths;
        if (!(0, $e129040e856338dd$export$c6fabfbfd097fc30)(item)) return undefined;
        const l = (0, $e129040e856338dd$export$e8a750b9efad93f5)(item, undefined, 'key').length;
        const isPub = l === publicKey || l === publicKeyUncompressed;
        const isSec = l === secretKey || !!allowedLengths?.includes(l);
        // P-521 accepts both 65- and 66-byte secret keys, so overlapping lengths stay ambiguous.
        if (isPub && isSec) return undefined;
        return isPub;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes encoded shared point from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result or expose the SEC 1 x-coordinate-only `z`.
     * Returns the encoded shared point on purpose: callers that need `x_P`
     * can derive it from the encoded point, but `x_P` alone cannot recover the
     * point/parity back.
     * This helper only exposes the fully validated public-key path, not cofactor DH.
     * @param isCompressed - whether to return compact (default), or full key
     * @returns shared point encoding
     */ function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true) throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false) throw new Error('second arg must be public key');
        const s = Fn.fromBytes(secretKeyA);
        const b = Point.fromBytes(publicKeyB); // checks for being on-curve
        if (b.is0()) throw new Error('invalid public key: point at infinity');
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        randomSecretKey: randomSecretKey
    };
    const keygen = (0, $4f109436b1b5c1eb$export$f3f81ccca4e43a9b)(randomSecretKey, getPublicKey);
    Object.freeze(utils);
    Object.freeze(lengths);
    return Object.freeze({
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        keygen: keygen,
        Point: Point,
        utils: utils,
        lengths: lengths
    });
}
function $84b2ae616b59ae0e$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts = {}) {
    (0, $4f109436b1b5c1eb$export$facc60e77e5ab0c2)(Point);
    // Custom hash / bits2int hooks are treated as pure functions over validated caller-owned bytes.
    const hash_ = hash;
    (0, $3c6c2c802c119f83$export$3ff5a4f04de7e52e)(hash_);
    (0, $e129040e856338dd$export$381bae2d0f08004f)(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function'
    });
    const opts = Object.assign({}, ecdsaOpts);
    const randomBytes = opts.randomBytes === undefined ? (0, $e129040e856338dd$export$5f828d93ff035aa8) : opts.randomBytes;
    const hmac = opts.hmac === undefined ? (key, msg)=>(0, $4d9ab8f4330b1bc7$export$355af40f8ab02f34)(hash_, key, msg) : opts.hmac;
    const { Fp: Fp, Fn: Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    // Nonce-inversion blinding in k2sig draws `getMinHashLength(n)` bytes per sign. Probe the RNG
    // once (see {@link probeRandomBytes}, shared with ScalarMultiplier): in environments without
    // working randomness, signing downgrades to Fermat inversion (invertCt) instead of throwing on
    // every sign(). The shape of returned bytes is still validated (by mapHashToField) on every
    // blinded call, where breakage fails closed.
    const blindLength = (0, $eaac85f28e130c0a$export$d058763b563056af)(CURVE_ORDER);
    const csprng = (0, $4f109436b1b5c1eb$export$c3ee88a08062d41c)(randomBytes, blindLength);
    const { keygen: keygen, getPublicKey: getPublicKey, getSharedSecret: getSharedSecret, utils: utils, lengths: lengths } = $84b2ae616b59ae0e$export$cb44b25bcf287f5d(Point, opts);
    const defaultSigOpts = {
        prehash: true,
        lowS: typeof opts.lowS === 'boolean' ? opts.lowS : true,
        format: 'compact',
        extraEntropy: false
    };
    // SEC 1 4.1.6 public-key recovery tries x = r + jn for j = 0..h. Our recovered-signature
    // format only stores one overflow bit, so it can only distinguish q.x = r from q.x = r + n.
    // A third lift would have the form q.x = r + 2n. Since valid ECDSA r is in 1..n-1, the
    // smallest such lift is 1 + 2n, not 2n.
    const hasLargeRecoveryLifts = CURVE_ORDER * $84b2ae616b59ae0e$var$_2n + $84b2ae616b59ae0e$var$_1n < Fp.ORDER;
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $84b2ae616b59ae0e$var$_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num)) throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function assertFieldSignIsSupported() {
        if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
    }
    // Recovery id of an affine point (x, y) whose x reduces to signature `r` mod n:
    // bit 0 = y parity, bit 1 = x overflowed the group order (x = r + n).
    function getRecoveryBit(x, y, r) {
        assertFieldSignIsSupported();
        return (x === r ? 0 : 2) | Number(Fp.isOdd(y));
    }
    function assertRecoverableCurve() {
        // ECDSA recovery only supports curves where the current recovery id can distinguish
        // q.x = r and q.x = r + n; larger lifts may need additional `r + n*i` branches.
        // SEC 1 4.1.6 recovers candidates via x = r + jn, but this format only encodes j = 0 or 1.
        // The next possible candidate is q.x = r + 2n, and its smallest valid value is 1 + 2n.
        // To easily get i, we either need to:
        // a. increase amount of valid recid values (4, 5...); OR
        // b. prohibit recovered signatures for those curves.
        if (hasLargeRecoveryLifts) throw new Error('"recovered" sig type is not supported for cofactor >2 curves');
    }
    function validateSigLength(bytes, format) {
        $84b2ae616b59ae0e$var$validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return (0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes, sizer);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */ class Signature {
        r;
        s;
        recovery;
        constructor(r, s, recovery){
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) {
                assertRecoverableCurve();
                if (![
                    0,
                    1,
                    2,
                    3
                ].includes(recovery)) throw new Error('invalid recovery id');
                this.recovery = recovery;
            }
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts.format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                // Valid scalar INTEGERs use at most Fn.BYTES plus one DER sign-padding byte. Keep the
                // total bound conservative so malformed inputs are rejected before parsing any INTEGER.
                if (bytes.length > 2 * Fn.BYTES + 16) throw new (0, $5f57a9b3c292b71f$export$56ac33195d7076db).Err('invalid signature: DER signature too long');
                const { r: r, s: s } = (0, $5f57a9b3c292b71f$export$56ac33195d7076db).toSig((0, $e129040e856338dd$export$e8a750b9efad93f5)(bytes), Fn.BYTES + 1);
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = lengths.signature / 2;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes((0, $e129040e856338dd$export$31c96b9df38bc8d4)(hex), format);
        }
        assertRecovery() {
            const { recovery: recovery } = this;
            if (recovery == null) throw new Error('invalid recovery id: must be present');
            return recovery;
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        // Unlike the top-level helper below, this method expects a digest that has
        // already been hashed to the curve's message representative.
        recoverPublicKey(messageHash) {
            const { r: r, s: s } = this;
            const recovery = this.assertRecovery();
            const radj = recovery === 2 || recovery === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj)) throw new Error('invalid recovery id: sig.r+curve.n != R.x');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes((0, $e129040e856338dd$export$287dd7971339c972)($84b2ae616b59ae0e$var$pprefix((recovery & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN((0, $e129040e856338dd$export$e8a750b9efad93f5)(messageHash, undefined, 'msgHash')); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.mulAddUnsafe(u1, R, u2);
            if (Q.is0()) throw new Error('invalid recovery: point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts.format) {
            $84b2ae616b59ae0e$var$validateSigFormat(format);
            if (format === 'der') return (0, $e129040e856338dd$export$31c96b9df38bc8d4)((0, $5f57a9b3c292b71f$export$56ac33195d7076db).hexFromSig(this));
            const { r: r, s: s } = this;
            const rb = Fn.toBytes(r);
            const sb = Fn.toBytes(s);
            if (format === 'recovered') {
                assertRecoverableCurve();
                return (0, $e129040e856338dd$export$287dd7971339c972)(Uint8Array.of(this.assertRecovery()), rb, sb);
            }
            return (0, $e129040e856338dd$export$287dd7971339c972)(rb, sb);
        }
        toHex(format) {
            return (0, $e129040e856338dd$export$58b867e287a802c8)(this.toBytes(format));
        }
    }
    Object.freeze(Signature.prototype);
    Object.freeze(Signature);
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = opts.bits2int === undefined ? function bits2int_def(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $e129040e856338dd$export$d609354794974f8)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    } : opts.bits2int;
    const bits2int_modN = opts.bits2int_modN === undefined ? function bits2int_modN_def(bytes) {
        return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
    } : opts.bits2int_modN;
    const ORDER_MASK = (0, $e129040e856338dd$export$803efa2fa1c7279)(fnBits);
    // Pads output with zero as per spec.
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */ function int2octets(num) {
        (0, $e129040e856338dd$export$86cc12b5dde3c1e4)('num < 2^' + fnBits, num, $84b2ae616b59ae0e$var$_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        (0, $e129040e856338dd$export$e8a750b9efad93f5)(message, undefined, 'message');
        return prehash ? (0, $e129040e856338dd$export$e8a750b9efad93f5)(hash_(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */ function prepSig(message, secretKey, opts) {
        const { lowS: lowS, prehash: prehash, extraEntropy: extraEntropy } = $84b2ae616b59ae0e$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = Fn.fromBytes(secretKey); // validate secret key, convert to bigint
        if (!Fn.isValidNot0(d)) throw new Error('invalid private key');
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push((0, $e129040e856338dd$export$e8a750b9efad93f5)(e, undefined, 'extraEntropy')); // check for being bytes
        }
        const seed = (0, $e129040e856338dd$export$287dd7971339c972)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // The nonce inversion is blinded: with random b ∈ [1,n−1], s = (bk)^-1(bm + bdr) per
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. Fn.inv()'s extended-Euclidean
        // loop count depends on its input (cf. Minerva), but here it only ever sees b·k — uniformly
        // random, independent of k — so its timing reveals nothing about the nonce; b also masks d in
        // the products. Without a CSPRNG (probed in ecdsa()) we fall back to Fermat inversion
        // (invertCt), whose control flow is data-independent, at ~4x the inversion cost.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!Fn.isValidNot0(k)) return; // Valid scalars (including k) must be in 1..N-1
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === $84b2ae616b59ae0e$var$_0n) return;
            let s;
            if (csprng !== undefined) {
                // mapHashToField maps 1.5x-order-length uniform bytes into [1, n-1], negligible bias.
                const b = (0, $e129040e856338dd$export$d609354794974f8)((0, $eaac85f28e130c0a$export$20cb21dbfa61dac3)(csprng(blindLength), CURVE_ORDER));
                const ibk = Fn.inv(Fn.mul(b, k)); // (bk)^-1: inversion input is decorrelated from k
                const bm = Fn.mul(b, m);
                const bd = Fn.mul(b, d);
                s = Fn.create(ibk * Fn.create(bm + bd * r)); // s = (bk)^-1(bm + bdr) = k^-1(m + rd) mod n
            } else {
                const ik = (0, $eaac85f28e130c0a$export$1dc1e1728368e49e)(k, CURVE_ORDER); // k^-1 mod n with data-independent control flow
                s = Fn.create(ik * Fn.create(m + r * d)); // s = k^-1(m + rd) mod n
            }
            if (s === $84b2ae616b59ae0e$var$_0n) return;
            let recovery = getRecoveryBit(q.x, q.y, r); // recovery bit (2 or 3 when q.x>n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always in the bottom half of N
                recovery ^= 1;
            }
            return new Signature(r, normS, hasLargeRecoveryLifts ? undefined : recovery);
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    /**
     * Signs a message or message hash with a secret key.
     * With the default `prehash: true`, raw message bytes are hashed internally;
     * only `{ prehash: false }` expects a caller-supplied digest.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */ function sign(message, secretKey, opts = {}) {
        const { seed: seed, k2sig: k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = (0, $e129040e856338dd$export$d459d139192e4fba)(hash_.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig.toBytes(opts.format);
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, message, publicKey, opts = {}) {
        const { lowS: lowS, prehash: prehash, format: format } = $84b2ae616b59ae0e$var$validateSigOpts(opts, defaultSigOpts);
        publicKey = (0, $e129040e856338dd$export$e8a750b9efad93f5)(publicKey, undefined, 'publicKey');
        message = validateMsgAndHash(message, prehash);
        if (!(0, $e129040e856338dd$export$c6fabfbfd097fc30)(signature)) {
            const end = signature instanceof Signature ? ', use sig.toBytes()' : '';
            throw new Error('verify expects Uint8Array signature' + end);
        }
        validateSigLength(signature, format); // execute this twice because we want loud error
        try {
            const sig = Signature.fromBytes(signature, format);
            const P = Point.fromBytes(publicKey);
            // SEC 1 verification keys must not be the identity, even when the generic point decoder
            // permits infinity for another protocol (for example, a pairing curve).
            if (P.is0()) return false;
            if (lowS && sig.hasHighS()) return false;
            const { r: r, s: s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.mulAddUnsafe(u1, P, u2); // u1⋅G + u2⋅P, joint Strauss–Shamir
            if (R.is0()) return false;
            const q = R.toAffine();
            const v = Fn.create(q.x); // v = R.x mod n
            if (v !== r) return false;
            // R is the exact point `recoverPublicKey(r, recid)` reconstructs (sR = hG + rP),
            // so binding the signature to its recovery id only needs R's parity/overflow bits.
            if (format === 'recovered' && sig.recovery !== getRecoveryBit(q.x, q.y, r)) return false;
            return true;
        } catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        // Top-level recovery mirrors `sign()` / `verify()`: it hashes raw message
        // bytes first unless the caller passes `{ prehash: false }`.
        const { prehash: prehash } = $84b2ae616b59ae0e$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    // utils.isValidPublicKey() already rejects the identity, so ECDSA needs no shadow copy.
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        utils: utils,
        lengths: lengths,
        Point: Point,
        sign: sign,
        verify: verify,
        recoverPublicKey: recoverPublicKey,
        Signature: Signature,
        hash: hash_
    });
}



// Seems like generator was produced from some seed:
// `Pointk1.BASE.multiply(Pointk1.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const $ada755e79ac828b0$var$secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')
};
const $ada755e79ac828b0$var$secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [
            BigInt('0x3086d221a7d46bcde86c90e49284eb15'),
            -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')
        ],
        [
            BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'),
            BigInt('0x3086d221a7d46bcde86c90e49284eb15')
        ]
    ]
};
const $ada755e79ac828b0$var$_0n = /* @__PURE__ */ BigInt(0);
const $ada755e79ac828b0$var$_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $ada755e79ac828b0$var$sqrtMod(y) {
    const P = $ada755e79ac828b0$var$secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b3, _3n, P) * b3 % P;
    const b9 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b6, _3n, P) * b3 % P;
    const b11 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b9, $ada755e79ac828b0$var$_2n, P) * b2 % P;
    const b22 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b11, _11n, P) * b11 % P;
    const b44 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b22, _22n, P) * b22 % P;
    const b88 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b44, _44n, P) * b44 % P;
    const b176 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b88, _88n, P) * b88 % P;
    const b220 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b176, _44n, P) * b44 % P;
    const b223 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b220, _3n, P) * b3 % P;
    const t1 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(b223, _23n, P) * b22 % P;
    const t2 = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(t1, _6n, P) * b2 % P;
    const root = (0, $eaac85f28e130c0a$export$fa569bd808b67eef)(t2, $ada755e79ac828b0$var$_2n, P);
    if (!$ada755e79ac828b0$var$Fpk1.eql($ada755e79ac828b0$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $ada755e79ac828b0$var$Fpk1 = /* @__PURE__ */ (0, $eaac85f28e130c0a$export$a455218a85c89869)($ada755e79ac828b0$var$secp256k1_CURVE.p, {
    sqrt: $ada755e79ac828b0$var$sqrtMod
});
const $ada755e79ac828b0$var$Pointk1 = /* @__PURE__ */ (0, $84b2ae616b59ae0e$export$350b8ea6f1c27fae)($ada755e79ac828b0$var$secp256k1_CURVE, {
    Fp: $ada755e79ac828b0$var$Fpk1,
    endo: $ada755e79ac828b0$var$secp256k1_ENDO
});
const $ada755e79ac828b0$export$529e6123e9353a90 = /* @__PURE__ */ (0, $84b2ae616b59ae0e$export$4812c9a1c4ca02a)($ada755e79ac828b0$var$Pointk1, (0, $3000ec301818b27b$export$bced8d2aada2d1c9));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $ada755e79ac828b0$var$TAGGED_HASH_PREFIXES = Object.create(null);
// BIP-340 phrases tags as UTF-8, but all current standardized names here are 7-bit ASCII.
function $ada755e79ac828b0$var$taggedHash(tag, ...messages) {
    let tagP = $ada755e79ac828b0$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $3000ec301818b27b$export$bced8d2aada2d1c9)((0, $e129040e856338dd$export$e151636497a65339)(tag));
        tagP = (0, $e129040e856338dd$export$287dd7971339c972)(tagH, tagH);
        $ada755e79ac828b0$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $3000ec301818b27b$export$bced8d2aada2d1c9)((0, $e129040e856338dd$export$287dd7971339c972)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $ada755e79ac828b0$var$pointToBytes = (point)=>point.toBytes(true).slice(1);
const $ada755e79ac828b0$var$affineXToBytes = ({ x: x })=>$ada755e79ac828b0$var$Fpk1.toBytes(x);
const $ada755e79ac828b0$var$hasEven = (y)=>!$ada755e79ac828b0$var$Fpk1.isOdd(y);
// Calculate point, scalar and bytes
function $ada755e79ac828b0$var$schnorrGetExtPubKey(priv) {
    const { Fn: Fn, BASE: BASE } = $ada755e79ac828b0$var$Pointk1;
    const d_ = Fn.fromBytes((0, $e129040e856338dd$export$e8a750b9efad93f5)(priv, 32, 'secretKey'));
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const affine = p.toAffine();
    const scalar = $ada755e79ac828b0$var$hasEven(affine.y) ? d_ : Fn.neg(d_);
    return {
        scalar: scalar,
        bytes: $ada755e79ac828b0$var$affineXToBytes(affine)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $ada755e79ac828b0$var$lift_x(x) {
    const Fp = $ada755e79ac828b0$var$Fpk1;
    if (!Fp.isValidNot0(x)) throw new Error("invalid x: Fail if x \u2265 p");
    const xx = Fp.sqr(x);
    const c = Fp.add(Fp.mulN(xx, x), BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!$ada755e79ac828b0$var$hasEven(y)) y = Fp.neg(y);
    const p = $ada755e79ac828b0$var$Pointk1.fromAffine({
        x: x,
        y: y
    });
    p.assertValidity();
    return p;
}
// BIP-340 callers still need to supply canonical 32-byte inputs where required; this alias only
// parses big-endian bytes and does not enforce the fixed-width contract itself.
const $ada755e79ac828b0$var$num = (0, $e129040e856338dd$export$d609354794974f8);
/** Create tagged hash, convert it to bigint, reduce modulo-n. */ function $ada755e79ac828b0$var$challenge(...args) {
    return $ada755e79ac828b0$var$Pointk1.Fn.create($ada755e79ac828b0$var$num($ada755e79ac828b0$var$taggedHash('BIP0340/challenge', ...args)));
}
/** Schnorr public key is just `x` coordinate of Point as per BIP340. */ function $ada755e79ac828b0$var$schnorrGetPublicKey(secretKey) {
    return $ada755e79ac828b0$var$schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * `auxRand` is optional and is not the sole source of `k` generation: bad CSPRNG output will not
 * be catastrophic, but BIP-340 still recommends fresh auxiliary randomness when available to harden
 * deterministic signing against side-channel and fault-injection attacks.
 */ function $ada755e79ac828b0$var$schnorrSign(message, secretKey, auxRand = (0, $3c6c2c802c119f83$export$5f828d93ff035aa8)(32)) {
    const { Fn: Fn, BASE: BASE } = $ada755e79ac828b0$var$Pointk1;
    // Snapshot once: nonce, challenge, and self-verification must use one transcript.
    const m = (0, $e129040e856338dd$export$56728fb2d7dba34e)((0, $e129040e856338dd$export$e8a750b9efad93f5)(message, undefined, 'message'));
    const { bytes: px, scalar: d } = $ada755e79ac828b0$var$schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = (0, $e129040e856338dd$export$e8a750b9efad93f5)(auxRand, 32, 'auxRand'); // Auxiliary random data a: a 32-byte array
    // Let t be the byte-wise xor of bytes(d) and hash/aux(a).
    const t = Fn.toBytes(d ^ $ada755e79ac828b0$var$num($ada755e79ac828b0$var$taggedHash('BIP0340/aux', a)));
    const rand = $ada755e79ac828b0$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // BIP340 defines k' = int(rand) mod n. We can't reuse schnorrGetExtPubKey(rand)
    // here: that helper parses canonical secret keys and rejects rand >= n instead
    // of reducing the nonce hash modulo the group order.
    const k_ = Fn.create($ada755e79ac828b0$var$num(rand));
    // BIP-340: "Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G."
    if (k_ === $ada755e79ac828b0$var$_0n) throw new Error('sign failed: k is zero');
    const p = BASE.multiply(k_); // Rejects zero; only the raw nonce hash needs reduction.
    const affine = p.toAffine();
    const k = $ada755e79ac828b0$var$hasEven(affine.y) ? k_ : Fn.neg(k_);
    const rx = $ada755e79ac828b0$var$affineXToBytes(affine);
    const e = $ada755e79ac828b0$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$ada755e79ac828b0$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $ada755e79ac828b0$var$schnorrVerify(signature, message, publicKey) {
    const { Fp: Fp, Fn: Fn, BASE: BASE } = $ada755e79ac828b0$var$Pointk1;
    const sig = (0, $e129040e856338dd$export$e8a750b9efad93f5)(signature, 64, 'signature');
    const m = (0, $e129040e856338dd$export$e8a750b9efad93f5)(message, undefined, 'message');
    const pub = (0, $e129040e856338dd$export$e8a750b9efad93f5)(publicKey, 32, 'publicKey');
    try {
        const P = $ada755e79ac828b0$var$lift_x($ada755e79ac828b0$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const rBytes = sig.subarray(0, 32);
        const r = $ada755e79ac828b0$var$num(rBytes); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!Fp.isValidNot0(r)) return false;
        const s = $ada755e79ac828b0$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        // Stricter than BIP-340/libsecp256k1, which only reject s >= n. Honest signing reaches
        // s = 0 only with negligible probability (k + e*d ≡ 0 mod n), so treat zero-s inputs as
        // crafted edge cases and fail closed instead of carrying that extra verification surface.
        if (!Fn.isValidNot0(s)) return false;
        // int(challenge(bytes(r) || bytes(P) || m)) % n
        const e = $ada755e79ac828b0$var$challenge(rBytes, $ada755e79ac828b0$var$pointToBytes(P), m);
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.mulAddUnsafe(s, P, Fn.neg(e)); // s⋅G + (-e)⋅P, joint Strauss–Shamir
        const { x: x, y: y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !$ada755e79ac828b0$var$hasEven(y) || !Fp.eql(x, r)) return false;
        return true;
    } catch (error) {
        return false;
    }
}
const $ada755e79ac828b0$export$94db462fde6ce256 = /* @__PURE__ */ Object.freeze({
    lift_x: $ada755e79ac828b0$var$lift_x,
    frostTweakPublic: $ada755e79ac828b0$var$frostTweakPublic,
    frostTweakSecret: $ada755e79ac828b0$var$frostTweakSecret
});
const $ada755e79ac828b0$export$1f2401df071be9f = /* @__PURE__ */ (()=>{
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed)=>{
        seed = seed === undefined ? (0, $3c6c2c802c119f83$export$5f828d93ff035aa8)(seedLength) : seed;
        return (0, $eaac85f28e130c0a$export$20cb21dbfa61dac3)((0, $e129040e856338dd$export$e8a750b9efad93f5)(seed, seedLength, 'seed'), $ada755e79ac828b0$var$secp256k1_CURVE.n);
    };
    return Object.freeze({
        keygen: (0, $4f109436b1b5c1eb$export$f3f81ccca4e43a9b)(randomSecretKey, $ada755e79ac828b0$var$schnorrGetPublicKey),
        getPublicKey: $ada755e79ac828b0$var$schnorrGetPublicKey,
        sign: $ada755e79ac828b0$var$schnorrSign,
        verify: $ada755e79ac828b0$var$schnorrVerify,
        Point: $ada755e79ac828b0$var$Pointk1,
        utils: Object.freeze({
            randomSecretKey: randomSecretKey,
            taggedHash: $ada755e79ac828b0$var$taggedHash,
            lift_x: $ada755e79ac828b0$var$lift_x,
            pointToBytes: $ada755e79ac828b0$var$pointToBytes
        }),
        lengths: Object.freeze({
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength
        })
    });
})();
// RFC 9380 Appendix E.1 3-isogeny coefficients for secp256k1, stored in ascending degree order.
// The final `1` in each denominator array is the explicit monic leading term.
const $ada755e79ac828b0$var$isoMap = /* @__PURE__ */ (()=>(0, $d6ac2d93e738b522$export$9393380cf1075f28)($ada755e79ac828b0$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
// RFC 9380 §8.7 secp256k1 E' parameters for the SWU-to-isogeny pipeline below.
let $ada755e79ac828b0$var$mapSWU;
const $ada755e79ac828b0$var$getMapSWU = ()=>$ada755e79ac828b0$var$mapSWU || ($ada755e79ac828b0$var$mapSWU = (0, $d6ac2d93e738b522$export$cc7fea9756a17416)($ada755e79ac828b0$var$Fpk1, {
        // Building the SWU sqrt-ratio helper eagerly adds noticeable `secp256k1.js` import cost, so
        // defer it to first use; after that the cached mapper is reused directly.
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $ada755e79ac828b0$var$Fpk1.create(BigInt('-11'))
    }));
const $ada755e79ac828b0$export$e7a33585c78e532a = /* @__PURE__ */ (()=>(0, $d6ac2d93e738b522$export$14b114effbc08b6b)($ada755e79ac828b0$var$Pointk1, (scalars)=>{
        const { x: x, y: y } = $ada755e79ac828b0$var$getMapSWU()($ada755e79ac828b0$var$Fpk1.create(scalars[0]));
        return $ada755e79ac828b0$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $ada755e79ac828b0$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $3000ec301818b27b$export$bced8d2aada2d1c9)
    }))();
const $ada755e79ac828b0$export$81b3456dc0d4210 = /* @__PURE__ */ (()=>(0, $47167bfa62af68b8$export$761a5c594301a577)({
        name: 'FROST-secp256k1-SHA256-v1',
        Point: $ada755e79ac828b0$var$Pointk1,
        hashToScalar: $ada755e79ac828b0$export$e7a33585c78e532a.hashToScalar,
        hash: (0, $3000ec301818b27b$export$bced8d2aada2d1c9)
    }))();
// Taproot utils
// `undefined` means "disable TapTweak entirely"; callers that want the BIP-341/BIP-386 empty
// merkle root must pass `new Uint8Array(0)` explicitly.
function $ada755e79ac828b0$var$tweak(point, merkleRoot) {
    if (merkleRoot === undefined) return $ada755e79ac828b0$var$_0n;
    const x = $ada755e79ac828b0$var$pointToBytes(point);
    const t = (0, $e129040e856338dd$export$d609354794974f8)($ada755e79ac828b0$var$taggedHash('TapTweak', x, merkleRoot));
    // BIP-341 taproot_tweak_pubkey/taproot_tweak_seckey: "if t >= SECP256K1_ORDER:
    // raise ValueError". TapTweak must reject overflow instead of reducing modulo n.
    if (!$ada755e79ac828b0$var$Pointk1.Fn.isValid(t)) throw new Error('invalid TapTweak hash');
    return t;
}
function $ada755e79ac828b0$var$frostPubToEvenY(pub) {
    const VK = $ada755e79ac828b0$var$Pointk1.fromBytes(pub.commitments[0]);
    // Keep aliasing on the already-even path so wrapper callers can skip unnecessary cloning.
    if ($ada755e79ac828b0$var$hasEven(VK.y)) return pub;
    return {
        signers: {
            min: pub.signers.min,
            max: pub.signers.max
        },
        commitments: pub.commitments.map((i)=>$ada755e79ac828b0$var$Pointk1.fromBytes(i).negate().toBytes()),
        verifyingShares: Object.fromEntries(Object.entries(pub.verifyingShares).map(([k, v])=>[
                k,
                $ada755e79ac828b0$var$Pointk1.fromBytes(v).negate().toBytes()
            ]))
    };
}
function $ada755e79ac828b0$var$frostSecretToEvenY(s, pub) {
    const VK = $ada755e79ac828b0$var$Pointk1.fromBytes(pub.commitments[0]);
    // Keep aliasing on the already-even path so wrapper callers can preserve package identity.
    if ($ada755e79ac828b0$var$hasEven(VK.y)) return s;
    const Fn = $ada755e79ac828b0$var$Pointk1.Fn;
    return {
        ...s,
        signingShare: Fn.toBytes(Fn.neg(Fn.fromBytes(s.signingShare)))
    };
}
function $ada755e79ac828b0$var$frostNoncesToEvenY(groupCommitment, nonces) {
    if ($ada755e79ac828b0$var$hasEven(groupCommitment.y)) return nonces;
    const Fn = $ada755e79ac828b0$var$Pointk1.Fn;
    return {
        binding: Fn.toBytes(Fn.neg(Fn.fromBytes(nonces.binding))),
        hiding: Fn.toBytes(Fn.neg(Fn.fromBytes(nonces.hiding)))
    };
}
function $ada755e79ac828b0$var$frostTweakSecret(s, pub, merkleRoot) {
    const Fn = $ada755e79ac828b0$var$Pointk1.Fn;
    const keyPackage = $ada755e79ac828b0$var$frostSecretToEvenY(s, pub);
    const evenPub = $ada755e79ac828b0$var$frostPubToEvenY(pub);
    const t = $ada755e79ac828b0$var$tweak($ada755e79ac828b0$var$Pointk1.fromBytes(evenPub.commitments[0]), merkleRoot);
    const signingShare = Fn.toBytes(Fn.add(Fn.fromBytes(keyPackage.signingShare), t));
    return {
        identifier: keyPackage.identifier,
        signingShare: signingShare
    };
}
function $ada755e79ac828b0$var$frostTweakPublic(pub, merkleRoot) {
    const PKPackage = $ada755e79ac828b0$var$frostPubToEvenY(pub);
    const t = $ada755e79ac828b0$var$tweak($ada755e79ac828b0$var$Pointk1.fromBytes(PKPackage.commitments[0]), merkleRoot);
    // Disabled TapTweak (t=0): return the even-Y-normalized package as-is. multiply() rejects
    // zero scalars, and adding [0]G would be a no-op anyway.
    if (t === $ada755e79ac828b0$var$_0n) return PKPackage;
    const tp = $ada755e79ac828b0$var$Pointk1.BASE.multiply(t);
    const commitments = PKPackage.commitments.map((c, i)=>(i === 0 ? $ada755e79ac828b0$var$Pointk1.fromBytes(c).add(tp) : $ada755e79ac828b0$var$Pointk1.fromBytes(c)).toBytes());
    const verifyingShares = {};
    for(const k in PKPackage.verifyingShares)verifyingShares[k] = $ada755e79ac828b0$var$Pointk1.fromBytes(PKPackage.verifyingShares[k]).add(tp).toBytes();
    return {
        signers: {
            min: PKPackage.signers.min,
            max: PKPackage.signers.max
        },
        commitments: commitments,
        verifyingShares: verifyingShares
    };
}
const $ada755e79ac828b0$export$1e7393d5f51138d3 = /* @__PURE__ */ (()=>(0, $47167bfa62af68b8$export$761a5c594301a577)({
        name: 'FROST-secp256k1-SHA256-TR-v1',
        Point: $ada755e79ac828b0$var$Pointk1,
        hashToScalar: $ada755e79ac828b0$export$e7a33585c78e532a.hashToScalar,
        hash: (0, $3000ec301818b27b$export$bced8d2aada2d1c9),
        // Taproot related hacks
        parsePublicKey (publicKey) {
            // External Taproot keys are x-only, but local key packages still use compressed points.
            if (publicKey.length === 32) return $ada755e79ac828b0$var$lift_x((0, $e129040e856338dd$export$d609354794974f8)(publicKey));
            if (publicKey.length === 33) return $ada755e79ac828b0$var$Pointk1.fromBytes(publicKey);
            throw new Error(`expected x-only or compressed public key, got length=${publicKey.length}`);
        },
        adjustScalar (n) {
            const PK = $ada755e79ac828b0$var$Pointk1.BASE.multiply(n);
            return $ada755e79ac828b0$var$hasEven(PK.y) ? n : $ada755e79ac828b0$var$Pointk1.Fn.neg(n);
        },
        adjustPoint: (p)=>$ada755e79ac828b0$var$hasEven(p.y) ? p : p.negate(),
        challenge (R, PK, msg) {
            return $ada755e79ac828b0$var$challenge($ada755e79ac828b0$var$pointToBytes(R), $ada755e79ac828b0$var$pointToBytes(PK), msg);
        },
        adjustNonces: $ada755e79ac828b0$var$frostNoncesToEvenY,
        adjustGroupCommitmentShare: (GC, GCShare)=>!$ada755e79ac828b0$var$hasEven(GC.y) ? GCShare.negate() : GCShare,
        adjustPublic: $ada755e79ac828b0$var$frostPubToEvenY,
        adjustSecret: $ada755e79ac828b0$var$frostSecretToEvenY,
        adjustTx: {
            // Compat with official implementation
            encode: (tx)=>tx.subarray(1),
            decode: (tx)=>(0, $e129040e856338dd$export$287dd7971339c972)(Uint8Array.of(0x02), tx)
        },
        adjustDKG: (k)=>{
            // Compatibility with frost-secp256k1-tr: DKG output is auto-tweaked with the
            // empty Taproot merkle root, while dealer-generated keys stay untweaked.
            const merkleRoot = new Uint8Array(0);
            return {
                public: $ada755e79ac828b0$var$frostTweakPublic(k.public, merkleRoot),
                secret: $ada755e79ac828b0$var$frostTweakSecret(k.secret, k.public, merkleRoot)
            };
        }
    }))();




/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ /**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ /**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $ab3ee39839356738$export$7effb53edfc7fa2d = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;


function $ab7af777c5df829d$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $ab7af777c5df829d$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $ab7af777c5df829d$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$ab7af777c5df829d$export$c6fabfbfd097fc30(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
function $ab7af777c5df829d$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    $ab7af777c5df829d$export$75364c6cb16d43b6(h.outputLen);
    $ab7af777c5df829d$export$75364c6cb16d43b6(h.blockLen);
}
function $ab7af777c5df829d$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $ab7af777c5df829d$export$e8e53abee12b995e(out, instance) {
    $ab7af777c5df829d$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $ab7af777c5df829d$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $ab7af777c5df829d$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $ab7af777c5df829d$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $ab7af777c5df829d$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $ab7af777c5df829d$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $ab7af777c5df829d$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $ab7af777c5df829d$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $ab7af777c5df829d$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $ab7af777c5df829d$export$e108944b32ae0e38 = $ab7af777c5df829d$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$ab7af777c5df829d$export$a4170f7f8be47425(n);
const $ab7af777c5df829d$export$4a0a88cc2d284e7f = $ab7af777c5df829d$export$e108944b32ae0e38;
function $ab7af777c5df829d$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $ab7af777c5df829d$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $ab7af777c5df829d$export$f3e5ccb1e5f96d20 = $ab7af777c5df829d$export$a0f88e38d4cf9577 ? (u)=>u : $ab7af777c5df829d$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $ab7af777c5df829d$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $ab7af777c5df829d$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $ab7af777c5df829d$export$58b867e287a802c8(bytes) {
    $ab7af777c5df829d$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($ab7af777c5df829d$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $ab7af777c5df829d$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $ab7af777c5df829d$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $ab7af777c5df829d$var$asciiToBase16(ch) {
    if (ch >= $ab7af777c5df829d$var$asciis._0 && ch <= $ab7af777c5df829d$var$asciis._9) return ch - $ab7af777c5df829d$var$asciis._0; // '2' => 50-48
    if (ch >= $ab7af777c5df829d$var$asciis.A && ch <= $ab7af777c5df829d$var$asciis.F) return ch - ($ab7af777c5df829d$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $ab7af777c5df829d$var$asciis.a && ch <= $ab7af777c5df829d$var$asciis.f) return ch - ($ab7af777c5df829d$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $ab7af777c5df829d$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($ab7af777c5df829d$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $ab7af777c5df829d$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $ab7af777c5df829d$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $ab7af777c5df829d$export$bdd553fddd433dcb = async ()=>{};
async function $ab7af777c5df829d$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $ab7af777c5df829d$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $ab7af777c5df829d$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $ab7af777c5df829d$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $ab7af777c5df829d$export$30a71edf0753ed6b(data) {
    if (typeof data === 'string') data = $ab7af777c5df829d$export$3df70a15530b5e81(data);
    $ab7af777c5df829d$export$e8a750b9efad93f5(data);
    return data;
}
function $ab7af777c5df829d$export$e01ba4a527b8942d(data) {
    if (typeof data === 'string') data = $ab7af777c5df829d$export$3df70a15530b5e81(data);
    $ab7af777c5df829d$export$e8a750b9efad93f5(data);
    return data;
}
function $ab7af777c5df829d$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $ab7af777c5df829d$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $ab7af777c5df829d$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
class $ab7af777c5df829d$export$ab85ecd77ce6a5cd {
}
function $ab7af777c5df829d$export$14b114effbc08b6b(hashCons) {
    const hashC = (msg)=>hashCons().update($ab7af777c5df829d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $ab7af777c5df829d$export$aaa6b3684f701ca2(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($ab7af777c5df829d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $ab7af777c5df829d$export$741ac6dc04ed5295(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($ab7af777c5df829d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
const $ab7af777c5df829d$export$f081816339df1972 = $ab7af777c5df829d$export$14b114effbc08b6b;
const $ab7af777c5df829d$export$b465638d1569a3ae = $ab7af777c5df829d$export$aaa6b3684f701ca2;
const $ab7af777c5df829d$export$e18964dbd6e083c1 = $ab7af777c5df829d$export$741ac6dc04ed5295;
function $ab7af777c5df829d$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $ab3ee39839356738$export$7effb53edfc7fa2d) && typeof (0, $ab3ee39839356738$export$7effb53edfc7fa2d).getRandomValues === 'function') return (0, $ab3ee39839356738$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $ab3ee39839356738$export$7effb53edfc7fa2d) && typeof (0, $ab3ee39839356738$export$7effb53edfc7fa2d).randomBytes === 'function') return Uint8Array.from((0, $ab3ee39839356738$export$7effb53edfc7fa2d).randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}


function $10f264e85f5d19cd$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $10f264e85f5d19cd$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $10f264e85f5d19cd$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $10f264e85f5d19cd$export$f9f830659f932cb2 extends (0, $ab7af777c5df829d$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $ab7af777c5df829d$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $ab7af777c5df829d$export$20871f6b1d047d77)(this);
        data = (0, $ab7af777c5df829d$export$30a71edf0753ed6b)(data);
        (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $ab7af777c5df829d$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $ab7af777c5df829d$export$20871f6b1d047d77)(this);
        (0, $ab7af777c5df829d$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $ab7af777c5df829d$export$cf0b2a6c63f9e656)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $10f264e85f5d19cd$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $ab7af777c5df829d$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $10f264e85f5d19cd$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $10f264e85f5d19cd$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $10f264e85f5d19cd$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $10f264e85f5d19cd$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);


/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $6594b3ab8c8eec41$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $6594b3ab8c8eec41$var$_32n = /* @__PURE__ */ BigInt(32);
function $6594b3ab8c8eec41$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $6594b3ab8c8eec41$var$U32_MASK64),
        l: Number(n >> $6594b3ab8c8eec41$var$_32n & $6594b3ab8c8eec41$var$U32_MASK64)
    };
    return {
        h: Number(n >> $6594b3ab8c8eec41$var$_32n & $6594b3ab8c8eec41$var$U32_MASK64) | 0,
        l: Number(n & $6594b3ab8c8eec41$var$U32_MASK64) | 0
    };
}
function $6594b3ab8c8eec41$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $6594b3ab8c8eec41$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $6594b3ab8c8eec41$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $6594b3ab8c8eec41$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $6594b3ab8c8eec41$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $6594b3ab8c8eec41$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $6594b3ab8c8eec41$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $6594b3ab8c8eec41$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $6594b3ab8c8eec41$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $6594b3ab8c8eec41$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $6594b3ab8c8eec41$export$a088d44bd387d2a3 = (_h, l)=>l;
const $6594b3ab8c8eec41$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $6594b3ab8c8eec41$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $6594b3ab8c8eec41$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $6594b3ab8c8eec41$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $6594b3ab8c8eec41$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $6594b3ab8c8eec41$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $6594b3ab8c8eec41$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $6594b3ab8c8eec41$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $6594b3ab8c8eec41$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $6594b3ab8c8eec41$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $6594b3ab8c8eec41$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $6594b3ab8c8eec41$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $6594b3ab8c8eec41$var$u64 = {
    fromBig: $6594b3ab8c8eec41$export$9625d4333cb56c3f,
    split: $6594b3ab8c8eec41$export$65980d18b75784e2,
    toBig: $6594b3ab8c8eec41$export$30f78adcaaa2eb7,
    shrSH: $6594b3ab8c8eec41$export$75aa78dc5bd52853,
    shrSL: $6594b3ab8c8eec41$export$a0225ff0aee14e25,
    rotrSH: $6594b3ab8c8eec41$export$97f812dfd830ca87,
    rotrSL: $6594b3ab8c8eec41$export$60987e30e2c9d9d,
    rotrBH: $6594b3ab8c8eec41$export$af9c7fbac44dcb76,
    rotrBL: $6594b3ab8c8eec41$export$f619171d6d5ac414,
    rotr32H: $6594b3ab8c8eec41$export$a088d44bd387d2a3,
    rotr32L: $6594b3ab8c8eec41$export$8415aae4d1f69577,
    rotlSH: $6594b3ab8c8eec41$export$4b80a2917447870e,
    rotlSL: $6594b3ab8c8eec41$export$20652918a7b63b3,
    rotlBH: $6594b3ab8c8eec41$export$a52f14bf902f9977,
    rotlBL: $6594b3ab8c8eec41$export$5d12cc1da441323f,
    add: $6594b3ab8c8eec41$export$e16d8520af44a096,
    add3L: $6594b3ab8c8eec41$export$c0c22b91f08911f,
    add3H: $6594b3ab8c8eec41$export$ef7b26044977a8ec,
    add4L: $6594b3ab8c8eec41$export$2f4e199c560f545d,
    add4H: $6594b3ab8c8eec41$export$e909220d675a7741,
    add5H: $6594b3ab8c8eec41$export$b45ee8d78c965098,
    add5L: $6594b3ab8c8eec41$export$d732b061fe9c9ae4
};
var $6594b3ab8c8eec41$export$2e2bcd8739ae039 = $6594b3ab8c8eec41$var$u64;



/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $5818663383f9b787$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $5818663383f9b787$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $5818663383f9b787$export$397b834fceb5b168 extends (0, $10f264e85f5d19cd$export$f9f830659f932cb2) {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[0] | 0;
        this.B = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[1] | 0;
        this.C = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[2] | 0;
        this.D = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[3] | 0;
        this.E = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[4] | 0;
        this.F = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[5] | 0;
        this.G = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[6] | 0;
        this.H = (0, $10f264e85f5d19cd$export$a986fdf7a5bdfdf8)[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$5818663383f9b787$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $5818663383f9b787$var$SHA256_W[i - 15];
            const W2 = $5818663383f9b787$var$SHA256_W[i - 2];
            const s0 = (0, $ab7af777c5df829d$export$466993d7d0d272aa)(W15, 7) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $ab7af777c5df829d$export$466993d7d0d272aa)(W2, 17) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $5818663383f9b787$var$SHA256_W[i] = s1 + $5818663383f9b787$var$SHA256_W[i - 7] + s0 + $5818663383f9b787$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $ab7af777c5df829d$export$466993d7d0d272aa)(E, 6) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(E, 11) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $10f264e85f5d19cd$export$d0d97f016526eaf0)(E, F, G) + $5818663383f9b787$var$SHA256_K[i] + $5818663383f9b787$var$SHA256_W[i] | 0;
            const sigma0 = (0, $ab7af777c5df829d$export$466993d7d0d272aa)(A, 2) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(A, 13) ^ (0, $ab7af777c5df829d$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $10f264e85f5d19cd$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $ab7af777c5df829d$export$cf0b2a6c63f9e656)($5818663383f9b787$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $ab7af777c5df829d$export$cf0b2a6c63f9e656)(this.buffer);
    }
}
class $5818663383f9b787$export$d90fcf4a65424421 extends $5818663383f9b787$export$397b834fceb5b168 {
    constructor(){
        super(28);
        this.A = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[0] | 0;
        this.B = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[1] | 0;
        this.C = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[2] | 0;
        this.D = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[3] | 0;
        this.E = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[4] | 0;
        this.F = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[5] | 0;
        this.G = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[6] | 0;
        this.H = (0, $10f264e85f5d19cd$export$104dc246f4c65f21)[7] | 0;
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $5818663383f9b787$var$K512 = /* @__PURE__ */ (()=>$6594b3ab8c8eec41$export$65980d18b75784e2([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $5818663383f9b787$var$SHA512_Kh = /* @__PURE__ */ (()=>$5818663383f9b787$var$K512[0])();
const $5818663383f9b787$var$SHA512_Kl = /* @__PURE__ */ (()=>$5818663383f9b787$var$K512[1])();
// Reusable temporary buffers
const $5818663383f9b787$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $5818663383f9b787$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $5818663383f9b787$export$d655fdb8a1cad5df extends (0, $10f264e85f5d19cd$export$f9f830659f932cb2) {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[0] | 0;
        this.Al = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[1] | 0;
        this.Bh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[2] | 0;
        this.Bl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[3] | 0;
        this.Ch = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[4] | 0;
        this.Cl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[5] | 0;
        this.Dh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[6] | 0;
        this.Dl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[7] | 0;
        this.Eh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[8] | 0;
        this.El = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[9] | 0;
        this.Fh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[10] | 0;
        this.Fl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[11] | 0;
        this.Gh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[12] | 0;
        this.Gl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[13] | 0;
        this.Hh = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[14] | 0;
        this.Hl = (0, $10f264e85f5d19cd$export$f2cbb88a1784d2d1)[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $5818663383f9b787$var$SHA512_W_H[i] = view.getUint32(offset);
            $5818663383f9b787$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $5818663383f9b787$var$SHA512_W_H[i - 15] | 0;
            const W15l = $5818663383f9b787$var$SHA512_W_L[i - 15] | 0;
            const s0h = $6594b3ab8c8eec41$export$97f812dfd830ca87(W15h, W15l, 1) ^ $6594b3ab8c8eec41$export$97f812dfd830ca87(W15h, W15l, 8) ^ $6594b3ab8c8eec41$export$75aa78dc5bd52853(W15h, W15l, 7);
            const s0l = $6594b3ab8c8eec41$export$60987e30e2c9d9d(W15h, W15l, 1) ^ $6594b3ab8c8eec41$export$60987e30e2c9d9d(W15h, W15l, 8) ^ $6594b3ab8c8eec41$export$a0225ff0aee14e25(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $5818663383f9b787$var$SHA512_W_H[i - 2] | 0;
            const W2l = $5818663383f9b787$var$SHA512_W_L[i - 2] | 0;
            const s1h = $6594b3ab8c8eec41$export$97f812dfd830ca87(W2h, W2l, 19) ^ $6594b3ab8c8eec41$export$af9c7fbac44dcb76(W2h, W2l, 61) ^ $6594b3ab8c8eec41$export$75aa78dc5bd52853(W2h, W2l, 6);
            const s1l = $6594b3ab8c8eec41$export$60987e30e2c9d9d(W2h, W2l, 19) ^ $6594b3ab8c8eec41$export$f619171d6d5ac414(W2h, W2l, 61) ^ $6594b3ab8c8eec41$export$a0225ff0aee14e25(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $6594b3ab8c8eec41$export$2f4e199c560f545d(s0l, s1l, $5818663383f9b787$var$SHA512_W_L[i - 7], $5818663383f9b787$var$SHA512_W_L[i - 16]);
            const SUMh = $6594b3ab8c8eec41$export$e909220d675a7741(SUMl, s0h, s1h, $5818663383f9b787$var$SHA512_W_H[i - 7], $5818663383f9b787$var$SHA512_W_H[i - 16]);
            $5818663383f9b787$var$SHA512_W_H[i] = SUMh | 0;
            $5818663383f9b787$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $6594b3ab8c8eec41$export$97f812dfd830ca87(Eh, El, 14) ^ $6594b3ab8c8eec41$export$97f812dfd830ca87(Eh, El, 18) ^ $6594b3ab8c8eec41$export$af9c7fbac44dcb76(Eh, El, 41);
            const sigma1l = $6594b3ab8c8eec41$export$60987e30e2c9d9d(Eh, El, 14) ^ $6594b3ab8c8eec41$export$60987e30e2c9d9d(Eh, El, 18) ^ $6594b3ab8c8eec41$export$f619171d6d5ac414(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $6594b3ab8c8eec41$export$d732b061fe9c9ae4(Hl, sigma1l, CHIl, $5818663383f9b787$var$SHA512_Kl[i], $5818663383f9b787$var$SHA512_W_L[i]);
            const T1h = $6594b3ab8c8eec41$export$b45ee8d78c965098(T1ll, Hh, sigma1h, CHIh, $5818663383f9b787$var$SHA512_Kh[i], $5818663383f9b787$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $6594b3ab8c8eec41$export$97f812dfd830ca87(Ah, Al, 28) ^ $6594b3ab8c8eec41$export$af9c7fbac44dcb76(Ah, Al, 34) ^ $6594b3ab8c8eec41$export$af9c7fbac44dcb76(Ah, Al, 39);
            const sigma0l = $6594b3ab8c8eec41$export$60987e30e2c9d9d(Ah, Al, 28) ^ $6594b3ab8c8eec41$export$f619171d6d5ac414(Ah, Al, 34) ^ $6594b3ab8c8eec41$export$f619171d6d5ac414(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $6594b3ab8c8eec41$export$e16d8520af44a096(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $6594b3ab8c8eec41$export$c0c22b91f08911f(T1l, sigma0l, MAJl);
            Ah = $6594b3ab8c8eec41$export$ef7b26044977a8ec(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $6594b3ab8c8eec41$export$e16d8520af44a096(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $ab7af777c5df829d$export$cf0b2a6c63f9e656)($5818663383f9b787$var$SHA512_W_H, $5818663383f9b787$var$SHA512_W_L);
    }
    destroy() {
        (0, $ab7af777c5df829d$export$cf0b2a6c63f9e656)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $5818663383f9b787$export$b4bd5cd48f62bcf0 extends $5818663383f9b787$export$d655fdb8a1cad5df {
    constructor(){
        super(48);
        this.Ah = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[0] | 0;
        this.Al = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[1] | 0;
        this.Bh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[2] | 0;
        this.Bl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[3] | 0;
        this.Ch = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[4] | 0;
        this.Cl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[5] | 0;
        this.Dh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[6] | 0;
        this.Dl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[7] | 0;
        this.Eh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[8] | 0;
        this.El = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[9] | 0;
        this.Fh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[10] | 0;
        this.Fl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[11] | 0;
        this.Gh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[12] | 0;
        this.Gl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[13] | 0;
        this.Hh = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[14] | 0;
        this.Hl = (0, $10f264e85f5d19cd$export$b5217b4b948279ee)[15] | 0;
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $5818663383f9b787$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $5818663383f9b787$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $5818663383f9b787$export$9269e18873efb8a1 extends $5818663383f9b787$export$d655fdb8a1cad5df {
    constructor(){
        super(28);
        this.Ah = $5818663383f9b787$var$T224_IV[0] | 0;
        this.Al = $5818663383f9b787$var$T224_IV[1] | 0;
        this.Bh = $5818663383f9b787$var$T224_IV[2] | 0;
        this.Bl = $5818663383f9b787$var$T224_IV[3] | 0;
        this.Ch = $5818663383f9b787$var$T224_IV[4] | 0;
        this.Cl = $5818663383f9b787$var$T224_IV[5] | 0;
        this.Dh = $5818663383f9b787$var$T224_IV[6] | 0;
        this.Dl = $5818663383f9b787$var$T224_IV[7] | 0;
        this.Eh = $5818663383f9b787$var$T224_IV[8] | 0;
        this.El = $5818663383f9b787$var$T224_IV[9] | 0;
        this.Fh = $5818663383f9b787$var$T224_IV[10] | 0;
        this.Fl = $5818663383f9b787$var$T224_IV[11] | 0;
        this.Gh = $5818663383f9b787$var$T224_IV[12] | 0;
        this.Gl = $5818663383f9b787$var$T224_IV[13] | 0;
        this.Hh = $5818663383f9b787$var$T224_IV[14] | 0;
        this.Hl = $5818663383f9b787$var$T224_IV[15] | 0;
    }
}
class $5818663383f9b787$export$70b84015054354f1 extends $5818663383f9b787$export$d655fdb8a1cad5df {
    constructor(){
        super(32);
        this.Ah = $5818663383f9b787$var$T256_IV[0] | 0;
        this.Al = $5818663383f9b787$var$T256_IV[1] | 0;
        this.Bh = $5818663383f9b787$var$T256_IV[2] | 0;
        this.Bl = $5818663383f9b787$var$T256_IV[3] | 0;
        this.Ch = $5818663383f9b787$var$T256_IV[4] | 0;
        this.Cl = $5818663383f9b787$var$T256_IV[5] | 0;
        this.Dh = $5818663383f9b787$var$T256_IV[6] | 0;
        this.Dl = $5818663383f9b787$var$T256_IV[7] | 0;
        this.Eh = $5818663383f9b787$var$T256_IV[8] | 0;
        this.El = $5818663383f9b787$var$T256_IV[9] | 0;
        this.Fh = $5818663383f9b787$var$T256_IV[10] | 0;
        this.Fl = $5818663383f9b787$var$T256_IV[11] | 0;
        this.Gh = $5818663383f9b787$var$T256_IV[12] | 0;
        this.Gl = $5818663383f9b787$var$T256_IV[13] | 0;
        this.Hh = $5818663383f9b787$var$T256_IV[14] | 0;
        this.Hl = $5818663383f9b787$var$T256_IV[15] | 0;
    }
}
const $5818663383f9b787$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$397b834fceb5b168());
const $5818663383f9b787$export$97b70509d4e397ea = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$d90fcf4a65424421());
const $5818663383f9b787$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$d655fdb8a1cad5df());
const $5818663383f9b787$export$612d47d55dedde45 = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$b4bd5cd48f62bcf0());
const $5818663383f9b787$export$c78786b6da86db2a = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$70b84015054354f1());
const $5818663383f9b787$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $ab7af777c5df829d$export$14b114effbc08b6b)(()=>new $5818663383f9b787$export$9269e18873efb8a1());



/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
const $3b17219c0ea055df$var$_0n = /* @__PURE__ */ BigInt(0);
const $3b17219c0ea055df$var$_1n = /* @__PURE__ */ BigInt(1);
function $3b17219c0ea055df$export$809304d28d77d92d(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
function $3b17219c0ea055df$export$dcc04a11b0f94c2a(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}"`;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
function $3b17219c0ea055df$export$8b73a320627a4b4b(value, length, title = '') {
    const bytes = (0, $ab7af777c5df829d$export$c6fabfbfd097fc30)(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
function $3b17219c0ea055df$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $3b17219c0ea055df$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $3b17219c0ea055df$var$_0n : BigInt('0x' + hex); // Big Endian
}
function $3b17219c0ea055df$export$d609354794974f8(bytes) {
    return $3b17219c0ea055df$export$d57f2bacc26b4249((0, $ab7af777c5df829d$export$58b867e287a802c8)(bytes));
}
function $3b17219c0ea055df$export$d67b1d03392107e7(bytes) {
    (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(bytes);
    return $3b17219c0ea055df$export$d57f2bacc26b4249((0, $ab7af777c5df829d$export$58b867e287a802c8)(Uint8Array.from(bytes).reverse()));
}
function $3b17219c0ea055df$export$1459dafd057611cb(n, len) {
    return (0, $ab7af777c5df829d$export$31c96b9df38bc8d4)(n.toString(16).padStart(len * 2, '0'));
}
function $3b17219c0ea055df$export$ba2172e58d139f6d(n, len) {
    return $3b17219c0ea055df$export$1459dafd057611cb(n, len).reverse();
}
function $3b17219c0ea055df$export$80ee8c1914de6dde(n) {
    return (0, $ab7af777c5df829d$export$31c96b9df38bc8d4)($3b17219c0ea055df$export$4ed2545b622827c1(n));
}
function $3b17219c0ea055df$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = (0, $ab7af777c5df829d$export$31c96b9df38bc8d4)(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if ((0, $ab7af777c5df829d$export$c6fabfbfd097fc30)(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
function $3b17219c0ea055df$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $3b17219c0ea055df$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}
function $3b17219c0ea055df$export$e151636497a65339(ascii) {
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ // export const utf8ToBytes: typeof utf8ToBytes_ = utf8ToBytes_;
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ // export const bytesToUtf8: typeof bytesToUtf8_ = bytesToUtf8_;
// Is positive bigint
const $3b17219c0ea055df$var$isPosBig = (n)=>typeof n === 'bigint' && $3b17219c0ea055df$var$_0n <= n;
function $3b17219c0ea055df$export$ddf89a9c5af38f94(n, min, max) {
    return $3b17219c0ea055df$var$isPosBig(n) && $3b17219c0ea055df$var$isPosBig(min) && $3b17219c0ea055df$var$isPosBig(max) && min <= n && n < max;
}
function $3b17219c0ea055df$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$3b17219c0ea055df$export$ddf89a9c5af38f94(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
function $3b17219c0ea055df$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $3b17219c0ea055df$var$_0n; n >>= $3b17219c0ea055df$var$_1n, len += 1);
    return len;
}
function $3b17219c0ea055df$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $3b17219c0ea055df$var$_1n;
}
function $3b17219c0ea055df$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $3b17219c0ea055df$var$_1n : $3b17219c0ea055df$var$_0n) << BigInt(pos);
}
const $3b17219c0ea055df$export$803efa2fa1c7279 = (n)=>($3b17219c0ea055df$var$_1n << BigInt(n)) - $3b17219c0ea055df$var$_1n;
function $3b17219c0ea055df$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
    const u8of = (byte)=>Uint8Array.of(byte); // another shortcut
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8of(0x00), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8of(0x01), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return (0, $ab7af777c5df829d$export$287dd7971339c972)(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $3b17219c0ea055df$var$validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || (0, $ab7af777c5df829d$export$c6fabfbfd097fc30)(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
function $3b17219c0ea055df$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $3b17219c0ea055df$var$validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
function $3b17219c0ea055df$export$e8eff8fe65a171f3(val) {
    return typeof val === 'function' && Number.isSafeInteger(val.outputLen);
}
function $3b17219c0ea055df$export$1b8d274177e893f0(object, fields, optFields = {}) {
    if (!object || typeof object !== 'object') throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    Object.entries(fields).forEach(([k, v])=>checkField(k, v, false));
    Object.entries(optFields).forEach(([k, v])=>checkField(k, v, true));
}
const $3b17219c0ea055df$export$94a5f06e658f87e2 = ()=>{
    throw new Error('not implemented');
};
function $3b17219c0ea055df$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}


/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
// prettier-ignore
const $ac09377731e862cc$var$_0n = BigInt(0), $ac09377731e862cc$var$_1n = BigInt(1), $ac09377731e862cc$var$_2n = /* @__PURE__ */ BigInt(2), $ac09377731e862cc$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $ac09377731e862cc$var$_4n = /* @__PURE__ */ BigInt(4), $ac09377731e862cc$var$_5n = /* @__PURE__ */ BigInt(5), $ac09377731e862cc$var$_7n = /* @__PURE__ */ BigInt(7);
// prettier-ignore
const $ac09377731e862cc$var$_8n = /* @__PURE__ */ BigInt(8), $ac09377731e862cc$var$_9n = /* @__PURE__ */ BigInt(9), $ac09377731e862cc$var$_16n = /* @__PURE__ */ BigInt(16);
function $ac09377731e862cc$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $ac09377731e862cc$var$_0n ? result : b + result;
}
function $ac09377731e862cc$export$9c297f60e22e3389(num, power, modulo) {
    return $ac09377731e862cc$export$5d8ce3717733a987($ac09377731e862cc$export$a455218a85c89869(modulo), num, power);
}
function $ac09377731e862cc$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $ac09377731e862cc$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $ac09377731e862cc$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $ac09377731e862cc$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $ac09377731e862cc$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $ac09377731e862cc$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $ac09377731e862cc$var$_0n, y = $ac09377731e862cc$var$_1n, u = $ac09377731e862cc$var$_1n, v = $ac09377731e862cc$var$_0n;
    while(a !== $ac09377731e862cc$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $ac09377731e862cc$var$_1n) throw new Error('invert: does not exist');
    return $ac09377731e862cc$export$842a2cf37af977e1(x, modulo);
}
function $ac09377731e862cc$var$assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $ac09377731e862cc$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $ac09377731e862cc$var$_1n) / $ac09377731e862cc$var$_4n;
    const root = Fp.pow(n, p1div4);
    $ac09377731e862cc$var$assertIsSquare(Fp, root, n);
    return root;
}
function $ac09377731e862cc$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $ac09377731e862cc$var$_5n) / $ac09377731e862cc$var$_8n;
    const n2 = Fp.mul(n, $ac09377731e862cc$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $ac09377731e862cc$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    $ac09377731e862cc$var$assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $ac09377731e862cc$var$sqrt9mod16(P) {
    const Fp_ = $ac09377731e862cc$export$a455218a85c89869(P);
    const tn = $ac09377731e862cc$export$69f29ab1f3e9a234(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $ac09377731e862cc$var$_7n) / $ac09377731e862cc$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $ac09377731e862cc$var$assertIsSquare(Fp, root, n);
        return root;
    };
}
function $ac09377731e862cc$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $ac09377731e862cc$var$_3n) throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $ac09377731e862cc$var$_1n;
    let S = 0;
    while(Q % $ac09377731e862cc$var$_2n === $ac09377731e862cc$var$_0n){
        Q /= $ac09377731e862cc$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $ac09377731e862cc$var$_2n;
    const _Fp = $ac09377731e862cc$export$a455218a85c89869(P);
    while($ac09377731e862cc$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $ac09377731e862cc$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $ac09377731e862cc$var$_1n) / $ac09377731e862cc$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($ac09377731e862cc$export$77ed22730026dd0d(Fp, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $ac09377731e862cc$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $ac09377731e862cc$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $ac09377731e862cc$var$_4n === $ac09377731e862cc$var$_3n) return $ac09377731e862cc$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $ac09377731e862cc$var$_8n === $ac09377731e862cc$var$_5n) return $ac09377731e862cc$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $ac09377731e862cc$var$_16n === $ac09377731e862cc$var$_9n) return $ac09377731e862cc$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $ac09377731e862cc$export$69f29ab1f3e9a234(P);
}
const $ac09377731e862cc$export$7806f13ad5078b2f = (num, modulo)=>($ac09377731e862cc$export$842a2cf37af977e1(num, modulo) & $ac09377731e862cc$var$_1n) === $ac09377731e862cc$var$_1n;
// prettier-ignore
const $ac09377731e862cc$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $ac09377731e862cc$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'number',
        BITS: 'number'
    };
    const opts = $ac09377731e862cc$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    (0, $3b17219c0ea055df$export$1b8d274177e893f0)(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
function $ac09377731e862cc$export$5d8ce3717733a987(Fp, num, power) {
    if (power < $ac09377731e862cc$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $ac09377731e862cc$var$_0n) return Fp.ONE;
    if (power === $ac09377731e862cc$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $ac09377731e862cc$var$_0n){
        if (power & $ac09377731e862cc$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $ac09377731e862cc$var$_1n;
    }
    return p;
}
function $ac09377731e862cc$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $ac09377731e862cc$export$e74c665040343df6(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? $ac09377731e862cc$export$6897c284b6f9f4dc(rhs, Fp.ORDER) : Fp.inv(rhs));
}
function $ac09377731e862cc$export$77ed22730026dd0d(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $ac09377731e862cc$var$_1n) / $ac09377731e862cc$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
function $ac09377731e862cc$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $ac09377731e862cc$export$77ed22730026dd0d(Fp, n);
    return l === 1;
}
function $ac09377731e862cc$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $ab7af777c5df829d$export$75364c6cb16d43b6)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $ac09377731e862cc$export$a455218a85c89869(ORDER, bitLenOrOpts, isLE = false, opts = {}) {
    if (ORDER <= $ac09377731e862cc$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    let _nbitLength = undefined;
    let _sqrt = undefined;
    let modFromBytes = false;
    let allowedLengths = undefined;
    if (typeof bitLenOrOpts === 'object' && bitLenOrOpts != null) {
        if (opts.sqrt || isLE) throw new Error('cannot specify opts in two arguments');
        const _opts = bitLenOrOpts;
        if (_opts.BITS) _nbitLength = _opts.BITS;
        if (_opts.sqrt) _sqrt = _opts.sqrt;
        if (typeof _opts.isLE === 'boolean') isLE = _opts.isLE;
        if (typeof _opts.modFromBytes === 'boolean') modFromBytes = _opts.modFromBytes;
        allowedLengths = _opts.allowedLengths;
    } else {
        if (typeof bitLenOrOpts === 'number') _nbitLength = bitLenOrOpts;
        if (opts.sqrt) _sqrt = opts.sqrt;
    }
    const { nBitLength: BITS, nByteLength: BYTES } = $ac09377731e862cc$export$c79df43ecd7e66c2(ORDER, _nbitLength);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $3b17219c0ea055df$export$803efa2fa1c7279)(BITS),
        ZERO: $ac09377731e862cc$var$_0n,
        ONE: $ac09377731e862cc$var$_1n,
        allowedLengths: allowedLengths,
        create: (num)=>$ac09377731e862cc$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return $ac09377731e862cc$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $ac09377731e862cc$var$_0n,
        // is valid and invertible
        isValidNot0: (num)=>!f.is0(num) && f.isValid(num),
        isOdd: (num)=>(num & $ac09377731e862cc$var$_1n) === $ac09377731e862cc$var$_1n,
        neg: (num)=>$ac09377731e862cc$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$ac09377731e862cc$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$ac09377731e862cc$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$ac09377731e862cc$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$ac09377731e862cc$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$ac09377731e862cc$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$ac09377731e862cc$export$842a2cf37af977e1(lhs * $ac09377731e862cc$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$ac09377731e862cc$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: _sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $ac09377731e862cc$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, $3b17219c0ea055df$export$ba2172e58d139f6d)(num, BYTES) : (0, $3b17219c0ea055df$export$1459dafd057611cb)(num, BYTES),
        fromBytes: (bytes, skipValidation = true)=>{
            if (allowedLengths) {
                if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
                const padded = new Uint8Array(BYTES);
                // isLE add 0 to right, !isLE to the left.
                padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
                bytes = padded;
            }
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            let scalar = isLE ? (0, $3b17219c0ea055df$export$d67b1d03392107e7)(bytes) : (0, $3b17219c0ea055df$export$d609354794974f8)(bytes);
            if (modFromBytes) scalar = $ac09377731e862cc$export$842a2cf37af977e1(scalar, ORDER);
            if (!skipValidation) {
                if (!f.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
            }
            // NOTE: we don't validate scalar here, please use isValid. This done such way because some
            // protocol may allow non-reduced scalar that reduced later or changed some other way.
            return scalar;
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>$ac09377731e862cc$export$a492e3387142c0e9(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
function $ac09377731e862cc$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $ac09377731e862cc$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $ac09377731e862cc$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = $ac09377731e862cc$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, $3b17219c0ea055df$export$d67b1d03392107e7)(hash) : (0, $3b17219c0ea055df$export$d609354794974f8)(hash);
    return $ac09377731e862cc$export$842a2cf37af977e1(num, groupOrder - $ac09377731e862cc$var$_1n) + $ac09377731e862cc$var$_1n;
}
function $ac09377731e862cc$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $ac09377731e862cc$export$d058763b563056af(fieldOrder) {
    const length = $ac09377731e862cc$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $ac09377731e862cc$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $ac09377731e862cc$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $ac09377731e862cc$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $3b17219c0ea055df$export$d67b1d03392107e7)(key) : (0, $3b17219c0ea055df$export$d609354794974f8)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $ac09377731e862cc$export$842a2cf37af977e1(num, fieldOrder - $ac09377731e862cc$var$_1n) + $ac09377731e862cc$var$_1n;
    return isLE ? (0, $3b17219c0ea055df$export$ba2172e58d139f6d)(reduced, fieldLen) : (0, $3b17219c0ea055df$export$1459dafd057611cb)(reduced, fieldLen);
}


const $bb3103cee1bb9983$var$_0n = BigInt(0);
const $bb3103cee1bb9983$var$_1n = BigInt(1);
function $bb3103cee1bb9983$export$c6bd445aafe431ea(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function $bb3103cee1bb9983$export$bc27bc65d7bff1c7(c, points) {
    const invertedZs = (0, $ac09377731e862cc$export$a492e3387142c0e9)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $bb3103cee1bb9983$var$validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function $bb3103cee1bb9983$var$calcWOpts(W, scalarBits) {
    $bb3103cee1bb9983$var$validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $3b17219c0ea055df$export$803efa2fa1c7279)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function $bb3103cee1bb9983$var$calcOffsets(n, window, wOpts) {
    const { windowSize: windowSize, mask: mask, maxNumber: maxNumber, shiftBy: shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += $bb3103cee1bb9983$var$_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function $bb3103cee1bb9983$var$validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function $bb3103cee1bb9983$var$validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const $bb3103cee1bb9983$var$pointPrecomputes = new WeakMap();
const $bb3103cee1bb9983$var$pointWindowSizes = new WeakMap();
function $bb3103cee1bb9983$var$getW(P) {
    // To disable precomputes:
    // return 1;
    return $bb3103cee1bb9983$var$pointWindowSizes.get(P) || 1;
}
function $bb3103cee1bb9983$var$assert0(n) {
    if (n !== $bb3103cee1bb9983$var$_0n) throw new Error('invalid wNAF');
}
class $bb3103cee1bb9983$export$1c8afd86ce547420 {
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits){
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while(n > $bb3103cee1bb9983$var$_0n){
            if (n & $bb3103cee1bb9983$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $bb3103cee1bb9983$var$_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow(point, W) {
        const { windows: windows, windowSize: windowSize } = $bb3103cee1bb9983$var$calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for(let i = 1; i < windowSize; i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */ wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n)) throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = $bb3103cee1bb9983$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg, isNegF: isNegF, offsetF: offsetF } = $bb3103cee1bb9983$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) // bits are 0: add garbage to fake point
            // Important part for const-time getPublicKey: add random "noise" point to f.
            f = f.add($bb3103cee1bb9983$export$c6bd445aafe431ea(isNegF, precomputes[offsetF]));
            else // bits are 1: add to result point
            p = p.add($bb3103cee1bb9983$export$c6bd445aafe431ea(isNeg, precomputes[offset]));
        }
        $bb3103cee1bb9983$var$assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return {
            p: p,
            f: f
        };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */ wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = $bb3103cee1bb9983$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            if (n === $bb3103cee1bb9983$var$_0n) break; // Early-exit, skip 0 value
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg } = $bb3103cee1bb9983$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) continue;
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        $bb3103cee1bb9983$var$assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = $bb3103cee1bb9983$var$pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function') comp = transform(comp);
                $bb3103cee1bb9983$var$pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = $bb3103cee1bb9983$var$getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = $bb3103cee1bb9983$var$getW(point);
        if (W === 1) return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        $bb3103cee1bb9983$var$validateW(W, this.bits);
        $bb3103cee1bb9983$var$pointWindowSizes.set(P, W);
        $bb3103cee1bb9983$var$pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return $bb3103cee1bb9983$var$getW(elm) !== 1;
    }
}
function $bb3103cee1bb9983$export$4e37e5581461a31(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while(k1 > $bb3103cee1bb9983$var$_0n || k2 > $bb3103cee1bb9983$var$_0n){
        if (k1 & $bb3103cee1bb9983$var$_1n) p1 = p1.add(acc);
        if (k2 & $bb3103cee1bb9983$var$_1n) p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= $bb3103cee1bb9983$var$_1n;
        k2 >>= $bb3103cee1bb9983$var$_1n;
    }
    return {
        p1: p1,
        p2: p2
    };
}
function $bb3103cee1bb9983$export$8e2f6717424463a3(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    $bb3103cee1bb9983$var$validateMSMPoints(points, c);
    $bb3103cee1bb9983$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $3b17219c0ea055df$export$e93ef600c41761a9)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $3b17219c0ea055df$export$803efa2fa1c7279)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function $bb3103cee1bb9983$export$c33f75a98e3bde1d(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ $bb3103cee1bb9983$var$validateW(windowSize, fieldN.BITS);
    $bb3103cee1bb9983$var$validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $3b17219c0ea055df$export$803efa2fa1c7279)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        $bb3103cee1bb9983$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function $bb3103cee1bb9983$export$8ffa17c2a9bceb5e(curve) {
    (0, $ac09377731e862cc$export$bd454f0cef11418d)(curve.Fp);
    (0, $3b17219c0ea055df$export$381bae2d0f08004f)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, $ac09377731e862cc$export$c79df43ecd7e66c2)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
function $bb3103cee1bb9983$var$createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $ac09377731e862cc$export$bd454f0cef11418d)(field);
        return field;
    } else return (0, $ac09377731e862cc$export$a455218a85c89869)(order, {
        isLE: isLE
    });
}
function $bb3103cee1bb9983$export$a26f87e9b807e0c6(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > $bb3103cee1bb9983$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $bb3103cee1bb9983$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $bb3103cee1bb9983$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}


/**
 * Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y².
 * For design rationale of types / exports, see weierstrass module documentation.
 * Untwisted Edwards curves exist, but they aren't used in real-world protocols.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 


// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $04bbd2fee334f878$var$_0n = BigInt(0), $04bbd2fee334f878$var$_1n = BigInt(1), $04bbd2fee334f878$var$_2n = BigInt(2), $04bbd2fee334f878$var$_8n = BigInt(8);
function $04bbd2fee334f878$var$isEdValidXY(Fp, CURVE, x, y) {
    const x2 = Fp.sqr(x);
    const y2 = Fp.sqr(y);
    const left = Fp.add(Fp.mul(CURVE.a, x2), y2);
    const right = Fp.add(Fp.ONE, Fp.mul(CURVE.d, Fp.mul(x2, y2)));
    return Fp.eql(left, right);
}
function $04bbd2fee334f878$export$2a322ec7af93e9e7(params, extraOpts = {}) {
    const validated = (0, $bb3103cee1bb9983$export$a26f87e9b807e0c6)('edwards', params, extraOpts, extraOpts.FpFnLE);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor } = CURVE;
    (0, $3b17219c0ea055df$export$1b8d274177e893f0)(extraOpts, {}, {
        uvRatio: 'function'
    });
    // Important:
    // There are some places where Fp.BYTES is used instead of nByteLength.
    // So far, everything has been tested with curves of Fp.BYTES == nByteLength.
    // TODO: test and find curves which behave otherwise.
    const MASK = $04bbd2fee334f878$var$_2n << BigInt(Fn.BYTES * 8) - $04bbd2fee334f878$var$_1n;
    const modP = (n)=>Fp.create(n); // Function overrides
    // sqrt(u/v)
    const uvRatio = extraOpts.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(Fp.div(u, v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $04bbd2fee334f878$var$_0n
            };
        }
    });
    // Validate whether the passed curve params are valid.
    // equation ax² + y² = 1 + dx²y² should work for generator point.
    if (!$04bbd2fee334f878$var$isEdValidXY(Fp, CURVE, CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    /**
     * Asserts coordinate is valid: 0 <= n < MASK.
     * Coordinates >= Fp.ORDER are allowed for zip215.
     */ function acoord(title, n, banZero = false) {
        const min = banZero ? $04bbd2fee334f878$var$_1n : $04bbd2fee334f878$var$_0n;
        (0, $3b17219c0ea055df$export$86cc12b5dde3c1e4)('coordinate ' + title, n, min, MASK);
        return n;
    }
    function aextpoint(other) {
        if (!(other instanceof Point)) throw new Error('ExtendedPoint expected');
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $3b17219c0ea055df$export$9756366f7cb6f62b)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $04bbd2fee334f878$var$_8n : Fp.inv(Z); // 8 was chosen arbitrarily
        const x = modP(X * iz);
        const y = modP(Y * iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: $04bbd2fee334f878$var$_0n,
            y: $04bbd2fee334f878$var$_1n
        };
        if (zz !== $04bbd2fee334f878$var$_1n) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    const assertValidMemo = (0, $3b17219c0ea055df$export$9756366f7cb6f62b)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error('bad point: ZERO'); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { X: X, Y: Y, Z: Z, T: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error('bad point: equation left != right (1)');
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error('bad point: equation left != right (2)');
        return true;
    });
    // Extended Point works in extended coordinates: (X, Y, Z, T) ∋ (x=X/Z, y=Y/Z, T=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(X, Y, Z, T){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y);
            this.Z = acoord('z', Z, true);
            this.T = acoord('t', T);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error('extended point not allowed');
            const { x: x, y: y } = p || {};
            acoord('x', x);
            acoord('y', y);
            return new Point(x, y, $04bbd2fee334f878$var$_1n, modP(x * y));
        }
        // Uses algo from RFC8032 5.1.3.
        static fromBytes(bytes, zip215 = false) {
            const len = Fp.BYTES;
            const { a: a, d: d } = CURVE;
            bytes = (0, $3b17219c0ea055df$export$56728fb2d7dba34e)((0, $3b17219c0ea055df$export$8b73a320627a4b4b)(bytes, len, 'point'));
            (0, $3b17219c0ea055df$export$dcc04a11b0f94c2a)(zip215, 'zip215');
            const normed = (0, $3b17219c0ea055df$export$56728fb2d7dba34e)(bytes); // copy again, we'll manipulate it
            const lastByte = bytes[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = (0, $3b17219c0ea055df$export$d67b1d03392107e7)(normed);
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            (0, $3b17219c0ea055df$export$86cc12b5dde3c1e4)('point.y', y, $04bbd2fee334f878$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $04bbd2fee334f878$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error('bad point: invalid y coordinate');
            const isXOdd = (x & $04bbd2fee334f878$var$_1n) === $04bbd2fee334f878$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $04bbd2fee334f878$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error('bad point: x=0 and x_0=1');
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromHex(bytes, zip215 = false) {
            return Point.fromBytes((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('point', bytes), zip215);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($04bbd2fee334f878$var$_2n); // random number
            return this;
        }
        // Useful in fromAffine() - not for fromBytes(), which always created valid points.
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            aextpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.X), this.Y, this.Z, modP(-this.T));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($04bbd2fee334f878$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            aextpoint(other);
            const { a: a, d: d } = CURVE;
            const { X: X1, Y: Y1, Z: Z1, T: T1 } = this;
            const { X: X2, Y: Y2, Z: Z2, T: T2 } = other;
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        // Constant-time multiplication.
        multiply(scalar) {
            // 1 <= scalar < L
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: expected 1 <= sc < curve.n');
            const { p: p, f: f } = wnaf.cached(this, scalar, (p)=>(0, $bb3103cee1bb9983$export$bc27bc65d7bff1c7)(Point, p));
            return (0, $bb3103cee1bb9983$export$bc27bc65d7bff1c7)(Point, [
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        // Accepts optional accumulator to merge with multiply (important for sparse scalars)
        multiplyUnsafe(scalar, acc = Point.ZERO) {
            // 0 <= scalar < L
            if (!Fn.isValid(scalar)) throw new Error('invalid scalar: expected 0 <= sc < curve.n');
            if (scalar === $04bbd2fee334f878$var$_0n) return Point.ZERO;
            if (this.is0() || scalar === $04bbd2fee334f878$var$_1n) return this;
            return wnaf.unsafe(this, scalar, (p)=>(0, $bb3103cee1bb9983$export$bc27bc65d7bff1c7)(Point, p), acc);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafe(this, CURVE.n).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        clearCofactor() {
            if (cofactor === $04bbd2fee334f878$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        toBytes() {
            const { x: x, y: y } = this.toAffine();
            // Fp.toBytes() allows non-canonical encoding of y (>= p).
            const bytes = Fp.toBytes(y);
            // Each y has 2 valid points: (x, y), (x,-y).
            // When compressing, it's enough to store y and use the last byte to encode sign of x
            bytes[bytes.length - 1] |= x & $04bbd2fee334f878$var$_1n ? 0x80 : 0;
            return bytes;
        }
        toHex() {
            return (0, $ab7af777c5df829d$export$58b867e287a802c8)(this.toBytes());
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
        // TODO: remove
        get ex() {
            return this.X;
        }
        get ey() {
            return this.Y;
        }
        get ez() {
            return this.Z;
        }
        get et() {
            return this.T;
        }
        static normalizeZ(points) {
            return (0, $bb3103cee1bb9983$export$bc27bc65d7bff1c7)(Point, points);
        }
        static msm(points, scalars) {
            return (0, $bb3103cee1bb9983$export$8e2f6717424463a3)(Point, Fn, points, scalars);
        }
        _setWindowSize(windowSize) {
            this.precompute(windowSize);
        }
        toRawBytes() {
            return this.toBytes();
        }
    }
    // base / generator point
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $04bbd2fee334f878$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    // zero / infinity / identity point
    Point.ZERO = new Point($04bbd2fee334f878$var$_0n, $04bbd2fee334f878$var$_1n, $04bbd2fee334f878$var$_1n, $04bbd2fee334f878$var$_0n); // 0, 1, 1, 0
    // math field
    Point.Fp = Fp;
    // scalar field
    Point.Fn = Fn;
    const wnaf = new (0, $bb3103cee1bb9983$export$1c8afd86ce547420)(Point, Fn.BITS);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
class $04bbd2fee334f878$export$de66e17e5739587e {
    constructor(ep){
        this.ep = ep;
    }
    // Static methods that must be implemented by subclasses
    static fromBytes(_bytes) {
        (0, $3b17219c0ea055df$export$94a5f06e658f87e2)();
    }
    static fromHex(_hex) {
        (0, $3b17219c0ea055df$export$94a5f06e658f87e2)();
    }
    get x() {
        return this.toAffine().x;
    }
    get y() {
        return this.toAffine().y;
    }
    // Common implementations
    clearCofactor() {
        // no-op for prime-order groups
        return this;
    }
    assertValidity() {
        this.ep.assertValidity();
    }
    toAffine(invertedZ) {
        return this.ep.toAffine(invertedZ);
    }
    toHex() {
        return (0, $ab7af777c5df829d$export$58b867e287a802c8)(this.toBytes());
    }
    toString() {
        return this.toHex();
    }
    isTorsionFree() {
        return true;
    }
    isSmallOrder() {
        return false;
    }
    add(other) {
        this.assertSame(other);
        return this.init(this.ep.add(other.ep));
    }
    subtract(other) {
        this.assertSame(other);
        return this.init(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return this.init(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return this.init(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return this.init(this.ep.double());
    }
    negate() {
        return this.init(this.ep.negate());
    }
    precompute(windowSize, isLazy) {
        return this.init(this.ep.precompute(windowSize, isLazy));
    }
    /** @deprecated use `toBytes` */ toRawBytes() {
        return this.toBytes();
    }
}
function $04bbd2fee334f878$export$446a9d260f465faa(Point, cHash, eddsaOpts = {}) {
    if (typeof cHash !== 'function') throw new Error('"hash" function param is required');
    (0, $3b17219c0ea055df$export$1b8d274177e893f0)(eddsaOpts, {}, {
        adjustScalarBytes: 'function',
        randomBytes: 'function',
        domain: 'function',
        prehash: 'function',
        mapToCurve: 'function'
    });
    const { prehash: prehash } = eddsaOpts;
    const { BASE: BASE, Fp: Fp, Fn: Fn } = Point;
    const randomBytes = eddsaOpts.randomBytes || (0, $ab7af777c5df829d$export$5f828d93ff035aa8);
    const adjustScalarBytes = eddsaOpts.adjustScalarBytes || ((bytes)=>bytes);
    const domain = eddsaOpts.domain || ((data, ctx, phflag)=>{
        (0, $3b17219c0ea055df$export$dcc04a11b0f94c2a)(phflag, 'phflag');
        if (ctx.length || phflag) throw new Error('Contexts/pre-hash are not supported');
        return data;
    }); // NOOP
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return Fn.create((0, $3b17219c0ea055df$export$d67b1d03392107e7)(hash)); // Not Fn.fromBytes: it has length limit
    }
    // Get the hashed private scalar per RFC8032 5.1.5
    function getPrivateScalar(key) {
        const len = lengths.secretKey;
        key = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('private key', key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('hashed private key', cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        return {
            head: head,
            prefix: prefix,
            scalar: scalar
        };
    }
    /** Convenience method that creates public key from scalar. RFC8032 5.1.5 */ function getExtendedPublicKey(secretKey) {
        const { head: head, prefix: prefix, scalar: scalar } = getPrivateScalar(secretKey);
        const point = BASE.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toBytes();
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    /** Calculates EdDSA pub key. RFC8032 5.1.5. */ function getPublicKey(secretKey) {
        return getExtendedPublicKey(secretKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = Uint8Array.of(), ...msgs) {
        const msg = (0, $ab7af777c5df829d$export$287dd7971339c972)(...msgs);
        return modN_LE(cHash(domain(msg, (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('context', context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, secretKey, options = {}) {
        msg = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('message', msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(secretKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = BASE.multiply(r).toBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = Fn.create(r + k * scalar); // S = (r + k * s) mod L
        if (!Fn.isValid(s)) throw new Error('sign failed: invalid s'); // 0 <= s < L
        const rs = (0, $ab7af777c5df829d$export$287dd7971339c972)(R, Fn.toBytes(s));
        return (0, $3b17219c0ea055df$export$8b73a320627a4b4b)(rs, lengths.signature, 'result');
    }
    // verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
    const verifyOpts = {
        zip215: true
    };
    /**
     * Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
     * An extended group equation is checked.
     */ function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = lengths.signature;
        sig = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('signature', sig, len);
        msg = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('message', msg);
        publicKey = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('publicKey', publicKey, lengths.publicKey);
        if (zip215 !== undefined) (0, $3b17219c0ea055df$export$dcc04a11b0f94c2a)(zip215, 'zip215');
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const mid = len / 2;
        const r = sig.subarray(0, mid);
        const s = (0, $3b17219c0ea055df$export$d67b1d03392107e7)(sig.subarray(mid, len));
        let A, R, SB;
        try {
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            A = Point.fromBytes(publicKey, zip215);
            R = Point.fromBytes(r, zip215);
            SB = BASE.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false; // zip215 allows public keys of small order
        const k = hashDomainToScalar(context, R.toBytes(), A.toBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // Extended group equation
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().is0();
    }
    const _size = Fp.BYTES; // 32 for ed25519, 57 for ed448
    const lengths = {
        secretKey: _size,
        publicKey: _size,
        signature: 2 * _size,
        seed: _size
    };
    function randomSecretKey(seed = randomBytes(lengths.seed)) {
        return (0, $3b17219c0ea055df$export$8b73a320627a4b4b)(seed, lengths.seed, 'seed');
    }
    function keygen(seed) {
        const secretKey = utils.randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    }
    function isValidSecretKey(key) {
        return (0, $ab7af777c5df829d$export$c6fabfbfd097fc30)(key) && key.length === Fn.BYTES;
    }
    function isValidPublicKey(key, zip215) {
        try {
            return !!Point.fromBytes(key, zip215);
        } catch (error) {
            return false;
        }
    }
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        randomSecretKey: randomSecretKey,
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        /**
         * Converts ed public key to x public key. Uses formula:
         * - ed25519:
         *   - `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
         *   - `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
         * - ed448:
         *   - `(u, v) = ((y-1)/(y+1), sqrt(156324)*u/x)`
         *   - `(x, y) = (sqrt(156324)*u/v, (1+u)/(1-u))`
         */ toMontgomery (publicKey) {
            const { y: y } = Point.fromBytes(publicKey);
            const size = lengths.publicKey;
            const is25519 = size === 32;
            if (!is25519 && size !== 57) throw new Error('only defined for 25519 and 448');
            const u = is25519 ? Fp.div($04bbd2fee334f878$var$_1n + y, $04bbd2fee334f878$var$_1n - y) : Fp.div(y - $04bbd2fee334f878$var$_1n, y + $04bbd2fee334f878$var$_1n);
            return Fp.toBytes(u);
        },
        toMontgomerySecret (secretKey) {
            const size = lengths.secretKey;
            (0, $3b17219c0ea055df$export$8b73a320627a4b4b)(secretKey, size);
            const hashed = cHash(secretKey.subarray(0, size));
            return adjustScalarBytes(hashed).subarray(0, size);
        },
        /** @deprecated */ randomPrivateKey: randomSecretKey,
        /** @deprecated */ precompute (windowSize = 8, point = Point.BASE) {
            return point.precompute(windowSize, false);
        }
    };
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        utils: utils,
        Point: Point,
        lengths: lengths
    });
}
function $04bbd2fee334f878$var$_eddsa_legacy_opts_to_new(c) {
    const CURVE = {
        a: c.a,
        d: c.d,
        p: c.Fp.ORDER,
        n: c.n,
        h: c.h,
        Gx: c.Gx,
        Gy: c.Gy
    };
    const Fp = c.Fp;
    const Fn = (0, $ac09377731e862cc$export$a455218a85c89869)(CURVE.n, c.nBitLength, true);
    const curveOpts = {
        Fp: Fp,
        Fn: Fn,
        uvRatio: c.uvRatio
    };
    const eddsaOpts = {
        randomBytes: c.randomBytes,
        adjustScalarBytes: c.adjustScalarBytes,
        domain: c.domain,
        prehash: c.prehash,
        mapToCurve: c.mapToCurve
    };
    return {
        CURVE: CURVE,
        curveOpts: curveOpts,
        hash: c.hash,
        eddsaOpts: eddsaOpts
    };
}
function $04bbd2fee334f878$var$_eddsa_new_output_to_legacy(c, eddsa) {
    const Point = eddsa.Point;
    const legacy = Object.assign({}, eddsa, {
        ExtendedPoint: Point,
        CURVE: c,
        nBitLength: Point.Fn.BITS,
        nByteLength: Point.Fn.BYTES
    });
    return legacy;
}
function $04bbd2fee334f878$export$f0c1eee63ea541eb(c) {
    const { CURVE: CURVE, curveOpts: curveOpts, hash: hash, eddsaOpts: eddsaOpts } = $04bbd2fee334f878$var$_eddsa_legacy_opts_to_new(c);
    const Point = $04bbd2fee334f878$export$2a322ec7af93e9e7(CURVE, curveOpts);
    const EDDSA = $04bbd2fee334f878$export$446a9d260f465faa(Point, hash, eddsaOpts);
    return $04bbd2fee334f878$var$_eddsa_new_output_to_legacy(c, EDDSA);
}




// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $a07456824fd2805f$var$os2ip = (0, $3b17219c0ea055df$export$d609354794974f8);
// Integer to Octet Stream (numberToBytesBE)
function $a07456824fd2805f$var$i2osp(value, length) {
    $a07456824fd2805f$var$anum(value);
    $a07456824fd2805f$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $a07456824fd2805f$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $a07456824fd2805f$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
function $a07456824fd2805f$var$normDST(DST) {
    if (!(0, $ab7af777c5df829d$export$c6fabfbfd097fc30)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or string');
    return typeof DST === 'string' ? (0, $ab7af777c5df829d$export$3df70a15530b5e81)(DST) : DST;
}
function $a07456824fd2805f$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(msg);
    $a07456824fd2805f$var$anum(lenInBytes);
    DST = $a07456824fd2805f$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $ab7af777c5df829d$export$287dd7971339c972)((0, $ab7af777c5df829d$export$3df70a15530b5e81)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $ab7af777c5df829d$export$287dd7971339c972)(DST, $a07456824fd2805f$var$i2osp(DST.length, 1));
    const Z_pad = $a07456824fd2805f$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $a07456824fd2805f$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $ab7af777c5df829d$export$287dd7971339c972)(Z_pad, msg, l_i_b_str, $a07456824fd2805f$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $ab7af777c5df829d$export$287dd7971339c972)(b_0, $a07456824fd2805f$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $a07456824fd2805f$var$strxor(b_0, b[i - 1]),
            $a07456824fd2805f$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $ab7af777c5df829d$export$287dd7971339c972)(...args));
    }
    const pseudo_random_bytes = (0, $ab7af777c5df829d$export$287dd7971339c972)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $a07456824fd2805f$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(msg);
    $a07456824fd2805f$var$anum(lenInBytes);
    DST = $a07456824fd2805f$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $ab7af777c5df829d$export$3df70a15530b5e81)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($a07456824fd2805f$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($a07456824fd2805f$var$i2osp(DST.length, 1)).digest();
}
function $a07456824fd2805f$export$97cdd5ee18de8172(msg, count, options) {
    (0, $3b17219c0ea055df$export$1b8d274177e893f0)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    if (!(0, $3b17219c0ea055df$export$e8eff8fe65a171f3)(options.hash)) throw new Error('expected valid hash');
    (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(msg);
    $a07456824fd2805f$var$anum(count);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $a07456824fd2805f$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $a07456824fd2805f$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $ac09377731e862cc$export$842a2cf37af977e1)($a07456824fd2805f$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $a07456824fd2805f$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $ac09377731e862cc$export$a492e3387142c0e9)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
const $a07456824fd2805f$export$eaf8c8caa9e37fdf = (0, $ab7af777c5df829d$export$3df70a15530b5e81)('HashToScalar-');
function $a07456824fd2805f$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: defaults,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, defaults, options);
            const u = $a07456824fd2805f$export$97cdd5ee18de8172(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = defaults.encodeDST ? {
                DST: defaults.encodeDST
            } : {};
            const opts = Object.assign({}, defaults, optsDst, options);
            const u = $a07456824fd2805f$export$97cdd5ee18de8172(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, defaults, {
                p: N,
                m: 1,
                DST: $a07456824fd2805f$export$eaf8c8caa9e37fdf
            }, options);
            return $a07456824fd2805f$export$97cdd5ee18de8172(msg, 1, opts)[0][0];
        }
    };
}



/**
 * Montgomery curve methods. It's not really whole montgomery curve,
 * just bunch of very specific methods for X25519 / X448 from
 * [RFC 7748](https://www.rfc-editor.org/rfc/rfc7748)
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 

const $1c69f605a1d14e80$var$_0n = BigInt(0);
const $1c69f605a1d14e80$var$_1n = BigInt(1);
const $1c69f605a1d14e80$var$_2n = BigInt(2);
function $1c69f605a1d14e80$var$validateOpts(curve) {
    (0, $3b17219c0ea055df$export$1b8d274177e893f0)(curve, {
        adjustScalarBytes: 'function',
        powPminus2: 'function'
    });
    return Object.freeze({
        ...curve
    });
}
function $1c69f605a1d14e80$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $1c69f605a1d14e80$var$validateOpts(curveDef);
    const { P: P, type: type, adjustScalarBytes: adjustScalarBytes, powPminus2: powPminus2, randomBytes: rand } = CURVE;
    const is25519 = type === 'x25519';
    if (!is25519 && type !== 'x448') throw new Error('invalid type');
    const randomBytes_ = rand || (0, $ab7af777c5df829d$export$5f828d93ff035aa8);
    const montgomeryBits = is25519 ? 255 : 448;
    const fieldLen = is25519 ? 32 : 56;
    const Gu = is25519 ? BigInt(9) : BigInt(5);
    // RFC 7748 #5:
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519 and
    // (156326 - 2) / 4 = 39081 for curve448/X448
    // const a = is25519 ? 156326n : 486662n;
    const a24 = is25519 ? BigInt(121665) : BigInt(39081);
    // RFC: x25519 "the resulting integer is of the form 2^254 plus
    // eight times a value between 0 and 2^251 - 1 (inclusive)"
    // x448: "2^447 plus four times a value between 0 and 2^445 - 1 (inclusive)"
    const minScalar = is25519 ? $1c69f605a1d14e80$var$_2n ** BigInt(254) : $1c69f605a1d14e80$var$_2n ** BigInt(447);
    const maxAdded = is25519 ? BigInt(8) * $1c69f605a1d14e80$var$_2n ** BigInt(251) - $1c69f605a1d14e80$var$_1n : BigInt(4) * $1c69f605a1d14e80$var$_2n ** BigInt(445) - $1c69f605a1d14e80$var$_1n;
    const maxScalar = minScalar + maxAdded + $1c69f605a1d14e80$var$_1n; // (inclusive)
    const modP = (n)=>(0, $ac09377731e862cc$export$842a2cf37af977e1)(n, P);
    const GuBytes = encodeU(Gu);
    function encodeU(u) {
        return (0, $3b17219c0ea055df$export$ba2172e58d139f6d)(modP(u), fieldLen);
    }
    function decodeU(u) {
        const _u = (0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('u coordinate', u, fieldLen);
        // RFC: When receiving such an array, implementations of X25519
        // (but not X448) MUST mask the most significant bit in the final byte.
        if (is25519) _u[31] &= 127; // 0b0111_1111
        // RFC: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.  The non-canonical
        // values are 2^255 - 19 through 2^255 - 1 for X25519 and 2^448 - 2^224
        // - 1 through 2^448 - 1 for X448.
        return modP((0, $3b17219c0ea055df$export$d67b1d03392107e7)(_u));
    }
    function decodeScalar(scalar) {
        return (0, $3b17219c0ea055df$export$d67b1d03392107e7)(adjustScalarBytes((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('scalar', scalar, fieldLen)));
    }
    function scalarMult(scalar, u) {
        const pu = montgomeryLadder(decodeU(u), decodeScalar(scalar));
        // Some public keys are useless, of low-order. Curve author doesn't think
        // it needs to be validated, but we do it nonetheless.
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $1c69f605a1d14e80$var$_0n) throw new Error('invalid private or public key received');
        return encodeU(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    // cswap from RFC7748 "example code"
    function cswap(swap, x_2, x_3) {
        // dummy = mask(swap) AND (x_2 XOR x_3)
        // Where mask(swap) is the all-1 or all-0 word of the same length as x_2
        // and x_3, computed, e.g., as mask(swap) = 0 - swap.
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy); // x_2 = x_2 XOR dummy
        x_3 = modP(x_3 + dummy); // x_3 = x_3 XOR dummy
        return {
            x_2: x_2,
            x_3: x_3
        };
    }
    /**
     * Montgomery x-only multiplication ladder.
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $3b17219c0ea055df$export$86cc12b5dde3c1e4)('u', u, $1c69f605a1d14e80$var$_0n, P);
        (0, $3b17219c0ea055df$export$86cc12b5dde3c1e4)('scalar', scalar, minScalar, maxScalar);
        const k = scalar;
        const x_1 = u;
        let x_2 = $1c69f605a1d14e80$var$_1n;
        let z_2 = $1c69f605a1d14e80$var$_0n;
        let x_3 = u;
        let z_3 = $1c69f605a1d14e80$var$_1n;
        let swap = $1c69f605a1d14e80$var$_0n;
        for(let t = BigInt(montgomeryBits - 1); t >= $1c69f605a1d14e80$var$_0n; t--){
            const k_t = k >> t & $1c69f605a1d14e80$var$_1n;
            swap ^= k_t;
            ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
            ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        ({ x_2: x_2, x_3: x_3 } = cswap(swap, x_2, x_3));
        ({ x_2: z_2, x_3: z_3 } = cswap(swap, z_2, z_3));
        const z2 = powPminus2(z_2); // `Fp.pow(x, P - _2n)` is much slower equivalent
        return modP(x_2 * z2); // Return x_2 * (z_2^(p - 2))
    }
    const lengths = {
        secretKey: fieldLen,
        publicKey: fieldLen,
        seed: fieldLen
    };
    const randomSecretKey = (seed = randomBytes_(fieldLen))=>{
        (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(seed, lengths.seed);
        return seed;
    };
    function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: scalarMultBase(secretKey)
        };
    }
    const utils = {
        randomSecretKey: randomSecretKey,
        randomPrivateKey: randomSecretKey
    };
    return {
        keygen: keygen,
        getSharedSecret: (secretKey, publicKey)=>scalarMult(secretKey, publicKey),
        getPublicKey: (secretKey)=>scalarMultBase(secretKey),
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        utils: utils,
        GuBytes: GuBytes.slice(),
        lengths: lengths
    };
}



// prettier-ignore
const $81dc8d0126b4a70a$var$_0n = /* @__PURE__ */ BigInt(0), $81dc8d0126b4a70a$var$_1n = BigInt(1), $81dc8d0126b4a70a$var$_2n = BigInt(2), $81dc8d0126b4a70a$var$_3n = BigInt(3);
// prettier-ignore
const $81dc8d0126b4a70a$var$_5n = BigInt(5), $81dc8d0126b4a70a$var$_8n = BigInt(8);
// P = 2n**255n-19n
const $81dc8d0126b4a70a$var$ed25519_CURVE_p = BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed');
// N = 2n**252n + 27742317777372353535851937790883648493n
// a = Fp.create(BigInt(-1))
// d = -121665/121666 a.k.a. Fp.neg(121665 * Fp.inv(121666))
const $81dc8d0126b4a70a$var$ed25519_CURVE = /* @__PURE__ */ (()=>({
        p: $81dc8d0126b4a70a$var$ed25519_CURVE_p,
        n: BigInt('0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed'),
        h: $81dc8d0126b4a70a$var$_8n,
        a: BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec'),
        d: BigInt('0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3'),
        Gx: BigInt('0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a'),
        Gy: BigInt('0x6666666666666666666666666666666666666666666666666666666666666658')
    }))();
function $81dc8d0126b4a70a$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $81dc8d0126b4a70a$var$ed25519_CURVE_p;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b2, $81dc8d0126b4a70a$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b4, $81dc8d0126b4a70a$var$_1n, P) * x % P; // x^31
    const b10 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b5, $81dc8d0126b4a70a$var$_5n, P) * b5 % P;
    const b20 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b10, _10n, P) * b10 % P;
    const b40 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b20, _20n, P) * b20 % P;
    const b80 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b40, _40n, P) * b40 % P;
    const b160 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b80, _80n, P) * b80 % P;
    const b240 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b160, _80n, P) * b80 % P;
    const b250 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $ac09377731e862cc$export$fa569bd808b67eef)(b250, $81dc8d0126b4a70a$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $81dc8d0126b4a70a$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// √(-1) aka √(a) aka 2^((p-1)/4)
// Fp.sqrt(Fp.neg(1))
const $81dc8d0126b4a70a$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt('19681161376707505956807079304988542015446066515923890162744021073123829784752');
// sqrt(u/v)
function $81dc8d0126b4a70a$var$uvRatio(u, v) {
    const P = $81dc8d0126b4a70a$var$ed25519_CURVE_p;
    const v3 = (0, $ac09377731e862cc$export$842a2cf37af977e1)(v * v * v, P); // v³
    const v7 = (0, $ac09377731e862cc$export$842a2cf37af977e1)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $81dc8d0126b4a70a$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $ac09377731e862cc$export$842a2cf37af977e1)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $ac09377731e862cc$export$842a2cf37af977e1)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $ac09377731e862cc$export$842a2cf37af977e1)(x * $81dc8d0126b4a70a$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $ac09377731e862cc$export$842a2cf37af977e1)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $ac09377731e862cc$export$842a2cf37af977e1)(-u * $81dc8d0126b4a70a$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $ac09377731e862cc$export$7806f13ad5078b2f)(x, P)) x = (0, $ac09377731e862cc$export$842a2cf37af977e1)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $81dc8d0126b4a70a$var$Fp = /* @__PURE__ */ (()=>(0, $ac09377731e862cc$export$a455218a85c89869)($81dc8d0126b4a70a$var$ed25519_CURVE.p, {
        isLE: true
    }))();
const $81dc8d0126b4a70a$var$Fn = /* @__PURE__ */ (()=>(0, $ac09377731e862cc$export$a455218a85c89869)($81dc8d0126b4a70a$var$ed25519_CURVE.n, {
        isLE: true
    }))();
const $81dc8d0126b4a70a$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        ...$81dc8d0126b4a70a$var$ed25519_CURVE,
        Fp: $81dc8d0126b4a70a$var$Fp,
        hash: (0, $5818663383f9b787$export$a888d2532e6dc7bb),
        adjustScalarBytes: $81dc8d0126b4a70a$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $81dc8d0126b4a70a$var$uvRatio
    }))();
const $81dc8d0126b4a70a$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $04bbd2fee334f878$export$f0c1eee63ea541eb)($81dc8d0126b4a70a$var$ed25519Defaults))();
function $81dc8d0126b4a70a$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error('Context is too big');
    return (0, $ab7af777c5df829d$export$287dd7971339c972)((0, $ab7af777c5df829d$export$3df70a15530b5e81)('SigEd25519 no Ed25519 collisions'), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $81dc8d0126b4a70a$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $04bbd2fee334f878$export$f0c1eee63ea541eb)({
        ...$81dc8d0126b4a70a$var$ed25519Defaults,
        domain: $81dc8d0126b4a70a$var$ed25519_domain
    }))();
const $81dc8d0126b4a70a$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $04bbd2fee334f878$export$f0c1eee63ea541eb)(Object.assign({}, $81dc8d0126b4a70a$var$ed25519Defaults, {
        domain: $81dc8d0126b4a70a$var$ed25519_domain,
        prehash: (0, $5818663383f9b787$export$a888d2532e6dc7bb)
    })))();
const $81dc8d0126b4a70a$export$dab9625394da700 = /* @__PURE__ */ (()=>{
    const P = $81dc8d0126b4a70a$var$Fp.ORDER;
    return (0, $1c69f605a1d14e80$export$bdbee0d01bf914a7)({
        P: P,
        type: 'x25519',
        powPminus2: (x)=>{
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $81dc8d0126b4a70a$var$ed25519_pow_2_252_3(x);
            return (0, $ac09377731e862cc$export$842a2cf37af977e1)((0, $ac09377731e862cc$export$fa569bd808b67eef)(pow_p_5_8, $81dc8d0126b4a70a$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $81dc8d0126b4a70a$var$adjustScalarBytes
    });
})();
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $81dc8d0126b4a70a$var$ELL2_C1 = /* @__PURE__ */ (()=>($81dc8d0126b4a70a$var$ed25519_CURVE_p + $81dc8d0126b4a70a$var$_3n) / $81dc8d0126b4a70a$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $81dc8d0126b4a70a$var$ELL2_C2 = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$var$Fp.pow($81dc8d0126b4a70a$var$_2n, $81dc8d0126b4a70a$var$ELL2_C1))(); // 2. c2 = 2^c1
const $81dc8d0126b4a70a$var$ELL2_C3 = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$var$Fp.sqrt($81dc8d0126b4a70a$var$Fp.neg($81dc8d0126b4a70a$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $81dc8d0126b4a70a$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($81dc8d0126b4a70a$var$ed25519_CURVE_p - $81dc8d0126b4a70a$var$_5n) / $81dc8d0126b4a70a$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $81dc8d0126b4a70a$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $81dc8d0126b4a70a$var$Fp.mul(tv1, $81dc8d0126b4a70a$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $81dc8d0126b4a70a$var$Fp.add(tv1, $81dc8d0126b4a70a$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $81dc8d0126b4a70a$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $81dc8d0126b4a70a$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $81dc8d0126b4a70a$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $81dc8d0126b4a70a$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $81dc8d0126b4a70a$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $81dc8d0126b4a70a$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $81dc8d0126b4a70a$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $81dc8d0126b4a70a$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $81dc8d0126b4a70a$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $81dc8d0126b4a70a$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $81dc8d0126b4a70a$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $81dc8d0126b4a70a$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $81dc8d0126b4a70a$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $81dc8d0126b4a70a$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $81dc8d0126b4a70a$var$Fp.mul(y11, $81dc8d0126b4a70a$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $81dc8d0126b4a70a$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $81dc8d0126b4a70a$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $81dc8d0126b4a70a$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $81dc8d0126b4a70a$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $81dc8d0126b4a70a$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $81dc8d0126b4a70a$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $81dc8d0126b4a70a$var$Fp.mul(y21, $81dc8d0126b4a70a$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $81dc8d0126b4a70a$var$Fp.mul(y21, $81dc8d0126b4a70a$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $81dc8d0126b4a70a$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $81dc8d0126b4a70a$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $81dc8d0126b4a70a$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $81dc8d0126b4a70a$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $81dc8d0126b4a70a$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $81dc8d0126b4a70a$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $81dc8d0126b4a70a$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $81dc8d0126b4a70a$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $81dc8d0126b4a70a$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $81dc8d0126b4a70a$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $81dc8d0126b4a70a$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $81dc8d0126b4a70a$var$Fp.cmov(y, $81dc8d0126b4a70a$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $81dc8d0126b4a70a$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $81dc8d0126b4a70a$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $ac09377731e862cc$export$1d7b691df0888e02)($81dc8d0126b4a70a$var$Fp, $81dc8d0126b4a70a$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $81dc8d0126b4a70a$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $81dc8d0126b4a70a$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $81dc8d0126b4a70a$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $81dc8d0126b4a70a$var$Fp.mul(xn, $81dc8d0126b4a70a$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $81dc8d0126b4a70a$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $81dc8d0126b4a70a$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $81dc8d0126b4a70a$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $81dc8d0126b4a70a$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $81dc8d0126b4a70a$var$Fp.eql(tv1, $81dc8d0126b4a70a$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $81dc8d0126b4a70a$var$Fp.cmov(xn, $81dc8d0126b4a70a$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $81dc8d0126b4a70a$var$Fp.cmov(xd, $81dc8d0126b4a70a$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $81dc8d0126b4a70a$var$Fp.cmov(yn, $81dc8d0126b4a70a$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $81dc8d0126b4a70a$var$Fp.cmov(yd, $81dc8d0126b4a70a$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const [xd_inv, yd_inv] = (0, $ac09377731e862cc$export$a492e3387142c0e9)($81dc8d0126b4a70a$var$Fp, [
        xd,
        yd
    ], true); // batch division
    return {
        x: $81dc8d0126b4a70a$var$Fp.mul(xn, xd_inv),
        y: $81dc8d0126b4a70a$var$Fp.mul(yn, yd_inv)
    }; //  13. return (xn, xd, yn, yd)
}
const $81dc8d0126b4a70a$export$bd158472185fbd42 = /* @__PURE__ */ (()=>(0, $a07456824fd2805f$export$14b114effbc08b6b)($81dc8d0126b4a70a$export$f63794f4a09a19c1.Point, (scalars)=>$81dc8d0126b4a70a$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: 'edwards25519_XMD:SHA-512_ELL2_RO_',
        encodeDST: 'edwards25519_XMD:SHA-512_ELL2_NU_',
        p: $81dc8d0126b4a70a$var$ed25519_CURVE_p,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $5818663383f9b787$export$a888d2532e6dc7bb)
    }))();
// √(-1) aka √(a) aka 2^((p-1)/4)
const $81dc8d0126b4a70a$var$SQRT_M1 = $81dc8d0126b4a70a$var$ED25519_SQRT_M1;
// √(ad - 1)
const $81dc8d0126b4a70a$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt('25063068953384623474111414158702152701244531502492656460079210482610430750235');
// 1 / √(a-d)
const $81dc8d0126b4a70a$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt('54469307008909316920995813868745141605393597292927456921205312896311721017578');
// 1-d²
const $81dc8d0126b4a70a$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt('1159843021668779879193775521855586647937357759715417654439879720876111806838');
// (d-1)²
const $81dc8d0126b4a70a$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt('40440834346308536858101042469323190826248399146238708352240133220865137265952');
// Calculates 1/√(number)
const $81dc8d0126b4a70a$var$invertSqrt = (number)=>$81dc8d0126b4a70a$var$uvRatio($81dc8d0126b4a70a$var$_1n, number);
const $81dc8d0126b4a70a$var$MAX_255B = /* @__PURE__ */ BigInt('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
const $81dc8d0126b4a70a$var$bytes255ToNumberLE = (bytes)=>$81dc8d0126b4a70a$export$f63794f4a09a19c1.Point.Fp.create((0, $3b17219c0ea055df$export$d67b1d03392107e7)(bytes) & $81dc8d0126b4a70a$var$MAX_255B);
/**
 * Computes Elligator map for Ristretto255.
 * Described in [RFC9380](https://www.rfc-editor.org/rfc/rfc9380#appendix-B) and on
 * the [website](https://ristretto.group/formulas/elligator.html).
 */ function $81dc8d0126b4a70a$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $81dc8d0126b4a70a$var$ed25519_CURVE;
    const P = $81dc8d0126b4a70a$var$ed25519_CURVE_p;
    const mod = (n)=>$81dc8d0126b4a70a$var$Fp.create(n);
    const r = mod($81dc8d0126b4a70a$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $81dc8d0126b4a70a$var$_1n) * $81dc8d0126b4a70a$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $81dc8d0126b4a70a$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $ac09377731e862cc$export$7806f13ad5078b2f)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $81dc8d0126b4a70a$var$_1n) * $81dc8d0126b4a70a$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $81dc8d0126b4a70a$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($81dc8d0126b4a70a$var$_1n - s2); // 12
    const W3 = mod($81dc8d0126b4a70a$var$_1n + s2); // 13
    return new $81dc8d0126b4a70a$export$f63794f4a09a19c1.Point(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
function $81dc8d0126b4a70a$var$ristretto255_map(bytes) {
    (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(bytes, 64);
    const r1 = $81dc8d0126b4a70a$var$bytes255ToNumberLE(bytes.subarray(0, 32));
    const R1 = $81dc8d0126b4a70a$var$calcElligatorRistrettoMap(r1);
    const r2 = $81dc8d0126b4a70a$var$bytes255ToNumberLE(bytes.subarray(32, 64));
    const R2 = $81dc8d0126b4a70a$var$calcElligatorRistrettoMap(r2);
    return new $81dc8d0126b4a70a$var$_RistrettoPoint(R1.add(R2));
}
/**
 * Wrapper over Edwards Point for ristretto255.
 *
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * See [RFC9496](https://www.rfc-editor.org/rfc/rfc9496).
 */ class $81dc8d0126b4a70a$var$_RistrettoPoint extends (0, $04bbd2fee334f878$export$de66e17e5739587e) {
    constructor(ep){
        super(ep);
    }
    static fromAffine(ap) {
        return new $81dc8d0126b4a70a$var$_RistrettoPoint($81dc8d0126b4a70a$export$f63794f4a09a19c1.Point.fromAffine(ap));
    }
    assertSame(other) {
        if (!(other instanceof $81dc8d0126b4a70a$var$_RistrettoPoint)) throw new Error('RistrettoPoint expected');
    }
    init(ep) {
        return new $81dc8d0126b4a70a$var$_RistrettoPoint(ep);
    }
    /** @deprecated use `import { ristretto255_hasher } from '@noble/curves/ed25519.js';` */ static hashToCurve(hex) {
        return $81dc8d0126b4a70a$var$ristretto255_map((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('ristrettoHash', hex, 64));
    }
    static fromBytes(bytes) {
        (0, $ab7af777c5df829d$export$e8a750b9efad93f5)(bytes, 32);
        const { a: a, d: d } = $81dc8d0126b4a70a$var$ed25519_CURVE;
        const P = $81dc8d0126b4a70a$var$ed25519_CURVE_p;
        const mod = (n)=>$81dc8d0126b4a70a$var$Fp.create(n);
        const s = $81dc8d0126b4a70a$var$bytes255ToNumberLE(bytes);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $3b17219c0ea055df$export$2aa59cef064b0333)($81dc8d0126b4a70a$var$Fp.toBytes(s), bytes) || (0, $ac09377731e862cc$export$7806f13ad5078b2f)(s, P)) throw new Error('invalid ristretto255 encoding 1');
        const s2 = mod(s * s);
        const u1 = mod($81dc8d0126b4a70a$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($81dc8d0126b4a70a$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $81dc8d0126b4a70a$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $ac09377731e862cc$export$7806f13ad5078b2f)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $ac09377731e862cc$export$7806f13ad5078b2f)(t, P) || y === $81dc8d0126b4a70a$var$_0n) throw new Error('invalid ristretto255 encoding 2');
        return new $81dc8d0126b4a70a$var$_RistrettoPoint(new $81dc8d0126b4a70a$export$f63794f4a09a19c1.Point(x, y, $81dc8d0126b4a70a$var$_1n, t));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-decode).
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        return $81dc8d0126b4a70a$var$_RistrettoPoint.fromBytes((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('ristrettoHex', hex, 32));
    }
    static msm(points, scalars) {
        return (0, $bb3103cee1bb9983$export$8e2f6717424463a3)($81dc8d0126b4a70a$var$_RistrettoPoint, $81dc8d0126b4a70a$export$f63794f4a09a19c1.Point.Fn, points, scalars);
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-encode).
     */ toBytes() {
        let { X: X, Y: Y, Z: Z, T: T } = this.ep;
        const P = $81dc8d0126b4a70a$var$ed25519_CURVE_p;
        const mod = (n)=>$81dc8d0126b4a70a$var$Fp.create(n);
        const u1 = mod(mod(Z + Y) * mod(Z - Y)); // 1
        const u2 = mod(X * Y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $81dc8d0126b4a70a$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * T); // 6
        let D; // 7
        if ((0, $ac09377731e862cc$export$7806f13ad5078b2f)(T * zInv, P)) {
            let _x = mod(Y * $81dc8d0126b4a70a$var$SQRT_M1);
            let _y = mod(X * $81dc8d0126b4a70a$var$SQRT_M1);
            X = _x;
            Y = _y;
            D = mod(D1 * $81dc8d0126b4a70a$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $ac09377731e862cc$export$7806f13ad5078b2f)(X * zInv, P)) Y = mod(-Y); // 9
        let s = mod((Z - Y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $ac09377731e862cc$export$7806f13ad5078b2f)(s, P)) s = mod(-s);
        return $81dc8d0126b4a70a$var$Fp.toBytes(s); // 11
    }
    /**
     * Compares two Ristretto points.
     * Described in [RFC9496](https://www.rfc-editor.org/rfc/rfc9496#name-equals).
     */ equals(other) {
        this.assertSame(other);
        const { X: X1, Y: Y1 } = this.ep;
        const { X: X2, Y: Y2 } = other.ep;
        const mod = (n)=>$81dc8d0126b4a70a$var$Fp.create(n);
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    is0() {
        return this.equals($81dc8d0126b4a70a$var$_RistrettoPoint.ZERO);
    }
}
// Do NOT change syntax: the following gymnastics is done,
// because typescript strips comments, which makes bundlers disable tree-shaking.
// prettier-ignore
$81dc8d0126b4a70a$var$_RistrettoPoint.BASE = /* @__PURE__ */ (()=>new $81dc8d0126b4a70a$var$_RistrettoPoint($81dc8d0126b4a70a$export$f63794f4a09a19c1.Point.BASE))();
// prettier-ignore
$81dc8d0126b4a70a$var$_RistrettoPoint.ZERO = /* @__PURE__ */ (()=>new $81dc8d0126b4a70a$var$_RistrettoPoint($81dc8d0126b4a70a$export$f63794f4a09a19c1.Point.ZERO))();
// prettier-ignore
$81dc8d0126b4a70a$var$_RistrettoPoint.Fp = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$var$Fp)();
// prettier-ignore
$81dc8d0126b4a70a$var$_RistrettoPoint.Fn = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$var$Fn)();
const $81dc8d0126b4a70a$export$f57beb4c2054cdc7 = {
    Point: $81dc8d0126b4a70a$var$_RistrettoPoint
};
const $81dc8d0126b4a70a$export$e58e8945170587ea = {
    hashToCurve (msg, options) {
        const DST = options?.DST || 'ristretto255_XMD:SHA-512_R255MAP_RO_';
        const xmd = (0, $a07456824fd2805f$export$3df78c69af9fc85d)(msg, DST, 64, (0, $5818663383f9b787$export$a888d2532e6dc7bb));
        return $81dc8d0126b4a70a$var$ristretto255_map(xmd);
    },
    hashToScalar (msg, options = {
        DST: (0, $a07456824fd2805f$export$eaf8c8caa9e37fdf)
    }) {
        const xmd = (0, $a07456824fd2805f$export$3df78c69af9fc85d)(msg, options.DST, 64, (0, $5818663383f9b787$export$a888d2532e6dc7bb));
        return $81dc8d0126b4a70a$var$Fn.create((0, $3b17219c0ea055df$export$d67b1d03392107e7)(xmd));
    }
};
const $81dc8d0126b4a70a$export$5ce3305f0d0b8e6f = [
    '0100000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a',
    '0000000000000000000000000000000000000000000000000000000000000080',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05',
    'ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f',
    '26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85',
    '0000000000000000000000000000000000000000000000000000000000000000',
    'c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa'
];
function $81dc8d0126b4a70a$export$78609ae56f1edf04(edwardsPub) {
    return $81dc8d0126b4a70a$export$f63794f4a09a19c1.utils.toMontgomery((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('pub', edwardsPub));
}
const $81dc8d0126b4a70a$export$84bc39a6e4664b07 = $81dc8d0126b4a70a$export$78609ae56f1edf04;
function $81dc8d0126b4a70a$export$c32b0f86cebbdf19(edwardsPriv) {
    return $81dc8d0126b4a70a$export$f63794f4a09a19c1.utils.toMontgomerySecret((0, $3b17219c0ea055df$export$3cb5d50a3a30e837)('pub', edwardsPriv));
}
const $81dc8d0126b4a70a$export$5e87c4f36f27816d = $81dc8d0126b4a70a$var$_RistrettoPoint;
const $81dc8d0126b4a70a$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$export$bd158472185fbd42.hashToCurve)();
const $81dc8d0126b4a70a$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$export$bd158472185fbd42.encodeToCurve)();
const $81dc8d0126b4a70a$export$c9ad4c0d917ad3 = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$export$e58e8945170587ea.hashToCurve)();
const $81dc8d0126b4a70a$export$667ef88de7a83a7f = /* @__PURE__ */ (()=>$81dc8d0126b4a70a$export$e58e8945170587ea.hashToCurve)();


// src/codes.ts
var $938d2f63083c1136$export$637a712014b81b9c = 1;
var $938d2f63083c1136$export$2b45309b0547a9c4 = 2;
var $938d2f63083c1136$export$7cf14cde1226b7cb = 3;
var $938d2f63083c1136$export$6ad19ea5e363a944 = 4;
var $938d2f63083c1136$export$c37fe345cc9b38e7 = 5;
var $938d2f63083c1136$export$cf7b28c4ea07497b = 6;
var $938d2f63083c1136$export$e8ff0c73a3d6800d = 7;
var $938d2f63083c1136$export$7dd7d17f1f93a166 = 8;
var $938d2f63083c1136$export$8b23617676679e2d = 9;
var $938d2f63083c1136$export$1cf7bba40d7d2361 = 10;
var $938d2f63083c1136$export$7cb3af4590511eb4 = 11;
var $938d2f63083c1136$export$5dac493019b18473 = 12;
var $938d2f63083c1136$export$38e770f41f89279d = 13;
var $938d2f63083c1136$export$49ac0c4c9d061eec = 14;
var $938d2f63083c1136$export$e09e3905081e44fe = -32700;
var $938d2f63083c1136$export$afa40fd3fc01204 = -32603;
var $938d2f63083c1136$export$2981978a530b1a7c = -32602;
var $938d2f63083c1136$export$5ec955cc8b7e8cf9 = -32601;
var $938d2f63083c1136$export$23cb4efd59427895 = -32600;
var $938d2f63083c1136$export$690667cf4da3ba9d = -32021;
var $938d2f63083c1136$export$8dfce16ef39ea58c = -32020;
var $938d2f63083c1136$export$35d837f314929752 = -32019;
var $938d2f63083c1136$export$86fc15c41ff3dc9c = -32018;
var $938d2f63083c1136$export$1e95c50f9776ce34 = -32017;
var $938d2f63083c1136$export$4f93db3d1b48599e = -32016;
var $938d2f63083c1136$export$f7685139153f9191 = -32015;
var $938d2f63083c1136$export$65235469ebe9845e = -32014;
var $938d2f63083c1136$export$bdeebdca616ef1f3 = -32013;
var $938d2f63083c1136$export$1b90c411626421b1 = -32012;
var $938d2f63083c1136$export$8e678bf9b4e5cb64 = -32011;
var $938d2f63083c1136$export$54dea2286c43ec1e = -32010;
var $938d2f63083c1136$export$e71fbee92648fc61 = -32009;
var $938d2f63083c1136$export$eb4f7515ff6aa19d = -32008;
var $938d2f63083c1136$export$d21075fd06730e = -32007;
var $938d2f63083c1136$export$d964b43bb02eacdf = -32006;
var $938d2f63083c1136$export$6bad0f4fb625ae6e = -32005;
var $938d2f63083c1136$export$bfbf8b75e865efa0 = -32004;
var $938d2f63083c1136$export$83dce8c0aef70463 = -32003;
var $938d2f63083c1136$export$426cc73f5ad00f38 = -32002;
var $938d2f63083c1136$export$6ae475e85fe02aad = -32001;
var $938d2f63083c1136$export$fe284a92110eab86 = 28e5;
var $938d2f63083c1136$export$8aae3518bf4ea38c = 2800001;
var $938d2f63083c1136$export$e31a90a3bf6aebaa = 2800002;
var $938d2f63083c1136$export$adaec66b544981e7 = 2800003;
var $938d2f63083c1136$export$523a769cce7318bf = 2800004;
var $938d2f63083c1136$export$68473acf744cabf5 = 2800005;
var $938d2f63083c1136$export$940d17d3b63dba7c = 2800006;
var $938d2f63083c1136$export$a1cf857da540ee2e = 2800007;
var $938d2f63083c1136$export$30501b98da9564bb = 2800008;
var $938d2f63083c1136$export$123d01dd469dc2ef = 2800009;
var $938d2f63083c1136$export$2a7684440f52314e = 2800010;
var $938d2f63083c1136$export$7ada2ae349acb674 = 2800011;
var $938d2f63083c1136$export$8f39956700e64760 = 323e4;
var $938d2f63083c1136$export$1239089c4564c858 = 32300001;
var $938d2f63083c1136$export$afc08ee11abbc257 = 3230002;
var $938d2f63083c1136$export$57836d13a84f54b0 = 3230003;
var $938d2f63083c1136$export$f080cd056a56cd54 = 3230004;
var $938d2f63083c1136$export$f2bbb3c14e29977e = 361e4;
var $938d2f63083c1136$export$f18173f573d8bb21 = 3610001;
var $938d2f63083c1136$export$7ad09900bd645a86 = 3610002;
var $938d2f63083c1136$export$69c08c51e1841f29 = 3610003;
var $938d2f63083c1136$export$325dad4e0a6bd514 = 3610004;
var $938d2f63083c1136$export$242c341c7c464bee = 3610005;
var $938d2f63083c1136$export$a73c064bb32a7c36 = 3610006;
var $938d2f63083c1136$export$b6497aaa1c3cb4a7 = 3610007;
var $938d2f63083c1136$export$bc2b26beee0f9a0b = 3611e3;
var $938d2f63083c1136$export$bc1242deaa4d848d = 3704e3;
var $938d2f63083c1136$export$44352af09ecae39f = 3704001;
var $938d2f63083c1136$export$d2a0e93e506be463 = 3704002;
var $938d2f63083c1136$export$bbe4ed5687bc7f55 = 3704003;
var $938d2f63083c1136$export$436df06ce5af77b3 = 3704004;
var $938d2f63083c1136$export$bc24f4f6bff910ad = 3704005;
var $938d2f63083c1136$export$a33e1278cd08ba37 = 3704006;
var $938d2f63083c1136$export$804a824ae398401e = 3704007;
var $938d2f63083c1136$export$1c659240f0b07a02 = 3712e3;
var $938d2f63083c1136$export$552eeff1216c4a1e = 4128e3;
var $938d2f63083c1136$export$b260fc8c8d3cde52 = 4128001;
var $938d2f63083c1136$export$b81e507604713b9b = 4128002;
var $938d2f63083c1136$export$d308cb6df5c28ff6 = 4615e3;
var $938d2f63083c1136$export$ab2273c84ffc5d61 = 4615001;
var $938d2f63083c1136$export$23cc359156888c7f = 4615002;
var $938d2f63083c1136$export$a4193356408e9ff0 = 4615003;
var $938d2f63083c1136$export$f9ae264f831e3bcf = 4615004;
var $938d2f63083c1136$export$e170b44d99a3d17c = 4615005;
var $938d2f63083c1136$export$84ec8e94b54ae7d2 = 4615006;
var $938d2f63083c1136$export$4063fe8d5aed84a5 = 4615007;
var $938d2f63083c1136$export$ecdd3388f6a493b1 = 4615008;
var $938d2f63083c1136$export$df0a6d6cbb0d96a1 = 4615009;
var $938d2f63083c1136$export$e45bdcd5a97f01d1 = 4615010;
var $938d2f63083c1136$export$c2bfe7e903a0febb = 4615011;
var $938d2f63083c1136$export$fa2d8ac69bd6117e = 4615012;
var $938d2f63083c1136$export$2b7e7e6bd3d5b8c4 = 4615013;
var $938d2f63083c1136$export$72e64aed285de589 = 4615014;
var $938d2f63083c1136$export$95d7c72146ee65c6 = 4615015;
var $938d2f63083c1136$export$aa03f185732dc00b = 4615016;
var $938d2f63083c1136$export$c390f45549d7336b = 4615017;
var $938d2f63083c1136$export$2ea2f2f9a9e26449 = 4615018;
var $938d2f63083c1136$export$c9ece88629d0d2d8 = 4615019;
var $938d2f63083c1136$export$2f331454431511bf = 4615020;
var $938d2f63083c1136$export$3c4b9377ed4116a0 = 4615021;
var $938d2f63083c1136$export$211b990ef3bd19ce = 4615022;
var $938d2f63083c1136$export$ef486e0fcc8262b = 4615023;
var $938d2f63083c1136$export$afcb9eeb4bf056b5 = 4615024;
var $938d2f63083c1136$export$4db39a3a67e51db2 = 4615025;
var $938d2f63083c1136$export$5abe2d1d040bf6cf = 4615026;
var $938d2f63083c1136$export$35a7a209cf9aaee8 = 4615027;
var $938d2f63083c1136$export$203fce7ce63eb278 = 4615028;
var $938d2f63083c1136$export$c65d87b69a4b86e5 = 4615029;
var $938d2f63083c1136$export$d13686e596713674 = 4615030;
var $938d2f63083c1136$export$a070310f29fe959b = 4615031;
var $938d2f63083c1136$export$8eb8ce58a8afa4d8 = 4615032;
var $938d2f63083c1136$export$1224afa7bd705d3d = 4615033;
var $938d2f63083c1136$export$547fdb4fff65c547 = 4615034;
var $938d2f63083c1136$export$cbeea52e947eb081 = 4615035;
var $938d2f63083c1136$export$fd7a98f0746b6c8a = 4615036;
var $938d2f63083c1136$export$8e6d399c8fb88eaa = 4615037;
var $938d2f63083c1136$export$2c001ce75e66180d = 4615038;
var $938d2f63083c1136$export$ec7d592dad68aa12 = 4615039;
var $938d2f63083c1136$export$8815da3ec592d05a = 4615040;
var $938d2f63083c1136$export$b1b9bf899899a525 = 4615041;
var $938d2f63083c1136$export$67715a67add5645f = 4615042;
var $938d2f63083c1136$export$e343a153899b82e9 = 4615043;
var $938d2f63083c1136$export$2199fb95c7d85b85 = 4615044;
var $938d2f63083c1136$export$57c1675a0c20931f = 4615045;
var $938d2f63083c1136$export$9e62f446da191370 = 4615046;
var $938d2f63083c1136$export$b5ccaf975fe486a0 = 4615047;
var $938d2f63083c1136$export$4d39d4c2f04b41a8 = 4615048;
var $938d2f63083c1136$export$1997554dc67e9c4e = 4615049;
var $938d2f63083c1136$export$8a65209e9cece2cd = 4615050;
var $938d2f63083c1136$export$6b675123aa59300c = 4615051;
var $938d2f63083c1136$export$70b4e2dd1496c5a3 = 4615052;
var $938d2f63083c1136$export$43d5111034db211a = 4615053;
var $938d2f63083c1136$export$8aebe3e76f515046 = 4615054;
var $938d2f63083c1136$export$ee84b29a9985e516 = 5508e3;
var $938d2f63083c1136$export$9998b265c986beaa = 5508001;
var $938d2f63083c1136$export$dd792e9d67cd031b = 5508002;
var $938d2f63083c1136$export$14d32fbdad2233cd = 5508003;
var $938d2f63083c1136$export$8c6fc1cfcec8440c = 5508004;
var $938d2f63083c1136$export$dcec7171cff295d1 = 5508005;
var $938d2f63083c1136$export$200acbfc722e322b = 5508006;
var $938d2f63083c1136$export$4c96d9a95880ae4b = 5508007;
var $938d2f63083c1136$export$bba76b21ada319a5 = 5508008;
var $938d2f63083c1136$export$3cb3b480d2bfdacc = 5508009;
var $938d2f63083c1136$export$1f5fbaa83776feec = 5508010;
var $938d2f63083c1136$export$1d51c4c8b2c49e09 = 5508011;
var $938d2f63083c1136$export$96a986fd198910e9 = 5508012;
var $938d2f63083c1136$export$e095feafa627ab93 = 5607e3;
var $938d2f63083c1136$export$1bd1351c3c04dffb = 5607001;
var $938d2f63083c1136$export$c2666c33001f9716 = 5607002;
var $938d2f63083c1136$export$13efb168b2f8723b = 5607003;
var $938d2f63083c1136$export$cdd46422e6064873 = 5607004;
var $938d2f63083c1136$export$ca446d431d3e0795 = 5607005;
var $938d2f63083c1136$export$7b86ea017e7c65a8 = 5607006;
var $938d2f63083c1136$export$47bddc6d96d8aafe = 5607007;
var $938d2f63083c1136$export$16aa99698ba98923 = 5607008;
var $938d2f63083c1136$export$24dfb058e3a278af = 5607009;
var $938d2f63083c1136$export$5de6608bb79088df = 5607010;
var $938d2f63083c1136$export$5b7facf9eb8f4fc1 = 5607011;
var $938d2f63083c1136$export$ac41328a8c021f1d = 5607012;
var $938d2f63083c1136$export$a722215db3dceeea = 5607013;
var $938d2f63083c1136$export$c0e832e2b8c6c75c = 5607014;
var $938d2f63083c1136$export$7be41df2aa4d6598 = 5607015;
var $938d2f63083c1136$export$f4c0dc856ca8d3c6 = 5607016;
var $938d2f63083c1136$export$3abfcff57e9c6b21 = 5607017;
var $938d2f63083c1136$export$bb317ddcc34ed03d = 5607018;
var $938d2f63083c1136$export$7fb8ee8f1d153f7d = 5607019;
var $938d2f63083c1136$export$694fd435994bcca = 5663e3;
var $938d2f63083c1136$export$707576ec00ca24d6 = 5663001;
var $938d2f63083c1136$export$e33d07a7526bded0 = 5663002;
var $938d2f63083c1136$export$a20747f749dd4515 = 5663003;
var $938d2f63083c1136$export$3963d9bca4091810 = 5663004;
var $938d2f63083c1136$export$b34a16b8adbffdc1 = 5663005;
var $938d2f63083c1136$export$3764bbcfb0679211 = 5663006;
var $938d2f63083c1136$export$ed2bdee7953e467f = 5663007;
var $938d2f63083c1136$export$11bea4440904349c = 5663008;
var $938d2f63083c1136$export$6d61b980429516bd = 5663009;
var $938d2f63083c1136$export$819b1b0603d2a966 = 5663010;
var $938d2f63083c1136$export$592862d1b11e32ac = 5663011;
var $938d2f63083c1136$export$242af5597d94abaf = 5663012;
var $938d2f63083c1136$export$802b3ebe5297e360 = 5663013;
var $938d2f63083c1136$export$bed6f92dafea0623 = 5663014;
var $938d2f63083c1136$export$36c2547c3c4d823f = 5663015;
var $938d2f63083c1136$export$de92784c954d1b84 = 5663016;
var $938d2f63083c1136$export$b55a3eb3d894ad9f = 5663017;
var $938d2f63083c1136$export$4e4582c633fc423e = 5663018;
var $938d2f63083c1136$export$923893d5c076a47c = 5663019;
var $938d2f63083c1136$export$980469bdb5d5bd4f = 5663020;
var $938d2f63083c1136$export$8ff97fea1326b6e7 = 5663021;
var $938d2f63083c1136$export$204c62c0e8d2efcc = 5663022;
var $938d2f63083c1136$export$102de27de91bf32b = 5663023;
var $938d2f63083c1136$export$15d93ee95a0fbfee = 5663024;
var $938d2f63083c1136$export$4641ca456c9ac65a = 5663025;
var $938d2f63083c1136$export$db5d0ad0319baeab = 5663026;
var $938d2f63083c1136$export$c94bf194991c6a40 = 5663027;
var $938d2f63083c1136$export$ee92f61088a1066a = 5663028;
var $938d2f63083c1136$export$ce102cf7a4dc8c26 = 5663029;
var $938d2f63083c1136$export$bb954aa95380cc07 = 5663030;
var $938d2f63083c1136$export$70cf12a7af68a7bb = 5663031;
var $938d2f63083c1136$export$3da8c24b63df7026 = 5663032;
var $938d2f63083c1136$export$24ca3e569f030a48 = 5663033;
var $938d2f63083c1136$export$7d52b2fdc6c6f4fd = 5663034;
var $938d2f63083c1136$export$d463b452862201a4 = 5663035;
var $938d2f63083c1136$export$7a52a9f8bedc82c0 = 5663036;
var $938d2f63083c1136$export$7774c611982e038 = 5663037;
var $938d2f63083c1136$export$a0d8e792371f738d = 5663038;
var $938d2f63083c1136$export$a1cb45d281e4f256 = 5663039;
var $938d2f63083c1136$export$84810c56288ac788 = 5663040;
var $938d2f63083c1136$export$a05704ad9908bda9 = 5664e3;
var $938d2f63083c1136$export$302ce5f895eb18ab = 5664001;
var $938d2f63083c1136$export$8c82dde5b12c9789 = 705e4;
var $938d2f63083c1136$export$a746609ecc2f6acf = 7050001;
var $938d2f63083c1136$export$c4d8217d3eb3eaf8 = 7050002;
var $938d2f63083c1136$export$5d0f06cd8bc8e3af = 7050003;
var $938d2f63083c1136$export$83c8fe2717d1b271 = 7050004;
var $938d2f63083c1136$export$39ead28cf48a604c = 7050005;
var $938d2f63083c1136$export$624f65633216eb57 = 7050006;
var $938d2f63083c1136$export$2bbd9403cb117ea7 = 7050007;
var $938d2f63083c1136$export$e108dd5343c4c11 = 7050008;
var $938d2f63083c1136$export$a504ed6cab09ce4a = 7050009;
var $938d2f63083c1136$export$8c1ae05eccc11ef9 = 7050010;
var $938d2f63083c1136$export$47df44101c6f04b0 = 7050011;
var $938d2f63083c1136$export$89ae0c424691fbcb = 7050012;
var $938d2f63083c1136$export$bea5f92951bc42e7 = 7050013;
var $938d2f63083c1136$export$91a668e132084ecf = 7050014;
var $938d2f63083c1136$export$211b9b84186690f0 = 7050015;
var $938d2f63083c1136$export$291ea8d5a7496fde = 7050016;
var $938d2f63083c1136$export$5f027a86397cba92 = 7050017;
var $938d2f63083c1136$export$58bf90c73afbc02e = 7050018;
var $938d2f63083c1136$export$b8b2610c9a910763 = 7050019;
var $938d2f63083c1136$export$fb693aebffa32676 = 7050020;
var $938d2f63083c1136$export$572954173bc64b66 = 7050021;
var $938d2f63083c1136$export$fa9a13f1b40ee2fb = 7050022;
var $938d2f63083c1136$export$95c94f6ea500f1ab = 7050023;
var $938d2f63083c1136$export$11d69fb6993b2cf5 = 7050024;
var $938d2f63083c1136$export$bd54a9a85614b3a7 = 7050025;
var $938d2f63083c1136$export$df4ef1824fd194a3 = 7050026;
var $938d2f63083c1136$export$2725d50dd432fb3a = 7050027;
var $938d2f63083c1136$export$41f13726b04d8d05 = 7050028;
var $938d2f63083c1136$export$7b4a7eebff68ca7b = 7050029;
var $938d2f63083c1136$export$e3a4007020a2e8f5 = 7050030;
var $938d2f63083c1136$export$2ecc275dffbc087c = 7050031;
var $938d2f63083c1136$export$e3289c5954208202 = 7050032;
var $938d2f63083c1136$export$3569c6c71e349538 = 7050033;
var $938d2f63083c1136$export$4f413e02d5e82221 = 7050034;
var $938d2f63083c1136$export$1cd0de5dfcdeb99d = 7050035;
var $938d2f63083c1136$export$87e01307d368f511 = 7050036;
var $938d2f63083c1136$export$4758b9d97c7acd49 = 7618e3;
var $938d2f63083c1136$export$2e5fda8b40bc9396 = 7618001;
var $938d2f63083c1136$export$b22811c3929e985a = 7618002;
var $938d2f63083c1136$export$12d6d18d48ba64e9 = 7618003;
var $938d2f63083c1136$export$e4bc7cf62067d898 = 7618004;
var $938d2f63083c1136$export$f988935bbec3c348 = 7618005;
var $938d2f63083c1136$export$a55985b9459d2f3b = 7618006;
var $938d2f63083c1136$export$dba3fa3abd2194c6 = 7618007;
var $938d2f63083c1136$export$a751080bf117630f = 7618008;
var $938d2f63083c1136$export$9318fa904fe94ef2 = 7618009;
var $938d2f63083c1136$export$9bfc7de894c3d9da = 7618010;
var $938d2f63083c1136$export$58f34489822f32f1 = 7618011;
var $938d2f63083c1136$export$ecfe9455a11db1e0 = 7618012;
var $938d2f63083c1136$export$9c9326ce1e3df40c = 8078e3;
var $938d2f63083c1136$export$18fbf24f19efc69b = 8078001;
var $938d2f63083c1136$export$93561b31b951410d = 8078002;
var $938d2f63083c1136$export$3417da5bc6bcb45 = 8078003;
var $938d2f63083c1136$export$c4c73ab3c0833591 = 8078004;
var $938d2f63083c1136$export$824d79ab1779d517 = 8078005;
var $938d2f63083c1136$export$c464f3b291f1f3d0 = 8078006;
var $938d2f63083c1136$export$c04710d31ef4d278 = 8078007;
var $938d2f63083c1136$export$1fa107ead8489cf2 = 8078008;
var $938d2f63083c1136$export$2bb0703affb8fe68 = 8078009;
var $938d2f63083c1136$export$f6bf8a7c1f3defe4 = 8078010;
var $938d2f63083c1136$export$8653c145864f47f4 = 8078011;
var $938d2f63083c1136$export$89b582b06852d433 = 8078012;
var $938d2f63083c1136$export$4c1fcb4bd20b2951 = 8078013;
var $938d2f63083c1136$export$a617dff403944ec6 = 8078014;
var $938d2f63083c1136$export$c89f43f0d783cd50 = 8078015;
var $938d2f63083c1136$export$f73fb8ecbd4b2395 = 8078016;
var $938d2f63083c1136$export$efbd199de191d2aa = 8078017;
var $938d2f63083c1136$export$cb77f5a0f0fa7f18 = 8078018;
var $938d2f63083c1136$export$47278510a511031b = 8078019;
var $938d2f63083c1136$export$a9282ed13660c9f6 = 8078020;
var $938d2f63083c1136$export$5bdfee6423bc35ce = 8078021;
var $938d2f63083c1136$export$a2e9526594022372 = 8078022;
var $938d2f63083c1136$export$11a7243580452ad8 = 8078023;
var $938d2f63083c1136$export$917fb07617f2d1fb = 8078024;
var $938d2f63083c1136$export$345850eef23c927d = 8078025;
var $938d2f63083c1136$export$8ed49819c26ad29f = 8078026;
var $938d2f63083c1136$export$5810fa8bfc01906b = 8078027;
var $938d2f63083c1136$export$160b1f6d4f97090b = 8078028;
var $938d2f63083c1136$export$7c7a00cd63be746a = 8078029;
var $938d2f63083c1136$export$66778002bb3d35e4 = 8078030;
var $938d2f63083c1136$export$e7d6af6e57db8b2b = 809e4;
var $938d2f63083c1136$export$92d7c36d7c6d6326 = 8090001;
var $938d2f63083c1136$export$929704b13825ef1d = 8090002;
var $938d2f63083c1136$export$72468d0872763e95 = 8090003;
var $938d2f63083c1136$export$b02d235d3b45fb86 = 8090004;
var $938d2f63083c1136$export$183ade6d1821d3b6 = 8090005;
var $938d2f63083c1136$export$85a626151643ef3b = 8090006;
var $938d2f63083c1136$export$2feecdeb7a6034df = 8090007;
var $938d2f63083c1136$export$9e032cc8893e9cb9 = 8090008;
var $938d2f63083c1136$export$ea486bd2871daf4e = 8090009;
var $938d2f63083c1136$export$8911b5c0a403a5af = 8090010;
var $938d2f63083c1136$export$974c80374b7537fd = 8090011;
var $938d2f63083c1136$export$dfd6489d84297a17 = 8090012;
var $938d2f63083c1136$export$ef742b7036fb9005 = 81e5;
var $938d2f63083c1136$export$2a2f0f75708d1697 = 8100001;
var $938d2f63083c1136$export$7f6822f75edb8f41 = 8100002;
var $938d2f63083c1136$export$119023a74b281384 = 8100003;
var $938d2f63083c1136$export$c32108b180210fc5 = 819e4;
var $938d2f63083c1136$export$e1a3658b043aad8e = 8190001;
var $938d2f63083c1136$export$ae8da83a78732501 = 8190002;
var $938d2f63083c1136$export$73f01f46f9a97cf0 = 8190003;
var $938d2f63083c1136$export$5293460f390d6127 = 8190004;
var $938d2f63083c1136$export$15c87714768dc01d = 8195e3;
var $938d2f63083c1136$export$55e9fe02b4fcdcf4 = 8195001;
var $938d2f63083c1136$export$7a470f3bbbd2358 = 85e5;
var $938d2f63083c1136$export$28c1d89d6f82797c = 8500001;
var $938d2f63083c1136$export$a35cab87219e2726 = 8500002;
var $938d2f63083c1136$export$a46c9b68bd6e4f3c = 8500003;
var $938d2f63083c1136$export$85e194a892d0127e = 8500004;
var $938d2f63083c1136$export$5397ee6ba4d6d1bc = 8500005;
var $938d2f63083c1136$export$6a51b1679eb0ed12 = 8500006;
var $938d2f63083c1136$export$6b5e7fa31b0b2af0 = 8500007;
var $938d2f63083c1136$export$eff143d04ba1c763 = 89e5;
var $938d2f63083c1136$export$c312471e35f2eb26 = 8900001;
var $938d2f63083c1136$export$199c235749811d11 = 8900002;
var $938d2f63083c1136$export$26183083c720a8a4 = 8900003;
var $938d2f63083c1136$export$93808c9da7bf7aff = 8900004;
var $938d2f63083c1136$export$91279c3e80690072 = 8900005;
var $938d2f63083c1136$export$4324114557ad2da1 = 8900006;
var $938d2f63083c1136$export$100e4d6784b74743 = 9e6;
var $938d2f63083c1136$export$53a95e64cc3268a = 9000001;
var $938d2f63083c1136$export$ece10101ca3fdef = 9000002;
var $938d2f63083c1136$export$a12ca71185bd51db = 99e5;
var $938d2f63083c1136$export$d5b3c70e0e0f470a = 9900001;
var $938d2f63083c1136$export$b57ffff6ec11f63 = 9900002;
var $938d2f63083c1136$export$6fe73388375373f = 9900003;
var $938d2f63083c1136$export$8b0d360227f3435e = 9900004;
var $938d2f63083c1136$export$bcbc513a8682960f = 9900005;
var $938d2f63083c1136$export$8f646bf76fb27ec0 = 9900006;
// src/context.ts
function $938d2f63083c1136$var$encodeValue(value) {
    if (Array.isArray(value)) {
        const commaSeparatedValues = value.map($938d2f63083c1136$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $938d2f63083c1136$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$938d2f63083c1136$var$encodeValue(value)}`;
}
function $938d2f63083c1136$var$encodeContextObject(context) {
    const searchParamsString = Object.entries(context).map($938d2f63083c1136$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
// src/messages.ts
var $938d2f63083c1136$var$SolanaErrorMessages = {
    [$938d2f63083c1136$export$8f39956700e64760]: "Account not found at address: $address",
    [$938d2f63083c1136$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$938d2f63083c1136$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$938d2f63083c1136$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$938d2f63083c1136$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$938d2f63083c1136$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$938d2f63083c1136$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$938d2f63083c1136$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$938d2f63083c1136$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$938d2f63083c1136$export$7ada2ae349acb674]: "$putativeOffCurveAddress is not a base58-encoded off-curve address.",
    [$938d2f63083c1136$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$938d2f63083c1136$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$938d2f63083c1136$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$938d2f63083c1136$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$938d2f63083c1136$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$938d2f63083c1136$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$938d2f63083c1136$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$938d2f63083c1136$export$6ad19ea5e363a944]: "Expected base58-encoded blockhash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$938d2f63083c1136$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$938d2f63083c1136$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$938d2f63083c1136$export$a2e9526594022372]: "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.",
    [$938d2f63083c1136$export$a9282ed13660c9f6]: "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].",
    [$938d2f63083c1136$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$938d2f63083c1136$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$938d2f63083c1136$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$938d2f63083c1136$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.",
    [$938d2f63083c1136$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$938d2f63083c1136$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$938d2f63083c1136$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$938d2f63083c1136$export$47278510a511031b]: "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].",
    [$938d2f63083c1136$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$938d2f63083c1136$export$cb77f5a0f0fa7f18]: "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].",
    [$938d2f63083c1136$export$2bb0703affb8fe68]: "Invalid discriminated union variant. Expected one of [$variants], got $value.",
    [$938d2f63083c1136$export$f6bf8a7c1f3defe4]: "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.",
    [$938d2f63083c1136$export$c89f43f0d783cd50]: "Invalid literal union variant. Expected one of [$variants], got $value.",
    [$938d2f63083c1136$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$938d2f63083c1136$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$938d2f63083c1136$export$8ed49819c26ad29f]: "Invalid UTF-8 byte sequence at offset $offset.",
    [$938d2f63083c1136$export$5810fa8bfc01906b]: "Invalid UTF-8 string. Found a lone surrogate at index $index.",
    [$938d2f63083c1136$export$f73fb8ecbd4b2395]: "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$938d2f63083c1136$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$938d2f63083c1136$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$938d2f63083c1136$export$160b1f6d4f97090b]: "Codec [$codecDescription] expected sentinel [$hexSentinel] to terminate the collection, but reached the end of the byte array without it.",
    [$938d2f63083c1136$export$5bdfee6423bc35ce]: "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].",
    [$938d2f63083c1136$export$7c7a00cd63be746a]: "The sentinel must not be empty.",
    [$938d2f63083c1136$export$66778002bb3d35e4]: "Codec [$codecDescription] cannot use the [$sizeStrategy] size strategy: the item codec has a fixed size of zero and consumes no bytes.",
    [$938d2f63083c1136$export$efbd199de191d2aa]: "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.",
    [$938d2f63083c1136$export$11a7243580452ad8]: "This decoder expected a byte array of exactly $expectedLength bytes, but $numExcessBytes unexpected excess bytes remained after decoding. Are you sure that you have chosen the correct decoder for this data?",
    [$938d2f63083c1136$export$917fb07617f2d1fb]: "Invalid pattern match value. The provided value does not match any of the specified patterns.",
    [$938d2f63083c1136$export$345850eef23c927d]: "Invalid pattern match bytes. The provided byte array does not match any of the specified patterns.",
    [$938d2f63083c1136$export$bc2b26beee0f9a0b]: "No random values implementation could be found.",
    [$938d2f63083c1136$export$7cb3af4590511eb4]: "Failed to send transaction$causeMessage",
    [$938d2f63083c1136$export$5dac493019b18473]: "Failed to send transactions$causeMessages",
    [$938d2f63083c1136$export$38e770f41f89279d]: "Failed to sign transaction$causeMessage",
    [$938d2f63083c1136$export$49ac0c4c9d061eec]: "Failed to sign transactions$causeMessages",
    [$938d2f63083c1136$export$2feecdeb7a6034df]: "Fixed-point operation `$operation` of kind `$kind` overflowed. Expected a raw bigint in [$min, $max], got $result.",
    [$938d2f63083c1136$export$ea486bd2871daf4e]: "Fixed-point division by zero for value of kind `$kind` ($signedness, $totalBits bits).",
    [$938d2f63083c1136$export$72468d0872763e95]: "`fractionalBits` ($fractionalBits) must not exceed `totalBits` ($totalBits).",
    [$938d2f63083c1136$export$929704b13825ef1d]: "Invalid `decimals`. Expected a non-negative integer, got $decimals.",
    [$938d2f63083c1136$export$92d7c36d7c6d6326]: "Invalid `fractionalBits`. Expected a non-negative integer, got $fractionalBits.",
    [$938d2f63083c1136$export$183ade6d1821d3b6]: "Invalid string `$input` for fixed-point value of kind `$kind`.",
    [$938d2f63083c1136$export$e7d6af6e57db8b2b]: "Invalid `totalBits`. Expected a positive integer, got $totalBits.",
    [$938d2f63083c1136$export$85a626151643ef3b]: "Invalid ratio $numerator/$denominator for fixed-point value of kind `$kind`. Denominator must be non-zero.",
    [$938d2f63083c1136$export$974c80374b7537fd]: "Fixed-point value of kind `$kind` has a malformed `raw` field. Expected a bigint, got `$raw`.",
    [$938d2f63083c1136$export$9e032cc8893e9cb9]: "Fixed-point `$operation` operation expected $expectedKind ($expectedSignedness, $expectedTotalBits bits, $expectedScale $expectedScaleLabel); got $actualKind ($actualSignedness, $actualTotalBits bits, $actualScale $actualScaleLabel).",
    [$938d2f63083c1136$export$8911b5c0a403a5af]: "Fixed-point operation `$operation` of kind `$kind` cannot be performed exactly; pass a rounding mode other than `strict` to allow a rounded result.",
    [$938d2f63083c1136$export$dfd6489d84297a17]: "Fixed-point codec of kind `$kind` requires `totalBits` to be a multiple of 8; got $totalBits.",
    [$938d2f63083c1136$export$b02d235d3b45fb86]: "Fixed-point value of kind `$kind` is out of range for $signedness $totalBits-bit storage. Expected a raw bigint in [$min, $max], got $raw.",
    [$938d2f63083c1136$export$1c659240f0b07a02]: "Filesystem operation `$operation` is not supported in this environment.",
    [$938d2f63083c1136$export$df0a6d6cbb0d96a1]: "Instruction requires an uninitialized account",
    [$938d2f63083c1136$export$ef486e0fcc8262b]: "Instruction tries to borrow reference for an account which is already borrowed",
    [$938d2f63083c1136$export$afcb9eeb4bf056b5]: "Instruction left account with an outstanding borrowed reference",
    [$938d2f63083c1136$export$3c4b9377ed4116a0]: "Program other than the account's owner changed the size of the account data",
    [$938d2f63083c1136$export$e170b44d99a3d17c]: "Account data too small for instruction",
    [$938d2f63083c1136$export$211b990ef3bd19ce]: "Instruction expected an executable account",
    [$938d2f63083c1136$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$938d2f63083c1136$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$938d2f63083c1136$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data",
    [$938d2f63083c1136$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$938d2f63083c1136$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$938d2f63083c1136$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$938d2f63083c1136$export$5abe2d1d040bf6cf]: "Custom program error: #$code",
    [$938d2f63083c1136$export$c390f45549d7336b]: "Instruction contains duplicate accounts",
    [$938d2f63083c1136$export$4db39a3a67e51db2]: "Instruction modifications of multiply-passed account differ",
    [$938d2f63083c1136$export$d13686e596713674]: "Executable accounts must be rent exempt",
    [$938d2f63083c1136$export$203fce7ce63eb278]: "Instruction changed executable accounts data",
    [$938d2f63083c1136$export$c65d87b69a4b86e5]: "Instruction changed the balance of an executable account",
    [$938d2f63083c1136$export$2ea2f2f9a9e26449]: "Instruction changed executable bit of an account",
    [$938d2f63083c1136$export$72e64aed285de589]: "Instruction modified data of an account it does not own",
    [$938d2f63083c1136$export$2b7e7e6bd3d5b8c4]: "Instruction spent from the balance of an account it does not own",
    [$938d2f63083c1136$export$ab2273c84ffc5d61]: "Generic instruction error",
    [$938d2f63083c1136$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$938d2f63083c1136$export$e343a153899b82e9]: "Account is immutable",
    [$938d2f63083c1136$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$938d2f63083c1136$export$4063fe8d5aed84a5]: "Incorrect program id for instruction",
    [$938d2f63083c1136$export$84ec8e94b54ae7d2]: "Insufficient funds for instruction",
    [$938d2f63083c1136$export$f9ae264f831e3bcf]: "Invalid account data for instruction",
    [$938d2f63083c1136$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$938d2f63083c1136$export$23cc359156888c7f]: "Invalid program argument",
    [$938d2f63083c1136$export$35a7a209cf9aaee8]: "Program returned invalid error code",
    [$938d2f63083c1136$export$a4193356408e9ff0]: "Invalid instruction data",
    [$938d2f63083c1136$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$938d2f63083c1136$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$938d2f63083c1136$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$938d2f63083c1136$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$938d2f63083c1136$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$938d2f63083c1136$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$938d2f63083c1136$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$938d2f63083c1136$export$ecdd3388f6a493b1]: "Missing required signature for instruction",
    [$938d2f63083c1136$export$fa2d8ac69bd6117e]: "Instruction illegally modified the program id of an account",
    [$938d2f63083c1136$export$2f331454431511bf]: "Insufficient account keys for instruction",
    [$938d2f63083c1136$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$938d2f63083c1136$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$938d2f63083c1136$export$67715a67add5645f]: "Program failed to compile",
    [$938d2f63083c1136$export$b1b9bf899899a525]: "Program failed to complete",
    [$938d2f63083c1136$export$aa03f185732dc00b]: "Instruction modified data of a read-only account",
    [$938d2f63083c1136$export$95d7c72146ee65c6]: "Instruction changed the balance of a read-only account",
    [$938d2f63083c1136$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$938d2f63083c1136$export$c9ece88629d0d2d8]: "Instruction modified rent epoch of an account",
    [$938d2f63083c1136$export$c2bfe7e903a0febb]: "Sum of account balances before and after instruction do not match",
    [$938d2f63083c1136$export$e45bdcd5a97f01d1]: "Instruction requires an initialized account",
    [$938d2f63083c1136$export$d308cb6df5c28ff6]: "The instruction failed with the error: $errorName",
    [$938d2f63083c1136$export$a070310f29fe959b]: "Unsupported program id",
    [$938d2f63083c1136$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$938d2f63083c1136$export$bcbc513a8682960f]: "Invalid instruction plan kind: $kind.",
    [$938d2f63083c1136$export$b22811c3929e985a]: "The provided instruction plan is empty.",
    [$938d2f63083c1136$export$f988935bbec3c348]: "No failed transaction plan result was found in the provided transaction plan result.",
    [$938d2f63083c1136$export$e4bc7cf62067d898]: "This transaction plan executor does not support non-divisible sequential plans. To support them, you may create your own executor such that multi-transaction atomicity is preserved \u2014 e.g. by targetting RPCs that support transaction bundles.",
    [$938d2f63083c1136$export$12d6d18d48ba64e9]: "The provided transaction plan failed to execute. See the `transactionPlanResult` attribute for more details. Note that the `cause` property is deprecated, and a future version will not set it.",
    [$938d2f63083c1136$export$58f34489822f32f1]: "The configured maximum of $maxInstructions instructions per transaction is invalid. It must be a positive integer no greater than the transaction format limit of $transactionInstructionLimit instructions per transaction. Provide a `maxInstructionsPerTransaction` (on the transaction planner) or `maxInstructions` (on the message packer) value between 1 and $transactionInstructionLimit.",
    [$938d2f63083c1136$export$9bfc7de894c3d9da]: "Planning this transaction message would require $numInstructions instructions, which exceeds the configured maximum of $maxInstructions instructions per transaction. This limit is configurable, and intended to leave headroom for inner instructions which are included in the maximum instruction limit for transactions. Increase `maxInstructionsPerTransaction` on the transaction planner (or `maxInstructions` on the message packer) to allow more instructions per transaction.",
    [$938d2f63083c1136$export$4758b9d97c7acd49]: "The provided message has insufficient capacity to accommodate the next instruction(s) in this plan. Expected at least $numBytesRequired free byte(s), got $numFreeBytes byte(s).",
    [$938d2f63083c1136$export$8f646bf76fb27ec0]: "Invalid transaction plan kind: $kind.",
    [$938d2f63083c1136$export$2e5fda8b40bc9396]: "No more instructions to pack; the message packer has completed the instruction plan.",
    [$938d2f63083c1136$export$ecfe9455a11db1e0]: "The message packer rejected the provided transaction message: $reason.",
    [$938d2f63083c1136$export$a55985b9459d2f3b]: "Unexpected instruction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$938d2f63083c1136$export$dba3fa3abd2194c6]: "Unexpected transaction plan. Expected $expectedKind plan, got $actualKind plan.",
    [$938d2f63083c1136$export$a751080bf117630f]: "Unexpected transaction plan result. Expected $expectedKind plan, got $actualKind plan.",
    [$938d2f63083c1136$export$9318fa904fe94ef2]: "Expected a successful transaction plan result. I.e. there is at least one failed or cancelled transaction in the plan.",
    [$938d2f63083c1136$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$938d2f63083c1136$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$938d2f63083c1136$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$938d2f63083c1136$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$938d2f63083c1136$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$938d2f63083c1136$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$938d2f63083c1136$export$8b0d360227f3435e]: "Invariant violation: This data publisher does not publish to the channel named `$channelName`. Supported channels include $supportedChannelNames.",
    [$938d2f63083c1136$export$d5b3c70e0e0f470a]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$938d2f63083c1136$export$a12ca71185bd51db]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$938d2f63083c1136$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$938d2f63083c1136$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$938d2f63083c1136$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$938d2f63083c1136$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$938d2f63083c1136$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$938d2f63083c1136$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$938d2f63083c1136$export$1b90c411626421b1]: "$__serverMessage",
    [$938d2f63083c1136$export$6ae475e85fe02aad]: "$__serverMessage",
    [$938d2f63083c1136$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$938d2f63083c1136$export$65235469ebe9845e]: "$__serverMessage",
    [$938d2f63083c1136$export$1e95c50f9776ce34]: "Epoch rewards period still active at slot $slot",
    [$938d2f63083c1136$export$8dfce16ef39ea58c]: "$__serverMessage",
    [$938d2f63083c1136$export$54dea2286c43ec1e]: "$__serverMessage",
    [$938d2f63083c1136$export$e71fbee92648fc61]: "$__serverMessage",
    [$938d2f63083c1136$export$35d837f314929752]: "Failed to query long-term storage; please try again",
    [$938d2f63083c1136$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$938d2f63083c1136$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$938d2f63083c1136$export$690667cf4da3ba9d]: "No slot history",
    [$938d2f63083c1136$export$eb4f7515ff6aa19d]: "No snapshot",
    [$938d2f63083c1136$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$938d2f63083c1136$export$86fc15c41ff3dc9c]: "Rewards cannot be found because slot $slot is not the epoch boundary. This may be due to gap in the queried node's local ledger or long-term storage",
    [$938d2f63083c1136$export$d21075fd06730e]: "$__serverMessage",
    [$938d2f63083c1136$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$938d2f63083c1136$export$d964b43bb02eacdf]: "$__serverMessage",
    [$938d2f63083c1136$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$938d2f63083c1136$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$938d2f63083c1136$export$f7685139153f9191]: "$__serverMessage",
    [$938d2f63083c1136$export$bc24f4f6bff910ad]: "The grind regex `/$source/` contains the character `$character`, which is not in the base58 alphabet and can never match a Solana address.",
    [$938d2f63083c1136$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$938d2f63083c1136$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$938d2f63083c1136$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$938d2f63083c1136$export$436df06ce5af77b3]: "The provided private key does not match the provided public key.",
    [$938d2f63083c1136$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$938d2f63083c1136$export$804a824ae398401e]: "Signatures can only be verified using an extractable public key. The bytes of the public key must be readable. If you imported the public key yourself, set `extractable` to `true`.",
    [$938d2f63083c1136$export$a33e1278cd08ba37]: "Writing a key pair to disk is not supported in this environment.",
    [$938d2f63083c1136$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$938d2f63083c1136$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$938d2f63083c1136$export$1cf7bba40d7d2361]: "$message",
    [$938d2f63083c1136$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$938d2f63083c1136$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$938d2f63083c1136$export$13efb168b2f8723b]: "Expected base58 encoded application domain to decode to a byte array of length 32. Actual length: $actualLength.",
    [$938d2f63083c1136$export$a722215db3dceeea]: "Attempted to sign an offchain message with an address that is not a signer for it",
    [$938d2f63083c1136$export$c2666c33001f9716]: "Expected base58-encoded application domain string of length in the range [32, 44]. Actual length: $actualLength.",
    [$938d2f63083c1136$export$bb317ddcc34ed03d]: "The content of the offchain message does not match the content that was expected. Expected content with a byte-length of $expectedBytes; got content with a byte-length of $actualBytes. The signer may have signed different data than was requested; do not trust its signature.",
    [$938d2f63083c1136$export$ac41328a8c021f1d]: "The signer addresses in this offchain message envelope do not match the list of required signers in the message preamble. These unexpected signers were present in the envelope: `[$unexpectedSigners]`. These required signers were missing from the envelope `[$missingSigners]`.",
    [$938d2f63083c1136$export$e095feafa627ab93]: "The message body provided has a byte-length of $actualBytes. The maximum allowable byte-length is $maxBytes",
    [$938d2f63083c1136$export$47bddc6d96d8aafe]: "Expected message format $expectedMessageFormat, got $actualMessageFormat",
    [$938d2f63083c1136$export$16aa99698ba98923]: "The message length specified in the message preamble is $specifiedLength bytes. The actual length of the message is $actualLength bytes.",
    [$938d2f63083c1136$export$24dfb058e3a278af]: "Offchain message content must be non-empty",
    [$938d2f63083c1136$export$ca446d431d3e0795]: "Offchain message must specify the address of at least one required signer",
    [$938d2f63083c1136$export$5de6608bb79088df]: "Offchain message envelope must reserve space for at least one signature",
    [$938d2f63083c1136$export$cdd46422e6064873]: "The offchain message preamble specifies $numRequiredSignatures required signature(s), got $signaturesLength.",
    [$938d2f63083c1136$export$7fb8ee8f1d153f7d]: "The offchain message lists different required signatories than was expected. Expected [$expectedAddresses]. Got [$actualAddresses]. The signer may have signed different data than was requested; do not trust its signature.",
    [$938d2f63083c1136$export$7be41df2aa4d6598]: "The signatories of this offchain message must be listed in lexicographical order",
    [$938d2f63083c1136$export$f4c0dc856ca8d3c6]: "An address must be listed no more than once among the signatories of an offchain message",
    [$938d2f63083c1136$export$5b7facf9eb8f4fc1]: "Offchain message is missing signatures for addresses: $addresses.",
    [$938d2f63083c1136$export$3abfcff57e9c6b21]: "Offchain message signature verification failed. Signature mismatch for required signatories [$signatoriesWithInvalidSignatures]. Missing signatures for signatories [$signatoriesWithMissingSignatures]",
    [$938d2f63083c1136$export$1bd1351c3c04dffb]: "The message body provided contains characters whose codes fall outside the allowed range. In order to ensure clear-signing compatiblity with hardware wallets, the message may only contain line feeds and characters in the range [\\x20-\\x7e].",
    [$938d2f63083c1136$export$c0e832e2b8c6c75c]: "Expected offchain message version $expectedVersion. Got $actualVersion.",
    [$938d2f63083c1136$export$7b86ea017e7c65a8]: "This version of Kit does not support decoding offchain messages with version $unsupportedVersion. The current max supported version is 0.",
    [$938d2f63083c1136$export$6a51b1679eb0ed12]: "The provided account could not be identified as an account from the $programName program.",
    [$938d2f63083c1136$export$a35cab87219e2726]: "The provided instruction could not be identified as an instruction from the $programName program.",
    [$938d2f63083c1136$export$7a470f3bbbd2358]: "The provided instruction is missing some accounts. Expected at least $expectedAccountMetas account(s), got $actualAccountMetas.",
    [$938d2f63083c1136$export$85e194a892d0127e]: "Expected resolved instruction input '$inputName' to be non-null.",
    [$938d2f63083c1136$export$6b5e7fa31b0b2af0]: "Expected resolved instruction input '$inputName' to be a `TransactionSigner` because the instruction requires this account to sign the transaction. If its signature is provided by other means, use `createNoopSigner()` from `@solana/signers` to satisfy this requirement.",
    [$938d2f63083c1136$export$a46c9b68bd6e4f3c]: "Expected resolved instruction input '$inputName' to be of type `$expectedType`.",
    [$938d2f63083c1136$export$5397ee6ba4d6d1bc]: "Unrecognized account type '$accountType' for the $programName program.",
    [$938d2f63083c1136$export$28c1d89d6f82797c]: "Unrecognized instruction type '$instructionType' for the $programName program.",
    [$938d2f63083c1136$export$c32108b180210fc5]: "The notification name must end in 'Notifications' and the API must supply a subscription plan creator function for the notification '$notificationName'.",
    [$938d2f63083c1136$export$ae8da83a78732501]: "WebSocket was closed before payload could be added to the send buffer",
    [$938d2f63083c1136$export$73f01f46f9a97cf0]: "WebSocket connection closed",
    [$938d2f63083c1136$export$5293460f390d6127]: "WebSocket failed to connect",
    [$938d2f63083c1136$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$938d2f63083c1136$export$119023a74b281384]: "Could not find an API plan for RPC method: `$method`",
    [$938d2f63083c1136$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$938d2f63083c1136$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$938d2f63083c1136$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$938d2f63083c1136$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$938d2f63083c1136$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$938d2f63083c1136$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$938d2f63083c1136$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$938d2f63083c1136$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$938d2f63083c1136$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$938d2f63083c1136$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$938d2f63083c1136$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$938d2f63083c1136$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$938d2f63083c1136$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$938d2f63083c1136$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `TransactionWithSingleSendingSigner` transaction.",
    [$938d2f63083c1136$export$96a986fd198910e9]: "The wallet account $address cannot be used to create a transaction signer because it does not implement either the `solana:signTransaction` or `solana:signAndSendTransaction` feature. At least one of these features is required. The account supports the following features: $supportedFeatures.",
    [$938d2f63083c1136$export$1d51c4c8b2c49e09]: "Wallet account signers do not support signing multiple messages/transactions in a single operation",
    [$938d2f63083c1136$export$15c87714768dc01d]: "This `ReactiveStreamStore` does not support retry. Use `createReactiveStoreFromDataPublisherFactory` to construct a retryable store.",
    [$938d2f63083c1136$export$55e9fe02b4fcdcf4]: "The stream store closed in an error state but did not report an error.",
    [$938d2f63083c1136$export$b6497aaa1c3cb4a7]: "Cannot export a non-extractable key.",
    [$938d2f63083c1136$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$938d2f63083c1136$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$938d2f63083c1136$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$938d2f63083c1136$export$69c08c51e1841f29]: "No key export implementation could be found.",
    [$938d2f63083c1136$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$938d2f63083c1136$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$938d2f63083c1136$export$a73c064bb32a7c36]: "No signature verification implementation could be found.",
    [$938d2f63083c1136$export$8b23617676679e2d]: "Timestamp value must be in the range [-(2n ** 63n), (2n ** 63n) - 1]. `$value` given",
    [$938d2f63083c1136$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$938d2f63083c1136$export$a746609ecc2f6acf]: "Account in use",
    [$938d2f63083c1136$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$938d2f63083c1136$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$938d2f63083c1136$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$938d2f63083c1136$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$938d2f63083c1136$export$e108dd5343c4c11]: "Blockhash not found",
    [$938d2f63083c1136$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$938d2f63083c1136$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$938d2f63083c1136$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$938d2f63083c1136$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$938d2f63083c1136$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$938d2f63083c1136$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$938d2f63083c1136$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$938d2f63083c1136$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$938d2f63083c1136$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$938d2f63083c1136$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$938d2f63083c1136$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$938d2f63083c1136$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$938d2f63083c1136$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$938d2f63083c1136$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$938d2f63083c1136$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$938d2f63083c1136$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$938d2f63083c1136$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$938d2f63083c1136$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$938d2f63083c1136$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$938d2f63083c1136$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$938d2f63083c1136$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$938d2f63083c1136$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$938d2f63083c1136$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$938d2f63083c1136$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$938d2f63083c1136$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$938d2f63083c1136$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$938d2f63083c1136$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$938d2f63083c1136$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$938d2f63083c1136$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$938d2f63083c1136$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$938d2f63083c1136$export$36c2547c3c4d823f]: "Attempted to sign a transaction with an address that is not a signer for it",
    [$938d2f63083c1136$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$938d2f63083c1136$export$de92784c954d1b84]: "Transaction has no expected signers therefore it cannot be encoded",
    [$938d2f63083c1136$export$a1cb45d281e4f256]: "Transaction compute unit limit must be an integer in the range [0, $maxComputeUnitLimit]. `$computeUnitLimit` given",
    [$938d2f63083c1136$export$980469bdb5d5bd4f]: "Transaction size $transactionSize exceeds limit of $transactionSizeLimit bytes",
    [$938d2f63083c1136$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$938d2f63083c1136$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$938d2f63083c1136$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$938d2f63083c1136$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$938d2f63083c1136$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$938d2f63083c1136$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$938d2f63083c1136$export$4e4582c633fc423e]: "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more",
    [$938d2f63083c1136$export$7a52a9f8bedc82c0]: "Failed to estimate the loaded accounts data size for this transaction message. The RPC did not return a `loadedAccountsDataSize` value from simulation. This value is required for version 1 transactions",
    [$938d2f63083c1136$export$923893d5c076a47c]: "Transaction failed when it was simulated in order to estimate the compute unit consumption. The compute unit estimate provided is for a transaction that failed when simulated and may not be representative of the compute units this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$938d2f63083c1136$export$7774c611982e038]: "Transaction failed when it was simulated in order to estimate its resource limits. The resource limit estimates provided are for a transaction that failed when simulated and may not be representative of the resources this transaction would consume if successful. Inspect the `cause` property of this error to learn more",
    [$938d2f63083c1136$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$938d2f63083c1136$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$938d2f63083c1136$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$938d2f63083c1136$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$938d2f63083c1136$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$938d2f63083c1136$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$938d2f63083c1136$export$b55a3eb3d894ad9f]: "The transaction message expected the transaction to have $numRequiredSignatures signatures, got $signaturesLength.",
    [$938d2f63083c1136$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$938d2f63083c1136$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given",
    [$938d2f63083c1136$export$8ff97fea1326b6e7]: "This version of Kit does not support decoding transactions with version $unsupportedVersion. The current max supported version is 1.",
    [$938d2f63083c1136$export$204c62c0e8d2efcc]: "The transaction has a durable nonce lifetime (with nonce `$nonce`), but the nonce account address is in a lookup table. The lifetime constraint cannot be constructed without fetching the lookup tables for the transaction.",
    [$938d2f63083c1136$export$ee92f61088a1066a]: "Invalid transaction config mask: $mask. Bits 0 and 1 must match (both set or both unset)",
    [$938d2f63083c1136$export$102de27de91bf32b]: "Transaction message bytes are malformed: $messageBytes",
    [$938d2f63083c1136$export$15d93ee95a0fbfee]: "Transaction message bytes are empty, so the transaction cannot be encoded",
    [$938d2f63083c1136$export$4641ca456c9ac65a]: "Transaction bytes are empty, so no transaction can be decoded",
    [$938d2f63083c1136$export$db5d0ad0319baeab]: "Transaction version 0 must be encoded with signatures first. This transaction was encoded with first byte $firstByte, which is expected to be a signature count for v0 transactions.",
    [$938d2f63083c1136$export$c94bf194991c6a40]: "The provided transaction bytes expect that there should be $numExpectedSignatures signatures, but the bytes are not long enough to contain a transaction message with this many signatures. The provided bytes are $transactionBytesLength bytes long.",
    [$938d2f63083c1136$export$84810c56288ac788]: "Transaction heap size must be an integer multiple of $multipleOf bytes in the range [$minHeapSize, $maxHeapSize]. `$heapSize` given",
    [$938d2f63083c1136$export$ce102cf7a4dc8c26]: "The transaction has a durable nonce lifetime, but the nonce account index is invalid. Expected a nonce account index less than $numberOfStaticAccounts, got $nonceAccountIndex.",
    [$938d2f63083c1136$export$bb954aa95380cc07]: "The transaction config value for $configName has the incorrect kind. Expected $expectedKind, got $actualKind.",
    [$938d2f63083c1136$export$70cf12a7af68a7bb]: "The transaction does not have the same number of instruction headers and instruction payloads. Got $numInstructionHeaders instruction headers, and $numInstructionPayloads instruction payloads.",
    [$938d2f63083c1136$export$3da8c24b63df7026]: "Transaction has $actualCount unique signer addresses but the maximum allowed is $maxAllowed",
    [$938d2f63083c1136$export$24ca3e569f030a48]: "Transaction has $actualCount unique account addresses but the maximum allowed is $maxAllowed",
    [$938d2f63083c1136$export$7d52b2fdc6c6f4fd]: "Transaction has $actualCount instructions but the maximum allowed is $maxAllowed",
    [$938d2f63083c1136$export$d463b452862201a4]: "The instruction at index $instructionIndex has $actualCount account references but the maximum allowed is $maxAllowed",
    [$938d2f63083c1136$export$a0d8e792371f738d]: "Could not find an account address at index $index while decompiling an instruction",
    [$938d2f63083c1136$export$a05704ad9908bda9]: "`getTransaction` responses fetched with `encoding: 'jsonParsed'` cannot be decoded. Re-fetch the transaction with `encoding: 'base64'`, `'base58'`, or `'json'`",
    [$938d2f63083c1136$export$302ce5f895eb18ab]: "Could not recognize the shape of this `getTransaction` response. Expected a response fetched with `encoding: 'base64'`, `'base58'`, or `'json'`",
    [$938d2f63083c1136$export$53a95e64cc3268a]: "`$hookName` requires the following capabilities to be installed on the client: [$capabilities]. $providerHint",
    [$938d2f63083c1136$export$100e4d6784b74743]: "`$hookName` was called outside of a `ClientProvider`. Mount a `<ClientProvider client={client}>` in the ancestor tree.",
    [$938d2f63083c1136$export$ece10101ca3fdef]: "The subscription closed in an error state but did not report an error.",
    [$938d2f63083c1136$export$eff143d04ba1c763]: "Cannot $operation: no wallet connected",
    [$938d2f63083c1136$export$c312471e35f2eb26]: "No signing wallet connected (status: $status)",
    [$938d2f63083c1136$export$199c235749811d11]: "Connected wallet does not support signing",
    [$938d2f63083c1136$export$26183083c720a8a4]: 'Account $address is not available in wallet "$walletName"',
    [$938d2f63083c1136$export$93808c9da7bf7aff]: 'Wallet "$walletName" did not return a valid signature of the requested message for account $address',
    [$938d2f63083c1136$export$4324114557ad2da1]: 'Wallet "$walletName" returned $actual outputs from `$featureName`, but $expected were requested',
    [$938d2f63083c1136$export$91279c3e80690072]: 'Wallet "$walletName" returned an invalid sign-in output for account $address'
};
// src/message-formatter.ts
var $938d2f63083c1136$var$INSTRUCTION_ERROR_RANGE_SIZE = 1e3;
var $938d2f63083c1136$var$START_INDEX = "i";
var $938d2f63083c1136$var$TYPE = "t";
function $938d2f63083c1136$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $938d2f63083c1136$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    let state;
    function commitStateUpTo(endIndex) {
        if (state[$938d2f63083c1136$var$TYPE] === 2 /* Variable */ ) {
            const variableName = messageFormatString.slice(state[$938d2f63083c1136$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${context[variableName]}` : `$${variableName}`);
        } else if (state[$938d2f63083c1136$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$938d2f63083c1136$var$START_INDEX], endIndex));
    }
    const fragments = [];
    messageFormatString.split("").forEach((char, ii)=>{
        if (ii === 0) {
            state = {
                [$938d2f63083c1136$var$START_INDEX]: 0,
                [$938d2f63083c1136$var$TYPE]: messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ 
            };
            return;
        }
        let nextState;
        switch(state[$938d2f63083c1136$var$TYPE]){
            case 0 /* EscapeSequence */ :
                nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 1 /* Text */ 
                };
                break;
            case 1 /* Text */ :
                if (char === "\\") nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 2 /* Variable */ 
                };
                break;
            case 2 /* Variable */ :
                if (char === "\\") nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 2 /* Variable */ 
                };
                else if (!char.match(/\w/)) nextState = {
                    [$938d2f63083c1136$var$START_INDEX]: ii,
                    [$938d2f63083c1136$var$TYPE]: 1 /* Text */ 
                };
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    let message = fragments.join("");
    if (code >= $938d2f63083c1136$export$d308cb6df5c28ff6 && code < $938d2f63083c1136$export$d308cb6df5c28ff6 + $938d2f63083c1136$var$INSTRUCTION_ERROR_RANGE_SIZE && "index" in context) message += ` (instruction #${context.index + 1})`;
    return message;
}
function $938d2f63083c1136$var$getErrorMessage(code, context = {}) {
    {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode -- ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` '${$938d2f63083c1136$var$encodeContextObject(context)}'`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $938d2f63083c1136$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $938d2f63083c1136$export$8349fd9adaaed269 = class extends Error {
    /**
   * Indicates the root cause of this {@link SolanaError}, if any.
   *
   * For example, a transaction error might have an instruction error as its root cause. In this
   * case, you will be able to access the instruction error on the transaction error as `cause`.
   */ cause = this.cause;
    /**
   * Contains context that can assist in understanding or recovering from a {@link SolanaError}.
   */ context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) Object.entries(Object.getOwnPropertyDescriptors(contextAndErrorOptions)).forEach(([name, descriptor])=>{
            if (name === "cause") errorOptions = {
                cause: descriptor.value
            };
            else {
                if (context === void 0) context = {
                    __code: code
                };
                Object.defineProperty(context, name, descriptor);
            }
        });
        const message = $938d2f63083c1136$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = Object.freeze(context === void 0 ? {
            __code: code
        } : context);
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $938d2f63083c1136$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $938d2f63083c1136$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $938d2f63083c1136$export$8349fd9adaaed269(errorCode, errorContext);
    $938d2f63083c1136$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $938d2f63083c1136$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/solana-sdk/blob/master/instruction-error/src/lib.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $938d2f63083c1136$export$4e38d43e41953f9e(index, instructionError) {
    const numberIndex = Number(index);
    return $938d2f63083c1136$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $938d2f63083c1136$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: numberIndex,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $938d2f63083c1136$export$5abe2d1d040bf6cf) return {
                code: Number(rpcErrorContext),
                index: numberIndex
            };
            return {
                index: numberIndex
            };
        },
        orderedErrorNames: $938d2f63083c1136$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $938d2f63083c1136$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $938d2f63083c1136$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $938d2f63083c1136$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $938d2f63083c1136$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $938d2f63083c1136$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $938d2f63083c1136$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $938d2f63083c1136$export$e3a4007020a2e8f5) return {
                index: Number(rpcErrorContext)
            };
            else if (errorCode === $938d2f63083c1136$export$2ecc275dffbc087c || errorCode === $938d2f63083c1136$export$1cd0de5dfcdeb99d) return {
                accountIndex: Number(rpcErrorContext.account_index)
            };
        },
        orderedErrorNames: $938d2f63083c1136$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $938d2f63083c1136$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $938d2f63083c1136$export$1f67f8d128316a6d(putativeErrorResponse) {
    let out;
    if ($938d2f63083c1136$var$isRpcErrorResponse(putativeErrorResponse)) {
        const { code: rawCode, data: data, message: message } = putativeErrorResponse;
        const code = Number(rawCode);
        if (code === $938d2f63083c1136$export$426cc73f5ad00f38) {
            const { err: err, ...preflightErrorContext } = data;
            const causeObject = err ? {
                cause: $938d2f63083c1136$export$c10ce7a2fd9c66f0(err)
            } : null;
            out = new $938d2f63083c1136$export$8349fd9adaaed269($938d2f63083c1136$export$426cc73f5ad00f38, {
                ...preflightErrorContext,
                ...causeObject
            });
        } else {
            let errorContext;
            switch(code){
                case $938d2f63083c1136$export$afa40fd3fc01204:
                case $938d2f63083c1136$export$2981978a530b1a7c:
                case $938d2f63083c1136$export$23cb4efd59427895:
                case $938d2f63083c1136$export$5ec955cc8b7e8cf9:
                case $938d2f63083c1136$export$e09e3905081e44fe:
                case $938d2f63083c1136$export$1b90c411626421b1:
                case $938d2f63083c1136$export$6ae475e85fe02aad:
                case $938d2f63083c1136$export$bfbf8b75e865efa0:
                case $938d2f63083c1136$export$65235469ebe9845e:
                case $938d2f63083c1136$export$8dfce16ef39ea58c:
                case $938d2f63083c1136$export$54dea2286c43ec1e:
                case $938d2f63083c1136$export$e71fbee92648fc61:
                case $938d2f63083c1136$export$d21075fd06730e:
                case $938d2f63083c1136$export$d964b43bb02eacdf:
                case $938d2f63083c1136$export$f7685139153f9191:
                    errorContext = {
                        __serverMessage: message
                    };
                    break;
                default:
                    if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
            }
            out = new $938d2f63083c1136$export$8349fd9adaaed269(code, errorContext);
        }
    } else {
        const message = typeof putativeErrorResponse === "object" && putativeErrorResponse !== null && "message" in putativeErrorResponse && typeof putativeErrorResponse.message === "string" ? putativeErrorResponse.message : "Malformed JSON-RPC error with no message attribute";
        out = new $938d2f63083c1136$export$8349fd9adaaed269($938d2f63083c1136$export$1cf7bba40d7d2361, {
            error: putativeErrorResponse,
            message: message
        });
    }
    $938d2f63083c1136$export$4608fd6508cb51(out, $938d2f63083c1136$export$1f67f8d128316a6d);
    return out;
}
function $938d2f63083c1136$var$isRpcErrorResponse(value) {
    return typeof value === "object" && value !== null && "code" in value && "message" in value && (typeof value.code === "number" || typeof value.code === "bigint") && typeof value.message === "string";
}
// src/simulation-errors.ts
function $938d2f63083c1136$export$ddd98780b31b44b0(error) {
    const simulationCodes = [
        $938d2f63083c1136$export$426cc73f5ad00f38,
        $938d2f63083c1136$export$923893d5c076a47c,
        $938d2f63083c1136$export$7774c611982e038
    ];
    if ($938d2f63083c1136$export$cfead212e52d9961(error) && !!error.cause && simulationCodes.includes(error.context.__code)) return error.cause;
    return error;
}
 //# sourceMappingURL=index.browser.mjs.map


// src/add-codec-sentinel.ts
// src/bytes.ts
var $9ad1ed5438114d10$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
function $9ad1ed5438114d10$export$4c6b868113605df3(bytes, length) {
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
}
var $9ad1ed5438114d10$export$11b3146a4f4702ef = (bytes, length)=>$9ad1ed5438114d10$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $9ad1ed5438114d10$export$1b62aef2a79e6b21(data, bytes, offset) {
    const slice = (offset === 0 || offset <= -data.byteLength) && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    return $9ad1ed5438114d10$export$c663ab80cce302c5(slice, bytes);
}
function $9ad1ed5438114d10$export$c663ab80cce302c5(bytes1, bytes2) {
    return bytes1.length === bytes2.length && bytes1.every((value, index)=>value === bytes2[index]);
}
function $9ad1ed5438114d10$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $9ad1ed5438114d10$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($9ad1ed5438114d10$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $9ad1ed5438114d10$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $9ad1ed5438114d10$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($9ad1ed5438114d10$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $9ad1ed5438114d10$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $9ad1ed5438114d10$export$4e85b7423fd6bc55(codec) {
    if (!$9ad1ed5438114d10$export$f9d60229c95384d4(codec)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$93561b31b951410d));
}
function $9ad1ed5438114d10$export$d76fd0b6e42f051a(codec) {
    return !$9ad1ed5438114d10$export$f9d60229c95384d4(codec);
}
function $9ad1ed5438114d10$export$6bf5fc425e413c8a(codec) {
    if (!$9ad1ed5438114d10$export$d76fd0b6e42f051a(codec)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$3417da5bc6bcb45));
}
function $9ad1ed5438114d10$export$b88681b853abde79(encoder, decoder) {
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(encoder) !== $9ad1ed5438114d10$export$f9d60229c95384d4(decoder)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$c4c73ab3c0833591));
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(encoder) && $9ad1ed5438114d10$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$9ad1ed5438114d10$export$f9d60229c95384d4(encoder) && !$9ad1ed5438114d10$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/add-codec-sentinel.ts
function $9ad1ed5438114d10$export$e98b1308839de22(encoder, sentinel) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        if ($9ad1ed5438114d10$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$a9282ed13660c9f6), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $9ad1ed5438114d10$var$hexBytes(encoderBytes),
            hexSentinel: $9ad1ed5438114d10$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(encoder)) return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    });
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        ...encoder.maxSize != null ? {
            maxSize: encoder.maxSize + sentinel.length
        } : {},
        getSizeFromValue: (value)=>encoder.getSizeFromValue(value) + sentinel.length,
        write: write
    });
}
function $9ad1ed5438114d10$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    const read = (bytes, offset)=>{
        const candidateBytes = offset === 0 || offset <= -bytes.byteLength ? bytes : bytes.slice(offset);
        const sentinelIndex = $9ad1ed5438114d10$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$5bdfee6423bc35ce), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $9ad1ed5438114d10$var$hexBytes(candidateBytes),
            hexSentinel: $9ad1ed5438114d10$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        const preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(decoder)) return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    });
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        ...decoder.maxSize != null ? {
            maxSize: decoder.maxSize + sentinel.length
        } : {},
        read: read
    });
}
function $9ad1ed5438114d10$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$e98b1308839de22(codec, sentinel), $9ad1ed5438114d10$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $9ad1ed5438114d10$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex((byte, index, arr)=>{
        if (sentinel.length === 1) return byte === sentinel[0];
        return $9ad1ed5438114d10$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $9ad1ed5438114d10$var$hexBytes(bytes) {
    return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
}
function $9ad1ed5438114d10$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $9ad1ed5438114d10$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $9ad1ed5438114d10$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $9ad1ed5438114d10$export$37e5b12cb5a8d560(encoder, prefix) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(prefix) && $9ad1ed5438114d10$export$f9d60229c95384d4(encoder)) return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    });
    const prefixMaxSize = $9ad1ed5438114d10$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const encoderMaxSize = $9ad1ed5438114d10$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : encoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (value)=>{
            const encoderSize = $9ad1ed5438114d10$export$30f3257599397621(value, encoder);
            return $9ad1ed5438114d10$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    });
}
function $9ad1ed5438114d10$export$fe2b33c81523b294(decoder, prefix) {
    const read = (bytes, offset)=>{
        const [bigintSize, decoderOffset] = prefix.read(bytes, offset);
        const size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $9ad1ed5438114d10$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(prefix) && $9ad1ed5438114d10$export$f9d60229c95384d4(decoder)) return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    });
    const prefixMaxSize = $9ad1ed5438114d10$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const decoderMaxSize = $9ad1ed5438114d10$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : decoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $9ad1ed5438114d10$export$ec85c1caba397ab2(codec, prefix) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$37e5b12cb5a8d560(codec, prefix), $9ad1ed5438114d10$export$fe2b33c81523b294(codec, prefix));
}
// src/array-buffers.ts
function $9ad1ed5438114d10$export$8b22b05f429b130c(bytes, offset, length) {
    let bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    let buffer;
    if (typeof SharedArrayBuffer === "undefined") buffer = bytes.buffer;
    else if (bytes.buffer instanceof SharedArrayBuffer) {
        buffer = new ArrayBuffer(bytes.length);
        new Uint8Array(buffer).set(new Uint8Array(bytes));
        bytesOffset = offset ?? 0;
    } else buffer = bytes.buffer;
    return (bytesOffset === 0 || bytesOffset === -buffer.byteLength) && bytesLength === buffer.byteLength ? buffer : buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
function $9ad1ed5438114d10$export$9fde90fcc5ed41ea(decoder) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read (bytes, offset) {
            const [value, newOffset] = decoder.read(bytes, offset);
            if (bytes.length > newOffset) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$11a7243580452ad8), {
                expectedLength: newOffset,
                numExcessBytes: bytes.length - newOffset
            });
            return [
                value,
                newOffset
            ];
        }
    });
}
// src/fix-codec-size.ts
function $9ad1ed5438114d10$export$cbdfce031443a1(encoder, fixedBytes) {
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $9ad1ed5438114d10$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $9ad1ed5438114d10$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($9ad1ed5438114d10$export$f9d60229c95384d4(decoder)) bytes = $9ad1ed5438114d10$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $9ad1ed5438114d10$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$cbdfce031443a1(codec, fixedBytes), $9ad1ed5438114d10$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $9ad1ed5438114d10$export$92407871fbff8926(encoder, config) {
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$9ad1ed5438114d10$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $9ad1ed5438114d10$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $9ad1ed5438114d10$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $9ad1ed5438114d10$export$24667feddece166a(decoder, config) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$9ad1ed5438114d10$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $9ad1ed5438114d10$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $9ad1ed5438114d10$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $9ad1ed5438114d10$export$8170ddca0f3f53ea(codec, config) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$92407871fbff8926(codec, config), $9ad1ed5438114d10$export$24667feddece166a(codec, config));
}
function $9ad1ed5438114d10$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $9ad1ed5438114d10$export$d41c2ca858573bc6(encoder, resize) {
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $9ad1ed5438114d10$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $9ad1ed5438114d10$export$7369e12a03366140(decoder, resize) {
    if ($9ad1ed5438114d10$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $9ad1ed5438114d10$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $9ad1ed5438114d10$export$aff234b7657ae683(codec, resize) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$d41c2ca858573bc6(codec, resize), $9ad1ed5438114d10$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $9ad1ed5438114d10$export$66b1746799cd3030(encoder, offset) {
    return $9ad1ed5438114d10$export$92407871fbff8926($9ad1ed5438114d10$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $9ad1ed5438114d10$export$770586d1e6f1e5b(encoder, offset) {
    return $9ad1ed5438114d10$export$92407871fbff8926($9ad1ed5438114d10$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $9ad1ed5438114d10$export$d88f5bbaa5c2e177(decoder, offset) {
    return $9ad1ed5438114d10$export$24667feddece166a($9ad1ed5438114d10$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $9ad1ed5438114d10$export$57a7baba87e0aed9(decoder, offset) {
    return $9ad1ed5438114d10$export$24667feddece166a($9ad1ed5438114d10$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $9ad1ed5438114d10$export$d6ed5bbf596a5505(codec, offset) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$66b1746799cd3030(codec, offset), $9ad1ed5438114d10$export$d88f5bbaa5c2e177(codec, offset));
}
function $9ad1ed5438114d10$export$b11ce69168faaa31(codec, offset) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$770586d1e6f1e5b(codec, offset), $9ad1ed5438114d10$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $9ad1ed5438114d10$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength, targetOffset = 0) {
    while(sourceOffset < --sourceLength){
        const leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $9ad1ed5438114d10$export$290b4b66fdcc682c(encoder) {
    $9ad1ed5438114d10$export$4e85b7423fd6bc55(encoder);
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            $9ad1ed5438114d10$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    });
}
function $9ad1ed5438114d10$export$1dded7e9fb3087ff(decoder) {
    $9ad1ed5438114d10$export$4e85b7423fd6bc55(decoder);
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reversedBytes = bytes.slice();
            $9ad1ed5438114d10$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $9ad1ed5438114d10$export$e1ef688f83355e2e(codec) {
    return $9ad1ed5438114d10$export$b88681b853abde79($9ad1ed5438114d10$export$290b4b66fdcc682c(codec), $9ad1ed5438114d10$export$1dded7e9fb3087ff(codec));
}
// src/tap-codec.ts
function $9ad1ed5438114d10$export$bea9f1c8669e4c23(encoder, tap) {
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            tap(value);
            return encoder.write(value, bytes, offset);
        }
    });
}
function $9ad1ed5438114d10$export$2ad7590b73e16ec2(decoder, tap) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            tap(value);
            return [
                value,
                newOffset
            ];
        }
    });
}
function $9ad1ed5438114d10$export$9caae6c4e296e462(codec, encodeTap, decodeTap) {
    return $9ad1ed5438114d10$export$a4cf2f585987cc8({
        ...codec,
        read: decodeTap ? (bytes, offset)=>{
            const [value, newOffset] = codec.read(bytes, offset);
            decodeTap(value);
            return [
                value,
                newOffset
            ];
        } : codec.read,
        write: (value, bytes, offset)=>{
            encodeTap(value);
            return codec.write(value, bytes, offset);
        }
    });
}
// src/tap-codec-bytes.ts
function $9ad1ed5438114d10$export$2ecb4599fe73977a(encoder, tap) {
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const postOffset = encoder.write(value, bytes, offset);
            tap(bytes, offset, postOffset);
            return postOffset;
        }
    });
}
function $9ad1ed5438114d10$export$7941707fc05d3802(decoder, tap) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            tap(bytes, offset);
            return decoder.read(bytes, offset);
        }
    });
}
function $9ad1ed5438114d10$export$7902cd12c3caacf9(codec, encodeTap, decodeTap) {
    return $9ad1ed5438114d10$export$a4cf2f585987cc8({
        ...codec,
        read: decodeTap ? (bytes, offset)=>{
            decodeTap(bytes, offset);
            return codec.read(bytes, offset);
        } : codec.read,
        write: (value, bytes, offset)=>{
            const postOffset = codec.write(value, bytes, offset);
            encodeTap(bytes, offset, postOffset);
            return postOffset;
        }
    });
}
// src/transform-codec.ts
function $9ad1ed5438114d10$export$30169aca64409a56(encoder, unmap) {
    return $9ad1ed5438114d10$export$4e76eeb6df88c889({
        ...$9ad1ed5438114d10$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $9ad1ed5438114d10$export$605b10ee38669daa(decoder, map) {
    return $9ad1ed5438114d10$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $9ad1ed5438114d10$export$59b20038bbe52b5f(codec, unmap, map) {
    return $9ad1ed5438114d10$export$a4cf2f585987cc8({
        ...$9ad1ed5438114d10$export$30169aca64409a56(codec, unmap),
        read: map ? $9ad1ed5438114d10$export$605b10ee38669daa(codec, map).read : codec.read
    });
}
 //# sourceMappingURL=index.browser.mjs.map




// src/assertions.ts
function $a3b9c16b0e3e8cb3$export$d81fb78fd5af226e(alphabet4, testValue, givenValue = testValue) {
    if (!testValue.match(new RegExp(`^[${alphabet4}]*$`))) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$89b582b06852d433), {
        alphabet: alphabet4,
        base: alphabet4.length,
        value: givenValue
    });
}
function $a3b9c16b0e3e8cb3$export$af0c8129dd18ef38(value) {
    const isWellFormed = value.isWellFormed;
    if (typeof isWellFormed === "function" && isWellFormed.call(value)) return;
    for(let index = 0; index < value.length; index++){
        const unit = value.charCodeAt(index);
        if (unit < 55296 || unit > 57343) continue;
        const next = value.charCodeAt(index + 1);
        if (unit <= 56319 && next >= 56320 && next <= 57343) {
            index++;
            continue;
        }
        throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$5810fa8bfc01906b), {
            index: index,
            value: value
        });
    }
}
function $a3b9c16b0e3e8cb3$export$a9d9fed816ededdc(bytes, offset = 0) {
    const length = bytes.length;
    let index = offset;
    while(index < length){
        const lead = bytes[index];
        let count;
        let min = 128;
        let max = 191;
        if (lead < 128) {
            index++;
            continue;
        } else if (lead >= 194 && lead <= 223) count = 1;
        else if (lead >= 224 && lead <= 239) {
            count = 2;
            if (lead === 224) min = 160;
            if (lead === 237) max = 159;
        } else if (lead >= 240 && lead <= 244) {
            count = 3;
            if (lead === 240) min = 144;
            if (lead === 244) max = 143;
        } else return index;
        const start = index;
        index++;
        for(let i = 0; i < count; i++, index++){
            if (index >= length) return start;
            const byte = bytes[index];
            const inRange = i === 0 ? byte >= min && byte <= max : byte >= 128 && byte <= 191;
            if (!inRange) return start;
        }
    }
    return -1;
}
function $a3b9c16b0e3e8cb3$export$3d0f2c0a8c4cf2f3(bytes, offset = 0) {
    const malformedOffset = $a3b9c16b0e3e8cb3$export$a9d9fed816ededdc(bytes, offset);
    if (malformedOffset !== -1) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$8ed49819c26ad29f), {
        bytes: bytes,
        offset: malformedOffset
    });
}
var $a3b9c16b0e3e8cb3$export$604e39a60e9aaee6 = (alphabet4)=>{
    return (0, $9ad1ed5438114d10$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            const [leadingZeroes, tailChars] = $a3b9c16b0e3e8cb3$var$partitionLeadingZeroes(value, alphabet4[0]);
            if (!tailChars) return value.length;
            const base10Number = $a3b9c16b0e3e8cb3$var$getBigIntFromBaseX(tailChars, alphabet4);
            return leadingZeroes.length + Math.ceil(base10Number.toString(16).length / 2);
        },
        write (value, bytes, offset) {
            $a3b9c16b0e3e8cb3$export$d81fb78fd5af226e(alphabet4, value);
            if (value === "") return offset;
            const [leadingZeroes, tailChars] = $a3b9c16b0e3e8cb3$var$partitionLeadingZeroes(value, alphabet4[0]);
            if (!tailChars) {
                bytes.set(new Uint8Array(leadingZeroes.length).fill(0), offset);
                return offset + leadingZeroes.length;
            }
            let base10Number = $a3b9c16b0e3e8cb3$var$getBigIntFromBaseX(tailChars, alphabet4);
            const tailBytes = [];
            while(base10Number > 0n){
                tailBytes.unshift(Number(base10Number % 256n));
                base10Number /= 256n;
            }
            const bytesToAdd = [
                ...Array(leadingZeroes.length).fill(0),
                ...tailBytes
            ];
            bytes.set(bytesToAdd, offset);
            return offset + bytesToAdd.length;
        }
    });
};
var $a3b9c16b0e3e8cb3$export$4637bf000c106942 = (alphabet4)=>{
    return (0, $9ad1ed5438114d10$export$f8c898e83b60faaa)({
        read (rawBytes, offset) {
            const bytes = offset === 0 || offset <= -rawBytes.byteLength ? rawBytes : rawBytes.slice(offset);
            if (bytes.length === 0) return [
                "",
                rawBytes.length
            ];
            let trailIndex = bytes.findIndex((n)=>n !== 0);
            trailIndex = trailIndex === -1 ? bytes.length : trailIndex;
            const leadingZeroes = alphabet4[0].repeat(trailIndex);
            if (trailIndex === bytes.length) return [
                leadingZeroes,
                rawBytes.length
            ];
            const base10Number = bytes.slice(trailIndex).reduce((sum, byte)=>sum * 256n + BigInt(byte), 0n);
            const tailChars = $a3b9c16b0e3e8cb3$var$getBaseXFromBigInt(base10Number, alphabet4);
            return [
                leadingZeroes + tailChars,
                rawBytes.length
            ];
        }
    });
};
var $a3b9c16b0e3e8cb3$export$fb7555f212ab1005 = (alphabet4)=>(0, $9ad1ed5438114d10$export$b88681b853abde79)($a3b9c16b0e3e8cb3$export$604e39a60e9aaee6(alphabet4), $a3b9c16b0e3e8cb3$export$4637bf000c106942(alphabet4));
function $a3b9c16b0e3e8cb3$var$partitionLeadingZeroes(value, zeroCharacter) {
    const [leadingZeros, tailChars] = value.split(new RegExp(`((?!${zeroCharacter}).*)`));
    return [
        leadingZeros,
        tailChars
    ];
}
function $a3b9c16b0e3e8cb3$var$getBigIntFromBaseX(value, alphabet4) {
    const base = BigInt(alphabet4.length);
    let sum = 0n;
    for (const char of value){
        sum *= base;
        sum += BigInt(alphabet4.indexOf(char));
    }
    return sum;
}
function $a3b9c16b0e3e8cb3$var$getBaseXFromBigInt(value, alphabet4) {
    const base = BigInt(alphabet4.length);
    const tailChars = [];
    while(value > 0n){
        tailChars.unshift(alphabet4[Number(value % base)]);
        value /= base;
    }
    return tailChars.join("");
}
// src/base10.ts
var $a3b9c16b0e3e8cb3$var$alphabet = "0123456789";
var $a3b9c16b0e3e8cb3$export$2c0b6b55e979e1c1 = ()=>$a3b9c16b0e3e8cb3$export$604e39a60e9aaee6($a3b9c16b0e3e8cb3$var$alphabet);
var $a3b9c16b0e3e8cb3$export$f430205c15d46a26 = ()=>$a3b9c16b0e3e8cb3$export$4637bf000c106942($a3b9c16b0e3e8cb3$var$alphabet);
var $a3b9c16b0e3e8cb3$export$582e4cb05e79b066 = ()=>$a3b9c16b0e3e8cb3$export$fb7555f212ab1005($a3b9c16b0e3e8cb3$var$alphabet);
var $a3b9c16b0e3e8cb3$var$INVALID_STRING_ERROR_BASE_CONFIG = {
    alphabet: "0123456789abcdef",
    base: 16
};
function $a3b9c16b0e3e8cb3$var$charCodeToBase16(char) {
    if (char >= 48 /* ZERO */  && char <= 57 /* NINE */ ) return char - 48 /* ZERO */ ;
    if (char >= 65 /* A_UP */  && char <= 70 /* F_UP */ ) return char - 55;
    if (char >= 97 /* A_LO */  && char <= 102 /* F_LO */ ) return char - 87;
}
var $a3b9c16b0e3e8cb3$export$4e36ea5b8d948c7 = ()=>(0, $9ad1ed5438114d10$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>Math.ceil(value.length / 2),
        write (value, bytes, offset) {
            const len = value.length;
            const al = Math.ceil(len / 2);
            if (len === 1) {
                const c = value.charCodeAt(0);
                const n = $a3b9c16b0e3e8cb3$var$charCodeToBase16(c);
                if (n === void 0) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$89b582b06852d433), {
                    ...$a3b9c16b0e3e8cb3$var$INVALID_STRING_ERROR_BASE_CONFIG,
                    value: value
                });
                bytes.set([
                    n
                ], offset);
                return 1 + offset;
            }
            const hexBytes = new Uint8Array(al);
            for(let i = 0, j = 0; i < al; i++){
                const c1 = value.charCodeAt(j++);
                const c2 = value.charCodeAt(j++);
                const n1 = $a3b9c16b0e3e8cb3$var$charCodeToBase16(c1);
                const n2 = $a3b9c16b0e3e8cb3$var$charCodeToBase16(c2);
                if (n1 === void 0 || n2 === void 0 && !Number.isNaN(c2)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$89b582b06852d433), {
                    ...$a3b9c16b0e3e8cb3$var$INVALID_STRING_ERROR_BASE_CONFIG,
                    value: value
                });
                hexBytes[i] = !Number.isNaN(c2) ? n1 << 4 | (n2 ?? 0) : n1;
            }
            bytes.set(hexBytes, offset);
            return hexBytes.length + offset;
        }
    });
var $a3b9c16b0e3e8cb3$export$a8743d71ec78d9cd = ()=>(0, $9ad1ed5438114d10$export$f8c898e83b60faaa)({
        read (bytes, offset) {
            const value = bytes.slice(offset).reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
            return [
                value,
                bytes.length
            ];
        }
    });
var $a3b9c16b0e3e8cb3$export$38b0279df5920b98 = ()=>(0, $9ad1ed5438114d10$export$b88681b853abde79)($a3b9c16b0e3e8cb3$export$4e36ea5b8d948c7(), $a3b9c16b0e3e8cb3$export$a8743d71ec78d9cd());
// src/base58.ts
var $a3b9c16b0e3e8cb3$var$alphabet2 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $a3b9c16b0e3e8cb3$export$c9b1da42c197e8e5 = ()=>$a3b9c16b0e3e8cb3$export$604e39a60e9aaee6($a3b9c16b0e3e8cb3$var$alphabet2);
var $a3b9c16b0e3e8cb3$export$81723918e05f84c7 = ()=>$a3b9c16b0e3e8cb3$export$4637bf000c106942($a3b9c16b0e3e8cb3$var$alphabet2);
var $a3b9c16b0e3e8cb3$export$6edf7801eef2b1bb = ()=>$a3b9c16b0e3e8cb3$export$fb7555f212ab1005($a3b9c16b0e3e8cb3$var$alphabet2);
var $a3b9c16b0e3e8cb3$export$72d35c538ba15ebf = (alphabet4, bits)=>(0, $9ad1ed5438114d10$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>Math.floor(value.length * bits / 8),
        write (value, bytes, offset) {
            $a3b9c16b0e3e8cb3$export$d81fb78fd5af226e(alphabet4, value);
            if (value === "") return offset;
            const charIndices = [
                ...value
            ].map((c)=>alphabet4.indexOf(c));
            const reslicedBytes = $a3b9c16b0e3e8cb3$var$reslice(charIndices, bits, 8, false);
            bytes.set(reslicedBytes, offset);
            return reslicedBytes.length + offset;
        }
    });
var $a3b9c16b0e3e8cb3$export$ae1f0b87cf8eee1e = (alphabet4, bits)=>(0, $9ad1ed5438114d10$export$f8c898e83b60faaa)({
        read (rawBytes, offset = 0) {
            const bytes = offset === 0 || offset <= -rawBytes.byteLength ? rawBytes : rawBytes.slice(offset);
            if (bytes.length === 0) return [
                "",
                rawBytes.length
            ];
            const charIndices = $a3b9c16b0e3e8cb3$var$reslice([
                ...bytes
            ], 8, bits, true);
            return [
                charIndices.map((i)=>alphabet4[i]).join(""),
                rawBytes.length
            ];
        }
    });
var $a3b9c16b0e3e8cb3$export$d828ca4fa0b3e3bb = (alphabet4, bits)=>(0, $9ad1ed5438114d10$export$b88681b853abde79)($a3b9c16b0e3e8cb3$export$72d35c538ba15ebf(alphabet4, bits), $a3b9c16b0e3e8cb3$export$ae1f0b87cf8eee1e(alphabet4, bits));
function $a3b9c16b0e3e8cb3$var$reslice(input, inputBits, outputBits, useRemainder) {
    const output = [];
    let accumulator = 0;
    let bitsInAccumulator = 0;
    const mask = (1 << outputBits) - 1;
    for (const value of input){
        accumulator = accumulator << inputBits | value;
        bitsInAccumulator += inputBits;
        while(bitsInAccumulator >= outputBits){
            bitsInAccumulator -= outputBits;
            output.push(accumulator >> bitsInAccumulator & mask);
        }
    }
    if (useRemainder && bitsInAccumulator > 0) output.push(accumulator << outputBits - bitsInAccumulator & mask);
    return output;
}
// src/base64.ts
var $a3b9c16b0e3e8cb3$var$alphabet3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $a3b9c16b0e3e8cb3$var$MAX_BYTES_PER_CHAR_CODE_CALL = 32768;
function $a3b9c16b0e3e8cb3$var$getBinaryString(bytes) {
    let binaryString = "";
    for(let offset = 0; offset < bytes.length; offset += $a3b9c16b0e3e8cb3$var$MAX_BYTES_PER_CHAR_CODE_CALL)binaryString += String.fromCharCode(...bytes.subarray(offset, offset + $a3b9c16b0e3e8cb3$var$MAX_BYTES_PER_CHAR_CODE_CALL));
    return binaryString;
}
var $a3b9c16b0e3e8cb3$export$7a87b201ca045431 = ()=>{
    return (0, $9ad1ed5438114d10$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            try {
                return atob(value).length;
            } catch  {
                throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$89b582b06852d433), {
                    alphabet: $a3b9c16b0e3e8cb3$var$alphabet3,
                    base: 64,
                    value: value
                });
            }
        },
        write (value, bytes, offset) {
            try {
                const bytesToAdd = atob(value).split("").map((c)=>c.charCodeAt(0));
                bytes.set(bytesToAdd, offset);
                return bytesToAdd.length + offset;
            } catch  {
                throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$89b582b06852d433), {
                    alphabet: $a3b9c16b0e3e8cb3$var$alphabet3,
                    base: 64,
                    value: value
                });
            }
        }
    });
};
var $a3b9c16b0e3e8cb3$export$ee20ac553cec1cb2 = ()=>{
    return (0, $9ad1ed5438114d10$export$f8c898e83b60faaa)({
        read (bytes, offset = 0) {
            const value = btoa($a3b9c16b0e3e8cb3$var$getBinaryString(bytes.subarray(offset)));
            return [
                value,
                bytes.length
            ];
        }
    });
};
var $a3b9c16b0e3e8cb3$export$90e6baef93ad018a = ()=>(0, $9ad1ed5438114d10$export$b88681b853abde79)($a3b9c16b0e3e8cb3$export$7a87b201ca045431(), $a3b9c16b0e3e8cb3$export$ee20ac553cec1cb2());
// src/null-characters.ts
var $a3b9c16b0e3e8cb3$export$33e68217e0ffdbfd = (value)=>// eslint-disable-next-line no-control-regex
    value.replace(/\u0000/g, "");
var $a3b9c16b0e3e8cb3$export$f9f4f744d6dfac88 = (value, chars)=>value.padEnd(chars, "\0");
// ../text-encoding-impl/dist/index.browser.mjs
var $a3b9c16b0e3e8cb3$var$e = globalThis.TextDecoder;
var $a3b9c16b0e3e8cb3$var$o = globalThis.TextEncoder;
// src/utf8.ts
var $a3b9c16b0e3e8cb3$export$9a335ef9e29610a7 = (config = {})=>{
    let textEncoder;
    return (0, $9ad1ed5438114d10$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>(textEncoder ||= new $a3b9c16b0e3e8cb3$var$o()).encode(value).length,
        write: (value, bytes, offset)=>{
            if (config.fatal) $a3b9c16b0e3e8cb3$export$af0c8129dd18ef38(value);
            const bytesToAdd = (textEncoder ||= new $a3b9c16b0e3e8cb3$var$o()).encode(value);
            bytes.set(bytesToAdd, offset);
            return offset + bytesToAdd.length;
        }
    });
};
var $a3b9c16b0e3e8cb3$export$3cdd8a41d7d6b55d = (config = {})=>{
    let textDecoder;
    return (0, $9ad1ed5438114d10$export$f8c898e83b60faaa)({
        read (bytes, offset) {
            textDecoder ||= new $a3b9c16b0e3e8cb3$var$e("utf-8", {
                fatal: config.fatal ?? false,
                ignoreBOM: config.ignoreBOM ?? false
            });
            let value = config.fatal ? $a3b9c16b0e3e8cb3$var$decodeFatal(textDecoder, bytes, offset) : textDecoder.decode(bytes.slice(offset));
            if (!config.ignoreBOM && textDecoder.ignoreBOM === void 0 && value.charCodeAt(0) === 65279) value = value.slice(1);
            if (config.removeNullCharacters !== false) value = $a3b9c16b0e3e8cb3$export$33e68217e0ffdbfd(value);
            return [
                value,
                bytes.length
            ];
        }
    });
};
function $a3b9c16b0e3e8cb3$var$decodeFatal(textDecoder, bytes, offset) {
    const slice = bytes.slice(offset);
    if (!textDecoder.fatal) {
        $a3b9c16b0e3e8cb3$export$3d0f2c0a8c4cf2f3(bytes, offset);
        return textDecoder.decode(slice);
    }
    try {
        return textDecoder.decode(slice);
    } catch  {
        throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$8ed49819c26ad29f), {
            bytes: bytes,
            offset: $a3b9c16b0e3e8cb3$export$a9d9fed816ededdc(bytes, offset)
        });
    }
}
var $a3b9c16b0e3e8cb3$export$7c78620cf2c2b679 = (config = {})=>(0, $9ad1ed5438114d10$export$b88681b853abde79)($a3b9c16b0e3e8cb3$export$9a335ef9e29610a7(config), $a3b9c16b0e3e8cb3$export$3cdd8a41d7d6b55d(config));
 //# sourceMappingURL=index.browser.mjs.map




// src/crypto.ts
function $d78082106aa85240$export$9ea69ae0922ea694() {
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.getRandomValues !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$bc2b26beee0f9a0b));
}
function $d78082106aa85240$var$assertIsSecureContext() {
    if (!globalThis.isSecureContext) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$f2bbb3c14e29977e));
}
var $d78082106aa85240$var$cachedEd25519Decision;
async function $d78082106aa85240$var$isEd25519CurveSupported(subtle) {
    if ($d78082106aa85240$var$cachedEd25519Decision === void 0) $d78082106aa85240$var$cachedEd25519Decision = new Promise((resolve)=>{
        subtle.generateKey("Ed25519", /* extractable */ false, [
            "sign",
            "verify"
        ]).then(()=>{
            resolve($d78082106aa85240$var$cachedEd25519Decision = true);
        }).catch(()=>{
            resolve($d78082106aa85240$var$cachedEd25519Decision = false);
        });
    });
    if (typeof $d78082106aa85240$var$cachedEd25519Decision === "boolean") return $d78082106aa85240$var$cachedEd25519Decision;
    else return await $d78082106aa85240$var$cachedEd25519Decision;
}
function $d78082106aa85240$export$4ec0c2a1c3ac9154() {
    $d78082106aa85240$var$assertIsSecureContext();
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.subtle?.digest !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$f18173f573d8bb21));
}
async function $d78082106aa85240$export$c8b831ead944a354() {
    $d78082106aa85240$var$assertIsSecureContext();
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.subtle?.generateKey !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$325dad4e0a6bd514));
    if (!await $d78082106aa85240$var$isEd25519CurveSupported(globalThis.crypto.subtle)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$7ad09900bd645a86));
}
function $d78082106aa85240$export$833df987f9577189() {
    $d78082106aa85240$var$assertIsSecureContext();
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.subtle?.exportKey !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$69c08c51e1841f29));
}
function $d78082106aa85240$export$a60e81a6d8aa0738() {
    $d78082106aa85240$var$assertIsSecureContext();
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.subtle?.sign !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$242c341c7c464bee));
}
function $d78082106aa85240$export$abe752f2065eb545() {
    $d78082106aa85240$var$assertIsSecureContext();
    if (typeof globalThis.crypto === "undefined" || typeof globalThis.crypto.subtle?.verify !== "function") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$a73c064bb32a7c36));
}
 //# sourceMappingURL=index.browser.mjs.map


// src/address.ts
var $d8a00a068933db63$var$memoizedBase58Encoder;
var $d8a00a068933db63$var$memoizedBase58Decoder;
function $d8a00a068933db63$var$getMemoizedBase58Encoder() {
    if (!$d8a00a068933db63$var$memoizedBase58Encoder) $d8a00a068933db63$var$memoizedBase58Encoder = (0, $a3b9c16b0e3e8cb3$export$c9b1da42c197e8e5)();
    return $d8a00a068933db63$var$memoizedBase58Encoder;
}
function $d8a00a068933db63$var$getMemoizedBase58Decoder() {
    if (!$d8a00a068933db63$var$memoizedBase58Decoder) $d8a00a068933db63$var$memoizedBase58Decoder = (0, $a3b9c16b0e3e8cb3$export$81723918e05f84c7)();
    return $d8a00a068933db63$var$memoizedBase58Decoder;
}
function $d8a00a068933db63$export$977e255126d763d6(putativeAddress) {
    if (// Lowest address (32 bytes of zeroes)
    putativeAddress.length < 32 || // Highest address (32 bytes of 255)
    putativeAddress.length > 44) return false;
    const base58Encoder = $d8a00a068933db63$var$getMemoizedBase58Encoder();
    try {
        return base58Encoder.encode(putativeAddress).byteLength === 32;
    } catch  {
        return false;
    }
}
function $d8a00a068933db63$export$ce82521337b7000f(putativeAddress) {
    if (// Lowest address (32 bytes of zeroes)
    putativeAddress.length < 32 || // Highest address (32 bytes of 255)
    putativeAddress.length > 44) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$8aae3518bf4ea38c), {
        actualLength: putativeAddress.length
    });
    const base58Encoder = $d8a00a068933db63$var$getMemoizedBase58Encoder();
    const bytes = base58Encoder.encode(putativeAddress);
    const numBytes = bytes.byteLength;
    if (numBytes !== 32) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$fe284a92110eab86), {
        actualLength: numBytes
    });
}
function $d8a00a068933db63$export$f7d3c097ceca6c15(putativeAddress) {
    $d8a00a068933db63$export$ce82521337b7000f(putativeAddress);
    return putativeAddress;
}
function $d8a00a068933db63$export$796121a945d5c29b() {
    return (0, $9ad1ed5438114d10$export$30169aca64409a56)((0, $9ad1ed5438114d10$export$cbdfce031443a1)($d8a00a068933db63$var$getMemoizedBase58Encoder(), 32), (value)=>$d8a00a068933db63$export$f7d3c097ceca6c15(typeof value === "string" ? value : value.address));
}
function $d8a00a068933db63$export$5fd6a09ea9008295() {
    return (0, $9ad1ed5438114d10$export$1f85f8b8d2788007)($d8a00a068933db63$var$getMemoizedBase58Decoder(), 32);
}
function $d8a00a068933db63$export$872beb68e6a83b96() {
    return (0, $9ad1ed5438114d10$export$b88681b853abde79)($d8a00a068933db63$export$796121a945d5c29b(), $d8a00a068933db63$export$5fd6a09ea9008295());
}
function $d8a00a068933db63$export$be47cbc6fd88c6e6() {
    return new Intl.Collator("en", {
        caseFirst: "lower",
        ignorePunctuation: false,
        localeMatcher: "best fit",
        numeric: false,
        sensitivity: "variant",
        usage: "sort"
    }).compare;
}
// src/vendor/noble/ed25519.ts
var $d8a00a068933db63$var$D = 37095705934669439343138083508754565189542113879843219016388785533085940283555n;
var $d8a00a068933db63$var$P = 57896044618658097711785492504343953926634992332820282019728792003956564819949n;
var $d8a00a068933db63$var$RM1 = 19681161376707505956807079304988542015446066515923890162744021073123829784752n;
function $d8a00a068933db63$var$mod(a) {
    const r = a % $d8a00a068933db63$var$P;
    return r >= 0n ? r : $d8a00a068933db63$var$P + r;
}
function $d8a00a068933db63$var$pow2(x, power) {
    let r = x;
    while(power-- > 0n){
        r *= r;
        r %= $d8a00a068933db63$var$P;
    }
    return r;
}
function $d8a00a068933db63$var$pow_2_252_3(x) {
    const x2 = x * x % $d8a00a068933db63$var$P;
    const b2 = x2 * x % $d8a00a068933db63$var$P;
    const b4 = $d8a00a068933db63$var$pow2(b2, 2n) * b2 % $d8a00a068933db63$var$P;
    const b5 = $d8a00a068933db63$var$pow2(b4, 1n) * x % $d8a00a068933db63$var$P;
    const b10 = $d8a00a068933db63$var$pow2(b5, 5n) * b5 % $d8a00a068933db63$var$P;
    const b20 = $d8a00a068933db63$var$pow2(b10, 10n) * b10 % $d8a00a068933db63$var$P;
    const b40 = $d8a00a068933db63$var$pow2(b20, 20n) * b20 % $d8a00a068933db63$var$P;
    const b80 = $d8a00a068933db63$var$pow2(b40, 40n) * b40 % $d8a00a068933db63$var$P;
    const b160 = $d8a00a068933db63$var$pow2(b80, 80n) * b80 % $d8a00a068933db63$var$P;
    const b240 = $d8a00a068933db63$var$pow2(b160, 80n) * b80 % $d8a00a068933db63$var$P;
    const b250 = $d8a00a068933db63$var$pow2(b240, 10n) * b10 % $d8a00a068933db63$var$P;
    const pow_p_5_8 = $d8a00a068933db63$var$pow2(b250, 2n) * x % $d8a00a068933db63$var$P;
    return pow_p_5_8;
}
function $d8a00a068933db63$var$uvRatio(u, v) {
    const v3 = $d8a00a068933db63$var$mod(v * v * v);
    const v7 = $d8a00a068933db63$var$mod(v3 * v3 * v);
    const pow = $d8a00a068933db63$var$pow_2_252_3(u * v7);
    let x = $d8a00a068933db63$var$mod(u * v3 * pow);
    const vx2 = $d8a00a068933db63$var$mod(v * x * x);
    const root1 = x;
    const root2 = $d8a00a068933db63$var$mod(x * $d8a00a068933db63$var$RM1);
    const useRoot1 = vx2 === u;
    const useRoot2 = vx2 === $d8a00a068933db63$var$mod(-u);
    const noRoot = vx2 === $d8a00a068933db63$var$mod(-u * $d8a00a068933db63$var$RM1);
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2;
    if (($d8a00a068933db63$var$mod(x) & 1n) === 1n) x = $d8a00a068933db63$var$mod(-x);
    if (!useRoot1 && !useRoot2) return null;
    return x;
}
function $d8a00a068933db63$var$pointIsOnCurve(y, lastByte) {
    const y2 = $d8a00a068933db63$var$mod(y * y);
    const u = $d8a00a068933db63$var$mod(y2 - 1n);
    const v = $d8a00a068933db63$var$mod($d8a00a068933db63$var$D * y2 + 1n);
    const x = $d8a00a068933db63$var$uvRatio(u, v);
    if (x === null) return false;
    const isLastByteOdd = (lastByte & 128) !== 0;
    if (x === 0n && isLastByteOdd) return false;
    return true;
}
// src/curve-internal.ts
function $d8a00a068933db63$var$byteToHex(byte) {
    const hexString = byte.toString(16);
    if (hexString.length === 1) return `0${hexString}`;
    else return hexString;
}
function $d8a00a068933db63$var$decompressPointBytes(bytes) {
    const hexString = bytes.reduce((acc, byte, ii)=>`${$d8a00a068933db63$var$byteToHex(ii === 31 ? byte & -129 : byte)}${acc}`, "");
    const integerLiteralString = `0x${hexString}`;
    return BigInt(integerLiteralString);
}
function $d8a00a068933db63$var$compressedPointBytesAreOnCurve(bytes) {
    if (bytes.byteLength !== 32) return false;
    const y = $d8a00a068933db63$var$decompressPointBytes(bytes);
    return $d8a00a068933db63$var$pointIsOnCurve(y, bytes[31]);
}
// src/curve.ts
function $d8a00a068933db63$export$6be0de63ec3caf15(putativeOffCurveAddress) {
    const addressBytes = $d8a00a068933db63$export$872beb68e6a83b96().encode(putativeOffCurveAddress);
    return $d8a00a068933db63$var$compressedPointBytesAreOnCurve(addressBytes) === false;
}
function $d8a00a068933db63$export$8f1b8960967e8769(putativeOffCurveAddress) {
    if (!$d8a00a068933db63$export$6be0de63ec3caf15(putativeOffCurveAddress)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$7ada2ae349acb674));
}
function $d8a00a068933db63$export$c2f76c3a1dcb2609(putativeOffCurveAddress) {
    $d8a00a068933db63$export$8f1b8960967e8769(putativeOffCurveAddress);
    return putativeOffCurveAddress;
}
function $d8a00a068933db63$export$62e170af72c8a219(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === "string" && typeof value[1] === "number" && value[1] >= 0 && value[1] <= 255 && $d8a00a068933db63$export$977e255126d763d6(value[0]);
}
function $d8a00a068933db63$export$b41ce18a9d54e115(value) {
    const validFormat = Array.isArray(value) && value.length === 2 && typeof value[0] === "string" && typeof value[1] === "number";
    if (!validFormat) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$523a769cce7318bf));
    if (value[1] < 0 || value[1] > 255) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$68473acf744cabf5), {
        bump: value[1]
    });
    $d8a00a068933db63$export$ce82521337b7000f(value[0]);
}
var $d8a00a068933db63$var$MAX_SEED_LENGTH = 32;
var $d8a00a068933db63$var$MAX_SEEDS = 16;
var $d8a00a068933db63$var$PDA_MARKER_BYTES = [
    // The string 'ProgramDerivedAddress'
    80,
    114,
    111,
    103,
    114,
    97,
    109,
    68,
    101,
    114,
    105,
    118,
    101,
    100,
    65,
    100,
    100,
    114,
    101,
    115,
    115
];
async function $d8a00a068933db63$var$createProgramDerivedAddress({ programAddress: programAddress, seeds: seeds }) {
    (0, $d78082106aa85240$export$4ec0c2a1c3ac9154)();
    if (seeds.length > $d8a00a068933db63$var$MAX_SEEDS) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$940d17d3b63dba7c), {
        actual: seeds.length,
        maxSeeds: $d8a00a068933db63$var$MAX_SEEDS
    });
    let textEncoder;
    const seedBytes = seeds.reduce((acc, seed, ii)=>{
        const bytes = typeof seed === "string" ? (textEncoder ||= new TextEncoder()).encode(seed) : seed;
        if (bytes.byteLength > $d8a00a068933db63$var$MAX_SEED_LENGTH) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$a1cf857da540ee2e), {
            actual: bytes.byteLength,
            index: ii,
            maxSeedLength: $d8a00a068933db63$var$MAX_SEED_LENGTH
        });
        acc.push(...bytes);
        return acc;
    }, []);
    const base58EncodedAddressCodec = $d8a00a068933db63$export$872beb68e6a83b96();
    const programAddressBytes = base58EncodedAddressCodec.encode(programAddress);
    const addressBytesBuffer = await crypto.subtle.digest("SHA-256", new Uint8Array([
        ...seedBytes,
        ...programAddressBytes,
        ...$d8a00a068933db63$var$PDA_MARKER_BYTES
    ]));
    const addressBytes = new Uint8Array(addressBytesBuffer);
    if ($d8a00a068933db63$var$compressedPointBytesAreOnCurve(addressBytes)) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$30501b98da9564bb));
    return base58EncodedAddressCodec.decode(addressBytes);
}
async function $d8a00a068933db63$export$4e565ad19ba445b({ programAddress: programAddress, seeds: seeds }) {
    let bumpSeed = 255;
    while(bumpSeed > 0)try {
        const address2 = await $d8a00a068933db63$var$createProgramDerivedAddress({
            programAddress: programAddress,
            seeds: [
                ...seeds,
                new Uint8Array([
                    bumpSeed
                ])
            ]
        });
        return [
            address2,
            bumpSeed
        ];
    } catch (e) {
        if ((0, $938d2f63083c1136$export$cfead212e52d9961)(e, (0, $938d2f63083c1136$export$30501b98da9564bb))) bumpSeed--;
        else throw e;
    }
    throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$123d01dd469dc2ef));
}
async function $d8a00a068933db63$export$be6e74907809ce04({ baseAddress: baseAddress, programAddress: programAddress, seed: seed }) {
    const { encode: encode, decode: decode } = $d8a00a068933db63$export$872beb68e6a83b96();
    const seedBytes = typeof seed === "string" ? new TextEncoder().encode(seed) : seed;
    if (seedBytes.byteLength > $d8a00a068933db63$var$MAX_SEED_LENGTH) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$a1cf857da540ee2e), {
        actual: seedBytes.byteLength,
        index: 0,
        maxSeedLength: $d8a00a068933db63$var$MAX_SEED_LENGTH
    });
    const programAddressBytes = encode(programAddress);
    if (programAddressBytes.length >= $d8a00a068933db63$var$PDA_MARKER_BYTES.length && (0, $9ad1ed5438114d10$export$c663ab80cce302c5)(programAddressBytes.slice(-$d8a00a068933db63$var$PDA_MARKER_BYTES.length), new Uint8Array($d8a00a068933db63$var$PDA_MARKER_BYTES))) throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$2a7684440f52314e));
    const addressBytesBuffer = await crypto.subtle.digest("SHA-256", new Uint8Array([
        ...encode(baseAddress),
        ...seedBytes,
        ...programAddressBytes
    ]));
    const addressBytes = new Uint8Array(addressBytesBuffer);
    return decode(addressBytes);
}
async function $d8a00a068933db63$export$a28ea21350b9dd16(publicKey) {
    (0, $d78082106aa85240$export$833df987f9577189)();
    if (publicKey.type !== "public" || publicKey.algorithm.name !== "Ed25519") throw new (0, $938d2f63083c1136$export$8349fd9adaaed269)((0, $938d2f63083c1136$export$adaec66b544981e7));
    const publicKeyBytes = await crypto.subtle.exportKey("raw", publicKey);
    return $d8a00a068933db63$export$5fd6a09ea9008295().decode(new Uint8Array(publicKeyBytes));
}
async function $d8a00a068933db63$export$bca2d63cbdc990ff(address2) {
    const addressBytes = $d8a00a068933db63$export$796121a945d5c29b().encode(address2);
    return await crypto.subtle.importKey("raw", addressBytes, {
        name: "Ed25519"
    }, true, [
        "verify"
    ]);
}
 //# sourceMappingURL=index.browser.mjs.map


function $afac340f4304ea48$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $afac340f4304ea48$export$c663ab80cce302c5(a, b) {
    return $afac340f4304ea48$export$234180f8206db11b(a, b);
}
function $afac340f4304ea48$export$25f2a2d02b7fa68d(address, publicKey) {
    // The decoder reads only the first 32 bytes and throws on fewer, so check the length explicitly.
    if (publicKey.length !== 32) return false;
    return (0, $d8a00a068933db63$export$5fd6a09ea9008295)().decode(publicKey) === address;
}
function $afac340f4304ea48$export$56728fb2d7dba34e(bytes) {
    // Accept a `Uint8Array` from another realm, the same way `@noble/curves` does.
    if (!(bytes instanceof Uint8Array || ArrayBuffer.isView(bytes) && bytes.constructor.name === 'Uint8Array')) return null;
    return Uint8Array.from(bytes);
}


function $26b1b631c43d49c5$export$54b8e79a8f938f52({ message: message, signedMessage: signedMessage, signature: signature, publicKey: publicKey }) {
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    // Copy the bytes so the message that's compared is the message that's verified.
    const messageBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(message);
    const signedMessageBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(signedMessage);
    const signatureBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(signature);
    const publicKeyBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(publicKey);
    if (!messageBytes || !signedMessageBytes || !signatureBytes || !publicKeyBytes) return false;
    return (0, $afac340f4304ea48$export$c663ab80cce302c5)(messageBytes, signedMessageBytes) && // Use strict RFC 8032 verification. The default (ZIP 215) accepts small-order public keys, for which a fixed
    // signature is valid for any message.
    (0, $81dc8d0126b4a70a$export$f63794f4a09a19c1).verify(signatureBytes, signedMessageBytes, publicKeyBytes, {
        zip215: false
    });
}
function $26b1b631c43d49c5$export$a7a8e868ceb02186(input, output) {
    const { message: message, account: { address: address, publicKey: publicKey } } = input;
    const { signedMessage: signedMessage, signature: signature } = output;
    // Copy the public key so the key that's checked against the address is the key that's verified.
    const publicKeyBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(publicKey);
    return !!publicKeyBytes && (0, $afac340f4304ea48$export$25f2a2d02b7fa68d)(address, publicKeyBytes) && $26b1b631c43d49c5$export$54b8e79a8f938f52({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKeyBytes
    });
}



function $f7ea0181f37a891f$export$9828dc452d20db63(input, output) {
    // Read each value from the wallet once, and copy the bytes, so the values that are checked are the values that are
    // verified.
    const { signedMessage: signedMessage, signature: signature, account: { address: address, publicKey: publicKey } } = output;
    const publicKeyBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(publicKey);
    const signedMessageBytes = (0, $afac340f4304ea48$export$56728fb2d7dba34e)(signedMessage);
    if (!publicKeyBytes || !signedMessageBytes) return false;
    if (!(0, $afac340f4304ea48$export$25f2a2d02b7fa68d)(address, publicKeyBytes)) return false;
    const text = $f7ea0181f37a891f$var$deriveSignInMessageTextForAccount(input, address, signedMessageBytes);
    if (!text) return false;
    return (0, $26b1b631c43d49c5$export$54b8e79a8f938f52)({
        message: new TextEncoder().encode(text),
        signedMessage: signedMessageBytes,
        signature: signature,
        publicKey: publicKeyBytes
    });
}
function $f7ea0181f37a891f$export$5a98156f426eafe8(input, output) {
    const text = $f7ea0181f37a891f$export$14d5fbb279d179c2(input, output);
    if (!text) return null;
    return new TextEncoder().encode(text);
}
function $f7ea0181f37a891f$export$14d5fbb279d179c2(input, output) {
    return $f7ea0181f37a891f$var$deriveSignInMessageTextForAccount(input, output.account.address, output.signedMessage);
}
function $f7ea0181f37a891f$var$deriveSignInMessageTextForAccount(input, accountAddress, signedMessage) {
    const parsed = $f7ea0181f37a891f$export$ddde1a7f6f94bd0a(signedMessage);
    if (!parsed) return null;
    if (input.domain && input.domain !== parsed.domain) return null;
    if (input.address && input.address !== parsed.address) return null;
    if (accountAddress !== parsed.address) return null;
    if (input.statement !== parsed.statement) return null;
    if (input.uri !== parsed.uri) return null;
    if (input.version !== parsed.version) return null;
    if (input.chainId !== parsed.chainId) return null;
    if (input.nonce !== parsed.nonce) return null;
    if (input.issuedAt !== parsed.issuedAt) return null;
    if (input.expirationTime !== parsed.expirationTime) return null;
    if (input.notBefore !== parsed.notBefore) return null;
    if (input.requestId !== parsed.requestId) return null;
    if (input.resources) {
        if (!parsed.resources) return null;
        if (!(0, $afac340f4304ea48$export$234180f8206db11b)(input.resources, parsed.resources)) return null;
    } else if (parsed.resources) return null;
    return $f7ea0181f37a891f$export$88aceda9565b68d2(parsed);
}
function $f7ea0181f37a891f$export$ddde1a7f6f94bd0a(message) {
    const text = new TextDecoder().decode(message);
    return $f7ea0181f37a891f$export$4a112f3ad8ba8e50(text);
}
// TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
const $f7ea0181f37a891f$var$DOMAIN = '(?<domain>[^\\n]+?) wants you to sign in with your Solana account:\\n';
const $f7ea0181f37a891f$var$ADDRESS = '(?<address>[^\\n]+)(?:\\n|$)';
const $f7ea0181f37a891f$var$STATEMENT = '(?:\\n(?<statement>[\\S\\s]*?)(?:\\n|$))??';
const $f7ea0181f37a891f$var$URI = '(?:\\nURI: (?<uri>[^\\n]+))?';
const $f7ea0181f37a891f$var$VERSION = '(?:\\nVersion: (?<version>[^\\n]+))?';
const $f7ea0181f37a891f$var$CHAIN_ID = '(?:\\nChain ID: (?<chainId>[^\\n]+))?';
const $f7ea0181f37a891f$var$NONCE = '(?:\\nNonce: (?<nonce>[^\\n]+))?';
const $f7ea0181f37a891f$var$ISSUED_AT = '(?:\\nIssued At: (?<issuedAt>[^\\n]+))?';
const $f7ea0181f37a891f$var$EXPIRATION_TIME = '(?:\\nExpiration Time: (?<expirationTime>[^\\n]+))?';
const $f7ea0181f37a891f$var$NOT_BEFORE = '(?:\\nNot Before: (?<notBefore>[^\\n]+))?';
const $f7ea0181f37a891f$var$REQUEST_ID = '(?:\\nRequest ID: (?<requestId>[^\\n]+))?';
const $f7ea0181f37a891f$var$RESOURCES = '(?:\\nResources:(?<resources>(?:\\n- [^\\n]+)*))?';
const $f7ea0181f37a891f$var$FIELDS = `${$f7ea0181f37a891f$var$URI}${$f7ea0181f37a891f$var$VERSION}${$f7ea0181f37a891f$var$CHAIN_ID}${$f7ea0181f37a891f$var$NONCE}${$f7ea0181f37a891f$var$ISSUED_AT}${$f7ea0181f37a891f$var$EXPIRATION_TIME}${$f7ea0181f37a891f$var$NOT_BEFORE}${$f7ea0181f37a891f$var$REQUEST_ID}${$f7ea0181f37a891f$var$RESOURCES}`;
const $f7ea0181f37a891f$var$MESSAGE = new RegExp(`^${$f7ea0181f37a891f$var$DOMAIN}${$f7ea0181f37a891f$var$ADDRESS}${$f7ea0181f37a891f$var$STATEMENT}${$f7ea0181f37a891f$var$FIELDS}\\n*$`);
function $f7ea0181f37a891f$export$4a112f3ad8ba8e50(text) {
    const match = $f7ea0181f37a891f$var$MESSAGE.exec(text);
    if (!match) return null;
    const groups = match.groups;
    if (!groups) return null;
    return {
        domain: groups.domain,
        address: groups.address,
        statement: groups.statement,
        uri: groups.uri,
        version: groups.version,
        nonce: groups.nonce,
        chainId: groups.chainId,
        issuedAt: groups.issuedAt,
        expirationTime: groups.expirationTime,
        notBefore: groups.notBefore,
        requestId: groups.requestId,
        resources: groups.resources?.split('\n- ').slice(1)
    };
}
function $f7ea0181f37a891f$export$92ddcd466ce9e7c4(input) {
    const text = $f7ea0181f37a891f$export$88aceda9565b68d2(input);
    return new TextEncoder().encode(text);
}
function $f7ea0181f37a891f$export$88aceda9565b68d2(input) {
    // ${domain} wants you to sign in with your Solana account:
    // ${address}
    //
    // ${statement}
    //
    // URI: ${uri}
    // Version: ${version}
    // Chain ID: ${chain}
    // Nonce: ${nonce}
    // Issued At: ${issued-at}
    // Expiration Time: ${expiration-time}
    // Not Before: ${not-before}
    // Request ID: ${request-id}
    // Resources:
    // - ${resources[0]}
    // - ${resources[1]}
    // ...
    // - ${resources[n]}
    let message = `${input.domain} wants you to sign in with your Solana account:\n`;
    message += `${input.address}`;
    if (input.statement) message += `\n\n${input.statement}`;
    const fields = [];
    if (input.uri) fields.push(`URI: ${input.uri}`);
    if (input.version) fields.push(`Version: ${input.version}`);
    if (input.chainId) fields.push(`Chain ID: ${input.chainId}`);
    if (input.nonce) fields.push(`Nonce: ${input.nonce}`);
    if (input.issuedAt) fields.push(`Issued At: ${input.issuedAt}`);
    if (input.expirationTime) fields.push(`Expiration Time: ${input.expirationTime}`);
    if (input.notBefore) fields.push(`Not Before: ${input.notBefore}`);
    if (input.requestId) fields.push(`Request ID: ${input.requestId}`);
    if (input.resources) {
        fields.push(`Resources:`);
        for (const resource of input.resources)fields.push(`- ${resource}`);
    }
    if (fields.length) message += `\n\n${fields.join('\n')}`;
    return message;
}


//#region src/errors.ts
const $b5177f26f29fa44f$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_REFLECTOR_ID_OUT_OF_RANGE: "ERROR_REFLECTOR_ID_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND",
    ERROR_INVALID_PROTOCOL_VERSION: "ERROR_INVALID_PROTOCOL_VERSION",
    ERROR_BROWSER_NOT_SUPPORTED: "ERROR_BROWSER_NOT_SUPPORTED",
    ERROR_LOOPBACK_ACCESS_BLOCKED: "ERROR_LOOPBACK_ACCESS_BLOCKED",
    ERROR_ASSOCIATION_CANCELLED: "ERROR_ASSOCIATION_CANCELLED",
    ERROR_ILLEGAL_TRANSPORT_STATE: "ERROR_ILLEGAL_TRANSPORT_STATE"
};
var $b5177f26f29fa44f$export$d77545679c409b63 = class extends Error {
    data;
    code;
    constructor(...args){
        const [code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.name = "SolanaMobileWalletAdapterError";
    }
};
const $b5177f26f29fa44f$export$23d27841621bc1e8 = {
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
var $b5177f26f29fa44f$export$58b788f937123c66 = class extends Error {
    data;
    code;
    jsonRpcMessageId;
    constructor(...args){
        const [jsonRpcMessageId, code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.jsonRpcMessageId = jsonRpcMessageId;
        this.name = "SolanaMobileWalletAdapterProtocolError";
    }
};
//#endregion
//#region src/nostr.ts
const $b5177f26f29fa44f$export$8901aba29937dfc8 = 20012;
function $b5177f26f29fa44f$export$6b56ae5ba13d5d8f() {
    const privateKey = (0, $ada755e79ac828b0$export$1f2401df071be9f).utils.randomSecretKey();
    return {
        privateKey: privateKey,
        publicKey: (0, $3c6c2c802c119f83$export$58b867e287a802c8)((0, $ada755e79ac828b0$export$1f2401df071be9f).getPublicKey(privateKey))
    };
}
async function $b5177f26f29fa44f$export$ec842aab867c14a3(associationPublicKey) {
    const rawKey = await crypto.subtle.exportKey("raw", associationPublicKey);
    const hash = (0, $3000ec301818b27b$export$bced8d2aada2d1c9)(new Uint8Array(rawKey));
    return (0, $3c6c2c802c119f83$export$58b867e287a802c8)(hash);
}
function $b5177f26f29fa44f$var$serializeEvent(pubkey, createdAt, kind, tags, content) {
    return JSON.stringify([
        0,
        pubkey,
        createdAt,
        kind,
        tags,
        content
    ]);
}
function $b5177f26f29fa44f$var$computeEventId(pubkey, createdAt, kind, tags, content) {
    const serialized = $b5177f26f29fa44f$var$serializeEvent(pubkey, createdAt, kind, tags, content);
    return (0, $3c6c2c802c119f83$export$58b867e287a802c8)((0, $3000ec301818b27b$export$bced8d2aada2d1c9)(new TextEncoder().encode(serialized)));
}
function $b5177f26f29fa44f$export$5276f5ebd0ea7dde(kind, content, tags, privateKey) {
    const pubkey = (0, $3c6c2c802c119f83$export$58b867e287a802c8)((0, $ada755e79ac828b0$export$1f2401df071be9f).getPublicKey(privateKey));
    const createdAt = Math.floor(Date.now() / 1e3);
    const id = $b5177f26f29fa44f$var$computeEventId(pubkey, createdAt, kind, tags, content);
    return {
        id: id,
        pubkey: pubkey,
        created_at: createdAt,
        kind: kind,
        tags: tags,
        content: content,
        sig: (0, $3c6c2c802c119f83$export$58b867e287a802c8)((0, $ada755e79ac828b0$export$1f2401df071be9f).sign((0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(id), privateKey))
    };
}
function $b5177f26f29fa44f$export$7785d6e706482c9a(event) {
    if ($b5177f26f29fa44f$var$computeEventId(event.pubkey, event.created_at, event.kind, event.tags, event.content) !== event.id) return false;
    try {
        return (0, $ada755e79ac828b0$export$1f2401df071be9f).verify((0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(event.sig), (0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(event.id), (0, $3c6c2c802c119f83$export$31c96b9df38bc8d4)(event.pubkey));
    } catch  {
        return false;
    }
}
//#endregion
//#region src/createHelloReq.ts
async function $b5177f26f29fa44f$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    const publicKeyBuffer = await crypto.subtle.exportKey("raw", ecdhPublicKey);
    const signatureBuffer = await crypto.subtle.sign({
        hash: "SHA-256",
        name: "ECDSA"
    }, associationKeypairPrivateKey, publicKeyBuffer);
    const response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
    response.set(new Uint8Array(publicKeyBuffer), 0);
    response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
    return response;
}
//#endregion
//#region src/createSIWSMessage.ts
function $b5177f26f29fa44f$var$createSIWSMessage(payload) {
    return (0, $f7ea0181f37a891f$export$88aceda9565b68d2)(payload);
}
function $b5177f26f29fa44f$var$createSIWSMessageBase64Url(payload) {
    return (0, $f97c98ce9ab46f75$export$2d1720544b23b823)($b5177f26f29fa44f$var$createSIWSMessage(payload)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
//#endregion
//#region src/types.ts
const $b5177f26f29fa44f$export$6d2aa8b15676f603 = "solana:signTransactions";
const $b5177f26f29fa44f$export$7b8713ece485d770 = "solana:cloneAuthorization";
const $b5177f26f29fa44f$export$fca2a421c519d7f8 = "solana:signInWithSolana";
//#endregion
//#region src/createMobileWalletProxy.ts
/**
* Creates a {@link MobileWallet} proxy that handles backwards compatibility and API to RPC conversion.
*
* @param protocolVersion the protocol version in use for this session/request
* @param protocolRequestHandler callback function that handles sending the RPC request to the wallet endpoint.
* @returns a {@link MobileWallet} proxy
*/ function $b5177f26f29fa44f$var$createMobileWalletProxy(protocolVersion, protocolRequestHandler) {
    return new Proxy({}, {
        get (target, p) {
            if (p === "then") return null;
            if (target[p] == null) target[p] = async function(inputParams) {
                const { method: method, params: params } = $b5177f26f29fa44f$var$handleMobileWalletRequest(p, inputParams, protocolVersion);
                const result = await protocolRequestHandler(method, params);
                if (method === "authorize" && params.sign_in_payload && !result.sign_in_result) result.sign_in_result = await $b5177f26f29fa44f$var$signInFallback(params.sign_in_payload, result, protocolRequestHandler);
                return $b5177f26f29fa44f$var$handleMobileWalletResponse(p, result, protocolVersion);
            };
            return target[p];
        },
        defineProperty () {
            return false;
        },
        deleteProperty () {
            return false;
        }
    });
}
/**
* Handles all {@link MobileWallet} API requests and determines the correct MWA RPC method and params to call.
* This handles backwards compatibility, based on the provided @protocolVersion.
*
* @param methodName the name of {@link MobileWallet} method that was called
* @param methodParams the parameters that were passed to the method
* @param protocolVersion the protocol version in use for this session/request
* @returns the RPC request method and params that should be sent to the wallet endpoint
*/ function $b5177f26f29fa44f$var$handleMobileWalletRequest(methodName, methodParams, protocolVersion) {
    let params = methodParams;
    let method = methodName.toString().replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`).toLowerCase();
    switch(methodName){
        case "authorize":
            {
                const authorizeParams = params;
                let { chain: chain } = authorizeParams;
                if (protocolVersion === "legacy") {
                    switch(chain){
                        case "solana:testnet":
                            chain = "testnet";
                            break;
                        case "solana:devnet":
                            chain = "devnet";
                            break;
                        case "solana:mainnet":
                            chain = "mainnet-beta";
                            break;
                        default:
                            chain = authorizeParams.cluster;
                    }
                    authorizeParams.cluster = chain;
                    params = authorizeParams;
                } else {
                    switch(chain){
                        case "testnet":
                        case "devnet":
                            chain = `solana:${chain}`;
                            break;
                        case "mainnet-beta":
                            chain = "solana:mainnet";
                    }
                    authorizeParams.chain = chain;
                    params = authorizeParams;
                }
            }
        case "reauthorize":
            {
                const { auth_token: auth_token, identity: identity } = params;
                if (auth_token) switch(protocolVersion){
                    case "legacy":
                        method = "reauthorize";
                        params = {
                            auth_token: auth_token,
                            identity: identity
                        };
                        break;
                    default:
                        method = "authorize";
                }
                break;
            }
    }
    return {
        method: method,
        params: params
    };
}
/**
* Handles all {@link MobileWallet} API responses and modifies the response for backwards compatibility, if needed
*
* @param method the {@link MobileWallet} method that was called
* @param response the original response that was returned by the method call
* @param protocolVersion the protocol version in use for this session/request
* @returns the possibly modified response
*/ function $b5177f26f29fa44f$var$handleMobileWalletResponse(method, response, protocolVersion) {
    switch(method){
        case "getCapabilities":
            {
                const capabilities = response;
                switch(protocolVersion){
                    case "legacy":
                        {
                            const features = [
                                $b5177f26f29fa44f$export$6d2aa8b15676f603
                            ];
                            if (capabilities.supports_clone_authorization === true) features.push($b5177f26f29fa44f$export$7b8713ece485d770);
                            return {
                                ...capabilities,
                                features: features
                            };
                        }
                    case "v1":
                        return {
                            ...capabilities,
                            supports_sign_and_send_transactions: true,
                            supports_clone_authorization: capabilities.features.includes($b5177f26f29fa44f$export$7b8713ece485d770)
                        };
                }
            }
    }
    return response;
}
async function $b5177f26f29fa44f$var$signInFallback(signInPayload, authorizationResult, protocolRequestHandler) {
    const domain = signInPayload.domain ?? window.location.host;
    const address = authorizationResult.accounts[0].address;
    const siwsMessage = $b5177f26f29fa44f$var$createSIWSMessageBase64Url({
        ...signInPayload,
        domain: domain,
        address: (0, $f97c98ce9ab46f75$export$4368d992c4eafac0)(address)
    });
    const signMessageResult = await protocolRequestHandler("sign_messages", {
        addresses: [
            address
        ],
        payloads: [
            siwsMessage
        ]
    });
    const signedPayload = (0, $f97c98ce9ab46f75$export$953cecd6e717a553)(signMessageResult.signed_payloads[0]);
    const signedMessage = (0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(signedPayload.slice(0, signedPayload.length - 64));
    const signature = (0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(signedPayload.slice(signedPayload.length - 64));
    return {
        address: address,
        signed_message: signedMessage.length == 0 ? siwsMessage : signedMessage,
        signature: signature
    };
}
function $b5177f26f29fa44f$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    const byteArray = /* @__PURE__ */ new ArrayBuffer(4);
    new DataView(byteArray).setUint32(0, sequenceNumber, false);
    return new Uint8Array(byteArray);
}
//#endregion
//#region src/encryptedMessage.ts
const $b5177f26f29fa44f$var$INITIALIZATION_VECTOR_BYTES = 12;
async function $b5177f26f29fa44f$var$encryptMessage(plaintext, sequenceNumber, sharedSecret) {
    const sequenceNumberVector = $b5177f26f29fa44f$var$createSequenceNumberVector(sequenceNumber);
    const initializationVector = new Uint8Array($b5177f26f29fa44f$var$INITIALIZATION_VECTOR_BYTES);
    crypto.getRandomValues(initializationVector);
    const ciphertext = await crypto.subtle.encrypt($b5177f26f29fa44f$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, (0, $f97c98ce9ab46f75$export$882b5998b3b9117c)(plaintext));
    const response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
    response.set(new Uint8Array(sequenceNumberVector), 0);
    response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
    response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
    return response;
}
async function $b5177f26f29fa44f$var$decryptMessage(message, sharedSecret) {
    const sequenceNumberVector = message.slice(0, 4);
    const initializationVector = message.slice(4, 16);
    const ciphertext = message.slice(16);
    const plaintextBuffer = await crypto.subtle.decrypt($b5177f26f29fa44f$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext);
    return (0, $f97c98ce9ab46f75$export$db3b6bfb95261072)(new Uint8Array(plaintextBuffer));
}
function $b5177f26f29fa44f$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
//#endregion
//#region src/generateAssociationKeypair.ts
async function $b5177f26f29fa44f$var$generateAssociationKeypair() {
    return await crypto.subtle.generateKey({
        name: "ECDSA",
        namedCurve: "P-256"
    }, false, [
        "sign"
    ]);
}
//#endregion
//#region src/generateECDHKeypair.ts
async function $b5177f26f29fa44f$var$generateECDHKeypair() {
    return await crypto.subtle.generateKey({
        name: "ECDH",
        namedCurve: "P-256"
    }, false, [
        "deriveKey",
        "deriveBits"
    ]);
}
//#endregion
//#region src/associationPort.ts
function $b5177f26f29fa44f$var$getRandomAssociationPort() {
    return $b5177f26f29fa44f$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $b5177f26f29fa44f$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${port} given.`, {
        port: port
    });
    return port;
}
//#endregion
//#region src/getStringWithURLUnsafeBase64CharactersReplaced.ts
function $b5177f26f29fa44f$var$getStringWithURLUnsafeBase64CharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, (m)=>({
            "/": "_",
            "+": "-",
            "=": "."
        })[m]);
}
//#endregion
//#region src/getAssociateAndroidIntentURL.ts
const $b5177f26f29fa44f$var$INTENT_NAME = "solana-wallet";
function $b5177f26f29fa44f$var$getPathParts(pathString) {
    return pathString.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $b5177f26f29fa44f$var$getIntentURL(methodPathname, intentUrlBase) {
    let baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch  {}
        if (baseUrl?.protocol !== "https:") throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl ||= new URL(`${$b5177f26f29fa44f$var$INTENT_NAME}:/`);
    const pathname = methodPathname.startsWith("/") ? methodPathname : [
        ...$b5177f26f29fa44f$var$getPathParts(baseUrl.pathname),
        ...$b5177f26f29fa44f$var$getPathParts(methodPathname)
    ].join("/");
    return new URL(pathname, baseUrl);
}
async function $b5177f26f29fa44f$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase, protocolVersions = [
    "v1"
]) {
    const associationPort = $b5177f26f29fa44f$var$assertAssociationPort(putativePort);
    const exportedKey = await crypto.subtle.exportKey("raw", associationPublicKey);
    const encodedKey = (0, $f97c98ce9ab46f75$export$3b14a55fb2447963)(exportedKey);
    const url = $b5177f26f29fa44f$var$getIntentURL("v1/associate/local", associationURLBase);
    url.searchParams.set("association", $b5177f26f29fa44f$var$getStringWithURLUnsafeBase64CharactersReplaced(encodedKey));
    url.searchParams.set("port", `${associationPort}`);
    protocolVersions.forEach((version)=>{
        url.searchParams.set("v", version);
    });
    return url;
}
async function $b5177f26f29fa44f$var$getRemoteAssociateAndroidIntentURL(associationPublicKey, hostAuthority, reflectorId, associationURLBase, protocolVersions = [
    "v1"
]) {
    const exportedKey = await crypto.subtle.exportKey("raw", associationPublicKey);
    const encodedKey = (0, $f97c98ce9ab46f75$export$3b14a55fb2447963)(exportedKey);
    const url = $b5177f26f29fa44f$var$getIntentURL("v1/associate/remote", associationURLBase);
    url.searchParams.set("association", $b5177f26f29fa44f$var$getStringWithURLUnsafeBase64CharactersReplaced(encodedKey));
    url.searchParams.set("reflector", `${hostAuthority}`);
    url.searchParams.set("id", `${(0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(reflectorId, true)}`);
    protocolVersions.forEach((version)=>{
        url.searchParams.set("v", version);
    });
    return url;
}
async function $b5177f26f29fa44f$var$getNostrAssociateAndroidIntentURL(associationPublicKey, connectionType, relayDomain, dappNostrPubkey, associationURLBase, protocolVersions = [
    "v1"
]) {
    const exportedKey = await crypto.subtle.exportKey("raw", associationPublicKey);
    const encodedKey = (0, $f97c98ce9ab46f75$export$3b14a55fb2447963)(exportedKey);
    const url = $b5177f26f29fa44f$var$getIntentURL(`v1/associate/${connectionType}/nostr`, associationURLBase);
    url.searchParams.set("association", $b5177f26f29fa44f$var$getStringWithURLUnsafeBase64CharactersReplaced(encodedKey));
    url.searchParams.set("relay", relayDomain);
    url.searchParams.set("pubkey", dappNostrPubkey);
    protocolVersions.forEach((version)=>{
        url.searchParams.set("v", version);
    });
    return url;
}
//#endregion
//#region src/jsonRpcMessage.ts
async function $b5177f26f29fa44f$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    const plaintext = JSON.stringify(jsonRpcMessage);
    const sequenceNumber = jsonRpcMessage.id;
    return $b5177f26f29fa44f$var$encryptMessage(plaintext, sequenceNumber, sharedSecret);
}
async function $b5177f26f29fa44f$var$decryptJsonRpcMessage(message, sharedSecret) {
    const plaintext = await $b5177f26f29fa44f$var$decryptMessage(message, sharedSecret);
    const jsonRpcMessage = JSON.parse(plaintext);
    if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $b5177f26f29fa44f$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
    return jsonRpcMessage;
}
//#endregion
//#region src/parseHelloRsp.ts
async function $b5177f26f29fa44f$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    const [associationPublicKeyBuffer, walletPublicKey] = await Promise.all([
        crypto.subtle.exportKey("raw", associationPublicKey),
        crypto.subtle.importKey("raw", payloadBuffer.slice(0, 65), {
            name: "ECDH",
            namedCurve: "P-256"
        }, false, [])
    ]);
    const sharedSecret = await crypto.subtle.deriveBits({
        name: "ECDH",
        public: walletPublicKey
    }, ecdhPrivateKey, 256);
    const ecdhSecretKey = await crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
        "deriveKey"
    ]);
    return await crypto.subtle.deriveKey({
        name: "HKDF",
        hash: "SHA-256",
        salt: new Uint8Array(associationPublicKeyBuffer),
        info: /* @__PURE__ */ new Uint8Array()
    }, ecdhSecretKey, {
        name: "AES-GCM",
        length: 128
    }, false, [
        "encrypt",
        "decrypt"
    ]);
}
//#endregion
//#region src/parseSessionProps.ts
async function $b5177f26f29fa44f$var$parseSessionProps(message, sharedSecret) {
    const plaintext = await $b5177f26f29fa44f$var$decryptMessage(message, sharedSecret);
    const jsonProperties = JSON.parse(plaintext);
    let protocolVersion = "legacy";
    if (Object.hasOwnProperty.call(jsonProperties, "v")) switch(jsonProperties.v){
        case 1:
        case "1":
        case "v1":
            protocolVersion = "v1";
            break;
        case "legacy":
            protocolVersion = "legacy";
            break;
        default:
            throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_INVALID_PROTOCOL_VERSION, `Unknown/unsupported protocol version: ${jsonProperties.v}`);
    }
    return {
        protocol_version: protocolVersion
    };
}
//#endregion
//#region src/startSession.ts
const $b5177f26f29fa44f$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $b5177f26f29fa44f$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $b5177f26f29fa44f$var$Browser.Firefox : $b5177f26f29fa44f$var$Browser.Other;
}
function $b5177f26f29fa44f$var$getDetectionPromise() {
    return new Promise((resolve, reject)=>{
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject();
        }, 3e3);
    });
}
let $b5177f26f29fa44f$var$_frame = null;
function $b5177f26f29fa44f$var$launchUrlThroughHiddenFrame(url) {
    if ($b5177f26f29fa44f$var$_frame == null || !$b5177f26f29fa44f$var$_frame.isConnected) {
        $b5177f26f29fa44f$var$_frame = document.createElement("iframe");
        $b5177f26f29fa44f$var$_frame.style.display = "none";
        document.body.appendChild($b5177f26f29fa44f$var$_frame);
    }
    $b5177f26f29fa44f$var$_frame.contentWindow.location.href = url.toString();
}
async function $b5177f26f29fa44f$var$launchAssociation(associationUrl) {
    if (associationUrl.protocol === "https:") window.location.assign(associationUrl);
    else try {
        switch($b5177f26f29fa44f$var$getBrowser()){
            case $b5177f26f29fa44f$var$Browser.Firefox:
                $b5177f26f29fa44f$var$launchUrlThroughHiddenFrame(associationUrl);
                break;
            case $b5177f26f29fa44f$var$Browser.Other:
                {
                    const detectionPromise = $b5177f26f29fa44f$var$getDetectionPromise();
                    window.location.assign(associationUrl);
                    await detectionPromise;
                    break;
                }
        }
    } catch  {
        throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
    }
}
async function $b5177f26f29fa44f$var$startSession(associationPublicKey, associationURLBase) {
    const randomAssociationPort = $b5177f26f29fa44f$var$getRandomAssociationPort();
    await $b5177f26f29fa44f$var$launchAssociation(await $b5177f26f29fa44f$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase));
    return randomAssociationPort;
}
async function $b5177f26f29fa44f$var$startNostrSession(associationPublicKey, connectionType, relayDomain, dappNostrPubkey, associationURLBase) {
    const associationUrl = await $b5177f26f29fa44f$var$getNostrAssociateAndroidIntentURL(associationPublicKey, connectionType, relayDomain, dappNostrPubkey, associationURLBase);
    if (connectionType == "local") await $b5177f26f29fa44f$var$launchAssociation(associationUrl);
    return associationUrl;
}
//#endregion
//#region src/transact.ts
const $b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
	* 300 milliseconds is a generally accepted threshold for what someone
	* would consider an acceptable response time for a user interface
	* after having performed a low-attention tapping task. We set the initial
	* interval at which we wait for the wallet to set up the websocket at
	* half this, as per the Nyquist frequency, with a progressive backoff
	* sequence from there. The total wait time is 30s, which allows for the
	* user to be presented with a disambiguation dialog, select a wallet, and
	* for the wallet app to subsequently start.
	*/ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1e3
    ],
    timeoutMs: 3e4
};
const $b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BINARY = "com.solana.mobilewalletadapter.v1";
const $b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BASE64 = "com.solana.mobilewalletadapter.v1.base64";
function $b5177f26f29fa44f$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $b5177f26f29fa44f$var$assertSecureEndpointSpecificURI(walletUriBase) {
    let url;
    try {
        url = new URL(walletUriBase);
    } catch  {
        throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(byteArray) {
    return new DataView(byteArray).getUint32(0, false);
}
function $b5177f26f29fa44f$var$decodeVarLong(byteArray) {
    const bytes = new Uint8Array(byteArray);
    const l = byteArray.byteLength;
    const limit = 10;
    let value = 0, offset = 0, b;
    do {
        if (offset >= l || offset > limit) throw new RangeError("Failed to decode varint");
        b = bytes[offset++];
        value |= (b & 127) << 7 * offset;
    }while (b >= 128);
    return {
        value: value,
        offset: offset
    };
}
function $b5177f26f29fa44f$var$getReflectorIdFromByteArray(byteArray) {
    const { value: length, offset: offset } = $b5177f26f29fa44f$var$decodeVarLong(byteArray);
    return new Uint8Array(byteArray.slice(offset, offset + length));
}
async function $b5177f26f29fa44f$export$dac1bad6146b2469(callback, config) {
    const { wallet: wallet, close: close } = await $b5177f26f29fa44f$export$9878cac6881bd297(config);
    try {
        return await callback(await wallet);
    } finally{
        close();
    }
}
async function $b5177f26f29fa44f$export$9878cac6881bd297(config) {
    $b5177f26f29fa44f$var$assertSecureContext();
    const associationKeypair = await $b5177f26f29fa44f$var$generateAssociationKeypair();
    const websocketURL = `ws://localhost:${await $b5177f26f29fa44f$var$startSession(associationKeypair.publicKey, config?.baseUri)}/solana-wallet`;
    let connectionStartTime;
    const getNextRetryDelayMs = (()=>{
        const schedule = [
            ...$b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
        ];
        return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
    })();
    let nextJsonRpcMessageId = 1;
    let lastKnownInboundSequenceNumber = 0;
    let state = {
        __type: "disconnected"
    };
    let socket;
    let sessionEstablished = false;
    let handleForceClose;
    return {
        close: ()=>{
            socket.close();
            handleForceClose();
        },
        wallet: new Promise((resolve, reject)=>{
            const jsonRpcResponsePromises = {};
            const handleOpen = async ()=>{
                if (state.__type !== "connecting") {
                    console.warn(`Expected adapter state to be \`connecting\` at the moment the websocket opens. Got \`${state.__type}\`.`);
                    return;
                }
                socket.removeEventListener("open", handleOpen);
                const { associationKeypair: associationKeypair } = state;
                const ecdhKeypair = await $b5177f26f29fa44f$var$generateECDHKeypair();
                socket.send(await $b5177f26f29fa44f$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey));
                state = {
                    __type: "hello_req_sent",
                    associationPublicKey: associationKeypair.publicKey,
                    ecdhPrivateKey: ecdhKeypair.privateKey
                };
            };
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = async (_evt)=>{
                disposeSocket();
                if (Date.now() - connectionStartTime >= $b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket at ${websocketURL}.`));
                else {
                    await new Promise((resolve)=>{
                        const retryDelayMs = getNextRetryDelayMs();
                        retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                    });
                    attemptSocketConnection();
                }
            };
            const handleMessage = async (evt)=>{
                const responseBuffer = await evt.data.arrayBuffer();
                switch(state.__type){
                    case "connecting":
                        {
                            if (responseBuffer.byteLength !== 0) {
                                reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encountered unexpected message while connecting"));
                                return;
                            }
                            const ecdhKeypair = await $b5177f26f29fa44f$var$generateECDHKeypair();
                            socket.send(await $b5177f26f29fa44f$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey));
                            state = {
                                __type: "hello_req_sent",
                                associationPublicKey: associationKeypair.publicKey,
                                ecdhPrivateKey: ecdhKeypair.privateKey
                            };
                            break;
                        }
                    case "connected":
                        try {
                            const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(responseBuffer.slice(0, 4));
                            if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number");
                            lastKnownInboundSequenceNumber = sequenceNumber;
                            const jsonRpcMessage = await $b5177f26f29fa44f$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                            const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                            delete jsonRpcResponsePromises[jsonRpcMessage.id];
                            responsePromise.resolve(jsonRpcMessage.result);
                        } catch (e) {
                            if (e instanceof $b5177f26f29fa44f$export$58b788f937123c66) {
                                const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                responsePromise.reject(e);
                            } else throw e;
                        }
                        break;
                    case "hello_req_sent":
                        {
                            if (responseBuffer.byteLength === 0) {
                                const ecdhKeypair = await $b5177f26f29fa44f$var$generateECDHKeypair();
                                socket.send(await $b5177f26f29fa44f$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey));
                                state = {
                                    __type: "hello_req_sent",
                                    associationPublicKey: associationKeypair.publicKey,
                                    ecdhPrivateKey: ecdhKeypair.privateKey
                                };
                                break;
                            }
                            const sharedSecret = await $b5177f26f29fa44f$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                            const sessionPropertiesBuffer = responseBuffer.slice(65);
                            const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? await (async ()=>{
                                const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(sessionPropertiesBuffer.slice(0, 4));
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) {
                                    reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number"));
                                    socket.close();
                                    return {
                                        protocol_version: "v1"
                                    };
                                }
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                return $b5177f26f29fa44f$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                            })() : {
                                protocol_version: "legacy"
                            };
                            state = {
                                __type: "connected",
                                sharedSecret: sharedSecret,
                                sessionProperties: sessionProperties
                            };
                            const wallet = $b5177f26f29fa44f$var$createMobileWalletProxy(sessionProperties.protocol_version, async (method, params)=>{
                                const id = nextJsonRpcMessageId++;
                                socket.send(await $b5177f26f29fa44f$var$encryptJsonRpcMessage({
                                    id: id,
                                    jsonrpc: "2.0",
                                    method: method,
                                    params: params ?? {}
                                }, sharedSecret));
                                return new Promise((resolve, reject)=>{
                                    jsonRpcResponsePromises[id] = {
                                        resolve (result) {
                                            switch(method){
                                                case "authorize":
                                                case "reauthorize":
                                                    {
                                                        const { wallet_uri_base: wallet_uri_base } = result;
                                                        if (wallet_uri_base != null) try {
                                                            $b5177f26f29fa44f$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                        } catch (e) {
                                                            reject(e);
                                                            return;
                                                        }
                                                        break;
                                                    }
                                            }
                                            resolve(result);
                                        },
                                        reject: reject
                                    };
                                });
                            });
                            sessionEstablished = true;
                            try {
                                resolve(wallet);
                            } catch (e) {
                                reject(e);
                            }
                            break;
                        }
                }
            };
            handleForceClose = ()=>{
                socket.removeEventListener("message", handleMessage);
                disposeSocket();
                if (!sessionEstablished) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session was closed before connection.`, {
                    closeEvent: new CloseEvent("socket was closed before connection")
                }));
            };
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                if (connectionStartTime === void 0) connectionStartTime = Date.now();
                socket = new WebSocket(websocketURL, [
                    $b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BINARY
                ]);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        })
    };
}
async function $b5177f26f29fa44f$export$8de2984f0eeb5c1f(config) {
    $b5177f26f29fa44f$var$assertSecureContext();
    const associationKeypair = await $b5177f26f29fa44f$var$generateAssociationKeypair();
    const websocketURL = `wss://${config?.remoteHostAuthority}/reflect`;
    let connectionStartTime;
    const getNextRetryDelayMs = (()=>{
        const schedule = [
            ...$b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
        ];
        return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
    })();
    let nextJsonRpcMessageId = 1;
    let lastKnownInboundSequenceNumber = 0;
    let encoding;
    let state = {
        __type: "disconnected"
    };
    let socket;
    let disposeSocket;
    const decodeBytes = async (evt)=>{
        if (encoding == "base64") {
            const message = await evt.data;
            return (0, $f97c98ce9ab46f75$export$953cecd6e717a553)(message).buffer;
        } else return await evt.data.arrayBuffer();
    };
    const associationUrl = await new Promise((resolve, reject)=>{
        const handleOpen = async ()=>{
            if (state.__type !== "connecting") {
                console.warn(`Expected adapter state to be \`connecting\` at the moment the websocket opens. Got \`${state.__type}\`.`);
                return;
            }
            if (socket.protocol.includes($b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BASE64)) encoding = "base64";
            else encoding = "binary";
            socket.removeEventListener("open", handleOpen);
        };
        const handleClose = (evt)=>{
            if (evt.wasClean) state = {
                __type: "disconnected"
            };
            else reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                closeEvent: evt
            }));
            disposeSocket();
        };
        const handleError = async (_evt)=>{
            disposeSocket();
            if (Date.now() - connectionStartTime >= $b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket at ${websocketURL}.`));
            else {
                await new Promise((resolve)=>{
                    const retryDelayMs = getNextRetryDelayMs();
                    retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                });
                attemptSocketConnection();
            }
        };
        const handleReflectorIdMessage = async (evt)=>{
            const responseBuffer = await decodeBytes(evt);
            if (state.__type === "connecting") {
                if (responseBuffer.byteLength == 0) {
                    reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encountered unexpected message while connecting"));
                    socket.close();
                    return;
                }
                const reflectorId = $b5177f26f29fa44f$var$getReflectorIdFromByteArray(responseBuffer);
                state = {
                    __type: "reflector_id_received",
                    reflectorId: reflectorId
                };
                const associationUrl = await $b5177f26f29fa44f$var$getRemoteAssociateAndroidIntentURL(associationKeypair.publicKey, config.remoteHostAuthority, reflectorId, config?.baseUri);
                socket.removeEventListener("message", handleReflectorIdMessage);
                resolve(associationUrl);
            }
        };
        let retryWaitTimeoutId;
        const attemptSocketConnection = ()=>{
            if (disposeSocket) disposeSocket();
            state = {
                __type: "connecting",
                associationKeypair: associationKeypair
            };
            if (connectionStartTime === void 0) connectionStartTime = Date.now();
            socket = new WebSocket(websocketURL, [
                $b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BINARY,
                $b5177f26f29fa44f$var$WEBSOCKET_PROTOCOL_BASE64
            ]);
            socket.addEventListener("open", handleOpen);
            socket.addEventListener("close", handleClose);
            socket.addEventListener("error", handleError);
            socket.addEventListener("message", handleReflectorIdMessage);
            disposeSocket = ()=>{
                window.clearTimeout(retryWaitTimeoutId);
                socket.removeEventListener("open", handleOpen);
                socket.removeEventListener("close", handleClose);
                socket.removeEventListener("error", handleError);
                socket.removeEventListener("message", handleReflectorIdMessage);
            };
        };
        attemptSocketConnection();
    });
    let sessionEstablished = false;
    let handleClose;
    return {
        associationUrl: associationUrl,
        close: ()=>{
            socket.close();
            handleClose();
        },
        wallet: new Promise((resolve, reject)=>{
            const jsonRpcResponsePromises = {};
            const handleMessage = async (evt)=>{
                const responseBuffer = await decodeBytes(evt);
                switch(state.__type){
                    case "reflector_id_received":
                        {
                            if (responseBuffer.byteLength !== 0) {
                                reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encountered unexpected message while awaiting reflection"));
                                socket.close();
                                return;
                            }
                            const ecdhKeypair = await $b5177f26f29fa44f$var$generateECDHKeypair();
                            const binaryMsg = await $b5177f26f29fa44f$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey);
                            if (encoding == "base64") socket.send((0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(binaryMsg));
                            else socket.send(binaryMsg);
                            state = {
                                __type: "hello_req_sent",
                                associationPublicKey: associationKeypair.publicKey,
                                ecdhPrivateKey: ecdhKeypair.privateKey
                            };
                            break;
                        }
                    case "connected":
                        try {
                            const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(responseBuffer.slice(0, 4));
                            if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number");
                            lastKnownInboundSequenceNumber = sequenceNumber;
                            const jsonRpcMessage = await $b5177f26f29fa44f$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                            const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                            delete jsonRpcResponsePromises[jsonRpcMessage.id];
                            responsePromise.resolve(jsonRpcMessage.result);
                        } catch (e) {
                            if (e instanceof $b5177f26f29fa44f$export$58b788f937123c66) {
                                const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                responsePromise.reject(e);
                            } else throw e;
                        }
                        break;
                    case "hello_req_sent":
                        {
                            const sharedSecret = await $b5177f26f29fa44f$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                            const sessionPropertiesBuffer = responseBuffer.slice(65);
                            const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? await (async ()=>{
                                const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(sessionPropertiesBuffer.slice(0, 4));
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) {
                                    reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number"));
                                    socket.close();
                                    return {
                                        protocol_version: "v1"
                                    };
                                }
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                return $b5177f26f29fa44f$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                            })() : {
                                protocol_version: "legacy"
                            };
                            state = {
                                __type: "connected",
                                sharedSecret: sharedSecret,
                                sessionProperties: sessionProperties
                            };
                            const wallet = $b5177f26f29fa44f$var$createMobileWalletProxy(sessionProperties.protocol_version, async (method, params)=>{
                                const id = nextJsonRpcMessageId++;
                                const binaryMsg = await $b5177f26f29fa44f$var$encryptJsonRpcMessage({
                                    id: id,
                                    jsonrpc: "2.0",
                                    method: method,
                                    params: params ?? {}
                                }, sharedSecret);
                                if (encoding == "base64") socket.send((0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(binaryMsg));
                                else socket.send(binaryMsg);
                                return new Promise((resolve, reject)=>{
                                    jsonRpcResponsePromises[id] = {
                                        resolve (result) {
                                            switch(method){
                                                case "authorize":
                                                case "reauthorize":
                                                    {
                                                        const { wallet_uri_base: wallet_uri_base } = result;
                                                        if (wallet_uri_base != null) try {
                                                            $b5177f26f29fa44f$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                        } catch (e) {
                                                            reject(e);
                                                            return;
                                                        }
                                                        break;
                                                    }
                                            }
                                            resolve(result);
                                        },
                                        reject: reject
                                    };
                                });
                            });
                            sessionEstablished = true;
                            try {
                                resolve(wallet);
                            } catch (e) {
                                reject(e);
                            }
                            break;
                        }
                }
            };
            socket.addEventListener("message", handleMessage);
            handleClose = ()=>{
                socket.removeEventListener("message", handleMessage);
                disposeSocket();
                if (!sessionEstablished) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session was closed before connection.`, {
                    closeEvent: new CloseEvent("socket was closed before connection")
                }));
            };
        })
    };
}
async function $b5177f26f29fa44f$export$d30526da7f04b709(config) {
    $b5177f26f29fa44f$var$assertSecureContext();
    const associationKeypair = await $b5177f26f29fa44f$var$generateAssociationKeypair();
    const { privateKey: dappNostrPrivateKey, publicKey: dappNostrPubkey } = $b5177f26f29fa44f$export$6b56ae5ba13d5d8f();
    const associationUrl = await $b5177f26f29fa44f$var$startNostrSession(associationKeypair.publicKey, config.connectionType, config.relayDomain, dappNostrPubkey, config.baseUri);
    const sessionIdentifier = await $b5177f26f29fa44f$export$ec842aab867c14a3(associationKeypair.publicKey);
    const subscriptionId = crypto.randomUUID();
    const webSocketURL = `wss://${config.relayDomain}`;
    const connectionStartTime = Date.now();
    const getNextRetryDelayMs = (()=>{
        const schedule = [
            ...$b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
        ];
        return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
    })();
    let nextJsonRpcMessageId = 1;
    let lastKnownInboundSequenceNumber = 0;
    let state = {
        __type: "disconnected"
    };
    let socket;
    let sessionEstablished = false;
    let handleForceClose;
    const sendNostrEvent = (content, walletPubkey)=>{
        const event = $b5177f26f29fa44f$export$5276f5ebd0ea7dde($b5177f26f29fa44f$export$8901aba29937dfc8, content, [
            [
                "d",
                sessionIdentifier
            ],
            [
                "p",
                walletPubkey
            ]
        ], dappNostrPrivateKey);
        socket.send(JSON.stringify([
            "EVENT",
            event
        ]));
    };
    const doClose = ()=>{
        if (state.__type == "connected" || state.__type == "hello_req_sent") {
            const event = $b5177f26f29fa44f$export$5276f5ebd0ea7dde($b5177f26f29fa44f$export$8901aba29937dfc8, "", [
                [
                    "d",
                    sessionIdentifier
                ],
                [
                    "p",
                    state.walletNostrPubkey
                ],
                [
                    "msg",
                    "SESSION_END"
                ]
            ], dappNostrPrivateKey);
            socket.send(JSON.stringify([
                "EVENT",
                event
            ]));
        }
        socket.close();
    };
    const scenario = {
        close: ()=>{
            doClose();
            handleForceClose();
        },
        wallet: new Promise((resolve, reject)=>{
            const jsonRpcResponsePromises = {};
            const handleOpen = async ()=>{
                if (state.__type !== "connecting") {
                    console.warn(`Expected adapter state to be \`connecting\` at the moment the websocket opens. Got \`${state.__type}\`.`);
                    return;
                }
                socket.removeEventListener("open", handleOpen);
                socket.send(JSON.stringify([
                    "REQ",
                    subscriptionId,
                    {
                        kinds: [
                            $b5177f26f29fa44f$export$8901aba29937dfc8
                        ],
                        "#d": [
                            sessionIdentifier
                        ]
                    }
                ]));
                state = {
                    __type: "subscribed",
                    dappNostrPrivateKey: dappNostrPrivateKey,
                    dappNostrPubkey: dappNostrPubkey,
                    sessionIdentifier: sessionIdentifier
                };
            };
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The Nostr subscription dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = async ()=>{
                disposeSocket();
                if (Date.now() - connectionStartTime >= $b5177f26f29fa44f$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the Nostr relay at ${config.relayDomain}.`));
                else {
                    await new Promise((resolve)=>{
                        const retryDelayMs = getNextRetryDelayMs();
                        retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                    });
                    attemptSocketConnection();
                }
            };
            const handleMessage = async (evt)=>{
                let msg;
                try {
                    msg = JSON.parse(evt.data);
                    if (!Array.isArray(msg)) throw new Error();
                } catch  {
                    reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Invalid Nostr message received: " + evt.data));
                    doClose();
                    return;
                }
                const type = msg[0];
                if (type === "CLOSED") disposeSocket();
                else if (type === "EVENT") {
                    const event = msg[2];
                    if (!event || !$b5177f26f29fa44f$export$7785d6e706482c9a(event)) return;
                    switch(state.__type){
                        case "subscribed":
                            {
                                if (event.content.length !== 0) {
                                    reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encountered unexpected message while awaiting reflection"));
                                    doClose();
                                    return;
                                }
                                const walletNostrPubkey = event.pubkey;
                                const ecdhKeypair = await $b5177f26f29fa44f$var$generateECDHKeypair();
                                const helloReq = await $b5177f26f29fa44f$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey);
                                const base64Content = (0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(helloReq);
                                sendNostrEvent(base64Content, walletNostrPubkey);
                                state = {
                                    __type: "hello_req_sent",
                                    associationPublicKey: associationKeypair.publicKey,
                                    ecdhPrivateKey: ecdhKeypair.privateKey,
                                    walletNostrPubkey: walletNostrPubkey
                                };
                                break;
                            }
                        case "hello_req_sent":
                            {
                                if (event.pubkey !== state.walletNostrPubkey) return;
                                if (event.content === "") return;
                                const responseBuffer = (0, $f97c98ce9ab46f75$export$953cecd6e717a553)(event.content).buffer;
                                const sharedSecret = await $b5177f26f29fa44f$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                const sessionPropertiesBuffer = responseBuffer.slice(65);
                                const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? await (async ()=>{
                                    const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(sessionPropertiesBuffer.slice(0, 4));
                                    if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) {
                                        reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number"));
                                        doClose();
                                        return {
                                            protocol_version: "v1"
                                        };
                                    }
                                    lastKnownInboundSequenceNumber = sequenceNumber;
                                    return $b5177f26f29fa44f$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                                })() : {
                                    protocol_version: "legacy"
                                };
                                state = {
                                    __type: "connected",
                                    sharedSecret: sharedSecret,
                                    sessionProperties: sessionProperties,
                                    walletNostrPubkey: state.walletNostrPubkey
                                };
                                const wallet = $b5177f26f29fa44f$var$createMobileWalletProxy(sessionProperties.protocol_version, async (method, params)=>{
                                    const id = nextJsonRpcMessageId++;
                                    const binaryMsg = await $b5177f26f29fa44f$var$encryptJsonRpcMessage({
                                        id: id,
                                        jsonrpc: "2.0",
                                        method: method,
                                        params: params ?? {}
                                    }, sharedSecret);
                                    sendNostrEvent((0, $f97c98ce9ab46f75$export$ffb5f4729a158638)(binaryMsg), state.walletNostrPubkey);
                                    return new Promise((resolve, reject)=>{
                                        jsonRpcResponsePromises[id] = {
                                            resolve (result) {
                                                switch(method){
                                                    case "authorize":
                                                    case "reauthorize":
                                                        {
                                                            const { wallet_uri_base: wallet_uri_base } = result;
                                                            if (wallet_uri_base != null) try {
                                                                $b5177f26f29fa44f$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                            } catch (e) {
                                                                reject(e);
                                                                return;
                                                            }
                                                            break;
                                                        }
                                                }
                                                resolve(result);
                                            },
                                            reject: reject
                                        };
                                    });
                                });
                                sessionEstablished = true;
                                try {
                                    resolve(wallet);
                                } catch (e) {
                                    reject(e);
                                }
                                break;
                            }
                        case "connected":
                            if (event.pubkey !== state.walletNostrPubkey) return;
                            if (event.content === "") return;
                            try {
                                const responseBuffer = (0, $f97c98ce9ab46f75$export$953cecd6e717a553)(event.content).buffer;
                                const sequenceNumber = $b5177f26f29fa44f$var$getSequenceNumberFromByteArray(responseBuffer.slice(0, 4));
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_ILLEGAL_TRANSPORT_STATE, "Encrypted message has invalid sequence number");
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                const jsonRpcMessage = await $b5177f26f29fa44f$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                responsePromise.resolve(jsonRpcMessage.result);
                            } catch (e) {
                                if (e instanceof $b5177f26f29fa44f$export$58b788f937123c66) {
                                    const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    responsePromise.reject(e);
                                } else throw e;
                            }
                    }
                }
            };
            handleForceClose = ()=>{
                socket.removeEventListener("message", handleMessage);
                disposeSocket();
                if (!sessionEstablished) reject(new $b5177f26f29fa44f$export$d77545679c409b63($b5177f26f29fa44f$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session was closed before connection.`, {
                    closeEvent: new CloseEvent("socket was closed before connection")
                }));
            };
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                socket = new WebSocket(webSocketURL);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        })
    };
    if (config.connectionType == "local") return scenario;
    else return {
        ...scenario,
        associationUrl: associationUrl
    };
}



/** Name of the feature. */ const $744408f28809a335$export$cc68487eeb93b1d4 = 'standard:connect';
const $744408f28809a335$export$59e6910693f047c2 = $744408f28809a335$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $393285782087969c$export$38dbd4bbb9b696e6 = 'standard:disconnect';
const $393285782087969c$export$9e282393ab352bcd = $393285782087969c$export$38dbd4bbb9b696e6;

/** Name of the feature. */ const $f4859eee1867cbdd$export$5296443ca9e9fa0f = 'standard:events';
const $f4859eee1867cbdd$export$ada873a34909da65 = $f4859eee1867cbdd$export$5296443ca9e9fa0f;


var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== 'undefined';
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $d22956012916b666$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $d22956012916b666$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = '[0-9]+';
const $d479c387334094fb$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, '\\u');
const $d479c387334094fb$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $d479c387334094fb$var$kanji + ')(?:.|[\r\n]))+';
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, 'g');
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, 'g');
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, 'g');
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, 'g');
const $d479c387334094fb$var$TEST_KANJI = new RegExp('^' + $d479c387334094fb$var$kanji + '$');
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp('^' + $d479c387334094fb$var$numeric + '$');
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case 'alphanumeric':
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case 'kanji':
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case 'byte':
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};

function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + '.\n Suggested mode is: ' + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd('M', col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


//#region src/createDefaultAuthorizationCache.ts
const $5281e12b82edb2e4$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $5281e12b82edb2e4$export$feee530a776f5153() {
    let storage;
    try {
        storage = window.localStorage;
    } catch  {}
    return {
        async clear () {
            if (!storage) return;
            try {
                storage.removeItem($5281e12b82edb2e4$var$CACHE_KEY);
            } catch  {}
        },
        async get () {
            if (!storage) return;
            try {
                const parsed = JSON.parse(storage.getItem($5281e12b82edb2e4$var$CACHE_KEY));
                if (parsed && parsed.accounts) {
                    const parsedAccounts = parsed.accounts.map((account)=>{
                        return {
                            ...account,
                            publicKey: "publicKey" in account ? new Uint8Array(Object.values(account.publicKey)) : (0, $f97c98ce9ab46f75$export$7ccc53e8f1e7dfc5)(account.address)
                        };
                    });
                    return {
                        ...parsed,
                        accounts: parsedAccounts
                    };
                } else return parsed || void 0;
            } catch  {}
        },
        async set (authorization) {
            if (!storage) return;
            try {
                storage.setItem($5281e12b82edb2e4$var$CACHE_KEY, JSON.stringify(authorization));
            } catch  {}
        }
    };
}
//#endregion
//#region src/createDefaultChainSelector.ts
function $5281e12b82edb2e4$export$6b2da63ffd66543a() {
    return {
        async select (chains) {
            if (chains.length === 1) return chains[0];
            else if (chains.includes((0, $54a90126d2f96ce7$export$bba9a228295b3963))) return 0, $54a90126d2f96ce7$export$bba9a228295b3963;
            else return chains[0];
        }
    };
}
//#endregion
//#region src/embedded-modal/modal.ts
const $5281e12b82edb2e4$var$modalHtml$1 = `
<div class="mobile-wallet-adapter-embedded-modal-container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
    <div data-modal-close style="position: absolute; width: 100%; height: 100%;"></div>
	<div class="mobile-wallet-adapter-embedded-modal-card">
		<div>
			<button data-modal-close class="mobile-wallet-adapter-embedded-modal-close">
				<svg width="14" height="14">
					<path d="M 6.7125,8.3036995 1.9082,13.108199 c -0.2113,0.2112 -0.4765,0.3168 -0.7957,0.3168 -0.3192,0 -0.5844,-0.1056 -0.7958,-0.3168 C 0.1056,12.896899 0,12.631699 0,12.312499 c 0,-0.3192 0.1056,-0.5844 0.3167,-0.7958 L 5.1212,6.7124995 0.3167,1.9082 C 0.1056,1.6969 0,1.4317 0,1.1125 0,0.7933 0.1056,0.5281 0.3167,0.3167 0.5281,0.1056 0.7933,0 1.1125,0 1.4317,0 1.6969,0.1056 1.9082,0.3167 L 6.7125,5.1212 11.5167,0.3167 C 11.7281,0.1056 11.9933,0 12.3125,0 c 0.3192,0 0.5844,0.1056 0.7957,0.3167 0.2112,0.2114 0.3168,0.4766 0.3168,0.7958 0,0.3192 -0.1056,0.5844 -0.3168,0.7957 L 8.3037001,6.7124995 13.1082,11.516699 c 0.2112,0.2114 0.3168,0.4766 0.3168,0.7958 0,0.3192 -0.1056,0.5844 -0.3168,0.7957 -0.2113,0.2112 -0.4765,0.3168 -0.7957,0.3168 -0.3192,0 -0.5844,-0.1056 -0.7958,-0.3168 z" />
				</svg>
			</button>
		</div>
		<div class="mobile-wallet-adapter-embedded-modal-content"></div>
	</div>
</div>
`;
const $5281e12b82edb2e4$var$css$6 = `
.mobile-wallet-adapter-embedded-modal-container {
    display: flex; /* Use flexbox to center content */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: fixed; /* Stay in place */
    z-index: 2147483647; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    overflow-y: auto; /* enable scrolling */
}

.mobile-wallet-adapter-embedded-modal-card {
    display: flex;
    flex-direction: column;
    margin: auto 20px;
    max-width: 780px;
    padding: 20px;
    border-radius: 24px;
    background: #ffffff;
    font-family: "Inter Tight", "PT Sans", Calibri, sans-serif;
    transform: translateY(-200%);
    animation: slide-in 0.5s forwards;
}

@keyframes slide-in {
    100% { transform: translateY(0%); }
}

.mobile-wallet-adapter-embedded-modal-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    background: #e4e9e9;
    border: none;
    border-radius: 50%;
}

.mobile-wallet-adapter-embedded-modal-close:focus-visible {
    outline-color: red;
}

.mobile-wallet-adapter-embedded-modal-close svg {
    fill: #546266;
    transition: fill 200ms ease 0s;
}

.mobile-wallet-adapter-embedded-modal-close:hover svg {
    fill: #fff;
}
`;
const $5281e12b82edb2e4$var$fonts = `
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Inter+Tight:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
`;
var $5281e12b82edb2e4$var$EmbeddedModal = class {
    #root = null;
    #eventListeners = {};
    #listenersAttached = false;
    dom = null;
    constructor(){
        this.init = this.init.bind(this);
        this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
    }
    async init() {
        console.log("Injecting modal");
        this.#injectHTML();
    }
    open = ()=>{
        console.debug("Modal open");
        this.#attachEventListeners();
        if (this.#root) this.#root.style.display = "flex";
    };
    close = (event)=>{
        console.debug("Modal close");
        this.#removeEventListeners();
        if (this.#root) this.#root.style.display = "none";
        this.#eventListeners["close"]?.forEach((listener)=>listener(event));
    };
    addEventListener(event, listener) {
        this.#eventListeners[event]?.push(listener) || (this.#eventListeners[event] = [
            listener
        ]);
        return ()=>this.removeEventListener(event, listener);
    }
    removeEventListener(event, listener) {
        this.#eventListeners[event] = this.#eventListeners[event]?.filter((existingListener)=>listener !== existingListener);
    }
    #injectHTML() {
        if (document.getElementById("mobile-wallet-adapter-embedded-root-ui")) {
            if (!this.#root) this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
            return;
        }
        this.#root = document.createElement("div");
        this.#root.id = "mobile-wallet-adapter-embedded-root-ui";
        this.#root.innerHTML = $5281e12b82edb2e4$var$modalHtml$1;
        this.#root.style.display = "none";
        const content = this.#root.querySelector(".mobile-wallet-adapter-embedded-modal-content");
        if (content) content.innerHTML = this.contentHtml;
        const styles = document.createElement("style");
        styles.id = "mobile-wallet-adapter-embedded-modal-styles";
        styles.textContent = $5281e12b82edb2e4$var$css$6 + this.contentStyles;
        const host = document.createElement("div");
        host.innerHTML = $5281e12b82edb2e4$var$fonts;
        this.dom = host.attachShadow({
            mode: "closed"
        });
        this.dom.appendChild(styles);
        this.dom.appendChild(this.#root);
        document.body.appendChild(host);
    }
    #attachEventListeners() {
        if (!this.#root || this.#listenersAttached) return;
        [
            ...this.#root.querySelectorAll("[data-modal-close]")
        ].forEach((closer)=>closer?.addEventListener("click", this.close));
        window.addEventListener("load", this.close);
        document.addEventListener("keydown", this.#handleKeyDown);
        this.#listenersAttached = true;
    }
    #removeEventListeners() {
        if (!this.#listenersAttached) return;
        window.removeEventListener("load", this.close);
        document.removeEventListener("keydown", this.#handleKeyDown);
        if (!this.#root) return;
        [
            ...this.#root.querySelectorAll("[data-modal-close]")
        ].forEach((closer)=>closer?.removeEventListener("click", this.close));
        this.#listenersAttached = false;
    }
    #handleKeyDown = (event)=>{
        if (event.key === "Escape") this.close(event);
    };
};
//#endregion
//#region src/embedded-modal/errorModal.ts
const $5281e12b82edb2e4$var$WALLET_NOT_FOUND_ERROR_MESSAGE = "To use mobile wallet adapter, you must have a compatible mobile wallet application installed on your device.";
const $5281e12b82edb2e4$var$BROWSER_NOT_SUPPORTED_ERROR_MESSAGE = "This browser appears to be incompatible with mobile wallet adapter. Open this page in a compatible mobile browser app and try again.";
var $5281e12b82edb2e4$var$ErrorModal = class extends $5281e12b82edb2e4$var$EmbeddedModal {
    contentStyles = $5281e12b82edb2e4$var$css$5;
    contentHtml = $5281e12b82edb2e4$var$ErrorDialogHtml$3;
    initWithError(error) {
        super.init();
        this.populateError(error);
    }
    populateError(error) {
        const errorMessageElement = this.dom?.getElementById("mobile-wallet-adapter-error-message");
        const actionBtn = this.dom?.getElementById("mobile-wallet-adapter-error-action");
        if (errorMessageElement) {
            if (error.name === "SolanaMobileWalletAdapterError") switch(error.code){
                case "ERROR_WALLET_NOT_FOUND":
                    errorMessageElement.innerHTML = $5281e12b82edb2e4$var$WALLET_NOT_FOUND_ERROR_MESSAGE;
                    if (actionBtn) actionBtn.addEventListener("click", ()=>{
                        window.location.href = "https://solanamobile.com/wallets";
                    });
                    return;
                case "ERROR_BROWSER_NOT_SUPPORTED":
                    errorMessageElement.innerHTML = $5281e12b82edb2e4$var$BROWSER_NOT_SUPPORTED_ERROR_MESSAGE;
                    if (actionBtn) actionBtn.style.display = "none";
                    return;
            }
            errorMessageElement.innerHTML = `An unexpected error occurred: ${error.message}`;
        } else console.log("Failed to locate error dialog element");
    }
};
const $5281e12b82edb2e4$var$ErrorDialogHtml$3 = `
<svg class="mobile-wallet-adapter-embedded-modal-error-icon" xmlns="http://www.w3.org/2000/svg" height="50px" viewBox="0 -960 960 960" width="50px" fill="#000000"><path d="M 280,-80 Q 197,-80 138.5,-138.5 80,-197 80,-280 80,-363 138.5,-421.5 197,-480 280,-480 q 83,0 141.5,58.5 58.5,58.5 58.5,141.5 0,83 -58.5,141.5 Q 363,-80 280,-80 Z M 824,-120 568,-376 Q 556,-389 542.5,-402.5 529,-416 516,-428 q 38,-24 61,-64 23,-40 23,-88 0,-75 -52.5,-127.5 Q 495,-760 420,-760 345,-760 292.5,-707.5 240,-655 240,-580 q 0,6 0.5,11.5 0.5,5.5 1.5,11.5 -18,2 -39.5,8 -21.5,6 -38.5,14 -2,-11 -3,-22 -1,-11 -1,-23 0,-109 75.5,-184.5 Q 311,-840 420,-840 q 109,0 184.5,75.5 75.5,75.5 75.5,184.5 0,43 -13.5,81.5 Q 653,-460 629,-428 l 251,252 z m -615,-61 71,-71 70,71 29,-28 -71,-71 71,-71 -28,-28 -71,71 -71,-71 -28,28 71,71 -71,71 z"/></svg>
<div class="mobile-wallet-adapter-embedded-modal-title">We can't find a wallet.</div>
<div id="mobile-wallet-adapter-error-message" class="mobile-wallet-adapter-embedded-modal-subtitle"></div>
<div>
    <button data-error-action id="mobile-wallet-adapter-error-action" class="mobile-wallet-adapter-embedded-modal-error-action">
        Find a wallet
    </button>
</div>
`;
const $5281e12b82edb2e4$var$css$5 = `
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}

.mobile-wallet-adapter-embedded-modal-error-icon {
    margin-top: 24px;
}

.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}

.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 30px 60px 40px 60px;
    color: #000000;
    font-size: 1.25em;
    font-weight: 400;
}

.mobile-wallet-adapter-embedded-modal-error-action {
    display: block;
    width: 100%;
    height: 56px;
    /*margin-top: 40px;*/
    font-size: 1.25em;
    /*line-height: 24px;*/
    /*letter-spacing: -1%;*/
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}

/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/createDefaultWalletNotFoundHandler.ts
async function $5281e12b82edb2e4$export$b3dc230575b36468() {
    if (typeof window !== "undefined") {
        const userAgent = window.navigator.userAgent.toLowerCase();
        const errorDialog = new $5281e12b82edb2e4$var$ErrorModal();
        if (userAgent.includes("wv")) errorDialog.initWithError({
            name: "SolanaMobileWalletAdapterError",
            code: "ERROR_BROWSER_NOT_SUPPORTED",
            message: ""
        });
        else errorDialog.initWithError({
            name: "SolanaMobileWalletAdapterError",
            code: "ERROR_WALLET_NOT_FOUND",
            message: ""
        });
        errorDialog.open();
    }
}
function $5281e12b82edb2e4$export$e8b9e70cdf783b70() {
    return async ()=>{
        $5281e12b82edb2e4$export$b3dc230575b36468();
    };
}
//#endregion
//#region src/embedded-modal/localConnectionModal.ts
var $5281e12b82edb2e4$var$LocalConnectionModal = class extends $5281e12b82edb2e4$var$EmbeddedModal {
    contentStyles = $5281e12b82edb2e4$var$css$4;
    contentHtml = $5281e12b82edb2e4$var$ErrorDialogHtml$2;
    initWithCallback(callback) {
        super.init();
        this.#prepareLaunchAction(callback);
    }
    #prepareLaunchAction(callback) {
        const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
        const listener = async ()=>{
            launchButton?.removeEventListener("click", listener);
            this.close();
            callback();
        };
        launchButton?.addEventListener("click", listener);
    }
};
const $5281e12b82edb2e4$var$ErrorDialogHtml$2 = `
<svg class="mobile-wallet-adapter-embedded-modal-launch-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6 48C7.2 48 0 40.8 0 26.4V21.6C0 7.2 7.2 0 21.6 0H26.4C40.8 0 48 7.2 48 21.6V26.4C48 40.8 40.8 48 26.4 48H21.6Z" fill="#15994E"/>
    <mask id="mask0_189_522" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
        <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_189_522)">
        <mask id="mask1_189_522" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
            <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask1_189_522)">
            <path d="M22.1092 26.1208L19.4498 23.4615C19.1736 23.1851 18.8253 23.0468 18.4048 23.0468C17.9846 23.0468 17.6363 23.1851 17.3598 23.4615C17.0836 23.7377 16.9468 24.0861 16.9495 24.5065C16.9522 24.9267 17.0916 25.275 17.3678 25.5512L21.0405 29.2238C21.3463 29.5276 21.7031 29.6795 22.1108 29.6795C22.5184 29.6795 22.8742 29.5276 23.1782 29.2238L30.5918 21.8098C30.8683 21.5336 31.0065 21.1867 31.0065 20.7692C31.0065 20.3514 30.8683 20.0044 30.5918 19.7282C30.3156 19.4517 29.9673 19.3135 29.5468 19.3135C29.1266 19.3135 28.7784 19.4517 28.5022 19.7282L22.1092 26.1208ZM23.9998 37.6042C22.113 37.6042 20.3425 37.2473 18.6885 36.5335C17.0343 35.8197 15.5954 34.8512 14.3718 33.6278C13.1485 32.4043 12.18 30.9654 11.4662 29.3112C10.7524 27.6572 10.3955 25.8867 10.3955 23.9998C10.3955 22.113 10.7524 20.3425 11.4662 18.6885C12.18 17.0343 13.1485 15.5954 14.3718 14.3718C15.5954 13.1485 17.0343 12.18 18.6885 11.4662C20.3425 10.7524 22.113 10.3955 23.9998 10.3955C25.8867 10.3955 27.6572 10.7524 29.3112 11.4662C30.9654 12.18 32.4043 13.1485 33.6278 14.3718C34.8512 15.5954 35.8197 17.0343 36.5335 18.6885C37.2473 20.3425 37.6042 22.113 37.6042 23.9998C37.6042 25.8867 37.2473 27.6572 36.5335 29.3112C35.8197 30.9654 34.8512 32.4043 33.6278 33.6278C32.4043 34.8512 30.9654 35.8197 29.3112 36.5335C27.6572 37.2473 25.8867 37.6042 23.9998 37.6042Z" fill="white"/>
        </g>
    </g>
</svg>
<div class="mobile-wallet-adapter-embedded-modal-title">Ready to connect!</div>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Connect Wallet
    </button>
</div>
`;
const $5281e12b82edb2e4$var$css$4 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
    min-width: 300px;
}
.mobile-wallet-adapter-embedded-modal-launch-icon {
    margin-top: 24px;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px 30px 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    font-size: 1.25em;
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/embedded-modal/loopbackBlockedModal.ts
var $5281e12b82edb2e4$var$LoopbackPermissionBlockedModal = class extends $5281e12b82edb2e4$var$EmbeddedModal {
    contentStyles = $5281e12b82edb2e4$var$css$3;
    get contentHtml() {
        const instructions = $5281e12b82edb2e4$var$getIsPwaLaunchedAsApp() ? "Long press the app icon on your home screen to open site settings" : "Tap the lock or settings icon in the address bar to open site settings";
        return $5281e12b82edb2e4$var$ErrorDialogHtml$1.replace("{{PERMISSION_INSTRUCTION_DETAIL}}", instructions);
    }
    async init() {
        super.init();
        this.#prepareLaunchAction();
    }
    #prepareLaunchAction() {
        const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
        const listener = async (event)=>{
            launchButton?.removeEventListener("click", listener);
            this.close(event);
        };
        launchButton?.addEventListener("click", listener);
    }
};
const $5281e12b82edb2e4$var$ErrorDialogHtml$1 = `
<div class="mobile-wallet-adapter-embedded-modal-header">
    Local Wallet Connection
</div>
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.6 48C7.2 48 0 40.8 0 26.4V21.6C0 7.2 7.2 0 21.6 0H26.4C40.8 0 48 7.2 48 21.6V26.4C48 40.8 40.8 48 26.4 48H21.6Z" fill="#ED1515"/>
    <mask id="mask0_147_1364" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="8" y="8" width="32" height="32">
        <rect x="8" y="8" width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_147_1364)">
        <path d="M20.1398 36.2705C19.7363 36.2705 19.3508 36.1945 18.9835 36.0425C18.6162 35.8907 18.2916 35.674 18.0098 35.3922L12.6072 29.9895C12.3254 29.7077 12.1086 29.3832 11.9568 29.0158C11.8048 28.6485 11.7288 28.2631 11.7288 27.8595V20.1395C11.7288 19.736 11.8048 19.3505 11.9568 18.9832C12.1086 18.6158 12.3254 18.2913 12.6072 18.0095L18.0098 12.6068C18.2916 12.3251 18.6162 12.1083 18.9835 11.9565C19.3508 11.8045 19.7363 11.7285 20.1398 11.7285H27.8598C28.2634 11.7285 28.6488 11.8045 29.0162 11.9565C29.3835 12.1083 29.708 12.3251 29.9898 12.6068L35.3925 18.0095C35.6743 18.2913 35.891 18.6158 36.0428 18.9832C36.1948 19.3505 36.2708 19.736 36.2708 20.1395V27.8595C36.2708 28.2631 36.1948 28.6485 36.0428 29.0158C35.891 29.3832 35.6743 29.7077 35.3925 29.9895L29.9898 35.3922C29.708 35.674 29.3835 35.8907 29.0162 36.0425C28.6488 36.1945 28.2634 36.2705 27.8598 36.2705H20.1398ZM20.1732 33.2372H27.8265L33.2375 27.8262V20.1728L27.8265 14.7618H20.1732L14.7622 20.1728V27.8262L20.1732 33.2372ZM23.9998 25.9538L26.7868 28.7408C27.0473 29.0013 27.3729 29.1302 27.7638 29.1275C28.1549 29.1248 28.4807 28.9933 28.7412 28.7328C29.0016 28.4724 29.1318 28.1466 29.1318 27.7555C29.1318 27.3646 29.0016 27.039 28.7412 26.7785L25.9542 23.9995L28.7412 21.2125C29.0016 20.9521 29.1318 20.6264 29.1318 20.2355C29.1318 19.8444 29.0016 19.5186 28.7412 19.2582C28.4807 18.9977 28.1549 18.8675 27.7638 18.8675C27.3729 18.8675 27.0473 18.9977 26.7868 19.2582L23.9998 22.0452L21.2128 19.2582C20.9524 18.9977 20.628 18.8675 20.2398 18.8675C19.8514 18.8675 19.5269 18.9977 19.2665 19.2582C19.006 19.5186 18.8758 19.8444 18.8758 20.2355C18.8758 20.6264 19.006 20.9521 19.2665 21.2125L22.0455 23.9995L19.2585 26.7865C18.998 27.047 18.8692 27.3713 18.8718 27.7595C18.8745 28.148 19.006 28.4724 19.2665 28.7328C19.5269 28.9933 19.8527 29.1235 20.2438 29.1235C20.6347 29.1235 20.9604 28.9933 21.2208 28.7328L23.9998 25.9538Z" fill="black"/>
    </g>
</svg>
<div class="mobile-wallet-adapter-embedded-modal-title">
    Your wallet connection is blocked
</div>
<div id="mobile-wallet-adapter-local-launch-message" class="mobile-wallet-adapter-embedded-modal-subtitle">
    Visit site settings in the address bar and allow "Apps on Device".
</div>

<div class="mobile-wallet-adapter-embedded-modal-divider"><hr></div>
<div class="mobile-wallet-adapter-embedded-modal-footer">
    <div class="mobile-wallet-adapter-embedded-modal-details">
        <!-- Clickable header (label associated with the checkbox) -->
      	<label for="collapsible-1" class="mobile-wallet-adapter-embedded-modal-details-collapsible-header">
            <!-- Hidden checkbox to track state -->
            <input type="checkbox" id="collapsible-1" class="mobile-wallet-adapter-embedded-modal-details-collapsible-input">
            <span class="mobile-wallet-adapter-embedded-modal-details-collapsible-header-label">
              See details
            </span>
            <svg class="mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_147_1382" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_147_1382)">
                <path d="M11.9999 17.0811C11.8506 17.0811 11.7087 17.0563 11.5741 17.0067C11.4395 16.957 11.3162 16.8762 11.2042 16.7643L6.57924 12.1393C6.36801 11.9281 6.26656 11.667 6.27489 11.3561C6.28322 11.0453 6.39301 10.7842 6.60424 10.573C6.81547 10.3618 7.08069 10.2561 7.39989 10.2561C7.71909 10.2561 7.9843 10.3618 8.19554 10.573L11.9999 14.3773L15.8292 10.548C16.0405 10.3368 16.3015 10.2353 16.6124 10.2436C16.9233 10.252 17.1843 10.3618 17.3955 10.573C17.6068 10.7842 17.7124 11.0494 17.7124 11.3686C17.7124 11.6878 17.6068 11.9531 17.3955 12.1643L12.7955 16.7643C12.6836 16.8762 12.5603 16.957 12.4257 17.0067C12.2911 17.0563 12.1492 17.0811 11.9999 17.0811Z" fill="black"/>
              </g>
            </svg>
      	</label>
        
        <!-- Content to show/hide -->
        <ul class="mobile-wallet-adapter-embedded-modal-details-collapsible-content">
            <li>{{PERMISSION_INSTRUCTION_DETAIL}}</li>
            <li>Allow "Apps on Device"</li>
        </ul>
    </div>
</div>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Got it
    </button>
</div>
`;
const $5281e12b82edb2e4$var$css$3 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}
.mobile-wallet-adapter-embedded-modal-header {
    margin: 18px auto 30px auto;
    color: #7D9093;
    font-size: 1.0em;
    font-weight: 500;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 12px 60px 30px 60px;
    color: #7D9093;
    font-size: 1.25em;
    font-weight: 400;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header {
    display: flex;
    flex-direction: row;
  	justify-content: space-between;
    margin: 10px auto 10px auto;
    color: #000000;
    font-size: 1.5em;
    font-weight: 600;
    cursor: pointer; /* Show pointer on hover */
    transition: background 0.2s ease; /* Smooth background change */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon {
  	transition: rotate 0.3s ease;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-input {
  	display: none; /* Hide the checkbox */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-content {
    margin: 0px auto 40px auto;
    max-height: 0px; /* Collapse content */
    overflow: hidden; /* Hide overflow when collapsed */
    transition: max-height 0.3s ease; /* Smooth transition */
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-content li {
    margin: 20px auto;
    color: #000000;
    font-size: 1.25em;
    font-weight: 400;
    text-align: left;
}
/* When checkbox is checked, show content */
.mobile-wallet-adapter-embedded-modal-details-collapsible-header:has(> input:checked) ~ .mobile-wallet-adapter-embedded-modal-details-collapsible-content {
  	max-height: 300px;
}
.mobile-wallet-adapter-embedded-modal-details-collapsible-header:has(> input:checked) > .mobile-wallet-adapter-embedded-modal-details-collapsible-header-icon {
  	rotate: 180deg;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    /*margin-top: 40px;*/
    font-size: 1.25em;
    /*line-height: 24px;*/
    /*letter-spacing: -1%;*/
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.75em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/embedded-modal/loopbackPermissionModal.ts
var $5281e12b82edb2e4$var$LoopbackPermissionModal = class extends $5281e12b82edb2e4$var$EmbeddedModal {
    contentStyles = $5281e12b82edb2e4$var$css$2;
    contentHtml = $5281e12b82edb2e4$var$ErrorDialogHtml;
    async init() {
        super.init();
        this.#prepareLaunchAction();
    }
    #prepareLaunchAction() {
        const launchButton = this.dom?.getElementById("mobile-wallet-adapter-launch-action");
        const listener = async ()=>{
            launchButton?.removeEventListener("click", listener);
            try {
                await fetch("http://localhost");
            } catch  {}
            this.close();
        };
        launchButton?.addEventListener("click", listener);
    }
};
const $5281e12b82edb2e4$var$ErrorDialogHtml = `
<div class="mobile-wallet-adapter-embedded-modal-title">Allow connections to your wallet</div>
<div id="mobile-wallet-adapter-local-launch-message" class="mobile-wallet-adapter-embedded-modal-subtitle">
    Tap "Allow" on the next screen
</div>
<svg class="mobile-wallet-adapter-embedded-modal-permission-prompt-mock" xmlns="http://www.w3.org/2000/svg" width="281" height="83" viewBox="0 0 281 83" fill="none">
    <rect width="281" height="83" rx="22" fill="#F0F3F5"/>
    <path d="M254.194 64L252.626 56.657H254.047L254.866 61.452L254.985 62.278H255.02L255.146 61.452L255.993 57.497H257.4L258.254 61.431L258.373 62.278H258.415L258.534 61.431L259.346 56.657H260.718L259.143 64H257.673L256.826 59.961L256.693 59.093H256.651L256.511 59.961L255.664 64H254.194Z" fill="black"/>
    <path d="M248.837 64.231C248.147 64.231 247.54 64.07 247.017 63.748C246.495 63.426 246.086 62.978 245.792 62.404C245.498 61.83 245.351 61.1673 245.351 60.416V60.241C245.351 59.4897 245.498 58.827 245.792 58.253C246.086 57.679 246.495 57.2333 247.017 56.916C247.54 56.594 248.147 56.433 248.837 56.433C249.528 56.433 250.135 56.594 250.657 56.916C251.18 57.2333 251.588 57.679 251.882 58.253C252.176 58.827 252.323 59.4897 252.323 60.241V60.416C252.323 61.1673 252.176 61.83 251.882 62.404C251.588 62.978 251.18 63.426 250.657 63.748C250.135 64.07 249.528 64.231 248.837 64.231ZM248.837 62.824C249.43 62.824 249.897 62.607 250.237 62.173C250.583 61.7343 250.755 61.1417 250.755 60.395V60.262C250.755 59.5107 250.583 58.918 250.237 58.484C249.897 58.05 249.43 57.833 248.837 57.833C248.249 57.833 247.783 58.05 247.437 58.484C247.092 58.918 246.919 59.5107 246.919 60.262V60.395C246.919 61.1417 247.092 61.7343 247.437 62.173C247.783 62.607 248.249 62.824 248.837 62.824Z" fill="black"/>
    <path d="M242.298 64.231C241.467 64.231 240.814 63.993 240.338 63.517C239.866 63.0364 239.631 62.3737 239.631 61.529V53.78H241.178V61.389C241.178 62.3317 241.591 62.803 242.417 62.803C242.65 62.803 242.865 62.7587 243.061 62.67C243.257 62.5814 243.464 62.4367 243.684 62.236L244.538 63.377C244.225 63.6664 243.884 63.881 243.516 64.021C243.152 64.161 242.746 64.231 242.298 64.231ZM237.51 55.061V53.78H240.611V55.061H237.51Z" fill="black"/>
    <path d="M234.463 64.231C233.633 64.231 232.979 63.993 232.503 63.517C232.032 63.0364 231.796 62.3737 231.796 61.529V53.78H233.343V61.389C233.343 62.3317 233.756 62.803 234.582 62.803C234.816 62.803 235.03 62.7587 235.226 62.67C235.422 62.5814 235.63 62.4367 235.849 62.236L236.703 63.377C236.391 63.6664 236.05 63.881 235.681 64.021C235.317 64.161 234.911 64.231 234.463 64.231ZM229.675 55.061V53.78H232.776V55.061H229.675Z" fill="black"/>
    <path d="M221.442 64L224.557 53.976H226.132L229.233 64H227.581L225.642 56.972L225.341 55.761H225.299L225.005 56.972L223.073 64H221.442ZM222.835 61.634L223.255 60.29H227.371L227.805 61.634H222.835Z" fill="black"/>
    <path d="M178.261 64L175.034 60.066V60.024L178.121 56.657H180.011L176.504 60.423V59.632L180.165 64H178.261ZM173.543 64V53.78H175.097V64H173.543Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M169.306 64.224C168.588 64.224 167.958 64.0653 167.416 63.748C166.88 63.426 166.462 62.9803 166.163 62.411C165.865 61.837 165.715 61.1673 165.715 60.402V60.248C165.715 59.4873 165.862 58.8223 166.156 58.253C166.45 57.679 166.863 57.2333 167.395 56.916C167.927 56.594 168.546 56.433 169.25 56.433C169.978 56.433 170.59 56.6056 171.084 56.951C171.579 57.2917 171.955 57.777 172.211 58.407L170.874 58.995C170.72 58.6123 170.508 58.323 170.237 58.127C169.967 57.9263 169.633 57.826 169.236 57.826C168.63 57.826 168.149 58.0383 167.794 58.463C167.444 58.883 167.269 59.4616 167.269 60.199V60.465C167.269 61.1837 167.454 61.7577 167.822 62.187C168.196 62.6163 168.69 62.831 169.306 62.831C169.712 62.831 170.06 62.733 170.349 62.537C170.639 62.341 170.877 62.0423 171.063 61.641L172.379 62.285C172.188 62.6957 171.941 63.0457 171.637 63.335C171.334 63.6243 170.986 63.846 170.594 64C170.202 64.1493 169.773 64.224 169.306 64.224Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M161.003 64.231C160.312 64.231 159.706 64.07 159.183 63.748C158.66 63.426 158.252 62.978 157.958 62.404C157.664 61.83 157.517 61.1673 157.517 60.416V60.241C157.517 59.4897 157.664 58.827 157.958 58.253C158.252 57.679 158.66 57.2333 159.183 56.916C159.706 56.594 160.312 56.433 161.003 56.433C161.694 56.433 162.3 56.594 162.823 56.916C163.346 57.2333 163.754 57.679 164.048 58.253C164.342 58.827 164.489 59.4897 164.489 60.241V60.416C164.489 61.1673 164.342 61.83 164.048 62.404C163.754 62.978 163.346 63.426 162.823 63.748C162.3 64.07 161.694 64.231 161.003 64.231ZM161.003 62.824C161.596 62.824 162.062 62.607 162.403 62.173C162.748 61.7343 162.921 61.1417 162.921 60.395V60.262C162.921 59.5107 162.748 58.918 162.403 58.484C162.062 58.05 161.596 57.833 161.003 57.833C160.415 57.833 159.948 58.05 159.603 58.484C159.258 58.918 159.085 59.5107 159.085 60.262V60.395C159.085 61.1417 159.258 61.7343 159.603 62.173C159.948 62.607 160.415 62.824 161.003 62.824Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M154.463 64.231C153.633 64.231 152.979 63.993 152.503 63.517C152.032 63.0364 151.796 62.3737 151.796 61.529V53.78H153.343V61.389C153.343 62.3317 153.756 62.803 154.582 62.803C154.816 62.803 155.03 62.7587 155.226 62.67C155.422 62.5814 155.63 62.4367 155.849 62.236L156.703 63.377C156.391 63.6664 156.05 63.881 155.681 64.021C155.317 64.161 154.911 64.231 154.463 64.231ZM149.675 55.061V53.78H152.776V55.061H149.675Z" fill="#7D9093" fill-opacity="0.5"/>
    <path d="M142.24 64V53.976H145.544C146.421 53.976 147.112 54.1953 147.616 54.634C148.12 55.0726 148.372 55.6583 148.372 56.391V56.566C148.372 57.0886 148.246 57.5366 147.994 57.91C147.742 58.2833 147.38 58.5586 146.909 58.736V58.792C147.492 58.9226 147.947 59.2003 148.274 59.625C148.605 60.045 148.771 60.5606 148.771 61.172V61.361C148.771 61.893 148.645 62.3573 148.393 62.754C148.145 63.1506 147.795 63.4586 147.343 63.678C146.895 63.8926 146.365 64 145.754 64H142.24ZM143.794 62.656H145.572C146.085 62.656 146.482 62.5253 146.762 62.264C147.042 62.0026 147.182 61.6293 147.182 61.144V60.99C147.182 60.5046 147.037 60.1313 146.748 59.87C146.463 59.604 146.05 59.471 145.509 59.471H143.36V58.183H145.32C145.791 58.183 146.153 58.064 146.405 57.826C146.657 57.588 146.783 57.2496 146.783 56.811V56.685C146.783 56.2416 146.657 55.9033 146.405 55.67C146.157 55.4366 145.796 55.32 145.32 55.32H143.794V62.656Z" fill="#7D9093" fill-opacity="0.5"/>
    <rect x="18" y="17" width="246" height="7" rx="3.5" fill="#7D9093" fill-opacity="0.26"/>
    <rect x="18" y="33" width="82" height="7" rx="3.5" fill="#7D9093" fill-opacity="0.26"/>
</svg>
<div>
    <button data-modal-action id="mobile-wallet-adapter-launch-action" class="mobile-wallet-adapter-embedded-modal-launch-action">
        Continue to Allow
    </button>
</div>
`;
const $5281e12b82edb2e4$var$css$2 = `
.mobile-wallet-adapter-embedded-modal-close {
    display: none;
}
.mobile-wallet-adapter-embedded-modal-content {
    text-align: center;
}
.mobile-wallet-adapter-embedded-modal-title {
    margin: 18px 100px auto 100px;
    color: #000000;
    font-size: 2.75em;
    font-weight: 600;
}
.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: 20px 60px 40px 60px;
    color: #7D9093;
    font-size: 1.25em;
    font-weight: 400;
}
.mobile-wallet-adapter-embedded-modal-permission-prompt-mock {
    width: 90%;
    height: auto;
    margin: 0 auto 30px auto;
    display: block;
}
.mobile-wallet-adapter-embedded-modal-launch-action {
    display: block;
    width: 100%;
    height: 56px;
    font-size: 1.25em;
    background: #000000;
    color: #FFFFFF;
    border-radius: 18px;
}
/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
        margin-right: 12px;
        margin-left: 12px;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: 12px;
        margin-left: 12px;
    }
}
`;
//#endregion
//#region src/getIsSupported.ts
function $5281e12b82edb2e4$var$getIsLocalAssociationSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
function $5281e12b82edb2e4$var$getIsRemoteAssociationSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function $5281e12b82edb2e4$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $5281e12b82edb2e4$var$isSolanaMobileWebShell(userAgentString) {
    return userAgentString.includes("Solana Mobile Web Shell");
}
function $5281e12b82edb2e4$var$getIsPwaLaunchedAsApp() {
    const isAndroidTwa = typeof document !== "undefined" && document.referrer.startsWith("android-app://");
    if (typeof window == "undefined") return isAndroidTwa;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    const isFullscreen = window.matchMedia("(display-mode: fullscreen)").matches;
    const isMinimalUI = window.matchMedia("(display-mode: minimal-ui)").matches;
    return isAndroidTwa || isStandalone || isFullscreen || isMinimalUI;
}
async function $5281e12b82edb2e4$var$isLocalWebSocketAvailable() {
    if (typeof navigator !== "undefined" && $5281e12b82edb2e4$var$isSolanaMobileWebShell(navigator.userAgent)) return true;
    try {
        return (await navigator.permissions.query({
            name: "loopback-network"
        })).state === "granted";
    } catch (e) {
        if (e instanceof TypeError && (e.message.includes("loopback-network") || e.message.includes("local-network-access"))) return true;
        return false;
    }
}
async function $5281e12b82edb2e4$var$checkLocalNetworkAccessPermission() {
    if (typeof navigator !== "undefined" && $5281e12b82edb2e4$var$isSolanaMobileWebShell(navigator.userAgent)) return;
    try {
        const lnaPermission = await navigator.permissions.query({
            name: "loopback-network"
        });
        if (lnaPermission.state === "granted") return;
        else if (lnaPermission.state === "denied") {
            const modal = new $5281e12b82edb2e4$var$LoopbackPermissionBlockedModal();
            modal.init();
            modal.open();
            throw new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_LOOPBACK_ACCESS_BLOCKED, "Local Network Access permission denied");
        } else if (lnaPermission.state === "prompt") {
            const modal = new $5281e12b82edb2e4$var$LoopbackPermissionModal();
            if (await new Promise((resolve, reject)=>{
                modal.addEventListener("close", (event)=>{
                    if (event) reject(new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_ASSOCIATION_CANCELLED, "Wallet connection cancelled by user", {
                        event: event
                    }));
                });
                lnaPermission.onchange = ()=>{
                    lnaPermission.onchange = null;
                    resolve(lnaPermission.state);
                };
                modal.init();
                modal.open();
            }) === "granted") {
                const modal = new $5281e12b82edb2e4$var$LocalConnectionModal();
                await new Promise((resolve, reject)=>{
                    modal.addEventListener("close", (event)=>{
                        if (event) reject(new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_ASSOCIATION_CANCELLED, "Wallet connection cancelled by user", {
                            event: event
                        }));
                    });
                    modal.initWithCallback(async ()=>{
                        resolve(true);
                    });
                    modal.open();
                });
                return;
            } else return await $5281e12b82edb2e4$var$checkLocalNetworkAccessPermission();
        }
        throw new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_LOOPBACK_ACCESS_BLOCKED, "Local Network Access permission unknown");
    } catch (e) {
        if (e instanceof TypeError && (e.message.includes("loopback-network") || e.message.includes("local-network-access"))) return;
        if (e instanceof (0, $b5177f26f29fa44f$export$d77545679c409b63)) throw e;
        throw new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_LOOPBACK_ACCESS_BLOCKED, e instanceof Error ? e.message : "Local Network Access permission unknown");
    }
}
//#endregion
//#region src/embedded-modal/loadingSpinner.ts
const $5281e12b82edb2e4$var$modalHtml = `
<div class="mobile-wallet-adapter-embedded-loading-indicator" role="dialog" aria-modal="true" aria-labelledby="modal-title">
    <div data-modal-close style="position: absolute; width: 100%; height: 100%;"></div>
    <div class="mobile-wallet-adapter-embedded-loading-container">
        <div class="mobile-wallet-adapter-embedded-loading-animation"></div>
    </div>
</div>
`;
const $5281e12b82edb2e4$var$css$1 = `
.mobile-wallet-adapter-embedded-loading-indicator {
    display: flex; /* Use flexbox to center content */
    justify-content: center; /* Center horizontally */
    align-items: start; /* Center vertically */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    overflow-y: auto; /* enable scrolling */
}

.mobile-wallet-adapter-embedded-loading-container {
    display: flex;
    margin: auto;
}

.mobile-wallet-adapter-embedded-loading-animation {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: var(--spinner-color);
    color: var(--spinner-color);
    box-shadow: 9984px 0 0 0 var(--spinner-color), 
                9999px 0 0 0 var(--spinner-color), 
                10014px 0 0 0 var(--spinner-color);
    animation: dot-typing 1.5s infinite linear;
}

@keyframes dot-typing {
    0% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    16.667% {
        box-shadow: 9984px -10px 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    33.333% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    50% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px -10px 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    66.667% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
    83.333% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px -10px 0 0 var(--spinner-color);
    }
    100% {
        box-shadow: 9984px 0 0 0 var(--spinner-color), 
                    9999px 0 0 0 var(--spinner-color), 
                    10014px 0 0 0 var(--spinner-color);
    }
}
`;
var $5281e12b82edb2e4$var$EmbeddedLoadingSpinner = class {
    #root = null;
    #eventListeners = {};
    #listenersAttached = false;
    dom = null;
    constructor(){
        this.init = this.init.bind(this);
        this.#root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
    }
    async init() {
        console.log("Injecting modal");
        this.#injectHTML();
    }
    open = ()=>{
        console.debug("Modal open");
        this.#attachEventListeners();
        if (this.#root) this.#root.style.display = "flex";
    };
    close = (event)=>{
        console.debug("Modal close");
        this.#removeEventListeners();
        if (this.#root) this.#root.style.display = "none";
        this.#eventListeners["close"]?.forEach((listener)=>listener(event));
    };
    addEventListener(event, listener) {
        this.#eventListeners[event]?.push(listener) || (this.#eventListeners[event] = [
            listener
        ]);
        return ()=>this.removeEventListener(event, listener);
    }
    removeEventListener(event, listener) {
        this.#eventListeners[event] = this.#eventListeners[event]?.filter((existingListener)=>listener !== existingListener);
    }
    #injectHTML() {
        if (this.dom) return;
        this.#root = document.createElement("div");
        this.#root.id = "mobile-wallet-adapter-embedded-root-ui";
        this.#root.innerHTML = $5281e12b82edb2e4$var$modalHtml;
        this.#root.style.display = "none";
        const styles = document.createElement("style");
        styles.id = "mobile-wallet-adapter-embedded-modal-styles";
        styles.textContent = $5281e12b82edb2e4$var$css$1;
        const host = document.createElement("div");
        this.dom = host.attachShadow({
            mode: "closed"
        });
        host.style.setProperty("--spinner-color", "#FFFFFF");
        this.dom.appendChild(styles);
        this.dom.appendChild(this.#root);
        document.body.appendChild(host);
    }
    #attachEventListeners() {
        if (!this.#root || this.#listenersAttached) return;
        [
            ...this.#root.querySelectorAll("[data-modal-close]")
        ].forEach((closer)=>closer?.addEventListener("click", (event)=>{
                this.close(event);
            }));
        window.addEventListener("load", this.close);
        document.addEventListener("keydown", this.#handleKeyDown);
        this.#listenersAttached = true;
    }
    #removeEventListeners() {
        if (!this.#listenersAttached) return;
        window.removeEventListener("load", this.close);
        document.removeEventListener("keydown", this.#handleKeyDown);
        if (!this.#root) return;
        [
            ...this.#root.querySelectorAll("[data-modal-close]")
        ].forEach((closer)=>closer?.removeEventListener("click", this.close));
        this.#listenersAttached = false;
    }
    #handleKeyDown = (event)=>{
        if (event.key === "Escape") this.close(event);
    };
};
//#endregion
//#region src/embedded-modal/remoteConnectionModal.ts
var $5281e12b82edb2e4$var$RemoteConnectionModal = class extends $5281e12b82edb2e4$var$EmbeddedModal {
    contentStyles = $5281e12b82edb2e4$var$css;
    contentHtml = $5281e12b82edb2e4$var$QRCodeHtml;
    async initWithQR(qrCode) {
        super.init();
        this.populateQRCode(qrCode);
    }
    async populateQRCode(qrUrl) {
        const qrcodeContainer = this.dom?.getElementById("mobile-wallet-adapter-embedded-modal-qr-code-container");
        if (qrcodeContainer) {
            const qrCodeElement = await (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toCanvas(qrUrl, {
                width: 200,
                margin: 0
            });
            if (qrcodeContainer.firstElementChild !== null) qrcodeContainer.replaceChild(qrCodeElement, qrcodeContainer.firstElementChild);
            else qrcodeContainer.appendChild(qrCodeElement);
            const qrPlaceholder = this.dom?.getElementById("mobile-wallet-adapter-embedded-modal-qr-placeholder");
            if (qrPlaceholder) qrPlaceholder.style.display = "none";
        } else console.error("QRCode Container not found");
    }
};
const $5281e12b82edb2e4$var$QRCodeHtml = `
<div class="mobile-wallet-adapter-embedded-modal-qr-content">
    <div>
        <svg class="mobile-wallet-adapter-embedded-modal-icon" width="100%" height="100%">
            <circle r="52" cx="53" cy="53" fill="#99b3be" stroke="#000000" stroke-width="2"/>
            <path d="m 53,82.7305 c -3.3116,0 -6.1361,-1.169 -8.4735,-3.507 -2.338,-2.338 -3.507,-5.1625 -3.507,-8.4735 0,-3.3116 1.169,-6.1364 3.507,-8.4744 2.3374,-2.338 5.1619,-3.507 8.4735,-3.507 3.3116,0 6.1361,1.169 8.4735,3.507 2.338,2.338 3.507,5.1628 3.507,8.4744 0,3.311 -1.169,6.1355 -3.507,8.4735 -2.3374,2.338 -5.1619,3.507 -8.4735,3.507 z m 0.007,-5.25 c 1.8532,0 3.437,-0.6598 4.7512,-1.9793 1.3149,-1.3195 1.9723,-2.9058 1.9723,-4.7591 0,-1.8526 -0.6598,-3.4364 -1.9793,-4.7512 -1.3195,-1.3149 -2.9055,-1.9723 -4.7582,-1.9723 -1.8533,0 -3.437,0.6598 -4.7513,1.9793 -1.3148,1.3195 -1.9722,2.9058 -1.9722,4.7591 0,1.8527 0.6597,3.4364 1.9792,4.7512 1.3195,1.3149 2.9056,1.9723 4.7583,1.9723 z m -28,-33.5729 -3.85,-3.6347 c 4.1195,-4.025 8.8792,-7.1984 14.2791,-9.52 5.4005,-2.3223 11.2551,-3.4834 17.5639,-3.4834 6.3087,0 12.1634,1.1611 17.5639,3.4834 5.3999,2.3216 10.1596,5.495 14.2791,9.52 l -3.85,3.6347 C 77.2999,40.358 73.0684,37.5726 68.2985,35.5514 63.5292,33.5301 58.4296,32.5195 53,32.5195 c -5.4297,0 -10.5292,1.0106 -15.2985,3.0319 -4.7699,2.0212 -9.0014,4.8066 -12.6945,8.3562 z m 44.625,10.8771 c -2.2709,-2.1046 -4.7962,-3.7167 -7.5758,-4.8361 -2.7795,-1.12 -5.7983,-1.68 -9.0562,-1.68 -3.2579,0 -6.2621,0.56 -9.0125,1.68 -2.7504,1.1194 -5.2903,2.7315 -7.6195,4.8361 L 32.5189,51.15 c 2.8355,-2.6028 5.9777,-4.6086 9.4263,-6.0174 3.4481,-1.4087 7.133,-2.1131 11.0548,-2.1131 3.9217,0 7.5979,0.7044 11.0285,2.1131 3.43,1.4088 6.5631,3.4146 9.3992,6.0174 z"/>
        </svg>
        <div class="mobile-wallet-adapter-embedded-modal-title">Remote Mobile Wallet Adapter</div>
    </div>
    <div>
        <div>
            <h4 class="mobile-wallet-adapter-embedded-modal-qr-label">
                Open your wallet and scan this code
            </h4>
        </div>
        <div id="mobile-wallet-adapter-embedded-modal-qr-code-container" class="mobile-wallet-adapter-embedded-modal-qr-code-container">
            <div id="mobile-wallet-adapter-embedded-modal-qr-placeholder" class="mobile-wallet-adapter-embedded-modal-qr-placeholder"></div>
        </div>
    </div>
</div>
<div class="mobile-wallet-adapter-embedded-modal-divider"><hr></div>
<div class="mobile-wallet-adapter-embedded-modal-footer">
    <div class="mobile-wallet-adapter-embedded-modal-subtitle">
        Follow the instructions on your device. When you're finished, this screen will update.
    </div>
    <div class="mobile-wallet-adapter-embedded-modal-progress-badge">
        <div>
            <div class="spinner">
                <div class="leftWrapper">
                    <div class="left">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="rightWrapper">
                    <div class="right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
        </div>
        <div>Waiting for scan</div>
    </div>
</div>
`;
const $5281e12b82edb2e4$var$css = `
.mobile-wallet-adapter-embedded-modal-qr-content {
    display: flex; 
    margin-top: 10px;
    padding: 10px;
}

.mobile-wallet-adapter-embedded-modal-qr-content > div:first-child {
    display: flex;
    flex-direction: column;
    flex: 2;
    margin-top: auto;
    margin-right: 30px;
}

.mobile-wallet-adapter-embedded-modal-qr-content > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: auto;
}

.mobile-wallet-adapter-embedded-modal-footer {
    display: flex;
    padding: 10px;
}

.mobile-wallet-adapter-embedded-modal-icon {}

.mobile-wallet-adapter-embedded-modal-title {
    color: #000000;
    font-size: 2.5em;
    font-weight: 600;
}

.mobile-wallet-adapter-embedded-modal-qr-label {
    text-align: right;
    color: #000000;
}

.mobile-wallet-adapter-embedded-modal-qr-code-container {
    margin-left: auto;
}

.mobile-wallet-adapter-embedded-modal-qr-placeholder {
    margin-left: auto;
    min-width: 200px;
    min-height: 200px;
    background: linear-gradient(-60deg, #F7F8F8 30%, #ECEEEE 50%, #F7F8F8 70%);
    background-size: 200%;
    animation: placeholderAnimate 2.7s linear infinite;
    border-radius: 12px;
}

.mobile-wallet-adapter-embedded-modal-divider {
    margin-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
}

.mobile-wallet-adapter-embedded-modal-divider hr {
    border-top: 1px solid #D9DEDE;
}

.mobile-wallet-adapter-embedded-modal-subtitle {
    margin: auto;
    margin-right: 60px;
    padding: 20px;
    color: #6E8286;
}

.mobile-wallet-adapter-embedded-modal-progress-badge {
    display: flex;
    background: #F7F8F8;
    height: 56px;
    min-width: 200px;
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 18px;
    color: #A8B6B8;
    align-items: center;
}

.mobile-wallet-adapter-embedded-modal-progress-badge > div:first-child {
    margin-left: auto;
    margin-right: 20px;
}

.mobile-wallet-adapter-embedded-modal-progress-badge > div:nth-child(2) {
    margin-right: auto;
}

/* Smaller screens */
@media all and (max-width: 600px) {
    .mobile-wallet-adapter-embedded-modal-card {
        text-align: center;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content {
        flex-direction: column;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content > div:first-child {
        margin: auto;
    }
    .mobile-wallet-adapter-embedded-modal-qr-content > div:nth-child(2) {
        margin: auto;
        flex: 2 auto;
    }
    .mobile-wallet-adapter-embedded-modal-footer {
        flex-direction: column;
    }
    .mobile-wallet-adapter-embedded-modal-icon {
        display: none;
    }
    .mobile-wallet-adapter-embedded-modal-title {
        font-size: 1.5em;
    }
    .mobile-wallet-adapter-embedded-modal-subtitle {
        margin-right: unset;
    }
    .mobile-wallet-adapter-embedded-modal-qr-label {
        text-align: center;
    }
    .mobile-wallet-adapter-embedded-modal-qr-code-container {
        margin: auto;
    }
    .mobile-wallet-adapter-embedded-modal-qr-placeholder {
        margin: auto;
    }
}

/* QR Placeholder */
@keyframes placeholderAnimate {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Spinner */
@keyframes spinLeft {
    0% {
        transform: rotate(20deg);
    }
    50% {
        transform: rotate(160deg);
    }
    100% {
        transform: rotate(20deg);
    }
}
@keyframes spinRight {
    0% {
        transform: rotate(160deg);
    }
    50% {
        transform: rotate(20deg);
    }
    100% {
        transform: rotate(160deg);
    }
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(2520deg);
    }
}

.spinner {
    position: relative;
    width: 1.5em;
    height: 1.5em;
    margin: auto;
    animation: spin 10s linear infinite;
}
.spinner::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.right, .rightWrapper, .left, .leftWrapper {
    position: absolute;
    top: 0;
    overflow: hidden;
    width: .75em;
    height: 1.5em;
}
.left, .leftWrapper {
    left: 0;
}
.right {
    left: -12px;
}
.rightWrapper {
    right: 0;
}
.circle {
    border: .125em solid #A8B6B8;
    width: 1.25em; /* 1.5em - 2*0.125em border */
    height: 1.25em; /* 1.5em - 2*0.125em border */
    border-radius: 0.75em; /* 0.5*1.5em spinner size 8 */
}
.left {
    transform-origin: 100% 50%;
    animation: spinLeft 2.5s cubic-bezier(.2,0,.8,1) infinite;
}
.right {
    transform-origin: 100% 50%;
    animation: spinRight 2.5s cubic-bezier(.2,0,.8,1) infinite;
}
`;
//#endregion
//#region src/icon.ts
const $5281e12b82edb2e4$var$icon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDIuNUgxN0MxNy44Mjg0IDIuNSAxOC41IDMuMTcxNTcgMTguNSA0VjIwQzE4LjUgMjAuODI4NCAxNy44Mjg0IDIxLjUgMTcgMjEuNUg3QzYuMTcxNTcgMjEuNSA1LjUgMjAuODI4NCA1LjUgMjBWNEM1LjUgMy4xNzE1NyA2LjE3MTU3IDIuNSA3IDIuNVpNMyA0QzMgMS43OTA4NiA0Ljc5MDg2IDAgNyAwSDE3QzE5LjIwOTEgMCAyMSAxLjc5MDg2IDIxIDRWMjBDMjEgMjIuMjA5MSAxOS4yMDkxIDI0IDE3IDI0SDdDNC43OTA4NiAyNCAzIDIyLjIwOTEgMyAyMFY0Wk0xMSA0LjYxNTM4QzEwLjQ0NzcgNC42MTUzOCAxMCA1LjA2MzEgMTAgNS42MTUzOFY2LjM4NDYyQzEwIDYuOTM2OSAxMC40NDc3IDcuMzg0NjIgMTEgNy4zODQ2MkgxM0MxMy41NTIzIDcuMzg0NjIgMTQgNi45MzY5IDE0IDYuMzg0NjJWNS42MTUzOEMxNCA1LjA2MzEgMTMuNTUyMyA0LjYxNTM4IDEzIDQuNjE1MzhIMTFaIiBmaWxsPSIjRENCOEZGIi8+Cjwvc3ZnPgo=";
//#endregion
//#region src/wallet.ts
const $5281e12b82edb2e4$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
const $5281e12b82edb2e4$export$8701a18cc5ef8b26 = "Remote Mobile Wallet Adapter";
const $5281e12b82edb2e4$var$DEFAULT_FEATURES = [
    (0, $da368ee8f406d58d$export$dd64f32469f35f81),
    (0, $97e08ae06ec466db$export$54187c3796d0ecb),
    (0, $5a4be9421d6e6c61$export$22c7939a38084172),
    (0, $29a99a74b28f2560$export$8adeab75f48a3607)
];
const $5281e12b82edb2e4$var$WALLET_ASSOCIATION_TIMEOUT = 3e4;
function $5281e12b82edb2e4$var$getErrorMessage(error) {
    return error instanceof Error ? error.message : "Unknown error";
}
var $5281e12b82edb2e4$export$f6af8d48fd135434 = class {
    #listeners = {};
    #version = "1.0.0";
    #name = $5281e12b82edb2e4$export$f1265e9082f346f1;
    #url = "https://solanamobile.com/wallets";
    #icon = $5281e12b82edb2e4$var$icon;
    #appIdentity;
    #authorization;
    #authorizationCache;
    #connecting = false;
    /**
	* Every time the connection is recycled in some way (eg. `disconnect()` is called)
	* increment this and use it to make sure that `transact` calls from the previous
	* 'generation' don't continue to do work and throw exceptions.
	*/ #connectionGeneration = 0;
    #chains = [];
    #chainSelector;
    #optionalFeatures;
    #onWalletNotFound;
    #nostrRelay;
    get version() {
        return this.#version;
    }
    get name() {
        return this.#name;
    }
    get url() {
        return this.#url;
    }
    get icon() {
        return this.#icon;
    }
    get chains() {
        return this.#chains;
    }
    get features() {
        return {
            [(0, $744408f28809a335$export$cc68487eeb93b1d4)]: {
                version: "1.0.0",
                connect: this.#connect
            },
            [(0, $393285782087969c$export$38dbd4bbb9b696e6)]: {
                version: "1.0.0",
                disconnect: this.#disconnect
            },
            [(0, $f4859eee1867cbdd$export$5296443ca9e9fa0f)]: {
                version: "1.0.0",
                on: this.#on
            },
            [(0, $5a4be9421d6e6c61$export$22c7939a38084172)]: {
                version: "1.0.0",
                signMessage: this.#signMessage
            },
            [(0, $29a99a74b28f2560$export$8adeab75f48a3607)]: {
                version: "1.0.0",
                signIn: this.#signIn
            },
            ...this.#optionalFeatures
        };
    }
    get accounts() {
        return this.#authorization?.accounts ?? [];
    }
    constructor(config){
        this.#authorizationCache = config.authorizationCache;
        this.#appIdentity = config.appIdentity;
        this.#chains = config.chains;
        this.#chainSelector = config.chainSelector;
        this.#onWalletNotFound = config.onWalletNotFound;
        this.#nostrRelay = config.nostrRelay;
        this.#optionalFeatures = {
            [(0, $da368ee8f406d58d$export$dd64f32469f35f81)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signAndSendTransaction: this.#signAndSendTransaction
            },
            [(0, $97e08ae06ec466db$export$54187c3796d0ecb)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signTransaction: this.#signTransaction
            }
        };
    }
    get connected() {
        return !!this.#authorization;
    }
    get isAuthorized() {
        return !!this.#authorization;
    }
    get currentAuthorization() {
        return this.#authorization;
    }
    get cachedAuthorizationResult() {
        return this.#authorizationCache.get();
    }
    #on = (event, listener)=>{
        this.#listeners[event]?.push(listener) || (this.#listeners[event] = [
            listener
        ]);
        return ()=>this.#off(event, listener);
    };
    #emit(event, ...args) {
        this.#listeners[event]?.forEach((listener)=>listener.apply(null, args));
    }
    #off(event, listener) {
        this.#listeners[event] = this.#listeners[event]?.filter((existingListener)=>listener !== existingListener);
    }
    #connect = async ({ silent: silent } = {})=>{
        if (this.#connecting || this.connected) return {
            accounts: this.accounts
        };
        this.#connecting = true;
        try {
            if (silent) {
                const cachedAuthorization = await this.#authorizationCache.get();
                if (cachedAuthorization) {
                    await this.#handleWalletCapabilitiesResult(cachedAuthorization.capabilities);
                    await this.#handleAuthorizationResult(cachedAuthorization);
                } else return {
                    accounts: this.accounts
                };
            } else await this.#performAuthorization();
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        } finally{
            this.#connecting = false;
        }
        return {
            accounts: this.accounts
        };
    };
    #performAuthorization = async (signInPayload)=>{
        try {
            const cachedAuthorizationResult = await this.#authorizationCache.get();
            if (cachedAuthorizationResult) {
                this.#handleAuthorizationResult(cachedAuthorizationResult);
                return cachedAuthorizationResult;
            }
            const selectedChain = await this.#chainSelector.select(this.#chains);
            return await this.#transact(async (wallet)=>{
                const [capabilities, mwaAuthorizationResult] = await Promise.all([
                    wallet.getCapabilities(),
                    wallet.authorize({
                        chain: selectedChain,
                        identity: this.#appIdentity,
                        sign_in_payload: signInPayload
                    })
                ]);
                const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
                const authorization = {
                    ...mwaAuthorizationResult,
                    accounts: accounts,
                    chain: selectedChain,
                    capabilities: capabilities
                };
                Promise.all([
                    this.#handleWalletCapabilitiesResult(capabilities),
                    this.#authorizationCache.set(authorization),
                    this.#handleAuthorizationResult(authorization)
                ]);
                return authorization;
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #handleAuthorizationResult = async (authorization)=>{
        const didPublicKeysChange = this.#authorization == null || this.#authorization?.accounts.length !== authorization.accounts.length || this.#authorization.accounts.some((account, ii)=>account.address !== authorization.accounts[ii].address);
        this.#authorization = authorization;
        if (didPublicKeysChange) this.#emit("change", {
            accounts: this.accounts
        });
    };
    #handleWalletCapabilitiesResult = async (capabilities)=>{
        const supportsSignTransaction = capabilities.features.includes("solana:signTransactions");
        const supportsSignAndSendTransaction = capabilities.supports_sign_and_send_transactions;
        const didCapabilitiesChange = (0, $da368ee8f406d58d$export$dd64f32469f35f81) in this.features !== supportsSignAndSendTransaction || (0, $97e08ae06ec466db$export$54187c3796d0ecb) in this.features !== supportsSignTransaction;
        this.#optionalFeatures = {
            ...(supportsSignAndSendTransaction || !supportsSignAndSendTransaction && !supportsSignTransaction) && {
                [(0, $da368ee8f406d58d$export$dd64f32469f35f81)]: {
                    version: "1.0.0",
                    supportedTransactionVersions: [
                        "legacy",
                        0
                    ],
                    signAndSendTransaction: this.#signAndSendTransaction
                }
            },
            ...supportsSignTransaction && {
                [(0, $97e08ae06ec466db$export$54187c3796d0ecb)]: {
                    version: "1.0.0",
                    supportedTransactionVersions: [
                        "legacy",
                        0
                    ],
                    signTransaction: this.#signTransaction
                }
            }
        };
        if (didCapabilitiesChange) this.#emit("change", {
            features: this.features
        });
    };
    #performReauthorization = async (wallet, authToken, chain)=>{
        try {
            const [capabilities, mwaAuthorizationResult] = await Promise.all([
                this.#authorization?.capabilities ?? await wallet.getCapabilities(),
                wallet.authorize({
                    auth_token: authToken,
                    identity: this.#appIdentity,
                    chain: chain
                })
            ]);
            const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
            const authorization = {
                ...mwaAuthorizationResult,
                accounts: accounts,
                chain: chain,
                capabilities: capabilities
            };
            Promise.all([
                this.#authorizationCache.set(authorization),
                this.#handleAuthorizationResult(authorization)
            ]);
        } catch (e) {
            this.#disconnect();
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #disconnect = async ()=>{
        this.#authorizationCache.clear();
        this.#connecting = false;
        this.#connectionGeneration++;
        this.#authorization = void 0;
        this.#emit("change", {
            accounts: this.accounts
        });
    };
    #transact = async (callback)=>{
        const walletUriBase = this.#authorization?.wallet_uri_base;
        const config = walletUriBase ? {
            baseUri: walletUriBase
        } : void 0;
        const currentConnectionGeneration = this.#connectionGeneration;
        const loadingSpinner = new $5281e12b82edb2e4$var$EmbeddedLoadingSpinner();
        try {
            let associating = true;
            let timeout = void 0;
            const useWebSocket = await $5281e12b82edb2e4$var$isLocalWebSocketAvailable();
            const result = await Promise.race([
                (async ()=>{
                    if (!useWebSocket && !this.#nostrRelay) await $5281e12b82edb2e4$var$checkLocalNetworkAccessPermission();
                })().then(async ()=>{
                    loadingSpinner.init();
                    const { wallet: wallet, close: close } = !useWebSocket && this.#nostrRelay ? await (0, $b5177f26f29fa44f$export$d30526da7f04b709)({
                        ...config,
                        connectionType: "local",
                        relayDomain: this.#nostrRelay
                    }) : await (0, $b5177f26f29fa44f$export$9878cac6881bd297)(config);
                    associating = false;
                    loadingSpinner.addEventListener("close", (event)=>{
                        if (event) close();
                    });
                    loadingSpinner.open();
                    const result = await callback(await wallet);
                    loadingSpinner.close();
                    close();
                    return result;
                }),
                new Promise((_, reject)=>{
                    timeout = setTimeout(()=>{
                        if (associating) reject(new (0, $b5177f26f29fa44f$export$d77545679c409b63)((0, $b5177f26f29fa44f$export$93083e877aec7a8a).ERROR_ASSOCIATION_CANCELLED, "Wallet connection timed out", {
                            event: void 0
                        }));
                    }, $5281e12b82edb2e4$var$WALLET_ASSOCIATION_TIMEOUT);
                })
            ]);
            clearTimeout(timeout);
            return result;
        } catch (e) {
            loadingSpinner.close();
            if (this.#connectionGeneration !== currentConnectionGeneration) await new Promise(()=>{});
            if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") await this.#onWalletNotFound(this);
            throw e;
        }
    };
    #assertIsAuthorized = ()=>{
        if (!this.#authorization) throw new Error("Wallet not connected");
        return {
            authToken: this.#authorization.auth_token,
            chain: this.#authorization.chain
        };
    };
    #accountsToWalletStandardAccounts = (accounts)=>{
        return accounts.map((account)=>{
            const publicKey = (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(account.address);
            return {
                address: (0, $f97c98ce9ab46f75$export$625550452a3fa3ec)(publicKey),
                publicKey: publicKey,
                label: account.label,
                icon: account.icon,
                chains: account.chains ?? this.#chains,
                features: account.features ?? $5281e12b82edb2e4$var$DEFAULT_FEATURES
            };
        });
    };
    #performSignTransactions = async (transactions)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        try {
            const base64Transactions = transactions.map((tx)=>{
                return (0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(tx);
            });
            return await this.#transact(async (wallet)=>{
                await this.#performReauthorization(wallet, authToken, chain);
                return (await wallet.signTransactions({
                    payloads: base64Transactions
                })).signed_payloads.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816));
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #performSignAndSendTransaction = async (transaction, options)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        try {
            return await this.#transact(async (wallet)=>{
                const [capabilities] = await Promise.all([
                    wallet.getCapabilities(),
                    this.#performReauthorization(wallet, authToken, chain)
                ]);
                if (capabilities.supports_sign_and_send_transactions) {
                    const base64Transaction = (0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(transaction);
                    return (await wallet.signAndSendTransactions({
                        ...options,
                        payloads: [
                            base64Transaction
                        ]
                    })).signatures.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816))[0];
                } else throw new Error("connected wallet does not support signAndSendTransaction");
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #signAndSendTransaction = async (...inputs)=>{
        const outputs = [];
        for (const input of inputs){
            const signature = await this.#performSignAndSendTransaction(input.transaction, input.options);
            outputs.push({
                signature: signature
            });
        }
        return outputs;
    };
    #signTransaction = async (...inputs)=>{
        return (await this.#performSignTransactions(inputs.map(({ transaction: transaction })=>transaction))).map((signedTransaction)=>{
            return {
                signedTransaction: signedTransaction
            };
        });
    };
    #signMessage = async (...inputs)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        const addresses = inputs.map(({ account: account })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(new Uint8Array(account.publicKey)));
        const messages = inputs.map(({ message: message })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(message));
        try {
            return await this.#transact(async (wallet)=>{
                await this.#performReauthorization(wallet, authToken, chain);
                return (await wallet.signMessages({
                    addresses: addresses,
                    payloads: messages
                })).signed_payloads.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816)).map((signedMessage)=>{
                    return {
                        signedMessage: signedMessage,
                        signature: signedMessage.slice(-64)
                    };
                });
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #signIn = async (...inputs)=>{
        const outputs = [];
        if (inputs.length > 1) for (const input of inputs)outputs.push(await this.#performSignIn(input));
        else return [
            await this.#performSignIn(inputs[0])
        ];
        return outputs;
    };
    #performSignIn = async (input)=>{
        this.#connecting = true;
        try {
            const authorizationResult = await this.#performAuthorization({
                ...input,
                domain: input?.domain ?? window.location.host
            });
            if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
            const signedInAddress = authorizationResult.sign_in_result.address;
            const signedInAccount = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress);
            return {
                account: {
                    ...signedInAccount ?? {
                        address: (0, $f97c98ce9ab46f75$export$625550452a3fa3ec)((0, $f97c98ce9ab46f75$export$ae1af26003f05816)(signedInAddress))
                    },
                    publicKey: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(signedInAddress),
                    chains: signedInAccount?.chains ?? this.#chains,
                    features: signedInAccount?.features ?? authorizationResult.capabilities.features
                },
                signedMessage: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(authorizationResult.sign_in_result.signed_message),
                signature: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(authorizationResult.sign_in_result.signature)
            };
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        } finally{
            this.#connecting = false;
        }
    };
};
var $5281e12b82edb2e4$export$4f5721d56be54e3 = class {
    #listeners = {};
    #version = "1.0.0";
    #name = $5281e12b82edb2e4$export$8701a18cc5ef8b26;
    #url = "https://solanamobile.com/wallets";
    #icon = $5281e12b82edb2e4$var$icon;
    #appIdentity;
    #authorization;
    #authorizationCache;
    #connecting = false;
    /**
	* Every time the connection is recycled in some way (eg. `disconnect()` is called)
	* increment this and use it to make sure that `transact` calls from the previous
	* 'generation' don't continue to do work and throw exceptions.
	*/ #connectionGeneration = 0;
    #chains = [];
    #chainSelector;
    #optionalFeatures;
    #onWalletNotFound;
    #relay;
    #session;
    get version() {
        return this.#version;
    }
    get name() {
        return this.#name;
    }
    get url() {
        return this.#url;
    }
    get icon() {
        return this.#icon;
    }
    get chains() {
        return this.#chains;
    }
    get features() {
        return {
            [(0, $744408f28809a335$export$cc68487eeb93b1d4)]: {
                version: "1.0.0",
                connect: this.#connect
            },
            [(0, $393285782087969c$export$38dbd4bbb9b696e6)]: {
                version: "1.0.0",
                disconnect: this.#disconnect
            },
            [(0, $f4859eee1867cbdd$export$5296443ca9e9fa0f)]: {
                version: "1.0.0",
                on: this.#on
            },
            [(0, $5a4be9421d6e6c61$export$22c7939a38084172)]: {
                version: "1.0.0",
                signMessage: this.#signMessage
            },
            [(0, $29a99a74b28f2560$export$8adeab75f48a3607)]: {
                version: "1.0.0",
                signIn: this.#signIn
            },
            ...this.#optionalFeatures
        };
    }
    get accounts() {
        return this.#authorization?.accounts ?? [];
    }
    constructor(config){
        this.#authorizationCache = config.authorizationCache;
        this.#appIdentity = config.appIdentity;
        this.#chains = config.chains;
        this.#chainSelector = config.chainSelector;
        this.#relay = "remoteHostAuthority" in config ? {
            kind: "reflector",
            domain: config.remoteHostAuthority
        } : {
            kind: "nostr",
            domain: config.nostrRelay
        };
        this.#onWalletNotFound = config.onWalletNotFound;
        this.#optionalFeatures = {
            [(0, $da368ee8f406d58d$export$dd64f32469f35f81)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signAndSendTransaction: this.#signAndSendTransaction
            },
            [(0, $97e08ae06ec466db$export$54187c3796d0ecb)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signTransaction: this.#signTransaction
            }
        };
    }
    get connected() {
        return !!this.#session && !!this.#authorization;
    }
    get isAuthorized() {
        return !!this.#authorization;
    }
    get currentAuthorization() {
        return this.#authorization;
    }
    get cachedAuthorizationResult() {
        return this.#authorizationCache.get();
    }
    #on = (event, listener)=>{
        this.#listeners[event]?.push(listener) || (this.#listeners[event] = [
            listener
        ]);
        return ()=>this.#off(event, listener);
    };
    #emit(event, ...args) {
        this.#listeners[event]?.forEach((listener)=>listener.apply(null, args));
    }
    #off(event, listener) {
        this.#listeners[event] = this.#listeners[event]?.filter((existingListener)=>listener !== existingListener);
    }
    #connect = async (_input = {})=>{
        if (this.#connecting || this.connected) return {
            accounts: this.accounts
        };
        this.#connecting = true;
        try {
            await this.#performAuthorization();
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        } finally{
            this.#connecting = false;
        }
        return {
            accounts: this.accounts
        };
    };
    #performAuthorization = async (signInPayload)=>{
        try {
            const cachedAuthorizationResult = await this.#authorizationCache.get();
            if (cachedAuthorizationResult) {
                this.#handleAuthorizationResult(cachedAuthorizationResult);
                return cachedAuthorizationResult;
            }
            if (this.#session) this.#session = void 0;
            const selectedChain = await this.#chainSelector.select(this.#chains);
            return await this.#transact(async (wallet)=>{
                const [capabilities, mwaAuthorizationResult] = await Promise.all([
                    wallet.getCapabilities(),
                    wallet.authorize({
                        chain: selectedChain,
                        identity: this.#appIdentity,
                        sign_in_payload: signInPayload
                    })
                ]);
                const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
                const authorizationResult = {
                    ...mwaAuthorizationResult,
                    accounts: accounts,
                    chain: selectedChain,
                    capabilities: capabilities
                };
                Promise.all([
                    this.#handleWalletCapabilitiesResult(capabilities),
                    this.#authorizationCache.set(authorizationResult),
                    this.#handleAuthorizationResult(authorizationResult)
                ]);
                return authorizationResult;
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #handleAuthorizationResult = async (authorization)=>{
        const didPublicKeysChange = this.#authorization == null || this.#authorization?.accounts.length !== authorization.accounts.length || this.#authorization.accounts.some((account, ii)=>account.address !== authorization.accounts[ii].address);
        this.#authorization = authorization;
        if (didPublicKeysChange) this.#emit("change", {
            accounts: this.accounts
        });
    };
    #handleWalletCapabilitiesResult = async (capabilities)=>{
        const supportsSignTransaction = capabilities.features.includes("solana:signTransactions");
        const supportsSignAndSendTransaction = capabilities.supports_sign_and_send_transactions || capabilities.features.includes("solana:signAndSendTransaction");
        const didCapabilitiesChange = (0, $da368ee8f406d58d$export$dd64f32469f35f81) in this.features !== supportsSignAndSendTransaction || (0, $97e08ae06ec466db$export$54187c3796d0ecb) in this.features !== supportsSignTransaction;
        this.#optionalFeatures = {
            ...supportsSignAndSendTransaction && {
                [(0, $da368ee8f406d58d$export$dd64f32469f35f81)]: {
                    version: "1.0.0",
                    supportedTransactionVersions: capabilities.supported_transaction_versions,
                    signAndSendTransaction: this.#signAndSendTransaction
                }
            },
            ...supportsSignTransaction && {
                [(0, $97e08ae06ec466db$export$54187c3796d0ecb)]: {
                    version: "1.0.0",
                    supportedTransactionVersions: capabilities.supported_transaction_versions,
                    signTransaction: this.#signTransaction
                }
            }
        };
        if (didCapabilitiesChange) this.#emit("change", {
            features: this.features
        });
    };
    #performReauthorization = async (wallet, authToken, chain)=>{
        try {
            const [capabilities, mwaAuthorizationResult] = await Promise.all([
                this.#authorization?.capabilities ?? await wallet.getCapabilities(),
                wallet.authorize({
                    auth_token: authToken,
                    identity: this.#appIdentity,
                    chain: chain
                })
            ]);
            const accounts = this.#accountsToWalletStandardAccounts(mwaAuthorizationResult.accounts);
            const authorization = {
                ...mwaAuthorizationResult,
                accounts: accounts,
                chain: chain,
                capabilities: capabilities
            };
            Promise.all([
                this.#authorizationCache.set(authorization),
                this.#handleAuthorizationResult(authorization)
            ]);
        } catch (e) {
            this.#disconnect();
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #disconnect = async ()=>{
        this.#session?.close();
        this.#authorizationCache.clear();
        this.#connecting = false;
        this.#connectionGeneration++;
        this.#authorization = void 0;
        this.#session = void 0;
        this.#emit("change", {
            accounts: this.accounts
        });
    };
    #transact = async (callback)=>{
        const walletUriBase = this.#authorization?.wallet_uri_base;
        const baseConfig = walletUriBase ? {
            baseUri: walletUriBase
        } : void 0;
        const currentConnectionGeneration = this.#connectionGeneration;
        const modal = new $5281e12b82edb2e4$var$RemoteConnectionModal();
        if (this.#session) return callback(this.#session.wallet);
        try {
            modal.init();
            modal.open();
            const { associationUrl: associationUrl, close: close, wallet: wallet } = this.#relay.kind == "reflector" ? await (0, $b5177f26f29fa44f$export$8de2984f0eeb5c1f)({
                ...baseConfig,
                remoteHostAuthority: this.#relay.domain
            }) : await (0, $b5177f26f29fa44f$export$d30526da7f04b709)({
                ...baseConfig,
                connectionType: "remote",
                relayDomain: this.#relay.domain
            });
            const removeCloseListener = modal.addEventListener("close", (event)=>{
                if (event) close();
            });
            modal.populateQRCode(associationUrl.toString());
            this.#session = {
                close: close,
                wallet: await wallet
            };
            removeCloseListener();
            modal.close();
            return await callback(this.#session.wallet);
        } catch (e) {
            modal.close();
            if (this.#connectionGeneration !== currentConnectionGeneration) await new Promise(()=>{});
            if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") await this.#onWalletNotFound(this);
            throw e;
        }
    };
    #assertIsAuthorized = ()=>{
        if (!this.#authorization) throw new Error("Wallet not connected");
        return {
            authToken: this.#authorization.auth_token,
            chain: this.#authorization.chain
        };
    };
    #accountsToWalletStandardAccounts = (accounts)=>{
        return accounts.map((account)=>{
            const publicKey = (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(account.address);
            return {
                address: (0, $f97c98ce9ab46f75$export$625550452a3fa3ec)(publicKey),
                publicKey: publicKey,
                label: account.label,
                icon: account.icon,
                chains: account.chains ?? this.#chains,
                features: account.features ?? $5281e12b82edb2e4$var$DEFAULT_FEATURES
            };
        });
    };
    #performSignTransactions = async (transactions)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        try {
            return await this.#transact(async (wallet)=>{
                await this.#performReauthorization(wallet, authToken, chain);
                return (await wallet.signTransactions({
                    payloads: transactions.map((0, $f97c98ce9ab46f75$export$23f2a1d2818174ef))
                })).signed_payloads.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816));
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #performSignAndSendTransaction = async (transaction, options)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        try {
            return await this.#transact(async (wallet)=>{
                const [capabilities] = await Promise.all([
                    wallet.getCapabilities(),
                    this.#performReauthorization(wallet, authToken, chain)
                ]);
                if (capabilities.supports_sign_and_send_transactions) return (await wallet.signAndSendTransactions({
                    ...options,
                    payloads: [
                        (0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(transaction)
                    ]
                })).signatures.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816))[0];
                else throw new Error("connected wallet does not support signAndSendTransaction");
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #signAndSendTransaction = async (...inputs)=>{
        const outputs = [];
        for (const input of inputs){
            const signature = await this.#performSignAndSendTransaction(input.transaction, input.options);
            outputs.push({
                signature: signature
            });
        }
        return outputs;
    };
    #signTransaction = async (...inputs)=>{
        return (await this.#performSignTransactions(inputs.map(({ transaction: transaction })=>transaction))).map((signedTransaction)=>{
            return {
                signedTransaction: signedTransaction
            };
        });
    };
    #signMessage = async (...inputs)=>{
        const { authToken: authToken, chain: chain } = this.#assertIsAuthorized();
        const addresses = inputs.map(({ account: account })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(new Uint8Array(account.publicKey)));
        const messages = inputs.map(({ message: message })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(message));
        try {
            return await this.#transact(async (wallet)=>{
                await this.#performReauthorization(wallet, authToken, chain);
                return (await wallet.signMessages({
                    addresses: addresses,
                    payloads: messages
                })).signed_payloads.map((0, $f97c98ce9ab46f75$export$ae1af26003f05816)).map((signedMessage)=>{
                    return {
                        signedMessage: signedMessage,
                        signature: signedMessage.slice(-64)
                    };
                });
            });
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        }
    };
    #signIn = async (...inputs)=>{
        const outputs = [];
        if (inputs.length > 1) for (const input of inputs)outputs.push(await this.#performSignIn(input));
        else return [
            await this.#performSignIn(inputs[0])
        ];
        return outputs;
    };
    #performSignIn = async (input)=>{
        this.#connecting = true;
        try {
            const authorizationResult = await this.#performAuthorization({
                ...input,
                domain: input?.domain ?? window.location.host
            });
            if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
            const signedInAddress = authorizationResult.sign_in_result.address;
            const signedInAccount = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress);
            return {
                account: {
                    ...signedInAccount ?? {
                        address: (0, $f97c98ce9ab46f75$export$625550452a3fa3ec)((0, $f97c98ce9ab46f75$export$ae1af26003f05816)(signedInAddress))
                    },
                    publicKey: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(signedInAddress),
                    chains: signedInAccount?.chains ?? this.#chains,
                    features: signedInAccount?.features ?? authorizationResult.capabilities.features
                },
                signedMessage: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(authorizationResult.sign_in_result.signed_message),
                signature: (0, $f97c98ce9ab46f75$export$ae1af26003f05816)(authorizationResult.sign_in_result.signature)
            };
        } catch (e) {
            throw new Error($5281e12b82edb2e4$var$getErrorMessage(e), {
                cause: e
            });
        } finally{
            this.#connecting = false;
        }
    };
};
//#endregion
//#region src/initialize.ts
function $5281e12b82edb2e4$export$81515f9c716e8230(config) {
    if (typeof window === "undefined") {
        console.warn(`MWA not registered: no window object`);
        return;
    }
    if (!window.isSecureContext) {
        console.warn(`MWA not registered: secure context required (https)`);
        return;
    }
    const userAgent = navigator.userAgent;
    if ($5281e12b82edb2e4$var$getIsLocalAssociationSupported() && (!$5281e12b82edb2e4$var$isWebView(userAgent) || $5281e12b82edb2e4$var$isSolanaMobileWebShell(userAgent))) (0, $aff560f1983590b4$export$ecffa18c0543eceb)(new $5281e12b82edb2e4$export$f6af8d48fd135434(config));
    else if ($5281e12b82edb2e4$var$getIsRemoteAssociationSupported() && ("nostrRelay" in config || config.remoteHostAuthority !== void 0)) {
        if ("nostrRelay" in config) (0, $aff560f1983590b4$export$ecffa18c0543eceb)(new $5281e12b82edb2e4$export$4f5721d56be54e3({
            ...config,
            nostrRelay: config.nostrRelay
        }));
        else (0, $aff560f1983590b4$export$ecffa18c0543eceb)(new $5281e12b82edb2e4$export$4f5721d56be54e3({
            ...config,
            remoteHostAuthority: config.remoteHostAuthority
        }));
    } else console.warn(`MWA not registered: device or environment not supported`);
}



//#region src/getIsSupported.ts
function $20df54e889d0f5a2$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
//#endregion
//#region src/adapter.ts
const $20df54e889d0f5a2$export$f1265e9082f346f1 = (0, $5281e12b82edb2e4$export$f1265e9082f346f1);
const $20df54e889d0f5a2$export$8701a18cc5ef8b26 = (0, $5281e12b82edb2e4$export$8701a18cc5ef8b26);
const $20df54e889d0f5a2$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $20df54e889d0f5a2$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
function $20df54e889d0f5a2$var$chainOrClusterToChainId(chain) {
    switch(chain){
        case "mainnet-beta":
            return "solana:mainnet";
        case "testnet":
            return "solana:testnet";
        case "devnet":
            return "solana:devnet";
        default:
            return chain;
    }
}
function $20df54e889d0f5a2$var$getErrorMessage(error) {
    return error instanceof Error ? error.message : "Unknown error";
}
var $20df54e889d0f5a2$var$BaseSolanaMobileWalletAdapter = class extends (0, $71b3859dfb523e38$export$9779f871ffdb3d87) {
    supportedTransactionVersions = /* @__PURE__ */ new Set([
        "legacy",
        0
    ]);
    name;
    icon;
    url;
    #wallet;
    #connecting = false;
    #readyState = $20df54e889d0f5a2$var$getIsSupported() ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported;
    #accountSelector;
    #selectedAccount;
    #publicKey;
    #handleChangeEvent = async (properties)=>{
        if (properties.accounts && properties.accounts.length > 0) {
            this.#declareWalletAsInstalled();
            const nextSelectedAccount = await this.#accountSelector(properties.accounts);
            if (nextSelectedAccount !== this.#selectedAccount) {
                this.#selectedAccount = nextSelectedAccount;
                this.#publicKey = void 0;
                this.emit("connect", this.publicKey);
            }
        }
    };
    constructor(wallet, config){
        super();
        this.#accountSelector = async (accounts)=>{
            const selectedBase64EncodedAddress = await config.addressSelector.select(accounts.map(({ publicKey: publicKey })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(new Uint8Array(publicKey))));
            return accounts.find(({ publicKey: publicKey })=>(0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(new Uint8Array(publicKey)) === selectedBase64EncodedAddress) ?? accounts[0];
        };
        this.#wallet = wallet;
        this.#wallet.features[0, $f4859eee1867cbdd$export$5296443ca9e9fa0f].on("change", this.#handleChangeEvent);
        this.name = this.#wallet.name;
        this.icon = this.#wallet.icon;
        this.url = this.#wallet.url;
    }
    get publicKey() {
        if (!this.#publicKey && this.#selectedAccount) try {
            this.#publicKey = new (0, $gNDby.PublicKey)(this.#selectedAccount.publicKey);
        } catch (e) {
            throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(e instanceof Error && e?.message || "Unknown error", e);
        }
        return this.#publicKey ?? null;
    }
    get connected() {
        return this.#wallet.connected;
    }
    get connecting() {
        return this.#connecting;
    }
    get readyState() {
        return this.#readyState;
    }
    /** @deprecated Use `autoConnect()` instead. */ async autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return await this.autoConnect();
    }
    async autoConnect() {
        this.#connect(true);
    }
    async connect() {
        this.#connect();
    }
    async #connect(autoConnect = false) {
        if (this.connecting || this.connected) return;
        return await this.#runWithGuard(async ()=>{
            if (this.#readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && this.#readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            this.#connecting = true;
            try {
                await this.#wallet.features[0, $744408f28809a335$export$cc68487eeb93b1d4].connect({
                    silent: autoConnect
                });
            } catch (e) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            } finally{
                this.#connecting = false;
            }
        });
    }
    /** @deprecated Use `connect()` or `autoConnect()` instead. */ async performAuthorization(signInPayload) {
        try {
            const cachedAuthorizationResult = await this.#wallet.cachedAuthorizationResult;
            if (cachedAuthorizationResult) {
                await this.#wallet.features[0, $744408f28809a335$export$cc68487eeb93b1d4].connect({
                    silent: true
                });
                return cachedAuthorizationResult;
            }
            if (signInPayload) await this.#wallet.features[0, $29a99a74b28f2560$export$8adeab75f48a3607].signIn(signInPayload);
            else await this.#wallet.features[0, $744408f28809a335$export$cc68487eeb93b1d4].connect();
            return await await this.#wallet.cachedAuthorizationResult;
        } catch (e) {
            throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
        }
    }
    async disconnect() {
        return await this.#runWithGuard(async ()=>{
            this.#connecting = false;
            this.#publicKey = void 0;
            this.#selectedAccount = void 0;
            await this.#wallet.features[0, $393285782087969c$export$38dbd4bbb9b696e6].disconnect();
            this.emit("disconnect");
        });
    }
    async signIn(input) {
        return this.#runWithGuard(async ()=>{
            if (this.#readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && this.#readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            this.#connecting = true;
            try {
                const outputs = await this.#wallet.features[0, $29a99a74b28f2560$export$8adeab75f48a3607].signIn({
                    ...input,
                    domain: input?.domain ?? window.location.host
                });
                if (outputs.length > 0) return outputs[0];
                else throw new Error("Sign in failed, no sign in result returned by wallet");
            } catch (e) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            } finally{
                this.#connecting = false;
            }
        });
    }
    async signMessage(message) {
        return await this.#runWithGuard(async ()=>{
            const account = this.#assertIsAuthorized();
            try {
                return (await this.#wallet.features[0, $5a4be9421d6e6c61$export$22c7939a38084172].signMessage({
                    account: account,
                    message: message
                }))[0].signature;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)($20df54e889d0f5a2$var$getErrorMessage(error), error);
            }
        });
    }
    async sendTransaction(transaction, connection, options) {
        return await this.#runWithGuard(async ()=>{
            const account = this.#assertIsAuthorized();
            try {
                function getTargetCommitment() {
                    let targetCommitment;
                    switch(connection.commitment){
                        case "confirmed":
                        case "finalized":
                        case "processed":
                            targetCommitment = connection.commitment;
                            break;
                        default:
                            targetCommitment = "finalized";
                    }
                    let targetPreflightCommitment;
                    switch(options?.preflightCommitment){
                        case "confirmed":
                        case "finalized":
                        case "processed":
                            targetPreflightCommitment = options.preflightCommitment;
                            break;
                        case void 0:
                            targetPreflightCommitment = targetCommitment;
                            break;
                        default:
                            targetPreflightCommitment = "finalized";
                    }
                    return (targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0) < (targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0) ? targetPreflightCommitment : targetCommitment;
                }
                if ((0, $da368ee8f406d58d$export$dd64f32469f35f81) in this.#wallet.features) {
                    const chain = $20df54e889d0f5a2$var$chainOrClusterToChainId(this.#wallet.currentAuthorization.chain);
                    const [signature] = (await this.#wallet.features[0, $da368ee8f406d58d$export$dd64f32469f35f81].signAndSendTransaction({
                        account: account,
                        transaction: transaction.serialize(),
                        chain: chain,
                        options: options ? {
                            skipPreflight: options.skipPreflight,
                            maxRetries: options.maxRetries
                        } : void 0
                    })).map((output)=>{
                        return (0, $f97c98ce9ab46f75$export$23f2a1d2818174ef)(output.signature);
                    });
                    return signature;
                } else {
                    const [signedTransaction] = await this.#performSignTransactions([
                        transaction
                    ]);
                    if ($20df54e889d0f5a2$var$isVersionedTransaction(signedTransaction)) return await connection.sendTransaction(signedTransaction);
                    else {
                        const serializedTransaction = signedTransaction.serialize();
                        return await connection.sendRawTransaction(serializedTransaction, {
                            ...options,
                            preflightCommitment: getTargetCommitment()
                        });
                    }
                }
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)($20df54e889d0f5a2$var$getErrorMessage(error), error);
            }
        });
    }
    async signTransaction(transaction) {
        return await this.#runWithGuard(async ()=>{
            const [signedTransaction] = await this.#performSignTransactions([
                transaction
            ]);
            return signedTransaction;
        });
    }
    async signAllTransactions(transactions) {
        return await this.#runWithGuard(async ()=>{
            return await this.#performSignTransactions(transactions);
        });
    }
    #declareWalletAsInstalled() {
        if (this.#readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this.#readyState = (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed);
    }
    #assertIsAuthorized() {
        if (!this.#wallet.isAuthorized || !this.#selectedAccount) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        return this.#selectedAccount;
    }
    async #performSignTransactions(transactions) {
        const account = this.#assertIsAuthorized();
        try {
            if ((0, $97e08ae06ec466db$export$54187c3796d0ecb) in this.#wallet.features) return this.#wallet.features[0, $97e08ae06ec466db$export$54187c3796d0ecb].signTransaction(...transactions.map((value)=>{
                return {
                    account: account,
                    transaction: value.serialize()
                };
            })).then((outputs)=>{
                return outputs.map((output)=>{
                    const byteArray = output.signedTransaction;
                    const messageOffset = byteArray[0] * $20df54e889d0f5a2$var$SIGNATURE_LENGTH_IN_BYTES + 1;
                    if ((0, $gNDby.VersionedMessage).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length)) === "legacy") return (0, $gNDby.Transaction).from(byteArray);
                    else return (0, $gNDby.VersionedTransaction).deserialize(byteArray);
                });
            });
            else throw new Error("Connected wallet does not support signing transactions");
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)($20df54e889d0f5a2$var$getErrorMessage(error), error);
        }
    }
    async #runWithGuard(callback) {
        try {
            return await callback();
        } catch (e) {
            this.emit("error", e instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d) ? e : new (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)($20df54e889d0f5a2$var$getErrorMessage(e), e));
            throw e;
        }
    }
};
var $20df54e889d0f5a2$export$54210add0a0aa7b7 = class extends $20df54e889d0f5a2$var$BaseSolanaMobileWalletAdapter {
    constructor(config){
        const chain = $20df54e889d0f5a2$var$chainOrClusterToChainId(config.chain ?? config.cluster);
        super(new (0, $5281e12b82edb2e4$export$f6af8d48fd135434)({
            appIdentity: config.appIdentity,
            authorizationCache: {
                set: config.authorizationResultCache.set,
                get: async ()=>{
                    return await config.authorizationResultCache.get();
                },
                clear: config.authorizationResultCache.clear
            },
            chains: [
                chain
            ],
            chainSelector: (0, $5281e12b82edb2e4$export$6b2da63ffd66543a)(),
            onWalletNotFound: async ()=>{
                config.onWalletNotFound(this);
            }
        }), {
            addressSelector: config.addressSelector,
            chain: chain
        });
    }
};
var $20df54e889d0f5a2$export$3a756d1397cdc444 = class extends $20df54e889d0f5a2$var$BaseSolanaMobileWalletAdapter {
    constructor(config){
        const chain = $20df54e889d0f5a2$var$chainOrClusterToChainId(config.chain);
        const baseConfig = {
            appIdentity: config.appIdentity,
            authorizationCache: {
                set: config.authorizationResultCache.set,
                get: async ()=>{
                    return await config.authorizationResultCache.get();
                },
                clear: config.authorizationResultCache.clear
            },
            chains: [
                chain
            ],
            chainSelector: (0, $5281e12b82edb2e4$export$6b2da63ffd66543a)(),
            onWalletNotFound: async ()=>{
                config.onWalletNotFound(this);
            }
        };
        super("remoteHostAuthority" in config ? new (0, $5281e12b82edb2e4$export$4f5721d56be54e3)({
            ...baseConfig,
            remoteHostAuthority: config.remoteHostAuthority
        }) : new (0, $5281e12b82edb2e4$export$4f5721d56be54e3)({
            ...baseConfig,
            nostrRelay: config.nostrRelay
        }), {
            addressSelector: config.addressSelector,
            chain: chain
        });
    }
};
var $20df54e889d0f5a2$export$dec251788b2f5a84 = class extends $20df54e889d0f5a2$export$54210add0a0aa7b7 {
};
//#endregion
//#region src/createDefaultAddressSelector.ts
function $20df54e889d0f5a2$export$a299fb0acc11345b() {
    return {
        async select (addresses) {
            return addresses[0];
        }
    };
}
//#endregion
//#region src/createDefaultAuthorizationResultCache.ts
function $20df54e889d0f5a2$export$4a0b597891770806() {
    return (0, $5281e12b82edb2e4$export$feee530a776f5153)();
}
//#endregion
//#region src/createDefaultWalletNotFoundHandler.ts
async function $20df54e889d0f5a2$var$defaultWalletNotFoundHandler(_mobileWalletAdapter) {
    return (0, $5281e12b82edb2e4$export$b3dc230575b36468)();
}
function $20df54e889d0f5a2$export$e8b9e70cdf783b70() {
    return $20df54e889d0f5a2$var$defaultWalletNotFoundHandler;
}




function $c0bcda49505f4253$export$de6946e7c2c87e9a(wallet) {
    return (0, $744408f28809a335$export$cc68487eeb93b1d4) in wallet.features && (0, $f4859eee1867cbdd$export$5296443ca9e9fa0f) in wallet.features && ((0, $da368ee8f406d58d$export$dd64f32469f35f81) in wallet.features || (0, $97e08ae06ec466db$export$54187c3796d0ecb) in wallet.features);
}


const $16e373f5e81645b1$export$c5439c91843266e6 = (0, $c0bcda49505f4253$export$de6946e7c2c87e9a);




const $bd67609293f84bc3$export$9462d80112b287bf = 'https://api.mainnet-beta.solana.com';
const $bd67609293f84bc3$export$2416cc3545b31c3b = 'https://api.devnet.solana.com';
const $bd67609293f84bc3$export$fe3dc909dfa57ddb = 'https://api.testnet.solana.com';
const $bd67609293f84bc3$export$ec9ed1d68bb4713f = 'http://localhost:8899';
function $bd67609293f84bc3$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($bd67609293f84bc3$export$9462d80112b287bf)) return 0, $54a90126d2f96ce7$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $54a90126d2f96ce7$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $54a90126d2f96ce7$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $54a90126d2f96ce7$export$483699a75281444c;
    return 0, $54a90126d2f96ce7$export$bba9a228295b3963;
}
function $bd67609293f84bc3$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $54a90126d2f96ce7$export$bba9a228295b3963)) return $bd67609293f84bc3$export$9462d80112b287bf;
    if (chain === (0, $54a90126d2f96ce7$export$654cc095bd2e650)) return $bd67609293f84bc3$export$2416cc3545b31c3b;
    if (chain === (0, $54a90126d2f96ce7$export$76575b7bf4de1f40)) return $bd67609293f84bc3$export$fe3dc909dfa57ddb;
    if (chain === (0, $54a90126d2f96ce7$export$483699a75281444c)) return $bd67609293f84bc3$export$ec9ed1d68bb4713f;
    return $bd67609293f84bc3$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $89ddb6b3d1c020ef$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case 'processed':
        case 'confirmed':
        case 'finalized':
        case undefined:
            return commitment;
        case 'recent':
            return 'processed';
        case 'single':
        case 'singleGossip':
            return 'confirmed';
        case 'max':
        case 'root':
            return 'finalized';
        default:
            return undefined;
    }
}



var $gNDby = parcelRequire("gNDby");

var $59f593984632af6a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $59f593984632af6a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $59f593984632af6a$var$_ReadonlyWalletAccount_address, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, $59f593984632af6a$var$_ReadonlyWalletAccount_features, $59f593984632af6a$var$_ReadonlyWalletAccount_label, $59f593984632af6a$var$_ReadonlyWalletAccount_icon;
class $59f593984632af6a$export$c0ac434c7ac96eb0 {
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ get address() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_address, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ get publicKey() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ get chains() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ get features() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_features, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ get label() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_label, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ get icon() {
        return $59f593984632af6a$var$__classPrivateFieldGet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_icon, "f");
    }
    /**
     * Create and freeze a read-only account.
     *
     * @param account Account to copy properties from.
     */ constructor(account){
        $59f593984632af6a$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $59f593984632af6a$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if (new.target === $59f593984632af6a$export$c0ac434c7ac96eb0) Object.freeze(this);
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_address, account.address, "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_label, account.label, "f");
        $59f593984632af6a$var$__classPrivateFieldSet(this, $59f593984632af6a$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
}
$59f593984632af6a$var$_ReadonlyWalletAccount_address = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_chains = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_features = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_label = new WeakMap(), $59f593984632af6a$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $59f593984632af6a$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $59f593984632af6a$export$c663ab80cce302c5(a, b) {
    return $59f593984632af6a$export$234180f8206db11b(a, b);
}
function $59f593984632af6a$export$287dd7971339c972(first, ...others) {
    const length = others.reduce((length, bytes)=>length + bytes.length, first.length);
    const bytes = new Uint8Array(length);
    bytes.set(first, 0);
    for (const other of others)bytes.set(other, bytes.length);
    return bytes;
}
function $59f593984632af6a$export$357523c63a2253b9(source, ...keys) {
    const picked = {};
    for (const key of keys)picked[key] = source[key];
    return picked;
}
function $59f593984632af6a$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}



var $bYkMz = parcelRequire("bYkMz");
var $4dddbb5dcd84d46c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4dddbb5dcd84d46c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_supportedTransactionVersions, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_readyState, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connect, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connected, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnected, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_changed, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signTransaction, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signAllTransactions, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signMessage, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signIn;
class $4dddbb5dcd84d46c$export$e0949de9e32fe3b2 extends (0, $a27aaf340df890aa$export$2af1ea2892adc469) {
    get name() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").name;
    }
    get url() {
        return 'https://github.com/solana-labs/wallet-standard';
    }
    get icon() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").icon;
    }
    get readyState() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_readyState, "f");
    }
    get publicKey() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, "f");
    }
    get connecting() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, "f");
    }
    get supportedTransactionVersions() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
    }
    get wallet() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f");
    }
    get standard() {
        return true;
    }
    constructor({ wallet: wallet }){
        super();
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances.add(this);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_supportedTransactionVersions.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet.set(this, void 0);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_readyState.set(this, typeof window === 'undefined' || typeof document === 'undefined' ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed);
        $4dddbb5dcd84d46c$var$_StandardWalletAdapter_changed.set(this, (properties)=>{
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ('accounts' in properties) {
                const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f") && !$4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, "f") && account !== $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connected).call(this, account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        this.emit('error', new (0, $92c515b2e16b5c4e$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnected).call(this);
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ('features' in properties) $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset).call(this);
        });
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, wallet, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, null, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, null, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, false, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, false, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off, $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $f4859eee1867cbdd$export$5296443ca9e9fa0f].on('change', $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_changed, "f")), "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset).call(this);
    }
    destroy() {
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, null, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, null, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, false, "f");
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, false, "f");
        const off = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off, "f");
        if (off) {
            $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off, null, "f");
            off();
        }
    }
    async autoConnect() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connect).call(this, {
            silent: true
        });
    }
    async connect() {
        return $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connect).call(this);
    }
    async disconnect() {
        if ((0, $393285782087969c$export$38dbd4bbb9b696e6) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features) try {
            $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, true, "f");
            await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $393285782087969c$export$38dbd4bbb9b696e6].disconnect();
        } catch (error) {
            this.emit('error', new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
        } finally{
            $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting, false, "f");
        }
        $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnected).call(this);
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f");
            if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            let feature;
            if ((0, $da368ee8f406d58d$export$dd64f32469f35f81) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features) {
                if (account.features.includes((0, $da368ee8f406d58d$export$dd64f32469f35f81))) feature = (0, $da368ee8f406d58d$export$dd64f32469f35f81);
                else if ((0, $97e08ae06ec466db$export$54187c3796d0ecb) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $97e08ae06ec466db$export$54187c3796d0ecb))) feature = (0, $97e08ae06ec466db$export$54187c3796d0ecb);
                else throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
            } else if ((0, $97e08ae06ec466db$export$54187c3796d0ecb) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features) {
                if (!account.features.includes((0, $97e08ae06ec466db$export$54187c3796d0ecb))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
                feature = (0, $97e08ae06ec466db$export$54187c3796d0ecb);
            } else throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
            const chain = (0, $bd67609293f84bc3$export$43dcd8213c5a5741)(connection.rpcEndpoint);
            if (!account.chains.includes(chain)) throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)();
            try {
                const { signers: signers, ...sendOptions } = options;
                let serializedTransaction;
                if ((0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction)) {
                    signers?.length && transaction.sign(signers);
                    serializedTransaction = transaction.serialize();
                } else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                    serializedTransaction = new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }));
                }
                if (feature === (0, $da368ee8f406d58d$export$dd64f32469f35f81)) {
                    const [output] = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $da368ee8f406d58d$export$dd64f32469f35f81].signAndSendTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            skipPreflight: sendOptions.skipPreflight,
                            maxRetries: sendOptions.maxRetries,
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode(output.signature);
                } else {
                    const [output] = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $97e08ae06ec466db$export$54187c3796d0ecb].signTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    return await connection.sendRawTransaction(output.signedTransaction, {
                        ...sendOptions,
                        preflightCommitment: (0, $89ddb6b3d1c020ef$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                    });
                }
            } catch (error) {
                if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
}
$4dddbb5dcd84d46c$var$_StandardWalletAdapter_account = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_off = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_readyState = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_changed = new WeakMap(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances = new WeakSet(), $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connect = async function _StandardWalletAdapter_connect(input) {
    try {
        if (this.connected || this.connecting) return;
        if ($4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_readyState, "f") !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, true, "f");
        if (!$4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").accounts.length) try {
            await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $744408f28809a335$export$cc68487eeb93b1d4].connect(input);
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
        }
        const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").accounts[0];
        if (!account) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connected).call(this, account);
    } catch (error) {
        this.emit('error', error);
        throw error;
    } finally{
        $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connecting, false, "f");
    }
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    let publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $gNDby.PublicKey)(account.address);
    } catch (error) {
        throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
    }
    $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, account, "f");
    $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset).call(this);
    this.emit('connect', publicKey);
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, null, "f");
    $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_publicKey, null, "f");
    $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset).call(this);
    this.emit('disconnect');
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    const supportedTransactionVersions = (0, $da368ee8f406d58d$export$dd64f32469f35f81) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features ? $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $da368ee8f406d58d$export$dd64f32469f35f81].supportedTransactionVersions : $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $97e08ae06ec466db$export$54187c3796d0ecb].supportedTransactionVersions;
    $4dddbb5dcd84d46c$var$__classPrivateFieldSet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $59f593984632af6a$export$234180f8206db11b)(supportedTransactionVersions, [
        'legacy'
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $97e08ae06ec466db$export$54187c3796d0ecb) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features && $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $97e08ae06ec466db$export$54187c3796d0ecb))) {
        this.signTransaction = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $5a4be9421d6e6c61$export$22c7939a38084172) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features && $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $5a4be9421d6e6c61$export$22c7939a38084172))) this.signMessage = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $29a99a74b28f2560$export$8adeab75f48a3607) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signTransaction = async function _StandardWalletAdapter_signTransaction(transaction) {
    try {
        const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $97e08ae06ec466db$export$54187c3796d0ecb) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $97e08ae06ec466db$export$54187c3796d0ecb))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $97e08ae06ec466db$export$54187c3796d0ecb].signTransaction({
                account: account,
                transaction: (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                    requireAllSignatures: false,
                    verifySignatures: false
                }))
            });
            const serializedTransaction = signedTransactions[0].signedTransaction;
            return (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? (0, $gNDby.VersionedTransaction).deserialize(serializedTransaction) : (0, $gNDby.Transaction).from(serializedTransaction);
        } catch (error) {
            if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
            throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit('error', error);
        throw error;
    }
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signAllTransactions = async function _StandardWalletAdapter_signAllTransactions(transactions) {
    try {
        const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $97e08ae06ec466db$export$54187c3796d0ecb) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $97e08ae06ec466db$export$54187c3796d0ecb))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $97e08ae06ec466db$export$54187c3796d0ecb].signTransaction(...transactions.map((transaction)=>({
                    account: account,
                    transaction: (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }))
                })));
            return transactions.map((transaction, index)=>{
                const signedTransaction = signedTransactions[index].signedTransaction;
                return (0, $afa5c06c212ba160$export$37ce1cc82e255d8)(transaction) ? (0, $gNDby.VersionedTransaction).deserialize(signedTransaction) : (0, $gNDby.Transaction).from(signedTransaction);
            });
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit('error', error);
        throw error;
    }
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signMessage = async function _StandardWalletAdapter_signMessage(message) {
    try {
        const account = $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
        if (!((0, $5a4be9421d6e6c61$export$22c7939a38084172) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        if (!account.features.includes((0, $5a4be9421d6e6c61$export$22c7939a38084172))) throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)();
        try {
            const signedMessages = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $5a4be9421d6e6c61$export$22c7939a38084172].signMessage({
                account: account,
                message: message
            });
            return signedMessages[0].signature;
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error?.message, error);
        }
    } catch (error) {
        this.emit('error', error);
        throw error;
    }
}, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_signIn = async function _StandardWalletAdapter_signIn(input = {}) {
    try {
        if (!((0, $29a99a74b28f2560$export$8adeab75f48a3607) in $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)();
        let output;
        try {
            [output] = await $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_wallet, "f").features[0, $29a99a74b28f2560$export$8adeab75f48a3607].signIn(input);
        } catch (error) {
            throw new (0, $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c)(error?.message, error);
        }
        if (!output) throw new (0, $92c515b2e16b5c4e$export$a4c7d3c66e3cdd6c)();
        $4dddbb5dcd84d46c$var$__classPrivateFieldGet(this, $4dddbb5dcd84d46c$var$_StandardWalletAdapter_instances, "m", $4dddbb5dcd84d46c$var$_StandardWalletAdapter_connected).call(this, output.account);
        return output;
    } catch (error) {
        this.emit('error', error);
        throw error;
    }
};


var $86bcbe742b97bee8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $86bcbe742b97bee8$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $86bcbe742b97bee8$var$_AppReadyEvent_detail;
let $86bcbe742b97bee8$var$wallets = undefined;
const $86bcbe742b97bee8$var$registeredWalletsSet = new Set();
function $86bcbe742b97bee8$var$addRegisteredWallet(wallet) {
    $86bcbe742b97bee8$var$cachedWalletsArray = undefined;
    $86bcbe742b97bee8$var$registeredWalletsSet.add(wallet);
}
function $86bcbe742b97bee8$var$removeRegisteredWallet(wallet) {
    $86bcbe742b97bee8$var$cachedWalletsArray = undefined;
    $86bcbe742b97bee8$var$registeredWalletsSet.delete(wallet);
}
const $86bcbe742b97bee8$var$listeners = {};
function $86bcbe742b97bee8$export$ac4d188b6eef3eb7() {
    if ($86bcbe742b97bee8$var$wallets) return $86bcbe742b97bee8$var$wallets;
    $86bcbe742b97bee8$var$wallets = Object.freeze({
        register: $86bcbe742b97bee8$var$register,
        get: $86bcbe742b97bee8$var$get,
        on: $86bcbe742b97bee8$var$on
    });
    if (typeof window === 'undefined') return $86bcbe742b97bee8$var$wallets;
    const api = Object.freeze({
        register: $86bcbe742b97bee8$var$register
    });
    try {
        window.addEventListener('wallet-standard:register-wallet', ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error('wallet-standard:register-wallet event listener could not be added\n', error);
    }
    try {
        window.dispatchEvent(new $86bcbe742b97bee8$var$AppReadyEvent(api));
    } catch (error) {
        console.error('wallet-standard:app-ready event could not be dispatched\n', error);
    }
    return $86bcbe742b97bee8$var$wallets;
}
function $86bcbe742b97bee8$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$86bcbe742b97bee8$var$registeredWalletsSet.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$86bcbe742b97bee8$var$addRegisteredWallet(wallet));
    $86bcbe742b97bee8$var$listeners['register']?.forEach((listener)=>$86bcbe742b97bee8$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$86bcbe742b97bee8$var$removeRegisteredWallet(wallet));
        $86bcbe742b97bee8$var$listeners['unregister']?.forEach((listener)=>$86bcbe742b97bee8$var$guard(()=>listener(...wallets)));
    };
}
let $86bcbe742b97bee8$var$cachedWalletsArray;
function $86bcbe742b97bee8$var$get() {
    if (!$86bcbe742b97bee8$var$cachedWalletsArray) $86bcbe742b97bee8$var$cachedWalletsArray = [
        ...$86bcbe742b97bee8$var$registeredWalletsSet
    ];
    return $86bcbe742b97bee8$var$cachedWalletsArray;
}
function $86bcbe742b97bee8$var$on(event, listener) {
    $86bcbe742b97bee8$var$listeners[event]?.push(listener) || ($86bcbe742b97bee8$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $86bcbe742b97bee8$var$listeners[event] = $86bcbe742b97bee8$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $86bcbe742b97bee8$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $86bcbe742b97bee8$var$AppReadyEvent extends Event {
    get detail() {
        return $86bcbe742b97bee8$var$__classPrivateFieldGet(this, $86bcbe742b97bee8$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return 'wallet-standard:app-ready';
    }
    constructor(api){
        super('wallet-standard:app-ready', {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $86bcbe742b97bee8$var$_AppReadyEvent_detail.set(this, void 0);
        $86bcbe742b97bee8$var$__classPrivateFieldSet(this, $86bcbe742b97bee8$var$_AppReadyEvent_detail, api, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error('preventDefault cannot be called');
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error('stopImmediatePropagation cannot be called');
    }
    /** @deprecated */ stopPropagation() {
        throw new Error('stopPropagation cannot be called');
    }
}
$86bcbe742b97bee8$var$_AppReadyEvent_detail = new WeakMap();
function $86bcbe742b97bee8$export$2194deb72a59836d() {
    if ($86bcbe742b97bee8$var$wallets) return $86bcbe742b97bee8$var$wallets;
    $86bcbe742b97bee8$var$wallets = $86bcbe742b97bee8$export$ac4d188b6eef3eb7();
    if (typeof window === 'undefined') return $86bcbe742b97bee8$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error('window.navigator.wallets is not an array');
        return $86bcbe742b97bee8$var$wallets;
    }
    const { register: register } = $86bcbe742b97bee8$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$86bcbe742b97bee8$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, 'wallets', {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error('window.navigator.wallets could not be set');
        return $86bcbe742b97bee8$var$wallets;
    }
    push(...callbacks);
    return $86bcbe742b97bee8$var$wallets;
}



var $acw62 = parcelRequire("acw62");
function $49086cb6c557b9e5$export$ca3bd81d254ceecf(adapters) {
    const warnings = $49086cb6c557b9e5$var$useConstant(()=>new Set());
    const { get: get, on: on } = $49086cb6c557b9e5$var$useConstant(()=>(0, $86bcbe742b97bee8$export$2194deb72a59836d)());
    const [standardAdapters, setStandardAdapters] = (0, $acw62.useState)(()=>$49086cb6c557b9e5$var$wrapWalletsWithAdapters(get()));
    (0, $acw62.useEffect)(()=>{
        const listeners = [
            on('register', (...wallets)=>setStandardAdapters((standardAdapters)=>[
                        ...standardAdapters,
                        ...$49086cb6c557b9e5$var$wrapWalletsWithAdapters(wallets)
                    ])),
            on('unregister', (...wallets)=>setStandardAdapters((standardAdapters)=>standardAdapters.filter((standardAdapter)=>!wallets.includes(standardAdapter.wallet))))
        ];
        return ()=>listeners.forEach((off)=>off());
    }, [
        on
    ]);
    const prevStandardAdapters = $49086cb6c557b9e5$var$usePrevious(standardAdapters);
    (0, $acw62.useEffect)(()=>{
        if (!prevStandardAdapters) return;
        const currentAdapters = new Set(standardAdapters);
        const removedAdapters = new Set(prevStandardAdapters.filter((previousAdapter)=>!currentAdapters.has(previousAdapter)));
        removedAdapters.forEach((adapter)=>adapter.destroy());
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>()=>standardAdapters.forEach((adapter)=>adapter.destroy()), []);
    return (0, $acw62.useMemo)(()=>[
            ...standardAdapters,
            ...adapters.filter(({ name: name })=>{
                if (standardAdapters.some((standardAdapter)=>standardAdapter.name === name)) {
                    if (!warnings.has(name)) {
                        warnings.add(name);
                        console.warn(`${name} was registered as a Standard Wallet. The Wallet Adapter for ${name} can be removed from your app.`);
                    }
                    return false;
                }
                return true;
            })
        ], [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $49086cb6c557b9e5$var$useConstant(fn) {
    const ref = (0, $acw62.useRef)(undefined);
    if (ref.current === undefined) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $49086cb6c557b9e5$var$usePrevious(state) {
    const ref = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $49086cb6c557b9e5$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $16e373f5e81645b1$export$c5439c91843266e6)).map((wallet)=>new (0, $4dddbb5dcd84d46c$export$e0949de9e32fe3b2)({
            wallet: wallet
        }));
}



var $acw62 = parcelRequire("acw62");


var $75c7a421bb3832e5$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($75c7a421bb3832e5$export$7dc6752a22ab011a || ($75c7a421bb3832e5$export$7dc6752a22ab011a = {}));
function $75c7a421bb3832e5$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $75c7a421bb3832e5$export$2e2bcd8739ae039({ adapters: adapters, userAgentString: userAgentString }) {
    if (adapters.some((adapter)=>adapter.name !== (0, $20df54e889d0f5a2$export$f1265e9082f346f1) && adapter.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed)) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $75c7a421bb3832e5$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$75c7a421bb3832e5$var$isWebView(userAgentString)) return $75c7a421bb3832e5$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $75c7a421bb3832e5$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $5a1621a149c16912$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return 'mainnet-beta';
    if (/devnet/i.test(endpoint)) return 'devnet';
    else if (/testnet/i.test(endpoint)) return 'testnet';
    else return 'mainnet-beta';
}




var $acw62 = parcelRequire("acw62");
function $c2fd0e07139613a0$var$getLocalStorage() {
    try {
        if (typeof globalThis === 'undefined') return null;
        const storage = globalThis.localStorage;
        return storage ?? null;
    } catch  {
        // e.g. private mode / restricted environments where accessing localStorage throws
        return null;
    }
}
function $c2fd0e07139613a0$export$86e2cef2561044ac(key, defaultState) {
    const state = (0, $acw62.useState)(()=>{
        const storage = $c2fd0e07139613a0$var$getLocalStorage();
        if (!storage) return defaultState;
        try {
            const value = storage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== 'undefined') console.error(error);
        }
        return defaultState;
    });
    const value = state[0];
    const isFirstRenderRef = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            const storage = $c2fd0e07139613a0$var$getLocalStorage();
            if (!storage) return;
            if (value === null) storage.removeItem(key);
            else storage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== 'undefined') console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}




var $acw62 = parcelRequire("acw62");

class $3c176f8d57de1623$export$3f5ccdf96415785c extends (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d) {
    constructor(){
        super(...arguments);
        this.name = 'WalletNotSelectedError';
    }
}



function $9230ddfe51f70f6e$export$a50b3c99d691184b({ children: children, wallets: adapters, adapter: adapter, isUnloadingRef: isUnloadingRef, onAutoConnectRequest: onAutoConnectRequest, onConnectError: onConnectError, onError: onError, onSelectWallet: onSelectWallet }) {
    const isConnectingRef = (0, $acw62.useRef)(false);
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    const isDisconnectingRef = (0, $acw62.useRef)(false);
    const [disconnecting, setDisconnecting] = (0, $acw62.useState)(false);
    const [publicKey, setPublicKey] = (0, $acw62.useState)(()=>adapter?.publicKey ?? null);
    const [connected, setConnected] = (0, $acw62.useState)(()=>adapter?.connected ?? false);
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ const onErrorRef = (0, $acw62.useRef)(onError);
    (0, $acw62.useEffect)(()=>{
        onErrorRef.current = onError;
        return ()=>{
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    const handleErrorRef = (0, $acw62.useRef)((error, adapter)=>{
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $92c515b2e16b5c4e$export$d65db264eda99cd7) && typeof window !== 'undefined' && adapter) window.open(adapter.url, '_blank');
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    const [wallets, setWallets] = (0, $acw62.useState)(()=>adapters.map((adapter)=>({
                adapter: adapter,
                readyState: adapter.readyState
            })).filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported));
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $acw62.useEffect)(()=>{
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets((wallets)=>adapters.map((adapter, index)=>{
                const wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported));
        function handleReadyStateChange(readyState) {
            setWallets((prevWallets)=>{
                const index = prevWallets.findIndex(({ adapter: adapter })=>adapter === this);
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { adapter: adapter } = prevWallets[index];
                return [
                    ...prevWallets.slice(0, index),
                    {
                        adapter: adapter,
                        readyState: readyState
                    },
                    ...prevWallets.slice(index + 1)
                ].filter(({ readyState: readyState })=>readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported);
            });
        }
        adapters.forEach((adapter)=>adapter.on('readyStateChange', handleReadyStateChange, adapter));
        return ()=>{
            adapters.forEach((adapter)=>adapter.off('readyStateChange', handleReadyStateChange, adapter));
        };
    }, [
        adapter,
        adapters
    ]);
    const wallet = (0, $acw62.useMemo)(()=>wallets.find((wallet)=>wallet.adapter === adapter) ?? null, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $acw62.useEffect)(()=>{
        if (!adapter) return;
        const handleConnect = (publicKey)=>{
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleDisconnect = ()=>{
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleError = (error)=>{
            handleErrorRef.current(error, adapter);
        };
        adapter.on('connect', handleConnect);
        adapter.on('disconnect', handleDisconnect);
        adapter.on('error', handleError);
        return ()=>{
            adapter.off('connect', handleConnect);
            adapter.off('disconnect', handleDisconnect);
            adapter.off('error', handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    const didAttemptAutoConnectRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $acw62.useEffect)(()=>{
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !(wallet?.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed || wallet?.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (async function() {
            try {
                await onAutoConnectRequest();
            } catch  {
                onConnectError();
            // Drop the error. It will be caught by `handleError` anyway.
            } finally{
                setConnecting(false);
                isConnectingRef.current = false;
            }
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    const sendTransaction = (0, $acw62.useCallback)(async (transaction, connection, options)=>{
        if (!adapter) throw handleErrorRef.current(new (0, $3c176f8d57de1623$export$3f5ccdf96415785c)());
        if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
        return await adapter.sendTransaction(transaction, connection, options);
    }, [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    const signTransaction = (0, $acw62.useMemo)(()=>adapter && 'signTransaction' in adapter ? async (transaction)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signTransaction(transaction);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    const signAllTransactions = (0, $acw62.useMemo)(()=>adapter && 'signAllTransactions' in adapter ? async (transactions)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signAllTransactions(transactions);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    const signMessage = (0, $acw62.useMemo)(()=>adapter && 'signMessage' in adapter ? async (message)=>{
            if (!connected) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$313d299817c74896)(), adapter);
            return await adapter.signMessage(message);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    const signIn = (0, $acw62.useMemo)(()=>adapter && 'signIn' in adapter ? async (input)=>{
            return await adapter.signIn(input);
        } : undefined, [
        adapter
    ]);
    const handleConnect = (0, $acw62.useCallback)(async ()=>{
        if (isConnectingRef.current || isDisconnectingRef.current || wallet?.adapter.connected) return;
        if (!wallet) throw handleErrorRef.current(new (0, $3c176f8d57de1623$export$3f5ccdf96415785c)());
        const { adapter: adapter, readyState: readyState } = wallet;
        if (!(readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed || readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)(), adapter);
        isConnectingRef.current = true;
        setConnecting(true);
        try {
            await adapter.connect();
        } catch (e) {
            onConnectError();
            throw e;
        } finally{
            setConnecting(false);
            isConnectingRef.current = false;
        }
    }, [
        onConnectError,
        wallet
    ]);
    const handleDisconnect = (0, $acw62.useCallback)(async ()=>{
        if (isDisconnectingRef.current) return;
        if (!adapter) return;
        isDisconnectingRef.current = true;
        setDisconnecting(true);
        try {
            await adapter.disconnect();
        } finally{
            setDisconnecting(false);
            isDisconnectingRef.current = false;
        }
    }, [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3aa6d87558212265$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


let $cd8099a814169194$var$_userAgent;
function $cd8099a814169194$var$getUserAgent() {
    if ($cd8099a814169194$var$_userAgent === undefined) $cd8099a814169194$var$_userAgent = globalThis.navigator?.userAgent ?? null;
    return $cd8099a814169194$var$_userAgent;
}
function $cd8099a814169194$var$getIsMobile(adapters) {
    const userAgentString = $cd8099a814169194$var$getUserAgent();
    return (0, $75c7a421bb3832e5$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $75c7a421bb3832e5$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $cd8099a814169194$var$getUriForAppIdentity() {
    const location = globalThis.location;
    if (!location) return;
    return `${location.protocol}//${location.host}`;
}
function $cd8099a814169194$export$717b22fc3a2082b3({ children: children, wallets: adapters, autoConnect: autoConnect, localStorageKey: localStorageKey = 'walletName', onError: onError }) {
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const adaptersWithStandardAdapters = (0, $49086cb6c557b9e5$export$ca3bd81d254ceecf)(adapters);
    const mobileWalletAdapter = (0, $acw62.useMemo)(()=>{
        if (!$cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        const existingMobileWalletAdapter = adaptersWithStandardAdapters.find((adapter)=>adapter.name === (0, $20df54e889d0f5a2$export$f1265e9082f346f1));
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $20df54e889d0f5a2$export$dec251788b2f5a84)({
            addressSelector: (0, $20df54e889d0f5a2$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $cd8099a814169194$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $20df54e889d0f5a2$export$4a0b597891770806)(),
            cluster: (0, $5a1621a149c16912$export$2e2bcd8739ae039)(connection?.rpcEndpoint),
            onWalletNotFound: (0, $20df54e889d0f5a2$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection?.rpcEndpoint
    ]);
    const adaptersWithMobileWalletAdapter = (0, $acw62.useMemo)(()=>{
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter,
            ...adaptersWithStandardAdapters
        ];
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    const [walletName, setWalletName] = (0, $c2fd0e07139613a0$export$86e2cef2561044ac)(localStorageKey, null);
    const adapter = (0, $acw62.useMemo)(()=>adaptersWithMobileWalletAdapter.find((a)=>a.name === walletName) ?? null, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    const changeWallet = (0, $acw62.useCallback)((nextWalletName)=>{
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $20df54e889d0f5a2$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            setWalletName(null);
        }
        adapter.on('disconnect', handleDisconnect);
        return ()=>{
            adapter.off('disconnect', handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    const hasUserSelectedAWallet = (0, $acw62.useRef)(false);
    const handleAutoConnectRequest = (0, $acw62.useMemo)(()=>{
        if (!autoConnect || !adapter) return;
        return async ()=>{
            // If autoConnect is true or returns true, use the default autoConnect behavior.
            if (autoConnect === true || await autoConnect(adapter)) {
                if (hasUserSelectedAWallet.current) await adapter.connect();
                else await adapter.autoConnect();
            }
        };
    }, [
        autoConnect,
        adapter
    ]);
    const isUnloadingRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (walletName === (0, $20df54e889d0f5a2$export$f1265e9082f346f1) && $cd8099a814169194$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    const handleConnectError = (0, $acw62.useCallback)(()=>{
        if (adapter) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    const selectWallet = (0, $acw62.useCallback)((walletName)=>{
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9230ddfe51f70f6e$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $a49dece09ceaa9bd$export$78768a9af065a7b = ({ id: id, children: children, expanded: expanded = false })=>{
    const ref = (0, $acw62.useRef)(null);
    const instant = (0, $acw62.useRef)(true);
    const transition = 'height 250ms ease-out';
    const openCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.scrollHeight + 'px';
        });
    };
    const closeCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.offsetHeight + 'px';
            node.style.overflow = 'hidden';
            requestAnimationFrame(()=>{
                node.style.height = '0';
            });
        });
    };
    (0, $acw62.useLayoutEffect)(()=>{
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? 'initial' : 'hidden';
            if (expanded) node.style.height = 'auto';
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === 'height') handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener('transitionend', handleTransitionEnd);
        return ()=>node.removeEventListener('transitionend', handleTransitionEnd);
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};




var $acw62 = parcelRequire("acw62");


const $d5bc90ea80ec8fbb$export$b6b33106605f17bb = ({ handleClick: handleClick, tabIndex: tabIndex, wallet: wallet })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed43aee2b6d2385b$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74cea3e5b753b58c$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, "Detected")));
};



var $acw62 = parcelRequire("acw62");
const $b6b1989aa7a0d175$export$d822b842d2dccc19 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};



const $1992e5ca812acf06$export$851b8e4aa786e6a1 = ({ className: className = '', container: container = 'body' })=>{
    const ref = (0, $acw62.useRef)(null);
    const { wallets: wallets, select: select } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $ca40ecc6394b8d2e$export$6fdf0454adae214b)();
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const [fadeIn, setFadeIn] = (0, $acw62.useState)(false);
    const [portal, setPortal] = (0, $acw62.useState)(null);
    const [listedWallets, collapsedWallets] = (0, $acw62.useMemo)(()=>{
        const installed = [];
        const notInstalled = [];
        for (const wallet of wallets)if (wallet.readyState === (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Installed) installed.push(wallet);
        else notInstalled.push(wallet);
        return installed.length ? [
            installed,
            notInstalled
        ] : [
            notInstalled,
            []
        ];
    }, [
        wallets
    ]);
    const hideModal = (0, $acw62.useCallback)(()=>{
        setFadeIn(false);
        setTimeout(()=>setVisible(false), 150);
    }, [
        setVisible
    ]);
    const handleClose = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    const handleWalletClick = (0, $acw62.useCallback)((event, walletName)=>{
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    const handleCollapseClick = (0, $acw62.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    const handleTabKey = (0, $acw62.useCallback)((event)=>{
        const node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        const focusableElements = node.querySelectorAll('button');
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') hideModal();
            else if (event.key === 'Tab') handleTabKey(event);
        };
        // Get original overflow
        const { overflow: overflow } = window.getComputedStyle(document.body);
        // Hack to enable fade in animation after mount
        setTimeout(()=>setFadeIn(true), 0);
        // Prevent scrolling on mount
        document.body.style.overflow = 'hidden';
        // Listen for keydown events
        window.addEventListener('keydown', handleKeyDown, false);
        return ()=>{
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener('keydown', handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $acw62.useLayoutEffect)(()=>setPortal(document.querySelector(container)), [
        container
    ]);
    return portal && (0, $11492dca620dcaa5$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: `wallet-adapter-modal ${fadeIn && 'wallet-adapter-modal-fade-in'} ${className}`,
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            wallet: wallet
        })), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a49dece09ceaa9bd$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, expanded ? 'Less ' : 'More ', "options"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? 'wallet-adapter-modal-list-more-icon-rotate' : ''}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b6b1989aa7a0d175$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, expanded ? 'Hide ' : 'Already have a wallet? View ', "options"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? 'wallet-adapter-modal-list-more-icon-rotate' : ''}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a49dece09ceaa9bd$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5bc90ea80ec8fbb$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


const $d7fa3fcfe186d6c8$export$43bb60413a8a3ee6 = ({ children: children, ...props })=>{
    const [visible, setVisible] = (0, $acw62.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca40ecc6394b8d2e$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1992e5ca812acf06$export$851b8e4aa786e6a1), {
        ...props
    }));
};




var $gNDby = parcelRequire("gNDby");
const $ccc5a1200daef488$export$451c6c898b82123e = 'Torus';

class $ccc5a1200daef488$export$94da6e8cd337dfaa extends (0, $71b3859dfb523e38$export$9db08bcddd106c96) {
    constructor({ params: params = {
        showTorusButton: false
    } } = {
        params: {
            showTorusButton: false
        }
    }){
        super();
        this.name = $ccc5a1200daef488$export$451c6c898b82123e;
        this.url = 'https://tor.us';
        this.icon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2IiByPSIxNiIgZmlsbD0iIzAzNjRGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjIxODYgOS40OTIxOUMxMC40NTM5IDkuNDkyMTkgOS44MzM5OCAxMC4xMTIxIDkuODMzOTggMTAuODc2OFYxMi40ODk4QzkuODMzOTggMTMuMjU0NSAxMC40NTM5IDEzLjg3NDQgMTEuMjE4NiAxMy44NzQ0SDEzLjY2ODRWMjIuODk3NkMxMy42Njg0IDIzLjY2MjMgMTQuMjg4MyAyNC4yODIyIDE1LjA1MyAyNC4yODIySDE2LjY2NkMxNy40MzA3IDI0LjI4MjIgMTguMDUwNiAyMy42NjIzIDE4LjA1MDYgMjIuODk3NlYxMi41MDE1QzE4LjA1MDYgMTIuNDk3NiAxOC4wNTA2IDEyLjQ5MzcgMTguMDUwNiAxMi40ODk4VjEwLjg3NjhDMTguMDUwNiAxMC4xMTIxIDE3LjQzMDcgOS40OTIxOSAxNi42NjYgOS40OTIxOUgxNS4wNTNIMTEuMjE4NloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMS4zMzc2IDEzLjg3NDRDMjIuNTQ3NyAxMy44NzQ0IDIzLjUyODcgMTIuODkzNCAyMy41Mjg3IDExLjY4MzNDMjMuNTI4NyAxMC40NzMyIDIyLjU0NzcgOS40OTIxOSAyMS4zMzc2IDkuNDkyMTlDMjAuMTI3NSA5LjQ5MjE5IDE5LjE0NjUgMTAuNDczMiAxOS4xNDY1IDExLjY4MzNDMTkuMTQ2NSAxMi44OTM0IDIwLjEyNzUgMTMuODc0NCAyMS4zMzc2IDEzLjg3NDRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K';
        this.supportedTransactionVersions = null;
        this._readyState = typeof window === 'undefined' || typeof document === 'undefined' ? (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Unsupported : (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable;
        this._connecting = false;
        this._wallet = null;
        this._publicKey = null;
        this._params = params;
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get connected() {
        return !!this._wallet?.isLoggedIn;
    }
    get readyState() {
        return this._readyState;
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this._readyState !== (0, $a27aaf340df890aa$export$2a7b8071105d05b6).Loadable) throw new (0, $92c515b2e16b5c4e$export$d65db264eda99cd7)();
            this._connecting = true;
            let TorusClass;
            try {
                TorusClass = (await (parcelRequire("ebfZx"))).default;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$9a551f94af9b0bf8)(error?.message, error);
            }
            let wallet;
            try {
                wallet = window.torus || new TorusClass();
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$9525019988612a5e)(error?.message, error);
            }
            if (!wallet.isInitialized) try {
                await wallet.init(this._params);
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$38f21f1c810261c7)(error?.message, error);
            }
            let accounts;
            try {
                accounts = await wallet.login();
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$cd6fa2f8e2a8a612)(error?.message, error);
            }
            let publicKey;
            try {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                publicKey = new (0, $gNDby.PublicKey)(accounts[0]);
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$735bef3bfb0f2c86)(error?.message, error);
            }
            this._wallet = wallet;
            this._publicKey = publicKey;
            this.emit('connect', publicKey);
        } catch (error) {
            this.emit('error', error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const wallet = this._wallet;
        if (wallet) {
            this._wallet = null;
            this._publicKey = null;
            try {
                if (wallet.isLoggedIn) await wallet.cleanUp();
            } catch (error) {
                this.emit('error', new (0, $92c515b2e16b5c4e$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit('disconnect');
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                const { signature: signature } = await wallet.signAndSendTransaction(transaction, sendOptions);
                return signature;
            } catch (error) {
                if (error instanceof (0, $92c515b2e16b5c4e$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $92c515b2e16b5c4e$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signTransaction(transaction) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signTransaction(transaction) || transaction;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signAllTransactions(transactions) || transactions;
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
    async signMessage(message) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $92c515b2e16b5c4e$export$313d299817c74896)();
            try {
                return await wallet.signMessage(message);
            } catch (error) {
                throw new (0, $92c515b2e16b5c4e$export$2622c1721bbd4b17)(error?.message, error);
            }
        } catch (error) {
            this.emit('error', error);
            throw error;
        }
    }
}



var $gNDby = parcelRequire("gNDby");

var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


const $ad6eb96a733c0ea2$export$5261e812c31263e7 = ({ children: children, recipient: recipient, label: label, splToken: splToken, icon: icon, symbol: symbol, decimals: decimals, minDecimals: minDecimals = 0, requiredConfirmations: requiredConfirmations = (0, $c3c4612a04ae44e4$export$d1c6250ed44053f0), connectWallet: connectWallet = false })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e019fb9064ab9dfa$export$a92f85ab3e9ad68b).Provider, {
        value: {
            recipient: recipient,
            label: label,
            splToken: splToken,
            symbol: symbol,
            icon: icon,
            decimals: decimals,
            minDecimals: minDecimals,
            requiredConfirmations: requiredConfirmations,
            connectWallet: connectWallet
        },
        children: children
    });
};




var $acw62 = parcelRequire("acw62");

function $ee73ad9ea4520533$export$d7e5f5607a21fc72() {
    return typeof document !== 'undefined' && !!(document.fullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen);
}
function $ee73ad9ea4520533$export$155b5dc43520b427() {
    const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
    if (exitFullscreen) exitFullscreen.call(document).catch((error)=>console.warn(error));
}
function $ee73ad9ea4520533$export$ce5e14e8a2a6d825() {
    const requestFullscreen = document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen || document.documentElement.mozRequestFullScreen || document.documentElement.msRequestFullscreen;
    if (requestFullscreen) requestFullscreen.call(document.documentElement).catch((error)=>console.warn(error));
}
function $ee73ad9ea4520533$export$1aba1ee5e6dc1474() {
    if ($ee73ad9ea4520533$export$d7e5f5607a21fc72()) $ee73ad9ea4520533$export$155b5dc43520b427();
    else $ee73ad9ea4520533$export$ce5e14e8a2a6d825();
}


const $d62b4117d570902d$export$985a58f449f041cc = ({ children: children })=>{
    const [fullscreen, setFullscreen] = (0, $acw62.useState)((0, $ee73ad9ea4520533$export$d7e5f5607a21fc72)());
    (0, $acw62.useLayoutEffect)(()=>setFullscreen((0, $ee73ad9ea4520533$export$d7e5f5607a21fc72)()), []);
    (0, $acw62.useLayoutEffect)(()=>{
        const listener = ()=>setFullscreen((0, $ee73ad9ea4520533$export$d7e5f5607a21fc72)());
        document.addEventListener('fullscreenchange', listener);
        document.addEventListener('webkitfullscreenchange', listener);
        return ()=>{
            document.removeEventListener('fullscreenchange', listener);
            document.removeEventListener('webkitfullscreenchange', listener);
        };
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        if (fullscreen) {
            document.documentElement.classList.add('fullscreen');
            return ()=>document.documentElement.classList.remove('fullscreen');
        }
    }, [
        fullscreen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7373bd93423a38b6$export$2ba283291ae215b4).Provider, {
        value: {
            fullscreen: fullscreen,
            toggleFullscreen: $ee73ad9ea4520533$export$1aba1ee5e6dc1474
        },
        children: children
    });
};






var $gNDby = parcelRequire("gNDby");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $21402e41490db56a$export$97a8146fc68cce0b() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { search: search } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    return (0, $acw62.useCallback)((pathname, options)=>navigate({
            pathname: pathname,
            search: search
        }, options), [
        navigate,
        search
    ]);
}



const $18961e5f5d06d3ae$export$202bc391a3eb96a = ({ children: children })=>{
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const { recipient: recipient, splToken: splToken, label: label, requiredConfirmations: requiredConfirmations, connectWallet: connectWallet } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const { publicKey: publicKey, sendTransaction: sendTransaction } = (0, $3aa6d87558212265$export$c34addee860b0acb)();
    const [amount, setAmount] = (0, $acw62.useState)();
    const [message, setMessage] = (0, $acw62.useState)();
    const [memo, setMemo] = (0, $acw62.useState)();
    const [reference, setReference] = (0, $acw62.useState)();
    const [signature, setSignature] = (0, $acw62.useState)();
    const [status, setStatus] = (0, $acw62.useState)((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).New);
    const [confirmations, setConfirmations] = (0, $acw62.useState)(0);
    const navigate = (0, $21402e41490db56a$export$97a8146fc68cce0b)();
    const progress = (0, $acw62.useMemo)(()=>confirmations / requiredConfirmations, [
        confirmations,
        requiredConfirmations
    ]);
    const url = (0, $acw62.useMemo)(()=>(0, $affe003e4d11b80a$export$1b3b10c8ada4b5e7)({
            recipient: recipient,
            amount: amount,
            splToken: splToken,
            reference: reference,
            label: label,
            message: message,
            memo: memo
        }).toString(), [
        recipient,
        amount,
        splToken,
        reference,
        label,
        message,
        memo
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        setAmount(undefined);
        setMessage(undefined);
        setMemo(undefined);
        setReference(undefined);
        setSignature(undefined);
        setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).New);
        setConfirmations(0);
        navigate('/new', {
            replace: true
        });
    }, [
        navigate
    ]);
    const generate = (0, $acw62.useCallback)(()=>{
        if (status === (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).New && !reference) {
            setReference((0, $gNDby.Keypair).generate().publicKey);
            setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Pending);
            navigate('/pending');
        }
    }, [
        status,
        reference,
        navigate
    ]);
    // If there's a connected wallet, use it to sign and send the transaction
    (0, $acw62.useEffect)(()=>{
        if (status === (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Pending && connectWallet && publicKey) {
            let changed = false;
            const run = async ()=>{
                try {
                    const parsed = (0, $f1d60412d4adebb9$export$4b3d9a5bae55976)(url);
                    if (!('recipient' in parsed) || !parsed.amount) return;
                    const transaction = await (0, $8f1af5f862f41861$export$4496203d8e8ed8bf)(connection, publicKey, {
                        recipient: parsed.recipient,
                        amount: parsed.amount,
                        splToken: parsed.splToken,
                        reference: parsed.reference,
                        memo: parsed.memo
                    });
                    if (!changed) await sendTransaction(transaction, connection);
                } catch (error) {
                    // If the transaction is declined or fails, try again
                    console.error(error);
                    timeout = setTimeout(run, 5000);
                }
            };
            let timeout = setTimeout(run, 0);
            return ()=>{
                changed = true;
                clearTimeout(timeout);
            };
        }
    }, [
        status,
        connectWallet,
        publicKey,
        url,
        connection,
        sendTransaction
    ]);
    // When the status is pending, poll for the transaction using the reference key
    (0, $acw62.useEffect)(()=>{
        if (!(status === (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Pending && reference && !signature)) return;
        let changed = false;
        const interval = setInterval(async ()=>{
            let signature;
            try {
                signature = await (0, $551a75e0b78a9257$export$d6236817627ac6ff)(connection, reference, {
                    finality: 'confirmed'
                });
                if (!changed) {
                    clearInterval(interval);
                    setSignature(signature.signature);
                    setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Confirmed);
                    navigate('/confirmed', {
                        replace: true
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                // If the RPC node doesn't have the transaction signature yet, try again
                if (!(error instanceof (0, $551a75e0b78a9257$export$aee33619f6db7629))) console.error(error);
            }
        }, 250);
        return ()=>{
            changed = true;
            clearInterval(interval);
        };
    }, [
        status,
        reference,
        signature,
        connection,
        navigate
    ]);
    // When the status is confirmed, validate the transaction against the provided params
    (0, $acw62.useEffect)(()=>{
        if (!(status === (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Confirmed && signature && amount)) return;
        let changed = false;
        const run = async ()=>{
            try {
                await (0, $6deb862192182b13$export$c93b909123043a2c)(connection, signature, {
                    recipient: recipient,
                    amount: amount,
                    splToken: splToken,
                    reference: reference
                }, {
                    commitment: 'confirmed'
                });
                if (!changed) setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Valid);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                // If the RPC node doesn't have the transaction yet, try again
                if (error instanceof (0, $6deb862192182b13$export$6f9800600a484b30) && (error.message === 'not found' || error.message === 'missing meta')) {
                    console.warn(error);
                    timeout = setTimeout(run, 250);
                    return;
                }
                console.error(error);
                setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Invalid);
            }
        };
        let timeout = setTimeout(run, 0);
        return ()=>{
            changed = true;
            clearTimeout(timeout);
        };
    }, [
        status,
        signature,
        amount,
        connection,
        recipient,
        splToken,
        reference
    ]);
    // When the status is valid, poll for confirmations until the transaction is finalized
    (0, $acw62.useEffect)(()=>{
        if (!(status === (0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Valid && signature)) return;
        let changed = false;
        const interval = setInterval(async ()=>{
            try {
                const response = await connection.getSignatureStatus(signature);
                const status = response.value;
                if (!status) return;
                if (status.err) throw status.err;
                if (!changed) {
                    setConfirmations(status.confirmations || 0);
                    if (status.confirmationStatus === 'finalized') {
                        clearInterval(interval);
                        setStatus((0, $9c00ffc6a7ba2f4f$export$999f810846f9d31d).Finalized);
                    }
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                console.log(error);
            }
        }, 250);
        return ()=>{
            changed = true;
            clearInterval(interval);
        };
    }, [
        status,
        signature,
        connection
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c00ffc6a7ba2f4f$export$d46d0749977ea231).Provider, {
        value: {
            amount: amount,
            setAmount: setAmount,
            message: message,
            setMessage: setMessage,
            memo: memo,
            setMemo: setMemo,
            reference: reference,
            signature: signature,
            status: status,
            confirmations: confirmations,
            progress: progress,
            url: url,
            reset: reset,
            generate: generate
        },
        children: children
    });
};




var $acw62 = parcelRequire("acw62");

const $1d24746e6b4c8e60$export$d8964aec282183a3 = ({ children: children })=>{
    const query = '(prefers-color-scheme: light)';
    const [theme, setTheme] = (0, $acw62.useState)(()=>typeof window !== 'undefined' && window.matchMedia && window.matchMedia(query).matches ? 'light' : 'dark');
    (0, $acw62.useLayoutEffect)(()=>{
        if (window.matchMedia) {
            const listener = (event)=>setTheme(event.matches ? 'light' : 'dark');
            window.matchMedia(query).addEventListener('change', listener);
            return ()=>window.matchMedia(query).removeEventListener('change', listener);
        }
    }, []);
    (0, $acw62.useLayoutEffect)(()=>{
        document.documentElement.classList.add(theme);
        return ()=>document.documentElement.classList.remove(theme);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4af075fe47980ed$export$2c657da244d00bd6).Provider, {
        value: {
            theme: theme,
            setTheme: setTheme
        },
        children: children
    });
};






var $gNDby = parcelRequire("gNDby");

var $dws6U = parcelRequire("dws6U");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $da07c62151760c48$export$d02fc7aba187370a = (0, $acw62.createContext)({});
function $da07c62151760c48$export$4127a74fddb92b6f() {
    return (0, $acw62.useContext)($da07c62151760c48$export$d02fc7aba187370a);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a00f75c511d2a4ee$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}



const $072c9e04e41b04b7$export$7646b9943da18268 = ({ children: children, pollInterval: pollInterval })=>{
    pollInterval ||= 10000;
    const { connection: connection } = (0, $86c338e4d5b0d511$export$985e8768c0e91dbc)();
    const { recipient: recipient, splToken: splToken } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const [associatedToken, setAssociatedToken] = (0, $acw62.useState)();
    const [signatures, setSignatures] = (0, $acw62.useState)([]);
    const [transactions, setTransactions] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Get the ATA for the recipient and token
    (0, $acw62.useEffect)(()=>{
        if (!splToken) return;
        let changed = false;
        (async ()=>{
            const associatedToken = await (0, $8bce0b6b9c22831c$export$d776e5c4182d21cc)(splToken, recipient);
            if (changed) return;
            setAssociatedToken(associatedToken);
        })();
        return ()=>{
            changed = true;
            setAssociatedToken(undefined);
        };
    }, [
        splToken,
        recipient
    ]);
    // Poll for signatures referencing the associated token account
    (0, $acw62.useEffect)(()=>{
        let changed = false;
        const run = async ()=>{
            try {
                setLoading(true);
                const confirmedSignatureInfos = await connection.getSignaturesForAddress(associatedToken || recipient, {
                    limit: 10
                }, 'confirmed');
                if (changed) return;
                setSignatures((prevSignatures)=>{
                    const nextSignatures = confirmedSignatureInfos.map(({ signature: signature })=>signature);
                    return (0, $a00f75c511d2a4ee$export$234180f8206db11b)(prevSignatures, nextSignatures) ? prevSignatures : nextSignatures;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                console.error(error);
            } finally{
                setLoading(false);
            }
        };
        const interval = setInterval(run, 5000);
        run();
        return ()=>{
            changed = true;
            clearInterval(interval);
            setSignatures([]);
        };
    }, [
        connection,
        associatedToken,
        recipient
    ]);
    // When the signatures change, poll and update the transactions
    (0, $acw62.useEffect)(()=>{
        if (!signatures.length) return;
        let changed = false;
        const run = async ()=>{
            let parsedConfirmedTransactions, signatureStatuses;
            try {
                setLoading(true);
                [parsedConfirmedTransactions, signatureStatuses] = await Promise.all([
                    connection.getParsedConfirmedTransactions(signatures),
                    connection.getSignatureStatuses(signatures, {
                        searchTransactionHistory: true
                    })
                ]);
            } catch (error) {
                if (changed) return;
                console.error(error);
                return;
            } finally{
                setLoading(false);
            }
            if (changed) return;
            setTransactions(signatures.map((signature, signatureIndex)=>{
                const parsedConfirmedTransaction = parsedConfirmedTransactions[signatureIndex];
                const signatureStatus = signatureStatuses.value[signatureIndex];
                if (!parsedConfirmedTransaction?.meta || !signatureStatus) return;
                const timestamp = parsedConfirmedTransaction.blockTime;
                const error = parsedConfirmedTransaction.meta.err;
                const status = signatureStatus.confirmationStatus;
                if (!timestamp || !status) return;
                if (parsedConfirmedTransaction.transaction.message.instructions.length !== 1) return;
                const instruction = parsedConfirmedTransaction.transaction.message.instructions[0];
                if (!('program' in instruction)) return;
                const program = instruction.program;
                const type = instruction.parsed?.type;
                const info = instruction.parsed.info;
                let preAmount, postAmount;
                if (!associatedToken) {
                    // Include only SystemProgram.transfer instructions
                    if (!(program === 'system' && type === 'transfer')) return;
                    // Include only transfers to the recipient
                    if (info?.destination !== recipient.toBase58()) return;
                    // Exclude self-transfers
                    if (info.source === recipient.toBase58()) return;
                    const accountIndex = parsedConfirmedTransaction.transaction.message.accountKeys.findIndex(({ pubkey: pubkey })=>pubkey.equals(recipient));
                    if (accountIndex === -1) return;
                    const preBalance = parsedConfirmedTransaction.meta.preBalances[accountIndex];
                    const postBalance = parsedConfirmedTransaction.meta.postBalances[accountIndex];
                    preAmount = new (0, $dws6U.default)(preBalance).div((0, $gNDby.LAMPORTS_PER_SOL));
                    postAmount = new (0, $dws6U.default)(postBalance).div((0, $gNDby.LAMPORTS_PER_SOL));
                } else {
                    // Include only TokenProgram.transfer / TokenProgram.transferChecked instructions
                    if (!(program === 'spl-token' && (type === 'transfer' || type === 'transferChecked'))) return;
                    // Include only transfers to the recipient ATA
                    if (info?.destination !== associatedToken.toBase58()) return;
                    // Exclude self-transfers
                    if (info.source === associatedToken.toBase58()) return;
                    const accountIndex = parsedConfirmedTransaction.transaction.message.accountKeys.findIndex(({ pubkey: pubkey })=>pubkey.equals(associatedToken));
                    if (accountIndex === -1) return;
                    const preBalance = parsedConfirmedTransaction.meta.preTokenBalances?.find((x)=>x.accountIndex === accountIndex);
                    if (!preBalance?.uiTokenAmount.uiAmountString) return;
                    const postBalance = parsedConfirmedTransaction.meta.postTokenBalances?.find((x)=>x.accountIndex === accountIndex);
                    if (!postBalance?.uiTokenAmount.uiAmountString) return;
                    preAmount = new (0, $dws6U.default)(preBalance.uiTokenAmount.uiAmountString);
                    postAmount = new (0, $dws6U.default)(postBalance.uiTokenAmount.uiAmountString);
                }
                // Exclude negative amounts
                if (postAmount.lt(preAmount)) return;
                const amount = postAmount.minus(preAmount).toString();
                const confirmations = status === 'finalized' ? (0, $c3c4612a04ae44e4$export$d1c6250ed44053f0) : signatureStatus.confirmations || 0;
                return {
                    signature: signature,
                    amount: amount,
                    timestamp: timestamp,
                    error: error,
                    status: status,
                    confirmations: confirmations
                };
            }).filter((transaction)=>!!transaction));
        };
        const interval = setInterval(run, pollInterval);
        run();
        return ()=>{
            changed = true;
            clearInterval(interval);
        };
    }, [
        signatures,
        connection,
        associatedToken,
        recipient,
        pollInterval
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da07c62151760c48$export$d02fc7aba187370a).Provider, {
        value: {
            transactions: transactions,
            loading: loading
        },
        children: children
    });
};




parcelRequire("acw62");
const $3cbb9327caf0f8a1$export$ba4b38cc28c66047 = ({ width: width = 32, height: height = 32 })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 84 84",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "22.0518",
                x2: "61.5149",
                y1: "64.0248",
                y2: "19.6111",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".08",
                        stopColor: "#9945ff"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".3",
                        stopColor: "#8752f3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".5",
                        stopColor: "#5497d5"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".6",
                        stopColor: "#43b4ca"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".72",
                        stopColor: "#28e0b9"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".97",
                        stopColor: "#19fb9b"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "42",
                cy: "42",
                fill: "#000",
                r: "42"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m65.7527 53.9024-7.9237 8.512c-.1723.1849-.3807.3323-.6123.4331-.2316.1007-.4814.1526-.7339.1525h-37.5629c-.1792 0-.3546-.0525-.5044-.1509-.1499-.0984-.2678-.2386-.3393-.4033-.0714-.1646-.0933-.3466-.0629-.5235s.1118-.3411.234-.4723l7.9299-8.512c.1717-.1844.3795-.3315.6103-.4323.2309-.1007.4799-.1529.7317-.1533h37.5609c.1792 0 .3546.0524.5044.1509.1499.0984.2678.2386.3393.4032.0714.1647.0933.3466.0629.5236-.0304.1769-.1118.3411-.234.4723zm-7.9237-17.1406c-.1723-.1849-.3807-.3323-.6123-.4331-.2316-.1007-.4814-.1526-.7339-.1525h-37.5629c-.1792 0-.3546.0524-.5044.1509-.1499.0984-.2678.2386-.3393.4032-.0714.1647-.0933.3467-.0629.5236s.1118.3411.234.4723l7.9299 8.512c.1717.1844.3795.3315.6103.4323.2309.1007.4799.1529.7317.1533h37.5609c.1792 0 .3546-.0524.5044-.1509.1499-.0984.2678-.2386.3393-.4032.0714-.1647.0933-.3467.0629-.5236s-.1118-.3411-.234-.4723zm-38.9091-6.1142h37.5629c.2525.0002.5023-.0518.7339-.1525.2316-.1008.44-.2482.6123-.4331l7.9237-8.512c.1222-.1312.2036-.2954.234-.4723s.0085-.3589-.0629-.5235c-.0715-.1647-.1894-.3049-.3393-.4033-.1498-.0984-.3252-.1509-.5044-.1509h-37.5609c-.2518.0004-.5008.0526-.7317.1534-.2308.1007-.4386.2478-.6103.4322l-7.9278 8.512c-.1222.1311-.2035.2951-.2339.4718-.0305.1768-.0088.3586.0624.5231.0712.1646.1888.3048.3383.4034.1496.0986.3246.1513.5037.1517z",
                fill: "url(#a)"
            })
        ]
    });
};


var $f41af8496518c92c$export$db3c28d99448dcff;
$f41af8496518c92c$export$db3c28d99448dcff = `xeS-LW_logo`;


const $d044d3f285a2da3f$export$6bfafc1e0f16edbd = ()=>{
    // If you're testing without a phone, set this to true to allow a browser-based wallet connection to be used
    const connectWallet = false;
    const wallets = (0, $acw62.useMemo)(()=>connectWallet ? [
            new (0, $27b337e06adc69ec$export$a8fff984faa686f6)(),
            new (0, $ccc5a1200daef488$export$94da6e8cd337dfaa)()
        ] : [], [
        connectWallet
    ]);
    const [params] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { recipient: recipient, label: label } = (0, $acw62.useMemo)(()=>{
        let recipient, label;
        const recipientParam = params.get('recipient');
        const labelParam = params.get('label');
        if (recipientParam && labelParam) try {
            recipient = new (0, $gNDby.PublicKey)(recipientParam);
            label = labelParam;
        } catch (error) {
            console.error(error);
        }
        return {
            recipient: recipient,
            label: label
        };
    }, [
        params
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d24746e6b4c8e60$export$d8964aec282183a3), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d62b4117d570902d$export$985a58f449f041cc), {
            children: recipient && label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95b24e620787a529$export$fd685cf7c99624bd), {
                endpoint: (0, $c3c4612a04ae44e4$export$2416cc3545b31c3b),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd8099a814169194$export$717b22fc3a2082b3), {
                    wallets: wallets,
                    autoConnect: connectWallet,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d7fa3fcfe186d6c8$export$43bb60413a8a3ee6), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad6eb96a733c0ea2$export$5261e812c31263e7), {
                            recipient: recipient,
                            label: label,
                            symbol: "SOL",
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbb9327caf0f8a1$export$ba4b38cc28c66047), {}),
                            decimals: 9,
                            minDecimals: 1,
                            requiredConfirmations: 9,
                            connectWallet: connectWallet,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $072c9e04e41b04b7$export$7646b9943da18268), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18961e5f5d06d3ae$export$202bc391a3eb96a), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
                                })
                            })
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $f41af8496518c92c$export$db3c28d99448dcff,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4cc807dfa418ba7$export$200d3d30c8dde009), {
                    width: 240,
                    height: 88
                })
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");





var $dws6U = parcelRequire("dws6U");
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;


var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}



var $fSwVM = parcelRequire("fSwVM");
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fSwVM.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $8a0cd77776020c49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}





function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $6bfc654d0d5b6f5d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $4ba07667a7282b10$export$2e2bcd8739ae039)(date).getTime() === (0, $f5125f9e9edab43e$export$2e2bcd8739ae039)(date).getTime();
}


function $2d8804d7e615dc3e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $1698c992e2cb67cc$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $6bfc654d0d5b6f5d$export$2e2bcd8739ae039)((0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $87eb8823ffa05467$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    return (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $c83d105896c1098b$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $c83d105896c1098b$var$defaultRoundingMethod = 'trunc';
function $c83d105896c1098b$export$b6474a47258c1211(method) {
    return method ? $c83d105896c1098b$var$roundingMap[method] : $c83d105896c1098b$var$roundingMap[$c83d105896c1098b$var$defaultRoundingMethod];
}


function $637fe0a8b24e6f33$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $87eb8823ffa05467$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $c83d105896c1098b$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);



function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $a3f0d923300214de$export$2e2bcd8739ae039(object) {
    return (0, $4c58fe0eb0761e95$export$2e2bcd8739ae039)({}, object);
}



/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}



var $4e2c21a599879745$var$MINUTES_IN_DAY = 1440;
var $4e2c21a599879745$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $4e2c21a599879745$var$MINUTES_IN_MONTH = 43200;
var $4e2c21a599879745$var$MINUTES_IN_TWO_MONTHS = 86400;
function $4e2c21a599879745$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $8a0cd77776020c49$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $4c58fe0eb0761e95$export$2e2bcd8739ae039)((0, $a3f0d923300214de$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $637fe0a8b24e6f33$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $6eb366e006a8b659$export$2e2bcd8739ae039)(dateRight) - (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $4e2c21a599879745$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $4e2c21a599879745$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $4e2c21a599879745$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $4e2c21a599879745$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $4e2c21a599879745$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $4e2c21a599879745$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $2d8804d7e615dc3e$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $4e2c21a599879745$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}



var $acw62 = parcelRequire("acw62");




var $bd200035f525023e$exports = {};

$parcel$export($bd200035f525023e$exports, "amount", () => $bd200035f525023e$export$802cfe72001a1ee, (v) => $bd200035f525023e$export$802cfe72001a1ee = v);
$parcel$export($bd200035f525023e$exports, "icon", () => $bd200035f525023e$export$1ca1ec8b29a4ce27, (v) => $bd200035f525023e$export$1ca1ec8b29a4ce27 = v);
$parcel$export($bd200035f525023e$exports, "left", () => $bd200035f525023e$export$eabcd2c8791e7bf4, (v) => $bd200035f525023e$export$eabcd2c8791e7bf4 = v);
$parcel$export($bd200035f525023e$exports, "right", () => $bd200035f525023e$export$79ffe56a765070d2, (v) => $bd200035f525023e$export$79ffe56a765070d2 = v);
$parcel$export($bd200035f525023e$exports, "root", () => $bd200035f525023e$export$e8e78c978b129247, (v) => $bd200035f525023e$export$e8e78c978b129247 = v);
$parcel$export($bd200035f525023e$exports, "signature", () => $bd200035f525023e$export$c9cd164b539ebb63, (v) => $bd200035f525023e$export$c9cd164b539ebb63 = v);
$parcel$export($bd200035f525023e$exports, "status", () => $bd200035f525023e$export$471f7ae5c4103ae1, (v) => $bd200035f525023e$export$471f7ae5c4103ae1 = v);
$parcel$export($bd200035f525023e$exports, "status-finalized", () => $bd200035f525023e$export$64eeedea56986ab1, (v) => $bd200035f525023e$export$64eeedea56986ab1 = v);
$parcel$export($bd200035f525023e$exports, "time", () => $bd200035f525023e$export$2da9be4cfdb689b1, (v) => $bd200035f525023e$export$2da9be4cfdb689b1 = v);
$parcel$export($bd200035f525023e$exports, "title", () => $bd200035f525023e$export$fb184b623420d9be, (v) => $bd200035f525023e$export$fb184b623420d9be = v);
$parcel$export($bd200035f525023e$exports, "transaction", () => $bd200035f525023e$export$2d62d2646dd2fb3c, (v) => $bd200035f525023e$export$2d62d2646dd2fb3c = v);
var $bd200035f525023e$export$802cfe72001a1ee;
var $bd200035f525023e$export$1ca1ec8b29a4ce27;
var $bd200035f525023e$export$eabcd2c8791e7bf4;
var $bd200035f525023e$export$79ffe56a765070d2;
var $bd200035f525023e$export$e8e78c978b129247;
var $bd200035f525023e$export$c9cd164b539ebb63;
var $bd200035f525023e$export$471f7ae5c4103ae1;
var $bd200035f525023e$export$64eeedea56986ab1;
var $bd200035f525023e$export$2da9be4cfdb689b1;
var $bd200035f525023e$export$fb184b623420d9be;
var $bd200035f525023e$export$2d62d2646dd2fb3c;
$bd200035f525023e$export$802cfe72001a1ee = `dn3_TG_amount`;
$bd200035f525023e$export$1ca1ec8b29a4ce27 = `dn3_TG_icon`;
$bd200035f525023e$export$eabcd2c8791e7bf4 = `dn3_TG_left`;
$bd200035f525023e$export$79ffe56a765070d2 = `dn3_TG_right`;
$bd200035f525023e$export$e8e78c978b129247 = `dn3_TG_root`;
$bd200035f525023e$export$c9cd164b539ebb63 = `dn3_TG_signature`;
$bd200035f525023e$export$471f7ae5c4103ae1 = `dn3_TG_status`;
$bd200035f525023e$export$64eeedea56986ab1 = `dn3_TG_status-finalized`;
$bd200035f525023e$export$2da9be4cfdb689b1 = `dn3_TG_time`;
$bd200035f525023e$export$fb184b623420d9be = `dn3_TG_title`;
$bd200035f525023e$export$2d62d2646dd2fb3c = `dn3_TG_transaction`;


const $d960bd488ed2ca18$export$7d08f46ba5d226c9 = ()=>{
    const { transactions: transactions } = (0, $da07c62151760c48$export$4127a74fddb92b6f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $bd200035f525023e$exports.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $bd200035f525023e$exports.title,
                children: "Recent Transactions"
            }),
            transactions.map((transaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d960bd488ed2ca18$var$Transaction, {
                    transaction: transaction
                }, transaction.signature))
        ]
    });
};
const $d960bd488ed2ca18$var$Transaction = ({ transaction: transaction })=>{
    const { icon: icon, symbol: symbol } = (0, $e019fb9064ab9dfa$export$b3611e87cd5ba6ce)();
    const amount = (0, $acw62.useMemo)(()=>new (0, $dws6U.default)(transaction.amount), [
        transaction.amount
    ]);
    const signature = (0, $acw62.useMemo)(()=>transaction.signature.slice(0, 8) + '....' + transaction.signature.slice(-8), [
        transaction.signature
    ]);
    const getTime = (0, $acw62.useCallback)(()=>(0, $4e2c21a599879745$export$2e2bcd8739ae039)(new Date(), new Date(transaction.timestamp * 1000)) + ' ago', [
        transaction.timestamp
    ]);
    const [time, setTime] = (0, $acw62.useState)(getTime());
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>setTime(getTime()), 1000);
        return ()=>clearInterval(interval);
    }, [
        getTime
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $bd200035f525023e$exports.transaction,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $bd200035f525023e$exports.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $bd200035f525023e$exports.left,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: $bd200035f525023e$exports.amount,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cb71ddbb0c9a1f3$export$5a2795e4838b67d2), {
                                amount: amount,
                                showZero: true
                            }),
                            (0, $c3c4612a04ae44e4$export$5692c2d0651ebabe) + symbol
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $bd200035f525023e$exports.signature,
                        children: signature
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: $bd200035f525023e$exports.right,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $bd200035f525023e$exports.time,
                        children: time
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)($bd200035f525023e$exports.status, $bd200035f525023e$exports[`status-${transaction.status}`]),
                        children: transaction.status
                    })
                ]
            })
        ]
    });
};


var $4e421bc5d75f067c$export$38e42c68cf43b5d4;
var $4e421bc5d75f067c$export$f22da7240b7add18;
var $4e421bc5d75f067c$export$e8e78c978b129247;
$4e421bc5d75f067c$export$38e42c68cf43b5d4 = `pG9SIa_header`;
$4e421bc5d75f067c$export$f22da7240b7add18 = `pG9SIa_main`;
$4e421bc5d75f067c$export$e8e78c978b129247 = `pG9SIa_root`;


const $cebaa64559d60c6d$export$5907cfed759ec192 = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const onClick = (0, $acw62.useCallback)(()=>navigate(-1), [
        navigate
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: $4e421bc5d75f067c$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $4e421bc5d75f067c$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69ffbf78f8ecebca$export$e0d897ee21382f67), {
                    onClick: onClick,
                    children: "Back"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $4e421bc5d75f067c$export$f22da7240b7add18,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d960bd488ed2ca18$export$7d08f46ba5d226c9), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15ff4f2bd2dc7e1f$export$3dbb5766eaeb5b24), {})
        ]
    });
};


const $8c10dd8884cb7442$export$55185c17a0fcbe46 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d044d3f285a2da3f$export$6bfafc1e0f16edbd), {}),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        index: true,
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8c10dd8884cb7442$var$IndexRedirect, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "new",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aef8e6ccd0a71b25$export$d9b48143d220099f), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "pending",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bed87405b8c4def6$export$37cb6e010e1a0f69), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "confirmed",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba4a8c4b11255531$export$72af88ed99d024ff), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: "transactions",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cebaa64559d60c6d$export$5907cfed759ec192), {})
                    })
                ]
            })
        })
    });
};
const $8c10dd8884cb7442$var$IndexRedirect = ()=>{
    const to = (0, $98110fe2c21af7aa$export$6d3a98bdec8985cb)('/new');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: to,
        replace: true
    });
};


(0, $11492dca620dcaa5$exports.render)((0, $acw62.createElement)((0, $8c10dd8884cb7442$export$55185c17a0fcbe46)), document.getElementById('app'));


//# sourceMappingURL=point-of-sale.e4fd5551.js.map
